
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9Ppdo", function(module, exports) {

$parcel$export(module.exports, "register", () => $727c6fa89708e74c$export$6503ec6e8aabbaf, (v) => $727c6fa89708e74c$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $727c6fa89708e74c$export$f7ad0328861e2f03, (v) => $727c6fa89708e74c$export$f7ad0328861e2f03 = v);
var $727c6fa89708e74c$export$6503ec6e8aabbaf;
var $727c6fa89708e74c$export$f7ad0328861e2f03;
"use strict";
var $727c6fa89708e74c$var$mapping = new Map();
function $727c6fa89708e74c$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$727c6fa89708e74c$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $727c6fa89708e74c$var$resolve(id) {
    var resolved = $727c6fa89708e74c$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$727c6fa89708e74c$export$6503ec6e8aabbaf = $727c6fa89708e74c$var$register;
$727c6fa89708e74c$export$f7ad0328861e2f03 = $727c6fa89708e74c$var$resolve;

});

parcelRegister("3bGoE", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $25234940c3d03db7$export$2105062e25df4afe);
$parcel$export(module.exports, "Provider", () => $25234940c3d03db7$export$2881499e37b75b9a);
$parcel$export(module.exports, "useDispatch", () => $25234940c3d03db7$export$8ad76b76a4c905f8);

var $lx97N = parcelRequire("lx97N");

var $9Y55j = parcelRequire("9Y55j");
var $25234940c3d03db7$var$__defProp = Object.defineProperty;
var $25234940c3d03db7$var$__defProps = Object.defineProperties;
var $25234940c3d03db7$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $25234940c3d03db7$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $25234940c3d03db7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $25234940c3d03db7$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $25234940c3d03db7$var$__defNormalProp = (obj, key, value)=>key in obj ? $25234940c3d03db7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $25234940c3d03db7$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($25234940c3d03db7$var$__hasOwnProp.call(b, prop)) $25234940c3d03db7$var$__defNormalProp(a, prop, b[prop]);
    if ($25234940c3d03db7$var$__getOwnPropSymbols) {
        for (var prop of $25234940c3d03db7$var$__getOwnPropSymbols(b))if ($25234940c3d03db7$var$__propIsEnum.call(b, prop)) $25234940c3d03db7$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $25234940c3d03db7$var$__spreadProps = (a, b)=>$25234940c3d03db7$var$__defProps(a, $25234940c3d03db7$var$__getOwnPropDescs(b));
var $25234940c3d03db7$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($25234940c3d03db7$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $25234940c3d03db7$var$__getOwnPropSymbols) {
        for (var prop of $25234940c3d03db7$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $25234940c3d03db7$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $25234940c3d03db7$var$React = // prettier-ignore
// @ts-ignore
"default" in $lx97N ? $lx97N["default"] : $lx97N;
// src/components/Context.ts
var $25234940c3d03db7$var$ContextKey = Symbol.for(`react-redux-context`);
var $25234940c3d03db7$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $25234940c3d03db7$var$getContext() {
    var _a;
    if (!$25234940c3d03db7$var$React.createContext) return {};
    const contextMap = (_a = $25234940c3d03db7$var$gT[$25234940c3d03db7$var$ContextKey]) != null ? _a : $25234940c3d03db7$var$gT[$25234940c3d03db7$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($25234940c3d03db7$var$React.createContext);
    if (!realContext) {
        realContext = $25234940c3d03db7$var$React.createContext(null);
        contextMap.set($25234940c3d03db7$var$React.createContext, realContext);
    }
    return realContext;
}
var $25234940c3d03db7$export$cc80c08dc91f1c00 = /* @__PURE__ */ $25234940c3d03db7$var$getContext();
// src/utils/useSyncExternalStore.ts
var $25234940c3d03db7$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $25234940c3d03db7$var$createReduxContextHook(context = $25234940c3d03db7$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $25234940c3d03db7$var$React.useContext(context);
        return contextValue;
    };
}
var $25234940c3d03db7$var$useReduxContext = /* @__PURE__ */ $25234940c3d03db7$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $25234940c3d03db7$var$useSyncExternalStoreWithSelector = $25234940c3d03db7$var$notInitialized;
var $25234940c3d03db7$var$initializeUseSelector = (fn)=>{
    $25234940c3d03db7$var$useSyncExternalStoreWithSelector = fn;
};
var $25234940c3d03db7$var$refEquality = (a, b)=>a === b;
function $25234940c3d03db7$export$2b53f90d2bd1cbfb(context = $25234940c3d03db7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $25234940c3d03db7$export$cc80c08dc91f1c00 ? $25234940c3d03db7$var$useReduxContext : $25234940c3d03db7$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $25234940c3d03db7$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $25234940c3d03db7$var$React.useRef(true);
        const wrappedSelector = $25234940c3d03db7$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $25234940c3d03db7$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $25234940c3d03db7$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $25234940c3d03db7$export$2105062e25df4afe = /* @__PURE__ */ $25234940c3d03db7$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $25234940c3d03db7$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $25234940c3d03db7$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $25234940c3d03db7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $25234940c3d03db7$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $25234940c3d03db7$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $25234940c3d03db7$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $25234940c3d03db7$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $25234940c3d03db7$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $25234940c3d03db7$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $25234940c3d03db7$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $25234940c3d03db7$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $25234940c3d03db7$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $25234940c3d03db7$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $25234940c3d03db7$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $25234940c3d03db7$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $25234940c3d03db7$var$ForwardRef = $25234940c3d03db7$var$REACT_FORWARD_REF_TYPE;
var $25234940c3d03db7$var$Memo = $25234940c3d03db7$var$REACT_MEMO_TYPE;
function $25234940c3d03db7$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $25234940c3d03db7$var$REACT_FRAGMENT_TYPE || type === $25234940c3d03db7$var$REACT_PROFILER_TYPE || type === $25234940c3d03db7$var$REACT_STRICT_MODE_TYPE || type === $25234940c3d03db7$var$REACT_SUSPENSE_TYPE || type === $25234940c3d03db7$var$REACT_SUSPENSE_LIST_TYPE || type === $25234940c3d03db7$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $25234940c3d03db7$var$REACT_LAZY_TYPE || type.$$typeof === $25234940c3d03db7$var$REACT_MEMO_TYPE || type.$$typeof === $25234940c3d03db7$var$REACT_PROVIDER_TYPE || type.$$typeof === $25234940c3d03db7$var$REACT_CONTEXT_TYPE || type.$$typeof === $25234940c3d03db7$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $25234940c3d03db7$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $25234940c3d03db7$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $25234940c3d03db7$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $25234940c3d03db7$var$REACT_FRAGMENT_TYPE:
                        case $25234940c3d03db7$var$REACT_PROFILER_TYPE:
                        case $25234940c3d03db7$var$REACT_STRICT_MODE_TYPE:
                        case $25234940c3d03db7$var$REACT_SUSPENSE_TYPE:
                        case $25234940c3d03db7$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $25234940c3d03db7$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $25234940c3d03db7$var$REACT_CONTEXT_TYPE:
                                    case $25234940c3d03db7$var$REACT_FORWARD_REF_TYPE:
                                    case $25234940c3d03db7$var$REACT_LAZY_TYPE:
                                    case $25234940c3d03db7$var$REACT_MEMO_TYPE:
                                    case $25234940c3d03db7$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $25234940c3d03db7$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $25234940c3d03db7$var$isContextConsumer(object) {
    return $25234940c3d03db7$var$typeOf(object) === $25234940c3d03db7$var$REACT_CONTEXT_TYPE;
}
function $25234940c3d03db7$var$isMemo(object) {
    return $25234940c3d03db7$var$typeOf(object) === $25234940c3d03db7$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $25234940c3d03db7$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $25234940c3d03db7$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $25234940c3d03db7$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $25234940c3d03db7$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $25234940c3d03db7$var$verify(mapStateToProps, "mapStateToProps");
    $25234940c3d03db7$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $25234940c3d03db7$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $25234940c3d03db7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $25234940c3d03db7$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $25234940c3d03db7$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $25234940c3d03db7$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $25234940c3d03db7$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $25234940c3d03db7$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $25234940c3d03db7$var$verifyPlainObject(value, displayName, methodName) {
    if (!$25234940c3d03db7$var$isPlainObject(value)) $25234940c3d03db7$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $25234940c3d03db7$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $25234940c3d03db7$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $25234940c3d03db7$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $25234940c3d03db7$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $25234940c3d03db7$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $25234940c3d03db7$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $25234940c3d03db7$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $25234940c3d03db7$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $25234940c3d03db7$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $25234940c3d03db7$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $25234940c3d03db7$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $25234940c3d03db7$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $25234940c3d03db7$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $25234940c3d03db7$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $25234940c3d03db7$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $25234940c3d03db7$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $25234940c3d03db7$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $25234940c3d03db7$var$__spreadValues($25234940c3d03db7$var$__spreadValues($25234940c3d03db7$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $25234940c3d03db7$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $25234940c3d03db7$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$25234940c3d03db7$var$defaultMergeProps : typeof mergeProps === "function" ? $25234940c3d03db7$var$wrapMergePropsFunc(mergeProps) : $25234940c3d03db7$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $25234940c3d03db7$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $25234940c3d03db7$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $25234940c3d03db7$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $25234940c3d03db7$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $25234940c3d03db7$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $25234940c3d03db7$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $25234940c3d03db7$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $25234940c3d03db7$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $25234940c3d03db7$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $25234940c3d03db7$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $25234940c3d03db7$var$useIsomorphicLayoutEffect = $25234940c3d03db7$var$canUseDOM || $25234940c3d03db7$var$isReactNative ? $25234940c3d03db7$var$React.useLayoutEffect : $25234940c3d03db7$var$React.useEffect;
// src/utils/shallowEqual.ts
function $25234940c3d03db7$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $25234940c3d03db7$export$d36bdfa510afb180(objA, objB) {
    if ($25234940c3d03db7$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$25234940c3d03db7$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $25234940c3d03db7$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $25234940c3d03db7$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $25234940c3d03db7$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $25234940c3d03db7$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $25234940c3d03db7$var$TYPE_STATICS = {
    [$25234940c3d03db7$var$ForwardRef]: $25234940c3d03db7$var$FORWARD_REF_STATICS,
    [$25234940c3d03db7$var$Memo]: $25234940c3d03db7$var$MEMO_STATICS
};
function $25234940c3d03db7$var$getStatics(component) {
    if ($25234940c3d03db7$var$isMemo(component)) return $25234940c3d03db7$var$MEMO_STATICS;
    return $25234940c3d03db7$var$TYPE_STATICS[component["$$typeof"]] || $25234940c3d03db7$var$REACT_STATICS;
}
var $25234940c3d03db7$var$defineProperty = Object.defineProperty;
var $25234940c3d03db7$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $25234940c3d03db7$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $25234940c3d03db7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $25234940c3d03db7$var$getPrototypeOf = Object.getPrototypeOf;
var $25234940c3d03db7$var$objectPrototype = Object.prototype;
function $25234940c3d03db7$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($25234940c3d03db7$var$objectPrototype) {
            const inheritedComponent = $25234940c3d03db7$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $25234940c3d03db7$var$objectPrototype) $25234940c3d03db7$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $25234940c3d03db7$var$getOwnPropertyNames(sourceComponent);
        if ($25234940c3d03db7$var$getOwnPropertySymbols) keys = keys.concat($25234940c3d03db7$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $25234940c3d03db7$var$getStatics(targetComponent);
        const sourceStatics = $25234940c3d03db7$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$25234940c3d03db7$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $25234940c3d03db7$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $25234940c3d03db7$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $25234940c3d03db7$var$useSyncExternalStore = $25234940c3d03db7$var$notInitialized;
var $25234940c3d03db7$var$initializeConnect = (fn)=>{
    $25234940c3d03db7$var$useSyncExternalStore = fn;
};
var $25234940c3d03db7$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $25234940c3d03db7$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $25234940c3d03db7$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $25234940c3d03db7$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $25234940c3d03db7$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $25234940c3d03db7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $25234940c3d03db7$var$strictEqual(a, b) {
    return a === b;
}
var $25234940c3d03db7$var$hasWarnedAboutDeprecatedPureOption = false;
function $25234940c3d03db7$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $25234940c3d03db7$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $25234940c3d03db7$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $25234940c3d03db7$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $25234940c3d03db7$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $25234940c3d03db7$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $25234940c3d03db7$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $25234940c3d03db7$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $25234940c3d03db7$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $25234940c3d03db7$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $25234940c3d03db7$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $25234940c3d03db7$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $25234940c3d03db7$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $25234940c3d03db7$var$React.useMemo(()=>{
                return $25234940c3d03db7$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $25234940c3d03db7$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $25234940c3d03db7$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $25234940c3d03db7$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $25234940c3d03db7$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $25234940c3d03db7$var$__spreadProps($25234940c3d03db7$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $25234940c3d03db7$var$React.useRef(void 0);
            const lastWrapperProps = $25234940c3d03db7$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $25234940c3d03db7$var$React.useRef(void 0);
            const renderIsScheduled = $25234940c3d03db7$var$React.useRef(false);
            const isMounted = $25234940c3d03db7$var$React.useRef(false);
            const latestSubscriptionCallbackError = $25234940c3d03db7$var$React.useRef(void 0);
            $25234940c3d03db7$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $25234940c3d03db7$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $25234940c3d03db7$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $25234940c3d03db7$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $25234940c3d03db7$var$useIsomorphicLayoutEffectWithArgs($25234940c3d03db7$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $25234940c3d03db7$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $25234940c3d03db7$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $25234940c3d03db7$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $25234940c3d03db7$var$React.createElement(WrappedComponent, $25234940c3d03db7$var$__spreadProps($25234940c3d03db7$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $25234940c3d03db7$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $25234940c3d03db7$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $25234940c3d03db7$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $25234940c3d03db7$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $25234940c3d03db7$var$React.createElement(Connect, $25234940c3d03db7$var$__spreadProps($25234940c3d03db7$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $25234940c3d03db7$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $25234940c3d03db7$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $25234940c3d03db7$export$64605811ab45167f = $25234940c3d03db7$var$connect;
// src/components/Provider.tsx
function $25234940c3d03db7$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $25234940c3d03db7$var$React.useMemo(()=>{
        const subscription = $25234940c3d03db7$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $25234940c3d03db7$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $25234940c3d03db7$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $25234940c3d03db7$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $25234940c3d03db7$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $25234940c3d03db7$export$2881499e37b75b9a = $25234940c3d03db7$var$Provider;
// src/hooks/useStore.ts
function $25234940c3d03db7$export$671dba69185d0304(context = $25234940c3d03db7$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $25234940c3d03db7$export$cc80c08dc91f1c00 ? $25234940c3d03db7$var$useReduxContext : // @ts-ignore
    $25234940c3d03db7$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $25234940c3d03db7$export$6ccbb43953eebf8 = /* @__PURE__ */ $25234940c3d03db7$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $25234940c3d03db7$export$bc9b55530897c558(context = $25234940c3d03db7$export$cc80c08dc91f1c00) {
    const useStore2 = context === $25234940c3d03db7$export$cc80c08dc91f1c00 ? $25234940c3d03db7$export$6ccbb43953eebf8 : $25234940c3d03db7$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $25234940c3d03db7$export$8ad76b76a4c905f8 = /* @__PURE__ */ $25234940c3d03db7$export$bc9b55530897c558();
// src/exports.ts
var $25234940c3d03db7$export$712ea50be43a7858 = $25234940c3d03db7$var$defaultNoopBatch;
// src/index.ts
$25234940c3d03db7$var$initializeUseSelector((0, $9Y55j.useSyncExternalStoreWithSelector));
$25234940c3d03db7$var$initializeConnect($lx97N.useSyncExternalStore);

});

parcelRegister("h0N84", function(module, exports) {

$parcel$export(module.exports, "getPreloadComplete", () => $9721c6ccd65e484a$export$bf28be230fb3c0ed);
let $9721c6ccd65e484a$var$chartiqUiManagerGuardInstalled = false;
const $9721c6ccd65e484a$var$ensureChartiqUiManagerRegistry = ()=>{
    const ciqRoot = globalThis;
    if (!ciqRoot.CIQ?.UI) return;
    ciqRoot.CIQ.UI._uiManagers ||= new WeakMap();
};
const $9721c6ccd65e484a$var$installChartiqUiManagerGuard = ()=>{
    $9721c6ccd65e484a$var$ensureChartiqUiManagerRegistry();
    if ($9721c6ccd65e484a$var$chartiqUiManagerGuardInstalled) return;
    window.addEventListener('beforeunload', $9721c6ccd65e484a$var$ensureChartiqUiManagerRegistry);
    $9721c6ccd65e484a$var$chartiqUiManagerGuardInstalled = true;
};
const $9721c6ccd65e484a$export$bf28be230fb3c0ed = async ()=>new Promise((resolve)=>{
        const script = document.createElement('script');
        script.onload = function() {
            globalThis.QEP.container.onReady(()=>{
                $9721c6ccd65e484a$var$installChartiqUiManagerGuard();
                resolve();
            });
        };
        script.src = '/preloads/qep-system.js';
        document.head.append(script);
    });

});

parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
'use strict';
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});

parcelRegister("l5EDh", function(module, exports) {

$parcel$export(module.exports, "createRule", () => createRule);
$parcel$export(module.exports, "toCssValue", () => toCssValue);
$parcel$export(module.exports, "RuleList", () => RuleList);
$parcel$export(module.exports, "create", () => createJss);
$parcel$export(module.exports, "hasCSSTOMSupport", () => hasCSSTOMSupport);
$parcel$export(module.exports, "getDynamicStyles", () => getDynamicStyles);

var $eR4tV = parcelRequire("eR4tV");

var $lDq78 = parcelRequire("lDq78");

var $cf94x = parcelRequire("cf94x");

var $gPL2t = parcelRequire("gPL2t");

var $3W2J1 = parcelRequire("3W2J1");

var $jzHgM = parcelRequire("jzHgM");

var $hphT8 = parcelRequire("hphT8");
var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
    if (style == null || typeof style !== 'object') return style;
    if (Array.isArray(style)) return style.map(cloneStyle);
    if (style.constructor !== plainObjectConstrurctor) return style;
    var newStyle = {};
    for(var name in style)newStyle[name] = cloneStyle(style[name]);
    return newStyle;
}
/**
 * Create a rule instance.
 */ function createRule(name, decl, options) {
    if (name === void 0) name = 'unnamed';
    var jss = options.jss;
    var declCopy = cloneStyle(decl);
    var rule = jss.plugins.onCreateRule(name, declCopy, options);
    if (rule) return rule; // It is an at-rule and it has no instance.
    name[0];
    return null;
}
var join = function join(value, by) {
    var result = '';
    for(var i = 0; i < value.length; i++){
        // Remove !important from the value, it will be readded later.
        if (value[i] === '!important') break;
        if (result) result += by;
        result += value[i];
    }
    return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */ var toCssValue = function toCssValue(value) {
    if (!Array.isArray(value)) return value;
    var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
    if (Array.isArray(value[0])) for(var i = 0; i < value.length; i++){
        if (value[i] === '!important') break;
        if (cssValue) cssValue += ', ';
        cssValue += join(value[i], ' ');
    }
    else cssValue = join(value, ', '); // Add !important, because it was ignored.
    if (value[value.length - 1] === '!important') cssValue += ' !important';
    return cssValue;
};
function getWhitespaceSymbols(options) {
    if (options && options.format === false) return {
        linebreak: '',
        space: ''
    };
    return {
        linebreak: '\n',
        space: ' '
    };
}
/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */ function indentStr(str, indent) {
    var result = '';
    for(var index = 0; index < indent; index++)result += '  ';
    return result + str;
}
/**
 * Converts a Rule to CSS string.
 */ function toCss(selector, style, options) {
    if (options === void 0) options = {};
    var result = '';
    if (!style) return result;
    var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
    var fallbacks = style.fallbacks;
    if (options.format === false) indent = -Infinity;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
    if (selector) indent++; // Apply fallbacks first.
    if (fallbacks) {
        // Array syntax {fallbacks: [{prop: value}]}
        if (Array.isArray(fallbacks)) for(var index = 0; index < fallbacks.length; index++){
            var fallback = fallbacks[index];
            for(var prop in fallback){
                var value = fallback[prop];
                if (value != null) {
                    if (result) result += linebreak;
                    result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
                }
            }
        }
        else // Object syntax {fallbacks: {prop: value}}
        for(var _prop in fallbacks){
            var _value = fallbacks[_prop];
            if (_value != null) {
                if (result) result += linebreak;
                result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
            }
        }
    }
    for(var _prop2 in style){
        var _value2 = style[_prop2];
        if (_value2 != null && _prop2 !== 'fallbacks') {
            if (result) result += linebreak;
            result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
        }
    } // Allow empty style in this case, because properties will be added dynamically.
    if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
    if (!selector) return result;
    indent--;
    if (result) result = "" + linebreak + result + linebreak;
    return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = function(str) {
    return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
};
var BaseStyleRule = /*#__PURE__*/ function() {
    function BaseStyleRule(key, style, options) {
        this.type = 'style';
        this.isProcessed = false;
        var sheet = options.sheet, Renderer = options.Renderer;
        this.key = key;
        this.options = options;
        this.style = style;
        if (sheet) this.renderer = sheet.renderer;
        else if (Renderer) this.renderer = new Renderer();
    }
    /**
   * Get or set a style property.
   */ var _proto = BaseStyleRule.prototype;
    _proto.prop = function prop(name, value, options) {
        // It's a getter.
        if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
        var force = options ? options.force : false;
        if (!force && this.style[name] === value) return this;
        var newValue = value;
        if (!options || options.process !== false) newValue = this.options.jss.plugins.onChangeValue(value, name, this);
        var isEmpty = newValue == null || newValue === false;
        var isDefined = name in this.style; // Value is empty and wasn't defined before.
        if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
        var remove = isEmpty && isDefined;
        if (remove) delete this.style[name];
        else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
        if (this.renderable && this.renderer) {
            if (remove) this.renderer.removeProperty(this.renderable, name);
            else this.renderer.setProperty(this.renderable, name, newValue);
            return this;
        }
        var sheet = this.options.sheet;
        sheet && sheet.attached;
        return this;
    };
    return BaseStyleRule;
}();
var StyleRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $3W2J1.default)(StyleRule, _BaseStyleRule);
    function StyleRule(key, style, options) {
        var _this;
        _this = _BaseStyleRule.call(this, key, style, options) || this;
        var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        if (selector) _this.selectorText = selector;
        else if (scoped !== false) {
            _this.id = generateId((0, $jzHgM.default)((0, $jzHgM.default)(_this)), sheet);
            _this.selectorText = "." + escape(_this.id);
        }
        return _this;
    }
    /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */ var _proto2 = StyleRule.prototype;
    /**
   * Apply rule to an element inline.
   */ _proto2.applyTo = function applyTo(renderable) {
        var renderer = this.renderer;
        if (renderer) {
            var json = this.toJSON();
            for(var prop in json)renderer.setProperty(renderable, prop, json[prop]);
        }
        return this;
    } /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */ ;
    _proto2.toJSON = function toJSON() {
        var json = {};
        for(var prop in this.style){
            var value = this.style[prop];
            if (typeof value !== 'object') json[prop] = value;
            else if (Array.isArray(value)) json[prop] = toCssValue(value);
        }
        return json;
    } /**
   * Generates a CSS string.
   */ ;
    _proto2.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $eR4tV.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.selectorText, this.style, opts);
    };
    (0, $gPL2t.default)(StyleRule, [
        {
            key: "selector",
            set: function set(selector) {
                if (selector === this.selectorText) return;
                this.selectorText = selector;
                var renderer = this.renderer, renderable = this.renderable;
                if (!renderable || !renderer) return;
                var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
                if (!hasChanged) renderer.replaceRule(renderable, this);
            },
            get: function get() {
                return this.selectorText;
            }
        }
    ]);
    return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') return null;
        return new StyleRule(key, style, options);
    }
};
var defaultToStringOptions = {
    indent: 1,
    children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */ var ConditionalRule = /*#__PURE__*/ function() {
    function ConditionalRule(key, styles, options) {
        this.type = 'conditional';
        this.isProcessed = false;
        this.key = key;
        var atMatch = key.match(atRegExp);
        this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
        this.query = options.name || "@" + this.at;
        this.options = options;
        this.rules = new RuleList((0, $eR4tV.default)({}, options, {
            parent: this
        }));
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = ConditionalRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions.indent;
        if (options.children == null) options.children = defaultToStringOptions.children;
        if (options.children === false) return this.query + " {}";
        var children = this.rules.toString(options);
        return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
    };
    return ConditionalRule;
}();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
    onCreateRule: function onCreateRule(key, styles, options) {
        return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
    }
};
var defaultToStringOptions$1 = {
    indent: 1,
    children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */ var KeyframesRule = /*#__PURE__*/ function() {
    function KeyframesRule(key, frames, options) {
        this.type = 'keyframes';
        this.at = '@keyframes';
        this.isProcessed = false;
        var nameMatch = key.match(nameRegExp);
        if (nameMatch && nameMatch[1]) this.name = nameMatch[1];
        else this.name = 'noname';
        this.key = this.type + "-" + this.name;
        this.options = options;
        var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
        this.id = scoped === false ? this.name : escape(generateId(this, sheet));
        this.rules = new RuleList((0, $eR4tV.default)({}, options, {
            parent: this
        }));
        for(var name in frames)this.rules.add(name, frames[name], (0, $eR4tV.default)({}, options, {
            parent: this
        }));
        this.rules.process();
    }
    /**
   * Generates a CSS string.
   */ var _proto = KeyframesRule.prototype;
    _proto.toString = function toString(options) {
        if (options === void 0) options = defaultToStringOptions$1;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
        if (options.children == null) options.children = defaultToStringOptions$1.children;
        if (options.children === false) return this.at + " " + this.id + " {}";
        var children = this.rules.toString(options);
        if (children) children = "" + linebreak + children + linebreak;
        return this.at + " " + this.id + " {" + children + "}";
    };
    return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
    if (typeof val === 'string') return val.replace(refRegExp, function(match, name) {
        if (name in keyframes) return keyframes[name];
        return match;
    });
    return val;
};
/**
 * Replace the reference for a animation name.
 */ var replaceRef = function replaceRef(style, prop, keyframes) {
    var value = style[prop];
    var refKeyframe = findReferencedKeyframe(value, keyframes);
    if (refKeyframe !== value) style[prop] = refKeyframe;
};
var pluginKeyframesRule = {
    onCreateRule: function onCreateRule(key, frames, options) {
        return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
    },
    // Animation name ref replacer.
    onProcessStyle: function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style' || !sheet) return style;
        if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
        if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
        return style;
    },
    onChangeValue: function onChangeValue(val, prop, rule) {
        var sheet = rule.options.sheet;
        if (!sheet) return val;
        switch(prop){
            case 'animation':
                return findReferencedKeyframe(val, sheet.keyframes);
            case 'animation-name':
                return findReferencedKeyframe(val, sheet.keyframes);
            default:
                return val;
        }
    }
};
var KeyframeRule = /*#__PURE__*/ function(_BaseStyleRule) {
    (0, $3W2J1.default)(KeyframeRule, _BaseStyleRule);
    function KeyframeRule() {
        return _BaseStyleRule.apply(this, arguments) || this;
    }
    var _proto = KeyframeRule.prototype;
    /**
   * Generates a CSS string.
   */ _proto.toString = function toString(options) {
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var opts = link ? (0, $eR4tV.default)({}, options, {
            allowEmpty: true
        }) : options;
        return toCss(this.key, this.style, opts);
    };
    return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        if (options.parent && options.parent.type === 'keyframes') return new KeyframeRule(key, style, options);
        return null;
    }
};
var FontFaceRule = /*#__PURE__*/ function() {
    function FontFaceRule(key, style, options) {
        this.type = 'font-face';
        this.at = '@font-face';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = FontFaceRule.prototype;
    _proto.toString = function toString(options) {
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        if (Array.isArray(this.style)) {
            var str = '';
            for(var index = 0; index < this.style.length; index++){
                str += toCss(this.at, this.style[index]);
                if (this.style[index + 1]) str += linebreak;
            }
            return str;
        }
        return toCss(this.at, this.style, options);
    };
    return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
    }
};
var ViewportRule = /*#__PURE__*/ function() {
    function ViewportRule(key, style, options) {
        this.type = 'viewport';
        this.at = '@viewport';
        this.isProcessed = false;
        this.key = key;
        this.style = style;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ var _proto = ViewportRule.prototype;
    _proto.toString = function toString(options) {
        return toCss(this.key, this.style, options);
    };
    return ViewportRule;
}();
var pluginViewportRule = {
    onCreateRule: function onCreateRule(key, style, options) {
        return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
    }
};
var SimpleRule = /*#__PURE__*/ function() {
    function SimpleRule(key, value, options) {
        this.type = 'simple';
        this.isProcessed = false;
        this.key = key;
        this.value = value;
        this.options = options;
    }
    /**
   * Generates a CSS string.
   */ // eslint-disable-next-line no-unused-vars
    var _proto = SimpleRule.prototype;
    _proto.toString = function toString(options) {
        if (Array.isArray(this.value)) {
            var str = '';
            for(var index = 0; index < this.value.length; index++){
                str += this.key + " " + this.value[index] + ";";
                if (this.value[index + 1]) str += '\n';
            }
            return str;
        }
        return this.key + " " + this.value + ";";
    };
    return SimpleRule;
}();
var keysMap = {
    '@charset': true,
    '@import': true,
    '@namespace': true
};
var pluginSimpleRule = {
    onCreateRule: function onCreateRule(key, value, options) {
        return key in keysMap ? new SimpleRule(key, value, options) : null;
    }
};
var plugins = [
    pluginStyleRule,
    pluginConditionalRule,
    pluginKeyframesRule,
    pluginKeyframeRule,
    pluginFontFaceRule,
    pluginViewportRule,
    pluginSimpleRule
];
var defaultUpdateOptions = {
    process: true
};
var forceUpdateOptions = {
    force: true,
    process: true
};
var RuleList = /*#__PURE__*/ function() {
    // Rules registry for access by .get() method.
    // It contains the same rule registered by name and by selector.
    // Original styles object.
    // Used to ensure correct rules order.
    function RuleList(options) {
        this.map = {};
        this.raw = {};
        this.index = [];
        this.counter = 0;
        this.options = options;
        this.classes = options.classes;
        this.keyframes = options.keyframes;
    }
    /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */ var _proto = RuleList.prototype;
    _proto.add = function add(name, decl, ruleOptions) {
        var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
        var options = (0, $eR4tV.default)({
            classes: this.classes,
            parent: parent,
            sheet: sheet,
            jss: jss,
            Renderer: Renderer,
            generateId: generateId,
            scoped: scoped,
            name: name,
            keyframes: this.keyframes,
            selector: undefined
        }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
        // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
        // we need to make the key unique within this RuleList instance scope.
        var key = name;
        if (name in this.raw) key = name + "-d" + this.counter++;
         // We need to save the original decl before creating the rule
        // because cache plugin needs to use it as a key to return a cached rule.
        this.raw[key] = decl;
        if (key in this.classes) // E.g. rules inside of @media container
        options.selector = "." + escape(this.classes[key]);
        var rule = createRule(key, decl, options);
        if (!rule) return null;
        this.register(rule);
        var index = options.index === undefined ? this.index.length : options.index;
        this.index.splice(index, 0, rule);
        return rule;
    } /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */ ;
    _proto.replace = function replace(name, decl, ruleOptions) {
        var oldRule = this.get(name);
        var oldIndex = this.index.indexOf(oldRule);
        if (oldRule) this.remove(oldRule);
        var options = ruleOptions;
        if (oldIndex !== -1) options = (0, $eR4tV.default)({}, ruleOptions, {
            index: oldIndex
        });
        return this.add(name, decl, options);
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.get = function get(nameOrSelector) {
        return this.map[nameOrSelector];
    } /**
   * Delete a rule.
   */ ;
    _proto.remove = function remove(rule) {
        this.unregister(rule);
        delete this.raw[rule.key];
        this.index.splice(this.index.indexOf(rule), 1);
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.index.indexOf(rule);
    } /**
   * Run `onProcessRule()` plugins on every rule.
   */ ;
    _proto.process = function process() {
        var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
        // we end up with very hard-to-track-down side effects.
        this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    } /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */ ;
    _proto.register = function register(rule) {
        this.map[rule.key] = rule;
        if (rule instanceof StyleRule) {
            this.map[rule.selector] = rule;
            if (rule.id) this.classes[rule.key] = rule.id;
        } else if (rule instanceof KeyframesRule && this.keyframes) this.keyframes[rule.name] = rule.id;
    } /**
   * Unregister a rule.
   */ ;
    _proto.unregister = function unregister(rule) {
        delete this.map[rule.key];
        if (rule instanceof StyleRule) {
            delete this.map[rule.selector];
            delete this.classes[rule.key];
        } else if (rule instanceof KeyframesRule) delete this.keyframes[rule.name];
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var name;
        var data;
        var options;
        if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
            name = arguments.length <= 0 ? undefined : arguments[0];
            data = arguments.length <= 1 ? undefined : arguments[1];
            options = arguments.length <= 2 ? undefined : arguments[2];
        } else {
            data = arguments.length <= 0 ? undefined : arguments[0];
            options = arguments.length <= 1 ? undefined : arguments[1];
            name = null;
        }
        if (name) this.updateOne(this.get(name), data, options);
        else for(var index = 0; index < this.index.length; index++)this.updateOne(this.index[index], data, options);
    } /**
   * Execute plugins, update rule props.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        if (options === void 0) options = defaultUpdateOptions;
        var _this$options2 = this.options, plugins = _this$options2.jss.plugins, sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
        if (rule.rules instanceof RuleList) {
            rule.rules.update(data, options);
            return;
        }
        var style = rule.style;
        plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
        if (options.process && style && style !== rule.style) {
            // We need to run the plugins in case new `style` relies on syntax plugins.
            plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.
            for(var prop in rule.style){
                var nextValue = rule.style[prop];
                var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (nextValue !== prevValue) rule.prop(prop, nextValue, forceUpdateOptions);
            } // Remove props.
            for(var _prop in style){
                var _nextValue = rule.style[_prop];
                var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
                // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
                if (_nextValue == null && _nextValue !== _prevValue) rule.prop(_prop, null, forceUpdateOptions);
            }
        }
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        var str = '';
        var sheet = this.options.sheet;
        var link = sheet ? sheet.options.link : false;
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        for(var index = 0; index < this.index.length; index++){
            var rule = this.index[index];
            var css = rule.toString(options); // No need to render an empty rule.
            if (!css && !link) continue;
            if (str) str += linebreak;
            str += css;
        }
        return str;
    };
    return RuleList;
}();
var StyleSheet = /*#__PURE__*/ function() {
    function StyleSheet(styles, options) {
        this.attached = false;
        this.deployed = false;
        this.classes = {};
        this.keyframes = {};
        this.options = (0, $eR4tV.default)({}, options, {
            sheet: this,
            parent: this,
            classes: this.classes,
            keyframes: this.keyframes
        });
        if (options.Renderer) this.renderer = new options.Renderer(this);
        this.rules = new RuleList(this.options);
        for(var name in styles)this.rules.add(name, styles[name]);
        this.rules.process();
    }
    /**
   * Attach renderable to the render tree.
   */ var _proto = StyleSheet.prototype;
    _proto.attach = function attach() {
        if (this.attached) return this;
        if (this.renderer) this.renderer.attach();
        this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
        if (!this.deployed) this.deploy();
        return this;
    } /**
   * Remove renderable from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.attached) return this;
        if (this.renderer) this.renderer.detach();
        this.attached = false;
        return this;
    } /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */ ;
    _proto.addRule = function addRule(name, decl, options) {
        var queue = this.queue; // Plugins can create rules.
        // In order to preserve the right order, we need to queue all `.addRule` calls,
        // which happen after the first `rules.add()` call.
        if (this.attached && !queue) this.queue = [];
        var rule = this.rules.add(name, decl, options);
        if (!rule) return null;
        this.options.jss.plugins.onProcessRule(rule);
        if (this.attached) {
            if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (queue) queue.push(rule);
            else {
                this.insertRule(rule);
                if (this.queue) {
                    this.queue.forEach(this.insertRule, this);
                    this.queue = undefined;
                }
            }
            return rule;
        } // We can't add rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return rule;
    } /**
   * Replace a rule in the current stylesheet.
   */ ;
    _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
        var oldRule = this.rules.get(nameOrSelector);
        if (!oldRule) return this.addRule(nameOrSelector, decl, options);
        var newRule = this.rules.replace(nameOrSelector, decl, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        if (this.attached) {
            if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
            // It will be inserted all together when .attach is called.
            if (this.renderer) {
                if (!newRule) this.renderer.deleteRule(oldRule);
                else if (oldRule.renderable) this.renderer.replaceRule(oldRule.renderable, newRule);
            }
            return newRule;
        } // We can't replace rules to a detached style node.
        // We will redeploy the sheet once user will attach it.
        this.deployed = false;
        return newRule;
    } /**
   * Insert rule into the StyleSheet
   */ ;
    _proto.insertRule = function insertRule(rule) {
        if (this.renderer) this.renderer.insertRule(rule);
    } /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */ ;
    _proto.addRules = function addRules(styles, options) {
        var added = [];
        for(var name in styles){
            var rule = this.addRule(name, styles[name], options);
            if (rule) added.push(rule);
        }
        return added;
    } /**
   * Get a rule by name or selector.
   */ ;
    _proto.getRule = function getRule(nameOrSelector) {
        return this.rules.get(nameOrSelector);
    } /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */ ;
    _proto.deleteRule = function deleteRule(name) {
        var rule = typeof name === 'object' ? name : this.rules.get(name);
        if (!rule || // Style sheet was created without link: true and attached, in this case we
        // won't be able to remove the CSS rule from the DOM.
        this.attached && !rule.renderable) return false;
        this.rules.remove(rule);
        if (this.attached && rule.renderable && this.renderer) return this.renderer.deleteRule(rule.renderable);
        return true;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Deploy pure CSS string to a renderable.
   */ ;
    _proto.deploy = function deploy() {
        if (this.renderer) this.renderer.deploy();
        this.deployed = true;
        return this;
    } /**
   * Update the function values with a new data.
   */ ;
    _proto.update = function update() {
        var _this$rules;
        (_this$rules = this.rules).update.apply(_this$rules, arguments);
        return this;
    } /**
   * Updates a single rule.
   */ ;
    _proto.updateOne = function updateOne(rule, data, options) {
        this.rules.updateOne(rule, data, options);
        return this;
    } /**
   * Convert rules to a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return StyleSheet;
}();
var PluginsRegistry = /*#__PURE__*/ function() {
    function PluginsRegistry() {
        this.plugins = {
            internal: [],
            external: []
        };
        this.registry = {};
    }
    var _proto = PluginsRegistry.prototype;
    /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */ _proto.onCreateRule = function onCreateRule(name, decl, options) {
        for(var i = 0; i < this.registry.onCreateRule.length; i++){
            var rule = this.registry.onCreateRule[i](name, decl, options);
            if (rule) return rule;
        }
        return null;
    } /**
   * Call `onProcessRule` hooks.
   */ ;
    _proto.onProcessRule = function onProcessRule(rule) {
        if (rule.isProcessed) return;
        var sheet = rule.options.sheet;
        for(var i = 0; i < this.registry.onProcessRule.length; i++)this.registry.onProcessRule[i](rule, sheet);
        if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
        rule.isProcessed = true;
    } /**
   * Call `onProcessStyle` hooks.
   */ ;
    _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
        for(var i = 0; i < this.registry.onProcessStyle.length; i++)rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    } /**
   * Call `onProcessSheet` hooks.
   */ ;
    _proto.onProcessSheet = function onProcessSheet(sheet) {
        for(var i = 0; i < this.registry.onProcessSheet.length; i++)this.registry.onProcessSheet[i](sheet);
    } /**
   * Call `onUpdate` hooks.
   */ ;
    _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
        for(var i = 0; i < this.registry.onUpdate.length; i++)this.registry.onUpdate[i](data, rule, sheet, options);
    } /**
   * Call `onChangeValue` hooks.
   */ ;
    _proto.onChangeValue = function onChangeValue(value, prop, rule) {
        var processedValue = value;
        for(var i = 0; i < this.registry.onChangeValue.length; i++)processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
        return processedValue;
    } /**
   * Register a plugin.
   */ ;
    _proto.use = function use(newPlugin, options) {
        if (options === void 0) options = {
            queue: 'external'
        };
        var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
        if (plugins.indexOf(newPlugin) !== -1) return;
        plugins.push(newPlugin);
        this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
            for(var name in plugin)if (name in registry) registry[name].push(plugin[name]);
            return registry;
        }, {
            onCreateRule: [],
            onProcessRule: [],
            onProcessStyle: [],
            onProcessSheet: [],
            onChangeValue: [],
            onUpdate: []
        });
    };
    return PluginsRegistry;
}();
/**
 * Sheets registry to access all instances in one place.
 */ var SheetsRegistry = /*#__PURE__*/ function() {
    function SheetsRegistry() {
        this.registry = [];
    }
    var _proto = SheetsRegistry.prototype;
    /**
   * Register a Style Sheet.
   */ _proto.add = function add(sheet) {
        var registry = this.registry;
        var index = sheet.options.index;
        if (registry.indexOf(sheet) !== -1) return;
        if (registry.length === 0 || index >= this.index) {
            registry.push(sheet);
            return;
        } // Find a position.
        for(var i = 0; i < registry.length; i++)if (registry[i].options.index > index) {
            registry.splice(i, 0, sheet);
            return;
        }
    } /**
   * Reset the registry.
   */ ;
    _proto.reset = function reset() {
        this.registry = [];
    } /**
   * Remove a Style Sheet.
   */ ;
    _proto.remove = function remove(sheet) {
        var index = this.registry.indexOf(sheet);
        this.registry.splice(index, 1);
    } /**
   * Convert all attached sheets to a CSS string.
   */ ;
    _proto.toString = function toString(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0, $hphT8.default)(_ref, [
            "attached"
        ]);
        var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
        var css = '';
        for(var i = 0; i < this.registry.length; i++){
            var sheet = this.registry[i];
            if (attached != null && sheet.attached !== attached) continue;
            if (css) css += linebreak;
            css += sheet.toString(options);
        }
        return css;
    };
    (0, $gPL2t.default)(SheetsRegistry, [
        {
            key: "index",
            /**
     * Current highest index number.
     */ get: function get() {
                return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
            }
        }
    ]);
    return SheetsRegistry;
}();
/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */ var sheets = new SheetsRegistry();
/* eslint-disable */ /**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */ var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */ var createGenerateId = function createGenerateId(options) {
    if (options === void 0) options = {};
    var ruleCounter = 0;
    var generateId = function generateId(rule, sheet) {
        ruleCounter += 1;
        var jssId = '';
        var prefix = '';
        if (sheet) {
            if (sheet.options.classNamePrefix) prefix = sheet.options.classNamePrefix;
            if (sheet.options.jss.id != null) jssId = String(sheet.options.jss.id);
        }
        if (options.minify) // Using "c" because a number can't be the first char in a class name.
        return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
        return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
    };
    return generateId;
};
/**
 * Cache the value from the first time a function is called.
 */ var memoize = function memoize(fn) {
    var value;
    return function() {
        if (!value) value = fn();
        return value;
    };
};
/**
 * Get a style property value.
 */ var getPropertyValue = function getPropertyValue(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) return cssRule.attributeStyleMap.get(prop);
        return cssRule.style.getPropertyValue(prop);
    } catch (err) {
        // IE may throw if property is unknown.
        return '';
    }
};
/**
 * Set a style property.
 */ var setProperty = function setProperty(cssRule, prop, value) {
    try {
        var cssValue = value;
        if (Array.isArray(value)) cssValue = toCssValue(value);
         // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.set(prop, cssValue);
        else {
            var indexOfImportantFlag = cssValue ? cssValue.indexOf('!important') : -1;
            var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
            cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? 'important' : '');
        }
    } catch (err) {
        // IE may throw if property is unknown.
        return false;
    }
    return true;
};
/**
 * Remove a style property.
 */ var removeProperty = function removeProperty(cssRule, prop) {
    try {
        // Support CSSTOM.
        if (cssRule.attributeStyleMap) cssRule.attributeStyleMap.delete(prop);
        else cssRule.style.removeProperty(prop);
    } catch (err) {}
};
/**
 * Set the selector.
 */ var setSelector = function setSelector(cssRule, selectorText) {
    cssRule.selectorText = selectorText; // Return false if setter was not successful.
    // Currently works in chrome only.
    return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */ var getHead = memoize(function() {
    return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */ function findHigherSheet(registry, options) {
    for(var i = 0; i < registry.length; i++){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find attached sheet with the highest index.
 */ function findHighestSheet(registry, options) {
    for(var i = registry.length - 1; i >= 0; i--){
        var sheet = registry[i];
        if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) return sheet;
    }
    return null;
}
/**
 * Find a comment with "jss" inside.
 */ function findCommentNode(text) {
    var head = getHead();
    for(var i = 0; i < head.childNodes.length; i++){
        var node = head.childNodes[i];
        if (node.nodeType === 8 && node.nodeValue.trim() === text) return node;
    }
    return null;
}
/**
 * Find a node before which we can insert the sheet.
 */ function findPrevNode(options) {
    var registry = sheets.registry;
    if (registry.length > 0) {
        // Try to insert before the next higher sheet.
        var sheet = findHigherSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element
        };
         // Otherwise insert after the last attached.
        sheet = findHighestSheet(registry, options);
        if (sheet && sheet.renderer) return {
            parent: sheet.renderer.element.parentNode,
            node: sheet.renderer.element.nextSibling
        };
    } // Try to find a comment placeholder if registry is empty.
    var insertionPoint = options.insertionPoint;
    if (insertionPoint && typeof insertionPoint === 'string') {
        var comment = findCommentNode(insertionPoint);
        if (comment) return {
            parent: comment.parentNode,
            node: comment.nextSibling
        };
         // If user specifies an insertion point and it can't be found in the document -
    }
    return false;
}
/**
 * Insert style element into the DOM.
 */ function insertStyle(style, options) {
    var insertionPoint = options.insertionPoint;
    var nextNode = findPrevNode(options);
    if (nextNode !== false && nextNode.parent) {
        nextNode.parent.insertBefore(style, nextNode.node);
        return;
    } // Works with iframes and any node types.
    if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
        var insertionPointElement = insertionPoint;
        var parentNode = insertionPointElement.parentNode;
        if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
        return;
    }
    getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */ var getNonce = memoize(function() {
    var node = document.querySelector('meta[property="csp-nonce"]');
    return node ? node.getAttribute('content') : null;
});
var _insertRule = function insertRule(container, rule, index) {
    try {
        if ('insertRule' in container) container.insertRule(rule, index);
        else if ('appendRule' in container) container.appendRule(rule);
    } catch (err) {
        return false;
    }
    return container.cssRules[index];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
    var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
    if (index === undefined || index > maxIndex) // eslint-disable-next-line no-param-reassign
    return maxIndex;
    return index;
};
var createStyle = function createStyle() {
    var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
    // insert rules after we insert the style tag.
    // It seems to kick-off the source order specificity algorithm.
    el.textContent = '\n';
    return el;
};
var DomRenderer = /*#__PURE__*/ function() {
    // Will be empty if link: true option is not set, because
    // it is only for use together with insertRule API.
    function DomRenderer(sheet) {
        this.getPropertyValue = getPropertyValue;
        this.setProperty = setProperty;
        this.removeProperty = removeProperty;
        this.setSelector = setSelector;
        this.hasInsertedRules = false;
        this.cssRules = [];
        // There is no sheet when the renderer is used from a standalone StyleRule.
        if (sheet) sheets.add(sheet);
        this.sheet = sheet;
        var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
        this.element = element || createStyle();
        this.element.setAttribute('data-jss', '');
        if (media) this.element.setAttribute('media', media);
        if (meta) this.element.setAttribute('data-meta', meta);
        var nonce = getNonce();
        if (nonce) this.element.setAttribute('nonce', nonce);
    }
    /**
   * Insert style element into render tree.
   */ var _proto = DomRenderer.prototype;
    _proto.attach = function attach() {
        // In the case the element node is external and it is already in the DOM.
        if (this.element.parentNode || !this.sheet) return;
        insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
        // most browsers create a new CSSStyleSheet, except of all IEs.
        var deployed = Boolean(this.sheet && this.sheet.deployed);
        if (this.hasInsertedRules && deployed) {
            this.hasInsertedRules = false;
            this.deploy();
        }
    } /**
   * Remove style element from render tree.
   */ ;
    _proto.detach = function detach() {
        if (!this.sheet) return;
        var parentNode = this.element.parentNode;
        if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
        // Though IE will keep them and we need a consistent behavior.
        if (this.sheet.options.link) {
            this.cssRules = [];
            this.element.textContent = '\n';
        }
    } /**
   * Inject CSS string into element.
   */ ;
    _proto.deploy = function deploy() {
        var sheet = this.sheet;
        if (!sheet) return;
        if (sheet.options.link) {
            this.insertRules(sheet.rules);
            return;
        }
        this.element.textContent = "\n" + sheet.toString() + "\n";
    } /**
   * Insert RuleList into an element.
   */ ;
    _proto.insertRules = function insertRules(rules, nativeParent) {
        for(var i = 0; i < rules.index.length; i++)this.insertRule(rules.index[i], i, nativeParent);
    } /**
   * Insert a rule into element.
   */ ;
    _proto.insertRule = function insertRule(rule, index, nativeParent) {
        if (nativeParent === void 0) nativeParent = this.element.sheet;
        if (rule.rules) {
            var parent = rule;
            var latestNativeParent = nativeParent;
            if (rule.type === 'conditional' || rule.type === 'keyframes') {
                var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.
                latestNativeParent = _insertRule(nativeParent, parent.toString({
                    children: false
                }), _insertionIndex);
                if (latestNativeParent === false) return false;
                this.refCssRule(rule, _insertionIndex, latestNativeParent);
            }
            this.insertRules(parent.rules, latestNativeParent);
            return latestNativeParent;
        }
        var ruleStr = rule.toString();
        if (!ruleStr) return false;
        var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);
        var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
        if (nativeRule === false) return false;
        this.hasInsertedRules = true;
        this.refCssRule(rule, insertionIndex, nativeRule);
        return nativeRule;
    };
    _proto.refCssRule = function refCssRule(rule, index, cssRule) {
        rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
        // like rules inside media queries or keyframes
        if (rule.options.parent instanceof StyleSheet) this.cssRules.splice(index, 0, cssRule);
    } /**
   * Delete a rule.
   */ ;
    _proto.deleteRule = function deleteRule(cssRule) {
        var sheet = this.element.sheet;
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return true;
    } /**
   * Get index of a CSS Rule.
   */ ;
    _proto.indexOf = function indexOf(cssRule) {
        return this.cssRules.indexOf(cssRule);
    } /**
   * Generate a new CSS rule and replace the existing one.
   */ ;
    _proto.replaceRule = function replaceRule(cssRule, rule) {
        var index = this.indexOf(cssRule);
        if (index === -1) return false;
        this.element.sheet.deleteRule(index);
        this.cssRules.splice(index, 1);
        return this.insertRule(rule, index);
    } /**
   * Get all rules elements.
   */ ;
    _proto.getRules = function getRules() {
        return this.element.sheet.cssRules;
    };
    return DomRenderer;
}();
var instanceCounter = 0;
var Jss = /*#__PURE__*/ function() {
    function Jss(options) {
        this.id = instanceCounter++;
        this.version = "10.10.0";
        this.plugins = new PluginsRegistry();
        this.options = {
            id: {
                minify: false
            },
            createGenerateId: createGenerateId,
            Renderer: (0, $lDq78.default) ? DomRenderer : null,
            plugins: []
        };
        this.generateId = createGenerateId({
            minify: false
        });
        for(var i = 0; i < plugins.length; i++)this.plugins.use(plugins[i], {
            queue: 'internal'
        });
        this.setup(options);
    }
    /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */ var _proto = Jss.prototype;
    _proto.setup = function setup(options) {
        if (options === void 0) options = {};
        if (options.createGenerateId) this.options.createGenerateId = options.createGenerateId;
        if (options.id) this.options.id = (0, $eR4tV.default)({}, this.options.id, options.id);
        if (options.createGenerateId || options.id) this.generateId = this.options.createGenerateId(this.options.id);
        if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
        if ('Renderer' in options) this.options.Renderer = options.Renderer;
         // eslint-disable-next-line prefer-spread
        if (options.plugins) this.use.apply(this, options.plugins);
        return this;
    } /**
   * Create a Style Sheet.
   */ ;
    _proto.createStyleSheet = function createStyleSheet(styles, options) {
        if (options === void 0) options = {};
        var _options = options, index = _options.index;
        if (typeof index !== 'number') index = sheets.index === 0 ? 0 : sheets.index + 1;
        var sheet = new StyleSheet(styles, (0, $eR4tV.default)({}, options, {
            jss: this,
            generateId: options.generateId || this.generateId,
            insertionPoint: this.options.insertionPoint,
            Renderer: this.options.Renderer,
            index: index
        }));
        this.plugins.onProcessSheet(sheet);
        return sheet;
    } /**
   * Detach the Style Sheet and remove it from the registry.
   */ ;
    _proto.removeStyleSheet = function removeStyleSheet(sheet) {
        sheet.detach();
        sheets.remove(sheet);
        return this;
    } /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */ ;
    _proto.createRule = function createRule$1(name, style, options) {
        if (style === void 0) style = {};
        if (options === void 0) options = {};
        // Enable rule without name for inline styles.
        if (typeof name === 'object') return this.createRule(undefined, name, style);
        var ruleOptions = (0, $eR4tV.default)({}, options, {
            name: name,
            jss: this,
            Renderer: this.options.Renderer
        });
        if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
        if (!ruleOptions.classes) ruleOptions.classes = {};
        if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
        var rule = createRule(name, style, ruleOptions);
        if (rule) this.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */ ;
    _proto.use = function use() {
        var _this = this;
        for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
        plugins.forEach(function(plugin) {
            _this.plugins.use(plugin);
        });
        return this;
    };
    return Jss;
}();
var createJss = function createJss(options) {
    return new Jss(options);
};
/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */ var SheetsManager = /*#__PURE__*/ function() {
    function SheetsManager() {
        this.length = 0;
        this.sheets = new WeakMap();
    }
    var _proto = SheetsManager.prototype;
    _proto.get = function get(key) {
        var entry = this.sheets.get(key);
        return entry && entry.sheet;
    };
    _proto.add = function add(key, sheet) {
        if (this.sheets.has(key)) return;
        this.length++;
        this.sheets.set(key, {
            sheet: sheet,
            refs: 0
        });
    };
    _proto.manage = function manage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs === 0) entry.sheet.attach();
            entry.refs++;
            return entry.sheet;
        }
        (0, $cf94x.default)(false, "[JSS] SheetsManager: can't find sheet to manage");
        return undefined;
    };
    _proto.unmanage = function unmanage(key) {
        var entry = this.sheets.get(key);
        if (entry) {
            if (entry.refs > 0) {
                entry.refs--;
                if (entry.refs === 0) entry.sheet.detach();
            }
        } else (0, $cf94x.default)(false, "SheetsManager: can't find sheet to unmanage");
    };
    (0, $gPL2t.default)(SheetsManager, [
        {
            key: "size",
            get: function get() {
                return this.length;
            }
        }
    ]);
    return SheetsManager;
}();
/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/ var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Extracts a styles object with only props that contain function values.
 */ function getDynamicStyles(styles) {
    var to = null;
    for(var key in styles){
        var value = styles[key];
        var type = typeof value;
        if (type === 'function') {
            if (!to) to = {};
            to[key] = value;
        } else if (type === 'object' && value !== null && !Array.isArray(value)) {
            var extracted = getDynamicStyles(value);
            if (extracted) {
                if (!to) to = {};
                to[key] = extracted;
            }
        }
    }
    return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */ var index = createJss();
var $f5a995616c837ab6$export$2e2bcd8739ae039 = index;

});
parcelRegister("eR4tV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad097dddec7c7edd$export$2e2bcd8739ae039);
function $ad097dddec7c7edd$export$2e2bcd8739ae039() {
    return $ad097dddec7c7edd$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ad097dddec7c7edd$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("lDq78", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc017f380ae26a99$export$2e2bcd8739ae039);
var $fc017f380ae26a99$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $fc017f380ae26a99$export$4e09c449d6c407f7 = (typeof window === "undefined" ? "undefined" : $fc017f380ae26a99$var$_typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : $fc017f380ae26a99$var$_typeof(document)) === 'object' && document.nodeType === 9;
var $fc017f380ae26a99$export$2e2bcd8739ae039 = $fc017f380ae26a99$export$4e09c449d6c407f7;

});

parcelRegister("cf94x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e9dec522e91235f$export$2e2bcd8739ae039);
var $8e9dec522e91235f$var$isProduction = true;
function $8e9dec522e91235f$var$warning(condition, message) {
    if (!$8e9dec522e91235f$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $8e9dec522e91235f$export$2e2bcd8739ae039 = $8e9dec522e91235f$var$warning;

});

parcelRegister("gPL2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $c415e5ba2e142709$export$2e2bcd8739ae039);

var $kVTLm = parcelRequire("kVTLm");
function $c415e5ba2e142709$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $kVTLm.default)(o.key), o);
    }
}
function $c415e5ba2e142709$export$2e2bcd8739ae039(e, r, t) {
    return r && $c415e5ba2e142709$var$_defineProperties(e.prototype, r), t && $c415e5ba2e142709$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("kVTLm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3d462d849baed73$export$2e2bcd8739ae039);

var $k0ffe = parcelRequire("k0ffe");

var $lXGQm = parcelRequire("lXGQm");
function $f3d462d849baed73$export$2e2bcd8739ae039(t) {
    var i = (0, $lXGQm.default)(t, "string");
    return "symbol" == (0, $k0ffe.default)(i) ? i : i + "";
}

});
parcelRegister("k0ffe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ffa1fd3ee3c0b8$export$2e2bcd8739ae039);
function $e8ffa1fd3ee3c0b8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e8ffa1fd3ee3c0b8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e8ffa1fd3ee3c0b8$export$2e2bcd8739ae039(o);
}

});

parcelRegister("lXGQm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd0578327fd16ad$export$2e2bcd8739ae039);

var $k0ffe = parcelRequire("k0ffe");
function $ffd0578327fd16ad$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $k0ffe.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $k0ffe.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("3W2J1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dd8e70d018bc7f8$export$2e2bcd8739ae039);

var $3DDpj = parcelRequire("3DDpj");
function $2dd8e70d018bc7f8$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3DDpj.default)(t, o);
}

});
parcelRegister("3DDpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a639517b6163a6c$export$2e2bcd8739ae039);
function $2a639517b6163a6c$export$2e2bcd8739ae039(t, e) {
    return $2a639517b6163a6c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2a639517b6163a6c$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("jzHgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e402d9a55f71ea62$export$2e2bcd8739ae039);
function $e402d9a55f71ea62$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("hphT8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cac2a5b4a9896ae9$export$2e2bcd8739ae039);
function $cac2a5b4a9896ae9$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("l2Ecb", function(module, exports) {

$parcel$export(module.exports, "getApiServer", () => $48b545935e79282a$export$6b0a0e50628c0c68);
$parcel$export(module.exports, "getFileServer", () => $48b545935e79282a$export$f85dd8f1286f813c);
$parcel$export(module.exports, "getWebSocketServer", () => $48b545935e79282a$export$514054619f0354c7);
$parcel$export(module.exports, "getMdsWsServer", () => $48b545935e79282a$export$c936a01fc0a08ef8);
$parcel$export(module.exports, "getOasWsServer", () => $48b545935e79282a$export$d1dcf2b0700804d1);
$parcel$export(module.exports, "getAuthClientId", () => $48b545935e79282a$export$1968d6548e59015f);
$parcel$export(module.exports, "getAuthRedirect", () => $48b545935e79282a$export$3fb2521e53c9a472);
$parcel$export(module.exports, "getAuthState", () => $48b545935e79282a$export$36491da625b5403b);
$parcel$export(module.exports, "getAppEnv", () => $48b545935e79282a$export$c5f9c10e769dff78);
$parcel$export(module.exports, "isPreviewMode", () => $48b545935e79282a$export$eb222702d291f55a);
$parcel$export(module.exports, "getSubscriptionPayloadLogMode", () => $48b545935e79282a$export$50f419c23e8b2722);
$parcel$export(module.exports, "isWorkspaceTabRenderOnDemand", () => $48b545935e79282a$export$bb7110a1ef3e59b1);
$parcel$export(module.exports, "isTestingQueryEnabled", () => $48b545935e79282a$export$b3414ab4b38ba9cd);
$parcel$export(module.exports, "getWorkerConfigQueryPrefix", () => $48b545935e79282a$export$14c043ff765916b7);
/** Resolves browser and worker runtime settings and limits query-driven test behavior to supported environments. */ 
var $4Jj9n = parcelRequire("4Jj9n");
const $48b545935e79282a$var$WORKER_QUERY_PREFIX = 'qepcfg_';
const $48b545935e79282a$var$RUNTIME_CONFIG_KEYS = [
    'API_SERVER',
    'FILESERVER',
    'WEBSOCKETSERVER',
    'MDS_WS_SERVER',
    'OAS_WS_SERVER',
    'AUTHCLIENTID',
    'AUTHREDIRECT',
    'AUTHSTATE',
    'APP_ENV',
    'PREVIEW_MODE',
    'SUBSCRIPTION_PAYLOAD_LOG_MODE',
    'WORKSPACE_TAB_RENDER_ON_DEMAND'
];
const $48b545935e79282a$var$RUNTIME_CONFIG_ALIASES = {
    apiServer: 'API_SERVER',
    appEnv: 'APP_ENV',
    fileServer: 'FILESERVER',
    previewMode: 'PREVIEW_MODE',
    workspaceTabRenderOnDemand: 'WORKSPACE_TAB_RENDER_ON_DEMAND',
    webSocketServer: 'WEBSOCKETSERVER',
    mdsWsServer: 'MDS_WS_SERVER',
    oasWsServer: 'OAS_WS_SERVER'
};
const $48b545935e79282a$export$2d61f17461e68a2e = [
    'local',
    'development',
    'staging'
];
const $48b545935e79282a$var$TESTING_APP_ENV_SET = new Set($48b545935e79282a$export$2d61f17461e68a2e);
const $48b545935e79282a$var$readWindowConfig = ()=>globalThis.__QEP_RUNTIME_CONFIG__ ?? {};
/**
 * Treats non-empty runtime values as usable so late Browser config does not erase earlier endpoint config.
 */ const $48b545935e79282a$var$isRuntimeConfigValuePresent = (value)=>value !== undefined && value !== null && value !== '';
/**
 * Normalizes Browser camelCase payloads and worker/env uppercase payloads into one runtime-config shape.
 */ const $48b545935e79282a$var$normalizeRuntimeConfig = (config)=>{
    const normalized = {};
    for (const key of $48b545935e79282a$var$RUNTIME_CONFIG_KEYS){
        const value = config[key];
        if ($48b545935e79282a$var$isRuntimeConfigValuePresent(value)) normalized[key] = String(value);
    }
    for (const [sourceKey, runtimeConfigKey] of Object.entries($48b545935e79282a$var$RUNTIME_CONFIG_ALIASES)){
        const value = config[sourceKey];
        if ($48b545935e79282a$var$isRuntimeConfigValuePresent(value)) normalized[runtimeConfigKey] = String(value);
    }
    return normalized;
};
/**
 * Reads build environment values through direct property access so Parcel can inline preview/deploy endpoints.
 */ const $48b545935e79282a$var$readBuildTimeConfig = ()=>$48b545935e79282a$var$normalizeRuntimeConfig({
        API_SERVER: "https://wgw.uat.qep.trade",
        FILESERVER: "https://uat.qep.trade",
        WEBSOCKETSERVER: "wss://wgw.uat.qep.trade/ws",
        MDS_WS_SERVER: "wss://mds.uat.qep.trade/v1/ws",
        OAS_WS_SERVER: "wss://oas.uat.qep.trade/v1/ws",
        AUTHCLIENTID: "e70c9e2b-f6f5-4172-a62f-ee986fdb2294",
        AUTHREDIRECT: "https://wgw.uat.qep.trade/auth/callback",
        AUTHSTATE: "staging",
        APP_ENV: "staging",
        PREVIEW_MODE: undefined,
        SUBSCRIPTION_PAYLOAD_LOG_MODE: "summary",
        WORKSPACE_TAB_RENDER_ON_DEMAND: "false"
    });
const $48b545935e79282a$export$e97bb19ced909bcb = (config)=>{
    const normalizedConfig = $48b545935e79282a$var$normalizeRuntimeConfig(config);
    globalThis.__QEP_RUNTIME_CONFIG__ = {
        ...$48b545935e79282a$var$readWindowConfig(),
        ...normalizedConfig
    };
};
const $48b545935e79282a$var$readWorkerQueryConfig = (key)=>{
    const { location: location } = globalThis;
    if (!location?.search) return undefined;
    return new URLSearchParams(location.search).get(`${$48b545935e79282a$var$WORKER_QUERY_PREFIX}${key}`) ?? undefined;
};
const $48b545935e79282a$var$readWorkerNameConfig = (key)=>{
    const { name: name } = globalThis;
    if (!name?.includes($48b545935e79282a$var$WORKER_QUERY_PREFIX)) return undefined;
    return new URLSearchParams(name.slice(name.indexOf($48b545935e79282a$var$WORKER_QUERY_PREFIX))).get(`${$48b545935e79282a$var$WORKER_QUERY_PREFIX}${key}`) ?? undefined;
};
const $48b545935e79282a$export$ab31041dd4c00502 = (key)=>$48b545935e79282a$var$readWindowConfig()[key] ?? $48b545935e79282a$var$readWorkerQueryConfig(key) ?? $48b545935e79282a$var$readWorkerNameConfig(key) ?? $48b545935e79282a$var$readBuildTimeConfig()[key] ?? $4Jj9n.env[key];
const $48b545935e79282a$export$6b0a0e50628c0c68 = ()=>$48b545935e79282a$export$ab31041dd4c00502('API_SERVER') ?? '';
const $48b545935e79282a$export$f85dd8f1286f813c = ()=>$48b545935e79282a$export$ab31041dd4c00502('FILESERVER') ?? '';
const $48b545935e79282a$export$514054619f0354c7 = ()=>$48b545935e79282a$export$ab31041dd4c00502('WEBSOCKETSERVER') ?? '';
const $48b545935e79282a$export$c936a01fc0a08ef8 = ()=>$48b545935e79282a$export$ab31041dd4c00502('MDS_WS_SERVER') ?? '';
const $48b545935e79282a$export$d1dcf2b0700804d1 = ()=>$48b545935e79282a$export$ab31041dd4c00502('OAS_WS_SERVER') ?? '';
const $48b545935e79282a$export$1968d6548e59015f = ()=>$48b545935e79282a$export$ab31041dd4c00502('AUTHCLIENTID') ?? '';
const $48b545935e79282a$export$3fb2521e53c9a472 = ()=>$48b545935e79282a$export$ab31041dd4c00502('AUTHREDIRECT') ?? '';
const $48b545935e79282a$export$36491da625b5403b = ()=>$48b545935e79282a$export$ab31041dd4c00502('AUTHSTATE') ?? '';
const $48b545935e79282a$export$c5f9c10e769dff78 = ()=>$48b545935e79282a$export$ab31041dd4c00502('APP_ENV') ?? '';
const $48b545935e79282a$export$eb222702d291f55a = ()=>$48b545935e79282a$export$ab31041dd4c00502('PREVIEW_MODE') === 'true';
const $48b545935e79282a$export$50f419c23e8b2722 = ()=>{
    const mode = $48b545935e79282a$export$ab31041dd4c00502('SUBSCRIPTION_PAYLOAD_LOG_MODE')?.trim().toLowerCase();
    if (mode === 'full' || mode === 'off') return mode;
    return 'summary';
};
const $48b545935e79282a$export$bb7110a1ef3e59b1 = ()=>$48b545935e79282a$export$ab31041dd4c00502('WORKSPACE_TAB_RENDER_ON_DEMAND')?.trim().toLowerCase() === 'true';
const $48b545935e79282a$export$41513cb308067e60 = (appEnv = $48b545935e79282a$export$c5f9c10e769dff78())=>$48b545935e79282a$var$TESTING_APP_ENV_SET.has(appEnv);
const $48b545935e79282a$export$b3414ab4b38ba9cd = (search = globalThis.location?.search ?? '')=>$48b545935e79282a$export$41513cb308067e60() && new URLSearchParams(search).get('testing') === 'true';
const $48b545935e79282a$export$14c043ff765916b7 = ()=>$48b545935e79282a$var$WORKER_QUERY_PREFIX;

});
parcelRegister("4Jj9n", function(module, exports) {
// shim for using process in browser
var $371a3837fd81d701$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};

});


parcelRegister("983Jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a57c1da9856f8eb$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $lx97N = parcelRequire("lx97N");

var $kRMlr = parcelRequire("kRMlr");

var $7Taur = parcelRequire("7Taur");

var $e3IZc = parcelRequire("e3IZc");

var $eQjGP = parcelRequire("eQjGP");
const $6a57c1da9856f8eb$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $lx97N.forwardRef)(({ className: className, ...props }, ref)=>(0, $lx97N.createElement)((0, $eQjGP.default), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $kRMlr.mergeClasses)(`lucide-${(0, $7Taur.toKebabCase)((0, $e3IZc.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $e3IZc.toPascalCase)(iconName);
    return Component;
};

});
parcelRegister("kRMlr", function(module, exports) {

$parcel$export(module.exports, "mergeClasses", () => $f30e422a8164335f$export$3d46f4579dba46e5);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $f30e422a8164335f$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();

});

parcelRegister("7Taur", function(module, exports) {

$parcel$export(module.exports, "toKebabCase", () => $5be5ce92a7cd3ffe$export$73bda83cddbc7187);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $5be5ce92a7cd3ffe$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

});

parcelRegister("e3IZc", function(module, exports) {

$parcel$export(module.exports, "toPascalCase", () => $a3c43dd3a90491e9$export$6fb43ff9addf7357);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $bAAqG = parcelRequire("bAAqG");
const $a3c43dd3a90491e9$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $bAAqG.toCamelCase)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};

});
parcelRegister("bAAqG", function(module, exports) {

$parcel$export(module.exports, "toCamelCase", () => $86ff50a2aaa76382$export$86f54f62aa7a7514);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $86ff50a2aaa76382$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());

});


parcelRegister("eQjGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace53204c3adf8ac$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $lx97N = parcelRequire("lx97N");

var $4NWzy = parcelRequire("4NWzy");

var $03huC = parcelRequire("03huC");

var $kRMlr = parcelRequire("kRMlr");
const $ace53204c3adf8ac$export$2e2bcd8739ae039 = (0, $lx97N.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $lx97N.createElement)("svg", {
        ref: ref,
        ...(0, $4NWzy.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $kRMlr.mergeClasses)("lucide", className),
        ...!children && !(0, $03huC.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $lx97N.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

});
parcelRegister("4NWzy", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f92c4e5cc6f1dd$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $37f92c4e5cc6f1dd$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

});

parcelRegister("03huC", function(module, exports) {

$parcel$export(module.exports, "hasA11yProp", () => $009dd9abfb149e10$export$ab365959aa6deed0);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $009dd9abfb149e10$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};

});



parcelRegister("5Wk8r", function(module, exports) {

$parcel$export(module.exports, "createAction", () => $4531fcedfce0ecca$export$309c7a02b0b0bc62);
$parcel$export(module.exports, "configureStore", () => $4531fcedfce0ecca$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createReducer", () => $4531fcedfce0ecca$export$473eb76d322d0290);
$parcel$export(module.exports, "createAsyncThunk", () => $4531fcedfce0ecca$export$6abd22dc03e5063f);
$parcel$export(module.exports, "createSlice", () => $4531fcedfce0ecca$export$4d8d9bd83c24ae8b);

var $QDzUP = parcelRequire("QDzUP");

var $f00np = parcelRequire("f00np");

var $khMaO = parcelRequire("khMaO");

var $h6tBd = parcelRequire("h6tBd");

var $4Jj9n = parcelRequire("4Jj9n");
var $4531fcedfce0ecca$var$__defProp = Object.defineProperty;
var $4531fcedfce0ecca$var$__defProps = Object.defineProperties;
var $4531fcedfce0ecca$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $4531fcedfce0ecca$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $4531fcedfce0ecca$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4531fcedfce0ecca$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $4531fcedfce0ecca$var$__defNormalProp = (obj, key, value)=>key in obj ? $4531fcedfce0ecca$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $4531fcedfce0ecca$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($4531fcedfce0ecca$var$__hasOwnProp.call(b, prop)) $4531fcedfce0ecca$var$__defNormalProp(a, prop, b[prop]);
    if ($4531fcedfce0ecca$var$__getOwnPropSymbols) {
        for (var prop of $4531fcedfce0ecca$var$__getOwnPropSymbols(b))if ($4531fcedfce0ecca$var$__propIsEnum.call(b, prop)) $4531fcedfce0ecca$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $4531fcedfce0ecca$var$__spreadProps = (a, b)=>$4531fcedfce0ecca$var$__defProps(a, $4531fcedfce0ecca$var$__getOwnPropDescs(b));
var $4531fcedfce0ecca$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($4531fcedfce0ecca$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $4531fcedfce0ecca$var$__getOwnPropSymbols) {
        for (var prop of $4531fcedfce0ecca$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $4531fcedfce0ecca$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $4531fcedfce0ecca$var$__publicField = (obj, key, value)=>$4531fcedfce0ecca$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var $4531fcedfce0ecca$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $khMaO.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $f00np.isDraft)(value) ? (0, $f00np.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $4531fcedfce0ecca$export$a5d3c27355e35910 = /* @__PURE__ */ $4531fcedfce0ecca$export$aab6de9e3dbb1473((0, $khMaO.weakMapMemoize));
var $4531fcedfce0ecca$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $QDzUP.compose;
    return (0, $QDzUP.compose).apply(null, arguments);
};
var $4531fcedfce0ecca$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $4531fcedfce0ecca$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $4531fcedfce0ecca$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(0));
            return $4531fcedfce0ecca$var$__spreadValues($4531fcedfce0ecca$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $QDzUP.isAction)(action) && action.type === type;
    return actionCreator;
}
function $4531fcedfce0ecca$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $4531fcedfce0ecca$var$hasMatchFunction(action);
}
function $4531fcedfce0ecca$export$ebd532f9034651f3(action) {
    return (0, $QDzUP.isAction)(action) && Object.keys(action).every($4531fcedfce0ecca$var$isValidKey);
}
function $4531fcedfce0ecca$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $4531fcedfce0ecca$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $4531fcedfce0ecca$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $4531fcedfce0ecca$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $4531fcedfce0ecca$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $4531fcedfce0ecca$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $4531fcedfce0ecca$var$freezeDraftable(val) {
    return (0, $f00np.isDraftable)(val) ? (0, $f00np.produce)(val, ()=>{}) : val;
}
function $4531fcedfce0ecca$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $4531fcedfce0ecca$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $4531fcedfce0ecca$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $4531fcedfce0ecca$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $4531fcedfce0ecca$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $4531fcedfce0ecca$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $4531fcedfce0ecca$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $4531fcedfce0ecca$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $4531fcedfce0ecca$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $4531fcedfce0ecca$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $4531fcedfce0ecca$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $QDzUP.isPlainObject)(val);
}
function $4531fcedfce0ecca$export$ada5dca0b571bc7(value, path = "", isSerializable = $4531fcedfce0ecca$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $4531fcedfce0ecca$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $4531fcedfce0ecca$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $4531fcedfce0ecca$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$4531fcedfce0ecca$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $4531fcedfce0ecca$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $4531fcedfce0ecca$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $4531fcedfce0ecca$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new $4531fcedfce0ecca$export$1908877435b1d5e9();
        if (thunk) {
            if ($4531fcedfce0ecca$var$isBoolean(thunk)) middlewareArray.push((0, $h6tBd.thunk));
            else middlewareArray.push((0, $h6tBd.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $4531fcedfce0ecca$export$8fb31c0f05df007b = "RTK_autoBatch";
var $4531fcedfce0ecca$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$4531fcedfce0ecca$export$8fb31c0f05df007b]: true
            }
        });
var $4531fcedfce0ecca$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $4531fcedfce0ecca$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $4531fcedfce0ecca$var$createQueueWithTimer(10);
var $4531fcedfce0ecca$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $4531fcedfce0ecca$var$rAF : options.type === "callback" ? options.queueNotification : $4531fcedfce0ecca$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$4531fcedfce0ecca$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $4531fcedfce0ecca$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options != null ? options : {};
        let enhancerArray = new $4531fcedfce0ecca$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($4531fcedfce0ecca$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $4531fcedfce0ecca$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $4531fcedfce0ecca$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $QDzUP.isPlainObject)(reducer)) rootReducer = (0, $QDzUP.combineReducers)(reducer);
    else throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, $QDzUP.compose);
    if (devTools) finalCompose = $4531fcedfce0ecca$var$composeWithDevTools($4531fcedfce0ecca$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, $QDzUP.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $4531fcedfce0ecca$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $QDzUP.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $4531fcedfce0ecca$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $4531fcedfce0ecca$var$isStateFunction(x) {
    return typeof x === "function";
}
function $4531fcedfce0ecca$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $4531fcedfce0ecca$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($4531fcedfce0ecca$var$isStateFunction(initialState)) getInitialState = ()=>$4531fcedfce0ecca$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $4531fcedfce0ecca$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $f00np.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $f00np.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $f00np.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $4531fcedfce0ecca$var$matches = (matcher, action)=>{
    if ($4531fcedfce0ecca$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $4531fcedfce0ecca$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$4531fcedfce0ecca$var$matches(matcher, action));
    };
}
function $4531fcedfce0ecca$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$4531fcedfce0ecca$var$matches(matcher, action));
    };
}
function $4531fcedfce0ecca$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $4531fcedfce0ecca$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $4531fcedfce0ecca$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4531fcedfce0ecca$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$4531fcedfce0ecca$var$isAsyncThunkArray(asyncThunks)) return $4531fcedfce0ecca$export$872dec21e9a69476()(asyncThunks[0]);
    return $4531fcedfce0ecca$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $4531fcedfce0ecca$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4531fcedfce0ecca$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$4531fcedfce0ecca$var$isAsyncThunkArray(asyncThunks)) return $4531fcedfce0ecca$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $4531fcedfce0ecca$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $4531fcedfce0ecca$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $4531fcedfce0ecca$export$9dd1fb32974da385($4531fcedfce0ecca$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$4531fcedfce0ecca$var$isAsyncThunkArray(asyncThunks)) return $4531fcedfce0ecca$export$fcc3388fb56de601()(asyncThunks[0]);
    return $4531fcedfce0ecca$export$9dd1fb32974da385($4531fcedfce0ecca$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $4531fcedfce0ecca$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4531fcedfce0ecca$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$4531fcedfce0ecca$var$isAsyncThunkArray(asyncThunks)) return $4531fcedfce0ecca$export$1da80a6ef1307441()(asyncThunks[0]);
    return $4531fcedfce0ecca$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $4531fcedfce0ecca$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$4531fcedfce0ecca$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$4531fcedfce0ecca$var$isAsyncThunkArray(asyncThunks)) return $4531fcedfce0ecca$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $4531fcedfce0ecca$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $4531fcedfce0ecca$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $4531fcedfce0ecca$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $4531fcedfce0ecca$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $4531fcedfce0ecca$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $4531fcedfce0ecca$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $4531fcedfce0ecca$var$__publicField(this, "_type");
    }
};
var $4531fcedfce0ecca$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $4531fcedfce0ecca$var$__publicField(this, "_type");
    }
};
var $4531fcedfce0ecca$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $4531fcedfce0ecca$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $4531fcedfce0ecca$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $4531fcedfce0ecca$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: $4531fcedfce0ecca$var$__spreadProps($4531fcedfce0ecca$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = $4531fcedfce0ecca$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: $4531fcedfce0ecca$var$__spreadProps($4531fcedfce0ecca$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = $4531fcedfce0ecca$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $4531fcedfce0ecca$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $4531fcedfce0ecca$var$__spreadProps($4531fcedfce0ecca$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $4531fcedfce0ecca$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($4531fcedfce0ecca$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $4531fcedfce0ecca$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $4531fcedfce0ecca$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $4531fcedfce0ecca$var$RejectWithValue) throw result;
                                if (result instanceof $4531fcedfce0ecca$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $4531fcedfce0ecca$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($4531fcedfce0ecca$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $4531fcedfce0ecca$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $4531fcedfce0ecca$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $4531fcedfce0ecca$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $4531fcedfce0ecca$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $4531fcedfce0ecca$export$343355ed40c51c46 = {
    [$4531fcedfce0ecca$var$asyncThunkSymbol]: $4531fcedfce0ecca$export$6abd22dc03e5063f
};
var $4531fcedfce0ecca$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($4531fcedfce0ecca$export$23a094319a4b586 || {});
function $4531fcedfce0ecca$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $4531fcedfce0ecca$export$affdea4146de9cf5({ creators: creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$4531fcedfce0ecca$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(11));
        typeof $4Jj9n;
        const reducers = (typeof options.reducers === "function" ? options.reducers($4531fcedfce0ecca$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $4531fcedfce0ecca$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($4531fcedfce0ecca$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $4531fcedfce0ecca$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $4531fcedfce0ecca$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $4531fcedfce0ecca$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = $4531fcedfce0ecca$var$__spreadValues($4531fcedfce0ecca$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $4531fcedfce0ecca$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $4531fcedfce0ecca$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $4531fcedfce0ecca$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        var _a2;
                        const map = {};
                        for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = $4531fcedfce0ecca$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = $4531fcedfce0ecca$var$__spreadProps($4531fcedfce0ecca$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = $4531fcedfce0ecca$var$__objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $4531fcedfce0ecca$var$__spreadValues($4531fcedfce0ecca$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $4531fcedfce0ecca$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $4531fcedfce0ecca$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $4531fcedfce0ecca$export$affdea4146de9cf5();
function $4531fcedfce0ecca$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $4531fcedfce0ecca$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $4531fcedfce0ecca$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$4531fcedfce0ecca$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $4531fcedfce0ecca$export$309c7a02b0b0bc62(type, prepareCallback) : $4531fcedfce0ecca$export$309c7a02b0b0bc62(type));
}
function $4531fcedfce0ecca$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $4531fcedfce0ecca$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $4531fcedfce0ecca$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $4531fcedfce0ecca$var$noop,
        pending: pending || $4531fcedfce0ecca$var$noop,
        rejected: rejected || $4531fcedfce0ecca$var$noop,
        settled: settled || $4531fcedfce0ecca$var$noop
    });
}
function $4531fcedfce0ecca$var$noop() {}
// src/entities/entity_state.ts
function $4531fcedfce0ecca$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $4531fcedfce0ecca$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($4531fcedfce0ecca$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $4531fcedfce0ecca$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $4531fcedfce0ecca$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $4531fcedfce0ecca$var$isDraftTyped = (0, $f00np.isDraft);
function $4531fcedfce0ecca$var$createSingleArgumentStateOperator(mutator) {
    const operator = $4531fcedfce0ecca$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $4531fcedfce0ecca$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $4531fcedfce0ecca$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($4531fcedfce0ecca$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $f00np.produce)(state, runMutator);
    };
}
function $4531fcedfce0ecca$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $4531fcedfce0ecca$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $4531fcedfce0ecca$var$getCurrent(value) {
    return (0, $f00np.isDraft)(value) ? (0, $f00np.current)(value) : value;
}
function $4531fcedfce0ecca$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $4531fcedfce0ecca$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $4531fcedfce0ecca$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $4531fcedfce0ecca$var$selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $4531fcedfce0ecca$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $4531fcedfce0ecca$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $4531fcedfce0ecca$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $4531fcedfce0ecca$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4531fcedfce0ecca$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4531fcedfce0ecca$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $4531fcedfce0ecca$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $4531fcedfce0ecca$var$__spreadValues($4531fcedfce0ecca$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$4531fcedfce0ecca$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $4531fcedfce0ecca$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $4531fcedfce0ecca$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $4531fcedfce0ecca$var$createStateOperator(addOneMutably),
        addMany: $4531fcedfce0ecca$var$createStateOperator(addManyMutably),
        setOne: $4531fcedfce0ecca$var$createStateOperator(setOneMutably),
        setMany: $4531fcedfce0ecca$var$createStateOperator(setManyMutably),
        setAll: $4531fcedfce0ecca$var$createStateOperator(setAllMutably),
        updateOne: $4531fcedfce0ecca$var$createStateOperator(updateOneMutably),
        updateMany: $4531fcedfce0ecca$var$createStateOperator(updateManyMutably),
        upsertOne: $4531fcedfce0ecca$var$createStateOperator(upsertOneMutably),
        upsertMany: $4531fcedfce0ecca$var$createStateOperator(upsertManyMutably),
        removeOne: $4531fcedfce0ecca$var$createStateOperator(removeOneMutably),
        removeMany: $4531fcedfce0ecca$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $4531fcedfce0ecca$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $4531fcedfce0ecca$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $4531fcedfce0ecca$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $4531fcedfce0ecca$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $4531fcedfce0ecca$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $4531fcedfce0ecca$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : $4531fcedfce0ecca$var$getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has($4531fcedfce0ecca$var$selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $4531fcedfce0ecca$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $4531fcedfce0ecca$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $4531fcedfce0ecca$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $4531fcedfce0ecca$var$getCurrent(state.entities);
        const currentIds = $4531fcedfce0ecca$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $4531fcedfce0ecca$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $4531fcedfce0ecca$var$createStateOperator(addOneMutably),
        updateOne: $4531fcedfce0ecca$var$createStateOperator(updateOneMutably),
        upsertOne: $4531fcedfce0ecca$var$createStateOperator(upsertOneMutably),
        setOne: $4531fcedfce0ecca$var$createStateOperator(setOneMutably),
        setMany: $4531fcedfce0ecca$var$createStateOperator(setManyMutably),
        setAll: $4531fcedfce0ecca$var$createStateOperator(setAllMutably),
        addMany: $4531fcedfce0ecca$var$createStateOperator(addManyMutably),
        updateMany: $4531fcedfce0ecca$var$createStateOperator(updateManyMutably),
        upsertMany: $4531fcedfce0ecca$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $4531fcedfce0ecca$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = $4531fcedfce0ecca$var$__spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? $4531fcedfce0ecca$var$createSortedStateAdapter(selectId, sortComparer) : $4531fcedfce0ecca$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $4531fcedfce0ecca$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $4531fcedfce0ecca$var$createSelectorsFactory();
    return $4531fcedfce0ecca$var$__spreadValues($4531fcedfce0ecca$var$__spreadValues($4531fcedfce0ecca$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $4531fcedfce0ecca$var$task = "task";
var $4531fcedfce0ecca$var$listener = "listener";
var $4531fcedfce0ecca$var$completed = "completed";
var $4531fcedfce0ecca$var$cancelled = "cancelled";
var $4531fcedfce0ecca$var$taskCancelled = `task-${$4531fcedfce0ecca$var$cancelled}`;
var $4531fcedfce0ecca$var$taskCompleted = `task-${$4531fcedfce0ecca$var$completed}`;
var $4531fcedfce0ecca$var$listenerCancelled = `${$4531fcedfce0ecca$var$listener}-${$4531fcedfce0ecca$var$cancelled}`;
var $4531fcedfce0ecca$var$listenerCompleted = `${$4531fcedfce0ecca$var$listener}-${$4531fcedfce0ecca$var$completed}`;
var $4531fcedfce0ecca$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        $4531fcedfce0ecca$var$__publicField(this, "name", "TaskAbortError");
        $4531fcedfce0ecca$var$__publicField(this, "message");
        this.message = `${$4531fcedfce0ecca$var$task} ${$4531fcedfce0ecca$var$cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var $4531fcedfce0ecca$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(32));
};
var $4531fcedfce0ecca$var$noop2 = ()=>{};
var $4531fcedfce0ecca$var$catchRejection = (promise, onError = $4531fcedfce0ecca$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $4531fcedfce0ecca$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $4531fcedfce0ecca$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $4531fcedfce0ecca$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $4531fcedfce0ecca$export$cb1bdac908fed7f(reason);
    }
};
function $4531fcedfce0ecca$var$raceWithSignal(signal, promise) {
    let cleanup = $4531fcedfce0ecca$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $4531fcedfce0ecca$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $4531fcedfce0ecca$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $4531fcedfce0ecca$var$noop2;
    });
}
var $4531fcedfce0ecca$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $4531fcedfce0ecca$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var $4531fcedfce0ecca$var$createPause = (signal)=>{
    return (promise)=>{
        return $4531fcedfce0ecca$var$catchRejection($4531fcedfce0ecca$var$raceWithSignal(signal, promise).then((output)=>{
            $4531fcedfce0ecca$var$validateActive(signal);
            return output;
        }));
    };
};
var $4531fcedfce0ecca$var$createDelay = (signal)=>{
    const pause = $4531fcedfce0ecca$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $4531fcedfce0ecca$var$assign } = Object;
var $4531fcedfce0ecca$var$INTERNAL_NIL_TOKEN = {};
var $4531fcedfce0ecca$var$alm = "listenerMiddleware";
var $4531fcedfce0ecca$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$4531fcedfce0ecca$var$addAbortSignalListener(parentAbortSignal, ()=>$4531fcedfce0ecca$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $4531fcedfce0ecca$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $4531fcedfce0ecca$var$runTask(async ()=>{
            $4531fcedfce0ecca$var$validateActive(parentAbortSignal);
            $4531fcedfce0ecca$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $4531fcedfce0ecca$var$createPause(childAbortController.signal),
                delay: $4531fcedfce0ecca$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $4531fcedfce0ecca$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$4531fcedfce0ecca$var$abortControllerWithReason(childAbortController, $4531fcedfce0ecca$var$taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($4531fcedfce0ecca$var$noop2));
        return {
            result: $4531fcedfce0ecca$var$createPause(parentAbortSignal)(result),
            cancel () {
                $4531fcedfce0ecca$var$abortControllerWithReason(childAbortController, $4531fcedfce0ecca$var$taskCancelled);
            }
        };
    };
};
var $4531fcedfce0ecca$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $4531fcedfce0ecca$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $4531fcedfce0ecca$var$raceWithSignal(signal, Promise.race(promises));
            $4531fcedfce0ecca$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$4531fcedfce0ecca$var$catchRejection(take(predicate, timeout));
};
var $4531fcedfce0ecca$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $4531fcedfce0ecca$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(21));
    $4531fcedfce0ecca$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $4531fcedfce0ecca$var$createListenerEntry = /* @__PURE__ */ $4531fcedfce0ecca$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $4531fcedfce0ecca$var$getListenerEntryPropsFrom(options);
    const id = $4531fcedfce0ecca$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$4531fcedfce0ecca$var$createListenerEntry
});
var $4531fcedfce0ecca$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $4531fcedfce0ecca$var$abortControllerWithReason(controller, $4531fcedfce0ecca$var$listenerCancelled);
    });
};
var $4531fcedfce0ecca$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($4531fcedfce0ecca$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $4531fcedfce0ecca$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $4531fcedfce0ecca$export$f03a6b845d3fb58b = /* @__PURE__ */ $4531fcedfce0ecca$var$assign(/* @__PURE__ */ $4531fcedfce0ecca$export$309c7a02b0b0bc62(`${$4531fcedfce0ecca$var$alm}/add`), {
    withTypes: ()=>$4531fcedfce0ecca$export$f03a6b845d3fb58b
});
var $4531fcedfce0ecca$export$b1b8022855fb2b71 = /* @__PURE__ */ $4531fcedfce0ecca$export$309c7a02b0b0bc62(`${$4531fcedfce0ecca$var$alm}/removeAll`);
var $4531fcedfce0ecca$export$b03e9483f936dccb = /* @__PURE__ */ $4531fcedfce0ecca$var$assign(/* @__PURE__ */ $4531fcedfce0ecca$export$309c7a02b0b0bc62(`${$4531fcedfce0ecca$var$alm}/remove`), {
    withTypes: ()=>$4531fcedfce0ecca$export$b03e9483f936dccb
});
var $4531fcedfce0ecca$var$defaultErrorHandler = (...args)=>{
    console.error(`${$4531fcedfce0ecca$var$alm}/error`, ...args);
};
var $4531fcedfce0ecca$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $4531fcedfce0ecca$var$defaultErrorHandler } = middlewareOptions;
    $4531fcedfce0ecca$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $4531fcedfce0ecca$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $4531fcedfce0ecca$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $4531fcedfce0ecca$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $4531fcedfce0ecca$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $4531fcedfce0ecca$var$getListenerEntryPropsFrom(options);
        const entry = $4531fcedfce0ecca$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $4531fcedfce0ecca$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $4531fcedfce0ecca$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $4531fcedfce0ecca$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $4531fcedfce0ecca$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $4531fcedfce0ecca$var$createDelay(internalTaskController.signal),
                pause: $4531fcedfce0ecca$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $4531fcedfce0ecca$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $4531fcedfce0ecca$var$abortControllerWithReason(controller, $4531fcedfce0ecca$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $4531fcedfce0ecca$var$abortControllerWithReason(internalTaskController, $4531fcedfce0ecca$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $4531fcedfce0ecca$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $4531fcedfce0ecca$export$cb1bdac908fed7f)) $4531fcedfce0ecca$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $4531fcedfce0ecca$var$abortControllerWithReason(internalTaskController, $4531fcedfce0ecca$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $4531fcedfce0ecca$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $QDzUP.isAction)(action)) return next(action);
                if ($4531fcedfce0ecca$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($4531fcedfce0ecca$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($4531fcedfce0ecca$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $4531fcedfce0ecca$var$INTERNAL_NIL_TOKEN) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $4531fcedfce0ecca$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $4531fcedfce0ecca$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $4531fcedfce0ecca$var$createMiddlewareEntry = (middleware)=>({
        id: $4531fcedfce0ecca$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $4531fcedfce0ecca$var$matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var $4531fcedfce0ecca$export$4bb1606a79445586 = ()=>{
    const instanceId = $4531fcedfce0ecca$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($4531fcedfce0ecca$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $4531fcedfce0ecca$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $4531fcedfce0ecca$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$4531fcedfce0ecca$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $QDzUP.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $4531fcedfce0ecca$export$9dd1fb32974da385(withMiddleware, $4531fcedfce0ecca$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $4531fcedfce0ecca$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $4531fcedfce0ecca$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$4531fcedfce0ecca$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $4531fcedfce0ecca$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $4531fcedfce0ecca$var$isStateProxy = (value)=>!!value && !!value[$4531fcedfce0ecca$var$ORIGINAL_STATE];
var $4531fcedfce0ecca$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $4531fcedfce0ecca$var$createStateProxy = (state, reducerMap)=>$4531fcedfce0ecca$var$emplace($4531fcedfce0ecca$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $4531fcedfce0ecca$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $4531fcedfce0ecca$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $4531fcedfce0ecca$var$original = (state)=>{
    if (!$4531fcedfce0ecca$var$isStateProxy(state)) throw new Error($4531fcedfce0ecca$export$378fa86b259c0280(25));
    return state[$4531fcedfce0ecca$var$ORIGINAL_STATE];
};
var $4531fcedfce0ecca$var$noopReducer = (state = {})=>state;
function $4531fcedfce0ecca$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($4531fcedfce0ecca$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $QDzUP.combineReducers)(reducerMap) : $4531fcedfce0ecca$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $4Jj9n;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($4531fcedfce0ecca$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $4531fcedfce0ecca$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $4531fcedfce0ecca$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});

parcelRegister("f00Nn", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $aeb779073e6ae545$export$a7c73072b1a182ae, (v) => $aeb779073e6ae545$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $aeb779073e6ae545$export$9f27bc3417b4524d, (v) => $aeb779073e6ae545$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $aeb779073e6ae545$export$db77ccec0bb4ccac, (v) => $aeb779073e6ae545$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $aeb779073e6ae545$export$8392c0c9d3dcbd35, (v) => $aeb779073e6ae545$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $aeb779073e6ae545$export$ffb0004e005737fa, (v) => $aeb779073e6ae545$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $aeb779073e6ae545$export$b624eff549462981, (v) => $aeb779073e6ae545$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $aeb779073e6ae545$export$7897aa7841a5380c, (v) => $aeb779073e6ae545$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $aeb779073e6ae545$export$602eac185826482c, (v) => $aeb779073e6ae545$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $aeb779073e6ae545$export$e2c29f18771995cb, (v) => $aeb779073e6ae545$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $aeb779073e6ae545$export$5f8d39834fd61797, (v) => $aeb779073e6ae545$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $aeb779073e6ae545$export$74bf444e3cd11ea5, (v) => $aeb779073e6ae545$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $aeb779073e6ae545$export$998bcd577473dd93, (v) => $aeb779073e6ae545$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $aeb779073e6ae545$export$92387174baf9b227, (v) => $aeb779073e6ae545$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $aeb779073e6ae545$export$ec112efeb987d9c6, (v) => $aeb779073e6ae545$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $aeb779073e6ae545$export$b706b080d889d2c9, (v) => $aeb779073e6ae545$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $aeb779073e6ae545$export$5be5a87408f70ddc, (v) => $aeb779073e6ae545$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $aeb779073e6ae545$export$45a5e7f76e0caa8d, (v) => $aeb779073e6ae545$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $aeb779073e6ae545$export$455c2e768291efa6, (v) => $aeb779073e6ae545$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $aeb779073e6ae545$export$9522e17588c12572, (v) => $aeb779073e6ae545$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $aeb779073e6ae545$export$2110ac352bb060b9, (v) => $aeb779073e6ae545$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $aeb779073e6ae545$export$56885ab8b9c456ab, (v) => $aeb779073e6ae545$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $aeb779073e6ae545$export$d927fcb6adf8f9de, (v) => $aeb779073e6ae545$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $aeb779073e6ae545$export$b82d16f27459e05a, (v) => $aeb779073e6ae545$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $aeb779073e6ae545$export$522c17b4f5e123e8, (v) => $aeb779073e6ae545$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $aeb779073e6ae545$export$1aabd8a0274ecfd6, (v) => $aeb779073e6ae545$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $aeb779073e6ae545$export$3d6c20d97e46b957, (v) => $aeb779073e6ae545$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $aeb779073e6ae545$export$9b621391a187a31a, (v) => $aeb779073e6ae545$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $aeb779073e6ae545$export$f5bbd400c2f4426f, (v) => $aeb779073e6ae545$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aeb779073e6ae545$export$a7c73072b1a182ae;
var $aeb779073e6ae545$export$9f27bc3417b4524d;
var $aeb779073e6ae545$export$db77ccec0bb4ccac;
var $aeb779073e6ae545$export$8392c0c9d3dcbd35;
var $aeb779073e6ae545$export$ffb0004e005737fa;
var $aeb779073e6ae545$export$b624eff549462981;
var $aeb779073e6ae545$export$7897aa7841a5380c;
var $aeb779073e6ae545$export$602eac185826482c;
var $aeb779073e6ae545$export$e2c29f18771995cb;
var $aeb779073e6ae545$export$5f8d39834fd61797;
var $aeb779073e6ae545$export$74bf444e3cd11ea5;
var $aeb779073e6ae545$export$998bcd577473dd93;
var $aeb779073e6ae545$export$92387174baf9b227;
var $aeb779073e6ae545$export$ec112efeb987d9c6;
var $aeb779073e6ae545$export$b706b080d889d2c9;
var $aeb779073e6ae545$export$5be5a87408f70ddc;
var $aeb779073e6ae545$export$45a5e7f76e0caa8d;
var $aeb779073e6ae545$export$455c2e768291efa6;
var $aeb779073e6ae545$export$9522e17588c12572;
var $aeb779073e6ae545$export$2110ac352bb060b9;
var $aeb779073e6ae545$export$56885ab8b9c456ab;
var $aeb779073e6ae545$export$d927fcb6adf8f9de;
var $aeb779073e6ae545$export$b82d16f27459e05a;
var $aeb779073e6ae545$export$522c17b4f5e123e8;
var $aeb779073e6ae545$export$1aabd8a0274ecfd6;
var $aeb779073e6ae545$export$3d6c20d97e46b957;
var $aeb779073e6ae545$export$9b621391a187a31a;
var $aeb779073e6ae545$export$f5bbd400c2f4426f;
'use strict';
var $aeb779073e6ae545$var$b = Symbol.for("react.element"), $aeb779073e6ae545$var$c = Symbol.for("react.portal"), $aeb779073e6ae545$var$d = Symbol.for("react.fragment"), $aeb779073e6ae545$var$e = Symbol.for("react.strict_mode"), $aeb779073e6ae545$var$f = Symbol.for("react.profiler"), $aeb779073e6ae545$var$g = Symbol.for("react.provider"), $aeb779073e6ae545$var$h = Symbol.for("react.context"), $aeb779073e6ae545$var$k = Symbol.for("react.server_context"), $aeb779073e6ae545$var$l = Symbol.for("react.forward_ref"), $aeb779073e6ae545$var$m = Symbol.for("react.suspense"), $aeb779073e6ae545$var$n = Symbol.for("react.suspense_list"), $aeb779073e6ae545$var$p = Symbol.for("react.memo"), $aeb779073e6ae545$var$q = Symbol.for("react.lazy"), $aeb779073e6ae545$var$t = Symbol.for("react.offscreen"), $aeb779073e6ae545$var$u;
$aeb779073e6ae545$var$u = Symbol.for("react.module.reference");
function $aeb779073e6ae545$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $aeb779073e6ae545$var$b:
                switch(a = a.type, a){
                    case $aeb779073e6ae545$var$d:
                    case $aeb779073e6ae545$var$f:
                    case $aeb779073e6ae545$var$e:
                    case $aeb779073e6ae545$var$m:
                    case $aeb779073e6ae545$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $aeb779073e6ae545$var$k:
                            case $aeb779073e6ae545$var$h:
                            case $aeb779073e6ae545$var$l:
                            case $aeb779073e6ae545$var$q:
                            case $aeb779073e6ae545$var$p:
                            case $aeb779073e6ae545$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $aeb779073e6ae545$var$c:
                return r;
        }
    }
}
$aeb779073e6ae545$export$a7c73072b1a182ae = $aeb779073e6ae545$var$h;
$aeb779073e6ae545$export$9f27bc3417b4524d = $aeb779073e6ae545$var$g;
$aeb779073e6ae545$export$db77ccec0bb4ccac = $aeb779073e6ae545$var$b;
$aeb779073e6ae545$export$8392c0c9d3dcbd35 = $aeb779073e6ae545$var$l;
$aeb779073e6ae545$export$ffb0004e005737fa = $aeb779073e6ae545$var$d;
$aeb779073e6ae545$export$b624eff549462981 = $aeb779073e6ae545$var$q;
$aeb779073e6ae545$export$7897aa7841a5380c = $aeb779073e6ae545$var$p;
$aeb779073e6ae545$export$602eac185826482c = $aeb779073e6ae545$var$c;
$aeb779073e6ae545$export$e2c29f18771995cb = $aeb779073e6ae545$var$f;
$aeb779073e6ae545$export$5f8d39834fd61797 = $aeb779073e6ae545$var$e;
$aeb779073e6ae545$export$74bf444e3cd11ea5 = $aeb779073e6ae545$var$m;
$aeb779073e6ae545$export$998bcd577473dd93 = $aeb779073e6ae545$var$n;
$aeb779073e6ae545$export$92387174baf9b227 = function() {
    return !1;
};
$aeb779073e6ae545$export$ec112efeb987d9c6 = function() {
    return !1;
};
$aeb779073e6ae545$export$b706b080d889d2c9 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$h;
};
$aeb779073e6ae545$export$5be5a87408f70ddc = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$g;
};
$aeb779073e6ae545$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $aeb779073e6ae545$var$b;
};
$aeb779073e6ae545$export$455c2e768291efa6 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$l;
};
$aeb779073e6ae545$export$9522e17588c12572 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$d;
};
$aeb779073e6ae545$export$2110ac352bb060b9 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$q;
};
$aeb779073e6ae545$export$56885ab8b9c456ab = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$p;
};
$aeb779073e6ae545$export$d927fcb6adf8f9de = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$c;
};
$aeb779073e6ae545$export$b82d16f27459e05a = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$f;
};
$aeb779073e6ae545$export$522c17b4f5e123e8 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$e;
};
$aeb779073e6ae545$export$1aabd8a0274ecfd6 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$m;
};
$aeb779073e6ae545$export$3d6c20d97e46b957 = function(a) {
    return $aeb779073e6ae545$var$v(a) === $aeb779073e6ae545$var$n;
};
$aeb779073e6ae545$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $aeb779073e6ae545$var$d || a === $aeb779073e6ae545$var$f || a === $aeb779073e6ae545$var$e || a === $aeb779073e6ae545$var$m || a === $aeb779073e6ae545$var$n || a === $aeb779073e6ae545$var$t || "object" === typeof a && null !== a && (a.$$typeof === $aeb779073e6ae545$var$q || a.$$typeof === $aeb779073e6ae545$var$p || a.$$typeof === $aeb779073e6ae545$var$g || a.$$typeof === $aeb779073e6ae545$var$h || a.$$typeof === $aeb779073e6ae545$var$l || a.$$typeof === $aeb779073e6ae545$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$aeb779073e6ae545$export$f5bbd400c2f4426f = $aeb779073e6ae545$var$v;

});

parcelRegister("dFcVn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3EewP.default;
    }
});

var $3EewP = parcelRequire("3EewP");

});
parcelRegister("3EewP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a806097d76e4a7f$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");

var $k77HR = parcelRequire("k77HR");

var $fRwNr = parcelRequire("fRwNr");
function $2a806097d76e4a7f$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $k77HR.default), (0, $eR4tV.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $k77HR.default).muiName;
    return /*#__PURE__*/ $lx97N.memo(/*#__PURE__*/ $lx97N.forwardRef(Component));
}

});
parcelRegister("k77HR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea4a7069bdc8c7e4$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");

var $4BrfH = parcelRequire("4BrfH");

var $zetlx = parcelRequire("zetlx");

var $7Ys8f = parcelRequire("7Ys8f");

var $dcTXD = parcelRequire("dcTXD");

var $fRwNr = parcelRequire("fRwNr");
const $ea4a7069bdc8c7e4$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $ea4a7069bdc8c7e4$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $4BrfH.default)(color)}`,
            `fontSize${(0, $4BrfH.default)(fontSize)}`
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $dcTXD.getSvgIconUtilityClass), classes);
};
const $ea4a7069bdc8c7e4$var$SvgIconRoot = (0, $7Ys8f.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $4BrfH.default)(ownerState.color)}`],
            styles[`fontSize${(0, $4BrfH.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$transitions2$d, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette$ownerState$c2, _palette2, _palette2$action, _palette3, _palette3$action;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        fill: 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null ? void 0 : (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null ? void 0 : (_theme$transitions2$d = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2$d.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null ? void 0 : (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null ? void 0 : (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null ? void 0 : (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null ? void 0 : (_palette$ownerState$c2 = _palette[ownerState.color]) == null ? void 0 : _palette$ownerState$c2.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null ? void 0 : (_palette2$action = _palette2.action) == null ? void 0 : _palette2$action.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null ? void 0 : (_palette3$action = _palette3.action) == null ? void 0 : _palette3$action.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $ea4a7069bdc8c7e4$var$SvgIcon = /*#__PURE__*/ $lx97N.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $hphT8.default)(props, $ea4a7069bdc8c7e4$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $ea4a7069bdc8c7e4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($ea4a7069bdc8c7e4$var$SvgIconRoot, (0, $eR4tV.default)({
        as: component,
        className: (0, $fmTP4.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, {
        ownerState: ownerState,
        children: [
            children,
            titleAccess ? /*#__PURE__*/ (0, $fRwNr.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$ea4a7069bdc8c7e4$var$SvgIcon.muiName = 'SvgIcon';
var $ea4a7069bdc8c7e4$export$2e2bcd8739ae039 = $ea4a7069bdc8c7e4$var$SvgIcon;

});
parcelRegister("fmTP4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b304364f8f64d6f9$export$2e2bcd8739ae039);
function $b304364f8f64d6f9$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $b304364f8f64d6f9$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $b304364f8f64d6f9$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $b304364f8f64d6f9$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $b304364f8f64d6f9$export$2e2bcd8739ae039 = $b304364f8f64d6f9$export$4f5d2d50c9deca37;

});

parcelRegister("8o5tH", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b4d074bce67131$export$2e2bcd8739ae039);
function $61b4d074bce67131$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("4BrfH", function(module, exports) {

$parcel$export(module.exports, "default", () => $359fc1da6f8f939e$export$2e2bcd8739ae039);

var $8rM6t = parcelRequire("8rM6t");
var $359fc1da6f8f939e$export$2e2bcd8739ae039 = (0, $8rM6t.default);

});
parcelRegister("8rM6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $626628af3085f7dd$export$2e2bcd8739ae039);

var $43Mr2 = parcelRequire("43Mr2");
function $626628af3085f7dd$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $43Mr2.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("43Mr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4d03738b378abe$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $2f4d03738b378abe$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});



parcelRegister("zetlx", function(module, exports) {

$parcel$export(module.exports, "default", () => $069e7ee6dee674ff$export$2e2bcd8739ae039);

var $3VxPf = parcelRequire("3VxPf");

var $cbdKw = parcelRequire("cbdKw");

var $Rnxzq = parcelRequire("Rnxzq");
function $069e7ee6dee674ff$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $3VxPf.default)({
        props: props,
        name: name,
        defaultTheme: $cbdKw.default,
        themeId: (0, $Rnxzq.default)
    });
}

});
parcelRegister("3VxPf", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dc0ef0417230c80$export$2e2bcd8739ae039);

var $hspre = parcelRequire("hspre");

var $43QO7 = parcelRequire("43QO7");
'use client';
function $2dc0ef0417230c80$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $43QO7.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $hspre.default)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}

});
parcelRegister("hspre", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb58c8b23594c77d$export$2e2bcd8739ae039);

var $bo0T6 = parcelRequire("bo0T6");
function $cb58c8b23594c77d$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $bo0T6.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("bo0T6", function(module, exports) {

$parcel$export(module.exports, "default", () => $84a29fe44c77995f$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");
function $84a29fe44c77995f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $eR4tV.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $eR4tV.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $eR4tV.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $84a29fe44c77995f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});


parcelRegister("43QO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5067b3bbc9dbd7$export$2e2bcd8739ae039);

var $jT8G1 = parcelRequire("jT8G1");

var $jQQSa = parcelRequire("jQQSa");
'use client';
const $2f5067b3bbc9dbd7$export$35e57303dbd8a66 = (0, $jT8G1.default)();
function $2f5067b3bbc9dbd7$var$useTheme(defaultTheme = $2f5067b3bbc9dbd7$export$35e57303dbd8a66) {
    return (0, $jQQSa.default)(defaultTheme);
}
var $2f5067b3bbc9dbd7$export$2e2bcd8739ae039 = $2f5067b3bbc9dbd7$var$useTheme;

});
parcelRegister("jT8G1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7a9e26049c98371$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $8zw8B = parcelRequire("8zw8B");

var $51cQb = parcelRequire("51cQb");

var $jOW9m = parcelRequire("jOW9m");

var $fiMdj = parcelRequire("fiMdj");

var $j1oop = parcelRequire("j1oop");

var $5sbKe = parcelRequire("5sbKe");

var $c8pRu = parcelRequire("c8pRu");
const $e7a9e26049c98371$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $e7a9e26049c98371$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $hphT8.default)(options, $e7a9e26049c98371$var$_excluded);
    const breakpoints = (0, $51cQb.default)(breakpointsInput);
    const spacing = (0, $fiMdj.default)(spacingInput);
    let muiTheme = (0, $8zw8B.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $eR4tV.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $eR4tV.default)({}, (0, $jOW9m.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $c8pRu.default);
    muiTheme = args.reduce((acc, argument)=>(0, $8zw8B.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $eR4tV.default)({}, (0, $5sbKe.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $j1oop.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $e7a9e26049c98371$export$2e2bcd8739ae039 = $e7a9e26049c98371$var$createTheme;

});
parcelRegister("8zw8B", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $63da85803bab0fc5$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $63da85803bab0fc5$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");
function $63da85803bab0fc5$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $63da85803bab0fc5$var$deepClone(source) {
    if (/*#__PURE__*/ $lx97N.isValidElement(source) || !$63da85803bab0fc5$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $63da85803bab0fc5$var$deepClone(source[key]);
    });
    return output;
}
function $63da85803bab0fc5$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $eR4tV.default)({}, target) : target;
    if ($63da85803bab0fc5$export$53b83ca8eaab0383(target) && $63da85803bab0fc5$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $lx97N.isValidElement(source[key])) output[key] = source[key];
        else if ($63da85803bab0fc5$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $63da85803bab0fc5$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $63da85803bab0fc5$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $63da85803bab0fc5$export$53b83ca8eaab0383(source[key]) ? $63da85803bab0fc5$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("51cQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a7701a586210239$export$2e2bcd8739ae039);

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");
const $3a7701a586210239$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $3a7701a586210239$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $3a7701a586210239$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $eR4tV.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $3a7701a586210239$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $hphT8.default)(breakpoints, $3a7701a586210239$var$_excluded);
    const sortedValues = $3a7701a586210239$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $eR4tV.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("jOW9m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6dfcb353bc01b0c$export$2e2bcd8739ae039);
const $e6dfcb353bc01b0c$var$shape = {
    borderRadius: 4
};
var $e6dfcb353bc01b0c$export$2e2bcd8739ae039 = $e6dfcb353bc01b0c$var$shape;

});

parcelRegister("fiMdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $b23defb306adea9a$export$2e2bcd8739ae039);

var $c5nRf = parcelRequire("c5nRf");
function $b23defb306adea9a$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $c5nRf.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("c5nRf", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $8cc87554d3828a7f$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $8cc87554d3828a7f$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $8cc87554d3828a7f$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $8cc87554d3828a7f$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $8cc87554d3828a7f$export$6f98e8eaf0be1996);


var $l5e2T = parcelRequire("l5e2T");

var $6aRyc = parcelRequire("6aRyc");

var $8Jv5h = parcelRequire("8Jv5h");

var $bBKL5 = parcelRequire("bBKL5");
const $8cc87554d3828a7f$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $8cc87554d3828a7f$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $8cc87554d3828a7f$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $8cc87554d3828a7f$var$getCssProperties = (0, $bBKL5.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($8cc87554d3828a7f$var$aliases[prop]) prop = $8cc87554d3828a7f$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $8cc87554d3828a7f$var$properties[a];
    const direction = $8cc87554d3828a7f$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $8cc87554d3828a7f$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $8cc87554d3828a7f$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $8cc87554d3828a7f$var$spacingKeys = [
    ...$8cc87554d3828a7f$export$aab52a0dde05ad8a,
    ...$8cc87554d3828a7f$export$f8397d44f03ab6ad
];
function $8cc87554d3828a7f$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $6aRyc.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $8cc87554d3828a7f$export$1def6f833384e3d1(theme) {
    return $8cc87554d3828a7f$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $8cc87554d3828a7f$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $8cc87554d3828a7f$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $8cc87554d3828a7f$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $8cc87554d3828a7f$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $8cc87554d3828a7f$var$getCssProperties(prop);
    const styleFromPropValue = $8cc87554d3828a7f$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $l5e2T.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $8cc87554d3828a7f$var$style(props, keys) {
    const transformer = $8cc87554d3828a7f$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$8cc87554d3828a7f$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $8Jv5h.default), {});
}
function $8cc87554d3828a7f$export$7ede87f9b603dd3c(props) {
    return $8cc87554d3828a7f$var$style(props, $8cc87554d3828a7f$export$aab52a0dde05ad8a);
}
$8cc87554d3828a7f$export$7ede87f9b603dd3c.propTypes = {};
$8cc87554d3828a7f$export$7ede87f9b603dd3c.filterProps = $8cc87554d3828a7f$export$aab52a0dde05ad8a;
function $8cc87554d3828a7f$export$6f98e8eaf0be1996(props) {
    return $8cc87554d3828a7f$var$style(props, $8cc87554d3828a7f$export$f8397d44f03ab6ad);
}
$8cc87554d3828a7f$export$6f98e8eaf0be1996.propTypes = {};
$8cc87554d3828a7f$export$6f98e8eaf0be1996.filterProps = $8cc87554d3828a7f$export$f8397d44f03ab6ad;
function $8cc87554d3828a7f$var$spacing(props) {
    return $8cc87554d3828a7f$var$style(props, $8cc87554d3828a7f$var$spacingKeys);
}
$8cc87554d3828a7f$var$spacing.propTypes = {};
$8cc87554d3828a7f$var$spacing.filterProps = $8cc87554d3828a7f$var$spacingKeys;
var $8cc87554d3828a7f$export$2e2bcd8739ae039 = $8cc87554d3828a7f$var$spacing;

});
parcelRegister("l5e2T", function(module, exports) {

$parcel$export(module.exports, "values", () => $f594f5c6429be6bc$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $f594f5c6429be6bc$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $f594f5c6429be6bc$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $f594f5c6429be6bc$export$8922c90b6e020726);
$parcel$export(module.exports, "mergeBreakpointsInOrder", () => $f594f5c6429be6bc$export$b89a003a1e05c0ee);
$parcel$export(module.exports, "resolveBreakpointValues", () => $f594f5c6429be6bc$export$980e6a259d807490);

var $eR4tV = parcelRequire("eR4tV");


var $8zw8B = parcelRequire("8zw8B");

var $8Jv5h = parcelRequire("8Jv5h");
const $f594f5c6429be6bc$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $f594f5c6429be6bc$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$f594f5c6429be6bc$export$68c286be0e7e55b7[key]}px)`
};
function $f594f5c6429be6bc$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $f594f5c6429be6bc$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $f594f5c6429be6bc$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $f594f5c6429be6bc$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $f594f5c6429be6bc$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $f594f5c6429be6bc$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $eR4tV.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $8Jv5h.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $f594f5c6429be6bc$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $f594f5c6429be6bc$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $f594f5c6429be6bc$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $f594f5c6429be6bc$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $8zw8B.default)(prev, next), {});
    return $f594f5c6429be6bc$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $f594f5c6429be6bc$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $f594f5c6429be6bc$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $f594f5c6429be6bc$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $f594f5c6429be6bc$export$2e2bcd8739ae039 = $f594f5c6429be6bc$var$breakpoints;

});
parcelRegister("8Jv5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $65baa35791418388$export$2e2bcd8739ae039);

var $8zw8B = parcelRequire("8zw8B");
function $65baa35791418388$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $8zw8B.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $65baa35791418388$export$2e2bcd8739ae039 = $65baa35791418388$var$merge;

});


parcelRegister("6aRyc", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $47ed374a066f0c36$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $47ed374a066f0c36$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $47ed374a066f0c36$export$2e2bcd8739ae039);

var $8rM6t = parcelRequire("8rM6t");


var $l5e2T = parcelRequire("l5e2T");
function $47ed374a066f0c36$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $47ed374a066f0c36$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $47ed374a066f0c36$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $47ed374a066f0c36$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $47ed374a066f0c36$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $47ed374a066f0c36$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $47ed374a066f0c36$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $8rM6t.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $l5e2T.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $47ed374a066f0c36$export$2e2bcd8739ae039 = $47ed374a066f0c36$var$style;

});

parcelRegister("bBKL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $87376ba5a2b39378$export$2e2bcd8739ae039);
function $87376ba5a2b39378$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("j1oop", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd9108324c112517$export$2e2bcd8739ae039);

var $8rM6t = parcelRequire("8rM6t");

var $8Jv5h = parcelRequire("8Jv5h");

var $6aRyc = parcelRequire("6aRyc");

var $l5e2T = parcelRequire("l5e2T");

var $5sbKe = parcelRequire("5sbKe");
function $dd9108324c112517$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $dd9108324c112517$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $dd9108324c112517$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $6aRyc.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $6aRyc.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $6aRyc.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $8rM6t.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $l5e2T.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $5sbKe.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $l5e2T.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $dd9108324c112517$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $8Jv5h.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $l5e2T.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($dd9108324c112517$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $8Jv5h.default)(css, breakpointsValues);
                        }
                    } else css = (0, $8Jv5h.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $l5e2T.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $l5e2T.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $dd9108324c112517$var$styleFunctionSx = $dd9108324c112517$export$7d53d8bf2911e013();
$dd9108324c112517$var$styleFunctionSx.filterProps = [
    'sx'
];
var $dd9108324c112517$export$2e2bcd8739ae039 = $dd9108324c112517$var$styleFunctionSx;

});
parcelRegister("5sbKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f88ad80a10880d8$export$2e2bcd8739ae039);

var $c5nRf = parcelRequire("c5nRf");

var $be7Zo = parcelRequire("be7Zo");

var $ekUbt = parcelRequire("ekUbt");

var $4DvC7 = parcelRequire("4DvC7");

var $2fcsU = parcelRequire("2fcsU");
const $3f88ad80a10880d8$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $be7Zo.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $be7Zo.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $be7Zo.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $be7Zo.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $be7Zo.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $be7Zo.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $be7Zo.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $4DvC7.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $4DvC7.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $4DvC7.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $c5nRf.padding)
    },
    pt: {
        style: (0, $c5nRf.padding)
    },
    pr: {
        style: (0, $c5nRf.padding)
    },
    pb: {
        style: (0, $c5nRf.padding)
    },
    pl: {
        style: (0, $c5nRf.padding)
    },
    px: {
        style: (0, $c5nRf.padding)
    },
    py: {
        style: (0, $c5nRf.padding)
    },
    padding: {
        style: (0, $c5nRf.padding)
    },
    paddingTop: {
        style: (0, $c5nRf.padding)
    },
    paddingRight: {
        style: (0, $c5nRf.padding)
    },
    paddingBottom: {
        style: (0, $c5nRf.padding)
    },
    paddingLeft: {
        style: (0, $c5nRf.padding)
    },
    paddingX: {
        style: (0, $c5nRf.padding)
    },
    paddingY: {
        style: (0, $c5nRf.padding)
    },
    paddingInline: {
        style: (0, $c5nRf.padding)
    },
    paddingInlineStart: {
        style: (0, $c5nRf.padding)
    },
    paddingInlineEnd: {
        style: (0, $c5nRf.padding)
    },
    paddingBlock: {
        style: (0, $c5nRf.padding)
    },
    paddingBlockStart: {
        style: (0, $c5nRf.padding)
    },
    paddingBlockEnd: {
        style: (0, $c5nRf.padding)
    },
    m: {
        style: (0, $c5nRf.margin)
    },
    mt: {
        style: (0, $c5nRf.margin)
    },
    mr: {
        style: (0, $c5nRf.margin)
    },
    mb: {
        style: (0, $c5nRf.margin)
    },
    ml: {
        style: (0, $c5nRf.margin)
    },
    mx: {
        style: (0, $c5nRf.margin)
    },
    my: {
        style: (0, $c5nRf.margin)
    },
    margin: {
        style: (0, $c5nRf.margin)
    },
    marginTop: {
        style: (0, $c5nRf.margin)
    },
    marginRight: {
        style: (0, $c5nRf.margin)
    },
    marginBottom: {
        style: (0, $c5nRf.margin)
    },
    marginLeft: {
        style: (0, $c5nRf.margin)
    },
    marginX: {
        style: (0, $c5nRf.margin)
    },
    marginY: {
        style: (0, $c5nRf.margin)
    },
    marginInline: {
        style: (0, $c5nRf.margin)
    },
    marginInlineStart: {
        style: (0, $c5nRf.margin)
    },
    marginInlineEnd: {
        style: (0, $c5nRf.margin)
    },
    marginBlock: {
        style: (0, $c5nRf.margin)
    },
    marginBlockStart: {
        style: (0, $c5nRf.margin)
    },
    marginBlockEnd: {
        style: (0, $c5nRf.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $ekUbt.gap)
    },
    rowGap: {
        style: (0, $ekUbt.rowGap)
    },
    columnGap: {
        style: (0, $ekUbt.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $2fcsU.sizingTransform)
    },
    maxWidth: {
        style: (0, $2fcsU.maxWidth)
    },
    minWidth: {
        transform: (0, $2fcsU.sizingTransform)
    },
    height: {
        transform: (0, $2fcsU.sizingTransform)
    },
    maxHeight: {
        transform: (0, $2fcsU.sizingTransform)
    },
    minHeight: {
        transform: (0, $2fcsU.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $3f88ad80a10880d8$export$2e2bcd8739ae039 = $3f88ad80a10880d8$var$defaultSxConfig;

});
parcelRegister("be7Zo", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $82c7330113aaa521$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $82c7330113aaa521$export$7a57f79000377ca2);


var $6aRyc = parcelRequire("6aRyc");

var $53zW6 = parcelRequire("53zW6");

var $c5nRf = parcelRequire("c5nRf");

var $l5e2T = parcelRequire("l5e2T");
function $82c7330113aaa521$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $82c7330113aaa521$var$createBorderStyle(prop, transform) {
    return (0, $6aRyc.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $82c7330113aaa521$export$1edee58a52776cd9 = $82c7330113aaa521$var$createBorderStyle('border', $82c7330113aaa521$export$34e2febe53ae29cc);
const $82c7330113aaa521$export$f9a7b6bd24892946 = $82c7330113aaa521$var$createBorderStyle('borderTop', $82c7330113aaa521$export$34e2febe53ae29cc);
const $82c7330113aaa521$export$5abca33e6be905d2 = $82c7330113aaa521$var$createBorderStyle('borderRight', $82c7330113aaa521$export$34e2febe53ae29cc);
const $82c7330113aaa521$export$e2ce9f12a980a822 = $82c7330113aaa521$var$createBorderStyle('borderBottom', $82c7330113aaa521$export$34e2febe53ae29cc);
const $82c7330113aaa521$export$47658cca1a909427 = $82c7330113aaa521$var$createBorderStyle('borderLeft', $82c7330113aaa521$export$34e2febe53ae29cc);
const $82c7330113aaa521$export$e7fb0694ba2404fc = $82c7330113aaa521$var$createBorderStyle('borderColor');
const $82c7330113aaa521$export$126a92c968acdb85 = $82c7330113aaa521$var$createBorderStyle('borderTopColor');
const $82c7330113aaa521$export$85cc51cb8fbb8c0e = $82c7330113aaa521$var$createBorderStyle('borderRightColor');
const $82c7330113aaa521$export$340b0327727f6d1a = $82c7330113aaa521$var$createBorderStyle('borderBottomColor');
const $82c7330113aaa521$export$60beef91a985b4bf = $82c7330113aaa521$var$createBorderStyle('borderLeftColor');
const $82c7330113aaa521$export$f9258c55612cbed7 = $82c7330113aaa521$var$createBorderStyle('outline', $82c7330113aaa521$export$34e2febe53ae29cc);
const $82c7330113aaa521$export$621fe586efeb64b9 = $82c7330113aaa521$var$createBorderStyle('outlineColor');
const $82c7330113aaa521$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $c5nRf.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $c5nRf.getValue)(transformer, propValue)
            });
        return (0, $l5e2T.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$82c7330113aaa521$export$7a57f79000377ca2.propTypes = {};
$82c7330113aaa521$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $82c7330113aaa521$var$borders = (0, $53zW6.default)($82c7330113aaa521$export$1edee58a52776cd9, $82c7330113aaa521$export$f9a7b6bd24892946, $82c7330113aaa521$export$5abca33e6be905d2, $82c7330113aaa521$export$e2ce9f12a980a822, $82c7330113aaa521$export$47658cca1a909427, $82c7330113aaa521$export$e7fb0694ba2404fc, $82c7330113aaa521$export$126a92c968acdb85, $82c7330113aaa521$export$85cc51cb8fbb8c0e, $82c7330113aaa521$export$340b0327727f6d1a, $82c7330113aaa521$export$60beef91a985b4bf, $82c7330113aaa521$export$7a57f79000377ca2, $82c7330113aaa521$export$f9258c55612cbed7, $82c7330113aaa521$export$621fe586efeb64b9);
var $82c7330113aaa521$export$2e2bcd8739ae039 = $82c7330113aaa521$var$borders;

});
parcelRegister("53zW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae91bc044bd231e$export$2e2bcd8739ae039);

var $8Jv5h = parcelRequire("8Jv5h");
function $3ae91bc044bd231e$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $8Jv5h.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $3ae91bc044bd231e$export$2e2bcd8739ae039 = $3ae91bc044bd231e$var$compose;

});


parcelRegister("ekUbt", function(module, exports) {

$parcel$export(module.exports, "gap", () => $a6fe83eaa79b0f90$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $a6fe83eaa79b0f90$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $a6fe83eaa79b0f90$export$8a833ffa5f5dbeda);

var $6aRyc = parcelRequire("6aRyc");

var $53zW6 = parcelRequire("53zW6");

var $c5nRf = parcelRequire("c5nRf");

var $l5e2T = parcelRequire("l5e2T");

const $a6fe83eaa79b0f90$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $c5nRf.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $c5nRf.getValue)(transformer, propValue)
            });
        return (0, $l5e2T.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$a6fe83eaa79b0f90$export$5df9adcb0db95e1e.propTypes = {};
$a6fe83eaa79b0f90$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $a6fe83eaa79b0f90$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $c5nRf.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $c5nRf.getValue)(transformer, propValue)
            });
        return (0, $l5e2T.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$a6fe83eaa79b0f90$export$ec60d70ff941a580.propTypes = {};
$a6fe83eaa79b0f90$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $a6fe83eaa79b0f90$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $c5nRf.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $c5nRf.getValue)(transformer, propValue)
            });
        return (0, $l5e2T.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$a6fe83eaa79b0f90$export$8a833ffa5f5dbeda.propTypes = {};
$a6fe83eaa79b0f90$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $a6fe83eaa79b0f90$export$baf44164ca3a34e8 = (0, $6aRyc.default)({
    prop: 'gridColumn'
});
const $a6fe83eaa79b0f90$export$8f7213a1cd01e832 = (0, $6aRyc.default)({
    prop: 'gridRow'
});
const $a6fe83eaa79b0f90$export$b0e0abbc49ba668 = (0, $6aRyc.default)({
    prop: 'gridAutoFlow'
});
const $a6fe83eaa79b0f90$export$bcd8b929d4b4142 = (0, $6aRyc.default)({
    prop: 'gridAutoColumns'
});
const $a6fe83eaa79b0f90$export$e5039a674e14c828 = (0, $6aRyc.default)({
    prop: 'gridAutoRows'
});
const $a6fe83eaa79b0f90$export$42bd9088661ffb03 = (0, $6aRyc.default)({
    prop: 'gridTemplateColumns'
});
const $a6fe83eaa79b0f90$export$920682ae05b999bc = (0, $6aRyc.default)({
    prop: 'gridTemplateRows'
});
const $a6fe83eaa79b0f90$export$1b88fbdd482fd33a = (0, $6aRyc.default)({
    prop: 'gridTemplateAreas'
});
const $a6fe83eaa79b0f90$export$bdb486e40d52d26f = (0, $6aRyc.default)({
    prop: 'gridArea'
});
const $a6fe83eaa79b0f90$var$grid = (0, $53zW6.default)($a6fe83eaa79b0f90$export$5df9adcb0db95e1e, $a6fe83eaa79b0f90$export$ec60d70ff941a580, $a6fe83eaa79b0f90$export$8a833ffa5f5dbeda, $a6fe83eaa79b0f90$export$baf44164ca3a34e8, $a6fe83eaa79b0f90$export$8f7213a1cd01e832, $a6fe83eaa79b0f90$export$b0e0abbc49ba668, $a6fe83eaa79b0f90$export$bcd8b929d4b4142, $a6fe83eaa79b0f90$export$e5039a674e14c828, $a6fe83eaa79b0f90$export$42bd9088661ffb03, $a6fe83eaa79b0f90$export$920682ae05b999bc, $a6fe83eaa79b0f90$export$1b88fbdd482fd33a, $a6fe83eaa79b0f90$export$bdb486e40d52d26f);
var $a6fe83eaa79b0f90$export$2e2bcd8739ae039 = $a6fe83eaa79b0f90$var$grid;

});

parcelRegister("4DvC7", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $360353c4fdc8e9a1$export$dbaffd4420ea0ac6);

var $6aRyc = parcelRequire("6aRyc");

var $53zW6 = parcelRequire("53zW6");
function $360353c4fdc8e9a1$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $360353c4fdc8e9a1$export$35e9368ef982300f = (0, $6aRyc.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $360353c4fdc8e9a1$export$dbaffd4420ea0ac6
});
const $360353c4fdc8e9a1$export$2506f56c10355b33 = (0, $6aRyc.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $360353c4fdc8e9a1$export$dbaffd4420ea0ac6
});
const $360353c4fdc8e9a1$export$8c5a050822fd698c = (0, $6aRyc.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $360353c4fdc8e9a1$export$dbaffd4420ea0ac6
});
const $360353c4fdc8e9a1$var$palette = (0, $53zW6.default)($360353c4fdc8e9a1$export$35e9368ef982300f, $360353c4fdc8e9a1$export$2506f56c10355b33, $360353c4fdc8e9a1$export$8c5a050822fd698c);
var $360353c4fdc8e9a1$export$2e2bcd8739ae039 = $360353c4fdc8e9a1$var$palette;

});

parcelRegister("2fcsU", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $1a26a6d2bf482809$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $1a26a6d2bf482809$export$488fda99655ff65a);

var $6aRyc = parcelRequire("6aRyc");

var $53zW6 = parcelRequire("53zW6");

var $l5e2T = parcelRequire("l5e2T");
function $1a26a6d2bf482809$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $1a26a6d2bf482809$export$7e3df82ee760448c = (0, $6aRyc.default)({
    prop: 'width',
    transform: $1a26a6d2bf482809$export$8afece71750ec241
});
const $1a26a6d2bf482809$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $l5e2T.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $1a26a6d2bf482809$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $l5e2T.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$1a26a6d2bf482809$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $1a26a6d2bf482809$export$ee148fbbe8357dd2 = (0, $6aRyc.default)({
    prop: 'minWidth',
    transform: $1a26a6d2bf482809$export$8afece71750ec241
});
const $1a26a6d2bf482809$export$ac607276a8fe9f0a = (0, $6aRyc.default)({
    prop: 'height',
    transform: $1a26a6d2bf482809$export$8afece71750ec241
});
const $1a26a6d2bf482809$export$dc0d8bd0b94f8570 = (0, $6aRyc.default)({
    prop: 'maxHeight',
    transform: $1a26a6d2bf482809$export$8afece71750ec241
});
const $1a26a6d2bf482809$export$a43cf604e12f3b17 = (0, $6aRyc.default)({
    prop: 'minHeight',
    transform: $1a26a6d2bf482809$export$8afece71750ec241
});
const $1a26a6d2bf482809$export$ffed9f14fb65e276 = (0, $6aRyc.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $1a26a6d2bf482809$export$8afece71750ec241
});
const $1a26a6d2bf482809$export$905076ed6620e671 = (0, $6aRyc.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $1a26a6d2bf482809$export$8afece71750ec241
});
const $1a26a6d2bf482809$export$6ccc93f785106a58 = (0, $6aRyc.default)({
    prop: 'boxSizing'
});
const $1a26a6d2bf482809$var$sizing = (0, $53zW6.default)($1a26a6d2bf482809$export$7e3df82ee760448c, $1a26a6d2bf482809$export$488fda99655ff65a, $1a26a6d2bf482809$export$ee148fbbe8357dd2, $1a26a6d2bf482809$export$ac607276a8fe9f0a, $1a26a6d2bf482809$export$dc0d8bd0b94f8570, $1a26a6d2bf482809$export$a43cf604e12f3b17, $1a26a6d2bf482809$export$6ccc93f785106a58);
var $1a26a6d2bf482809$export$2e2bcd8739ae039 = $1a26a6d2bf482809$var$sizing;

});



parcelRegister("c8pRu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d5a4afe2569fc5c$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $8d5a4afe2569fc5c$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("jQQSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73be30d11c0a4d8$export$2e2bcd8739ae039);

var $lx97N = parcelRequire("lx97N");
parcelRequire("9Hxe6");
var $jx6dC = parcelRequire("jx6dC");
'use client';
function $e73be30d11c0a4d8$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $e73be30d11c0a4d8$var$useTheme(defaultTheme = null) {
    const contextTheme = $lx97N.useContext((0, $jx6dC.T));
    return !contextTheme || $e73be30d11c0a4d8$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $e73be30d11c0a4d8$export$2e2bcd8739ae039 = $e73be30d11c0a4d8$var$useTheme;

});
parcelRegister("9Hxe6", function(module, exports) {

$parcel$export(module.exports, "Global", () => $7101e75081d0f94c$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $7101e75081d0f94c$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $7101e75081d0f94c$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("jx6dC")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("jx6dC")).w);

var $jx6dC = parcelRequire("jx6dC");

var $lx97N = parcelRequire("lx97N");

var $3oBZb = parcelRequire("3oBZb");

var $fZcY5 = parcelRequire("fZcY5");

var $eC8G3 = parcelRequire("eC8G3");
parcelRequire("jZyl4");
parcelRequire("8Wv3B");
parcelRequire("g8a6V");

parcelRequire("4Djfw");
var $7101e75081d0f94c$var$pkg = {
    name: "@emotion/react",
    version: "11.11.0",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $7101e75081d0f94c$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $jx6dC.h).call(props, 'css')) // $FlowFixMe
    return $lx97N.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $jx6dC.E);
    createElementArgArray[1] = (0, $jx6dC.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $lx97N.createElement.apply(null, createElementArgArray);
};
var $7101e75081d0f94c$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $7101e75081d0f94c$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $jx6dC.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $eC8G3.serializeStyles)([
        styles
    ], undefined, $lx97N.useContext((0, $jx6dC.T)));
    if (!(0, $jx6dC.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $lx97N.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $lx97N.useRef();
    (0, $fZcY5.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $fZcY5.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $3oBZb.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $7101e75081d0f94c$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $eC8G3.serializeStyles)(args);
}
var $7101e75081d0f94c$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $7101e75081d0f94c$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $7101e75081d0f94c$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $7101e75081d0f94c$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $3oBZb.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $7101e75081d0f94c$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $fZcY5.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $3oBZb.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $7101e75081d0f94c$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $jx6dC.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $eC8G3.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $3oBZb.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $7101e75081d0f94c$var$merge(cache.registered, css, $7101e75081d0f94c$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $lx97N.useContext((0, $jx6dC.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $lx97N.createElement($lx97N.Fragment, null, /*#__PURE__*/ $lx97N.createElement($7101e75081d0f94c$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $7101e75081d0f94c$var$isBrowser, $7101e75081d0f94c$var$isTestEnv, $7101e75081d0f94c$var$globalContext, $7101e75081d0f94c$var$globalKey;

});
parcelRegister("jx6dC", function(module, exports) {

$parcel$export(module.exports, "i", () => $e385ec476690f3fc$export$23f2a1d2818174ef);
$parcel$export(module.exports, "h", () => $e385ec476690f3fc$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "w", () => $e385ec476690f3fc$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $e385ec476690f3fc$export$971d5caa766a69d7);
$parcel$export(module.exports, "c", () => $e385ec476690f3fc$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $e385ec476690f3fc$export$a9c23c6ac3fc3eca);

var $lx97N = parcelRequire("lx97N");

var $jZyl4 = parcelRequire("jZyl4");

var $eR4tV = parcelRequire("eR4tV");

var $g8a6V = parcelRequire("g8a6V");

var $4xF3v = parcelRequire("4xF3v");

var $3oBZb = parcelRequire("3oBZb");

var $eC8G3 = parcelRequire("eC8G3");

var $fZcY5 = parcelRequire("fZcY5");
var $e385ec476690f3fc$export$23f2a1d2818174ef = true;
var $e385ec476690f3fc$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e385ec476690f3fc$var$EmotionCacheContext = /* #__PURE__ */ $lx97N.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $jZyl4.default)({
    key: 'css'
}) : null);
var $e385ec476690f3fc$export$e7094788287c5e9b = $e385ec476690f3fc$var$EmotionCacheContext.Provider;
var $e385ec476690f3fc$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $lx97N.useContext)($e385ec476690f3fc$var$EmotionCacheContext);
};
var $e385ec476690f3fc$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $lx97N.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $lx97N.useContext)($e385ec476690f3fc$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e385ec476690f3fc$export$23f2a1d2818174ef) $e385ec476690f3fc$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $lx97N.useContext)($e385ec476690f3fc$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $jZyl4.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $lx97N.createElement($e385ec476690f3fc$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e385ec476690f3fc$export$971d5caa766a69d7 = /* #__PURE__ */ $lx97N.createContext({});
var $e385ec476690f3fc$export$3b14a55fb2447963 = function useTheme() {
    return $lx97N.useContext($e385ec476690f3fc$export$971d5caa766a69d7);
};
var $e385ec476690f3fc$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $eR4tV.default)({}, outerTheme, theme);
};
var $e385ec476690f3fc$var$createCacheWithTheme = /* #__PURE__ */ (0, $g8a6V.default)(function(outerTheme) {
    return (0, $g8a6V.default)(function(theme) {
        return $e385ec476690f3fc$var$getTheme(outerTheme, theme);
    });
});
var $e385ec476690f3fc$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $lx97N.useContext($e385ec476690f3fc$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e385ec476690f3fc$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $lx97N.createElement($e385ec476690f3fc$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e385ec476690f3fc$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $lx97N.useContext($e385ec476690f3fc$export$971d5caa766a69d7);
        return /*#__PURE__*/ $lx97N.createElement(Component, (0, $eR4tV.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $lx97N.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $4xF3v.default)(WithTheme, Component);
}
var $e385ec476690f3fc$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $e385ec476690f3fc$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $e385ec476690f3fc$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $e385ec476690f3fc$var$getLastPart(match[1]);
    return undefined;
};
var $e385ec476690f3fc$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $e385ec476690f3fc$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $e385ec476690f3fc$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $e385ec476690f3fc$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($e385ec476690f3fc$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $e385ec476690f3fc$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $e385ec476690f3fc$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $e385ec476690f3fc$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $e385ec476690f3fc$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($e385ec476690f3fc$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$e385ec476690f3fc$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $e385ec476690f3fc$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3oBZb.registerStyles)(cache, serialized, isStringTag);
    (0, $fZcY5.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3oBZb.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $e385ec476690f3fc$var$Emotion = /* #__PURE__ */ $e385ec476690f3fc$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e385ec476690f3fc$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $3oBZb.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $eC8G3.serializeStyles)(registeredStyles, undefined, $lx97N.useContext($e385ec476690f3fc$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e385ec476690f3fc$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $e385ec476690f3fc$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $lx97N.createElement($lx97N.Fragment, null, /*#__PURE__*/ $lx97N.createElement($e385ec476690f3fc$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $lx97N.createElement(WrappedComponent, newProps));
});
var $e385ec476690f3fc$export$a9c23c6ac3fc3eca = $e385ec476690f3fc$var$Emotion;

});
parcelRegister("jZyl4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8de59cef78c71aa$export$2e2bcd8739ae039);

var $bIyd5 = parcelRequire("bIyd5");

var $cEoWI = parcelRequire("cEoWI");

var $83kLZ = parcelRequire("83kLZ");

var $jeNL3 = parcelRequire("jeNL3");
var $e8de59cef78c71aa$var$isBrowser = typeof document !== 'undefined';
var $e8de59cef78c71aa$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cEoWI.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cEoWI.token)(character)) break;
        (0, $cEoWI.next)();
    }
    return (0, $cEoWI.slice)(begin, (0, $cEoWI.position));
};
var $e8de59cef78c71aa$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cEoWI.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cEoWI.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $e8de59cef78c71aa$var$identifierWithPointTracking((0, $cEoWI.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cEoWI.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cEoWI.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cEoWI.from)(character);
    }
    while (character = (0, $cEoWI.next)());
    return parsed;
};
var $e8de59cef78c71aa$var$getRules = function getRules(value, points) {
    return (0, $cEoWI.dealloc)($e8de59cef78c71aa$var$toRules((0, $cEoWI.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $e8de59cef78c71aa$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $e8de59cef78c71aa$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$e8de59cef78c71aa$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $e8de59cef78c71aa$var$fixedElements.set(element, true);
    var points = [];
    var rules = $e8de59cef78c71aa$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $e8de59cef78c71aa$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $e8de59cef78c71aa$var$prefix(value, length) {
    switch((0, $cEoWI.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cEoWI.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cEoWI.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MOZ) + value + (0, $cEoWI.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + value + value;
        // order
        case 6165:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.replace)(value, /(\w+).+(:[^]+)/, (0, $cEoWI.WEBKIT) + 'box-$1$2' + (0, $cEoWI.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + 'flex-item-' + (0, $cEoWI.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + 'flex-line-pack' + (0, $cEoWI.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $cEoWI.WEBKIT) + 'box-' + (0, $cEoWI.replace)(value, '-grow', '') + (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $cEoWI.WEBKIT) + (0, $cEoWI.replace)(value, /([^-])(transform)/g, '$1' + (0, $cEoWI.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $cEoWI.replace)((0, $cEoWI.replace)((0, $cEoWI.replace)(value, /(zoom-|grab)/, (0, $cEoWI.WEBKIT) + '$1'), /(image-set)/, (0, $cEoWI.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cEoWI.replace)(value, /(image-set\([^]*)/, (0, $cEoWI.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $cEoWI.replace)((0, $cEoWI.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cEoWI.WEBKIT) + 'box-pack:$3' + (0, $cEoWI.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $cEoWI.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cEoWI.replace)(value, /(.+)-inline(.+)/, (0, $cEoWI.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cEoWI.strlen)(value) - 1 - length > 6) switch((0, $cEoWI.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cEoWI.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cEoWI.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $cEoWI.WEBKIT) + '$2-$3' + '$1' + (0, $cEoWI.MOZ) + ((0, $cEoWI.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cEoWI.indexof)(value, 'stretch') ? $e8de59cef78c71aa$var$prefix((0, $cEoWI.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cEoWI.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cEoWI.charat)(value, (0, $cEoWI.strlen)(value) - 3 - (~(0, $cEoWI.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $cEoWI.replace)(value, ':', ':' + (0, $cEoWI.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cEoWI.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $cEoWI.WEBKIT) + ((0, $cEoWI.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $cEoWI.WEBKIT) + '$2$3' + '$1' + (0, $cEoWI.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cEoWI.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + (0, $cEoWI.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $cEoWI.WEBKIT) + value + (0, $cEoWI.MS) + value + value;
    }
    return value;
}
var $e8de59cef78c71aa$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cEoWI.DECLARATION:
                element["return"] = $e8de59cef78c71aa$var$prefix(element.value, element.length);
                break;
            case 0, $cEoWI.KEYFRAMES:
                return (0, $cEoWI.serialize)([
                    (0, $cEoWI.copy)(element, {
                        value: (0, $cEoWI.replace)(element.value, '@', '@' + (0, $cEoWI.WEBKIT))
                    })
                ], callback);
            case 0, $cEoWI.RULESET:
                if (element.length) return (0, $cEoWI.combine)(element.props, function(value) {
                    switch((0, $cEoWI.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $cEoWI.serialize)([
                                (0, $cEoWI.copy)(element, {
                                    props: [
                                        (0, $cEoWI.replace)(value, /:(read-\w+)/, ':' + (0, $cEoWI.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $cEoWI.serialize)([
                                (0, $cEoWI.copy)(element, {
                                    props: [
                                        (0, $cEoWI.replace)(value, /:(plac\w+)/, ':' + (0, $cEoWI.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $cEoWI.copy)(element, {
                                    props: [
                                        (0, $cEoWI.replace)(value, /:(plac\w+)/, ':' + (0, $cEoWI.MOZ) + '$1')
                                    ]
                                }),
                                (0, $cEoWI.copy)(element, {
                                    props: [
                                        (0, $cEoWI.replace)(value, /:(plac\w+)/, (0, $cEoWI.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $e8de59cef78c71aa$var$getServerStylisCache = $e8de59cef78c71aa$var$isBrowser ? undefined : (0, $83kLZ.default)(function() {
    return (0, $jeNL3.default)(function() {
        return {};
    });
});
var $e8de59cef78c71aa$var$defaultStylisPlugins = [
    $e8de59cef78c71aa$var$prefixer
];
var $e8de59cef78c71aa$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($e8de59cef78c71aa$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $e8de59cef78c71aa$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($e8de59cef78c71aa$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $e8de59cef78c71aa$var$compat,
        $e8de59cef78c71aa$var$removeLabel
    ];
    if (!$e8de59cef78c71aa$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $cEoWI.stringify),
            (0, $cEoWI.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $cEoWI.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $cEoWI.serialize)((0, $cEoWI.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $cEoWI.stringify)
        ];
        var _serializer = (0, $cEoWI.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $cEoWI.serialize)((0, $cEoWI.compile)(styles), _serializer);
        };
        var serverStylisCache = $e8de59cef78c71aa$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $bIyd5.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bIyd5", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $887e572a59b27363$export$9d753cd7ae895cce);
var $887e572a59b27363$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $887e572a59b27363$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $887e572a59b27363$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $887e572a59b27363$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$887e572a59b27363$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($887e572a59b27363$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $887e572a59b27363$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cEoWI", function(module, exports) {

$parcel$export(module.exports, "MS", () => $be3710ecc2092733$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $be3710ecc2092733$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $be3710ecc2092733$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $be3710ecc2092733$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $be3710ecc2092733$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $be3710ecc2092733$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $be3710ecc2092733$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $be3710ecc2092733$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $be3710ecc2092733$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $be3710ecc2092733$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $be3710ecc2092733$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $be3710ecc2092733$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $be3710ecc2092733$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $be3710ecc2092733$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $be3710ecc2092733$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $be3710ecc2092733$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $be3710ecc2092733$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $be3710ecc2092733$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $be3710ecc2092733$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $be3710ecc2092733$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $be3710ecc2092733$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $be3710ecc2092733$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $be3710ecc2092733$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $be3710ecc2092733$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $be3710ecc2092733$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $be3710ecc2092733$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $be3710ecc2092733$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $be3710ecc2092733$export$38bcb760f1d4871c);
var $be3710ecc2092733$export$71ad59f2e432cfe8 = "-ms-";
var $be3710ecc2092733$export$2c0f367103c8d01c = "-moz-";
var $be3710ecc2092733$export$39dfd62a25e0fe93 = "-webkit-";
var $be3710ecc2092733$export$a29989082612d0d9 = "comm";
var $be3710ecc2092733$export$aa3a2e812ca8570d = "rule";
var $be3710ecc2092733$export$527d108ccf083c2b = "decl";
var $be3710ecc2092733$export$d3d35020fa5b54f0 = "@page";
var $be3710ecc2092733$export$500415a86c544f73 = "@media";
var $be3710ecc2092733$export$a763edbf796b780a = "@import";
var $be3710ecc2092733$export$2790aeb8b4e5c826 = "@charset";
var $be3710ecc2092733$export$1cc683e23b84b133 = "@viewport";
var $be3710ecc2092733$export$9447a5efea57e862 = "@supports";
var $be3710ecc2092733$export$ef011b4e114b1fba = "@document";
var $be3710ecc2092733$export$6aad947bda0f3f46 = "@namespace";
var $be3710ecc2092733$export$b44a8529a35fcb60 = "@keyframes";
var $be3710ecc2092733$export$2c16de31893252e6 = "@font-face";
var $be3710ecc2092733$export$3d846dd52e150c6f = "@counter-style";
var $be3710ecc2092733$export$22314bfbb57653fe = "@font-feature-values";
var $be3710ecc2092733$export$d773506282b3cfe6 = "@layer";
var $be3710ecc2092733$export$2335f513bbd82c6d = Math.abs;
var $be3710ecc2092733$export$6788812c4e6611e6 = String.fromCharCode;
var $be3710ecc2092733$export$e6e34fd1f2686227 = Object.assign;
function $be3710ecc2092733$export$d6af199866bfb566(e, r) {
    return $be3710ecc2092733$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 0)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 1)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 2)) << 2 ^ $be3710ecc2092733$export$a9db5e087081082d(e, 3) : 0;
}
function $be3710ecc2092733$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $be3710ecc2092733$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $be3710ecc2092733$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $be3710ecc2092733$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $be3710ecc2092733$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $be3710ecc2092733$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $be3710ecc2092733$export$36776f635604f274(e) {
    return e.length;
}
function $be3710ecc2092733$export$f9084667e487ed46(e) {
    return e.length;
}
function $be3710ecc2092733$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $be3710ecc2092733$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $be3710ecc2092733$export$53f1d5ea8de3d7c = 1;
var $be3710ecc2092733$export$4e0c71f277ca26b3 = 1;
var $be3710ecc2092733$export$f24224f1c91d8156 = 0;
var $be3710ecc2092733$export$5880b8b5730aff45 = 0;
var $be3710ecc2092733$export$c0306caf338ac095 = 0;
var $be3710ecc2092733$export$30a86d91af8ff6e6 = "";
function $be3710ecc2092733$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $be3710ecc2092733$export$53f1d5ea8de3d7c,
        column: $be3710ecc2092733$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $be3710ecc2092733$export$784d13d8ee351f07(e, r) {
    return $be3710ecc2092733$export$e6e34fd1f2686227($be3710ecc2092733$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $be3710ecc2092733$export$eba6f6f03b0a92e7() {
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$232faf9add678146() {
    $be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$5880b8b5730aff45 > 0 ? $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, --$be3710ecc2092733$export$5880b8b5730aff45) : 0;
    if ($be3710ecc2092733$export$4e0c71f277ca26b3--, $be3710ecc2092733$export$c0306caf338ac095 === 10) $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$53f1d5ea8de3d7c--;
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$48cfd1e771a65c4f() {
    $be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$5880b8b5730aff45 < $be3710ecc2092733$export$f24224f1c91d8156 ? $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, $be3710ecc2092733$export$5880b8b5730aff45++) : 0;
    if ($be3710ecc2092733$export$4e0c71f277ca26b3++, $be3710ecc2092733$export$c0306caf338ac095 === 10) $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$53f1d5ea8de3d7c++;
    return $be3710ecc2092733$export$c0306caf338ac095;
}
function $be3710ecc2092733$export$4d3fb11e950abb9e() {
    return $be3710ecc2092733$export$a9db5e087081082d($be3710ecc2092733$export$30a86d91af8ff6e6, $be3710ecc2092733$export$5880b8b5730aff45);
}
function $be3710ecc2092733$export$e88cb2efb12ae807() {
    return $be3710ecc2092733$export$5880b8b5730aff45;
}
function $be3710ecc2092733$export$58adb3bec8346d0f(e, r) {
    return $be3710ecc2092733$export$2f35ab04d2335697($be3710ecc2092733$export$30a86d91af8ff6e6, e, r);
}
function $be3710ecc2092733$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $be3710ecc2092733$export$2de70f21292aac9e(e) {
    return $be3710ecc2092733$export$53f1d5ea8de3d7c = $be3710ecc2092733$export$4e0c71f277ca26b3 = 1, $be3710ecc2092733$export$f24224f1c91d8156 = $be3710ecc2092733$export$36776f635604f274($be3710ecc2092733$export$30a86d91af8ff6e6 = e), $be3710ecc2092733$export$5880b8b5730aff45 = 0, [];
}
function $be3710ecc2092733$export$45918ac1574455b1(e) {
    return $be3710ecc2092733$export$30a86d91af8ff6e6 = "", e;
}
function $be3710ecc2092733$export$410ac95b9ec204b8(e) {
    return $be3710ecc2092733$export$87c2784dc9fc4ab($be3710ecc2092733$export$58adb3bec8346d0f($be3710ecc2092733$export$5880b8b5730aff45 - 1, $be3710ecc2092733$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $be3710ecc2092733$export$660b2ee2d4fb4eff(e) {
    return $be3710ecc2092733$export$45918ac1574455b1($be3710ecc2092733$export$5f8c09e3ae6f64e1($be3710ecc2092733$export$2de70f21292aac9e(e)));
}
function $be3710ecc2092733$export$7af1228ff777d175(e) {
    while($be3710ecc2092733$export$c0306caf338ac095 = $be3710ecc2092733$export$4d3fb11e950abb9e())if ($be3710ecc2092733$export$c0306caf338ac095 < 33) $be3710ecc2092733$export$48cfd1e771a65c4f();
    else break;
    return $be3710ecc2092733$export$9e1725a4cfeada27(e) > 2 || $be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $be3710ecc2092733$export$5f8c09e3ae6f64e1(e) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())switch($be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$c0306caf338ac095)){
        case 0:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$c2ab62c7bf24634($be3710ecc2092733$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$410ac95b9ec204b8($be3710ecc2092733$export$c0306caf338ac095), e);
            break;
        default:
            $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$6788812c4e6611e6($be3710ecc2092733$export$c0306caf338ac095), e);
    }
    return e;
}
function $be3710ecc2092733$export$955ba06d119e085e(e, r) {
    while(--r && $be3710ecc2092733$export$48cfd1e771a65c4f())if ($be3710ecc2092733$export$c0306caf338ac095 < 48 || $be3710ecc2092733$export$c0306caf338ac095 > 102 || $be3710ecc2092733$export$c0306caf338ac095 > 57 && $be3710ecc2092733$export$c0306caf338ac095 < 65 || $be3710ecc2092733$export$c0306caf338ac095 > 70 && $be3710ecc2092733$export$c0306caf338ac095 < 97) break;
    return $be3710ecc2092733$export$58adb3bec8346d0f(e, $be3710ecc2092733$export$e88cb2efb12ae807() + (r < 6 && $be3710ecc2092733$export$4d3fb11e950abb9e() == 32 && $be3710ecc2092733$export$48cfd1e771a65c4f() == 32));
}
function $be3710ecc2092733$export$c889f2fcc19dbf12(e) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())switch($be3710ecc2092733$export$c0306caf338ac095){
        case e:
            return $be3710ecc2092733$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $be3710ecc2092733$export$c889f2fcc19dbf12($be3710ecc2092733$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $be3710ecc2092733$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $be3710ecc2092733$export$48cfd1e771a65c4f();
            break;
    }
    return $be3710ecc2092733$export$5880b8b5730aff45;
}
function $be3710ecc2092733$export$4254d4e2b3745c4c(e, r) {
    while($be3710ecc2092733$export$48cfd1e771a65c4f())if (e + $be3710ecc2092733$export$c0306caf338ac095 === 57) break;
    else if (e + $be3710ecc2092733$export$c0306caf338ac095 === 84 && $be3710ecc2092733$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $be3710ecc2092733$export$58adb3bec8346d0f(r, $be3710ecc2092733$export$5880b8b5730aff45 - 1) + "*" + $be3710ecc2092733$export$6788812c4e6611e6(e === 47 ? e : $be3710ecc2092733$export$48cfd1e771a65c4f());
}
function $be3710ecc2092733$export$c2ab62c7bf24634(e) {
    while(!$be3710ecc2092733$export$9e1725a4cfeada27($be3710ecc2092733$export$4d3fb11e950abb9e()))$be3710ecc2092733$export$48cfd1e771a65c4f();
    return $be3710ecc2092733$export$58adb3bec8346d0f(e, $be3710ecc2092733$export$5880b8b5730aff45);
}
function $be3710ecc2092733$export$ef7acd7185315e22(e) {
    return $be3710ecc2092733$export$45918ac1574455b1($be3710ecc2092733$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $be3710ecc2092733$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $be3710ecc2092733$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $be3710ecc2092733$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $be3710ecc2092733$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($be3710ecc2092733$export$f8e21b1e77979a08(j += $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $be3710ecc2092733$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $be3710ecc2092733$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $be3710ecc2092733$export$955ba06d119e085e($be3710ecc2092733$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($be3710ecc2092733$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$4a34f930e789283c($be3710ecc2092733$export$4254d4e2b3745c4c($be3710ecc2092733$export$48cfd1e771a65c4f(), $be3710ecc2092733$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $be3710ecc2092733$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $be3710ecc2092733$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $be3710ecc2092733$export$36776f635604f274(j) - l) $be3710ecc2092733$export$10d8903dec122b9d(p > 32 ? $be3710ecc2092733$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $be3710ecc2092733$export$f8483753829ec8f3($be3710ecc2092733$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $be3710ecc2092733$export$10d8903dec122b9d(y = $be3710ecc2092733$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $be3710ecc2092733$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $be3710ecc2092733$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $be3710ecc2092733$export$98e6a39c04603d36(e, y, y, n && $be3710ecc2092733$export$10d8903dec122b9d($be3710ecc2092733$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $be3710ecc2092733$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $be3710ecc2092733$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $be3710ecc2092733$export$232faf9add678146() == 125) continue;
            }
            switch(j += $be3710ecc2092733$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($be3710ecc2092733$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($be3710ecc2092733$export$4d3fb11e950abb9e() === 45) j += $be3710ecc2092733$export$410ac95b9ec204b8($be3710ecc2092733$export$48cfd1e771a65c4f());
                    v = $be3710ecc2092733$export$4d3fb11e950abb9e(), o = l = $be3710ecc2092733$export$36776f635604f274(g = j += $be3710ecc2092733$export$c2ab62c7bf24634($be3710ecc2092733$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $be3710ecc2092733$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $be3710ecc2092733$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $be3710ecc2092733$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $be3710ecc2092733$export$2f35ab04d2335697(e, v + 1, v = $be3710ecc2092733$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $be3710ecc2092733$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $be3710ecc2092733$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, s === 0 ? $be3710ecc2092733$export$aa3a2e812ca8570d : i, f, o, l);
}
function $be3710ecc2092733$export$4a34f930e789283c(e, r, a) {
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, $be3710ecc2092733$export$a29989082612d0d9, $be3710ecc2092733$export$6788812c4e6611e6($be3710ecc2092733$export$eba6f6f03b0a92e7()), $be3710ecc2092733$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $be3710ecc2092733$export$f8483753829ec8f3(e, r, a, n) {
    return $be3710ecc2092733$export$35059013cd4a06db(e, r, a, $be3710ecc2092733$export$527d108ccf083c2b, $be3710ecc2092733$export$2f35ab04d2335697(e, 0, n), $be3710ecc2092733$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $be3710ecc2092733$export$82e9f45cca5ba907(n, c, s) {
    switch($be3710ecc2092733$export$d6af199866bfb566(n, c)){
        case 5103:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $be3710ecc2092733$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$2c0f367103c8d01c + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($be3710ecc2092733$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-$1$2" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-item-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$be3710ecc2092733$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-row-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-line-pack" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-" + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-grow", "") + $be3710ecc2092733$export$39dfd62a25e0fe93 + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $be3710ecc2092733$export$39dfd62a25e0fe93 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "box-pack:$3" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $be3710ecc2092733$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$be3710ecc2092733$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-column-align" + $be3710ecc2092733$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $be3710ecc2092733$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$be3710ecc2092733$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $be3710ecc2092733$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$be3710ecc2092733$export$f8e21b1e77979a08(s, "span") ? $be3710ecc2092733$export$4659b591c19bdf3d(s, /\d+/) : +$be3710ecc2092733$export$4659b591c19bdf3d(s, /\d+/) - +$be3710ecc2092733$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $be3710ecc2092733$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $be3710ecc2092733$export$71ad59f2e432cfe8 + $be3710ecc2092733$export$77ad94ebf1c2b9ed($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $be3710ecc2092733$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($be3710ecc2092733$export$36776f635604f274(n) - 1 - c > 6) switch($be3710ecc2092733$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($be3710ecc2092733$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $be3710ecc2092733$export$2c0f367103c8d01c + ($be3710ecc2092733$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$be3710ecc2092733$export$f8e21b1e77979a08(n, "stretch") ? $be3710ecc2092733$export$82e9f45cca5ba907($be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $be3710ecc2092733$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $be3710ecc2092733$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($be3710ecc2092733$export$a9db5e087081082d(n, c + 6) === 121) return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, ":", ":" + $be3710ecc2092733$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($be3710ecc2092733$export$a9db5e087081082d(n, $be3710ecc2092733$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + ($be3710ecc2092733$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $be3710ecc2092733$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, ":", ":" + $be3710ecc2092733$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $be3710ecc2092733$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $be3710ecc2092733$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $be3710ecc2092733$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $be3710ecc2092733$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $be3710ecc2092733$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $be3710ecc2092733$export$a763edbf796b780a:
        case $be3710ecc2092733$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $be3710ecc2092733$export$a29989082612d0d9:
            return "";
        case $be3710ecc2092733$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $be3710ecc2092733$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $be3710ecc2092733$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $be3710ecc2092733$export$36776f635604f274(a = $be3710ecc2092733$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $be3710ecc2092733$export$5a7767152ae0305f(e) {
    var r = $be3710ecc2092733$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $be3710ecc2092733$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $be3710ecc2092733$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $be3710ecc2092733$export$527d108ccf083c2b:
                n.return = $be3710ecc2092733$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $be3710ecc2092733$export$b44a8529a35fcb60:
                return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                    $be3710ecc2092733$export$784d13d8ee351f07(n, {
                        value: $be3710ecc2092733$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $be3710ecc2092733$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $be3710ecc2092733$export$aa3a2e812ca8570d:
                if (n.length) return $be3710ecc2092733$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($be3710ecc2092733$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $be3710ecc2092733$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $be3710ecc2092733$export$dfdc1655ccc5b9cb([
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $be3710ecc2092733$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $be3710ecc2092733$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $be3710ecc2092733$export$784d13d8ee351f07(n, {
                                    props: [
                                        $be3710ecc2092733$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $be3710ecc2092733$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $be3710ecc2092733$export$76a88f7de6507443(e) {
    switch(e.type){
        case $be3710ecc2092733$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $be3710ecc2092733$export$1be1fc439b849fdf($be3710ecc2092733$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($be3710ecc2092733$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $be3710ecc2092733$export$2f35ab04d2335697(r, 1, $be3710ecc2092733$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $be3710ecc2092733$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $be3710ecc2092733$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $be3710ecc2092733$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("83kLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dceb7a01231679c$export$2e2bcd8739ae039);
var $5dceb7a01231679c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("jeNL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e015ec02b8c36601$export$2e2bcd8739ae039);
function $e015ec02b8c36601$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("g8a6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe53c7de2609795$export$2e2bcd8739ae039);
var $bbe53c7de2609795$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4xF3v", function(module, exports) {

$parcel$export(module.exports, "default", () => $34ea173fbb6d6a45$export$2e2bcd8739ae039);

var $4Djfw = parcelRequire("4Djfw");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $34ea173fbb6d6a45$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Djfw)))(targetComponent, sourceComponent);
};

});
parcelRegister("4Djfw", function(module, exports) {
'use strict';

var $9rjTY = parcelRequire("9rjTY");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $35f9bc7c0d546ba3$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $35f9bc7c0d546ba3$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$TYPE_STATICS = {};
$35f9bc7c0d546ba3$var$TYPE_STATICS[$9rjTY.ForwardRef] = $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS;
$35f9bc7c0d546ba3$var$TYPE_STATICS[$9rjTY.Memo] = $35f9bc7c0d546ba3$var$MEMO_STATICS;
function $35f9bc7c0d546ba3$var$getStatics(component) {
    // React v16.11 and below
    if ($9rjTY.isMemo(component)) return $35f9bc7c0d546ba3$var$MEMO_STATICS;
     // React v16.12 and above
    return $35f9bc7c0d546ba3$var$TYPE_STATICS[component['$$typeof']] || $35f9bc7c0d546ba3$var$REACT_STATICS;
}
var $35f9bc7c0d546ba3$var$defineProperty = Object.defineProperty;
var $35f9bc7c0d546ba3$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $35f9bc7c0d546ba3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $35f9bc7c0d546ba3$var$getPrototypeOf = Object.getPrototypeOf;
var $35f9bc7c0d546ba3$var$objectPrototype = Object.prototype;
function $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($35f9bc7c0d546ba3$var$objectPrototype) {
            var inheritedComponent = $35f9bc7c0d546ba3$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $35f9bc7c0d546ba3$var$objectPrototype) $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $35f9bc7c0d546ba3$var$getOwnPropertyNames(sourceComponent);
        if ($35f9bc7c0d546ba3$var$getOwnPropertySymbols) keys = keys.concat($35f9bc7c0d546ba3$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $35f9bc7c0d546ba3$var$getStatics(targetComponent);
        var sourceStatics = $35f9bc7c0d546ba3$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$35f9bc7c0d546ba3$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $35f9bc7c0d546ba3$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $35f9bc7c0d546ba3$var$hoistNonReactStatics;

});
parcelRegister("9rjTY", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dhnve"));

});



parcelRegister("3oBZb", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $27911428553baf2d$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $27911428553baf2d$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $27911428553baf2d$export$6f077d94b33a01aa);
var $27911428553baf2d$var$isBrowser = typeof document !== 'undefined';
function $27911428553baf2d$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $27911428553baf2d$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $27911428553baf2d$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $27911428553baf2d$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $27911428553baf2d$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$27911428553baf2d$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$27911428553baf2d$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("eC8G3", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $aa3b5868d1a715ff$export$6321afa313b251b5);

var $ayDaZ = parcelRequire("ayDaZ");

var $2TSYT = parcelRequire("2TSYT");

var $jeNL3 = parcelRequire("jeNL3");
var $aa3b5868d1a715ff$var$isDevelopment = false;
var $aa3b5868d1a715ff$var$hyphenateRegex = /[A-Z]|^ms/g;
var $aa3b5868d1a715ff$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $aa3b5868d1a715ff$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $aa3b5868d1a715ff$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $aa3b5868d1a715ff$var$processStyleName = /* #__PURE__ */ (0, $jeNL3.default)(function(styleName) {
    return $aa3b5868d1a715ff$var$isCustomProperty(styleName) ? styleName : styleName.replace($aa3b5868d1a715ff$var$hyphenateRegex, '-$&').toLowerCase();
});
var $aa3b5868d1a715ff$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($aa3b5868d1a715ff$var$animationRegex, function(match, p1, p2) {
                $aa3b5868d1a715ff$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $aa3b5868d1a715ff$var$cursor
                };
                return p1;
            });
    }
    if ((0, $2TSYT.default)[key] !== 1 && !$aa3b5868d1a715ff$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $aa3b5868d1a715ff$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $aa3b5868d1a715ff$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $aa3b5868d1a715ff$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $aa3b5868d1a715ff$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $aa3b5868d1a715ff$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $aa3b5868d1a715ff$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $aa3b5868d1a715ff$var$cursor;
                var result = interpolation(mergedProps);
                $aa3b5868d1a715ff$var$cursor = previousCursor;
                return $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $aa3b5868d1a715ff$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($aa3b5868d1a715ff$var$isProcessableValue(asString)) string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + $aa3b5868d1a715ff$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $aa3b5868d1a715ff$var$isDevelopment) throw new Error($aa3b5868d1a715ff$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($aa3b5868d1a715ff$var$isProcessableValue(value[_i])) string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + $aa3b5868d1a715ff$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $aa3b5868d1a715ff$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $aa3b5868d1a715ff$var$cursor;
function $aa3b5868d1a715ff$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $aa3b5868d1a715ff$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $aa3b5868d1a715ff$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $aa3b5868d1a715ff$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $ayDaZ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $aa3b5868d1a715ff$var$cursor
    };
}

});
parcelRegister("ayDaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afb77f31dbef2ab$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7afb77f31dbef2ab$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("2TSYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cb5de91d0b0040$export$2e2bcd8739ae039);
var $21cb5de91d0b0040$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("fZcY5", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $ba369cbd9088197f$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $ba369cbd9088197f$export$811a713a7276cb9d);

var $lx97N = parcelRequire("lx97N");
var $ba369cbd9088197f$var$isBrowser = typeof document !== 'undefined';
var $ba369cbd9088197f$var$syncFallback = function syncFallback(create) {
    return create();
};
var $ba369cbd9088197f$var$useInsertionEffect = $lx97N.useInsertionEffect ? $lx97N.useInsertionEffect : false;
var $ba369cbd9088197f$export$db21c7ffa21794e7 = !$ba369cbd9088197f$var$isBrowser ? $ba369cbd9088197f$var$syncFallback : $ba369cbd9088197f$var$useInsertionEffect || $ba369cbd9088197f$var$syncFallback;
var $ba369cbd9088197f$export$811a713a7276cb9d = $ba369cbd9088197f$var$useInsertionEffect || $lx97N.useLayoutEffect;

});


parcelRegister("8Wv3B", function(module, exports) {
function $682bd4cd285df927$var$_extends() {
    return module.exports = $682bd4cd285df927$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $682bd4cd285df927$var$_extends.apply(null, arguments);
}
module.exports = $682bd4cd285df927$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("cbdKw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8de12d735d894a9c$export$2e2bcd8739ae039);

var $aBr5J = parcelRequire("aBr5J");
const $8de12d735d894a9c$var$defaultTheme = (0, $aBr5J.default)();
var $8de12d735d894a9c$export$2e2bcd8739ae039 = $8de12d735d894a9c$var$defaultTheme;

});
parcelRegister("aBr5J", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b825fe668279dd9$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $8zw8B = parcelRequire("8zw8B");
var $43Mr2 = parcelRequire("43Mr2");

var $jT8G1 = parcelRequire("jT8G1");
var $5sbKe = parcelRequire("5sbKe");
var $j1oop = parcelRequire("j1oop");


var $lkVUu = parcelRequire("lkVUu");

var $jZIMX = parcelRequire("jZIMX");

var $bjkKE = parcelRequire("bjkKE");

var $kfU43 = parcelRequire("kfU43");

var $kwSxW = parcelRequire("kwSxW");

var $aph8P = parcelRequire("aph8P");
const $7b825fe668279dd9$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $7b825fe668279dd9$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $hphT8.default)(options, $7b825fe668279dd9$var$_excluded);
    if (options.vars) throw new Error((0, $43Mr2.default)(18));
    const palette = (0, $jZIMX.default)(paletteInput);
    const systemTheme = (0, $jT8G1.default)(options);
    let muiTheme = (0, $8zw8B.default)(systemTheme, {
        mixins: (0, $lkVUu.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $kfU43.default).slice(),
        typography: (0, $bjkKE.default)(palette, typographyInput),
        transitions: (0, $kwSxW.default)(transitionsInput),
        zIndex: (0, $eR4tV.default)({}, (0, $aph8P.default))
    });
    muiTheme = (0, $8zw8B.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $8zw8B.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $eR4tV.default)({}, (0, $5sbKe.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $j1oop.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $7b825fe668279dd9$var$warnedOnce = false;
function $7b825fe668279dd9$export$c469355549431d9b(...args) {
    return $7b825fe668279dd9$var$createTheme(...args);
}
var $7b825fe668279dd9$export$2e2bcd8739ae039 = $7b825fe668279dd9$var$createTheme;

});
parcelRegister("lkVUu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f88862fe2d250124$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");
function $f88862fe2d250124$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $eR4tV.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("jZIMX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8e674eb24c6e69d$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $8zw8B = parcelRequire("8zw8B");
var $43Mr2 = parcelRequire("43Mr2");

var $fMSjE = parcelRequire("fMSjE");

var $c50PA = parcelRequire("c50PA");

var $3vTcs = parcelRequire("3vTcs");

var $7jfm2 = parcelRequire("7jfm2");

var $j3SEY = parcelRequire("j3SEY");

var $kizQb = parcelRequire("kizQb");

var $3xkOP = parcelRequire("3xkOP");

var $atOPa = parcelRequire("atOPa");

var $eR3uo = parcelRequire("eR3uo");
const $e8e674eb24c6e69d$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $e8e674eb24c6e69d$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $c50PA.default).white,
        default: (0, $c50PA.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $e8e674eb24c6e69d$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $c50PA.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $c50PA.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $e8e674eb24c6e69d$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $fMSjE.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $fMSjE.darken)(intent.main, tonalOffsetDark);
    }
}
function $e8e674eb24c6e69d$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3xkOP.default)[200],
        light: (0, $3xkOP.default)[50],
        dark: (0, $3xkOP.default)[400]
    };
    return {
        main: (0, $3xkOP.default)[700],
        light: (0, $3xkOP.default)[400],
        dark: (0, $3xkOP.default)[800]
    };
}
function $e8e674eb24c6e69d$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $7jfm2.default)[200],
        light: (0, $7jfm2.default)[50],
        dark: (0, $7jfm2.default)[400]
    };
    return {
        main: (0, $7jfm2.default)[500],
        light: (0, $7jfm2.default)[300],
        dark: (0, $7jfm2.default)[700]
    };
}
function $e8e674eb24c6e69d$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $j3SEY.default)[500],
        light: (0, $j3SEY.default)[300],
        dark: (0, $j3SEY.default)[700]
    };
    return {
        main: (0, $j3SEY.default)[700],
        light: (0, $j3SEY.default)[400],
        dark: (0, $j3SEY.default)[800]
    };
}
function $e8e674eb24c6e69d$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $atOPa.default)[400],
        light: (0, $atOPa.default)[300],
        dark: (0, $atOPa.default)[700]
    };
    return {
        main: (0, $atOPa.default)[700],
        light: (0, $atOPa.default)[500],
        dark: (0, $atOPa.default)[900]
    };
}
function $e8e674eb24c6e69d$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $eR3uo.default)[400],
        light: (0, $eR3uo.default)[300],
        dark: (0, $eR3uo.default)[700]
    };
    return {
        main: (0, $eR3uo.default)[800],
        light: (0, $eR3uo.default)[500],
        dark: (0, $eR3uo.default)[900]
    };
}
function $e8e674eb24c6e69d$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kizQb.default)[400],
        light: (0, $kizQb.default)[300],
        dark: (0, $kizQb.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $kizQb.default)[500],
        dark: (0, $kizQb.default)[900]
    };
}
function $e8e674eb24c6e69d$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $hphT8.default)(palette, $e8e674eb24c6e69d$var$_excluded);
    const primary = palette.primary || $e8e674eb24c6e69d$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $e8e674eb24c6e69d$var$getDefaultSecondary(mode);
    const error = palette.error || $e8e674eb24c6e69d$var$getDefaultError(mode);
    const info = palette.info || $e8e674eb24c6e69d$var$getDefaultInfo(mode);
    const success = palette.success || $e8e674eb24c6e69d$var$getDefaultSuccess(mode);
    const warning = palette.warning || $e8e674eb24c6e69d$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $fMSjE.getContrastRatio)(background, $e8e674eb24c6e69d$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $e8e674eb24c6e69d$export$55ce6f3a06c59543.text.primary : $e8e674eb24c6e69d$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $eR4tV.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $43Mr2.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $43Mr2.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $e8e674eb24c6e69d$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $e8e674eb24c6e69d$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $e8e674eb24c6e69d$export$55ce6f3a06c59543,
        light: $e8e674eb24c6e69d$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $8zw8B.default)((0, $eR4tV.default)({
        // A collection of common colors.
        common: (0, $eR4tV.default)({}, (0, $c50PA.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $3vTcs.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("fMSjE", function(module, exports) {

$parcel$export(module.exports, "getContrastRatio", () => $b7e578b8d852235c$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $b7e578b8d852235c$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "darken", () => $b7e578b8d852235c$export$4b073707ff63303);
$parcel$export(module.exports, "lighten", () => $b7e578b8d852235c$export$c0816ed86df316af);

var $43Mr2 = parcelRequire("43Mr2");

var $gVnZn = parcelRequire("gVnZn");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $b7e578b8d852235c$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $gVnZn.default)(value, min, max);
}
function $b7e578b8d852235c$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $b7e578b8d852235c$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $b7e578b8d852235c$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $b7e578b8d852235c$export$677b39864803984e($b7e578b8d852235c$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $43Mr2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $43Mr2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $b7e578b8d852235c$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $b7e578b8d852235c$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
const $b7e578b8d852235c$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $b7e578b8d852235c$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $b7e578b8d852235c$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $b7e578b8d852235c$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $b7e578b8d852235c$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$b7e578b8d852235c$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $b7e578b8d852235c$export$29fb7152bd3f781a(color) {
    color = $b7e578b8d852235c$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $b7e578b8d852235c$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $b7e578b8d852235c$export$c852d90bf7403b62(color) {
    color = $b7e578b8d852235c$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $b7e578b8d852235c$export$677b39864803984e($b7e578b8d852235c$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $b7e578b8d852235c$export$d061e26956a60b0a(foreground, background) {
    const lumA = $b7e578b8d852235c$export$c852d90bf7403b62(foreground);
    const lumB = $b7e578b8d852235c$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $b7e578b8d852235c$export$58f0f39f63f3cf42(color, value) {
    color = $b7e578b8d852235c$export$677b39864803984e(color);
    value = $b7e578b8d852235c$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $b7e578b8d852235c$export$211a73f2b8c10ce4(color);
}
function $b7e578b8d852235c$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $b7e578b8d852235c$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $b7e578b8d852235c$export$4b073707ff63303(color, coefficient) {
    color = $b7e578b8d852235c$export$677b39864803984e(color);
    coefficient = $b7e578b8d852235c$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $b7e578b8d852235c$export$211a73f2b8c10ce4(color);
}
function $b7e578b8d852235c$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $b7e578b8d852235c$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $b7e578b8d852235c$export$c0816ed86df316af(color, coefficient) {
    color = $b7e578b8d852235c$export$677b39864803984e(color);
    coefficient = $b7e578b8d852235c$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $b7e578b8d852235c$export$211a73f2b8c10ce4(color);
}
function $b7e578b8d852235c$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $b7e578b8d852235c$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $b7e578b8d852235c$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $b7e578b8d852235c$export$c852d90bf7403b62(color) > 0.5 ? $b7e578b8d852235c$export$4b073707ff63303(color, coefficient) : $b7e578b8d852235c$export$c0816ed86df316af(color, coefficient);
}
function $b7e578b8d852235c$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $b7e578b8d852235c$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $b7e578b8d852235c$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $b7e578b8d852235c$export$677b39864803984e(background);
    const overlayColor = $b7e578b8d852235c$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $b7e578b8d852235c$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("gVnZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c52493eba34e3b1d$export$2e2bcd8739ae039);
function $c52493eba34e3b1d$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $c52493eba34e3b1d$export$2e2bcd8739ae039 = $c52493eba34e3b1d$var$clamp;

});


parcelRegister("c50PA", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb698b5c4a09775$export$2e2bcd8739ae039);
const $8cb698b5c4a09775$var$common = {
    black: '#000',
    white: '#fff'
};
var $8cb698b5c4a09775$export$2e2bcd8739ae039 = $8cb698b5c4a09775$var$common;

});

parcelRegister("3vTcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $28ef15e339e6abcb$export$2e2bcd8739ae039);
const $28ef15e339e6abcb$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $28ef15e339e6abcb$export$2e2bcd8739ae039 = $28ef15e339e6abcb$var$grey;

});

parcelRegister("7jfm2", function(module, exports) {

$parcel$export(module.exports, "default", () => $552637d7c8bb6c45$export$2e2bcd8739ae039);
const $552637d7c8bb6c45$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $552637d7c8bb6c45$export$2e2bcd8739ae039 = $552637d7c8bb6c45$var$purple;

});

parcelRegister("j3SEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $de08b26fc66e6f85$export$2e2bcd8739ae039);
const $de08b26fc66e6f85$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $de08b26fc66e6f85$export$2e2bcd8739ae039 = $de08b26fc66e6f85$var$red;

});

parcelRegister("kizQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec714a4747789417$export$2e2bcd8739ae039);
const $ec714a4747789417$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $ec714a4747789417$export$2e2bcd8739ae039 = $ec714a4747789417$var$orange;

});

parcelRegister("3xkOP", function(module, exports) {

$parcel$export(module.exports, "default", () => $29349a56d3b9c0b1$export$2e2bcd8739ae039);
const $29349a56d3b9c0b1$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $29349a56d3b9c0b1$export$2e2bcd8739ae039 = $29349a56d3b9c0b1$var$blue;

});

parcelRegister("atOPa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a140972efb34e61$export$2e2bcd8739ae039);
const $7a140972efb34e61$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $7a140972efb34e61$export$2e2bcd8739ae039 = $7a140972efb34e61$var$lightBlue;

});

parcelRegister("eR3uo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad08b8d04e6305ec$export$2e2bcd8739ae039);
const $ad08b8d04e6305ec$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $ad08b8d04e6305ec$export$2e2bcd8739ae039 = $ad08b8d04e6305ec$var$green;

});


parcelRegister("bjkKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $83c190df4ea9b183$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $8zw8B = parcelRequire("8zw8B");
const $83c190df4ea9b183$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $83c190df4ea9b183$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $83c190df4ea9b183$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $83c190df4ea9b183$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $83c190df4ea9b183$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $83c190df4ea9b183$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $hphT8.default)(_ref, $83c190df4ea9b183$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $eR4tV.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $83c190df4ea9b183$var$defaultFontFamily ? {
            letterSpacing: `${$83c190df4ea9b183$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $83c190df4ea9b183$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $83c190df4ea9b183$var$caseAllCaps),
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $8zw8B.default)((0, $eR4tV.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("kfU43", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf0b297e06480a2$export$2e2bcd8739ae039);
const $ebf0b297e06480a2$var$shadowKeyUmbraOpacity = 0.2;
const $ebf0b297e06480a2$var$shadowKeyPenumbraOpacity = 0.14;
const $ebf0b297e06480a2$var$shadowAmbientShadowOpacity = 0.12;
function $ebf0b297e06480a2$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$ebf0b297e06480a2$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$ebf0b297e06480a2$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$ebf0b297e06480a2$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $ebf0b297e06480a2$var$shadows = [
    'none',
    $ebf0b297e06480a2$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $ebf0b297e06480a2$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $ebf0b297e06480a2$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $ebf0b297e06480a2$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $ebf0b297e06480a2$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $ebf0b297e06480a2$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $ebf0b297e06480a2$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $ebf0b297e06480a2$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $ebf0b297e06480a2$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $ebf0b297e06480a2$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $ebf0b297e06480a2$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $ebf0b297e06480a2$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $ebf0b297e06480a2$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $ebf0b297e06480a2$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $ebf0b297e06480a2$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $ebf0b297e06480a2$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $ebf0b297e06480a2$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $ebf0b297e06480a2$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $ebf0b297e06480a2$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $ebf0b297e06480a2$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $ebf0b297e06480a2$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $ebf0b297e06480a2$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $ebf0b297e06480a2$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $ebf0b297e06480a2$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $ebf0b297e06480a2$export$2e2bcd8739ae039 = $ebf0b297e06480a2$var$shadows;

});

parcelRegister("kwSxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef211b91af647f3d$export$2e2bcd8739ae039);

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");
const $ef211b91af647f3d$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ef211b91af647f3d$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $ef211b91af647f3d$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ef211b91af647f3d$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ef211b91af647f3d$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ef211b91af647f3d$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $eR4tV.default)({}, $ef211b91af647f3d$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $eR4tV.default)({}, $ef211b91af647f3d$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $hphT8.default)(options, $ef211b91af647f3d$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $ef211b91af647f3d$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $ef211b91af647f3d$var$formatMs(delay)}`).join(',');
    };
    return (0, $eR4tV.default)({
        getAutoHeightDuration: $ef211b91af647f3d$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("aph8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $7939891c604221f1$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $7939891c604221f1$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $7939891c604221f1$export$2e2bcd8739ae039 = $7939891c604221f1$var$zIndex;

});



parcelRegister("Rnxzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0735ff22641a44$export$2e2bcd8739ae039);
var $0a0735ff22641a44$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("7Ys8f", function(module, exports) {

$parcel$export(module.exports, "rootShouldForwardProp", () => $5ce3f574aaba0fde$export$effb20ecdbf4d6aa);
$parcel$export(module.exports, "slotShouldForwardProp", () => $5ce3f574aaba0fde$export$f10c5a10d27438e5);
$parcel$export(module.exports, "default", () => $5ce3f574aaba0fde$export$2e2bcd8739ae039);

var $hLuFn = parcelRequire("hLuFn");

var $cbdKw = parcelRequire("cbdKw");

var $Rnxzq = parcelRequire("Rnxzq");
const $5ce3f574aaba0fde$export$effb20ecdbf4d6aa = (prop)=>(0, $hLuFn.shouldForwardProp)(prop) && prop !== 'classes';
const $5ce3f574aaba0fde$export$f10c5a10d27438e5 = (0, $hLuFn.shouldForwardProp);
const $5ce3f574aaba0fde$var$styled = (0, $hLuFn.default)({
    themeId: (0, $Rnxzq.default),
    defaultTheme: $cbdKw.default,
    rootShouldForwardProp: $5ce3f574aaba0fde$export$effb20ecdbf4d6aa
});
var $5ce3f574aaba0fde$export$2e2bcd8739ae039 = $5ce3f574aaba0fde$var$styled;

});
parcelRegister("hLuFn", function(module, exports) {

$parcel$export(module.exports, "shouldForwardProp", () => $ceee9d2376fca9a6$export$3ba67b570e26eea0);
$parcel$export(module.exports, "default", () => $ceee9d2376fca9a6$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $d8uBH = parcelRequire("d8uBH");

var $8zw8B = parcelRequire("8zw8B");



var $jT8G1 = parcelRequire("jT8G1");

var $j1oop = parcelRequire("j1oop");
const $ceee9d2376fca9a6$var$_excluded = [
    "ownerState"
], $ceee9d2376fca9a6$var$_excluded2 = [
    "variants"
], $ceee9d2376fca9a6$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $ceee9d2376fca9a6$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $ceee9d2376fca9a6$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $ceee9d2376fca9a6$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $ceee9d2376fca9a6$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $ceee9d2376fca9a6$export$35e57303dbd8a66 = (0, $jT8G1.default)();
const $ceee9d2376fca9a6$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $ceee9d2376fca9a6$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $ceee9d2376fca9a6$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $ceee9d2376fca9a6$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $ceee9d2376fca9a6$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $hphT8.default)(_ref, $ceee9d2376fca9a6$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $eR4tV.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$ceee9d2376fca9a6$var$processStyleArg(resolvedStyle, (0, $eR4tV.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $hphT8.default)(resolvedStylesArg, $ceee9d2376fca9a6$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $eR4tV.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $eR4tV.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $ceee9d2376fca9a6$var$shallowLayer((0, $d8uBH.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $ceee9d2376fca9a6$var$shallowLayer((0, $d8uBH.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $ceee9d2376fca9a6$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $ceee9d2376fca9a6$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $ceee9d2376fca9a6$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $ceee9d2376fca9a6$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $j1oop.default)((0, $eR4tV.default)({}, props, {
            theme: $ceee9d2376fca9a6$var$resolveTheme((0, $eR4tV.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $d8uBH.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $ceee9d2376fca9a6$var$defaultOverridesResolver($ceee9d2376fca9a6$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $hphT8.default)(inputOptions, $ceee9d2376fca9a6$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $ceee9d2376fca9a6$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($ceee9d2376fca9a6$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $d8uBH.default)(tag, (0, $eR4tV.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $8zw8B.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $ceee9d2376fca9a6$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $ceee9d2376fca9a6$var$processStyleArg(stylesArg, (0, $eR4tV.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $ceee9d2376fca9a6$var$resolveTheme((0, $eR4tV.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $ceee9d2376fca9a6$var$processStyleArg(slotStyle, (0, $eR4tV.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $ceee9d2376fca9a6$var$resolveTheme((0, $eR4tV.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $ceee9d2376fca9a6$var$processStyleArg({
                    variants: themeVariants
                }, (0, $eR4tV.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("d8uBH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9903c3a67b1b059d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_processStyles", () => $9903c3a67b1b059d$export$e00380445f2b9e0c);
$parcel$export(module.exports, "internal_serializeStyles", () => $9903c3a67b1b059d$export$13a2d3ef13012b32);
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $haET7 = parcelRequire("haET7");

var $eC8G3 = parcelRequire("eC8G3");

var $9Hxe6 = parcelRequire("9Hxe6");
var $jx6dC = parcelRequire("jx6dC");


var $hHT9b = parcelRequire("hHT9b");
'use client';
function $9903c3a67b1b059d$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $haET7.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $9903c3a67b1b059d$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $9903c3a67b1b059d$var$wrapper = [];
function $9903c3a67b1b059d$export$13a2d3ef13012b32(styles) {
    $9903c3a67b1b059d$var$wrapper[0] = styles;
    return (0, $eC8G3.serializeStyles)($9903c3a67b1b059d$var$wrapper);
}

});
parcelRegister("haET7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c803165c4e312c33$export$2e2bcd8739ae039);

var $7g0OF = parcelRequire("7g0OF");
parcelRequire("8Wv3B");

parcelRequire("eC8G3");
parcelRequire("fZcY5");
parcelRequire("3oBZb");
parcelRequire("lx97N");
parcelRequire("jHGAH");
var $c803165c4e312c33$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $c803165c4e312c33$export$2e2bcd8739ae039 = (0, $7g0OF.default).bind(null);
$c803165c4e312c33$var$tags.forEach(function(tagName) {
    $c803165c4e312c33$export$2e2bcd8739ae039[tagName] = $c803165c4e312c33$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("7g0OF", function(module, exports) {

$parcel$export(module.exports, "default", () => $548aa915c1ecd831$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");
parcelRequire("9Hxe6");
var $jx6dC = parcelRequire("jx6dC");

var $eC8G3 = parcelRequire("eC8G3");

var $fZcY5 = parcelRequire("fZcY5");

var $3oBZb = parcelRequire("3oBZb");

var $lx97N = parcelRequire("lx97N");

var $jHGAH = parcelRequire("jHGAH");
var $548aa915c1ecd831$var$isBrowser = typeof document !== 'undefined';
var $548aa915c1ecd831$var$isDevelopment = false;
var $548aa915c1ecd831$var$testOmitPropsOnStringTag = (0, $jHGAH.default);
var $548aa915c1ecd831$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $548aa915c1ecd831$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $548aa915c1ecd831$var$testOmitPropsOnStringTag : $548aa915c1ecd831$var$testOmitPropsOnComponent;
};
var $548aa915c1ecd831$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $548aa915c1ecd831$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $3oBZb.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $fZcY5.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $3oBZb.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$548aa915c1ecd831$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $lx97N.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $548aa915c1ecd831$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $548aa915c1ecd831$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $548aa915c1ecd831$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $jx6dC.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $lx97N.useContext((0, $jx6dC.T));
            }
            if (typeof props.className === 'string') className = (0, $3oBZb.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $eC8G3.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $548aa915c1ecd831$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $lx97N.createElement($lx97N.Fragment, null, /*#__PURE__*/ $lx97N.createElement($548aa915c1ecd831$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $lx97N.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $548aa915c1ecd831$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eR4tV.default)({}, options, nextOptions, {
                shouldForwardProp: $548aa915c1ecd831$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("jHGAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e58312245c719150$export$2e2bcd8739ae039);

var $jeNL3 = parcelRequire("jeNL3");
// eslint-disable-next-line no-undef
var $e58312245c719150$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e58312245c719150$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $jeNL3.default)(function(prop) {
    return $e58312245c719150$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("hHT9b", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce413ae059a893c8$export$2e2bcd8739ae039);
parcelRequire("lx97N");


var $9Hxe6 = parcelRequire("9Hxe6");

var $fRwNr = parcelRequire("fRwNr");
'use client';
function $ce413ae059a893c8$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $ce413ae059a893c8$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($ce413ae059a893c8$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $9Hxe6.Global), {
        styles: globalStyles
    });
}

});




parcelRegister("dcTXD", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $99d7ce08d978986c$export$c7c50641356bdfa5);

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $99d7ce08d978986c$export$c7c50641356bdfa5(slot) {
    return (0, $h6nFM.default)('MuiSvgIcon', slot);
}
const $99d7ce08d978986c$var$svgIconClasses = (0, $3OBXm.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $99d7ce08d978986c$export$2e2bcd8739ae039 = $99d7ce08d978986c$var$svgIconClasses;

});
parcelRegister("3OBXm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c737bf780d63deb$export$2e2bcd8739ae039);

var $h6nFM = parcelRequire("h6nFM");
function $2c737bf780d63deb$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $h6nFM.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("h6nFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7355c234ebf5f90$export$2e2bcd8739ae039);

var $aNn1w = parcelRequire("aNn1w");
const $c7355c234ebf5f90$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $c7355c234ebf5f90$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $c7355c234ebf5f90$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $aNn1w.default).generate(componentName)}-${slot}`;
}
function $c7355c234ebf5f90$export$34c0130b1f3e8ae3(slot) {
    return $c7355c234ebf5f90$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("aNn1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dc056f6ffb24f89$export$2e2bcd8739ae039);
const $7dc056f6ffb24f89$var$defaultGenerator = (componentName)=>componentName;
const $7dc056f6ffb24f89$var$createClassNameGenerator = ()=>{
    let generate = $7dc056f6ffb24f89$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $7dc056f6ffb24f89$var$defaultGenerator;
        }
    };
};
const $7dc056f6ffb24f89$var$ClassNameGenerator = $7dc056f6ffb24f89$var$createClassNameGenerator();
var $7dc056f6ffb24f89$export$2e2bcd8739ae039 = $7dc056f6ffb24f89$var$ClassNameGenerator;

});







parcelRegister("fQojQ", function(module, exports) {

$parcel$export(module.exports, "clsx", () => $ee9d4e7b280b4edb$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $ee9d4e7b280b4edb$export$2e2bcd8739ae039);
function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;

});

parcelRegister("4z7Fu", function(module, exports) {
"use strict";
/**
 * Root reference for iframes.
 */ let root;
if (typeof window !== 'undefined') // Browser window
root = window;
else if (typeof self === 'undefined') {
    // Other environments
    console.warn('Using browser-only version of superagent in non-browser environment');
    root = void 0;
} else // Web Worker
root = self;

var $jiPGG = parcelRequire("jiPGG");

var $eY713 = parcelRequire("eY713");

var $4B36u = parcelRequire("4B36u");

var $8tZXK = parcelRequire("8tZXK");

var $cLRJi = parcelRequire("cLRJi");
var $3530611008748870$require$isObject = $cLRJi.isObject;
var $3530611008748870$require$mixin = $cLRJi.mixin;
var $3530611008748870$require$hasOwn = $cLRJi.hasOwn;

var $kJXnV = parcelRequire("kJXnV");

var $eLAxe = parcelRequire("eLAxe");
/**
 * Noop.
 */ function noop() {}
/**
 * Expose `request`.
 */ module.exports = function(method, url) {
    // callback
    if (typeof url === 'function') return new exports.Request('GET', method).end(url);
    // url first
    if (arguments.length === 1) return new exports.Request('GET', method);
    return new exports.Request(method, url);
};
exports = module.exports;
const request = exports;
exports.Request = Request;
/**
 * Determine XHR.
 */ request.getXHR = ()=>{
    if (root.XMLHttpRequest) return new root.XMLHttpRequest();
    throw new Error('Browser-only version of superagent could not find XHR');
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */ const trim = ''.trim ? (s)=>s.trim() : (s)=>s.replace(/(^\s*|\s*$)/g, '');
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */ function serialize(object) {
    if (!$3530611008748870$require$isObject(object)) return object;
    const pairs = [];
    for(const key in object)if ($3530611008748870$require$hasOwn(object, key)) pushEncodedKeyValuePair(pairs, key, object[key]);
    return pairs.join('&');
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */ function pushEncodedKeyValuePair(pairs, key, value) {
    if (value === undefined) return;
    if (value === null) {
        pairs.push(encodeURI(key));
        return;
    }
    if (Array.isArray(value)) for (const v of value)pushEncodedKeyValuePair(pairs, key, v);
    else if ($3530611008748870$require$isObject(value)) {
        for(const subkey in value)if ($3530611008748870$require$hasOwn(value, subkey)) pushEncodedKeyValuePair(pairs, `${key}[${subkey}]`, value[subkey]);
    } else pairs.push(encodeURI(key) + '=' + encodeURIComponent(value));
}
/**
 * Expose serialization method.
 */ request.serializeObject = serialize;
/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseString(string_) {
    const object = {};
    const pairs = string_.split('&');
    let pair;
    let pos;
    for(let i = 0, length_ = pairs.length; i < length_; ++i){
        pair = pairs[i];
        pos = pair.indexOf('=');
        if (pos === -1) object[decodeURIComponent(pair)] = '';
        else object[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
    return object;
}
/**
 * Expose parser.
 */ request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */ request.types = {
    html: 'text/html',
    json: 'application/json',
    xml: 'text/xml',
    urlencoded: 'application/x-www-form-urlencoded',
    form: 'application/x-www-form-urlencoded',
    'form-data': 'application/x-www-form-urlencoded'
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */ request.serialize = {
    'application/x-www-form-urlencoded': $4B36u.stringify,
    'application/json': $eY713
};
/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */ request.parse = {
    'application/x-www-form-urlencoded': parseString,
    'application/json': JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseHeader(string_) {
    const lines = string_.split(/\r?\n/);
    const fields = {};
    let index;
    let line;
    let field;
    let value;
    for(let i = 0, length_ = lines.length; i < length_; ++i){
        line = lines[i];
        index = line.indexOf(':');
        if (index === -1) continue;
        field = line.slice(0, index).toLowerCase();
        value = trim(line.slice(index + 1));
        fields[field] = value;
    }
    return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */ function isJSON(mime) {
    // should match /json or +json
    // but not /json-seq
    return /[/+]json($|[^-\w])/i.test(mime);
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */ function Response(request_) {
    this.req = request_;
    this.xhr = this.req.xhr;
    // responseText is accessible only if responseType is '' or 'text' and on older browsers
    this.text = this.req.method !== 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
    this.statusText = this.req.xhr.statusText;
    let { status } = this.xhr;
    // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    if (status === 1223) status = 204;
    this._setStatusProperties(status);
    this.headers = parseHeader(this.xhr.getAllResponseHeaders());
    this.header = this.headers;
    // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
    // getResponseHeader still works. so we get content-type even if getting
    // other headers fails.
    this.header['content-type'] = this.xhr.getResponseHeader('content-type');
    this._setHeaderProperties(this.header);
    if (this.text === null && request_._responseType) this.body = this.xhr.response;
    else this.body = this.req.method === 'HEAD' ? null : this._parseBody(this.text ? this.text : this.xhr.response);
}
$3530611008748870$require$mixin(Response.prototype, $kJXnV.prototype);
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */ Response.prototype._parseBody = function(string_) {
    let parse = request.parse[this.type];
    if (this.req._parser) return this.req._parser(this, string_);
    if (!parse && isJSON(this.type)) parse = request.parse['application/json'];
    return parse && string_ && (string_.length > 0 || string_ instanceof Object) ? parse(string_) : null;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */ Response.prototype.toError = function() {
    const { req } = this;
    const { method } = req;
    const { url } = req;
    const message = `cannot ${method} ${url} (${this.status})`;
    const error = new Error(message);
    error.status = this.status;
    error.method = method;
    error.url = url;
    return error;
};
/**
 * Expose `Response`.
 */ request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */ function Request(method, url) {
    const self1 = this;
    this._query = this._query || [];
    this.method = method;
    this.url = url;
    this.header = {}; // preserves header name case
    this._header = {}; // coerces header names to lowercase
    this.on('end', ()=>{
        let error = null;
        let res = null;
        try {
            res = new Response(self1);
        } catch (err) {
            error = new Error('Parser is unable to parse the response');
            error.parse = true;
            error.original = err;
            // issue #675: return the raw response if the response parsing fails
            if (self1.xhr) {
                // ie9 doesn't have 'response' property
                error.rawResponse = typeof self1.xhr.responseType === 'undefined' ? self1.xhr.responseText : self1.xhr.response;
                // issue #876: return the http status code if the response parsing fails
                error.status = self1.xhr.status ? self1.xhr.status : null;
                error.statusCode = error.status; // backwards-compat only
            } else {
                error.rawResponse = null;
                error.status = null;
            }
            return self1.callback(error);
        }
        self1.emit('response', res);
        let new_error;
        try {
            if (!self1._isResponseOK(res)) new_error = new Error(res.statusText || res.text || 'Unsuccessful HTTP response');
        } catch (err) {
            new_error = err; // ok() callback can throw
        }
        // #1000 don't catch errors from the callback to avoid double calling it
        if (new_error) {
            new_error.original = error;
            new_error.response = res;
            new_error.status = new_error.status || res.status;
            self1.callback(new_error, res);
        } else self1.callback(null, res);
    });
}
/**
 * Mixin `Emitter` and `RequestBase`.
 */ // eslint-disable-next-line new-cap
$jiPGG(Request.prototype);
$3530611008748870$require$mixin(Request.prototype, $8tZXK.prototype);
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.type = function(type) {
    this.set('Content-Type', request.types[type] || type);
    return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.accept = function(type) {
    this.set('Accept', request.types[type] || type);
    return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.auth = function(user, pass, options) {
    if (arguments.length === 1) pass = '';
    if (typeof pass === 'object' && pass !== null) {
        // pass is optional and can be replaced with options
        options = pass;
        pass = '';
    }
    if (!options) options = {
        type: typeof btoa === 'function' ? 'basic' : 'auto'
    };
    const encoder = options.encoder ? options.encoder : (string)=>{
        if (typeof btoa === 'function') return btoa(string);
        throw new Error('Cannot use basic auth, btoa is not a function');
    };
    return this._auth(user, pass, options, encoder);
};
/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.query = function(value) {
    if (typeof value !== 'string') value = serialize(value);
    if (value) this._query.push(value);
    return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.attach = function(field, file, options) {
    if (file) {
        if (this._data) throw new Error("superagent can't mix .send() and .attach()");
        this._getFormData().append(field, file, options || file.name);
    }
    return this;
};
Request.prototype._getFormData = function() {
    if (!this._formData) this._formData = new root.FormData();
    return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */ Request.prototype.callback = function(error, res) {
    if (this._shouldRetry(error, res)) return this._retry();
    const fn = this._callback;
    this.clearTimeout();
    if (error) {
        if (this._maxRetries) error.retries = this._retries - 1;
        this.emit('error', error);
    }
    fn(error, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */ Request.prototype.crossDomainError = function() {
    const error = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
    error.crossDomain = true;
    error.status = this.status;
    error.method = this.method;
    error.url = this.url;
    this.callback(error);
};
// This only warns, because the request is still likely to work
Request.prototype.agent = function() {
    console.warn('This is not supported in browser version of superagent');
    return this;
};
Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca;
// This throws, because it can't send/receive data as expected
Request.prototype.write = ()=>{
    throw new Error('Streaming is not supported in browser version of superagent');
};
Request.prototype.pipe = Request.prototype.write;
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */ Request.prototype._isHost = function(object) {
    // Native objects stringify to [object File], [object Blob], [object FormData], etc.
    return object && typeof object === 'object' && !Array.isArray(object) && Object.prototype.toString.call(object) !== '[object Object]';
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.end = function(fn) {
    if (this._endCalled) console.warn('Warning: .end() was called twice. This is not supported in superagent');
    this._endCalled = true;
    // store callback
    this._callback = fn || noop;
    // querystring
    this._finalizeQueryString();
    this._end();
};
Request.prototype._setUploadTimeout = function() {
    const self1 = this;
    // upload timeout it's wokrs only if deadline timeout is off
    if (this._uploadTimeout && !this._uploadTimeoutTimer) this._uploadTimeoutTimer = setTimeout(()=>{
        self1._timeoutError('Upload timeout of ', self1._uploadTimeout, 'ETIMEDOUT');
    }, this._uploadTimeout);
};
// eslint-disable-next-line complexity
Request.prototype._end = function() {
    if (this._aborted) return this.callback(new Error('The request has been aborted even before .end() was called'));
    const self1 = this;
    this.xhr = request.getXHR();
    const { xhr } = this;
    let data = this._formData || this._data;
    this._setTimeouts();
    // state change
    xhr.addEventListener('readystatechange', ()=>{
        const { readyState } = xhr;
        if (readyState >= 2 && self1._responseTimeoutTimer) clearTimeout(self1._responseTimeoutTimer);
        if (readyState !== 4) return;
        // In IE9, reads to any property (e.g. status) off of an aborted XHR will
        // result in the error "Could not complete the operation due to error c00c023f"
        let status;
        try {
            status = xhr.status;
        } catch (err) {
            status = 0;
        }
        if (!status) {
            if (self1.timedout || self1._aborted) return;
            return self1.crossDomainError();
        }
        self1.emit('end');
    });
    // progress
    const handleProgress = (direction, e)=>{
        if (e.total > 0) {
            e.percent = e.loaded / e.total * 100;
            if (e.percent === 100) clearTimeout(self1._uploadTimeoutTimer);
        }
        e.direction = direction;
        self1.emit('progress', e);
    };
    if (this.hasListeners('progress')) try {
        xhr.addEventListener('progress', handleProgress.bind(null, 'download'));
        if (xhr.upload) xhr.upload.addEventListener('progress', handleProgress.bind(null, 'upload'));
    } catch (err) {
    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
    if (xhr.upload) this._setUploadTimeout();
    // initiate request
    try {
        if (this.username && this.password) xhr.open(this.method, this.url, true, this.username, this.password);
        else xhr.open(this.method, this.url, true);
    } catch (err) {
        // see #1149
        return this.callback(err);
    }
    // CORS
    if (this._withCredentials) xhr.withCredentials = true;
    // body
    if (!this._formData && this.method !== 'GET' && this.method !== 'HEAD' && typeof data !== 'string' && !this._isHost(data)) {
        // serialize stuff
        const contentType = this._header['content-type'];
        let serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
        if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
        if (serialize) data = serialize(data);
    }
    // set header fields
    for(const field in this.header){
        if (this.header[field] === null) continue;
        if ($3530611008748870$require$hasOwn(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
    }
    if (this._responseType) xhr.responseType = this._responseType;
    // send stuff
    this.emit('request', this);
    // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
    // We need null here if data is undefined
    xhr.send(typeof data === 'undefined' ? null : data);
};
request.agent = ()=>new $eLAxe();
for (const method of [
    'GET',
    'POST',
    'OPTIONS',
    'PATCH',
    'PUT',
    'DELETE'
])$eLAxe.prototype[method.toLowerCase()] = function(url, fn) {
    const request_ = new request.Request(method, url);
    this._setDefaults(request_);
    if (fn) request_.end(fn);
    return request_;
};
$eLAxe.prototype.del = $eLAxe.prototype.delete;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.get = (url, data, fn)=>{
    const request_ = request('GET', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) request_.query(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.head = (url, data, fn)=>{
    const request_ = request('HEAD', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) request_.query(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.options = (url, data, fn)=>{
    const request_ = request('OPTIONS', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ function del(url, data, fn) {
    const request_ = request('DELETE', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
}
request.del = del;
request.delete = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.patch = (url, data, fn)=>{
    const request_ = request('PATCH', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.post = (url, data, fn)=>{
    const request_ = request('POST', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.put = (url, data, fn)=>{
    const request_ = request('PUT', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) request_.send(data);
    if (fn) request_.end(fn);
    return request_;
};

});
parcelRegister("8tZXK", function(module, exports) {
"use strict";

var $cLRJi = parcelRequire("cLRJi");
var $62d118aa4f3c18f7$require$isObject = $cLRJi.isObject;
var $62d118aa4f3c18f7$require$hasOwn = $cLRJi.hasOwn;
/**
 * Expose `RequestBase`.
 */ module.exports = $62d118aa4f3c18f7$var$RequestBase;
/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */ function $62d118aa4f3c18f7$var$RequestBase() {}
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.clearTimeout = function() {
    clearTimeout(this._timer);
    clearTimeout(this._responseTimeoutTimer);
    clearTimeout(this._uploadTimeoutTimer);
    delete this._timer;
    delete this._responseTimeoutTimer;
    delete this._uploadTimeoutTimer;
    return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.parse = function(fn) {
    this._parser = fn;
    return this;
};
/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.responseType = function(value) {
    this._responseType = value;
    return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.serialize = function(fn) {
    this._serializer = fn;
    return this;
};
/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.timeout = function(options) {
    if (!options || typeof options !== 'object') {
        this._timeout = options;
        this._responseTimeout = 0;
        this._uploadTimeout = 0;
        return this;
    }
    for(const option in options)if ($62d118aa4f3c18f7$require$hasOwn(options, option)) switch(option){
        case 'deadline':
            this._timeout = options.deadline;
            break;
        case 'response':
            this._responseTimeout = options.response;
            break;
        case 'upload':
            this._uploadTimeout = options.upload;
            break;
        default:
            console.warn('Unknown timeout option', option);
    }
    return this;
};
/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.retry = function(count, fn) {
    // Default to 1 if no count passed or true
    if (arguments.length === 0 || count === true) count = 1;
    if (count <= 0) count = 0;
    this._maxRetries = count;
    this._retries = 0;
    this._retryCallback = fn;
    return this;
};
//
// NOTE: we do not include ESOCKETTIMEDOUT because that is from `request` package
//       <https://github.com/sindresorhus/got/pull/537>
//
// NOTE: we do not include EADDRINFO because it was removed from libuv in 2014
//       <https://github.com/libuv/libuv/commit/02e1ebd40b807be5af46343ea873331b2ee4e9c1>
//       <https://github.com/request/request/search?q=ESOCKETTIMEDOUT&unscoped_q=ESOCKETTIMEDOUT>
//
//
// TODO: expose these as configurable defaults
//
const $62d118aa4f3c18f7$var$ERROR_CODES = new Set([
    'ETIMEDOUT',
    'ECONNRESET',
    'EADDRINUSE',
    'ECONNREFUSED',
    'EPIPE',
    'ENOTFOUND',
    'ENETUNREACH',
    'EAI_AGAIN'
]);
const $62d118aa4f3c18f7$var$STATUS_CODES = new Set([
    408,
    413,
    429,
    500,
    502,
    503,
    504,
    521,
    522,
    524
]);
// TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
// const METHODS = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);
/**
 * Determine if a request should be retried.
 * (Inspired by https://github.com/sindresorhus/got#retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */ $62d118aa4f3c18f7$var$RequestBase.prototype._shouldRetry = function(error, res) {
    if (!this._maxRetries || this._retries++ >= this._maxRetries) return false;
    if (this._retryCallback) try {
        const override = this._retryCallback(error, res);
        if (override === true) return true;
        if (override === false) return false;
    // undefined falls back to defaults
    } catch (err) {
        console.error(err);
    }
    // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
    /*
  if (
    this.req &&
    this.req.method &&
    !METHODS.has(this.req.method.toUpperCase())
  )
    return false;
  */ if (res && res.status && $62d118aa4f3c18f7$var$STATUS_CODES.has(res.status)) return true;
    if (error) {
        if (error.code && $62d118aa4f3c18f7$var$ERROR_CODES.has(error.code)) return true;
        // Superagent timeout
        if (error.timeout && error.code === 'ECONNABORTED') return true;
        if (error.crossDomain) return true;
    }
    return false;
};
/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */ $62d118aa4f3c18f7$var$RequestBase.prototype._retry = function() {
    this.clearTimeout();
    // node
    if (this.req) {
        this.req = null;
        this.req = this.request();
    }
    this._aborted = false;
    this.timedout = false;
    this.timedoutError = null;
    return this._end();
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.then = function(resolve, reject) {
    if (!this._fullfilledPromise) {
        const self = this;
        if (this._endCalled) console.warn('Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises');
        this._fullfilledPromise = new Promise((resolve, reject)=>{
            self.on('abort', ()=>{
                if (this._maxRetries && this._maxRetries > this._retries) return;
                if (this.timedout && this.timedoutError) {
                    reject(this.timedoutError);
                    return;
                }
                const error = new Error('Aborted');
                error.code = 'ABORTED';
                error.status = this.status;
                error.method = this.method;
                error.url = this.url;
                reject(error);
            });
            self.end((error, res)=>{
                if (error) reject(error);
                else resolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
};
$62d118aa4f3c18f7$var$RequestBase.prototype.catch = function(callback) {
    return this.then(undefined, callback);
};
/**
 * Allow for extension
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.use = function(fn) {
    fn(this);
    return this;
};
$62d118aa4f3c18f7$var$RequestBase.prototype.ok = function(callback) {
    if (typeof callback !== 'function') throw new Error('Callback required');
    this._okCallback = callback;
    return this;
};
$62d118aa4f3c18f7$var$RequestBase.prototype._isResponseOK = function(res) {
    if (!res) return false;
    if (this._okCallback) return this._okCallback(res);
    return res.status >= 200 && res.status < 300;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.get = function(field) {
    return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.getHeader = $62d118aa4f3c18f7$var$RequestBase.prototype.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.set = function(field, value) {
    if ($62d118aa4f3c18f7$require$isObject(field)) {
        for(const key in field)if ($62d118aa4f3c18f7$require$hasOwn(field, key)) this.set(key, field[key]);
        return this;
    }
    this._header[field.toLowerCase()] = value;
    this.header[field] = value;
    return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.unset = function(field) {
    delete this._header[field.toLowerCase()];
    delete this.header[field];
    return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @param {String} options extra options, e.g. 'blob'
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.field = function(name, value, options) {
    // name should be either a string or an object.
    if (name === null || undefined === name) throw new Error('.field(name, val) name can not be empty');
    if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    if ($62d118aa4f3c18f7$require$isObject(name)) {
        for(const key in name)if ($62d118aa4f3c18f7$require$hasOwn(name, key)) this.field(key, name[key]);
        return this;
    }
    if (Array.isArray(value)) {
        for(const i in value)if ($62d118aa4f3c18f7$require$hasOwn(value, i)) this.field(name, value[i]);
        return this;
    }
    // val should be defined now
    if (value === null || undefined === value) throw new Error('.field(name, val) val can not be empty');
    if (typeof value === 'boolean') value = String(value);
    // fix https://github.com/ladjs/superagent/issues/1680
    if (options) this._getFormData().append(name, value, options);
    else this._getFormData().append(name, value);
    return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.abort = function() {
    if (this._aborted) return this;
    this._aborted = true;
    if (this.xhr) this.xhr.abort(); // browser
    if (this.req) this.req.abort(); // node
    this.clearTimeout();
    this.emit('abort');
    return this;
};
$62d118aa4f3c18f7$var$RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
    switch(options.type){
        case 'basic':
            this.set('Authorization', `Basic ${base64Encoder(`${user}:${pass}`)}`);
            break;
        case 'auto':
            this.username = user;
            this.password = pass;
            break;
        case 'bearer':
            // usage would be .auth(accessToken, { type: 'bearer' })
            this.set('Authorization', `Bearer ${user}`);
            break;
        default:
            break;
    }
    return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 * @param {Boolean} [on=true] - Set 'withCredentials' state
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.withCredentials = function(on) {
    // This is browser-only functionality. Node side is no-op.
    if (on === undefined) on = true;
    this._withCredentials = on;
    return this;
};
/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.redirects = function(n) {
    this._maxRedirects = n;
    return this;
};
/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.maxResponseSize = function(n) {
    if (typeof n !== 'number') throw new TypeError('Invalid argument');
    this._maxResponseSize = n;
    return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */ // eslint-disable-next-line complexity
$62d118aa4f3c18f7$var$RequestBase.prototype.send = function(data) {
    const isObject_ = $62d118aa4f3c18f7$require$isObject(data);
    let type = this._header['content-type'];
    if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    if (isObject_ && !this._data) {
        if (Array.isArray(data)) this._data = [];
        else if (!this._isHost(data)) this._data = {};
    } else if (data && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
    // merge
    if (isObject_ && $62d118aa4f3c18f7$require$isObject(this._data)) for(const key in data){
        if (typeof data[key] == 'bigint' && !data[key].toJSON) throw new Error('Cannot serialize BigInt value to json');
        if ($62d118aa4f3c18f7$require$hasOwn(data, key)) this._data[key] = data[key];
    }
    else if (typeof data === 'bigint') throw new Error("Cannot send value of type BigInt");
    else if (typeof data === 'string') {
        // default to x-www-form-urlencoded
        if (!type) this.type('form');
        type = this._header['content-type'];
        if (type) type = type.toLowerCase().trim();
        if (type === 'application/x-www-form-urlencoded') this._data = this._data ? `${this._data}&${data}` : data;
        else this._data = (this._data || '') + data;
    } else this._data = data;
    if (!isObject_ || this._isHost(data)) return this;
    // default to json
    if (!type) this.type('json');
    return this;
};
/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */ $62d118aa4f3c18f7$var$RequestBase.prototype.sortQuery = function(sort) {
    // _sort default to true but otherwise can be a function or boolean
    this._sort = typeof sort === 'undefined' ? true : sort;
    return this;
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */ $62d118aa4f3c18f7$var$RequestBase.prototype._finalizeQueryString = function() {
    const query = this._query.join('&');
    if (query) this.url += (this.url.includes('?') ? '&' : '?') + query;
    this._query.length = 0; // Makes the call idempotent
    if (this._sort) {
        const index = this.url.indexOf('?');
        if (index >= 0) {
            const queryArray = this.url.slice(index + 1).split('&');
            if (typeof this._sort === 'function') queryArray.sort(this._sort);
            else queryArray.sort();
            this.url = this.url.slice(0, index) + '?' + queryArray.join('&');
        }
    }
};
// For backwards compat only
$62d118aa4f3c18f7$var$RequestBase.prototype._appendQueryString = ()=>{
    console.warn('Unsupported');
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */ $62d118aa4f3c18f7$var$RequestBase.prototype._timeoutError = function(reason, timeout, errno) {
    if (this._aborted) return;
    const error = new Error(`${reason + timeout}ms exceeded`);
    error.timeout = timeout;
    error.code = 'ECONNABORTED';
    error.errno = errno;
    this.timedout = true;
    this.timedoutError = error;
    this.abort();
    this.callback(error);
};
$62d118aa4f3c18f7$var$RequestBase.prototype._setTimeouts = function() {
    const self = this;
    // deadline
    if (this._timeout && !this._timer) this._timer = setTimeout(()=>{
        self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
    // response timeout
    if (this._responseTimeout && !this._responseTimeoutTimer) this._responseTimeoutTimer = setTimeout(()=>{
        self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
};

});
parcelRegister("cLRJi", function(module, exports) {

$parcel$export(module.exports, "type", () => $94c38d6685648d29$export$bf9fb029d174d554, (v) => $94c38d6685648d29$export$bf9fb029d174d554 = v);
$parcel$export(module.exports, "params", () => $94c38d6685648d29$export$281ad3752a540efe, (v) => $94c38d6685648d29$export$281ad3752a540efe = v);
$parcel$export(module.exports, "parseLinks", () => $94c38d6685648d29$export$255722312ba7ba74, (v) => $94c38d6685648d29$export$255722312ba7ba74 = v);
$parcel$export(module.exports, "isObject", () => $94c38d6685648d29$export$a6cdc56e425d0d0a, (v) => $94c38d6685648d29$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "hasOwn", () => $94c38d6685648d29$export$b5a638e9b3fff9f3, (v) => $94c38d6685648d29$export$b5a638e9b3fff9f3 = v);
$parcel$export(module.exports, "mixin", () => $94c38d6685648d29$export$e36fc9d62a853069, (v) => $94c38d6685648d29$export$e36fc9d62a853069 = v);
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ var $94c38d6685648d29$export$bf9fb029d174d554;
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $94c38d6685648d29$export$281ad3752a540efe;
/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $94c38d6685648d29$export$255722312ba7ba74;
/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */ var $94c38d6685648d29$export$bbc652556e2dc9ed;
/**
 * Check if `obj` is an object.
 *
 * @param {Object} object
 * @return {Boolean}
 * @api private
 */ var $94c38d6685648d29$export$a6cdc56e425d0d0a;
/**
 * Object.hasOwn fallback/polyfill.
 *
 * @type {(object: object, property: string) => boolean} object
 * @api private
 */ var $94c38d6685648d29$export$b5a638e9b3fff9f3;
var $94c38d6685648d29$export$e36fc9d62a853069;
"use strict";
$94c38d6685648d29$export$bf9fb029d174d554 = (string_)=>string_.split(/ *; */).shift();
$94c38d6685648d29$export$281ad3752a540efe = (value)=>{
    const object = {};
    for (const string_ of value.split(/ *; */)){
        const parts = string_.split(/ *= */);
        const key = parts.shift();
        const value = parts.shift();
        if (key && value) object[key] = value;
    }
    return object;
};
$94c38d6685648d29$export$255722312ba7ba74 = (value)=>{
    const object = {};
    for (const string_ of value.split(/ *, */)){
        const parts = string_.split(/ *; */);
        const url = parts[0].slice(1, -1);
        const rel = parts[1].split(/ *= */)[1].slice(1, -1);
        object[rel] = url;
    }
    return object;
};
$94c38d6685648d29$export$bbc652556e2dc9ed = (header, changesOrigin)=>{
    delete header['content-type'];
    delete header['content-length'];
    delete header['transfer-encoding'];
    delete header.host;
    // secuirty
    if (changesOrigin) {
        delete header.authorization;
        delete header.cookie;
    }
    return header;
};
$94c38d6685648d29$export$a6cdc56e425d0d0a = (object)=>{
    return object !== null && typeof object === 'object';
};
$94c38d6685648d29$export$b5a638e9b3fff9f3 = Object.hasOwn || function(object, property) {
    if (object == null) throw new TypeError('Cannot convert undefined or null to object');
    return Object.prototype.hasOwnProperty.call(new Object(object), property);
};
$94c38d6685648d29$export$e36fc9d62a853069 = (target, source)=>{
    for(const key in source)if ($94c38d6685648d29$export$b5a638e9b3fff9f3(source, key)) target[key] = source[key];
};

});


parcelRegister("kJXnV", function(module, exports) {
"use strict";

var $cLRJi = parcelRequire("cLRJi");
/**
 * Expose `ResponseBase`.
 */ module.exports = $f19613352b99bd83$var$ResponseBase;
/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */ function $f19613352b99bd83$var$ResponseBase() {}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $f19613352b99bd83$var$ResponseBase.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */ $f19613352b99bd83$var$ResponseBase.prototype._setHeaderProperties = function(header) {
    // TODO: moar!
    // TODO: make this a util
    // content-type
    const ct = header['content-type'] || '';
    this.type = $cLRJi.type(ct);
    // params
    const parameters = $cLRJi.params(ct);
    for(const key in parameters)if (Object.prototype.hasOwnProperty.call(parameters, key)) this[key] = parameters[key];
    this.links = {};
    // links
    try {
        if (header.link) this.links = $cLRJi.parseLinks(header.link);
    } catch (err) {
    // ignore
    }
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */ $f19613352b99bd83$var$ResponseBase.prototype._setStatusProperties = function(status) {
    const type = Math.trunc(status / 100);
    // status / class
    this.statusCode = status;
    this.status = this.statusCode;
    this.statusType = type;
    // basics
    this.info = type === 1;
    this.ok = type === 2;
    this.redirect = type === 3;
    this.clientError = type === 4;
    this.serverError = type === 5;
    this.error = type === 4 || type === 5 ? this.toError() : false;
    // sugar
    this.created = status === 201;
    this.accepted = status === 202;
    this.noContent = status === 204;
    this.badRequest = status === 400;
    this.unauthorized = status === 401;
    this.notAcceptable = status === 406;
    this.forbidden = status === 403;
    this.notFound = status === 404;
    this.unprocessableEntity = status === 422;
};

});

parcelRegister("eLAxe", function(module, exports) {
"use strict";
const $ac01cb8fd1aed930$var$defaults = [
    'use',
    'on',
    'once',
    'set',
    'query',
    'type',
    'accept',
    'auth',
    'withCredentials',
    'sortQuery',
    'retry',
    'ok',
    'redirects',
    'timeout',
    'buffer',
    'serialize',
    'parse',
    'ca',
    'key',
    'pfx',
    'cert',
    'disableTLSCerts'
];
class $ac01cb8fd1aed930$var$Agent {
    constructor(){
        this._defaults = [];
    }
    _setDefaults(request) {
        for (const def of this._defaults)request[def.fn](...def.args);
    }
}
for (const fn of $ac01cb8fd1aed930$var$defaults)// Default setting for all requests from this agent
$ac01cb8fd1aed930$var$Agent.prototype[fn] = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    this._defaults.push({
        fn: fn,
        args: args
    });
    return this;
};
module.exports = $ac01cb8fd1aed930$var$Agent;

});


parcelRegister("gBE7E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fxj72", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("18O95", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6Qk6Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hCvn3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aLLdg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3SsWc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5FoaD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6di5Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("826Qt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5znkU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3ivQF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7umGY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("c711O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cuyV5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3aT4k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iWv1Y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ijG0x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("80sFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7eoVv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lEwRe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2gpfs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3Vkxu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dzp8H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2VTlv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2dPh2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("f44sE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("TEUFO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4CV9C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iwjHh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9MlXy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jcaqX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lvWIJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("kmyGy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gCqEc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("e3rMY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("frWrQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jr6el", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iqHHC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("79rLu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hsXeS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hBBzx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jl7Pe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1RCnq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("qC0PA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iZKF6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aBdu0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4JBhu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gKJpE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eBqIe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cRANn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lFRTu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("84Gvd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gLPd5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fAOwX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1NWUE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1VUzl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jCvsV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aaPpl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ZqD5T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iAhPK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnreachableCaseError = void 0;
class $037dd4535cf1bb4f$var$UnreachableCaseError extends Error {
    constructor(value){
        super(`Unreachable case: ${value}`);
    }
}
module.exports.UnreachableCaseError = $037dd4535cf1bb4f$var$UnreachableCaseError;

});

parcelRegister("8QX3Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assert = void 0;
function $6720fe5a9b534021$var$assert(condition, message = "no additional info provided") {
    if (!condition) throw new Error("Assertion Error: " + message);
}
module.exports.assert = $6720fe5a9b534021$var$assert;

});

parcelRegister("hNUEX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createFactoryWithConstraint = void 0;
const $cf62f6aa8198fe8d$var$createFactoryWithConstraint = ()=>(value)=>value;
module.exports.createFactoryWithConstraint = $cf62f6aa8198fe8d$var$createFactoryWithConstraint;

});

parcelRegister("b7U2G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isExact = void 0;
const $819bd1f97fdb42bf$var$isExact = ()=>(actual)=>{
        return actual;
    };
module.exports.isExact = $819bd1f97fdb42bf$var$isExact;

});

parcelRegister("jUUFV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.noop = void 0;
function $e7ff35cc6457c788$var$noop(..._args) {}
module.exports.noop = $e7ff35cc6457c788$var$noop;

});

parcelRegister("kOUOq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aPqHS", function(module, exports) {

var $hmSZZ = parcelRequire("hmSZZ");


module.exports = Promise.all([
    (parcelRequire("dY3rC"))((parcelRequire("9Ppdo")).resolve("OiOgP")),
    $hmSZZ("lJh5i")
]).then(()=>parcelRequire('22oRb'));

});
parcelRegister("hmSZZ", function(module, exports) {
"use strict";

function $ca4f275ce6eda8bf$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("9Ppdo")).resolve(id));
}
module.exports = $ca4f275ce6eda8bf$var$load;

});

parcelRegister("dY3rC", function(module, exports) {
"use strict";

var $c8GJz = parcelRequire("c8GJz");
module.exports = $c8GJz(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("c8GJz", function(module, exports) {
"use strict";
var $8d67617c94569805$var$cachedBundles = {};
var $8d67617c94569805$var$cachedPreloads = {};
var $8d67617c94569805$var$cachedPrefetches = {};
function $8d67617c94569805$var$getCache(type) {
    switch(type){
        case 'preload':
            return $8d67617c94569805$var$cachedPreloads;
        case 'prefetch':
            return $8d67617c94569805$var$cachedPrefetches;
        default:
            return $8d67617c94569805$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $8d67617c94569805$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("6xvTc", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $4c2e8fb01297a259$export$a7c73072b1a182ae, (v) => $4c2e8fb01297a259$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $4c2e8fb01297a259$export$9f27bc3417b4524d, (v) => $4c2e8fb01297a259$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $4c2e8fb01297a259$export$db77ccec0bb4ccac, (v) => $4c2e8fb01297a259$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $4c2e8fb01297a259$export$8392c0c9d3dcbd35, (v) => $4c2e8fb01297a259$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $4c2e8fb01297a259$export$ffb0004e005737fa, (v) => $4c2e8fb01297a259$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $4c2e8fb01297a259$export$b624eff549462981, (v) => $4c2e8fb01297a259$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $4c2e8fb01297a259$export$7897aa7841a5380c, (v) => $4c2e8fb01297a259$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $4c2e8fb01297a259$export$602eac185826482c, (v) => $4c2e8fb01297a259$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $4c2e8fb01297a259$export$e2c29f18771995cb, (v) => $4c2e8fb01297a259$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $4c2e8fb01297a259$export$5f8d39834fd61797, (v) => $4c2e8fb01297a259$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $4c2e8fb01297a259$export$74bf444e3cd11ea5, (v) => $4c2e8fb01297a259$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $4c2e8fb01297a259$export$92387174baf9b227, (v) => $4c2e8fb01297a259$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $4c2e8fb01297a259$export$ec112efeb987d9c6, (v) => $4c2e8fb01297a259$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $4c2e8fb01297a259$export$b706b080d889d2c9, (v) => $4c2e8fb01297a259$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $4c2e8fb01297a259$export$5be5a87408f70ddc, (v) => $4c2e8fb01297a259$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $4c2e8fb01297a259$export$45a5e7f76e0caa8d, (v) => $4c2e8fb01297a259$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $4c2e8fb01297a259$export$455c2e768291efa6, (v) => $4c2e8fb01297a259$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $4c2e8fb01297a259$export$9522e17588c12572, (v) => $4c2e8fb01297a259$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $4c2e8fb01297a259$export$2110ac352bb060b9, (v) => $4c2e8fb01297a259$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $4c2e8fb01297a259$export$56885ab8b9c456ab, (v) => $4c2e8fb01297a259$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $4c2e8fb01297a259$export$d927fcb6adf8f9de, (v) => $4c2e8fb01297a259$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $4c2e8fb01297a259$export$b82d16f27459e05a, (v) => $4c2e8fb01297a259$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $4c2e8fb01297a259$export$522c17b4f5e123e8, (v) => $4c2e8fb01297a259$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $4c2e8fb01297a259$export$1aabd8a0274ecfd6, (v) => $4c2e8fb01297a259$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $4c2e8fb01297a259$export$9b621391a187a31a, (v) => $4c2e8fb01297a259$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $4c2e8fb01297a259$export$f5bbd400c2f4426f, (v) => $4c2e8fb01297a259$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4c2e8fb01297a259$export$a7c73072b1a182ae;
var $4c2e8fb01297a259$export$9f27bc3417b4524d;
var $4c2e8fb01297a259$export$db77ccec0bb4ccac;
var $4c2e8fb01297a259$export$8392c0c9d3dcbd35;
var $4c2e8fb01297a259$export$ffb0004e005737fa;
var $4c2e8fb01297a259$export$b624eff549462981;
var $4c2e8fb01297a259$export$7897aa7841a5380c;
var $4c2e8fb01297a259$export$602eac185826482c;
var $4c2e8fb01297a259$export$e2c29f18771995cb;
var $4c2e8fb01297a259$export$5f8d39834fd61797;
var $4c2e8fb01297a259$export$74bf444e3cd11ea5;
var $4c2e8fb01297a259$export$92387174baf9b227;
var $4c2e8fb01297a259$export$ec112efeb987d9c6;
var $4c2e8fb01297a259$export$b706b080d889d2c9;
var $4c2e8fb01297a259$export$5be5a87408f70ddc;
var $4c2e8fb01297a259$export$45a5e7f76e0caa8d;
var $4c2e8fb01297a259$export$455c2e768291efa6;
var $4c2e8fb01297a259$export$9522e17588c12572;
var $4c2e8fb01297a259$export$2110ac352bb060b9;
var $4c2e8fb01297a259$export$56885ab8b9c456ab;
var $4c2e8fb01297a259$export$d927fcb6adf8f9de;
var $4c2e8fb01297a259$export$b82d16f27459e05a;
var $4c2e8fb01297a259$export$522c17b4f5e123e8;
var $4c2e8fb01297a259$export$1aabd8a0274ecfd6;
var $4c2e8fb01297a259$export$9b621391a187a31a;
var $4c2e8fb01297a259$export$f5bbd400c2f4426f;
'use strict';
var $4c2e8fb01297a259$var$b = 60103, $4c2e8fb01297a259$var$c = 60106, $4c2e8fb01297a259$var$d = 60107, $4c2e8fb01297a259$var$e = 60108, $4c2e8fb01297a259$var$f = 60114, $4c2e8fb01297a259$var$g = 60109, $4c2e8fb01297a259$var$h = 60110, $4c2e8fb01297a259$var$k = 60112, $4c2e8fb01297a259$var$l = 60113, $4c2e8fb01297a259$var$m = 60120, $4c2e8fb01297a259$var$n = 60115, $4c2e8fb01297a259$var$p = 60116, $4c2e8fb01297a259$var$q = 60121, $4c2e8fb01297a259$var$r = 60122, $4c2e8fb01297a259$var$u = 60117, $4c2e8fb01297a259$var$v = 60129, $4c2e8fb01297a259$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $4c2e8fb01297a259$var$x = Symbol.for;
    $4c2e8fb01297a259$var$b = $4c2e8fb01297a259$var$x("react.element");
    $4c2e8fb01297a259$var$c = $4c2e8fb01297a259$var$x("react.portal");
    $4c2e8fb01297a259$var$d = $4c2e8fb01297a259$var$x("react.fragment");
    $4c2e8fb01297a259$var$e = $4c2e8fb01297a259$var$x("react.strict_mode");
    $4c2e8fb01297a259$var$f = $4c2e8fb01297a259$var$x("react.profiler");
    $4c2e8fb01297a259$var$g = $4c2e8fb01297a259$var$x("react.provider");
    $4c2e8fb01297a259$var$h = $4c2e8fb01297a259$var$x("react.context");
    $4c2e8fb01297a259$var$k = $4c2e8fb01297a259$var$x("react.forward_ref");
    $4c2e8fb01297a259$var$l = $4c2e8fb01297a259$var$x("react.suspense");
    $4c2e8fb01297a259$var$m = $4c2e8fb01297a259$var$x("react.suspense_list");
    $4c2e8fb01297a259$var$n = $4c2e8fb01297a259$var$x("react.memo");
    $4c2e8fb01297a259$var$p = $4c2e8fb01297a259$var$x("react.lazy");
    $4c2e8fb01297a259$var$q = $4c2e8fb01297a259$var$x("react.block");
    $4c2e8fb01297a259$var$r = $4c2e8fb01297a259$var$x("react.server.block");
    $4c2e8fb01297a259$var$u = $4c2e8fb01297a259$var$x("react.fundamental");
    $4c2e8fb01297a259$var$v = $4c2e8fb01297a259$var$x("react.debug_trace_mode");
    $4c2e8fb01297a259$var$w = $4c2e8fb01297a259$var$x("react.legacy_hidden");
}
function $4c2e8fb01297a259$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $4c2e8fb01297a259$var$b:
                switch(a = a.type, a){
                    case $4c2e8fb01297a259$var$d:
                    case $4c2e8fb01297a259$var$f:
                    case $4c2e8fb01297a259$var$e:
                    case $4c2e8fb01297a259$var$l:
                    case $4c2e8fb01297a259$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $4c2e8fb01297a259$var$h:
                            case $4c2e8fb01297a259$var$k:
                            case $4c2e8fb01297a259$var$p:
                            case $4c2e8fb01297a259$var$n:
                            case $4c2e8fb01297a259$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $4c2e8fb01297a259$var$c:
                return t;
        }
    }
}
var $4c2e8fb01297a259$var$z = $4c2e8fb01297a259$var$g, $4c2e8fb01297a259$var$A = $4c2e8fb01297a259$var$b, $4c2e8fb01297a259$var$B = $4c2e8fb01297a259$var$k, $4c2e8fb01297a259$var$C = $4c2e8fb01297a259$var$d, $4c2e8fb01297a259$var$D = $4c2e8fb01297a259$var$p, $4c2e8fb01297a259$var$E = $4c2e8fb01297a259$var$n, $4c2e8fb01297a259$var$F = $4c2e8fb01297a259$var$c, $4c2e8fb01297a259$var$G = $4c2e8fb01297a259$var$f, $4c2e8fb01297a259$var$H = $4c2e8fb01297a259$var$e, $4c2e8fb01297a259$var$I = $4c2e8fb01297a259$var$l;
$4c2e8fb01297a259$export$a7c73072b1a182ae = $4c2e8fb01297a259$var$h;
$4c2e8fb01297a259$export$9f27bc3417b4524d = $4c2e8fb01297a259$var$z;
$4c2e8fb01297a259$export$db77ccec0bb4ccac = $4c2e8fb01297a259$var$A;
$4c2e8fb01297a259$export$8392c0c9d3dcbd35 = $4c2e8fb01297a259$var$B;
$4c2e8fb01297a259$export$ffb0004e005737fa = $4c2e8fb01297a259$var$C;
$4c2e8fb01297a259$export$b624eff549462981 = $4c2e8fb01297a259$var$D;
$4c2e8fb01297a259$export$7897aa7841a5380c = $4c2e8fb01297a259$var$E;
$4c2e8fb01297a259$export$602eac185826482c = $4c2e8fb01297a259$var$F;
$4c2e8fb01297a259$export$e2c29f18771995cb = $4c2e8fb01297a259$var$G;
$4c2e8fb01297a259$export$5f8d39834fd61797 = $4c2e8fb01297a259$var$H;
$4c2e8fb01297a259$export$74bf444e3cd11ea5 = $4c2e8fb01297a259$var$I;
$4c2e8fb01297a259$export$92387174baf9b227 = function() {
    return !1;
};
$4c2e8fb01297a259$export$ec112efeb987d9c6 = function() {
    return !1;
};
$4c2e8fb01297a259$export$b706b080d889d2c9 = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$h;
};
$4c2e8fb01297a259$export$5be5a87408f70ddc = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$g;
};
$4c2e8fb01297a259$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $4c2e8fb01297a259$var$b;
};
$4c2e8fb01297a259$export$455c2e768291efa6 = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$k;
};
$4c2e8fb01297a259$export$9522e17588c12572 = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$d;
};
$4c2e8fb01297a259$export$2110ac352bb060b9 = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$p;
};
$4c2e8fb01297a259$export$56885ab8b9c456ab = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$n;
};
$4c2e8fb01297a259$export$d927fcb6adf8f9de = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$c;
};
$4c2e8fb01297a259$export$b82d16f27459e05a = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$f;
};
$4c2e8fb01297a259$export$522c17b4f5e123e8 = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$e;
};
$4c2e8fb01297a259$export$1aabd8a0274ecfd6 = function(a) {
    return $4c2e8fb01297a259$var$y(a) === $4c2e8fb01297a259$var$l;
};
$4c2e8fb01297a259$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $4c2e8fb01297a259$var$d || a === $4c2e8fb01297a259$var$f || a === $4c2e8fb01297a259$var$v || a === $4c2e8fb01297a259$var$e || a === $4c2e8fb01297a259$var$l || a === $4c2e8fb01297a259$var$m || a === $4c2e8fb01297a259$var$w || "object" === typeof a && null !== a && (a.$$typeof === $4c2e8fb01297a259$var$p || a.$$typeof === $4c2e8fb01297a259$var$n || a.$$typeof === $4c2e8fb01297a259$var$g || a.$$typeof === $4c2e8fb01297a259$var$h || a.$$typeof === $4c2e8fb01297a259$var$k || a.$$typeof === $4c2e8fb01297a259$var$u || a.$$typeof === $4c2e8fb01297a259$var$q || a[0] === $4c2e8fb01297a259$var$r) ? !0 : !1;
};
$4c2e8fb01297a259$export$f5bbd400c2f4426f = $4c2e8fb01297a259$var$y;

});

parcelRegister("foLar", function(module, exports) {

$parcel$export(module.exports, "default", () => $b35daf5c4dce34f5$export$2e2bcd8739ae039);
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $b35daf5c4dce34f5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $b35daf5c4dce34f5$export$2e2bcd8739ae039 = (0, $983Jy.default)("x", $b35daf5c4dce34f5$export$3efd853dbb351e94);

});

parcelRegister("4RND8", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("dflA0"))();

});

var $5322d461e9e8d2ef$exports = {};

(parcelRequire("9Ppdo")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"2izni\",\"index.82fd2036.js\",\"jo6b9\",\"../QEPSplash.5858df75.jpg\",\"6X3Oh\",\"../darkLogo.406eb4a0.png\",\"lJh5i\",\"../trade-allocation-modal.193790d6.js\",\"OiOgP\",\"../trade-allocation-modal.5c22b0d5.css\",\"7It0p\",\"../darkLogo.0ad3084c.svg\",\"6GhHL\",\"../components/authentication/AuthFail.ab5dda4c.js\",\"4QWiF\",\"../components/authentication/AuthFail.c4236ec6.js\",\"13WgX\",\"../components/authentication/AuthSuccess.492505ec.js\",\"4tgGr\",\"index.ae3ced9f.js\",\"dPl7C\",\"index.f8840c09.css\",\"lno95\",\"index.9b2c6fb6.js\",\"d6tT3\",\"index.f2ad65e5.js\"]"));

/* eslint-disable n/prefer-global/process */ /** Initializes the Browser shell, authentication state, and ordered automatic logout lifecycle. */ 
var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $jhfT6 = parcelRequire("jhfT6");

var $3bGoE = parcelRequire("3bGoE");

var $h0N84 = parcelRequire("h0N84");

var $fRwNr = parcelRequire("fRwNr");
var $5b45c4e874e30f29$exports = {};

(function(global, factory) {
    factory($5b45c4e874e30f29$exports, (parcelRequire("lx97N")));
})($5b45c4e874e30f29$exports, function(exports1, React) {
    'use strict';
    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) Object.keys(e).forEach(function(k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function() {
                        return e[k];
                    }
                });
            }
        });
        n["default"] = e;
        return Object.freeze(n);
    }
    var React__namespace = /*#__PURE__*/ _interopNamespace(React);
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    var changedArray = function changedArray(a, b) {
        if (a === void 0) a = [];
        if (b === void 0) b = [];
        return a.length !== b.length || a.some(function(item, index) {
            return !Object.is(item, b[index]);
        });
    };
    var initialState = {
        error: null
    };
    var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
        _inheritsLoose(ErrorBoundary, _React$Component);
        function ErrorBoundary() {
            var _this;
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(_args)) || this;
            _this.state = initialState;
            _this.resetErrorBoundary = function() {
                var _this$props;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                _this.props.onReset == null || (_this$props = _this.props).onReset.apply(_this$props, args);
                _this.reset();
            };
            return _this;
        }
        ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
            return {
                error: error
            };
        };
        var _proto = ErrorBoundary.prototype;
        _proto.reset = function reset() {
            this.setState(initialState);
        };
        _proto.componentDidCatch = function componentDidCatch(error, info) {
            var _this$props$onError, _this$props2;
            (_this$props$onError = (_this$props2 = this.props).onError) == null || _this$props$onError.call(_this$props2, error, info);
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            var error = this.state.error;
            var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
            // happens to *also* be in the resetKeys array, we'd end up resetting
            // the error boundary immediately. This would likely trigger a second
            // error to be thrown.
            // So we make sure that we don't check the resetKeys on the first call
            // of cDU after the error is set
            if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
                var _this$props$onResetKe, _this$props3;
                (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null || _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
                this.reset();
            }
        };
        _proto.render = function render() {
            var error = this.state.error;
            var _this$props4 = this.props, fallbackRender = _this$props4.fallbackRender, FallbackComponent = _this$props4.FallbackComponent, fallback = _this$props4.fallback;
            if (error !== null) {
                var _props = {
                    error: error,
                    resetErrorBoundary: this.resetErrorBoundary
                };
                if (/*#__PURE__*/ React__namespace.isValidElement(fallback)) return fallback;
                else if (typeof fallbackRender === 'function') return fallbackRender(_props);
                else if (FallbackComponent) return /*#__PURE__*/ React__namespace.createElement(FallbackComponent, _props);
                else throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
            }
            return this.props.children;
        };
        return ErrorBoundary;
    }(React__namespace.Component);
    function withErrorBoundary(Component, errorBoundaryProps) {
        var Wrapped = function Wrapped(props) {
            return /*#__PURE__*/ React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/ React__namespace.createElement(Component, props));
        }; // Format for display in DevTools
        var name = Component.displayName || Component.name || 'Unknown';
        Wrapped.displayName = "withErrorBoundary(" + name + ")";
        return Wrapped;
    }
    function useErrorHandler(givenError) {
        var _React$useState = React__namespace.useState(null), error = _React$useState[0], setError = _React$useState[1];
        if (givenError != null) throw givenError;
        if (error != null) throw error;
        return setError;
    }
    /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */ exports1.ErrorBoundary = ErrorBoundary;
    exports1.useErrorHandler = useErrorHandler;
    exports1.withErrorBoundary = withErrorBoundary;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});



var $fRwNr = parcelRequire("fRwNr");

var $hphT8 = parcelRequire("hphT8");
function $c6acedbaaa8a0e98$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $hphT8.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $eR4tV = parcelRequire("eR4tV");

var $eR4tV = parcelRequire("eR4tV");


var $lx97N = parcelRequire("lx97N");


var $4Djfw = parcelRequire("4Djfw");



var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");

var $l5EDh = parcelRequire("l5EDh");

var $eR4tV = parcelRequire("eR4tV");

function $420dbfb5f7d724c2$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
    if (!newClasses) return baseClasses;
    var nextClasses = (0, $eR4tV.default)({}, baseClasses);
    Object.keys(newClasses).forEach(function(key) {
        if (newClasses[key]) nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    });
    return nextClasses;
}


// Used https://github.com/thinkloop/multi-key-cache as inspiration
var $975d08610f0a2640$var$multiKeyStore = {
    set: function set(cache, key1, key2, value) {
        var subCache = cache.get(key1);
        if (!subCache) {
            subCache = new Map();
            cache.set(key1, subCache);
        }
        subCache.set(key2, value);
    },
    get: function get(cache, key1, key2) {
        var subCache = cache.get(key1);
        return subCache ? subCache.get(key2) : undefined;
    },
    delete: function _delete(cache, key1, key2) {
        var subCache = cache.get(key1);
        subCache.delete(key2);
    }
};
var $975d08610f0a2640$export$2e2bcd8739ae039 = $975d08610f0a2640$var$multiKeyStore;



var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
var $fe7d46c4bbb2e69c$var$ThemeContext = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext(null);
var $fe7d46c4bbb2e69c$export$2e2bcd8739ae039 = $fe7d46c4bbb2e69c$var$ThemeContext;


function $fe3cbcbcc4b394ba$export$2e2bcd8739ae039() {
    var theme = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useContext((0, $fe7d46c4bbb2e69c$export$2e2bcd8739ae039));
    return theme;
}



var $eR4tV = parcelRequire("eR4tV");


var $lx97N = parcelRequire("lx97N");


var $275c8e4a8d52cae8$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $275c8e4a8d52cae8$export$2e2bcd8739ae039 = $275c8e4a8d52cae8$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';


/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */ var $40b2a7d9d2ba3ceb$var$pseudoClasses = [
    'checked',
    'disabled',
    'error',
    'focused',
    'focusVisible',
    'required',
    'expanded',
    'selected'
]; // Returns a function which generates unique class names based on counters.
function $40b2a7d9d2ba3ceb$export$2e2bcd8739ae039() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? '' : _options$seed;
    var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
    var ruleCounter = 0;
    var getNextCounterId = function getNextCounterId() {
        ruleCounter += 1;
        return ruleCounter;
    };
    return function(rule, styleSheet) {
        var name = styleSheet.options.name; // Is a global static MUI style?
        if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
            // We can use a shorthand class name, we never use the keys to style the components.
            if ($40b2a7d9d2ba3ceb$var$pseudoClasses.indexOf(rule.key) !== -1) return "Mui-".concat(rule.key);
            var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
            if (!styleSheet.options.theme[0, $275c8e4a8d52cae8$export$2e2bcd8739ae039] || seed !== '') return prefix;
            return "".concat(prefix, "-").concat(getNextCounterId());
        }
        var suffix;
        return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    };
}



var $l5EDh = parcelRequire("l5EDh");


var $l5EDh = parcelRequire("l5EDh");
var $11c405024852272d$var$now = Date.now();
var $11c405024852272d$var$fnValuesNs = "fnValues" + $11c405024852272d$var$now;
var $11c405024852272d$var$fnRuleNs = "fnStyle" + ++$11c405024852272d$var$now;
var $11c405024852272d$var$functionPlugin = function functionPlugin() {
    return {
        onCreateRule: function onCreateRule(name, decl, options) {
            if (typeof decl !== 'function') return null;
            var rule = (0, $l5EDh.createRule)(name, {}, options);
            rule[$11c405024852272d$var$fnRuleNs] = decl;
            return rule;
        },
        onProcessStyle: function onProcessStyle(style, rule) {
            // We need to extract function values from the declaration, so that we can keep core unaware of them.
            // We need to do that only once.
            // We don't need to extract functions on each style update, since this can happen only once.
            // We don't support function values inside of function rules.
            if ($11c405024852272d$var$fnValuesNs in rule || $11c405024852272d$var$fnRuleNs in rule) return style;
            var fnValues = {};
            for(var prop in style){
                var value = style[prop];
                if (typeof value !== 'function') continue;
                delete style[prop];
                fnValues[prop] = value;
            }
            rule[$11c405024852272d$var$fnValuesNs] = fnValues;
            return style;
        },
        onUpdate: function onUpdate(data, rule, sheet, options) {
            var styleRule = rule;
            var fnRule = styleRule[$11c405024852272d$var$fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
            // will be returned from that function.
            if (fnRule) {
                // Empty object will remove all currently defined props
                // in case function rule returns a falsy value.
                styleRule.style = fnRule(data) || {};
                var prop;
            }
            var fnValues = styleRule[$11c405024852272d$var$fnValuesNs]; // If we have a fn values map, it is a rule with function values.
            if (fnValues) for(var _prop in fnValues)styleRule.prop(_prop, fnValues[_prop](data), options);
        }
    };
};
var $11c405024852272d$export$2e2bcd8739ae039 = $11c405024852272d$var$functionPlugin;



var $eR4tV = parcelRequire("eR4tV");

var $l5EDh = parcelRequire("l5EDh");
var $772622bba3f3411a$var$at = '@global';
var $772622bba3f3411a$var$atPrefix = '@global ';
var $772622bba3f3411a$var$GlobalContainerRule = /*#__PURE__*/ function() {
    function GlobalContainerRule(key, styles, options) {
        this.type = 'global';
        this.at = $772622bba3f3411a$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        this.rules = new (0, $l5EDh.RuleList)((0, $eR4tV.default)({}, options, {
            parent: this
        }));
        for(var selector in styles)this.rules.add(selector, styles[selector]);
        this.rules.process();
    }
    /**
   * Get a rule.
   */ var _proto = GlobalContainerRule.prototype;
    _proto.getRule = function getRule(name) {
        return this.rules.get(name);
    } /**
   * Create and register rule, run plugins.
   */ ;
    _proto.addRule = function addRule(name, style, options) {
        var rule = this.rules.add(name, style, options);
        if (rule) this.options.jss.plugins.onProcessRule(rule);
        return rule;
    } /**
   * Replace rule, run plugins.
   */ ;
    _proto.replaceRule = function replaceRule(name, style, options) {
        var newRule = this.rules.replace(name, style, options);
        if (newRule) this.options.jss.plugins.onProcessRule(newRule);
        return newRule;
    } /**
   * Get index of a rule.
   */ ;
    _proto.indexOf = function indexOf(rule) {
        return this.rules.indexOf(rule);
    } /**
   * Generates a CSS string.
   */ ;
    _proto.toString = function toString(options) {
        return this.rules.toString(options);
    };
    return GlobalContainerRule;
}();
var $772622bba3f3411a$var$GlobalPrefixedRule = /*#__PURE__*/ function() {
    function GlobalPrefixedRule(key, style, options) {
        this.type = 'global';
        this.at = $772622bba3f3411a$var$at;
        this.isProcessed = false;
        this.key = key;
        this.options = options;
        var selector = key.substr($772622bba3f3411a$var$atPrefix.length);
        this.rule = options.jss.createRule(selector, style, (0, $eR4tV.default)({}, options, {
            parent: this
        }));
    }
    var _proto2 = GlobalPrefixedRule.prototype;
    _proto2.toString = function toString(options) {
        return this.rule ? this.rule.toString(options) : '';
    };
    return GlobalPrefixedRule;
}();
var $772622bba3f3411a$var$separatorRegExp = /\s*,\s*/g;
function $772622bba3f3411a$var$addScope(selector, scope) {
    var parts = selector.split($772622bba3f3411a$var$separatorRegExp);
    var scoped = '';
    for(var i = 0; i < parts.length; i++){
        scoped += scope + " " + parts[i].trim();
        if (parts[i + 1]) scoped += ', ';
    }
    return scoped;
}
function $772622bba3f3411a$var$handleNestedGlobalContainerRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    var rules = style ? style[$772622bba3f3411a$var$at] : null;
    if (!rules) return;
    for(var name in rules)sheet.addRule(name, rules[name], (0, $eR4tV.default)({}, options, {
        selector: $772622bba3f3411a$var$addScope(name, rule.selector)
    }));
    delete style[$772622bba3f3411a$var$at];
}
function $772622bba3f3411a$var$handlePrefixedGlobalRule(rule, sheet) {
    var options = rule.options, style = rule.style;
    for(var prop in style){
        if (prop[0] !== '@' || prop.substr(0, $772622bba3f3411a$var$at.length) !== $772622bba3f3411a$var$at) continue;
        var selector = $772622bba3f3411a$var$addScope(prop.substr($772622bba3f3411a$var$at.length), rule.selector);
        sheet.addRule(selector, style[prop], (0, $eR4tV.default)({}, options, {
            selector: selector
        }));
        delete style[prop];
    }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $772622bba3f3411a$var$jssGlobal() {
    function onCreateRule(name, styles, options) {
        if (!name) return null;
        if (name === $772622bba3f3411a$var$at) return new $772622bba3f3411a$var$GlobalContainerRule(name, styles, options);
        if (name[0] === '@' && name.substr(0, $772622bba3f3411a$var$atPrefix.length) === $772622bba3f3411a$var$atPrefix) return new $772622bba3f3411a$var$GlobalPrefixedRule(name, styles, options);
        var parent = options.parent;
        if (parent) {
            if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') options.scoped = false;
        }
        if (!options.selector && options.scoped === false) options.selector = name;
        return null;
    }
    function onProcessRule(rule, sheet) {
        if (rule.type !== 'style' || !sheet) return;
        $772622bba3f3411a$var$handleNestedGlobalContainerRule(rule, sheet);
        $772622bba3f3411a$var$handlePrefixedGlobalRule(rule, sheet);
    }
    return {
        onCreateRule: onCreateRule,
        onProcessRule: onProcessRule
    };
}
var $772622bba3f3411a$export$2e2bcd8739ae039 = $772622bba3f3411a$var$jssGlobal;



var $eR4tV = parcelRequire("eR4tV");

var $0648a61fa7afaef3$var$separatorRegExp = /\s*,\s*/g;
var $0648a61fa7afaef3$var$parentRegExp = /&/g;
var $0648a61fa7afaef3$var$refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */ function $0648a61fa7afaef3$var$jssNested() {
    // Get a function to be used for $ref replacement.
    function getReplaceRef(container, sheet) {
        return function(match, key) {
            var rule = container.getRule(key) || sheet && sheet.getRule(key);
            if (rule) return rule.selector;
            return key;
        };
    }
    function replaceParentRefs(nestedProp, parentProp) {
        var parentSelectors = parentProp.split($0648a61fa7afaef3$var$separatorRegExp);
        var nestedSelectors = nestedProp.split($0648a61fa7afaef3$var$separatorRegExp);
        var result = '';
        for(var i = 0; i < parentSelectors.length; i++){
            var parent = parentSelectors[i];
            for(var j = 0; j < nestedSelectors.length; j++){
                var nested = nestedSelectors[j];
                if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
                result += nested.indexOf('&') !== -1 ? nested.replace($0648a61fa7afaef3$var$parentRegExp, parent) : parent + " " + nested;
            }
        }
        return result;
    }
    function getOptions(rule, container, prevOptions) {
        // Options has been already created, now we only increase index.
        if (prevOptions) return (0, $eR4tV.default)({}, prevOptions, {
            index: prevOptions.index + 1
        });
        var nestingLevel = rule.options.nestingLevel;
        nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
        var options = (0, $eR4tV.default)({}, rule.options, {
            nestingLevel: nestingLevel,
            index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
        });
        delete options.name;
        return options;
    }
    function onProcessStyle(style, rule, sheet) {
        if (rule.type !== 'style') return style;
        var styleRule = rule;
        var container = styleRule.options.parent;
        var options;
        var replaceRef;
        for(var prop in style){
            var isNested = prop.indexOf('&') !== -1;
            var isNestedConditional = prop[0] === '@';
            if (!isNested && !isNestedConditional) continue;
            options = getOptions(styleRule, container, options);
            if (isNested) {
                var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
                // all nested rules within the sheet.
                if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
                selector = selector.replace($0648a61fa7afaef3$var$refRegExp, replaceRef);
                var name = styleRule.key + "-" + prop;
                if ('replaceRule' in container) // for backward compatibility
                container.replaceRule(name, style[prop], (0, $eR4tV.default)({}, options, {
                    selector: selector
                }));
                else container.addRule(name, style[prop], (0, $eR4tV.default)({}, options, {
                    selector: selector
                }));
            } else if (isNestedConditional) // Place conditional right after the parent rule to ensure right ordering.
            container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
                selector: styleRule.selector
            });
            delete style[prop];
        }
        return style;
    }
    return {
        onProcessStyle: onProcessStyle
    };
}
var $0648a61fa7afaef3$export$2e2bcd8739ae039 = $0648a61fa7afaef3$var$jssNested;


/* eslint-disable no-var, prefer-template */ var $2f003cdbf58660f6$var$uppercasePattern = /[A-Z]/g;
var $2f003cdbf58660f6$var$msPattern = /^ms-/;
var $2f003cdbf58660f6$var$cache = {};
function $2f003cdbf58660f6$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $2f003cdbf58660f6$var$hyphenateStyleName(name) {
    if ($2f003cdbf58660f6$var$cache.hasOwnProperty(name)) return $2f003cdbf58660f6$var$cache[name];
    var hName = name.replace($2f003cdbf58660f6$var$uppercasePattern, $2f003cdbf58660f6$var$toHyphenLower);
    return $2f003cdbf58660f6$var$cache[name] = $2f003cdbf58660f6$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $2f003cdbf58660f6$export$2e2bcd8739ae039 = $2f003cdbf58660f6$var$hyphenateStyleName;


/**
 * Convert camel cased property names to dash separated.
 */ function $a277082344b255b4$var$convertCase(style) {
    var converted = {};
    for(var prop in style){
        var key = prop.indexOf('--') === 0 ? prop : (0, $2f003cdbf58660f6$export$2e2bcd8739ae039)(prop);
        converted[key] = style[prop];
    }
    if (style.fallbacks) {
        if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map($a277082344b255b4$var$convertCase);
        else converted.fallbacks = $a277082344b255b4$var$convertCase(style.fallbacks);
    }
    return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */ function $a277082344b255b4$var$camelCase() {
    function onProcessStyle(style) {
        if (Array.isArray(style)) {
            // Handle rules like @font-face, which can have multiple styles in an array
            for(var index = 0; index < style.length; index++)style[index] = $a277082344b255b4$var$convertCase(style[index]);
            return style;
        }
        return $a277082344b255b4$var$convertCase(style);
    }
    function onChangeValue(value, prop, rule) {
        if (prop.indexOf('--') === 0) return value;
        var hyphenatedProp = (0, $2f003cdbf58660f6$export$2e2bcd8739ae039)(prop); // There was no camel case in place
        if (prop === hyphenatedProp) return value;
        rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
        return null;
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $a277082344b255b4$export$2e2bcd8739ae039 = $a277082344b255b4$var$camelCase;



var $l5EDh = parcelRequire("l5EDh");
var $80c24183cdb905d9$var$px = (0, $l5EDh.hasCSSTOMSupport) && CSS ? CSS.px : 'px';
var $80c24183cdb905d9$var$ms = (0, $l5EDh.hasCSSTOMSupport) && CSS ? CSS.ms : 'ms';
var $80c24183cdb905d9$var$percent = (0, $l5EDh.hasCSSTOMSupport) && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */ var $80c24183cdb905d9$var$defaultUnits = {
    // Animation properties
    'animation-delay': $80c24183cdb905d9$var$ms,
    'animation-duration': $80c24183cdb905d9$var$ms,
    // Background properties
    'background-position': $80c24183cdb905d9$var$px,
    'background-position-x': $80c24183cdb905d9$var$px,
    'background-position-y': $80c24183cdb905d9$var$px,
    'background-size': $80c24183cdb905d9$var$px,
    // Border Properties
    border: $80c24183cdb905d9$var$px,
    'border-bottom': $80c24183cdb905d9$var$px,
    'border-bottom-left-radius': $80c24183cdb905d9$var$px,
    'border-bottom-right-radius': $80c24183cdb905d9$var$px,
    'border-bottom-width': $80c24183cdb905d9$var$px,
    'border-left': $80c24183cdb905d9$var$px,
    'border-left-width': $80c24183cdb905d9$var$px,
    'border-radius': $80c24183cdb905d9$var$px,
    'border-right': $80c24183cdb905d9$var$px,
    'border-right-width': $80c24183cdb905d9$var$px,
    'border-top': $80c24183cdb905d9$var$px,
    'border-top-left-radius': $80c24183cdb905d9$var$px,
    'border-top-right-radius': $80c24183cdb905d9$var$px,
    'border-top-width': $80c24183cdb905d9$var$px,
    'border-width': $80c24183cdb905d9$var$px,
    'border-block': $80c24183cdb905d9$var$px,
    'border-block-end': $80c24183cdb905d9$var$px,
    'border-block-end-width': $80c24183cdb905d9$var$px,
    'border-block-start': $80c24183cdb905d9$var$px,
    'border-block-start-width': $80c24183cdb905d9$var$px,
    'border-block-width': $80c24183cdb905d9$var$px,
    'border-inline': $80c24183cdb905d9$var$px,
    'border-inline-end': $80c24183cdb905d9$var$px,
    'border-inline-end-width': $80c24183cdb905d9$var$px,
    'border-inline-start': $80c24183cdb905d9$var$px,
    'border-inline-start-width': $80c24183cdb905d9$var$px,
    'border-inline-width': $80c24183cdb905d9$var$px,
    'border-start-start-radius': $80c24183cdb905d9$var$px,
    'border-start-end-radius': $80c24183cdb905d9$var$px,
    'border-end-start-radius': $80c24183cdb905d9$var$px,
    'border-end-end-radius': $80c24183cdb905d9$var$px,
    // Margin properties
    margin: $80c24183cdb905d9$var$px,
    'margin-bottom': $80c24183cdb905d9$var$px,
    'margin-left': $80c24183cdb905d9$var$px,
    'margin-right': $80c24183cdb905d9$var$px,
    'margin-top': $80c24183cdb905d9$var$px,
    'margin-block': $80c24183cdb905d9$var$px,
    'margin-block-end': $80c24183cdb905d9$var$px,
    'margin-block-start': $80c24183cdb905d9$var$px,
    'margin-inline': $80c24183cdb905d9$var$px,
    'margin-inline-end': $80c24183cdb905d9$var$px,
    'margin-inline-start': $80c24183cdb905d9$var$px,
    // Padding properties
    padding: $80c24183cdb905d9$var$px,
    'padding-bottom': $80c24183cdb905d9$var$px,
    'padding-left': $80c24183cdb905d9$var$px,
    'padding-right': $80c24183cdb905d9$var$px,
    'padding-top': $80c24183cdb905d9$var$px,
    'padding-block': $80c24183cdb905d9$var$px,
    'padding-block-end': $80c24183cdb905d9$var$px,
    'padding-block-start': $80c24183cdb905d9$var$px,
    'padding-inline': $80c24183cdb905d9$var$px,
    'padding-inline-end': $80c24183cdb905d9$var$px,
    'padding-inline-start': $80c24183cdb905d9$var$px,
    // Mask properties
    'mask-position-x': $80c24183cdb905d9$var$px,
    'mask-position-y': $80c24183cdb905d9$var$px,
    'mask-size': $80c24183cdb905d9$var$px,
    // Width and height properties
    height: $80c24183cdb905d9$var$px,
    width: $80c24183cdb905d9$var$px,
    'min-height': $80c24183cdb905d9$var$px,
    'max-height': $80c24183cdb905d9$var$px,
    'min-width': $80c24183cdb905d9$var$px,
    'max-width': $80c24183cdb905d9$var$px,
    // Position properties
    bottom: $80c24183cdb905d9$var$px,
    left: $80c24183cdb905d9$var$px,
    top: $80c24183cdb905d9$var$px,
    right: $80c24183cdb905d9$var$px,
    inset: $80c24183cdb905d9$var$px,
    'inset-block': $80c24183cdb905d9$var$px,
    'inset-block-end': $80c24183cdb905d9$var$px,
    'inset-block-start': $80c24183cdb905d9$var$px,
    'inset-inline': $80c24183cdb905d9$var$px,
    'inset-inline-end': $80c24183cdb905d9$var$px,
    'inset-inline-start': $80c24183cdb905d9$var$px,
    // Shadow properties
    'box-shadow': $80c24183cdb905d9$var$px,
    'text-shadow': $80c24183cdb905d9$var$px,
    // Column properties
    'column-gap': $80c24183cdb905d9$var$px,
    'column-rule': $80c24183cdb905d9$var$px,
    'column-rule-width': $80c24183cdb905d9$var$px,
    'column-width': $80c24183cdb905d9$var$px,
    // Font and text properties
    'font-size': $80c24183cdb905d9$var$px,
    'font-size-delta': $80c24183cdb905d9$var$px,
    'letter-spacing': $80c24183cdb905d9$var$px,
    'text-decoration-thickness': $80c24183cdb905d9$var$px,
    'text-indent': $80c24183cdb905d9$var$px,
    'text-stroke': $80c24183cdb905d9$var$px,
    'text-stroke-width': $80c24183cdb905d9$var$px,
    'word-spacing': $80c24183cdb905d9$var$px,
    // Motion properties
    motion: $80c24183cdb905d9$var$px,
    'motion-offset': $80c24183cdb905d9$var$px,
    // Outline properties
    outline: $80c24183cdb905d9$var$px,
    'outline-offset': $80c24183cdb905d9$var$px,
    'outline-width': $80c24183cdb905d9$var$px,
    // Perspective properties
    perspective: $80c24183cdb905d9$var$px,
    'perspective-origin-x': $80c24183cdb905d9$var$percent,
    'perspective-origin-y': $80c24183cdb905d9$var$percent,
    // Transform properties
    'transform-origin': $80c24183cdb905d9$var$percent,
    'transform-origin-x': $80c24183cdb905d9$var$percent,
    'transform-origin-y': $80c24183cdb905d9$var$percent,
    'transform-origin-z': $80c24183cdb905d9$var$percent,
    // Transition properties
    'transition-delay': $80c24183cdb905d9$var$ms,
    'transition-duration': $80c24183cdb905d9$var$ms,
    // Alignment properties
    'vertical-align': $80c24183cdb905d9$var$px,
    'flex-basis': $80c24183cdb905d9$var$px,
    // Some random properties
    'shape-margin': $80c24183cdb905d9$var$px,
    size: $80c24183cdb905d9$var$px,
    gap: $80c24183cdb905d9$var$px,
    // Grid properties
    grid: $80c24183cdb905d9$var$px,
    'grid-gap': $80c24183cdb905d9$var$px,
    'row-gap': $80c24183cdb905d9$var$px,
    'grid-row-gap': $80c24183cdb905d9$var$px,
    'grid-column-gap': $80c24183cdb905d9$var$px,
    'grid-template-rows': $80c24183cdb905d9$var$px,
    'grid-template-columns': $80c24183cdb905d9$var$px,
    'grid-auto-rows': $80c24183cdb905d9$var$px,
    'grid-auto-columns': $80c24183cdb905d9$var$px,
    // Not existing properties.
    // Used to avoid issues with jss-plugin-expand integration.
    'box-shadow-x': $80c24183cdb905d9$var$px,
    'box-shadow-y': $80c24183cdb905d9$var$px,
    'box-shadow-blur': $80c24183cdb905d9$var$px,
    'box-shadow-spread': $80c24183cdb905d9$var$px,
    'font-line-height': $80c24183cdb905d9$var$px,
    'text-shadow-x': $80c24183cdb905d9$var$px,
    'text-shadow-y': $80c24183cdb905d9$var$px,
    'text-shadow-blur': $80c24183cdb905d9$var$px
};
/**
 * Clones the object and adds a camel cased property version.
 */ function $80c24183cdb905d9$var$addCamelCasedVersion(obj) {
    var regExp = /(-[a-z])/g;
    var replace = function replace(str) {
        return str[1].toUpperCase();
    };
    var newObj = {};
    for(var key in obj){
        newObj[key] = obj[key];
        newObj[key.replace(regExp, replace)] = obj[key];
    }
    return newObj;
}
var $80c24183cdb905d9$var$units = $80c24183cdb905d9$var$addCamelCasedVersion($80c24183cdb905d9$var$defaultUnits);
/**
 * Recursive deep style passing function
 */ function $80c24183cdb905d9$var$iterate(prop, value, options) {
    if (value == null) return value;
    if (Array.isArray(value)) for(var i = 0; i < value.length; i++)value[i] = $80c24183cdb905d9$var$iterate(prop, value[i], options);
    else if (typeof value === 'object') {
        if (prop === 'fallbacks') for(var innerProp in value)value[innerProp] = $80c24183cdb905d9$var$iterate(innerProp, value[innerProp], options);
        else for(var _innerProp in value)value[_innerProp] = $80c24183cdb905d9$var$iterate(prop + "-" + _innerProp, value[_innerProp], options);
         // eslint-disable-next-line no-restricted-globals
    } else if (typeof value === 'number' && isNaN(value) === false) {
        var unit = options[prop] || $80c24183cdb905d9$var$units[prop]; // Add the unit if available, except for the special case of 0px.
        if (unit && !(value === 0 && unit === $80c24183cdb905d9$var$px)) return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
        return value.toString();
    }
    return value;
}
/**
 * Add unit to numeric values.
 */ function $80c24183cdb905d9$var$defaultUnit(options) {
    if (options === void 0) options = {};
    var camelCasedOptions = $80c24183cdb905d9$var$addCamelCasedVersion(options);
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        for(var prop in style)style[prop] = $80c24183cdb905d9$var$iterate(prop, style[prop], camelCasedOptions);
        return style;
    }
    function onChangeValue(value, prop) {
        return $80c24183cdb905d9$var$iterate(prop, value, camelCasedOptions);
    }
    return {
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $80c24183cdb905d9$export$2e2bcd8739ae039 = $80c24183cdb905d9$var$defaultUnit;



var $lDq78 = parcelRequire("lDq78");
function $95a6fae2438244f2$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $c6e0fe493a0bb8b0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $95a6fae2438244f2$export$2e2bcd8739ae039)(r);
}


function $c3d5afa8ff50c0f7$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $7715ec4682011719$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $95a6fae2438244f2$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $95a6fae2438244f2$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $76911ba49d8a29e5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $2905eabba6b75ab9$export$2e2bcd8739ae039(r) {
    return (0, $c6e0fe493a0bb8b0$export$2e2bcd8739ae039)(r) || (0, $c3d5afa8ff50c0f7$export$2e2bcd8739ae039)(r) || (0, $7715ec4682011719$export$2e2bcd8739ae039)(r) || (0, $76911ba49d8a29e5$export$2e2bcd8739ae039)();
}


// Export javascript style and css style vendor prefixes.
var $9792a1e08a2d8ad6$var$js = '';
var $9792a1e08a2d8ad6$var$css = '';
var $9792a1e08a2d8ad6$var$vendor = '';
var $9792a1e08a2d8ad6$var$browser = '';
var $9792a1e08a2d8ad6$var$isTouch = (0, $lDq78.default) && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
if (0, $lDq78.default) {
    // Order matters. We need to check Webkit the last one because
    // other vendors use to add Webkit prefixes to some properties
    var $9792a1e08a2d8ad6$var$jsCssMap = {
        Moz: '-moz-',
        ms: '-ms-',
        O: '-o-',
        Webkit: '-webkit-'
    };
    var $9792a1e08a2d8ad6$var$_document$createEleme = document.createElement('p'), $9792a1e08a2d8ad6$var$style = $9792a1e08a2d8ad6$var$_document$createEleme.style;
    var $9792a1e08a2d8ad6$var$testProp = 'Transform';
    for(var $9792a1e08a2d8ad6$var$key in $9792a1e08a2d8ad6$var$jsCssMap)if ($9792a1e08a2d8ad6$var$key + $9792a1e08a2d8ad6$var$testProp in $9792a1e08a2d8ad6$var$style) {
        $9792a1e08a2d8ad6$var$js = $9792a1e08a2d8ad6$var$key;
        $9792a1e08a2d8ad6$var$css = $9792a1e08a2d8ad6$var$jsCssMap[$9792a1e08a2d8ad6$var$key];
        break;
    }
     // Correctly detect the Edge browser.
    if ($9792a1e08a2d8ad6$var$js === 'Webkit' && 'msHyphens' in $9792a1e08a2d8ad6$var$style) {
        $9792a1e08a2d8ad6$var$js = 'ms';
        $9792a1e08a2d8ad6$var$css = $9792a1e08a2d8ad6$var$jsCssMap.ms;
        $9792a1e08a2d8ad6$var$browser = 'edge';
    } // Correctly detect the Safari browser.
    if ($9792a1e08a2d8ad6$var$js === 'Webkit' && '-apple-trailing-word' in $9792a1e08a2d8ad6$var$style) $9792a1e08a2d8ad6$var$vendor = 'apple';
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */ var $9792a1e08a2d8ad6$export$82e9f45cca5ba907 = {
    js: $9792a1e08a2d8ad6$var$js,
    css: $9792a1e08a2d8ad6$var$css,
    vendor: $9792a1e08a2d8ad6$var$vendor,
    browser: $9792a1e08a2d8ad6$var$browser,
    isTouch: $9792a1e08a2d8ad6$var$isTouch
};
/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */ function $9792a1e08a2d8ad6$export$b6aa0648d950180a(key) {
    // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
    if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
    // https://caniuse.com/#search=keyframes
    if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'ms') return key;
    return "@" + $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + "keyframes" + key.substr(10);
}
// https://caniuse.com/#search=appearance
var $9792a1e08a2d8ad6$var$appearence = {
    noPrefill: [
        'appearance'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'appearance') return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'ms') return "-webkit-" + prop;
        return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=color-adjust
var $9792a1e08a2d8ad6$var$colorAdjust = {
    noPrefill: [
        'color-adjust'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'color-adjust') return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'Webkit') return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + "print-" + prop;
        return prop;
    }
};
var $9792a1e08a2d8ad6$var$regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */ function $9792a1e08a2d8ad6$var$toUpper(match, c) {
    return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $9792a1e08a2d8ad6$var$camelize(str) {
    return str.replace($9792a1e08a2d8ad6$var$regExp, $9792a1e08a2d8ad6$var$toUpper);
}
/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ function $9792a1e08a2d8ad6$var$pascalize(str) {
    return $9792a1e08a2d8ad6$var$camelize("-" + str);
}
// but we can use a longhand property instead.
// https://caniuse.com/#search=mask
var $9792a1e08a2d8ad6$var$mask = {
    noPrefill: [
        'mask'
    ],
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^mask/.test(prop)) return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'Webkit') {
            var longhand = 'mask-image';
            if ($9792a1e08a2d8ad6$var$camelize(longhand) in style) return prop;
            if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js + $9792a1e08a2d8ad6$var$pascalize(longhand) in style) return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop;
        }
        return prop;
    }
};
// https://caniuse.com/#search=text-orientation
var $9792a1e08a2d8ad6$var$textOrientation = {
    noPrefill: [
        'text-orientation'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'text-orientation') return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.vendor === 'apple' && !$9792a1e08a2d8ad6$export$82e9f45cca5ba907.isTouch) return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=transform
var $9792a1e08a2d8ad6$var$transform = {
    noPrefill: [
        'transform'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transform') return false;
        if (options.transform) return prop;
        return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=transition
var $9792a1e08a2d8ad6$var$transition = {
    noPrefill: [
        'transition'
    ],
    supportedProperty: function supportedProperty(prop, style, options) {
        if (prop !== 'transition') return false;
        if (options.transition) return prop;
        return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop;
    }
};
// https://caniuse.com/#search=writing-mode
var $9792a1e08a2d8ad6$var$writingMode = {
    noPrefill: [
        'writing-mode'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'writing-mode') return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'Webkit' || $9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'ms' && $9792a1e08a2d8ad6$export$82e9f45cca5ba907.browser !== 'edge') return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=user-select
var $9792a1e08a2d8ad6$var$userSelect = {
    noPrefill: [
        'user-select'
    ],
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'user-select') return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'Moz' || $9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'ms' || $9792a1e08a2d8ad6$export$82e9f45cca5ba907.vendor === 'apple') return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177
var $9792a1e08a2d8ad6$var$breakPropsOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^break-/.test(prop)) return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'Webkit') {
            var jsProp = "WebkitColumn" + $9792a1e08a2d8ad6$var$pascalize(prop);
            return jsProp in style ? $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + "column-" + prop : false;
        }
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'Moz') {
            var _jsProp = "page" + $9792a1e08a2d8ad6$var$pascalize(prop);
            return _jsProp in style ? "page-" + prop : false;
        }
        return false;
    }
};
// See https://github.com/postcss/autoprefixer/issues/324.
var $9792a1e08a2d8ad6$var$inlineLogicalOld = {
    supportedProperty: function supportedProperty(prop, style) {
        if (!/^(border|margin|padding)-inline/.test(prop)) return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'Moz') return prop;
        var newProp = prop.replace('-inline', '');
        return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.js + $9792a1e08a2d8ad6$var$pascalize(newProp) in style ? $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + newProp : false;
    }
};
// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.
var $9792a1e08a2d8ad6$var$unprefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        return $9792a1e08a2d8ad6$var$camelize(prop) in style ? prop : false;
    }
};
var $9792a1e08a2d8ad6$var$prefixed = {
    supportedProperty: function supportedProperty(prop, style) {
        var pascalized = $9792a1e08a2d8ad6$var$pascalize(prop); // Return custom CSS variable without prefixing.
        if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
        if (prop[0] === '-' && prop[1] === '-') return prop;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js + pascalized in style) return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop; // Try webkit fallback.
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
        return false;
    }
};
// https://caniuse.com/#search=scroll-snap
var $9792a1e08a2d8ad6$var$scrollSnap = {
    supportedProperty: function supportedProperty(prop) {
        if (prop.substring(0, 11) !== 'scroll-snap') return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'ms') return "" + $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prop;
        return prop;
    }
};
// https://caniuse.com/#search=overscroll-behavior
var $9792a1e08a2d8ad6$var$overscrollBehavior = {
    supportedProperty: function supportedProperty(prop) {
        if (prop !== 'overscroll-behavior') return false;
        if ($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js === 'ms') return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + "scroll-chaining";
        return prop;
    }
};
var $9792a1e08a2d8ad6$var$propMap = {
    'flex-grow': 'flex-positive',
    'flex-shrink': 'flex-negative',
    'flex-basis': 'flex-preferred-size',
    'justify-content': 'flex-pack',
    order: 'flex-order',
    'align-items': 'flex-align',
    'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
}; // Support old flex spec from 2012.
var $9792a1e08a2d8ad6$var$flex2012 = {
    supportedProperty: function supportedProperty(prop, style) {
        var newProp = $9792a1e08a2d8ad6$var$propMap[prop];
        if (!newProp) return false;
        return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.js + $9792a1e08a2d8ad6$var$pascalize(newProp) in style ? $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + newProp : false;
    }
};
var $9792a1e08a2d8ad6$var$propMap$1 = {
    flex: 'box-flex',
    'flex-grow': 'box-flex',
    'flex-direction': [
        'box-orient',
        'box-direction'
    ],
    order: 'box-ordinal-group',
    'align-items': 'box-align',
    'flex-flow': [
        'box-orient',
        'box-direction'
    ],
    'justify-content': 'box-pack'
};
var $9792a1e08a2d8ad6$var$propKeys = Object.keys($9792a1e08a2d8ad6$var$propMap$1);
var $9792a1e08a2d8ad6$var$prefixCss = function prefixCss(p) {
    return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + p;
}; // Support old flex spec from 2009.
var $9792a1e08a2d8ad6$var$flex2009 = {
    supportedProperty: function supportedProperty(prop, style, _ref) {
        var multiple = _ref.multiple;
        if ($9792a1e08a2d8ad6$var$propKeys.indexOf(prop) > -1) {
            var newProp = $9792a1e08a2d8ad6$var$propMap$1[prop];
            if (!Array.isArray(newProp)) return $9792a1e08a2d8ad6$export$82e9f45cca5ba907.js + $9792a1e08a2d8ad6$var$pascalize(newProp) in style ? $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + newProp : false;
            if (!multiple) return false;
            for(var i = 0; i < newProp.length; i++){
                if (!($9792a1e08a2d8ad6$export$82e9f45cca5ba907.js + $9792a1e08a2d8ad6$var$pascalize(newProp[0]) in style)) return false;
            }
            return newProp.map($9792a1e08a2d8ad6$var$prefixCss);
        }
        return false;
    }
};
// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'
var $9792a1e08a2d8ad6$var$plugins = [
    $9792a1e08a2d8ad6$var$appearence,
    $9792a1e08a2d8ad6$var$colorAdjust,
    $9792a1e08a2d8ad6$var$mask,
    $9792a1e08a2d8ad6$var$textOrientation,
    $9792a1e08a2d8ad6$var$transform,
    $9792a1e08a2d8ad6$var$transition,
    $9792a1e08a2d8ad6$var$writingMode,
    $9792a1e08a2d8ad6$var$userSelect,
    $9792a1e08a2d8ad6$var$breakPropsOld,
    $9792a1e08a2d8ad6$var$inlineLogicalOld,
    $9792a1e08a2d8ad6$var$unprefixed,
    $9792a1e08a2d8ad6$var$prefixed,
    $9792a1e08a2d8ad6$var$scrollSnap,
    $9792a1e08a2d8ad6$var$overscrollBehavior,
    $9792a1e08a2d8ad6$var$flex2012,
    $9792a1e08a2d8ad6$var$flex2009
];
var $9792a1e08a2d8ad6$var$propertyDetectors = $9792a1e08a2d8ad6$var$plugins.filter(function(p) {
    return p.supportedProperty;
}).map(function(p) {
    return p.supportedProperty;
});
var $9792a1e08a2d8ad6$var$noPrefill = $9792a1e08a2d8ad6$var$plugins.filter(function(p) {
    return p.noPrefill;
}).reduce(function(a, p) {
    a.push.apply(a, (0, $2905eabba6b75ab9$export$2e2bcd8739ae039)(p.noPrefill));
    return a;
}, []);
var $9792a1e08a2d8ad6$var$el;
var $9792a1e08a2d8ad6$var$cache = {};
if (0, $lDq78.default) {
    $9792a1e08a2d8ad6$var$el = document.createElement('p'); // We test every property on vendor prefix requirement.
    // Once tested, result is cached. It gives us up to 70% perf boost.
    // http://jsperf.com/element-style-object-access-vs-plain-object
    //
    // Prefill cache with known css properties to reduce amount of
    // properties we need to feature test at runtime.
    // http://davidwalsh.name/vendor-prefix
    var $9792a1e08a2d8ad6$var$computed = window.getComputedStyle(document.documentElement, '');
    for(var $9792a1e08a2d8ad6$var$key$1 in $9792a1e08a2d8ad6$var$computed)// eslint-disable-next-line no-restricted-globals
    if (!isNaN($9792a1e08a2d8ad6$var$key$1)) $9792a1e08a2d8ad6$var$cache[$9792a1e08a2d8ad6$var$computed[$9792a1e08a2d8ad6$var$key$1]] = $9792a1e08a2d8ad6$var$computed[$9792a1e08a2d8ad6$var$key$1];
     // Properties that cannot be correctly detected using the
    // cache prefill method.
    $9792a1e08a2d8ad6$var$noPrefill.forEach(function(x) {
        return delete $9792a1e08a2d8ad6$var$cache[x];
    });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */ function $9792a1e08a2d8ad6$export$ce097f82c2e4551a(prop, options) {
    if (options === void 0) options = {};
    // For server-side rendering.
    if (!$9792a1e08a2d8ad6$var$el) return prop; // Remove cache for benchmark tests or return property from the cache.
    if ($9792a1e08a2d8ad6$var$cache[prop] != null) return $9792a1e08a2d8ad6$var$cache[prop];
     // Check if 'transition' or 'transform' natively supported in browser.
    if (prop === 'transition' || prop === 'transform') options[prop] = prop in $9792a1e08a2d8ad6$var$el.style;
     // Find a plugin for current prefix property.
    for(var i = 0; i < $9792a1e08a2d8ad6$var$propertyDetectors.length; i++){
        $9792a1e08a2d8ad6$var$cache[prop] = $9792a1e08a2d8ad6$var$propertyDetectors[i](prop, $9792a1e08a2d8ad6$var$el.style, options); // Break loop, if value found.
        if ($9792a1e08a2d8ad6$var$cache[prop]) break;
    } // Reset styles for current property.
    // Firefox can even throw an error for invalid properties, e.g., "0".
    try {
        $9792a1e08a2d8ad6$var$el.style[prop] = '';
    } catch (err) {
        return false;
    }
    return $9792a1e08a2d8ad6$var$cache[prop];
}
var $9792a1e08a2d8ad6$var$cache$1 = {};
var $9792a1e08a2d8ad6$var$transitionProperties = {
    transition: 1,
    'transition-property': 1,
    '-webkit-transition': 1,
    '-webkit-transition-property': 1
};
var $9792a1e08a2d8ad6$var$transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var $9792a1e08a2d8ad6$var$el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */ function $9792a1e08a2d8ad6$var$prefixTransitionCallback(match, p1, p2) {
    if (p1 === 'var') return 'var';
    if (p1 === 'all') return 'all';
    if (p2 === 'all') return ', all';
    var prefixedValue = p1 ? $9792a1e08a2d8ad6$export$ce097f82c2e4551a(p1) : ", " + $9792a1e08a2d8ad6$export$ce097f82c2e4551a(p2);
    if (!prefixedValue) return p1 || p2;
    return prefixedValue;
}
if (0, $lDq78.default) $9792a1e08a2d8ad6$var$el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */ function $9792a1e08a2d8ad6$export$511766124059c277(property, value) {
    // For server-side rendering.
    var prefixedValue = value;
    if (!$9792a1e08a2d8ad6$var$el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
    // We want only prefixable values here.
    // eslint-disable-next-line no-restricted-globals
    if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) return prefixedValue;
     // Create cache key for current value.
    var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
    if ($9792a1e08a2d8ad6$var$cache$1[cacheKey] != null) return $9792a1e08a2d8ad6$var$cache$1[cacheKey];
     // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
    try {
        // Test value as it is.
        $9792a1e08a2d8ad6$var$el$1.style[property] = prefixedValue;
    } catch (err) {
        // Return false if value not supported.
        $9792a1e08a2d8ad6$var$cache$1[cacheKey] = false;
        return false;
    } // If 'transition' or 'transition-property' property.
    if ($9792a1e08a2d8ad6$var$transitionProperties[property]) prefixedValue = prefixedValue.replace($9792a1e08a2d8ad6$var$transPropsRegExp, $9792a1e08a2d8ad6$var$prefixTransitionCallback);
    else if ($9792a1e08a2d8ad6$var$el$1.style[property] === '') {
        // Value with a vendor prefix.
        prefixedValue = $9792a1e08a2d8ad6$export$82e9f45cca5ba907.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
        if (prefixedValue === '-ms-flex') $9792a1e08a2d8ad6$var$el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
        $9792a1e08a2d8ad6$var$el$1.style[property] = prefixedValue; // Return false if value not supported.
        if ($9792a1e08a2d8ad6$var$el$1.style[property] === '') {
            $9792a1e08a2d8ad6$var$cache$1[cacheKey] = false;
            return false;
        }
    } // Reset styles for current property.
    $9792a1e08a2d8ad6$var$el$1.style[property] = ''; // Write current value to cache.
    $9792a1e08a2d8ad6$var$cache$1[cacheKey] = prefixedValue;
    return $9792a1e08a2d8ad6$var$cache$1[cacheKey];
}



var $l5EDh = parcelRequire("l5EDh");
/**
 * Add vendor prefix to a property name when needed.
 */ function $cae2f5c4857cd055$var$jssVendorPrefixer() {
    function onProcessRule(rule) {
        if (rule.type === 'keyframes') {
            var atRule = rule;
            atRule.at = (0, $9792a1e08a2d8ad6$export$b6aa0648d950180a)(atRule.at);
        }
    }
    function prefixStyle(style) {
        for(var prop in style){
            var value = style[prop];
            if (prop === 'fallbacks' && Array.isArray(value)) {
                style[prop] = value.map(prefixStyle);
                continue;
            }
            var changeProp = false;
            var supportedProp = (0, $9792a1e08a2d8ad6$export$ce097f82c2e4551a)(prop);
            if (supportedProp && supportedProp !== prop) changeProp = true;
            var changeValue = false;
            var supportedValue$1 = (0, $9792a1e08a2d8ad6$export$511766124059c277)(supportedProp, (0, $l5EDh.toCssValue)(value));
            if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
            if (changeProp || changeValue) {
                if (changeProp) delete style[prop];
                style[supportedProp || prop] = supportedValue$1 || value;
            }
        }
        return style;
    }
    function onProcessStyle(style, rule) {
        if (rule.type !== 'style') return style;
        return prefixStyle(style);
    }
    function onChangeValue(value, prop) {
        return (0, $9792a1e08a2d8ad6$export$511766124059c277)(prop, (0, $l5EDh.toCssValue)(value)) || value;
    }
    return {
        onProcessRule: onProcessRule,
        onProcessStyle: onProcessStyle,
        onChangeValue: onChangeValue
    };
}
var $cae2f5c4857cd055$export$2e2bcd8739ae039 = $cae2f5c4857cd055$var$jssVendorPrefixer;


/**
 * Sort props by length.
 */ function $27c45a51f5c9e889$var$jssPropsSort() {
    var sort = function sort(prop0, prop1) {
        if (prop0.length === prop1.length) return prop0 > prop1 ? 1 : -1;
        return prop0.length - prop1.length;
    };
    return {
        onProcessStyle: function onProcessStyle(style, rule) {
            if (rule.type !== 'style') return style;
            var newStyle = {};
            var props = Object.keys(style).sort(sort);
            for(var i = 0; i < props.length; i++)newStyle[props[i]] = style[props[i]];
            return newStyle;
        }
    };
}
var $27c45a51f5c9e889$export$2e2bcd8739ae039 = $27c45a51f5c9e889$var$jssPropsSort;


function $67ef801c77383e55$export$2e2bcd8739ae039() {
    return {
        plugins: [
            (0, $11c405024852272d$export$2e2bcd8739ae039)(),
            (0, $772622bba3f3411a$export$2e2bcd8739ae039)(),
            (0, $0648a61fa7afaef3$export$2e2bcd8739ae039)(),
            (0, $a277082344b255b4$export$2e2bcd8739ae039)(),
            (0, $80c24183cdb905d9$export$2e2bcd8739ae039)(),
            // This way, we can get a performance boost.
            // In the documentation, we are using `autoprefixer` to solve this problem.
            typeof window === 'undefined' ? null : (0, $cae2f5c4857cd055$export$2e2bcd8739ae039)(),
            (0, $27c45a51f5c9e889$export$2e2bcd8739ae039)()
        ]
    };
}


var $659289dd5c87c2d9$var$jss = (0, $l5EDh.create)((0, $67ef801c77383e55$export$2e2bcd8739ae039)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.
var $659289dd5c87c2d9$var$generateClassName = (0, $40b2a7d9d2ba3ceb$export$2e2bcd8739ae039)(); // Exported for test purposes
var $659289dd5c87c2d9$export$70a8aea9ff58d1cd = new Map();
var $659289dd5c87c2d9$var$defaultOptions = {
    disableGeneration: false,
    generateClassName: $659289dd5c87c2d9$var$generateClassName,
    jss: $659289dd5c87c2d9$var$jss,
    sheetsCache: null,
    sheetsManager: $659289dd5c87c2d9$export$70a8aea9ff58d1cd,
    sheetsRegistry: null
};
var $659289dd5c87c2d9$export$f4de434b269fe487 = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext($659289dd5c87c2d9$var$defaultOptions);
var $659289dd5c87c2d9$var$injectFirstNode;
function $659289dd5c87c2d9$export$2e2bcd8739ae039(props) {
    var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(props, [
        "children",
        "injectFirst",
        "disableGeneration"
    ]);
    var outerOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useContext($659289dd5c87c2d9$export$f4de434b269fe487);
    var context = (0, $eR4tV.default)({}, outerOptions, {
        disableGeneration: disableGeneration
    }, localOptions);
    if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
        if (!$659289dd5c87c2d9$var$injectFirstNode) {
            var head = document.head;
            $659289dd5c87c2d9$var$injectFirstNode = document.createComment('mui-inject-first');
            head.insertBefore($659289dd5c87c2d9$var$injectFirstNode, head.firstChild);
        }
        context.jss = (0, $l5EDh.create)({
            plugins: (0, $67ef801c77383e55$export$2e2bcd8739ae039)().plugins,
            insertionPoint: $659289dd5c87c2d9$var$injectFirstNode
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement($659289dd5c87c2d9$export$f4de434b269fe487.Provider, {
        value: context
    }, children);
}


/* eslint-disable import/prefer-default-export */ // Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var $253914fcf3b7ac62$var$indexCounter = -1000000000;
function $253914fcf3b7ac62$export$a2647aa13413c947() {
    $253914fcf3b7ac62$var$indexCounter += 1;
    return $253914fcf3b7ac62$var$indexCounter;
}



var $eR4tV = parcelRequire("eR4tV");
parcelRequire("k0ffe");

var $eR4tV = parcelRequire("eR4tV");

var $k0ffe = parcelRequire("k0ffe");
function $c5a49a164fa2421a$export$53b83ca8eaab0383(item) {
    return item && (0, $k0ffe.default)(item) === 'object' && item.constructor === Object;
}
function $c5a49a164fa2421a$export$2e2bcd8739ae039(target, source) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        clone: true
    };
    var output = options.clone ? (0, $eR4tV.default)({}, target) : target;
    if ($c5a49a164fa2421a$export$53b83ca8eaab0383(target) && $c5a49a164fa2421a$export$53b83ca8eaab0383(source)) Object.keys(source).forEach(function(key) {
        // Avoid prototype pollution
        if (key === '__proto__') return;
        if ($c5a49a164fa2421a$export$53b83ca8eaab0383(source[key]) && key in target) output[key] = $c5a49a164fa2421a$export$2e2bcd8739ae039(target[key], source[key], options);
        else output[key] = source[key];
    });
    return output;
}



function $d72f71d8a10d4722$export$2e2bcd8739ae039(stylesOrCreator) {
    var themingEnabled = typeof stylesOrCreator === 'function';
    return {
        create: function create(theme, name) {
            var styles;
            try {
                styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
            } catch (err) {
                throw err;
            }
            if (!name || !theme.overrides || !theme.overrides[name]) return styles;
            var overrides = theme.overrides[name];
            var stylesWithOverrides = (0, $eR4tV.default)({}, styles);
            Object.keys(overrides).forEach(function(key) {
                stylesWithOverrides[key] = (0, $c5a49a164fa2421a$export$2e2bcd8739ae039)(stylesWithOverrides[key], overrides[key]);
            });
            return stylesWithOverrides;
        },
        options: {}
    };
}


// We use the same empty object to ref count the styles that don't need a theme object.
var $77d9b80ddb9ec1de$var$noopTheme = {};
var $77d9b80ddb9ec1de$export$2e2bcd8739ae039 = $77d9b80ddb9ec1de$var$noopTheme;


function $8b8b403817df405f$var$getClasses(_ref, classes, Component) {
    var state = _ref.state, stylesOptions = _ref.stylesOptions;
    if (stylesOptions.disableGeneration) return classes || {};
    if (!state.cacheClasses) state.cacheClasses = {
        // Cache for the finalized classes value.
        value: null,
        // Cache for the last used classes prop pointer.
        lastProp: null,
        // Cache for the last used rendered classes pointer.
        lastJSS: {}
    };
     // Tracks if either the rendered classes or classes prop has changed,
    // requiring the generation of a new finalized classes object.
    var generate = false;
    if (state.classes !== state.cacheClasses.lastJSS) {
        state.cacheClasses.lastJSS = state.classes;
        generate = true;
    }
    if (classes !== state.cacheClasses.lastProp) {
        state.cacheClasses.lastProp = classes;
        generate = true;
    }
    if (generate) state.cacheClasses.value = (0, $420dbfb5f7d724c2$export$2e2bcd8739ae039)({
        baseClasses: state.cacheClasses.lastJSS,
        newClasses: classes,
        Component: Component
    });
    return state.cacheClasses.value;
}
function $8b8b403817df405f$var$attach(_ref2, props) {
    var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $975d08610f0a2640$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    if (!sheetManager) {
        sheetManager = {
            refs: 0,
            staticSheet: null,
            dynamicStyles: null
        };
        (0, $975d08610f0a2640$export$2e2bcd8739ae039).set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
    }
    var options = (0, $eR4tV.default)({}, stylesCreator.options, stylesOptions, {
        theme: theme,
        flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
    });
    options.generateId = options.serverGenerateClassName || options.generateClassName;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        var staticSheet;
        if (stylesOptions.sheetsCache) staticSheet = (0, $975d08610f0a2640$export$2e2bcd8739ae039).get(stylesOptions.sheetsCache, stylesCreator, theme);
        var styles = stylesCreator.create(theme, name);
        if (!staticSheet) {
            staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, $eR4tV.default)({
                link: false
            }, options));
            staticSheet.attach();
            if (stylesOptions.sheetsCache) (0, $975d08610f0a2640$export$2e2bcd8739ae039).set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
        }
        if (sheetsRegistry) sheetsRegistry.add(staticSheet);
        sheetManager.staticSheet = staticSheet;
        sheetManager.dynamicStyles = (0, $l5EDh.getDynamicStyles)(styles);
    }
    if (sheetManager.dynamicStyles) {
        var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, $eR4tV.default)({
            link: true
        }, options));
        dynamicSheet.update(props);
        dynamicSheet.attach();
        state.dynamicSheet = dynamicSheet;
        state.classes = (0, $420dbfb5f7d724c2$export$2e2bcd8739ae039)({
            baseClasses: sheetManager.staticSheet.classes,
            newClasses: dynamicSheet.classes
        });
        if (sheetsRegistry) sheetsRegistry.add(dynamicSheet);
    } else state.classes = sheetManager.staticSheet.classes;
    sheetManager.refs += 1;
}
function $8b8b403817df405f$var$update(_ref3, props) {
    var state = _ref3.state;
    if (state.dynamicSheet) state.dynamicSheet.update(props);
}
function $8b8b403817df405f$var$detach(_ref4) {
    var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
    if (stylesOptions.disableGeneration) return;
    var sheetManager = (0, $975d08610f0a2640$export$2e2bcd8739ae039).get(stylesOptions.sheetsManager, stylesCreator, theme);
    sheetManager.refs -= 1;
    var sheetsRegistry = stylesOptions.sheetsRegistry;
    if (sheetManager.refs === 0) {
        (0, $975d08610f0a2640$export$2e2bcd8739ae039).delete(stylesOptions.sheetsManager, stylesCreator, theme);
        stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
        if (sheetsRegistry) sheetsRegistry.remove(sheetManager.staticSheet);
    }
    if (state.dynamicSheet) {
        stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
        if (sheetsRegistry) sheetsRegistry.remove(state.dynamicSheet);
    }
}
function $8b8b403817df405f$var$useSynchronousEffect(func, values) {
    var key = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useRef([]);
    var output; // Store "generation" key. Just returns a new object every time
    var currentKey = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useMemo(function() {
        return {};
    }, values); // eslint-disable-line react-hooks/exhaustive-deps
    // "the first render", or "memo dropped the value"
    if (key.current !== currentKey) {
        key.current = currentKey;
        output = func();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useEffect(function() {
        return function() {
            if (output) output();
        };
    }, [
        currentKey
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
}
function $8b8b403817df405f$export$2e2bcd8739ae039(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? (0, $77d9b80ddb9ec1de$export$2e2bcd8739ae039) : _options$defaultTheme, stylesOptions2 = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(options, [
        "name",
        "classNamePrefix",
        "Component",
        "defaultTheme"
    ]);
    var stylesCreator = (0, $d72f71d8a10d4722$export$2e2bcd8739ae039)(stylesOrCreator);
    var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
    stylesCreator.options = {
        index: (0, $253914fcf3b7ac62$export$a2647aa13413c947)(),
        name: name,
        meta: classNamePrefix,
        classNamePrefix: classNamePrefix
    };
    var useStyles = function useStyles() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var theme = (0, $fe3cbcbcc4b394ba$export$2e2bcd8739ae039)() || defaultTheme;
        var stylesOptions = (0, $eR4tV.default)({}, (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useContext((0, $659289dd5c87c2d9$export$f4de434b269fe487)), stylesOptions2);
        var instance = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useRef();
        var shouldUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useRef();
        $8b8b403817df405f$var$useSynchronousEffect(function() {
            var current = {
                name: name,
                state: {},
                stylesCreator: stylesCreator,
                stylesOptions: stylesOptions,
                theme: theme
            };
            $8b8b403817df405f$var$attach(current, props);
            shouldUpdate.current = false;
            instance.current = current;
            return function() {
                $8b8b403817df405f$var$detach(current);
            };
        }, [
            theme,
            stylesCreator
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useEffect(function() {
            if (shouldUpdate.current) $8b8b403817df405f$var$update(instance.current, props);
            shouldUpdate.current = true;
        });
        var classes = $8b8b403817df405f$var$getClasses(instance.current, props.classes, Component);
        return classes;
    };
    return useStyles;
}


/* eslint-disable no-restricted-syntax */ function $25edeee17645807c$export$2e2bcd8739ae039(params) {
    var theme = params.theme, name = params.name, props = params.props;
    if (!theme || !theme.props || !theme.props[name]) return props;
     // Resolve default props, code borrow from React source.
    // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
    var defaultProps = theme.props[name];
    var propName;
    for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
    return props;
}



// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.
var $cf78fbceb0e88663$var$withStyles = function withStyles(stylesOrCreator) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(Component) {
        var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(options, [
            "defaultTheme",
            "withTheme",
            "name"
        ]);
        var classNamePrefix = name;
        var displayName;
        var useStyles = (0, $8b8b403817df405f$export$2e2bcd8739ae039)(stylesOrCreator, (0, $eR4tV.default)({
            defaultTheme: defaultTheme,
            Component: Component,
            name: name || Component.displayName,
            classNamePrefix: classNamePrefix
        }, stylesOptions));
        var WithStyles = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function WithStyles(props, ref) {
            var classesProp = props.classes, innerRef = props.innerRef, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(props, [
                "classes",
                "innerRef"
            ]); // The wrapper receives only user supplied props, which could be a subset of
            // the actual props Component might receive due to merging with defaultProps.
            // So copying it here would give us the same result in the wrapper as well.
            var classes = useStyles((0, $eR4tV.default)({}, Component.defaultProps, props));
            var theme;
            var more = other;
            if (typeof name === 'string' || withTheme) {
                // name and withTheme are invariant in the outer scope
                // eslint-disable-next-line react-hooks/rules-of-hooks
                theme = (0, $fe3cbcbcc4b394ba$export$2e2bcd8739ae039)() || defaultTheme;
                if (name) more = (0, $25edeee17645807c$export$2e2bcd8739ae039)({
                    theme: theme,
                    name: name,
                    props: other
                });
                 // Provide the theme to the wrapped component.
                // So we don't have to use the `withTheme()` Higher-order Component.
                if (withTheme && !more.theme) more.theme = theme;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $eR4tV.default)({
                ref: innerRef || ref,
                classes: classes
            }, more));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4Djfw)))(WithStyles, Component);
        return WithStyles;
    };
};
var $cf78fbceb0e88663$export$2e2bcd8739ae039 = $cf78fbceb0e88663$var$withStyles;



var $kVTLm = parcelRequire("kVTLm");
function $767c462feeb9a501$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $kVTLm.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}





var $eR4tV = parcelRequire("eR4tV");

var $ca76f9f29c766ebf$export$ed97f33186d4b816 = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]; // Keep in mind that @media is inclusive by the CSS specification.
function $ca76f9f29c766ebf$export$2e2bcd8739ae039(breakpoints) {
    var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920
    } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(breakpoints, [
        "values",
        "unit",
        "step"
    ]);
    function up(key) {
        var value = typeof values[key] === 'number' ? values[key] : key;
        return "@media (min-width:".concat(value).concat(unit, ")");
    }
    function down(key) {
        var endIndex = $ca76f9f29c766ebf$export$ed97f33186d4b816.indexOf(key) + 1;
        var upperbound = values[$ca76f9f29c766ebf$export$ed97f33186d4b816[endIndex]];
        if (endIndex === $ca76f9f29c766ebf$export$ed97f33186d4b816.length) // xl down applies to all sizes
        return up('xs');
        var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
        return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
    }
    function between(start, end) {
        var endIndex = $ca76f9f29c766ebf$export$ed97f33186d4b816.indexOf(end);
        if (endIndex === $ca76f9f29c766ebf$export$ed97f33186d4b816.length - 1) return up(start);
        return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[$ca76f9f29c766ebf$export$ed97f33186d4b816[endIndex + 1]] === 'number' ? values[$ca76f9f29c766ebf$export$ed97f33186d4b816[endIndex + 1]] : end) - step / 100).concat(unit, ")");
    }
    function only(key) {
        return between(key, key);
    }
    var warnedOnce = false;
    function width(key) {
        return values[key];
    }
    return (0, $eR4tV.default)({
        keys: $ca76f9f29c766ebf$export$ed97f33186d4b816,
        values: values,
        up: up,
        down: down,
        between: between,
        only: only,
        width: width
    }, other);
}




var $eR4tV = parcelRequire("eR4tV");
function $cb259a70b7d4e458$export$2e2bcd8739ae039(breakpoints, spacing, mixins) {
    var _toolbar;
    return (0, $eR4tV.default)({
        gutters: function gutters() {
            var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            console.warn([
                'Material-UI: theme.mixins.gutters() is deprecated.',
                'You can use the source of the mixin directly:',
                "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "
            ].join('\n'));
            return (0, $eR4tV.default)({
                paddingLeft: spacing(2),
                paddingRight: spacing(2)
            }, styles, (0, $767c462feeb9a501$export$2e2bcd8739ae039)({}, breakpoints.up('sm'), (0, $eR4tV.default)({
                paddingLeft: spacing(3),
                paddingRight: spacing(3)
            }, styles[breakpoints.up('sm')])));
        },
        toolbar: (_toolbar = {
            minHeight: 56
        }, (0, $767c462feeb9a501$export$2e2bcd8739ae039)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
            minHeight: 48
        }), (0, $767c462feeb9a501$export$2e2bcd8739ae039)(_toolbar, breakpoints.up('sm'), {
            minHeight: 64
        }), _toolbar)
    }, mixins);
}



var $eR4tV = parcelRequire("eR4tV");

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */ function $36ea5f142d2ea750$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe iff we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ var url = 'https://mui.com/production-error/?code=' + code;
    for(var i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }


var $7eafa24db89d581e$var$common = {
    black: '#000',
    white: '#fff'
};
var $7eafa24db89d581e$export$2e2bcd8739ae039 = $7eafa24db89d581e$var$common;


var $f26764bd7530da5f$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#d5d5d5',
    A200: '#aaaaaa',
    A400: '#303030',
    A700: '#616161'
};
var $f26764bd7530da5f$export$2e2bcd8739ae039 = $f26764bd7530da5f$var$grey;


var $da404e91532ef4f5$var$indigo = {
    50: '#e8eaf6',
    100: '#c5cae9',
    200: '#9fa8da',
    300: '#7986cb',
    400: '#5c6bc0',
    500: '#3f51b5',
    600: '#3949ab',
    700: '#303f9f',
    800: '#283593',
    900: '#1a237e',
    A100: '#8c9eff',
    A200: '#536dfe',
    A400: '#3d5afe',
    A700: '#304ffe'
};
var $da404e91532ef4f5$export$2e2bcd8739ae039 = $da404e91532ef4f5$var$indigo;


var $b0794645b1c957de$var$pink = {
    50: '#fce4ec',
    100: '#f8bbd0',
    200: '#f48fb1',
    300: '#f06292',
    400: '#ec407a',
    500: '#e91e63',
    600: '#d81b60',
    700: '#c2185b',
    800: '#ad1457',
    900: '#880e4f',
    A100: '#ff80ab',
    A200: '#ff4081',
    A400: '#f50057',
    A700: '#c51162'
};
var $b0794645b1c957de$export$2e2bcd8739ae039 = $b0794645b1c957de$var$pink;


var $7e32f15daf9dbf76$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $7e32f15daf9dbf76$export$2e2bcd8739ae039 = $7e32f15daf9dbf76$var$red;


var $11c3f7f50ddc482e$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $11c3f7f50ddc482e$export$2e2bcd8739ae039 = $11c3f7f50ddc482e$var$orange;


var $aa9a40caaac2dbd8$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $aa9a40caaac2dbd8$export$2e2bcd8739ae039 = $aa9a40caaac2dbd8$var$blue;


var $7bac0601c1cdf911$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $7bac0601c1cdf911$export$2e2bcd8739ae039 = $7bac0601c1cdf911$var$green;



/* eslint-disable no-use-before-define */ /**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $65a40c6bd53abec5$var$clamp(value) {
    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.min(Math.max(min, value), max);
}
function $65a40c6bd53abec5$export$5a544e13ad4e1fa5(color) {
    color = color.substr(1);
    var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
    var colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map(function(n) {
        return n + n;
    });
    return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function(n, index) {
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', '), ")") : '';
}
function $65a40c6bd53abec5$var$intToHex(int) {
    var hex = int.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
}
function $65a40c6bd53abec5$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    var _decomposeColor = $65a40c6bd53abec5$export$677b39864803984e(color), values = _decomposeColor.values;
    return "#".concat(values.map(function(n) {
        return $65a40c6bd53abec5$var$intToHex(n);
    }).join(''));
}
function $65a40c6bd53abec5$export$29fb7152bd3f781a(color) {
    color = $65a40c6bd53abec5$export$677b39864803984e(color);
    var _color = color, values = _color.values;
    var h = values[0];
    var s = values[1] / 100;
    var l = values[2] / 100;
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
        return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    };
    var type = 'rgb';
    var rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $65a40c6bd53abec5$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $65a40c6bd53abec5$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $65a40c6bd53abec5$export$677b39864803984e($65a40c6bd53abec5$export$5a544e13ad4e1fa5(color));
    var marker = color.indexOf('(');
    var type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla'
    ].indexOf(type) === -1) throw new Error((0, $36ea5f142d2ea750$export$2e2bcd8739ae039)(3, color));
    var values = color.substring(marker + 1, color.length - 1).split(',');
    values = values.map(function(value) {
        return parseFloat(value);
    });
    return {
        type: type,
        values: values
    };
}
function $65a40c6bd53abec5$export$211a73f2b8c10ce4(color) {
    var type = color.type;
    var values = color.values;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function(n, i) {
        return i < 3 ? parseInt(n, 10) : n;
    });
    else if (type.indexOf('hsl') !== -1) {
        values[1] = "".concat(values[1], "%");
        values[2] = "".concat(values[2], "%");
    }
    return "".concat(type, "(").concat(values.join(', '), ")");
}
function $65a40c6bd53abec5$export$d061e26956a60b0a(foreground, background) {
    var lumA = $65a40c6bd53abec5$export$c852d90bf7403b62(foreground);
    var lumB = $65a40c6bd53abec5$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $65a40c6bd53abec5$export$c852d90bf7403b62(color) {
    color = $65a40c6bd53abec5$export$677b39864803984e(color);
    var rgb = color.type === 'hsl' ? $65a40c6bd53abec5$export$677b39864803984e($65a40c6bd53abec5$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map(function(val) {
        val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $65a40c6bd53abec5$export$e665714f76e581fd(color) {
    var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
    return $65a40c6bd53abec5$export$c852d90bf7403b62(color) > 0.5 ? $65a40c6bd53abec5$export$4b073707ff63303(color, coefficient) : $65a40c6bd53abec5$export$c0816ed86df316af(color, coefficient);
}
var $65a40c6bd53abec5$var$warnedOnce = false;
function $65a40c6bd53abec5$export$cbea29d068a2e18f(color, value) {
    return $65a40c6bd53abec5$export$58f0f39f63f3cf42(color, value);
}
function $65a40c6bd53abec5$export$58f0f39f63f3cf42(color, value) {
    color = $65a40c6bd53abec5$export$677b39864803984e(color);
    value = $65a40c6bd53abec5$var$clamp(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    color.values[3] = value;
    return $65a40c6bd53abec5$export$211a73f2b8c10ce4(color);
}
function $65a40c6bd53abec5$export$4b073707ff63303(color, coefficient) {
    color = $65a40c6bd53abec5$export$677b39864803984e(color);
    coefficient = $65a40c6bd53abec5$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $65a40c6bd53abec5$export$211a73f2b8c10ce4(color);
}
function $65a40c6bd53abec5$export$c0816ed86df316af(color, coefficient) {
    color = $65a40c6bd53abec5$export$677b39864803984e(color);
    coefficient = $65a40c6bd53abec5$var$clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(var i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    return $65a40c6bd53abec5$export$211a73f2b8c10ce4(color);
}


var $6867604e4e179d24$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.54)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)',
        // Text hints.
        hint: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $7eafa24db89d581e$export$2e2bcd8739ae039).white,
        default: (0, $f26764bd7530da5f$export$2e2bcd8739ae039)[50]
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
var $6867604e4e179d24$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $7eafa24db89d581e$export$2e2bcd8739ae039).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        hint: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: (0, $f26764bd7530da5f$export$2e2bcd8739ae039)[800],
        default: '#303030'
    },
    action: {
        active: (0, $7eafa24db89d581e$export$2e2bcd8739ae039).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $6867604e4e179d24$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    var tonalOffsetLight = tonalOffset.light || tonalOffset;
    var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $65a40c6bd53abec5$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $65a40c6bd53abec5$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $6867604e4e179d24$export$2e2bcd8739ae039(palette) {
    var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
        light: (0, $da404e91532ef4f5$export$2e2bcd8739ae039)[300],
        main: (0, $da404e91532ef4f5$export$2e2bcd8739ae039)[500],
        dark: (0, $da404e91532ef4f5$export$2e2bcd8739ae039)[700]
    } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
        light: (0, $b0794645b1c957de$export$2e2bcd8739ae039).A200,
        main: (0, $b0794645b1c957de$export$2e2bcd8739ae039).A400,
        dark: (0, $b0794645b1c957de$export$2e2bcd8739ae039).A700
    } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
        light: (0, $7e32f15daf9dbf76$export$2e2bcd8739ae039)[300],
        main: (0, $7e32f15daf9dbf76$export$2e2bcd8739ae039)[500],
        dark: (0, $7e32f15daf9dbf76$export$2e2bcd8739ae039)[700]
    } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
        light: (0, $11c3f7f50ddc482e$export$2e2bcd8739ae039)[300],
        main: (0, $11c3f7f50ddc482e$export$2e2bcd8739ae039)[500],
        dark: (0, $11c3f7f50ddc482e$export$2e2bcd8739ae039)[700]
    } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
        light: (0, $aa9a40caaac2dbd8$export$2e2bcd8739ae039)[300],
        main: (0, $aa9a40caaac2dbd8$export$2e2bcd8739ae039)[500],
        dark: (0, $aa9a40caaac2dbd8$export$2e2bcd8739ae039)[700]
    } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
        light: (0, $7bac0601c1cdf911$export$2e2bcd8739ae039)[300],
        main: (0, $7bac0601c1cdf911$export$2e2bcd8739ae039)[500],
        dark: (0, $7bac0601c1cdf911$export$2e2bcd8739ae039)[700]
    } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? 'light' : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(palette, [
        "primary",
        "secondary",
        "error",
        "warning",
        "info",
        "success",
        "type",
        "contrastThreshold",
        "tonalOffset"
    ]); // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        var contrastText = (0, $65a40c6bd53abec5$export$d061e26956a60b0a)(background, $6867604e4e179d24$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $6867604e4e179d24$export$55ce6f3a06c59543.text.primary : $6867604e4e179d24$export$a43af521ac8c3202.text.primary;
        var contrast;
        return contrastText;
    }
    var augmentColor = function augmentColor(color) {
        var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
        var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
        var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
        color = (0, $eR4tV.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.main) throw new Error((0, $36ea5f142d2ea750$export$2e2bcd8739ae039)(4, mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $36ea5f142d2ea750$export$2e2bcd8739ae039)(5, JSON.stringify(color.main)));
        $6867604e4e179d24$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $6867604e4e179d24$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    var types = {
        dark: $6867604e4e179d24$export$55ce6f3a06c59543,
        light: $6867604e4e179d24$export$a43af521ac8c3202
    };
    var paletteOutput = (0, $c5a49a164fa2421a$export$2e2bcd8739ae039)((0, $eR4tV.default)({
        // A collection of common colors.
        common: (0, $7eafa24db89d581e$export$2e2bcd8739ae039),
        // The palette type, can be light or dark.
        type: type,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor(primary),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor(error),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor(warning),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor(info),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor(success),
        // The grey colors.
        grey: (0, $f26764bd7530da5f$export$2e2bcd8739ae039),
        // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold: contrastThreshold,
        // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText: getContrastText,
        // Generate a rich color object.
        augmentColor: augmentColor,
        // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset: tonalOffset
    }, types[type]), other);
    return paletteOutput;
}



var $eR4tV = parcelRequire("eR4tV");


function $ffcf1dc87389e227$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
var $ffcf1dc87389e227$var$warnedOnce = false;
function $ffcf1dc87389e227$var$roundWithDeprecationWarning(value) {
    return $ffcf1dc87389e227$var$round(value);
}
var $ffcf1dc87389e227$var$caseAllCaps = {
    textTransform: 'uppercase'
};
var $ffcf1dc87389e227$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $ffcf1dc87389e227$export$2e2bcd8739ae039(palette, typography) {
    var _ref = typeof typography === 'function' ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? $ffcf1dc87389e227$var$defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(_ref, [
        "fontFamily",
        "fontSize",
        "fontWeightLight",
        "fontWeightRegular",
        "fontWeightMedium",
        "fontWeightBold",
        "htmlFontSize",
        "allVariants",
        "pxToRem"
    ]);
    var coef = fontSize / 14;
    var pxToRem = pxToRem2 || function(size) {
        return "".concat(size / htmlFontSize * coef, "rem");
    };
    var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
        return (0, $eR4tV.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight: lineHeight
        }, fontFamily === $ffcf1dc87389e227$var$defaultFontFamily ? {
            letterSpacing: "".concat($ffcf1dc87389e227$var$round(letterSpacing / size), "em")
        } : {}, casing, allVariants);
    };
    var variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $ffcf1dc87389e227$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $ffcf1dc87389e227$var$caseAllCaps)
    };
    return (0, $c5a49a164fa2421a$export$2e2bcd8739ae039)((0, $eR4tV.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        round: $ffcf1dc87389e227$var$roundWithDeprecationWarning,
        // TODO v5: remove
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


var $f95cadb7dc9682d3$var$shadowKeyUmbraOpacity = 0.2;
var $f95cadb7dc9682d3$var$shadowKeyPenumbraOpacity = 0.14;
var $f95cadb7dc9682d3$var$shadowAmbientShadowOpacity = 0.12;
function $f95cadb7dc9682d3$var$createShadow() {
    return [
        "".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat($f95cadb7dc9682d3$var$shadowKeyUmbraOpacity, ")"),
        "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat($f95cadb7dc9682d3$var$shadowKeyPenumbraOpacity, ")"),
        "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat($f95cadb7dc9682d3$var$shadowAmbientShadowOpacity, ")")
    ].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
var $f95cadb7dc9682d3$var$shadows = [
    'none',
    $f95cadb7dc9682d3$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $f95cadb7dc9682d3$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $f95cadb7dc9682d3$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $f95cadb7dc9682d3$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $f95cadb7dc9682d3$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $f95cadb7dc9682d3$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $f95cadb7dc9682d3$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $f95cadb7dc9682d3$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $f95cadb7dc9682d3$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $f95cadb7dc9682d3$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $f95cadb7dc9682d3$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $f95cadb7dc9682d3$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $f95cadb7dc9682d3$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $f95cadb7dc9682d3$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $f95cadb7dc9682d3$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $f95cadb7dc9682d3$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $f95cadb7dc9682d3$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $f95cadb7dc9682d3$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $f95cadb7dc9682d3$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $f95cadb7dc9682d3$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $f95cadb7dc9682d3$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $f95cadb7dc9682d3$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $f95cadb7dc9682d3$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $f95cadb7dc9682d3$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $f95cadb7dc9682d3$export$2e2bcd8739ae039 = $f95cadb7dc9682d3$var$shadows;


var $cc48399d9c802693$var$shape = {
    borderRadius: 4
};
var $cc48399d9c802693$export$2e2bcd8739ae039 = $cc48399d9c802693$var$shape;


function $d9cc1c09fbf51bad$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $1e2a846e624396a6$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $9faea1cd2f002071$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $16928d8f77bbb3ea$export$2e2bcd8739ae039(r, e) {
    return (0, $d9cc1c09fbf51bad$export$2e2bcd8739ae039)(r) || (0, $1e2a846e624396a6$export$2e2bcd8739ae039)(r, e) || (0, $7715ec4682011719$export$2e2bcd8739ae039)(r, e) || (0, $9faea1cd2f002071$export$2e2bcd8739ae039)();
}





var $eR4tV = parcelRequire("eR4tV");

var $k0ffe = parcelRequire("k0ffe");


function $7a9e3fb1055d6e2e$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $c5a49a164fa2421a$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $7a9e3fb1055d6e2e$export$2e2bcd8739ae039 = $7a9e3fb1055d6e2e$var$merge;


// For instance with the first breakpoint xs: [xs, sm[.
var $f1bc18ddb2006d57$var$values = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
};
var $f1bc18ddb2006d57$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: function up(key) {
        return "@media (min-width:".concat($f1bc18ddb2006d57$var$values[key], "px)");
    }
};
function $f1bc18ddb2006d57$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    if (Array.isArray(propValue)) {
        var themeBreakpoints = props.theme.breakpoints || $f1bc18ddb2006d57$var$defaultBreakpoints;
        return propValue.reduce(function(acc, item, index) {
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if ((0, $k0ffe.default)(propValue) === 'object') {
        var _themeBreakpoints = props.theme.breakpoints || $f1bc18ddb2006d57$var$defaultBreakpoints;
        return Object.keys(propValue).reduce(function(acc, breakpoint) {
            acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
            return acc;
        }, {});
    }
    var output = styleFromPropValue(propValue);
    return output;
}
function $f1bc18ddb2006d57$var$breakpoints(styleFunction) {
    var newStyleFunction = function newStyleFunction(props) {
        var base = styleFunction(props);
        var themeBreakpoints = props.theme.breakpoints || $f1bc18ddb2006d57$var$defaultBreakpoints;
        var extended = themeBreakpoints.keys.reduce(function(acc, key) {
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $eR4tV.default)({
                    theme: props.theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $7a9e3fb1055d6e2e$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ].concat((0, $2905eabba6b75ab9$export$2e2bcd8739ae039)(styleFunction.filterProps));
    return newStyleFunction;
}
var $f1bc18ddb2006d57$export$2e2bcd8739ae039 = $f1bc18ddb2006d57$var$breakpoints;



function $497c8a210e2778e9$export$2e2bcd8739ae039(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $6847639651697eb2$var$properties = {
    m: 'margin',
    p: 'padding'
};
var $6847639651697eb2$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
var $6847639651697eb2$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
var $6847639651697eb2$var$getCssProperties = (0, $497c8a210e2778e9$export$2e2bcd8739ae039)(function(prop) {
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($6847639651697eb2$var$aliases[prop]) prop = $6847639651697eb2$var$aliases[prop];
        else return [
            prop
        ];
    }
    var _prop$split = prop.split(''), _prop$split2 = (0, $16928d8f77bbb3ea$export$2e2bcd8739ae039)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
    var property = $6847639651697eb2$var$properties[a];
    var direction = $6847639651697eb2$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map(function(dir) {
        return property + dir;
    }) : [
        property + direction
    ];
});
var $6847639651697eb2$var$spacingKeys = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY'
];
function $6847639651697eb2$export$1def6f833384e3d1(theme) {
    var themeSpacing = theme.spacing || 8;
    if (typeof themeSpacing === 'number') return function(abs) {
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return function(abs) {
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return function() {
        return undefined;
    };
}
function $6847639651697eb2$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    var abs = Math.abs(propValue);
    var transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return "-".concat(transformed);
}
function $6847639651697eb2$var$getStyleFromPropValue(cssProperties, transformer) {
    return function(propValue) {
        return cssProperties.reduce(function(acc, cssProperty) {
            acc[cssProperty] = $6847639651697eb2$var$getValue(transformer, propValue);
            return acc;
        }, {});
    };
}
function $6847639651697eb2$var$spacing(props) {
    var theme = props.theme;
    var transformer = $6847639651697eb2$export$1def6f833384e3d1(theme);
    return Object.keys(props).map(function(prop) {
        // Using a hash computation over an array iteration could be faster, but with only 28 items,
        // it's doesn't worth the bundle size.
        if ($6847639651697eb2$var$spacingKeys.indexOf(prop) === -1) return null;
        var cssProperties = $6847639651697eb2$var$getCssProperties(prop);
        var styleFromPropValue = $6847639651697eb2$var$getStyleFromPropValue(cssProperties, transformer);
        var propValue = props[prop];
        return (0, $f1bc18ddb2006d57$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    }).reduce((0, $7a9e3fb1055d6e2e$export$2e2bcd8739ae039), {});
}
$6847639651697eb2$var$spacing.propTypes = {};
$6847639651697eb2$var$spacing.filterProps = $6847639651697eb2$var$spacingKeys;
var $6847639651697eb2$export$2e2bcd8739ae039 = $6847639651697eb2$var$spacing;


var $18da797638aed2d2$var$warnOnce;
function $18da797638aed2d2$export$2e2bcd8739ae039() {
    var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
     // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
    // Smaller components, such as icons and type, can align to a 4dp grid.
    // https://material.io/design/layout/understanding-layout.html#usage
    var transform = (0, $6847639651697eb2$export$1def6f833384e3d1)({
        spacing: spacingInput
    });
    var spacing = function spacing() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 0) return transform(1);
        if (args.length === 1) return transform(args[0]);
        return args.map(function(argument) {
            if (typeof argument === 'string') return argument;
            var output = transform(argument);
            return typeof output === 'number' ? "".concat(output, "px") : output;
        }).join(' ');
    }; // Backward compatibility, to remove in v5.
    Object.defineProperty(spacing, 'unit', {
        get: function get() {
            return spacingInput;
        }
    });
    spacing.mui = true;
    return spacing;
}



var $46313b472dc891dc$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
var $46313b472dc891dc$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $46313b472dc891dc$var$formatMs(milliseconds) {
    return "".concat(Math.round(milliseconds), "ms");
}
var /**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */ $46313b472dc891dc$export$2e2bcd8739ae039 = {
    easing: $46313b472dc891dc$export$24c5ac7c37452e7d,
    duration: $46313b472dc891dc$export$1f34108aa9eb96ab,
    create: function create() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'all'
        ];
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _options$duration = options.duration, durationOption = _options$duration === void 0 ? $46313b472dc891dc$export$1f34108aa9eb96ab.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? $46313b472dc891dc$export$24c5ac7c37452e7d.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(options, [
            "duration",
            "easing",
            "delay"
        ]);
        var isString, isNumber;
        return (Array.isArray(props) ? props : [
            props
        ]).map(function(animatedProp) {
            return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : $46313b472dc891dc$var$formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : $46313b472dc891dc$var$formatMs(delay));
        }).join(',');
    },
    getAutoHeightDuration: function getAutoHeightDuration(height) {
        if (!height) return 0;
        var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
        return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
    }
};


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var $7d040e4f8e6b6c4c$var$zIndex = {
    mobileStepper: 1000,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $7d040e4f8e6b6c4c$export$2e2bcd8739ae039 = $7d040e4f8e6b6c4c$var$zIndex;


function $dd72264e873dc013$var$createTheme() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(options, [
        "breakpoints",
        "mixins",
        "palette",
        "spacing",
        "typography"
    ]);
    var palette = (0, $6867604e4e179d24$export$2e2bcd8739ae039)(paletteInput);
    var breakpoints = (0, $ca76f9f29c766ebf$export$2e2bcd8739ae039)(breakpointsInput);
    var spacing = (0, $18da797638aed2d2$export$2e2bcd8739ae039)(spacingInput);
    var muiTheme = (0, $c5a49a164fa2421a$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        mixins: (0, $cb259a70b7d4e458$export$2e2bcd8739ae039)(breakpoints, spacing, mixinsInput),
        overrides: {},
        // Inject custom styles
        palette: palette,
        props: {},
        // Provide default props
        shadows: (0, $f95cadb7dc9682d3$export$2e2bcd8739ae039),
        typography: (0, $ffcf1dc87389e227$export$2e2bcd8739ae039)(palette, typographyInput),
        spacing: spacing,
        shape: (0, $cc48399d9c802693$export$2e2bcd8739ae039),
        transitions: (0, $46313b472dc891dc$export$2e2bcd8739ae039),
        zIndex: (0, $7d040e4f8e6b6c4c$export$2e2bcd8739ae039)
    }, other);
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    muiTheme = args.reduce(function(acc, argument) {
        return (0, $c5a49a164fa2421a$export$2e2bcd8739ae039)(acc, argument);
    }, muiTheme);
    var pseudoClasses, traverse;
    return muiTheme;
}
var $dd72264e873dc013$var$warnedOnce = false;
function $dd72264e873dc013$export$c469355549431d9b() {
    return $dd72264e873dc013$var$createTheme.apply(void 0, arguments);
}
var $dd72264e873dc013$export$2e2bcd8739ae039 = $dd72264e873dc013$var$createTheme;


var $843a8f57ee0b12dc$var$defaultTheme = (0, $dd72264e873dc013$export$2e2bcd8739ae039)();
var $843a8f57ee0b12dc$export$2e2bcd8739ae039 = $843a8f57ee0b12dc$var$defaultTheme;


function $766b7176cd69abd5$var$withStyles(stylesOrCreator, options) {
    return (0, $cf78fbceb0e88663$export$2e2bcd8739ae039)(stylesOrCreator, (0, $eR4tV.default)({
        defaultTheme: (0, $843a8f57ee0b12dc$export$2e2bcd8739ae039)
    }, options));
}
var $766b7176cd69abd5$export$2e2bcd8739ae039 = $766b7176cd69abd5$var$withStyles;




var $eR4tV = parcelRequire("eR4tV");


var $lx97N = parcelRequire("lx97N");


var $1amKe = parcelRequire("1amKe");

var $fmTP4 = parcelRequire("fmTP4");


var $lx97N = parcelRequire("lx97N");
// TODO v5: consider to make it private
function $3ca221fed6f9afd7$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


function $ed4c5577c8e8339a$export$2e2bcd8739ae039(refA, refB) {
    /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */ return $lx97N.useMemo(function() {
        if (refA == null && refB == null) return null;
        return function(refValue) {
            (0, $3ca221fed6f9afd7$export$2e2bcd8739ae039)(refA, refValue);
            (0, $3ca221fed6f9afd7$export$2e2bcd8739ae039)(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}



var $lx97N = parcelRequire("lx97N");
var $451573ee8047e885$var$useEnhancedEffect = typeof window !== 'undefined' ? $lx97N.useLayoutEffect : $lx97N.useEffect;
function $451573ee8047e885$export$2e2bcd8739ae039(fn) {
    var ref = $lx97N.useRef(fn);
    $451573ee8047e885$var$useEnhancedEffect(function() {
        ref.current = fn;
    });
    return $lx97N.useCallback(function() {
        return (0, ref.current).apply(void 0, arguments);
    }, []);
}




// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js

var $lx97N = parcelRequire("lx97N");

var $1amKe = parcelRequire("1amKe");
var $95dc06ed5b82265c$var$hadKeyboardEvent = true;
var $95dc06ed5b82265c$var$hadFocusVisibleRecently = false;
var $95dc06ed5b82265c$var$hadFocusVisibleRecentlyTimeout = null;
var $95dc06ed5b82265c$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */ function $95dc06ed5b82265c$var$focusTriggersKeyboardModality(node) {
    var type = node.type, tagName = node.tagName;
    if (tagName === 'INPUT' && $95dc06ed5b82265c$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $95dc06ed5b82265c$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $95dc06ed5b82265c$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $95dc06ed5b82265c$var$handlePointerDown() {
    $95dc06ed5b82265c$var$hadKeyboardEvent = false;
}
function $95dc06ed5b82265c$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($95dc06ed5b82265c$var$hadFocusVisibleRecently) $95dc06ed5b82265c$var$hadKeyboardEvent = true;
    }
}
function $95dc06ed5b82265c$var$prepare(doc) {
    doc.addEventListener('keydown', $95dc06ed5b82265c$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $95dc06ed5b82265c$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $95dc06ed5b82265c$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $95dc06ed5b82265c$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $95dc06ed5b82265c$var$handleVisibilityChange, true);
}
function $95dc06ed5b82265c$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $95dc06ed5b82265c$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $95dc06ed5b82265c$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $95dc06ed5b82265c$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $95dc06ed5b82265c$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $95dc06ed5b82265c$var$handleVisibilityChange, true);
}
function $95dc06ed5b82265c$var$isFocusVisible(event) {
    var target = event.target;
    try {
        return target.matches(':focus-visible');
    } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
    // we use our own heuristic for those browsers
    // rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    // no need for validFocusTarget check. the user does that by attaching it to
    // focusable events only
    return $95dc06ed5b82265c$var$hadKeyboardEvent || $95dc06ed5b82265c$var$focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */ function $95dc06ed5b82265c$var$handleBlurVisible() {
    // To detect a tab/window switch, we look for a blur event followed
    // rapidly by a visibility change.
    // If we don't see a visibility change within 100ms, it's probably a
    // regular focus change.
    $95dc06ed5b82265c$var$hadFocusVisibleRecently = true;
    window.clearTimeout($95dc06ed5b82265c$var$hadFocusVisibleRecentlyTimeout);
    $95dc06ed5b82265c$var$hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
        $95dc06ed5b82265c$var$hadFocusVisibleRecently = false;
    }, 100);
}
function $95dc06ed5b82265c$export$2e2bcd8739ae039() {
    var ref = $lx97N.useCallback(function(instance) {
        var node = $1amKe.findDOMNode(instance);
        if (node != null) $95dc06ed5b82265c$var$prepare(node.ownerDocument);
    }, []);
    return {
        isFocusVisible: $95dc06ed5b82265c$var$isFocusVisible,
        onBlurVisible: $95dc06ed5b82265c$var$handleBlurVisible,
        ref: ref
    };
}



var $eR4tV = parcelRequire("eR4tV");



var $lx97N = parcelRequire("lx97N");


var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $jzHgM = parcelRequire("jzHgM");

var $3W2J1 = parcelRequire("3W2J1");


var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
var $d2f3945552f4b8f7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext(null);



var $lx97N = parcelRequire("lx97N");
function $978802b154636dc5$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $lx97N.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $lx97N.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $978802b154636dc5$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $978802b154636dc5$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $978802b154636dc5$export$fa71e2345c31d7a2(props, onExited) {
    return $978802b154636dc5$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $lx97N.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $978802b154636dc5$var$getProp(child, 'appear', props),
            enter: $978802b154636dc5$var$getProp(child, 'enter', props),
            exit: $978802b154636dc5$var$getProp(child, 'exit', props)
        });
    });
}
function $978802b154636dc5$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $978802b154636dc5$export$bbc8a025727ea824(nextProps.children);
    var children = $978802b154636dc5$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $lx97N.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $lx97N.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $lx97N.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $978802b154636dc5$var$getProp(child, 'exit', nextProps),
            enter: $978802b154636dc5$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $lx97N.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $lx97N.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $lx97N.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $978802b154636dc5$var$getProp(child, 'exit', nextProps),
            enter: $978802b154636dc5$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $b187fb0b2f4345b8$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $b187fb0b2f4345b8$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $b187fb0b2f4345b8$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $3W2J1.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $jzHgM.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $978802b154636dc5$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $978802b154636dc5$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $978802b154636dc5$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $eR4tV.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $hphT8.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $b187fb0b2f4345b8$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $d2f3945552f4b8f7$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $d2f3945552f4b8f7$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Component);
$b187fb0b2f4345b8$var$TransitionGroup.propTypes = {};
$b187fb0b2f4345b8$var$TransitionGroup.defaultProps = $b187fb0b2f4345b8$var$defaultProps;
var $b187fb0b2f4345b8$export$2e2bcd8739ae039 = $b187fb0b2f4345b8$var$TransitionGroup;



var $fmTP4 = parcelRequire("fmTP4");


var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $fba30ea8a7442c14$var$useEnhancedEffect = typeof window === 'undefined' ? $lx97N.useEffect : $lx97N.useLayoutEffect;
/**
 * @ignore - internal component.
 */ function $fba30ea8a7442c14$var$Ripple(props) {
    var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {} : _props$onExited, timeout = props.timeout;
    var _React$useState = $lx97N.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
    var rippleClassName = (0, $fmTP4.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    var rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    var childClassName = (0, $fmTP4.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    var handleExited = (0, $451573ee8047e885$export$2e2bcd8739ae039)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
    $fba30ea8a7442c14$var$useEnhancedEffect(function() {
        if (!inProp) {
            // react-transition-group#onExit
            setLeaving(true); // react-transition-group#onExited
            var timeoutId = setTimeout(handleExited, timeout);
            return function() {
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        handleExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ $lx97N.createElement("span", {
        className: rippleClassName,
        style: rippleStyles
    }, /*#__PURE__*/ $lx97N.createElement("span", {
        className: childClassName
    }));
}
var $fba30ea8a7442c14$export$2e2bcd8739ae039 = $fba30ea8a7442c14$var$Ripple;


var $43afbdcbd81cb137$var$DURATION = 550;
var $43afbdcbd81cb137$export$95d0c9356b2231a3 = 80;
var $43afbdcbd81cb137$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: {
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            zIndex: 0,
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            borderRadius: 'inherit'
        },
        /* Styles applied to the internal `Ripple` components `ripple` class. */ ripple: {
            opacity: 0,
            position: 'absolute'
        },
        /* Styles applied to the internal `Ripple` components `rippleVisible` class. */ rippleVisible: {
            opacity: 0.3,
            transform: 'scale(1)',
            animation: "$enter ".concat($43afbdcbd81cb137$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */ ripplePulsate: {
            animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
        },
        /* Styles applied to the internal `Ripple` components `child` class. */ child: {
            opacity: 1,
            display: 'block',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            backgroundColor: 'currentColor'
        },
        /* Styles applied to the internal `Ripple` components `childLeaving` class. */ childLeaving: {
            opacity: 0,
            animation: "$exit ".concat($43afbdcbd81cb137$var$DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
        },
        /* Styles applied to the internal `Ripple` components `childPulsate` class. */ childPulsate: {
            position: 'absolute',
            left: 0,
            top: 0,
            animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
        },
        '@keyframes enter': {
            '0%': {
                transform: 'scale(0)',
                opacity: 0.1
            },
            '100%': {
                transform: 'scale(1)',
                opacity: 0.3
            }
        },
        '@keyframes exit': {
            '0%': {
                opacity: 1
            },
            '100%': {
                opacity: 0
            }
        },
        '@keyframes pulsate': {
            '0%': {
                transform: 'scale(1)'
            },
            '50%': {
                transform: 'scale(0.92)'
            },
            '100%': {
                transform: 'scale(1)'
            }
        }
    };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ var $43afbdcbd81cb137$var$TouchRipple = /*#__PURE__*/ $lx97N.forwardRef(function TouchRipple(props, ref) {
    var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(props, [
        "center",
        "classes",
        "className"
    ]);
    var _React$useState = $lx97N.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
    var nextKey = $lx97N.useRef(0);
    var rippleCallback = $lx97N.useRef(null);
    $lx97N.useEffect(function() {
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]); // Used to filter out mouse emulated events on mobile.
    var ignoringMouseDown = $lx97N.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    var startTimer = $lx97N.useRef(null); // This is the hook called once the previous timeout is ready.
    var startTimerCommit = $lx97N.useRef(null);
    var container = $lx97N.useRef(null);
    $lx97N.useEffect(function() {
        return function() {
            clearTimeout(startTimer.current);
        };
    }, []);
    var startCommit = $lx97N.useCallback(function(params) {
        var pulsate = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
        setRipples(function(oldRipples) {
            return [].concat((0, $2905eabba6b75ab9$export$2e2bcd8739ae039)(oldRipples), [
                /*#__PURE__*/ $lx97N.createElement((0, $fba30ea8a7442c14$export$2e2bcd8739ae039), {
                    key: nextKey.current,
                    classes: classes,
                    timeout: $43afbdcbd81cb137$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                })
            ]);
        });
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    var start = $lx97N.useCallback(function() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments.length > 2 ? arguments[2] : undefined;
        var _options$pulsate = options.pulsate, pulsate = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
        if (event.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event.type === 'touchstart') ignoringMouseDown.current = true;
        var element = fakeElement ? null : container.current;
        var rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        }; // Get the size of the ripple
        var rippleX;
        var rippleY;
        var rippleSize;
        if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
        } // Touche devices
        if (event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = function() {
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                }; // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(function() {
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $43afbdcbd81cb137$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    var pulsate = $lx97N.useCallback(function() {
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    var stop = $lx97N.useCallback(function(event, cb) {
        clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event.type === 'touchend' && startTimerCommit.current) {
            event.persist();
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(function() {
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples(function(oldRipples) {
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $lx97N.useImperativeHandle(ref, function() {
        return {
            pulsate: pulsate,
            start: start,
            stop: stop
        };
    }, [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ $lx97N.createElement("span", (0, $eR4tV.default)({
        className: (0, $fmTP4.default)(classes.root, className),
        ref: container
    }, other), /*#__PURE__*/ $lx97N.createElement((0, $b187fb0b2f4345b8$export$2e2bcd8739ae039), {
        component: null,
        exit: true
    }, ripples));
});
var $43afbdcbd81cb137$export$2e2bcd8739ae039 = (0, $766b7176cd69abd5$export$2e2bcd8739ae039)($43afbdcbd81cb137$export$9dd6ff9ea0189349, {
    flip: false,
    name: 'MuiTouchRipple'
})(/*#__PURE__*/ $lx97N.memo($43afbdcbd81cb137$var$TouchRipple));


var $e061d11bad63312f$export$9dd6ff9ea0189349 = {
    /* Styles applied to the root element. */ root: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        '-moz-appearance': 'none',
        // Reset
        '-webkit-appearance': 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        '&$disabled': {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
    /* Pseudo-class applied to the root element if keyboard focused. */ focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ var $e061d11bad63312f$var$ButtonBase = /*#__PURE__*/ $lx97N.forwardRef(function ButtonBase(props, ref) {
    var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(props, [
        "action",
        "buttonRef",
        "centerRipple",
        "children",
        "classes",
        "className",
        "component",
        "disabled",
        "disableRipple",
        "disableTouchRipple",
        "focusRipple",
        "focusVisibleClassName",
        "onBlur",
        "onClick",
        "onFocus",
        "onFocusVisible",
        "onKeyDown",
        "onKeyUp",
        "onMouseDown",
        "onMouseLeave",
        "onMouseUp",
        "onTouchEnd",
        "onTouchMove",
        "onTouchStart",
        "onDragLeave",
        "tabIndex",
        "TouchRippleProps",
        "type"
    ]);
    var buttonRef = $lx97N.useRef(null);
    function getButtonNode() {
        // #StrictMode ready
        return $1amKe.findDOMNode(buttonRef.current);
    }
    var rippleRef = $lx97N.useRef(null);
    var _React$useState = $lx97N.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
    if (disabled && focusVisible) setFocusVisible(false);
    var _useIsFocusVisible = (0, $95dc06ed5b82265c$export$2e2bcd8739ae039)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
    $lx97N.useImperativeHandle(action, function() {
        return {
            focusVisible: function focusVisible() {
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        };
    }, []);
    $lx97N.useEffect(function() {
        if (focusVisible && focusRipple && !disableRipple) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible
    ]);
    function useRippleHandler(rippleAction, eventCallback) {
        var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
        return (0, $451573ee8047e885$export$2e2bcd8739ae039)(function(event) {
            if (eventCallback) eventCallback(event);
            var ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    var handleMouseDown = useRippleHandler('start', onMouseDown);
    var handleDragLeave = useRippleHandler('stop', onDragLeave);
    var handleMouseUp = useRippleHandler('stop', onMouseUp);
    var handleMouseLeave = useRippleHandler('stop', function(event) {
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    var handleTouchStart = useRippleHandler('start', onTouchStart);
    var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    var handleTouchMove = useRippleHandler('stop', onTouchMove);
    var handleBlur = useRippleHandler('stop', function(event) {
        if (focusVisible) {
            onBlurVisible(event);
            setFocusVisible(false);
        }
        if (onBlur) onBlur(event);
    }, false);
    var handleFocus = (0, $451573ee8047e885$export$2e2bcd8739ae039)(function(event) {
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (isFocusVisible(event)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    var isNonNativeButton = function isNonNativeButton() {
        var button = getButtonNode();
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ var keydownRef = $lx97N.useRef(false);
    var handleKeyDown = (0, $451573ee8047e885$export$2e2bcd8739ae039)(function(event) {
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
         // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    var handleKeyUp = (0, $451573ee8047e885$export$2e2bcd8739ae039)(function(event) {
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            event.persist();
            rippleRef.current.stop(event, function() {
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
         // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    var ComponentProp = component;
    if (ComponentProp === 'button' && other.href) ComponentProp = 'a';
    var buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type;
        buttonProps.disabled = disabled;
    } else {
        if (ComponentProp !== 'a' || !other.href) buttonProps.role = 'button';
        buttonProps['aria-disabled'] = disabled;
    }
    var handleUserRef = (0, $ed4c5577c8e8339a$export$2e2bcd8739ae039)(buttonRefProp, ref);
    var handleOwnRef = (0, $ed4c5577c8e8339a$export$2e2bcd8739ae039)(focusVisibleRef, buttonRef);
    var handleRef = (0, $ed4c5577c8e8339a$export$2e2bcd8739ae039)(handleUserRef, handleOwnRef);
    var _React$useState2 = $lx97N.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
    $lx97N.useEffect(function() {
        setMountedState(true);
    }, []);
    var enableTouchRipple = mountedState && !disableRipple && !disabled;
    return /*#__PURE__*/ $lx97N.createElement(ComponentProp, (0, $eR4tV.default)({
        className: (0, $fmTP4.default)(classes.root, className, focusVisible && [
            classes.focusVisible,
            focusVisibleClassName
        ], disabled && classes.disabled),
        onBlur: handleBlur,
        onClick: onClick,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex
    }, buttonProps, other), children, enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ $lx97N.createElement((0, $43afbdcbd81cb137$export$2e2bcd8739ae039), (0, $eR4tV.default)({
        ref: rippleRef,
        center: centerRipple
    }, TouchRippleProps)) : null);
});
var $e061d11bad63312f$export$2e2bcd8739ae039 = (0, $766b7176cd69abd5$export$2e2bcd8739ae039)($e061d11bad63312f$export$9dd6ff9ea0189349, {
    name: 'MuiButtonBase'
})($e061d11bad63312f$var$ButtonBase);



function $cb77ab8202ccfa22$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $36ea5f142d2ea750$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}


var $8868573fff8ef968$export$9dd6ff9ea0189349 = function styles(theme) {
    return {
        /* Styles applied to the root element. */ root: (0, $eR4tV.default)({}, theme.typography.button, {
            boxSizing: 'border-box',
            minWidth: 64,
            padding: '6px 16px',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.primary,
            transition: theme.transitions.create([
                'background-color',
                'box-shadow',
                'border'
            ], {
                duration: theme.transitions.duration.short
            }),
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: (0, $65a40c6bd53abec5$export$58f0f39f63f3cf42)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                },
                '&$disabled': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                color: theme.palette.action.disabled
            }
        }),
        /* Styles applied to the span element that wraps the children. */ label: {
            width: '100%',
            // Ensure the correct width for iOS Safari
            display: 'inherit',
            alignItems: 'inherit',
            justifyContent: 'inherit'
        },
        /* Styles applied to the root element if `variant="text"`. */ text: {
            padding: '6px 8px'
        },
        /* Styles applied to the root element if `variant="text"` and `color="primary"`. */ textPrimary: {
            color: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: (0, $65a40c6bd53abec5$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */ textSecondary: {
            color: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: (0, $65a40c6bd53abec5$export$58f0f39f63f3cf42)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"`. */ outlined: {
            padding: '5px 15px',
            border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabledBackground)
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */ outlinedPrimary: {
            color: theme.palette.primary.main,
            border: "1px solid ".concat((0, $65a40c6bd53abec5$export$58f0f39f63f3cf42)(theme.palette.primary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.primary.main),
                backgroundColor: (0, $65a40c6bd53abec5$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            }
        },
        /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */ outlinedSecondary: {
            color: theme.palette.secondary.main,
            border: "1px solid ".concat((0, $65a40c6bd53abec5$export$58f0f39f63f3cf42)(theme.palette.secondary.main, 0.5)),
            '&:hover': {
                border: "1px solid ".concat(theme.palette.secondary.main),
                backgroundColor: (0, $65a40c6bd53abec5$export$58f0f39f63f3cf42)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&$disabled': {
                border: "1px solid ".concat(theme.palette.action.disabled)
            }
        },
        /* Styles applied to the root element if `variant="contained"`. */ contained: {
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            backgroundColor: theme.palette.grey[300],
            boxShadow: theme.shadows[2],
            '&:hover': {
                backgroundColor: theme.palette.grey.A100,
                boxShadow: theme.shadows[4],
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    boxShadow: theme.shadows[2],
                    backgroundColor: theme.palette.grey[300]
                },
                '&$disabled': {
                    backgroundColor: theme.palette.action.disabledBackground
                }
            },
            '&$focusVisible': {
                boxShadow: theme.shadows[6]
            },
            '&:active': {
                boxShadow: theme.shadows[8]
            },
            '&$disabled': {
                color: theme.palette.action.disabled,
                boxShadow: theme.shadows[0],
                backgroundColor: theme.palette.action.disabledBackground
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */ containedPrimary: {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.primary.main
                }
            }
        },
        /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */ containedSecondary: {
            color: theme.palette.secondary.contrastText,
            backgroundColor: theme.palette.secondary.main,
            '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: theme.palette.secondary.main
                }
            }
        },
        /* Styles applied to the root element if `disableElevation={true}`. */ disableElevation: {
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none'
            },
            '&$focusVisible': {
                boxShadow: 'none'
            },
            '&:active': {
                boxShadow: 'none'
            },
            '&$disabled': {
                boxShadow: 'none'
            }
        },
        /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */ focusVisible: {},
        /* Pseudo-class applied to the root element if `disabled={true}`. */ disabled: {},
        /* Styles applied to the root element if `color="inherit"`. */ colorInherit: {
            color: 'inherit',
            borderColor: 'currentColor'
        },
        /* Styles applied to the root element if `size="small"` and `variant="text"`. */ textSizeSmall: {
            padding: '4px 5px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="text"`. */ textSizeLarge: {
            padding: '8px 11px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */ outlinedSizeSmall: {
            padding: '3px 9px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */ outlinedSizeLarge: {
            padding: '7px 21px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"` and `variant="contained"`. */ containedSizeSmall: {
            padding: '4px 10px',
            fontSize: theme.typography.pxToRem(13)
        },
        /* Styles applied to the root element if `size="large"` and `variant="contained"`. */ containedSizeLarge: {
            padding: '8px 22px',
            fontSize: theme.typography.pxToRem(15)
        },
        /* Styles applied to the root element if `size="small"`. */ sizeSmall: {},
        /* Styles applied to the root element if `size="large"`. */ sizeLarge: {},
        /* Styles applied to the root element if `fullWidth={true}`. */ fullWidth: {
            width: '100%'
        },
        /* Styles applied to the startIcon element if supplied. */ startIcon: {
            display: 'inherit',
            marginRight: 8,
            marginLeft: -4,
            '&$iconSizeSmall': {
                marginLeft: -2
            }
        },
        /* Styles applied to the endIcon element if supplied. */ endIcon: {
            display: 'inherit',
            marginRight: -4,
            marginLeft: 8,
            '&$iconSizeSmall': {
                marginRight: -2
            }
        },
        /* Styles applied to the icon element if supplied and `size="small"`. */ iconSizeSmall: {
            '& > *:first-child': {
                fontSize: 18
            }
        },
        /* Styles applied to the icon element if supplied and `size="medium"`. */ iconSizeMedium: {
            '& > *:first-child': {
                fontSize: 20
            }
        },
        /* Styles applied to the icon element if supplied and `size="large"`. */ iconSizeLarge: {
            '& > *:first-child': {
                fontSize: 22
            }
        }
    };
};
var $8868573fff8ef968$var$Button = /*#__PURE__*/ $lx97N.forwardRef(function Button(props, ref) {
    var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'default' : _props$color, _props$component = props.component, component = _props$component === void 0 ? 'button' : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? 'button' : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? 'text' : _props$variant, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(props, [
        "children",
        "classes",
        "className",
        "color",
        "component",
        "disabled",
        "disableElevation",
        "disableFocusRipple",
        "endIcon",
        "focusVisibleClassName",
        "fullWidth",
        "size",
        "startIcon",
        "type",
        "variant"
    ]);
    var startIcon = startIconProp && /*#__PURE__*/ $lx97N.createElement("span", {
        className: (0, $fmTP4.default)(classes.startIcon, classes["iconSize".concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(size))])
    }, startIconProp);
    var endIcon = endIconProp && /*#__PURE__*/ $lx97N.createElement("span", {
        className: (0, $fmTP4.default)(classes.endIcon, classes["iconSize".concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(size))])
    }, endIconProp);
    return /*#__PURE__*/ $lx97N.createElement((0, $e061d11bad63312f$export$2e2bcd8739ae039), (0, $eR4tV.default)({
        className: (0, $fmTP4.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(color))], size !== 'medium' && [
            classes["".concat(variant, "Size").concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(size))],
            classes["size".concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(size))]
        ], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $fmTP4.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other), /*#__PURE__*/ $lx97N.createElement("span", {
        className: classes.label
    }, startIcon, children, endIcon));
});
var $8868573fff8ef968$export$2e2bcd8739ae039 = (0, $766b7176cd69abd5$export$2e2bcd8739ae039)($8868573fff8ef968$export$9dd6ff9ea0189349, {
    name: 'MuiButton'
})($8868573fff8ef968$var$Button);



function $bf5e1d370ce0ec0a$export$f365abd1f26084fd({ error: error, resetErrorBoundary: resetErrorBoundary }) {
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        role: "alert",
        className: "qep-renderError",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "qep-renderError__message",
                children: [
                    "There was a component error.",
                    /*#__PURE__*/ (0, $fRwNr.jsx)("br", {}),
                    "Click the button to try reloading.",
                    /*#__PURE__*/ (0, $fRwNr.jsx)("br", {}),
                    "If this fails, please restart the application."
                ]
            }),
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "qep-renderError__error",
                children: [
                    error.name,
                    ": ",
                    error.message
                ]
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8868573fff8ef968$export$2e2bcd8739ae039), {
                className: "qep-renderError__button",
                role: "button",
                variant: "outlined",
                onClick: resetErrorBoundary,
                children: "Try Again"
            })
        ]
    });
}


function $49c44fb299ddf6a4$export$dd147bee413758f6({ children: children }) {
    return(// @ts-ignore - A bug in this library
    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $5b45c4e874e30f29$exports.ErrorBoundary), {
        FallbackComponent: (0, $bf5e1d370ce0ec0a$export$f365abd1f26084fd),
        children: children
    }));
}



var $fRwNr = parcelRequire("fRwNr");
parcelRequire("lx97N");

var $aBr5J = parcelRequire("aBr5J");
var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");
parcelRequire("lx97N");


var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");



var $lx97N = parcelRequire("lx97N");
const $8c99aebb6e70a77d$var$ThemeContext = /*#__PURE__*/ $lx97N.createContext(null);
var $8c99aebb6e70a77d$export$2e2bcd8739ae039 = $8c99aebb6e70a77d$var$ThemeContext;



var $lx97N = parcelRequire("lx97N");

function $9c92c8d313eedaae$export$2e2bcd8739ae039() {
    const theme = $lx97N.useContext((0, $8c99aebb6e70a77d$export$2e2bcd8739ae039));
    return theme;
}


const $c2b0ab498751280f$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $c2b0ab498751280f$export$2e2bcd8739ae039 = $c2b0ab498751280f$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $fRwNr = parcelRequire("fRwNr");
function $d8a51332e8a7ec08$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $eR4tV.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $d8a51332e8a7ec08$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $9c92c8d313eedaae$export$2e2bcd8739ae039)();
    const theme = $lx97N.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $d8a51332e8a7ec08$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $c2b0ab498751280f$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8c99aebb6e70a77d$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $d8a51332e8a7ec08$export$2e2bcd8739ae039 = $d8a51332e8a7ec08$var$ThemeProvider;



parcelRequire("9Hxe6");
var $jx6dC = parcelRequire("jx6dC");

var $jQQSa = parcelRequire("jQQSa");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");


var $fRwNr = parcelRequire("fRwNr");
const $b33232a9dd8b7231$var$_excluded = [
    "value"
];
const $b33232a9dd8b7231$var$RtlContext = /*#__PURE__*/ $lx97N.createContext();
function $b33232a9dd8b7231$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $hphT8.default)(_ref, $b33232a9dd8b7231$var$_excluded);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($b33232a9dd8b7231$var$RtlContext.Provider, (0, $eR4tV.default)({
        value: value != null ? value : true
    }, props));
}
const $b33232a9dd8b7231$export$b2dd014b6c321cb = ()=>{
    const value = $lx97N.useContext($b33232a9dd8b7231$var$RtlContext);
    return value != null ? value : false;
};
var $b33232a9dd8b7231$export$2e2bcd8739ae039 = $b33232a9dd8b7231$var$RtlProvider;



var $lx97N = parcelRequire("lx97N");


var $bo0T6 = parcelRequire("bo0T6");

var $fRwNr = parcelRequire("fRwNr");
'use client';
const $cea54411c8d30f71$var$PropsContext = /*#__PURE__*/ $lx97N.createContext(undefined);
function $cea54411c8d30f71$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $fRwNr.jsx)($cea54411c8d30f71$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $cea54411c8d30f71$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $bo0T6.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $bo0T6.default)(config, props);
    return props;
}
function $cea54411c8d30f71$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $lx97N.useContext($cea54411c8d30f71$var$PropsContext);
    return $cea54411c8d30f71$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $cea54411c8d30f71$export$2e2bcd8739ae039 = $cea54411c8d30f71$var$DefaultPropsProvider;


parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $dad405edc2b429da$var$useEnhancedEffect = typeof window !== 'undefined' ? $lx97N.useLayoutEffect : $lx97N.useEffect;
var $dad405edc2b429da$export$2e2bcd8739ae039 = $dad405edc2b429da$var$useEnhancedEffect;



var $lx97N = parcelRequire("lx97N");
'use client';
let $a879fbe3b7cb644f$var$globalId = 0;
function $a879fbe3b7cb644f$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $lx97N.useState(idOverride);
    const id = idOverride || defaultId;
    $lx97N.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $a879fbe3b7cb644f$var$globalId += 1;
            setDefaultId(`mui-${$a879fbe3b7cb644f$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $a879fbe3b7cb644f$var$maybeReactUseId = $lx97N['useId'.toString()];
function $a879fbe3b7cb644f$export$2e2bcd8739ae039(idOverride) {
    if ($a879fbe3b7cb644f$var$maybeReactUseId !== undefined) {
        const reactId = $a879fbe3b7cb644f$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $a879fbe3b7cb644f$var$useGlobalId(idOverride);
}


parcelRequire("lx97N");


var $hHT9b = parcelRequire("hHT9b");
var $d8uBH = parcelRequire("d8uBH");

var $43QO7 = parcelRequire("43QO7");

var $fRwNr = parcelRequire("fRwNr");
'use client';
function $22e6415d7ae3c92f$var$wrapGlobalLayer(styles) {
    const serialized = (0, $d8uBH.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $22e6415d7ae3c92f$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $43QO7.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $22e6415d7ae3c92f$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $22e6415d7ae3c92f$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $22e6415d7ae3c92f$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $hHT9b.default), {
        styles: globalStyles
    });
}
var $22e6415d7ae3c92f$export$2e2bcd8739ae039 = $22e6415d7ae3c92f$var$GlobalStyles;



var $jQQSa = parcelRequire("jQQSa");

var $fRwNr = parcelRequire("fRwNr");
'use client';
function $49ab34931044277d$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $jQQSa.default)();
    const id = (0, $a879fbe3b7cb644f$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $dad405edc2b429da$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $22e6415d7ae3c92f$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $fRwNr = parcelRequire("fRwNr");
'use client';
const $41831f5157326937$var$EMPTY_THEME = {};
function $41831f5157326937$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $lx97N.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $eR4tV.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $eR4tV.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $eR4tV.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $41831f5157326937$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $jQQSa.default)($41831f5157326937$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $9c92c8d313eedaae$export$2e2bcd8739ae039)() || $41831f5157326937$var$EMPTY_THEME;
    const engineTheme = $41831f5157326937$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $41831f5157326937$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $49ab34931044277d$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d8a51332e8a7ec08$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $jx6dC.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $b33232a9dd8b7231$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $cea54411c8d30f71$export$2e2bcd8739ae039), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $41831f5157326937$export$2e2bcd8739ae039 = $41831f5157326937$var$ThemeProvider;



var $Rnxzq = parcelRequire("Rnxzq");

var $fRwNr = parcelRequire("fRwNr");
const $ea3418f5a0bf32e7$var$_excluded = [
    "theme"
];
function $ea3418f5a0bf32e7$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $hphT8.default)(_ref, $ea3418f5a0bf32e7$var$_excluded);
    const scopedTheme = themeInput[0, $Rnxzq.default];
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $41831f5157326937$export$2e2bcd8739ae039), (0, $eR4tV.default)({}, props, {
        themeId: scopedTheme ? (0, $Rnxzq.default) : undefined,
        theme: scopedTheme || themeInput
    }));
}


function $48db39880a45c6a8$export$d8964aec282183a3({ children: children }) {
    const darkTheme = (0, $aBr5J.default)({
        palette: {
            mode: 'dark'
        }
    });
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $ea3418f5a0bf32e7$export$2e2bcd8739ae039), {
        theme: darkTheme,
        children: children
    });
}




var $d9gj3 = parcelRequire("d9gj3");
var $lx97N = parcelRequire("lx97N");
const $53062adebdc9cb0b$export$8ede4c887370b89a = 'America/Chicago';
const $53062adebdc9cb0b$export$e6df0238c765f87d = 16;
const $53062adebdc9cb0b$export$327067b4b1f547ae = 30;
const $53062adebdc9cb0b$export$d1f550c97ec35f2b = 30000;
const $53062adebdc9cb0b$var$getZonedDateTimeParts = (timestampMs, timeZone)=>{
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        hourCycle: 'h23'
    });
    const parts = formatter.formatToParts(new Date(timestampMs));
    const byType = Object.fromEntries(parts.map((part)=>[
            part.type,
            part.value
        ]));
    return {
        year: Number(byType.year),
        month: Number(byType.month),
        day: Number(byType.day),
        hour: Number(byType.hour),
        minute: Number(byType.minute)
    };
};
const $53062adebdc9cb0b$var$getDayKey = (parts)=>`${parts.year}-${parts.month}-${parts.day}`;
const $53062adebdc9cb0b$var$getMinutesSinceMidnight = (parts)=>parts.hour * 60 + parts.minute;
const $53062adebdc9cb0b$export$e157413978fb74eb = (onLogout, { enabled: enabled = true, timeZone: timeZone = $53062adebdc9cb0b$export$8ede4c887370b89a, targetHour: targetHour = $53062adebdc9cb0b$export$e6df0238c765f87d, targetMinute: targetMinute = $53062adebdc9cb0b$export$327067b4b1f547ae, checkIntervalMs: checkIntervalMs = $53062adebdc9cb0b$export$d1f550c97ec35f2b } = {})=>{
    const intervalRef = (0, $lx97N.useRef)(null);
    const isLogoutInProgressRef = (0, $lx97N.useRef)(false);
    const lastLogoutDateRef = (0, $lx97N.useRef)(null);
    const previousCheckRef = (0, $lx97N.useRef)(null);
    const crossedTargetDateRef = (0, $lx97N.useRef)(null);
    (0, $lx97N.useEffect)(()=>{
        if (!enabled) {
            previousCheckRef.current = null;
            crossedTargetDateRef.current = null;
            return;
        }
        const triggerLogout = (dayKey)=>{
            if (isLogoutInProgressRef.current) return;
            isLogoutInProgressRef.current = true;
            Promise.resolve(onLogout()).then(()=>{
                // Only mark the day as handled after a successful logout.
                lastLogoutDateRef.current = dayKey;
            }).catch(()=>{
            // Avoid unhandled promise rejection if logout fails. Keeping
            // lastLogoutDateRef unchanged allows retry on the next interval.
            }).finally(()=>{
                isLogoutInProgressRef.current = false;
            });
        };
        const checkIfLogoutIsDue = ()=>{
            const nowZoned = $53062adebdc9cb0b$var$getZonedDateTimeParts(Date.now(), timeZone);
            const dayKey = $53062adebdc9cb0b$var$getDayKey(nowZoned);
            const currentMinutes = $53062adebdc9cb0b$var$getMinutesSinceMidnight(nowZoned);
            const targetMinutes = targetHour * 60 + targetMinute;
            if (lastLogoutDateRef.current === dayKey) {
                previousCheckRef.current = {
                    dayKey: dayKey,
                    minutesSinceMidnight: currentMinutes
                };
                return;
            }
            const previousCheck = previousCheckRef.current;
            // First check while enabled only establishes a baseline. This prevents
            // forcing logout for users who log in after the target time.
            if (!previousCheck) {
                previousCheckRef.current = {
                    dayKey: dayKey,
                    minutesSinceMidnight: currentMinutes
                };
                return;
            }
            const crossedTargetThisDay = previousCheck.dayKey === dayKey && previousCheck.minutesSinceMidnight < targetMinutes && currentMinutes >= targetMinutes;
            if (previousCheck.dayKey !== dayKey) crossedTargetDateRef.current = null;
            if (crossedTargetThisDay) crossedTargetDateRef.current = dayKey;
            previousCheckRef.current = {
                dayKey: dayKey,
                minutesSinceMidnight: currentMinutes
            };
            const shouldAttemptLogout = crossedTargetDateRef.current === dayKey && currentMinutes >= targetMinutes && lastLogoutDateRef.current !== dayKey;
            if (!shouldAttemptLogout) return;
            triggerLogout(dayKey);
        };
        // Run once immediately to initialize the baseline check state.
        checkIfLogoutIsDue();
        intervalRef.current = setInterval(()=>{
            checkIfLogoutIsDue();
        }, checkIntervalMs);
        return ()=>{
            if (intervalRef.current) clearInterval(intervalRef.current);
        };
    }, [
        enabled,
        onLogout,
        timeZone,
        targetHour,
        targetMinute,
        checkIntervalMs
    ]);
};



var $l2Ecb = parcelRequire("l2Ecb");
var $035d655aca4aa381$exports = {};
$035d655aca4aa381$exports = new URL("../QEPSplash.5858df75.jpg", import.meta.url).toString();




var $d9gj3 = parcelRequire("d9gj3");
const $27e6451b22bf09f3$export$49f5bf502122d4f7 = ()=>(0, $d9gj3.getQepSystem)().container;
function $27e6451b22bf09f3$export$a543b6e2fc959d7c(component) {
    return {
        type: 'tab',
        // id: component.windowId,
        name: component.name,
        component: 'multitype',
        config: {
            spawnDataId: component?.configs?.spawnDataId,
            componentId: component?.configs?.componentId,
            type: 'url',
            data: component.url,
            linkerGroups: component?.configs?.linkerGroups || []
        }
    };
}


/**
 * Centralizes Browser API-subscription cleanup shared by manual and automatic logout paths.
 */ 
var $d9gj3 = parcelRequire("d9gj3");
function $b70d5c68bc353deb$export$b7d6753c864dd3cf() {
    try {
        (0, $d9gj3.getQepSystem)().apiServices?.unsubscribeAndCleanup?.();
    } catch (error) {
        console.error('Failed to clean up subscriptions before logout', error);
    }
}


/* Hosts the authenticated mobile/tablet trading shell after the browser login flow has completed. */ 
var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $fRwNr = parcelRequire("fRwNr");

var $4ke2G = parcelRequire("4ke2G");
var $k4snv = parcelRequire("k4snv");
const $18c26bf3fa1baa25$export$7c07b633a151f9c5 = new (0, $4ke2G.QueryClient)();
function $18c26bf3fa1baa25$export$51e651dc78bb62ed({ children: children }) {
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $k4snv.QueryClientProvider), {
        client: $18c26bf3fa1baa25$export$7c07b633a151f9c5,
        children: children
    });
}


/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $6d98f6a530ac9778$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            key: "tgr4d6"
        }
    ],
    [
        "path",
        {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            key: "116196"
        }
    ],
    [
        "path",
        {
            d: "M12 11h4",
            key: "1jrz19"
        }
    ],
    [
        "path",
        {
            d: "M12 16h4",
            key: "n85exb"
        }
    ],
    [
        "path",
        {
            d: "M8 11h.01",
            key: "1dfujw"
        }
    ],
    [
        "path",
        {
            d: "M8 16h.01",
            key: "18s6g9"
        }
    ]
];
const $6d98f6a530ac9778$export$2e2bcd8739ae039 = (0, $983Jy.default)("clipboard-list", $6d98f6a530ac9778$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $292c2c681ce28f0f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
            key: "qn84l0"
        }
    ],
    [
        "path",
        {
            d: "M13 5v2",
            key: "dyzc3o"
        }
    ],
    [
        "path",
        {
            d: "M13 17v2",
            key: "1ont0d"
        }
    ],
    [
        "path",
        {
            d: "M13 11v2",
            key: "1wjjxi"
        }
    ]
];
const $292c2c681ce28f0f$export$2e2bcd8739ae039 = (0, $983Jy.default)("ticket", $292c2c681ce28f0f$export$3efd853dbb351e94);



/* Renders the compact manual single-leg order ticket for authenticated mobile users. */ 
var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $jgKwB = parcelRequire("jgKwB");

var $9vFCJ = parcelRequire("9vFCJ");

var $jq43i = parcelRequire("jq43i");
/* Converts the compact mobile order ticket into the shared manual Order Entry payload. */ 
var $cckdX = parcelRequire("cckdX");
/** Parses finite positive user-entered numeric fields without accepting empty or non-numeric strings. */ function $b9363c48738ff0d2$var$parsePositiveNumber(value) {
    const trimmedValue = value.trim();
    if (!/^\d+(?:\.\d+)?$/.test(trimmedValue)) return undefined;
    const parsed = Number.parseFloat(trimmedValue);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
}
/** Checks whether a TraderDB product specification can route the selected product. */ function $b9363c48738ff0d2$var$productSpecificationMatchesProduct(specification, product) {
    const { rootSymbol: rootSymbol, underlyingRootSymbol: underlyingRootSymbol, segmentMic: segmentMic } = product;
    const acceptableRoots = [
        rootSymbol,
        underlyingRootSymbol
    ].filter((root)=>typeof root === 'string' && root.length > 0);
    return acceptableRoots.includes(specification.symbol) && (specification.exchangeCode === segmentMic || specification.exchangeName === segmentMic);
}
/** Converts a TraderDB account into the account payload shape expected by the shared order service. */ function $b9363c48738ff0d2$var$toTradingAccount(account) {
    return {
        id: account.id,
        accountId: account.neovestAccount,
        accountCode: account.code,
        execCode: account.code,
        description: account.description,
        memo: account.memo ?? '',
        clearingString: account.clearingString ?? '',
        notes: [
            account.tradeIntentions[0]?.tradeIntentionName ?? '',
            account.customText2 ?? '',
            account.customText3 ?? ''
        ],
        tradeIntentionId: account.tradeIntentions[0]?.id
    };
}
/** Maps the compact buy/sell control to the Direction enum consumed by shared manual order placement. */ function $b9363c48738ff0d2$var$toDirection(side) {
    return side === 'sell' ? (0, $cckdX.Direction).Sell : (0, $cckdX.Direction).Buy;
}
/** Maps the compact type control to the order type enum consumed by the OMS request builder. */ function $b9363c48738ff0d2$var$toOrderType(orderType) {
    return orderType === 'limit' ? (0, $cckdX.OrderType).ORDERTYPE_LIMIT : (0, $cckdX.OrderType).ORDERTYPE_MARKET;
}
/** Maps the compact TIF control to the TimeInForce enum consumed by the OMS request builder. */ function $b9363c48738ff0d2$var$toTimeInForce(timeInForce) {
    return timeInForce === 'gtc' ? (0, $cckdX.TimeInForce).TIMEINFORCE_UNTIL_CANCELED : (0, $cckdX.TimeInForce).TIMEINFORCE_REGULAR_TRADING_HOURS;
}
function $b9363c48738ff0d2$export$24fabee03d37c346(accounts, product) {
    if (!product?.symbolDetails) return [];
    return accounts.filter((account)=>account.isActive && account.action === 'Trading' && account.productSpecifications.some((specification)=>$b9363c48738ff0d2$var$productSpecificationMatchesProduct(specification, product)));
}
function $b9363c48738ff0d2$export$368f6da79e6cd790(draft) {
    const errors = {};
    if (!draft.product?.symbolDetails) errors.symbol = 'Select a symbol.';
    if (!draft.accountId) errors.account = 'Select an account.';
    if ($b9363c48738ff0d2$var$parsePositiveNumber(draft.quantity) === undefined) errors.quantity = 'Enter a quantity greater than 0.';
    if (draft.orderType === 'limit' && $b9363c48738ff0d2$var$parsePositiveNumber(draft.limitPrice) === undefined) errors.limitPrice = 'Enter a limit price greater than 0.';
    return errors;
}
/** Throws the first validation message so submit handlers can show one actionable failure. */ function $b9363c48738ff0d2$var$assertNoValidationErrors(errors) {
    const [message] = Object.values(errors);
    if (message) throw new Error(message);
}
function $b9363c48738ff0d2$export$22f9acc9b7f6662d(draft, accounts) {
    $b9363c48738ff0d2$var$assertNoValidationErrors($b9363c48738ff0d2$export$368f6da79e6cd790(draft));
    const product = draft.product;
    const symbol = product.symbolDetails;
    const quantity = $b9363c48738ff0d2$var$parsePositiveNumber(draft.quantity);
    const account = $b9363c48738ff0d2$export$24fabee03d37c346(accounts, product).find((candidate)=>candidate.id === draft.accountId);
    if (!account) throw new Error('Select an account.');
    const leg = {
        key: `${symbol.segmentMic}:${symbol.exchangeSymbol}`,
        symbol: symbol,
        quantity: quantity,
        direction: $b9363c48738ff0d2$var$toDirection(draft.side),
        account: $b9363c48738ff0d2$var$toTradingAccount(account)
    };
    return {
        ticketType: (0, $cckdX.OrderTypes).Manual,
        legs: [
            leg
        ],
        params: {
            orderType: $b9363c48738ff0d2$var$toOrderType(draft.orderType),
            limitPrice: draft.orderType === 'limit' ? draft.limitPrice : undefined,
            timeInForce: $b9363c48738ff0d2$var$toTimeInForce(draft.timeInForce)
        },
        symbols: [
            symbol
        ]
    };
}


const $7be5033609289db0$var$initialDraft = {
    product: undefined,
    accountId: undefined,
    side: 'buy',
    quantity: '1',
    orderType: 'limit',
    limitPrice: '',
    timeInForce: 'gtc'
};
/** Returns a concise display symbol from the selected product. */ function $7be5033609289db0$var$getProductDisplaySymbol(product) {
    return product?.symbolDetails?.exchangeSymbol ?? product?.exchangeSymbol ?? 'Order';
}
/** Returns a readable error message from unknown service failures. */ function $7be5033609289db0$var$getErrorMessage(error) {
    return error instanceof Error ? error.message : String(error);
}
/** Creates a session-local submission record that powers the compact order status list. */ function $7be5033609289db0$var$createSubmission({ draft: draft, status: status, message: message, serviceOrder: serviceOrder }) {
    const clientId = `mobile-${Date.now()}`;
    const orderId = serviceOrder?.orderId ?? serviceOrder?.clientOrderId ?? clientId;
    const accountLabel = draft.accountId ?? 'No account';
    return {
        id: orderId,
        clientId: clientId,
        symbol: $7be5033609289db0$var$getProductDisplaySymbol(draft.product),
        accountLabel: accountLabel,
        side: draft.side,
        quantity: Number.parseFloat(draft.quantity) || 0,
        orderType: draft.orderType,
        limitPrice: draft.orderType === 'limit' ? draft.limitPrice : undefined,
        status: status,
        timestamp: new Date().toISOString(),
        message: message,
        serviceOrder: serviceOrder
    };
}
/** Builds segmented button classes from active state and optional semantic color tone. */ function $7be5033609289db0$var$getSegmentedButtonClassName(isActive, tone) {
    return [
        isActive ? 'active' : '',
        tone ? `mobile-tone-${tone}` : ''
    ].filter(Boolean).join(' ');
}
/** Renders a two-option segmented control while preserving regular button semantics for tests and touch users. */ function $7be5033609289db0$var$SegmentedControl({ label: label, value: value, options: options, onChange: onChange }) {
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        className: "mobile-field",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                className: "mobile-field-label",
                children: label
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                className: "mobile-segmented-control",
                children: options.map((option)=>/*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                        type: "button",
                        className: $7be5033609289db0$var$getSegmentedButtonClassName(value === option.value, option.tone),
                        "aria-pressed": value === option.value,
                        onClick: ()=>{
                            onChange(option.value);
                        },
                        children: option.label
                    }, option.value))
            })
        ]
    });
}
/** Renders the compact mobile trade ticket and submits valid orders through the shared order service. */ const $7be5033609289db0$var$MobileTradePage = ({ orders: orders, onOrderSubmitted: onOrderSubmitted })=>{
    const [draft, setDraft] = (0, $lx97N.useState)($7be5033609289db0$var$initialDraft);
    const [accounts, setAccounts] = (0, $lx97N.useState)([]);
    const [accountLoadError, setAccountLoadError] = (0, $lx97N.useState)(undefined);
    const [isLoadingAccounts, setIsLoadingAccounts] = (0, $lx97N.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, $lx97N.useState)(false);
    const [submitMessage, setSubmitMessage] = (0, $lx97N.useState)(undefined);
    (0, $lx97N.useEffect)(()=>{
        let cancelled = false;
        /** Loads TraderDB accounts once so account filtering can happen locally after symbol selection. */ async function loadAccounts() {
            try {
                const traderAccounts = await (0, $9vFCJ.getUserAccountsFromTraderDB)();
                if (!cancelled) {
                    setAccounts(traderAccounts);
                    setAccountLoadError(undefined);
                }
            } catch (error) {
                if (!cancelled) setAccountLoadError($7be5033609289db0$var$getErrorMessage(error));
            } finally{
                if (!cancelled) setIsLoadingAccounts(false);
            }
        }
        loadAccounts();
        return ()=>{
            cancelled = true;
        };
    }, []);
    const tradableAccounts = (0, $lx97N.useMemo)(()=>(0, $b9363c48738ff0d2$export$24fabee03d37c346)(accounts, draft.product), [
        accounts,
        draft.product
    ]);
    const errors = (0, $b9363c48738ff0d2$export$368f6da79e6cd790)(draft);
    const selectedSymbol = $7be5033609289db0$var$getProductDisplaySymbol(draft.product);
    const latestOrder = orders[0];
    const hasErrors = Object.keys(errors).length > 0;
    (0, $lx97N.useEffect)(()=>{
        if (!draft.product) return;
        const hasSelectedAccount = tradableAccounts.some((account)=>account.id === draft.accountId);
        if (!hasSelectedAccount) setDraft((previous)=>({
                ...previous,
                accountId: tradableAccounts[0]?.id
            }));
    }, [
        draft.accountId,
        draft.product,
        tradableAccounts
    ]);
    const updateDraft = (0, $lx97N.useCallback)((changes)=>{
        setDraft((previous)=>({
                ...previous,
                ...changes
            }));
        setSubmitMessage(undefined);
    }, []);
    const handleSymbolChange = (0, $lx97N.useCallback)((products)=>{
        const [product] = products;
        updateDraft({
            product: product,
            accountId: undefined
        });
    }, [
        updateDraft
    ]);
    const handleSubmit = (0, $lx97N.useCallback)(async ()=>{
        setSubmitMessage(undefined);
        if (hasErrors || isSubmitting) return;
        try {
            setIsSubmitting(true);
            const payload = (0, $b9363c48738ff0d2$export$22f9acc9b7f6662d)(draft, accounts);
            const serviceOrder = await (0, $jq43i.placeOrder)(payload);
            const acceptedOrder = $7be5033609289db0$var$createSubmission({
                draft: draft,
                status: 'accepted',
                serviceOrder: serviceOrder,
                message: 'Order accepted.'
            });
            onOrderSubmitted(acceptedOrder);
            setSubmitMessage('Order accepted.');
        } catch (error) {
            const message = $7be5033609289db0$var$getErrorMessage(error);
            const rejectedOrder = $7be5033609289db0$var$createSubmission({
                draft: draft,
                status: 'rejected',
                message: message
            });
            onOrderSubmitted(rejectedOrder);
            setSubmitMessage(message);
        } finally{
            setIsSubmitting(false);
        }
    }, [
        accounts,
        draft,
        hasErrors,
        isSubmitting,
        onOrderSubmitted
    ]);
    const submitLabel = `${draft.side === 'buy' ? 'Buy' : 'Sell'} ${selectedSymbol}`;
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("article", {
        className: "mobile-trade-page",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("header", {
                className: "mobile-page-header",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                className: "mobile-eyebrow",
                                children: "Manual Order"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("h1", {
                                children: "Trade"
                            })
                        ]
                    }),
                    latestOrder && /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        className: `mobile-status-chip ${latestOrder.status}`,
                        children: latestOrder.status
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fRwNr.jsxs)("section", {
                className: "mobile-ticket-panel",
                "aria-label": "Mobile manual order ticket",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "mobile-symbol-field",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("label", {
                                className: "mobile-field-label",
                                children: "Symbol"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $jgKwB.SymbolPicker), {
                                mode: "single",
                                enabledFilters: [
                                    'Future'
                                ],
                                placeholder: "Search symbol",
                                className: "mobile-symbol-picker",
                                onChange: handleSymbolChange
                            }),
                            draft.product && /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                className: "mobile-selected-symbol",
                                children: selectedSymbol
                            }),
                            errors.symbol && /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                className: "mobile-error-text",
                                children: errors.symbol
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "mobile-field",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("label", {
                                htmlFor: "mobile-account",
                                children: "Account"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsxs)("select", {
                                id: "mobile-account",
                                value: draft.accountId ?? '',
                                disabled: isLoadingAccounts || !draft.product,
                                onChange: (event)=>{
                                    updateDraft({
                                        accountId: event.target.value || undefined
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("option", {
                                        value: "",
                                        children: isLoadingAccounts ? 'Loading accounts...' : 'Select account'
                                    }),
                                    tradableAccounts.map((account)=>/*#__PURE__*/ (0, $fRwNr.jsx)("option", {
                                            value: account.id,
                                            children: account.description || account.code
                                        }, account.id))
                                ]
                            }),
                            errors.account && /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                className: "mobile-error-text",
                                children: errors.account
                            }),
                            accountLoadError && /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                className: "mobile-error-text",
                                children: accountLoadError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)($7be5033609289db0$var$SegmentedControl, {
                        label: "Side",
                        value: draft.side,
                        options: [
                            {
                                value: 'buy',
                                label: 'Buy',
                                tone: 'buy'
                            },
                            {
                                value: 'sell',
                                label: 'Sell',
                                tone: 'sell'
                            }
                        ],
                        onChange: (side)=>{
                            updateDraft({
                                side: side
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "mobile-field",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("label", {
                                htmlFor: "mobile-quantity",
                                children: "Quantity"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("input", {
                                id: "mobile-quantity",
                                type: "number",
                                min: "0",
                                step: "1",
                                value: draft.quantity,
                                onChange: (event)=>{
                                    updateDraft({
                                        quantity: event.target.value
                                    });
                                }
                            }),
                            errors.quantity && /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                className: "mobile-error-text",
                                children: errors.quantity
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)($7be5033609289db0$var$SegmentedControl, {
                        label: "Type",
                        value: draft.orderType,
                        options: [
                            {
                                value: 'market',
                                label: 'Market'
                            },
                            {
                                value: 'limit',
                                label: 'Limit'
                            }
                        ],
                        onChange: (orderType)=>{
                            updateDraft({
                                orderType: orderType
                            });
                        }
                    }),
                    draft.orderType === 'limit' && /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "mobile-field",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("label", {
                                htmlFor: "mobile-limit-price",
                                children: "Limit Price"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("input", {
                                id: "mobile-limit-price",
                                type: "number",
                                min: "0",
                                step: "0.01",
                                value: draft.limitPrice,
                                onChange: (event)=>{
                                    updateDraft({
                                        limitPrice: event.target.value
                                    });
                                }
                            }),
                            errors.limitPrice && /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                className: "mobile-error-text",
                                children: errors.limitPrice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "mobile-field",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("label", {
                                htmlFor: "mobile-tif",
                                children: "TIF"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsxs)("select", {
                                id: "mobile-tif",
                                value: draft.timeInForce,
                                onChange: (event)=>{
                                    updateDraft({
                                        timeInForce: event.target.value === 'rth' ? 'rth' : 'gtc'
                                    });
                                },
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("option", {
                                        value: "rth",
                                        children: "RTH"
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("option", {
                                        value: "gtc",
                                        children: "GTC"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "mobile-quote-strip",
                        "aria-label": "Market quote summary",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                children: "Bid --"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                children: "Ask --"
                            })
                        ]
                    }),
                    submitMessage && /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: "mobile-submit-message",
                        children: submitMessage
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                        type: "button",
                        className: `mobile-submit-button ${draft.side}`,
                        disabled: hasErrors || isSubmitting,
                        onClick: ()=>{
                            handleSubmit();
                        },
                        children: isSubmitting ? 'Submitting...' : submitLabel
                    })
                ]
            })
        ]
    });
};
var $7be5033609289db0$export$2e2bcd8739ae039 = $7be5033609289db0$var$MobileTradePage;


/* Renders the compact mobile order summary view with local submission feedback as a secondary section. */ 
var $fRwNr = parcelRequire("fRwNr");
parcelRequire("lx97N");
const $29c5cb980bb3923b$var$statusLabels = {
    pending: 'Pending',
    accepted: 'Accepted',
    rejected: 'Rejected'
};
/** Formats an ISO timestamp into a compact intraday order-list timestamp. */ function $29c5cb980bb3923b$var$formatOrderTime(timestamp) {
    return new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit'
    }).format(new Date(timestamp));
}
/** Maps order sides into CSS tone names so compact rows can carry side color without service coupling. */ function $29c5cb980bb3923b$var$getSummarySideTone(sideLabel) {
    const normalizedSide = sideLabel.trim().toLowerCase();
    if (normalizedSide === 'buy') return 'buy';
    if (normalizedSide === 'sell') return 'sell';
    if (normalizedSide === 'algo') return 'algo';
    return 'neutral';
}
/** Builds the compact summary card class list from order status and side display fields. */ function $29c5cb980bb3923b$var$getSummaryCardClassName(order) {
    const sideTone = $29c5cb980bb3923b$var$getSummarySideTone(order.sideLabel);
    return [
        'mobile-order-card',
        'mobile-summary-card',
        'mobile-summary-card-dense',
        `mobile-summary-card-${order.statusTone}`,
        `mobile-summary-side-${sideTone}`
    ].join(' ');
}
/** Renders one single-row live order summary card optimized for phone-width status scanning. */ function $29c5cb980bb3923b$var$MobileOrderSummaryCard({ order: order }) {
    const sideTone = $29c5cb980bb3923b$var$getSummarySideTone(order.sideLabel);
    return /*#__PURE__*/ (0, $fRwNr.jsx)("article", {
        "aria-label": `Order ${order.traderLabel} ${order.symbolLabel}`,
        className: $29c5cb980bb3923b$var$getSummaryCardClassName(order),
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
            className: "mobile-summary-dense-row",
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                    className: `mobile-side-pill mobile-side-pill-${sideTone}`,
                    "aria-label": `Side ${order.sideLabel}`,
                    children: [
                        "Side ",
                        order.sideLabel
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                    className: `mobile-status-chip mobile-state-chip summary-${order.statusTone}`,
                    "aria-label": `State ${order.statusLabel}`,
                    children: [
                        "State ",
                        order.statusLabel
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("strong", {
                    children: order.symbolLabel
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                    className: "mobile-trader-label",
                    children: order.traderLabel
                }),
                /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                    children: [
                        "Qty ",
                        order.orderQuantity
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                    children: [
                        "@ ",
                        order.priceLabel
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                    children: [
                        order.filledQuantity,
                        "/",
                        order.orderQuantity
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                    children: [
                        order.remainingQuantity,
                        " left"
                    ]
                })
            ]
        })
    });
}
/** Renders one mobile-submission status row for immediate local feedback after submit. */ function $29c5cb980bb3923b$var$MobileSessionOrderCard({ order: order }) {
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("article", {
        className: `mobile-order-card mobile-session-card mobile-session-card-${order.status}`,
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "mobile-summary-primary",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("strong", {
                                children: order.id
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                children: order.symbol
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        className: `mobile-status-chip ${order.status}`,
                        children: $29c5cb980bb3923b$var$statusLabels[order.status]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "mobile-summary-details",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                        children: [
                            order.side === 'buy' ? 'Buy' : 'Sell',
                            " ",
                            order.quantity
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        children: order.orderType === 'limit' ? 'Limit' : 'Market'
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        children: order.limitPrice ?? 'MKT'
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        children: $29c5cb980bb3923b$var$formatOrderTime(order.timestamp)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                className: "mobile-order-account",
                children: order.accountLabel
            }),
            order.message && /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                className: "mobile-order-message",
                children: order.message
            })
        ]
    });
}
/** Renders order summary cards first, then newest-first local mobile submission status cards. */ const $29c5cb980bb3923b$var$MobileOrdersPage = ({ orders: orders, summaryErrorMessage: summaryErrorMessage, summaryOrders: summaryOrders })=>/*#__PURE__*/ (0, $fRwNr.jsxs)("article", {
        className: "mobile-orders-page",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("header", {
                className: "mobile-page-header",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                className: "mobile-eyebrow",
                                children: "Order Summary"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("h1", {
                                children: "Orders"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        className: "mobile-order-count",
                        children: summaryOrders.length
                    })
                ]
            }),
            summaryErrorMessage && /*#__PURE__*/ (0, $fRwNr.jsx)("section", {
                className: "mobile-orders-alert",
                role: "status",
                children: summaryErrorMessage
            }),
            summaryOrders.length === 0 ? /*#__PURE__*/ (0, $fRwNr.jsxs)("section", {
                className: "mobile-empty-orders",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("h2", {
                        children: "No order summary yet"
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                        children: "Order Summary updates will appear here when the stream sends records."
                    })
                ]
            }) : /*#__PURE__*/ (0, $fRwNr.jsx)("section", {
                className: "mobile-order-list",
                "aria-label": "Order summary",
                children: summaryOrders.map((order)=>/*#__PURE__*/ (0, $fRwNr.jsx)($29c5cb980bb3923b$var$MobileOrderSummaryCard, {
                        order: order
                    }, order.id))
            }),
            orders.length > 0 && /*#__PURE__*/ (0, $fRwNr.jsxs)("section", {
                className: "mobile-session-orders",
                "aria-label": "Recent mobile submissions",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "mobile-section-heading",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("h2", {
                                children: "Recent Mobile Submissions"
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                children: orders.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: "mobile-order-list",
                        children: orders.map((order)=>/*#__PURE__*/ (0, $fRwNr.jsx)($29c5cb980bb3923b$var$MobileSessionOrderCard, {
                                order: order
                            }, order.clientId))
                    })
                ]
            })
        ]
    });
var $29c5cb980bb3923b$export$2e2bcd8739ae039 = $29c5cb980bb3923b$var$MobileOrdersPage;


/* Manages the session-local order status list used by the compact mobile shell. */ const $184329fa391f4bd5$export$a855034b8be4fda8 = 100;
function $184329fa391f4bd5$export$f4f3fe85683511f7(orders) {
    return [
        ...orders
    ].sort((left, right)=>new Date(right.timestamp).getTime() - new Date(left.timestamp).getTime());
}
function $184329fa391f4bd5$export$50f05823ef35710f(orders, order, maxOrders = $184329fa391f4bd5$export$a855034b8be4fda8) {
    return [
        order,
        ...orders.filter((candidate)=>candidate.clientId !== order.clientId)
    ].slice(0, maxOrders);
}


/* Adapts the desktop order summary subscription into compact records for the browser mobile Orders screen. */ 
var $lx97N = parcelRequire("lx97N");

var $cckdX = parcelRequire("cckdX");
const $7862ab3085227212$var$notAvailableLabel = 'Unknown';
const $7862ab3085227212$var$unknownTraderLabel = 'Unknown trader';
const $7862ab3085227212$var$replacingTopics = new Set([
    'INITIAL',
    'RESET'
]);
const $7862ab3085227212$var$statusDisplayByValue = new Map([
    [
        (0, $cckdX.OrderState).ORDERSTATE_PARTIAL_FILLED,
        {
            label: 'Partial',
            tone: 'partial'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_PENDING_REPLACE,
        {
            label: 'Partial',
            tone: 'partial'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_CALCULATED,
        {
            label: 'Partial',
            tone: 'partial'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_FILLED,
        {
            label: 'Filled',
            tone: 'filled'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_REJECTED,
        {
            label: 'Rejected',
            tone: 'rejected'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_CANCEL_REJECTED,
        {
            label: 'Rejected',
            tone: 'rejected'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_PENDING_NEW,
        {
            label: 'Pending New',
            tone: 'pending'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_ACKNOWLEDGED,
        {
            label: 'Pending New',
            tone: 'pending'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_PENDING_CANCEL,
        {
            label: 'Pending Cancel',
            tone: 'cancelled'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_PAUSED,
        {
            label: 'Paused',
            tone: 'cancelled'
        }
    ],
    [
        (0, $cckdX.OrderState).ORDERSTATE_NEW,
        {
            label: 'Open',
            tone: 'open'
        }
    ]
]);
/** Converts unknown service errors into copy that fits the compact mobile Orders status row. */ function $7862ab3085227212$var$getOrderSummaryErrorMessage(error) {
    if (error instanceof Error && error.message.trim()) return error.message;
    if (typeof error === 'string' && error.trim()) return error;
    return 'Order summary is unavailable.';
}
function $7862ab3085227212$export$1d08905c78a177c0(source = globalThis) {
    return source.QEP?.apiServices?.orderSummary ?? source.window?.QEP?.apiServices?.orderSummary;
}
/** Returns a subscription payload as an array so INITIAL, RESET, and UPDATE records share one reducer path. */ function $7862ab3085227212$var$getOrderSummaryPayloadRecords(update) {
    if (!update?.payload) return [];
    return Array.isArray(update.payload) ? update.payload : [
        update.payload
    ];
}
/** Parses numeric service values while tolerating the stringified quantities used by order summary payloads. */ function $7862ab3085227212$var$toFiniteNumber(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value !== 'string') return undefined;
    const normalized = Number(value.replaceAll(',', '').trim());
    return Number.isFinite(normalized) ? normalized : undefined;
}
/** Returns a trimmed display string so mobile rows do not render empty or symbolic placeholders. */ function $7862ab3085227212$var$toDisplayLabel(value, fallback = $7862ab3085227212$var$notAvailableLabel) {
    if (typeof value !== 'string') return fallback;
    const trimmedValue = value.trim();
    return trimmedValue || fallback;
}
/** Normalizes enum payloads that may arrive as strings from order summary subscriptions. */ function $7862ab3085227212$var$normalizeServiceEnumValue(value) {
    if (typeof value !== 'string') return value;
    const trimmedValue = value.trim();
    if (!trimmedValue) return undefined;
    const numericValue = Number(trimmedValue);
    return Number.isFinite(numericValue) ? numericValue : trimmedValue;
}
/** Formats a quantity for dense mobile cards without trailing decimals when the value is whole. */ function $7862ab3085227212$var$formatQuantity(value, fallback = '0') {
    const numericValue = $7862ab3085227212$var$toFiniteNumber(value);
    if (numericValue === undefined) return fallback;
    return Number.isInteger(numericValue) ? String(numericValue) : String(numericValue);
}
/** Formats a nullable price, returning MKT when a market order or missing price has no display value. */ function $7862ab3085227212$var$formatPrice(record) {
    const price = record.orderPx ?? record.orderPrice ?? record.targetOrderPrice ?? record.price;
    const numericPrice = $7862ab3085227212$var$toFiniteNumber(price);
    if (numericPrice === undefined) return $7862ab3085227212$var$normalizeServiceEnumValue(record.orderType) === (0, $cckdX.OrderType).ORDERTYPE_LIMIT ? $7862ab3085227212$var$notAvailableLabel : 'MKT';
    return String(numericPrice);
}
/** Resolves the account label across raw service records and normalized order summary grid records. */ function $7862ab3085227212$var$getAccountLabel(account) {
    if (!account) return $7862ab3085227212$var$notAvailableLabel;
    if (typeof account === 'string') return $7862ab3085227212$var$toDisplayLabel(account);
    const tradingAccount = account;
    return $7862ab3085227212$var$toDisplayLabel(tradingAccount.code ?? tradingAccount.accountCode ?? tradingAccount.id, $7862ab3085227212$var$notAvailableLabel);
}
/** Picks the shortest recognizable symbol label from raw product records and normalized order summary rows. */ function $7862ab3085227212$var$getSymbolLabel(record) {
    const recordWithStringSymbol = record;
    if (typeof recordWithStringSymbol.symbol === 'string') return $7862ab3085227212$var$toDisplayLabel(recordWithStringSymbol.symbol);
    return recordWithStringSymbol.symbol?.symbol ?? record.exchangeSymbol ?? record.fixSymbol ?? record.qepSymbol ?? record.root ?? $7862ab3085227212$var$notAvailableLabel;
}
/** Reads the symbol and MIC fields used to disambiguate spread-leg order summary rows. */ function $7862ab3085227212$var$getSpreadLegIdentitySymbol(record) {
    if (!record.symbol || typeof record.symbol !== 'object') return {
        segmentMic: '',
        symbol: ''
    };
    const symbol = record.symbol;
    return {
        segmentMic: typeof symbol.segmentMic === 'string' ? symbol.segmentMic : '',
        symbol: typeof symbol.symbol === 'string' ? symbol.symbol : ''
    };
}
/** Builds a stable manual order row id that matches replay keying for spread legs sharing one order id. */ function $7862ab3085227212$var$getManualOrderSummaryId(record) {
    if (typeof record.orderId === 'string' && record.orderId.length > 0 && Number($7862ab3085227212$var$normalizeServiceEnumValue(record.multiLegReportingType)) === 2) {
        const { segmentMic: segmentMic, symbol: symbol } = $7862ab3085227212$var$getSpreadLegIdentitySymbol(record);
        return `spread:${record.orderId}:${symbol}:${segmentMic}:${record.orderSide ?? ''}`;
    }
    return record.orderId ?? record.clientOrderId ?? record.key ?? record.orderRecordKey;
}
/** Converts raw order-side enum, numeric-string, and text variants into a concise mobile side label. */ function $7862ab3085227212$var$normalizeSideLabel(value) {
    const normalizedValue = $7862ab3085227212$var$normalizeServiceEnumValue(value);
    if (normalizedValue === (0, $cckdX.OrderSide).ORDERSIDE_BUY) return 'Buy';
    if (normalizedValue === (0, $cckdX.OrderSide).ORDERSIDE_SELL) return 'Sell';
    if (typeof normalizedValue !== 'string') return undefined;
    const normalizedText = normalizedValue.trim().toLowerCase();
    if ([
        '-',
        'n/a',
        'na',
        'unknown'
    ].includes(normalizedText)) return undefined;
    if (normalizedText === 'buy' || normalizedText === 'b') return 'Buy';
    if (normalizedText === 'sell' || normalizedText === 's') return 'Sell';
    return normalizedValue.trim();
}
/** Converts order side enum/string values into human-readable Buy/Sell labels for mobile cards. */ function $7862ab3085227212$var$getSideLabel(record) {
    return $7862ab3085227212$var$normalizeSideLabel(record.side) ?? $7862ab3085227212$var$normalizeSideLabel(record.orderSide) ?? $7862ab3085227212$var$normalizeSideLabel(record.orderSideString) ?? $7862ab3085227212$var$notAvailableLabel;
}
/** Converts order type enum/string values into the concise labels expected in the mobile summary card. */ function $7862ab3085227212$var$getOrderTypeLabel(orderType) {
    const normalizedOrderType = $7862ab3085227212$var$normalizeServiceEnumValue(orderType);
    if (normalizedOrderType === (0, $cckdX.OrderType).ORDERTYPE_LIMIT) return 'Limit';
    if (normalizedOrderType === (0, $cckdX.OrderType).ORDERTYPE_MARKET) return 'Market';
    if (normalizedOrderType === (0, $cckdX.OrderType).ORDERTYPE_STOP) return 'Stop';
    if (normalizedOrderType === (0, $cckdX.OrderType).ORDERTYPE_STOP_LIMIT) return 'Stop Limit';
    if (typeof normalizedOrderType === 'string' || typeof normalizedOrderType === 'number') return String(normalizedOrderType);
    return $7862ab3085227212$var$notAvailableLabel;
}
/** Resolves trader identity from the variants sent by manual and normalized order summary payloads. */ function $7862ab3085227212$var$getTraderLabel(record) {
    const { traderInfo: traderInfo } = record;
    if (typeof traderInfo === 'string') return $7862ab3085227212$var$toDisplayLabel(traderInfo, $7862ab3085227212$var$unknownTraderLabel);
    if (traderInfo && typeof traderInfo === 'object') {
        const typedTraderInfo = traderInfo;
        return typedTraderInfo.name ?? typedTraderInfo.username ?? typedTraderInfo.traderId ?? $7862ab3085227212$var$unknownTraderLabel;
    }
    return $7862ab3085227212$var$toDisplayLabel(record.trader ?? record.traderId ?? record.trader_id, $7862ab3085227212$var$unknownTraderLabel);
}
/** Converts text status strings into status labels and tones while avoiding raw numeric fallbacks. */ function $7862ab3085227212$var$getTextStatusDisplay(status) {
    const normalizedStatus = status.trim().toLowerCase();
    if (!normalizedStatus || [
        '-',
        'n/a',
        'na',
        'unknown'
    ].includes(normalizedStatus)) return undefined;
    if (normalizedStatus.includes('reject')) return {
        label: status,
        tone: 'rejected'
    };
    if (normalizedStatus.includes('cancel') || normalizedStatus.includes('expire') || normalizedStatus.includes('pause') || normalizedStatus.includes('stop')) return {
        label: status,
        tone: 'cancelled'
    };
    if (normalizedStatus.includes('partial')) return {
        label: status,
        tone: 'partial'
    };
    if (normalizedStatus.includes('fill')) return {
        label: status,
        tone: 'filled'
    };
    if (normalizedStatus.includes('pending') || normalizedStatus.includes('ack')) return {
        label: status,
        tone: 'pending'
    };
    if (normalizedStatus === 'new' || normalizedStatus === 'open') return {
        label: status,
        tone: 'open'
    };
    return {
        label: status,
        tone: 'open'
    };
}
/** Converts order state enum/string values into concise labels and color tones for summary chips. */ function $7862ab3085227212$var$getStatusDisplay(record) {
    const status = $7862ab3085227212$var$normalizeServiceEnumValue(record.status ?? record.orderStatus ?? record.statusString);
    if (status === (0, $cckdX.OrderState).ORDERSTATE_CANCELED || status === (0, $cckdX.OrderState).ORDERSTATE_EXPIRED) return {
        label: $7862ab3085227212$var$toFiniteNumber(record.totalFillQty ?? record.totalFilled) ? 'Canceled Partial' : 'Canceled',
        tone: 'cancelled'
    };
    const knownStatusDisplay = $7862ab3085227212$var$statusDisplayByValue.get(status);
    if (knownStatusDisplay) return knownStatusDisplay;
    if (typeof status === 'string') return $7862ab3085227212$var$getTextStatusDisplay(status) ?? {
        label: $7862ab3085227212$var$notAvailableLabel,
        tone: 'open'
    };
    if (status === undefined || status === null) return {
        label: $7862ab3085227212$var$notAvailableLabel,
        tone: 'open'
    };
    return {
        label: $7862ab3085227212$var$notAvailableLabel,
        tone: 'open'
    };
}
/** Parses the most useful timestamp on an order summary record for display and newest-first sorting. */ function $7862ab3085227212$var$getOrderTimestamp(record) {
    const timestamp = record.transactionTime ?? record.sendingTimeUTC ?? record.createdAt ?? record.initialOrderTime ?? record.lastUpdateTime;
    const parsedTime = timestamp ? new Date(timestamp).getTime() : Number.NaN;
    if (!Number.isFinite(parsedTime)) return {
        label: $7862ab3085227212$var$notAvailableLabel,
        sortTime: 0
    };
    return {
        label: new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',
            minute: '2-digit'
        }).format(new Date(parsedTime)),
        sortTime: parsedTime
    };
}
/** Detects algo reports so mobile can display them without the desktop order summary grid converter. */ function $7862ab3085227212$var$isAlgoSummaryRecord(record) {
    return 'algoRunId' in record && typeof record.algoRunId === 'string';
}
/** Sums an algo-trade numeric field while tolerating missing or stringified upstream values. */ function $7862ab3085227212$var$sumAlgoTradeQuantity(record, field) {
    return record.algoTrades.reduce((total, trade)=>total + ($7862ab3085227212$var$toFiniteNumber(trade[field]) ?? 0), 0);
}
/** Builds a compact symbol label for algo records that can contain one or many underlying trades. */ function $7862ab3085227212$var$getAlgoSymbolLabel(record) {
    const explicitSymbols = record.symbolsWithQTY ?? record.symbols;
    if (Array.isArray(explicitSymbols) && explicitSymbols.length > 0) {
        const firstSymbol = explicitSymbols[0];
        return typeof firstSymbol === 'string' ? $7862ab3085227212$var$toDisplayLabel(firstSymbol) : firstSymbol?.symbol ?? $7862ab3085227212$var$notAvailableLabel;
    }
    return record.algoTrades[0]?.symbol?.symbol ?? record.algoTrades[0]?.qepSymbol ?? $7862ab3085227212$var$notAvailableLabel;
}
/** Converts algo summary records into one compact row keyed by algo run id. */ function $7862ab3085227212$var$toMobileAlgoSummaryRecord(record) {
    const targetQuantity = $7862ab3085227212$var$sumAlgoTradeQuantity(record, 'targetQuantity');
    const filledQuantity = record.algoMetrics?.tradedQuantityOverall ?? $7862ab3085227212$var$sumAlgoTradeQuantity(record, 'tradedQuantity');
    const remainingQuantity = $7862ab3085227212$var$sumAlgoTradeQuantity(record, 'remainingQuantity');
    const timestamp = $7862ab3085227212$var$getOrderTimestamp({
        lastUpdateTime: record.lastUpdated ? new Date(record.lastUpdated) : undefined,
        transactionTime: record.latestStatusDate ? new Date(record.latestStatusDate) : undefined
    });
    return {
        accountLabel: record.accountInfo?.executionCode ?? record.accountInfo?.clearingAccount ?? $7862ab3085227212$var$notAvailableLabel,
        filledQuantity: $7862ab3085227212$var$formatQuantity(filledQuantity),
        id: record.orderId ?? record.key ?? record.algoRunId,
        orderQuantity: $7862ab3085227212$var$formatQuantity(record.algoMetrics?.targetQuantityOverall ?? targetQuantity),
        orderTypeLabel: record.algoType || 'Algo',
        priceLabel: $7862ab3085227212$var$notAvailableLabel,
        remainingQuantity: $7862ab3085227212$var$formatQuantity(remainingQuantity),
        sideLabel: 'Algo',
        sortTime: timestamp.sortTime,
        statusLabel: record.algoStatus || 'Algo',
        statusTone: record.completedDate ? 'filled' : 'open',
        symbolLabel: $7862ab3085227212$var$getAlgoSymbolLabel(record),
        timeLabel: timestamp.label,
        traderLabel: record.accountInfo?.traderId ?? $7862ab3085227212$var$unknownTraderLabel
    };
}
function $7862ab3085227212$export$ba88916e40026ce(record) {
    if ($7862ab3085227212$var$isAlgoSummaryRecord(record)) return $7862ab3085227212$var$toMobileAlgoSummaryRecord(record);
    const id = $7862ab3085227212$var$getManualOrderSummaryId(record);
    if (!id) return undefined;
    const orderQuantity = record.orderQty ?? record.orderQuantity ?? record.quantity;
    const filledQuantity = record.totalFillQty ?? record.totalFilled ?? record.fillQuantity;
    const orderQuantityNumber = $7862ab3085227212$var$toFiniteNumber(orderQuantity);
    const filledQuantityNumber = $7862ab3085227212$var$toFiniteNumber(filledQuantity) ?? 0;
    const remainingQuantity = record.remainingQty ?? (orderQuantityNumber === undefined ? undefined : Math.max(orderQuantityNumber - filledQuantityNumber, 0));
    const status = $7862ab3085227212$var$getStatusDisplay(record);
    const timestamp = $7862ab3085227212$var$getOrderTimestamp(record);
    return {
        accountLabel: $7862ab3085227212$var$getAccountLabel(record.account),
        filledQuantity: $7862ab3085227212$var$formatQuantity(filledQuantity),
        id: id,
        orderQuantity: $7862ab3085227212$var$formatQuantity(orderQuantity),
        orderTypeLabel: $7862ab3085227212$var$getOrderTypeLabel(record.orderType),
        priceLabel: $7862ab3085227212$var$formatPrice(record),
        remainingQuantity: $7862ab3085227212$var$formatQuantity(remainingQuantity),
        sideLabel: $7862ab3085227212$var$getSideLabel(record),
        sortTime: timestamp.sortTime,
        statusLabel: status.label,
        statusTone: status.tone,
        strategyLabel: record.strategy ?? record.executionTag,
        symbolLabel: $7862ab3085227212$var$getSymbolLabel(record),
        timeLabel: timestamp.label,
        traderLabel: $7862ab3085227212$var$getTraderLabel(record)
    };
}
function $7862ab3085227212$export$8e325ba3365a9297(orders) {
    return [
        ...orders
    ].sort((left, right)=>right.sortTime - left.sortTime || right.id.localeCompare(left.id));
}
function $7862ab3085227212$export$fd839f8dbf130e67(previousOrders, update) {
    const nextOrders = $7862ab3085227212$var$getOrderSummaryPayloadRecords(update).map((record)=>$7862ab3085227212$export$ba88916e40026ce(record)).filter((record)=>record !== undefined);
    if (!update?.topic || $7862ab3085227212$var$replacingTopics.has(update.topic)) return $7862ab3085227212$export$8e325ba3365a9297(nextOrders);
    const byId = new Map(previousOrders.map((order)=>[
            order.id,
            order
        ]));
    for (const order of nextOrders)byId.set(order.id, order);
    return $7862ab3085227212$export$8e325ba3365a9297([
        ...byId.values()
    ]);
}
function $7862ab3085227212$export$73955bc0e10f5eed() {
    const [state, setState] = (0, $lx97N.useState)({
        orders: []
    });
    (0, $lx97N.useEffect)(()=>{
        const subscribeToOrderSummary = $7862ab3085227212$export$1d08905c78a177c0()?.subscribeToOrderSummary;
        if (!subscribeToOrderSummary) {
            setState({
                errorMessage: 'Order summary is unavailable.',
                orders: []
            });
            return undefined;
        }
        let isMounted = true;
        const unsubscribe = subscribeToOrderSummary((error, update)=>{
            if (!isMounted) return;
            if (error) {
                setState((previous)=>({
                        ...previous,
                        errorMessage: $7862ab3085227212$var$getOrderSummaryErrorMessage(error)
                    }));
                return;
            }
            setState((previous)=>({
                    errorMessage: undefined,
                    orders: $7862ab3085227212$export$fd839f8dbf130e67(previous.orders, update)
                }));
        }, 'Browser Mobile Orders');
        return ()=>{
            isMounted = false;
            unsubscribe?.();
        };
    }, []);
    return state;
}


/* Detects whether the authenticated browser shell should render the compact mobile/tablet app. */ const $6139c2c725da4b69$export$475305d4a6b19fe2 = 768;
const $6139c2c725da4b69$export$91c74bd42472c6dd = 1180;
/** Returns whether the viewport reports a touch-first coarse pointer. */ function $6139c2c725da4b69$var$hasCoarsePointer(viewport) {
    return typeof viewport.matchMedia === 'function' && viewport.matchMedia('(pointer: coarse)').matches;
}
/** Detects iPads that report a desktop Safari user agent but still expose multi-touch Mac hardware. */ function $6139c2c725da4b69$var$isDesktopUserAgentIpad(navigator) {
    return navigator.platform === 'MacIntel' && (navigator.maxTouchPoints ?? 0) > 1;
}
/** Detects phone-class user agents so landscape phones keep the tabbed layout. */ function $6139c2c725da4b69$var$isPhoneUserAgent(navigator) {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipod|mobi|opera mini|iemobile|wpdesktop/i.test(userAgent) || userAgent.includes('android') && userAgent.includes('mobile');
}
function $6139c2c725da4b69$export$713066d5f49c53c8(viewport = globalThis) {
    const userAgent = viewport.navigator.userAgent.toLowerCase();
    const hasMobileUserAgent = /mobi|android|iphone|ipad|ipod|opera mini|iemobile|wpdesktop|tablet/i.test(userAgent);
    const isPhoneViewport = viewport.innerWidth <= $6139c2c725da4b69$export$475305d4a6b19fe2;
    const isTouchTabletViewport = viewport.innerWidth <= $6139c2c725da4b69$export$91c74bd42472c6dd && $6139c2c725da4b69$var$hasCoarsePointer(viewport);
    return hasMobileUserAgent || $6139c2c725da4b69$var$isDesktopUserAgentIpad(viewport.navigator) || isPhoneViewport || isTouchTabletViewport;
}
function $6139c2c725da4b69$export$46cce7747cdf479a(viewport = globalThis) {
    return $6139c2c725da4b69$export$713066d5f49c53c8(viewport) && viewport.innerWidth >= $6139c2c725da4b69$export$475305d4a6b19fe2 && !$6139c2c725da4b69$var$isPhoneUserAgent(viewport.navigator);
}


/** Tracks whether the already-selected mobile shell has enough width for the tablet split layout. */ function $f9a6beb82d30d817$var$useTabletSplitLayout() {
    const [isTabletSplit, setIsTabletSplit] = (0, $lx97N.useState)(()=>(0, $6139c2c725da4b69$export$46cce7747cdf479a)());
    (0, $lx97N.useEffect)(()=>{
        /** Recomputes tablet split state when the mobile shell viewport changes. */ function handleResize() {
            setIsTabletSplit((0, $6139c2c725da4b69$export$46cce7747cdf479a)());
        }
        globalThis.addEventListener('resize', handleResize);
        return ()=>{
            globalThis.removeEventListener('resize', handleResize);
        };
    }, []);
    return isTabletSplit;
}
/** Renders the mobile-only tab button with stable labels and icon affordances. */ function $f9a6beb82d30d817$var$MobileTabButton({ page: page, activePage: activePage, onSelect: onSelect, children: children }) {
    const isActive = activePage === page;
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("button", {
        type: "button",
        className: `mobile-tab-button ${isActive ? 'active' : ''}`,
        "aria-selected": isActive,
        onClick: ()=>{
            onSelect(page);
        },
        children: [
            children,
            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                children: page
            })
        ]
    });
}
/** Provides the compact mobile order shell, using tabs on phones and split panes on tablets. */ const $f9a6beb82d30d817$var$MobileApp = ()=>{
    const [activePage, setActivePage] = (0, $lx97N.useState)('Trade');
    const [orders, setOrders] = (0, $lx97N.useState)([]);
    const isTabletSplit = $f9a6beb82d30d817$var$useTabletSplitLayout();
    const orderSummary = (0, $7862ab3085227212$export$73955bc0e10f5eed)();
    const newestOrders = (0, $lx97N.useMemo)(()=>(0, $184329fa391f4bd5$export$f4f3fe85683511f7)(orders), [
        orders
    ]);
    const handleOrderSubmitted = (0, $lx97N.useCallback)((order)=>{
        setOrders((previous)=>(0, $184329fa391f4bd5$export$50f05823ef35710f)(previous, order));
    }, []);
    const tradePage = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $7be5033609289db0$export$2e2bcd8739ae039), {
        orders: orders,
        onOrderSubmitted: handleOrderSubmitted
    });
    const ordersPage = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $29c5cb980bb3923b$export$2e2bcd8739ae039), {
        orders: newestOrders,
        summaryErrorMessage: orderSummary.errorMessage,
        summaryOrders: orderSummary.orders
    });
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $18c26bf3fa1baa25$export$51e651dc78bb62ed), {
        children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
            className: `mobile-app-container ${isTabletSplit ? 'tablet-split' : 'phone-tabs'}`,
            "data-testid": "mobile-app",
            children: isTabletSplit ? /*#__PURE__*/ (0, $fRwNr.jsxs)("main", {
                className: "mobile-tablet-grid",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("section", {
                        className: "mobile-pane mobile-pane-trade",
                        children: tradePage
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("section", {
                        className: "mobile-pane mobile-pane-orders",
                        children: ordersPage
                    })
                ]
            }) : /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("main", {
                        className: "mobile-phone-main mobile-phone-scroll",
                        children: activePage === 'Trade' ? tradePage : ordersPage
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("nav", {
                        className: "mobile-bottom-nav",
                        "aria-label": "Mobile order navigation",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)($f9a6beb82d30d817$var$MobileTabButton, {
                                page: "Trade",
                                activePage: activePage,
                                onSelect: setActivePage,
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $292c2c681ce28f0f$export$2e2bcd8739ae039), {
                                    "aria-hidden": "true",
                                    size: 22
                                })
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)($f9a6beb82d30d817$var$MobileTabButton, {
                                page: "Orders",
                                activePage: activePage,
                                onSelect: setActivePage,
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $6d98f6a530ac9778$export$2e2bcd8739ae039), {
                                    "aria-hidden": "true",
                                    size: 22
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $f9a6beb82d30d817$export$2e2bcd8739ae039 = $f9a6beb82d30d817$var$MobileApp;




var $fRwNr = parcelRequire("fRwNr");
/**
 * flexlayout-react
 * @version 0.9.1
 */ 
var $lx97N = parcelRequire("lx97N");

var $1amKe = parcelRequire("1amKe");

var $fRwNr = parcelRequire("fRwNr");

var $jhfT6 = parcelRequire("jhfT6");
//#region src/model/Orientation.ts
var $8041f202454d6b76$export$df54d73aa0ec5e82 = class Orientation {
    static HORZ = new Orientation("horz");
    static VERT = new Orientation("vert");
    static flip(from) {
        if (from === Orientation.HORZ) return Orientation.VERT;
        else return Orientation.HORZ;
    }
    /** @internal */ _name;
    /** @internal */ constructor(name){
        this._name = name;
    }
    getName() {
        return this._name;
    }
    toString() {
        return this._name;
    }
};
//#endregion
//#region src/model/Rect.ts
var $8041f202454d6b76$export$c79fc6492f3af13d = class Rect {
    static empty() {
        return new Rect(0, 0, 0, 0);
    }
    static fromJson(json) {
        return new Rect(json.x, json.y, json.width, json.height);
    }
    x;
    y;
    width;
    height;
    constructor(x, y, width, height){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    toJson() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    }
    snap(round) {
        this.x = Math.round(this.x / round) * round;
        this.y = Math.round(this.y / round) * round;
        this.width = Math.round(this.width / round) * round;
        this.height = Math.round(this.height / round) * round;
    }
    static getBoundingClientRect(element) {
        const { x: x, y: y, width: width, height: height } = element.getBoundingClientRect();
        return new Rect(x, y, width, height);
    }
    static getContentRect(element) {
        const rect = element.getBoundingClientRect();
        const style = window.getComputedStyle(element);
        const paddingLeft = parseFloat(style.paddingLeft);
        const paddingRight = parseFloat(style.paddingRight);
        const paddingTop = parseFloat(style.paddingTop);
        const paddingBottom = parseFloat(style.paddingBottom);
        const borderLeftWidth = parseFloat(style.borderLeftWidth);
        const borderRightWidth = parseFloat(style.borderRightWidth);
        const borderTopWidth = parseFloat(style.borderTopWidth);
        const borderBottomWidth = parseFloat(style.borderBottomWidth);
        const contentWidth = rect.width - borderLeftWidth - paddingLeft - paddingRight - borderRightWidth;
        const contentHeight = rect.height - borderTopWidth - paddingTop - paddingBottom - borderBottomWidth;
        return new Rect(rect.left + borderLeftWidth + paddingLeft, rect.top + borderTopWidth + paddingTop, contentWidth, contentHeight);
    }
    static fromDomRect(domRect) {
        return new Rect(domRect.x, domRect.y, domRect.width, domRect.height);
    }
    relativeTo(r) {
        return new Rect(this.x - r.x, this.y - r.y, this.width, this.height);
    }
    clone() {
        return new Rect(this.x, this.y, this.width, this.height);
    }
    equals(rect) {
        return this.x === rect?.x && this.y === rect?.y && this.width === rect?.width && this.height === rect?.height;
    }
    equalsWhenRounded(rect) {
        if (!rect) return false;
        const epsilon = .5;
        return Math.abs(this.x - rect.x) < epsilon && Math.abs(this.y - rect.y) < epsilon && Math.abs(this.width - rect.width) < epsilon && Math.abs(this.height - rect.height) < epsilon;
    }
    equalSize(rect) {
        return this.width === rect?.width && this.height === rect?.height;
    }
    getBottom() {
        return this.y + this.height;
    }
    getRight() {
        return this.x + this.width;
    }
    get bottom() {
        return this.y + this.height;
    }
    get right() {
        return this.x + this.width;
    }
    getCenter() {
        return {
            x: this.x + this.width / 2,
            y: this.y + this.height / 2
        };
    }
    positionElement(element, position) {
        this.styleWithPosition(element.style, position);
    }
    styleWithPosition(style, position = "absolute") {
        style.left = this.x + "px";
        style.top = this.y + "px";
        style.width = Math.max(0, this.width) + "px";
        style.height = Math.max(0, this.height) + "px";
        style.position = position;
        return style;
    }
    contains(x, y) {
        if (this.x <= x && x <= this.getRight() && this.y <= y && y <= this.getBottom()) return true;
        else return false;
    }
    removeInsets(insets) {
        return new Rect(this.x + insets.left, this.y + insets.top, Math.max(0, this.width - insets.left - insets.right), Math.max(0, this.height - insets.top - insets.bottom));
    }
    centerInRect(outerRect) {
        this.x = (outerRect.width - this.width) / 2;
        this.y = (outerRect.height - this.height) / 2;
    }
    clamp(outerRect) {
        if (this.width > outerRect.width) this.width = outerRect.width;
        if (this.height > outerRect.height) this.height = outerRect.height;
        if (this.x < outerRect.x) this.x = outerRect.x;
        if (this.y < outerRect.y) this.y = outerRect.y;
        if (this.getRight() > outerRect.getRight()) this.x = outerRect.getRight() - this.width;
        if (this.getBottom() > outerRect.getBottom()) this.y = outerRect.getBottom() - this.height;
        if (this.x < outerRect.x) this.x = outerRect.x;
        if (this.y < outerRect.y) this.y = outerRect.y;
    }
    /** @internal */ _getSize(orientation) {
        let prefSize = this.width;
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.VERT) prefSize = this.height;
        return prefSize;
    }
    toString() {
        return "(Rect: x=" + this.x + ", y=" + this.y + ", width=" + this.width + ", height=" + this.height + ")";
    }
};
//#endregion
//#region src/model/DockLocation.ts
var $8041f202454d6b76$export$5bf830809a2e00b2 = class DockLocation {
    static values = /* @__PURE__ */ new Map();
    static TOP = new DockLocation("top", $8041f202454d6b76$export$df54d73aa0ec5e82.VERT, 0);
    static BOTTOM = new DockLocation("bottom", $8041f202454d6b76$export$df54d73aa0ec5e82.VERT, 1);
    static LEFT = new DockLocation("left", $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ, 0);
    static RIGHT = new DockLocation("right", $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ, 1);
    static CENTER = new DockLocation("center", $8041f202454d6b76$export$df54d73aa0ec5e82.VERT, 0);
    /** @internal */ static getByName(name) {
        return DockLocation.values.get(name);
    }
    /** @internal */ static getLocation(rect, x, y) {
        x = (x - rect.x) / rect.width;
        y = (y - rect.y) / rect.height;
        if (x >= .25 && x < .75 && y >= .25 && y < .75) return DockLocation.CENTER;
        const bl = y >= x;
        const br = y >= 1 - x;
        if (bl) return br ? DockLocation.BOTTOM : DockLocation.LEFT;
        else return br ? DockLocation.RIGHT : DockLocation.TOP;
    }
    /** @internal */ name;
    /** @internal */ orientation;
    /** @internal */ indexPlus;
    /** @internal */ constructor(_name, _orientation, _indexPlus){
        this.name = _name;
        this.orientation = _orientation;
        this.indexPlus = _indexPlus;
        DockLocation.values.set(this.name, this);
    }
    getName() {
        return this.name;
    }
    getOrientation() {
        return this.orientation;
    }
    /** @internal */ getDockRect(r) {
        if (this === DockLocation.TOP) return new $8041f202454d6b76$export$c79fc6492f3af13d(r.x, r.y, r.width, r.height / 2);
        else if (this === DockLocation.BOTTOM) return new $8041f202454d6b76$export$c79fc6492f3af13d(r.x, r.getBottom() - r.height / 2, r.width, r.height / 2);
        if (this === DockLocation.LEFT) return new $8041f202454d6b76$export$c79fc6492f3af13d(r.x, r.y, r.width / 2, r.height);
        else if (this === DockLocation.RIGHT) return new $8041f202454d6b76$export$c79fc6492f3af13d(r.getRight() - r.width / 2, r.y, r.width / 2, r.height);
        else return r.clone();
    }
    /** @internal */ split(rect, size) {
        if (this === DockLocation.TOP) return {
            start: new $8041f202454d6b76$export$c79fc6492f3af13d(rect.x, rect.y, rect.width, size),
            end: new $8041f202454d6b76$export$c79fc6492f3af13d(rect.x, rect.y + size, rect.width, rect.height - size)
        };
        else if (this === DockLocation.LEFT) return {
            start: new $8041f202454d6b76$export$c79fc6492f3af13d(rect.x, rect.y, size, rect.height),
            end: new $8041f202454d6b76$export$c79fc6492f3af13d(rect.x + size, rect.y, rect.width - size, rect.height)
        };
        if (this === DockLocation.RIGHT) return {
            start: new $8041f202454d6b76$export$c79fc6492f3af13d(rect.getRight() - size, rect.y, size, rect.height),
            end: new $8041f202454d6b76$export$c79fc6492f3af13d(rect.x, rect.y, rect.width - size, rect.height)
        };
        else return {
            start: new $8041f202454d6b76$export$c79fc6492f3af13d(rect.x, rect.getBottom() - size, rect.width, size),
            end: new $8041f202454d6b76$export$c79fc6492f3af13d(rect.x, rect.y, rect.width, rect.height - size)
        };
    }
    /** @internal */ reflect() {
        if (this === DockLocation.TOP) return DockLocation.BOTTOM;
        else if (this === DockLocation.LEFT) return DockLocation.RIGHT;
        if (this === DockLocation.RIGHT) return DockLocation.LEFT;
        else return DockLocation.TOP;
    }
    toString() {
        return "(DockLocation: name=" + this.name + ", orientation=" + this.orientation + ")";
    }
};
//#endregion
//#region src/view/CSSClassNames.ts
var $8041f202454d6b76$export$ba41d43e4a419565 = /* @__PURE__ */ function(CLASSES) {
    CLASSES["FLEXLAYOUT__BORDER"] = "flexlayout__border";
    CLASSES["FLEXLAYOUT__BORDER_"] = "flexlayout__border_";
    CLASSES["FLEXLAYOUT__BORDER_TAB_CONTENTS"] = "flexlayout__border_tab_contents";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON"] = "flexlayout__border_button";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON_"] = "flexlayout__border_button_";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON_CONTENT"] = "flexlayout__border_button_content";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON_LEADING"] = "flexlayout__border_button_leading";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON_TRAILING"] = "flexlayout__border_button_trailing";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON__SELECTED"] = "flexlayout__border_button--selected";
    CLASSES["FLEXLAYOUT__BORDER_BUTTON__UNSELECTED"] = "flexlayout__border_button--unselected";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_OVERFLOW"] = "flexlayout__border_toolbar_button_overflow";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_OVERFLOW_"] = "flexlayout__border_toolbar_button_overflow_";
    CLASSES["FLEXLAYOUT__BORDER_INNER"] = "flexlayout__border_inner";
    CLASSES["FLEXLAYOUT__BORDER_INNER_"] = "flexlayout__border_inner_";
    CLASSES["FLEXLAYOUT__BORDER_INNER_TAB_CONTAINER"] = "flexlayout__border_inner_tab_container";
    CLASSES["FLEXLAYOUT__BORDER_INNER_TAB_CONTAINER_"] = "flexlayout__border_inner_tab_container_";
    CLASSES["FLEXLAYOUT__BORDER_TAB_DIVIDER"] = "flexlayout__border_tab_divider";
    CLASSES["FLEXLAYOUT__BORDER_LEADING"] = "flexlayout__border_leading";
    CLASSES["FLEXLAYOUT__BORDER_SIZER"] = "flexlayout__border_sizer";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR"] = "flexlayout__border_toolbar";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_"] = "flexlayout__border_toolbar_";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_BUTTON"] = "flexlayout__border_toolbar_button";
    CLASSES["FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_FLOAT"] = "flexlayout__border_toolbar_button-float";
    CLASSES["FLEXLAYOUT__DRAG_RECT"] = "flexlayout__drag_rect";
    CLASSES["FLEXLAYOUT__EDGE_RECT"] = "flexlayout__edge_rect";
    CLASSES["FLEXLAYOUT__EDGE_RECT_TOP"] = "flexlayout__edge_rect_top";
    CLASSES["FLEXLAYOUT__EDGE_RECT_LEFT"] = "flexlayout__edge_rect_left";
    CLASSES["FLEXLAYOUT__EDGE_RECT_BOTTOM"] = "flexlayout__edge_rect_bottom";
    CLASSES["FLEXLAYOUT__EDGE_RECT_RIGHT"] = "flexlayout__edge_rect_right";
    CLASSES["FLEXLAYOUT__ERROR_BOUNDARY_CONTAINER"] = "flexlayout__error_boundary_container";
    CLASSES["FLEXLAYOUT__ERROR_BOUNDARY_CONTENT"] = "flexlayout__error_boundary_content";
    CLASSES["FLEXLAYOUT__FLOAT_WINDOW"] = "flexlayout__float_window";
    CLASSES["FLEXLAYOUT__FLOAT_WINDOW_HEADER"] = "flexlayout__float_window_header";
    CLASSES["FLEXLAYOUT__FLOAT_WINDOW_CONTENT"] = "flexlayout__float_window_content";
    CLASSES["FLEXLAYOUT__FLOATING_WINDOW_CONTENT"] = "flexlayout__floating_window_content";
    CLASSES["FLEXLAYOUT__LAYOUT"] = "flexlayout__layout";
    CLASSES["FLEXLAYOUT__LAYOUT_METRICS"] = "flexlayout__layout_metrics";
    CLASSES["FLEXLAYOUT__LAYOUT_MOVEABLES_HOME"] = "flexlayout__layout_moveables_home";
    CLASSES["FLEXLAYOUT__LAYOUT_OVERLAY"] = "flexlayout__layout_overlay";
    CLASSES["FLEXLAYOUT__LAYOUT_TAB_STAMPS"] = "flexlayout__layout_tab_stamps";
    CLASSES["FLEXLAYOUT__LAYOUT_MAIN"] = "flexlayout__layout_main";
    CLASSES["FLEXLAYOUT__LAYOUT_BORDER_CONTAINER"] = "flexlayout__layout_border_container";
    CLASSES["FLEXLAYOUT__LAYOUT_BORDER_CONTAINER_INNER"] = "flexlayout__layout_border_container_inner";
    CLASSES["FLEXLAYOUT__OUTLINE_RECT"] = "flexlayout__outline_rect";
    CLASSES["FLEXLAYOUT__OUTLINE_RECT_EDGE"] = "flexlayout__outline_rect_edge";
    CLASSES["FLEXLAYOUT__SPLITTER"] = "flexlayout__splitter";
    CLASSES["FLEXLAYOUT__SPLITTER_EXTRA"] = "flexlayout__splitter_extra";
    CLASSES["FLEXLAYOUT__SPLITTER_"] = "flexlayout__splitter_";
    CLASSES["FLEXLAYOUT__SPLITTER_BORDER"] = "flexlayout__splitter_border";
    CLASSES["FLEXLAYOUT__SPLITTER_DRAG"] = "flexlayout__splitter_drag";
    CLASSES["FLEXLAYOUT__SPLITTER_HANDLE"] = "flexlayout__splitter_handle";
    CLASSES["FLEXLAYOUT__SPLITTER_HANDLE_HORZ"] = "flexlayout__splitter_handle_horz";
    CLASSES["FLEXLAYOUT__SPLITTER_HANDLE_VERT"] = "flexlayout__splitter_handle_vert";
    CLASSES["FLEXLAYOUT__ROW"] = "flexlayout__row";
    CLASSES["FLEXLAYOUT__TAB"] = "flexlayout__tab";
    CLASSES["FLEXLAYOUT__TAB_POSITION"] = "flexlayout__tab_position";
    CLASSES["FLEXLAYOUT__TAB_MOVEABLE"] = "flexlayout__tab_moveable";
    CLASSES["FLEXLAYOUT__TAB_OVERLAY"] = "flexlayout__tab_overlay";
    CLASSES["FLEXLAYOUT__TAB_LAYOUT_CONTAINER"] = "flexlayout__tab_layout_container";
    CLASSES["FLEXLAYOUT__TAB_LAYOUT_CONTAINER_USER"] = "flexlayout__tab_layout_container_user";
    CLASSES["FLEXLAYOUT__TABSET"] = "flexlayout__tabset";
    CLASSES["FLEXLAYOUT__TABSET_CONTAINER"] = "flexlayout__tabset_container";
    CLASSES["FLEXLAYOUT__TABSET_MAXIMIZED"] = "flexlayout__tabset-maximized";
    CLASSES["FLEXLAYOUT__TABSET_SELECTED"] = "flexlayout__tabset-selected";
    CLASSES["FLEXLAYOUT__TABSET_TAB_SPACER"] = "flexlayout__tabset_tab_spacer";
    CLASSES["FLEXLAYOUT__TABSET_TAB_DIVIDER"] = "flexlayout__tabset_tab_divider";
    CLASSES["FLEXLAYOUT__TABSET_TAB_DIVIDER_SELECTED_BEFORE"] = "flexlayout__tabset_tab_divider_selected_before";
    CLASSES["FLEXLAYOUT__TABSET_TAB_DIVIDER_SELECTED_AFTER"] = "flexlayout__tabset_tab_divider_selected_after";
    CLASSES["FLEXLAYOUT__TABSET_TAB_DIVIDER_INNER"] = "flexlayout__tabset_tab_divider_inner";
    CLASSES["FLEXLAYOUT__TABSET_CONTENT"] = "flexlayout__tabset_content";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_INNER"] = "flexlayout__tabset_tabbar_inner";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_INNER_"] = "flexlayout__tabset_tabbar_inner_";
    CLASSES["FLEXLAYOUT__TABSET_LEADING"] = "flexlayout__tabset_leading";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_INNER_TAB_CONTAINER"] = "flexlayout__tabset_tabbar_inner_tab_container";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_INNER_TAB_CONTAINER_"] = "flexlayout__tabset_tabbar_inner_tab_container_";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_OUTER"] = "flexlayout__tabset_tabbar_outer";
    CLASSES["FLEXLAYOUT__TABSET_TABBAR_OUTER_"] = "flexlayout__tabset_tabbar_outer_";
    CLASSES["FLEXLAYOUT__TAB_BORDER"] = "flexlayout__tab_border";
    CLASSES["FLEXLAYOUT__TAB_BORDER_"] = "flexlayout__tab_border_";
    CLASSES["FLEXLAYOUT__TAB_BUTTON"] = "flexlayout__tab_button";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_STRETCH"] = "flexlayout__tab_button_stretch";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_CONTENT"] = "flexlayout__tab_button_content";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_LEADING"] = "flexlayout__tab_button_leading";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_OVERFLOW"] = "flexlayout__tab_button_overflow";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_OVERFLOW_COUNT"] = "flexlayout__tab_button_overflow_count";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_TEXTBOX"] = "flexlayout__tab_button_textbox";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_TRAILING"] = "flexlayout__tab_button_trailing";
    CLASSES["FLEXLAYOUT__TAB_BUTTON_STAMP"] = "flexlayout__tab_button_stamp";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR"] = "flexlayout__tab_toolbar";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_BUTTON"] = "flexlayout__tab_toolbar_button";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_ICON"] = "flexlayout__tab_toolbar_icon";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_BUTTON_"] = "flexlayout__tab_toolbar_button-";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_BUTTON_FLOAT"] = "flexlayout__tab_toolbar_button-float";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_STICKY_BUTTONS_CONTAINER"] = "flexlayout__tab_toolbar_sticky_buttons_container";
    CLASSES["FLEXLAYOUT__TAB_TOOLBAR_BUTTON_CLOSE"] = "flexlayout__tab_toolbar_button-close";
    CLASSES["FLEXLAYOUT__POPUP_MENU_CONTAINER"] = "flexlayout__popup_menu_container";
    CLASSES["FLEXLAYOUT__POPUP_MENU_ITEM"] = "flexlayout__popup_menu_item";
    CLASSES["FLEXLAYOUT__POPUP_MENU_ITEM__SELECTED"] = "flexlayout__popup_menu_item--selected";
    CLASSES["FLEXLAYOUT__POPUP_MENU"] = "flexlayout__popup_menu";
    CLASSES["FLEXLAYOUT__MINI_SCROLLBAR"] = "flexlayout__mini_scrollbar";
    CLASSES["FLEXLAYOUT__MINI_SCROLLBAR_CONTAINER"] = "flexlayout__mini_scrollbar_container";
    return CLASSES;
}({});
//#endregion
//#region src/model/Actions.ts
/**
* The Action creator class for FlexLayout model actions
*/ var $8041f202454d6b76$export$b52183d5cfb26dc9 = class Actions {
    static ADD_TAB = "FlexLayout_AddTab";
    static DELETE_TAB = "FlexLayout_DeleteTab";
    static RENAME_TAB = "FlexLayout_RenameTab";
    static SELECT_TAB = "FlexLayout_SelectTab";
    static MOVE_NODE = "FlexLayout_MoveNode";
    static DELETE_TABSET = "FlexLayout_DeleteTabset";
    static SET_ACTIVE_TABSET = "FlexLayout_SetActiveTabset";
    static ADJUST_WEIGHTS = "FlexLayout_AdjustWeights";
    static ADJUST_BORDER_SPLIT = "FlexLayout_AdjustBorderSplit";
    static MAXIMIZE_TOGGLE = "FlexLayout_MaximizeToggle";
    static UPDATE_MODEL_ATTRIBUTES = "FlexLayout_UpdateModelAttributes";
    static UPDATE_NODE_ATTRIBUTES = "FlexLayout_UpdateNodeAttributes";
    static POPOUT_TAB = "FlexLayout_PopoutTab";
    static POPOUT_TABSET = "FlexLayout_PopoutTabset";
    static CLOSE_POPOUT = "FlexLayout_ClosePopout";
    static MOVE_POPOUT_TO_FRONT = "FlexLayout_MoveFloatToFront";
    static CREATE_SUBLAYOUT = "FlexLayout_CreateSubLayout";
    /**
	* Adds a tab node to the given tabset node
	* @param json the json for the new tab node e.g {type:"tab", component:"table"}
	* @param toNodeId the new tab node will be added to the tabset with this node id
	* @param location the location where the new tab will be added, one of the DockLocation enum values.
	* @param index for docking to the center this value is the index of the tab, use -1 to add to the end.
	* @param select (optional) whether to select the new tab, overriding autoSelectTab
	* @returns {Action} the action
	*/ static addTab(json, toNodeId, location, index, select) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.ADD_TAB, {
            json: json,
            toNode: toNodeId,
            location: location.getName(),
            index: index,
            select: select
        });
    }
    /** @deprecated use 'addTab' instead */ static addNode(json, toNodeId, location, index, select) {
        return this.addTab(json, toNodeId, location, index, select);
    }
    /**
	* Moves a node (tab or tabset) from one location to another
	* @param fromNodeId the id of the node to move
	* @param toNodeId the id of the node to receive the moved node
	* @param location the location where the moved node will be added, one of the DockLocation enum values.
	* @param index for docking to the center this value is the index of the tab, use -1 to add to the end.
	* @param select (optional) whether to select the moved tab(s) in new tabset, overriding autoSelectTab
	* @returns {Action} the action
	*/ static moveNode(fromNodeId, toNodeId, location, index, select) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.MOVE_NODE, {
            fromNode: fromNodeId,
            toNode: toNodeId,
            location: location.getName(),
            index: index,
            select: select
        });
    }
    /**
	* Deletes a tab node from the layout
	* @param tabNodeId the id of the tab node to delete
	* @returns {Action} the action
	*/ static deleteTab(tabNodeId) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.DELETE_TAB, {
            node: tabNodeId
        });
    }
    /**
	* Deletes a tabset node and all it's child tab nodes from the layout
	* @param tabsetNodeId the id of the tabset node to delete
	* @returns {Action} the action
	*/ static deleteTabset(tabsetNodeId) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.DELETE_TABSET, {
            node: tabsetNodeId
        });
    }
    /**
	* Change the given nodes tab text
	* @param tabNodeId the id of the tab node to rename
	* @param text the test of the tab
	* @returns {Action} the action
	*/ static renameTab(tabNodeId, text) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.RENAME_TAB, {
            node: tabNodeId,
            text: text
        });
    }
    /**
	* Selects the given tab in its parent tabset
	* @param tabNodeId the id of the tab node to set selected
	* @returns {Action} the action
	*/ static selectTab(tabNodeId) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.SELECT_TAB, {
            tabNode: tabNodeId
        });
    }
    /**
	* Set the given tabset node as the active tabset
	* @param tabsetNodeId the id of the tabset node to set as active
	* @returns {Action} the action
	*/ static setActiveTabset(tabsetNodeId, layoutId) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.SET_ACTIVE_TABSET, {
            tabsetNode: tabsetNodeId,
            layoutId: layoutId
        });
    }
    /**
	* Adjust the weights of a row, used when the splitter is moved
	* @param nodeId the id of the row node whose childrens weights are being adjusted
	* @param weights an array of weights to be applied to the children 
	* @returns {Action} the action
	*/ static adjustWeights(nodeId, weights) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.ADJUST_WEIGHTS, {
            nodeId: nodeId,
            weights: weights
        });
    }
    /**
	* Adjust the size of the border
	* @param nodeId the id of the border node to adjust
	* @param size the new border size 
	* @returns {Action} the action
	*/ static adjustBorderSplit(nodeId, size) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.ADJUST_BORDER_SPLIT, {
            node: nodeId,
            size: size
        });
    }
    /**
	* Maximizes the given tabset
	* @param tabsetNodeId the id of the tabset to maximize
	* @returns {Action} the action
	*/ static maximizeToggle(tabsetNodeId, layoutId) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.MAXIMIZE_TOGGLE, {
            node: tabsetNodeId,
            layoutId: layoutId
        });
    }
    /**
	* Updates the global model jsone attributes
	* @param attributes the json for the model attributes to update (merge into the existing attributes)
	* @returns {Action} the action
	*/ static updateModelAttributes(attributes) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.UPDATE_MODEL_ATTRIBUTES, {
            json: attributes
        });
    }
    /**
	* Updates the given nodes json attributes
	* @param nodeId the id of the node to update
	* @param attributes the json attributes to update (merge with the existing attributes)
	* @returns {Action} the action
	*/ static updateNodeAttributes(nodeId, attributes) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.UPDATE_NODE_ATTRIBUTES, {
            node: nodeId,
            json: attributes
        });
    }
    /**
	* Pops out the given tab node into a new browser window or floating panel
	* @param nodeId the tab node to popout
	* @param type the type of window to create, either "window" (native browser window) or "float" (simulated div based window)
	* @returns {Action} the action
	*/ static popoutTab(nodeId, type = "window") {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.POPOUT_TAB, {
            node: nodeId,
            type: type
        });
    }
    /**
	* Pops out the given tabset node into a new browser window or floating panel
	* @param nodeId the tabset node to popout
	* @param type the type of window to create, either "window" (native browser window) or "float" (simulated div based window)
	* @returns {Action} the action
	*/ static popoutTabset(nodeId, type = "window") {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.POPOUT_TABSET, {
            node: nodeId,
            type: type
        });
    }
    /**
	* Closes the popout
	* @param layoutId the id of the popout to close
	* @returns {Action} the action
	*/ static closePopout(layoutId) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.CLOSE_POPOUT, {
            layoutId: layoutId
        });
    }
    /**
	* Moves a floating panel popout to the front of the display
	* @param layoutId the id of the floating panel popout to move
	* @returns {Action} the action
	*/ static movePopoutToFront(layoutId) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.MOVE_POPOUT_TO_FRONT, {
            layoutId: layoutId
        });
    }
    /**
	* Creates a new empty popout window with the given layout (alias for createSubLayout)
	* @param layout the json layout for the new window
	* @param rect the window rectangle in screen coordinates
	* @param type the type of the popout either "window", "float"
	* @returns {Action} the action
	*/ static createPopout(layout, rect, type) {
        return this.createSubLayout(layout, rect, type);
    }
    /**
	* Creates a new sublayout with the given layout
	* @param layout the json layout for the new window
	* @param rect the window rectangle in screen coordinates
	* @param type the type of the sublayout either "window", "float" or "tab"
	* @returns {Action} the action
	*/ static createSubLayout(layout, rect, type) {
        return new $8041f202454d6b76$export$e19cd5f9376f8cee(Actions.CREATE_SUBLAYOUT, {
            layout: layout,
            rect: rect,
            type: type
        });
    }
};
var $8041f202454d6b76$export$e19cd5f9376f8cee = class {
    type;
    data;
    constructor(type, data){
        this.type = type;
        this.data = data;
    }
};
//#endregion
//#region src/model/Attributes.ts
/** @internal */ var $8041f202454d6b76$var$Attributes = class {
    attributes;
    nameToAttribute;
    constructor(){
        this.attributes = [];
        this.nameToAttribute = /* @__PURE__ */ new Map();
    }
    addWithAll(name, modelName, defaultValue, alwaysWriteJson) {
        const attr = new $8041f202454d6b76$var$Attribute(name, modelName, defaultValue, alwaysWriteJson);
        this.attributes.push(attr);
        this.nameToAttribute.set(name, attr);
        return attr;
    }
    addInherited(name, modelName) {
        return this.addWithAll(name, modelName, void 0, false);
    }
    add(name, defaultValue, alwaysWriteJson) {
        return this.addWithAll(name, void 0, defaultValue, alwaysWriteJson);
    }
    getAttributes() {
        return this.attributes;
    }
    getModelName(name) {
        const conversion = this.nameToAttribute.get(name);
        if (conversion !== void 0) return conversion.modelName;
    }
    toJson(jsonObj, obj) {
        for (const attr of this.attributes){
            const fromValue = obj[attr.name];
            if (attr.alwaysWriteJson || fromValue !== attr.defaultValue) jsonObj[attr.name] = fromValue;
        }
    }
    fromJson(jsonObj, obj) {
        for (const attr of this.attributes){
            let fromValue = jsonObj[attr.name];
            if (fromValue === void 0 && attr.alias) fromValue = jsonObj[attr.alias];
            if (fromValue === void 0) obj[attr.name] = attr.defaultValue;
            else obj[attr.name] = fromValue;
        }
    }
    update(jsonObj, obj) {
        for (const attr of this.attributes)if (Object.prototype.hasOwnProperty.call(jsonObj, attr.name)) {
            const fromValue = jsonObj[attr.name];
            if (fromValue === void 0) delete obj[attr.name];
            else obj[attr.name] = fromValue;
        }
    }
    setDefaults(obj) {
        for (const attr of this.attributes)obj[attr.name] = attr.defaultValue;
    }
    pairAttributes(type, childAttributes) {
        for (const attr of childAttributes.attributes)if (attr.modelName && this.nameToAttribute.has(attr.modelName)) {
            const pairedAttr = this.nameToAttribute.get(attr.modelName);
            pairedAttr.setpairedAttr(attr);
            attr.setpairedAttr(pairedAttr);
            pairedAttr.setPairedType(type);
        }
    }
    toTypescriptInterface(name, parentAttributes) {
        const lines = [];
        const sorted = this.attributes.sort((a, b)=>a.name.localeCompare(b.name));
        lines.push("export interface I" + name + "Attributes {");
        for(let i = 0; i < sorted.length; i++){
            const c = sorted[i];
            let type = c.type;
            let defaultValue = void 0;
            let attr = c;
            let inherited = void 0;
            if (attr.defaultValue !== void 0) defaultValue = attr.defaultValue;
            else if (attr.modelName !== void 0 && parentAttributes !== void 0 && parentAttributes.nameToAttribute.get(attr.modelName) !== void 0) {
                inherited = attr.modelName;
                attr = parentAttributes.nameToAttribute.get(inherited);
                defaultValue = attr.defaultValue;
                type = attr.type;
            }
            const defValue = JSON.stringify(defaultValue);
            const required = attr.required ? "" : "?";
            let sb = "	/**\n	  ";
            if (c.description) sb += c.description;
            else if (c.pairedType && c.pairedAttr?.description) {
                sb += `Value for ${c.pairedType} attribute ${c.pairedAttr.name} if not overridden`;
                sb += "\n\n	  ";
                sb += c.pairedAttr?.description;
            }
            sb += "\n\n	  ";
            if (c.fixed) sb += `Fixed value: ${defValue}`;
            else if (inherited) sb += `Default: inherited from Global attribute ${c.modelName} (default ${defValue})`;
            else sb += `Default: ${defValue}`;
            sb += "\n	 */";
            lines.push(sb);
            lines.push("	" + c.name + required + ": " + type + ";\n");
        }
        lines.push("}");
        return lines.join("\n");
    }
};
/** @internal */ var $8041f202454d6b76$var$Attribute = class {
    static NUMBER = "number";
    static STRING = "string";
    static BOOLEAN = "boolean";
    name;
    alias;
    modelName;
    pairedAttr;
    pairedType;
    defaultValue;
    alwaysWriteJson;
    type;
    required;
    fixed;
    description;
    constructor(name, modelName, defaultValue, alwaysWriteJson){
        this.name = name;
        this.alias = void 0;
        this.modelName = modelName;
        this.defaultValue = defaultValue;
        this.alwaysWriteJson = alwaysWriteJson;
        this.required = false;
        this.fixed = false;
        this.type = "any";
    }
    setType(value) {
        this.type = value;
        return this;
    }
    setAlias(value) {
        this.alias = value;
        return this;
    }
    setDescription(value) {
        this.description = value;
    }
    setRequired() {
        this.required = true;
        return this;
    }
    setFixed() {
        this.fixed = true;
        return this;
    }
    setpairedAttr(value) {
        this.pairedAttr = value;
    }
    setPairedType(value) {
        this.pairedType = value;
    }
};
//#endregion
//#region src/model/DropInfo.ts
var $8041f202454d6b76$export$e14a08f842f4256c = class {
    node;
    rect;
    location;
    index;
    className;
    constructor(node, rect, location, index, className){
        this.node = node;
        this.rect = rect;
        this.location = location;
        this.index = index;
        this.className = className;
    }
};
//#endregion
//#region src/model/Node.ts
var $8041f202454d6b76$export$85c928794f8d04d4 = class {
    /** @internal */ model;
    /** @internal */ attributes;
    /** @internal */ parent;
    /** @internal */ children;
    /** @internal */ rect;
    /** @internal */ path;
    /** @internal */ listeners;
    /** @internal */ constructor(_model){
        this.model = _model;
        this.attributes = {};
        this.children = [];
        this.rect = $8041f202454d6b76$export$c79fc6492f3af13d.empty();
        this.listeners = /* @__PURE__ */ new Map();
        this.path = "";
    }
    getId() {
        let id = this.attributes.id;
        if (id !== void 0) return id;
        id = this.model.nextUniqueId();
        this.setId(id);
        return id;
    }
    getModel() {
        return this.model;
    }
    getType() {
        return this.attributes.type;
    }
    getParent() {
        return this.parent;
    }
    getChildren() {
        return this.children;
    }
    getRect() {
        return this.rect;
    }
    getPath() {
        return this.path;
    }
    isCloseable() {
        for(let i = 0; i < this.children.length; i++)if (!this.children[i].isCloseable()) return false;
        return true;
    }
    isAllowedInWindow() {
        for(let i = 0; i < this.children.length; i++)if (!this.children[i].isAllowedInWindow()) return false;
        return true;
    }
    getOrientation() {
        if (this.parent === void 0) return this.model.isRootOrientationVertical() ? $8041f202454d6b76$export$df54d73aa0ec5e82.VERT : $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ;
        else return $8041f202454d6b76$export$df54d73aa0ec5e82.flip(this.parent.getOrientation());
    }
    getLayoutId() {
        return this.getLayout().getLayoutId();
    }
    /** @internal */ getLayout() {
        if (this.parent) return this.parent.getLayout();
        return this.model.getMainLayout();
    }
    setEventListener(event, callback) {
        this.listeners.set(event, callback);
    }
    removeEventListener(event) {
        this.listeners.delete(event);
    }
    /** @internal */ setId(id) {
        this.attributes.id = id;
    }
    /** @internal */ fireEvent(event, params) {
        if (this.listeners.has(event)) this.listeners.get(event)(params);
    }
    /** @internal */ getAttr(name) {
        let val = this.attributes[name];
        if (val === void 0) {
            const modelName = this.getAttributeDefinitions().getModelName(name);
            if (modelName !== void 0) val = this.model.getAttribute(modelName);
        }
        return val;
    }
    /** @internal */ forEachNode(fn, level) {
        fn(this, level);
        level++;
        for (const node of this.children)node.forEachNode(fn, level);
    }
    /** @internal */ setPaths(path) {
        let i = 0;
        for (const node of this.children){
            let newPath = path;
            if (node.getType() === "row") newPath += "/r" + i;
            else if (node.getType() === "tabset") newPath += "/ts" + i;
            else if (node.getType() === "tab") newPath += "/t" + i;
            node.path = newPath;
            node.setPaths(newPath);
            i++;
        }
    }
    /** @internal */ setParent(parent) {
        this.parent = parent;
    }
    /** @internal */ setRect(rect) {
        this.rect = rect;
    }
    /** @internal */ setPath(path) {
        this.path = path;
    }
    /** @internal */ setWeight(weight) {
        this.attributes.weight = weight;
    }
    /** @internal */ setSelected(index) {
        this.attributes.selected = index;
    }
    /** @internal */ findDropTargetNode(layoutId, dragNode, x, y) {
        let rtn;
        if (this.rect.contains(x, y)) {
            if (this.model.getMaximizedTabset(layoutId) !== void 0) rtn = this.model.getMaximizedTabset(layoutId).canDrop(dragNode, x, y);
            else {
                rtn = this.canDrop(dragNode, x, y);
                if (rtn === void 0) {
                    if (this.children.length !== 0) for (const child of this.children){
                        rtn = child.findDropTargetNode(layoutId, dragNode, x, y);
                        if (rtn !== void 0) break;
                    }
                }
            }
        }
        return rtn;
    }
    /** @internal */ canDrop(dragNode, x, y) {}
    /** @internal */ canDockInto(dragNode, dropInfo) {
        if (dropInfo != null) {
            if (dropInfo.location === $8041f202454d6b76$export$5bf830809a2e00b2.CENTER && dropInfo.node.isEnableDrop() === false) return false;
            if (dropInfo.location === $8041f202454d6b76$export$5bf830809a2e00b2.CENTER && dragNode.getType() === "tabset" && dragNode.isEnableClose() === false) return false;
            if (dropInfo.location !== $8041f202454d6b76$export$5bf830809a2e00b2.CENTER && dropInfo.node.isEnableDivide() === false) return false;
            if (this.model.getOnAllowDrop()) return this.model.getOnAllowDrop()(dragNode, dropInfo);
        }
        return true;
    }
    /** @internal */ removeChild(childNode) {
        const pos = this.children.indexOf(childNode);
        if (pos !== -1) this.children.splice(pos, 1);
        return pos;
    }
    /** @internal */ addChild(childNode, pos) {
        if (pos != null) this.children.splice(pos, 0, childNode);
        else {
            this.children.push(childNode);
            pos = this.children.length - 1;
        }
        childNode.parent = this;
        return pos;
    }
    /** @internal */ removeAll() {
        this.children = [];
    }
    /** @internal */ styleWithPosition(style) {
        if (style == null) style = {};
        return this.rect.styleWithPosition(style);
    }
    /** @internal */ isEnableDivide() {
        return true;
    }
    /** @internal */ toAttributeString() {
        return JSON.stringify(this.attributes, void 0, "	");
    }
};
//#endregion
//#region src/model/TabNode.ts
var $8041f202454d6b76$export$8dbf7edd89edc19c = class TabNode extends $8041f202454d6b76$export$85c928794f8d04d4 {
    static TYPE = "tab";
    /** @internal */ static fromJson(json, model, addToModel = true) {
        return new TabNode(model, json, addToModel);
    }
    tabRect = $8041f202454d6b76$export$c79fc6492f3af13d.empty();
    renderedName;
    extra;
    visible;
    rendered;
    moveableElement;
    tabStamp;
    scrollTop;
    scrollLeft;
    /** @internal */ constructor(model, json, addToModel = true){
        super(model);
        this.extra = {};
        this.moveableElement = document.createElement("div");
        this.moveableElement.className = $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_MOVEABLE;
        this.tabStamp = null;
        this.rendered = false;
        this.visible = false;
        TabNode.attributeDefinitions.fromJson(json, this.attributes);
        if (addToModel === true) model.addNode(this);
    }
    getName() {
        return this.getAttr("name");
    }
    getIcon() {
        return this.getAttr("icon");
    }
    getSubLayoutId() {
        return this.getAttr("subLayoutId");
    }
    getHelpText() {
        return this.getAttr("helpText");
    }
    getComponent() {
        return this.getAttr("component");
    }
    getWindowId() {
        const layout = this.getLayout();
        if (layout) return layout.getWindowId();
    }
    /**
	* Returns the config attribute that can be used to store node specific data that
	* WILL be saved to the json. The config attribute should be changed via the action Actions.updateNodeAttributes rather
	* than directly, for example:
	* this.state.model.doAction(
	*   FlexLayout.Actions.updateNodeAttributes(node.getId(), {config:myConfigObject}));
	*/ getConfig() {
        return this.attributes.config;
    }
    /**
	* Returns an object that can be used to store transient node specific data that will
	* NOT be saved in the json.
	*/ getExtraData() {
        return this.extra;
    }
    isPoppedOut() {
        return this.getLayoutId() !== $8041f202454d6b76$export$a1edc412be3e1841.MAIN_LAYOUT_ID;
    }
    isSelected() {
        return this.getParent().getSelectedNode() === this;
    }
    isCloseable() {
        let closeable = this.isEnableClose();
        if (closeable && this.getSubLayoutId()) closeable = this.model.getLayouts().get(this.getSubLayoutId()).getRootRow().isCloseable();
        return closeable;
    }
    isAllowedInWindow() {
        let allowed = this.isEnablePopout();
        if (allowed && this.getSubLayoutId()) allowed = this.model.getLayouts().get(this.getSubLayoutId()).getRootRow().isAllowedInWindow();
        return allowed;
    }
    isEnableClose() {
        return this.getAttr("enableClose");
    }
    getCloseType() {
        return this.getAttr("closeType");
    }
    isEnablePopout() {
        return this.getAttr("enablePopout");
    }
    isEnablePopoutIcon() {
        return this.getAttr("enablePopoutIcon");
    }
    isEnablePopoutFloatIcon() {
        return this.getAttr("enablePopoutFloatIcon");
    }
    isEnablePopoutOverlay() {
        return this.getAttr("enablePopoutOverlay");
    }
    isEnableDrag() {
        return this.getAttr("enableDrag");
    }
    isEnableRename() {
        return this.getAttr("enableRename");
    }
    isEnableWindowReMount() {
        return this.getAttr("enableWindowReMount");
    }
    getClassName() {
        return this.getAttr("className");
    }
    getContentClassName() {
        return this.getAttr("contentClassName");
    }
    getTabSetClassName() {
        return this.getAttr("tabsetClassName");
    }
    isEnableRenderOnDemand() {
        return this.getAttr("enableRenderOnDemand");
    }
    getMinWidth() {
        return this.getAttr("minWidth");
    }
    getMinHeight() {
        return this.getAttr("minHeight");
    }
    getMaxWidth() {
        return this.getAttr("maxWidth");
    }
    getMaxHeight() {
        return this.getAttr("maxHeight");
    }
    isVisible() {
        return this.visible;
    }
    toJson() {
        const json = {};
        TabNode.attributeDefinitions.toJson(json, this.attributes);
        return json;
    }
    /** @internal */ saveScrollPosition() {
        if (this.moveableElement) {
            this.scrollLeft = this.moveableElement.scrollLeft;
            this.scrollTop = this.moveableElement.scrollTop;
        }
    }
    /** @internal */ restoreScrollPosition() {
        if (this.scrollTop) requestAnimationFrame(()=>{
            if (this.moveableElement) {
                if (this.scrollTop) {
                    this.moveableElement.scrollTop = this.scrollTop;
                    this.moveableElement.scrollLeft = this.scrollLeft;
                }
            }
        });
    }
    /** @internal */ setRect(rect) {
        if (!rect.equals(this.rect)) {
            this.fireEvent("resize", {
                rect: rect
            });
            this.rect = rect;
        }
    }
    /** @internal */ setVisible(visible) {
        if (visible !== this.visible) {
            this.visible = visible;
            this.fireEvent("visibility", {
                visible: visible
            });
        }
    }
    /** @internal */ getScrollTop() {
        return this.scrollTop;
    }
    /** @internal */ setScrollTop(scrollTop) {
        this.scrollTop = scrollTop;
    }
    /** @internal */ getScrollLeft() {
        return this.scrollLeft;
    }
    /** @internal */ setScrollLeft(scrollLeft) {
        this.scrollLeft = scrollLeft;
    }
    /** @internal */ isRendered() {
        return this.rendered;
    }
    /** @internal */ setRendered(rendered) {
        this.rendered = rendered;
    }
    /** @internal */ getTabRect() {
        return this.tabRect;
    }
    /** @internal */ setTabRect(rect) {
        this.tabRect = rect;
    }
    /** @internal */ getTabStamp() {
        return this.tabStamp;
    }
    /** @internal */ setTabStamp(stamp) {
        this.tabStamp = stamp;
    }
    /** @internal */ getMoveableElement() {
        return this.moveableElement;
    }
    /** @internal */ setRenderedName(name) {
        this.renderedName = name;
    }
    /** @internal */ getNameForOverflowMenu() {
        const altName = this.getAttr("altName");
        if (altName !== void 0) return altName;
        return this.renderedName;
    }
    /** @internal */ setName(name) {
        this.attributes.name = name;
    }
    /** @internal */ delete() {
        this.parent.remove(this);
        if (this.getSubLayoutId()) this.model.getLayouts().delete(this.getSubLayoutId());
        this.fireEvent("close", {});
    }
    /** @internal */ updateAttrs(json) {
        TabNode.attributeDefinitions.update(json, this.attributes);
    }
    /** @internal */ getAttributeDefinitions() {
        return TabNode.attributeDefinitions;
    }
    /** @internal */ setBorderWidth(width) {
        this.attributes.borderWidth = width;
    }
    /** @internal */ setBorderHeight(height) {
        this.attributes.borderHeight = height;
    }
    /** @internal */ static getAttributeDefinitions() {
        return TabNode.attributeDefinitions;
    }
    /** @internal */ static attributeDefinitions = TabNode.createAttributeDefinitions();
    /** @internal */ static createAttributeDefinitions() {
        const attributeDefinitions = new $8041f202454d6b76$var$Attributes();
        attributeDefinitions.add("type", TabNode.TYPE, true).setType($8041f202454d6b76$var$Attribute.STRING).setFixed();
        attributeDefinitions.add("id", void 0).setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`the unique id of the tab, if left undefined a uuid will be assigned`);
        attributeDefinitions.add("name", "[Unnamed Tab]").setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`name of tab to be displayed in the tab button`);
        attributeDefinitions.add("component", void 0).setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`string identifying which component to render in this tab (used in the layout factory function)`);
        attributeDefinitions.add("subLayoutId", void 0).setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`the Id of the sub layout to render in this tab, defined in the subLayouts section of the model json (if
            component is also defined then use the <TabLayout> component in the factory to render the sublayout)`);
        attributeDefinitions.add("altName", void 0).setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`if there is no name specifed then this value will be used in the overflow menu`);
        attributeDefinitions.add("helpText", void 0).setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`help text for the tab to be displayed upon tab hover.`);
        attributeDefinitions.add("config", void 0).setType("any").setDescription(`a place to hold json config for the hosted component`);
        attributeDefinitions.add("tabsetClassName", void 0).setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`class applied to parent tabset when this is the only tab and it is stretched to fill the tabset`);
        attributeDefinitions.add("enableWindowReMount", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`if enabled the tab will re-mount when popped out/in`);
        attributeDefinitions.addInherited("enableClose", "tabEnableClose").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`allow user to close tab via close button`);
        attributeDefinitions.addInherited("closeType", "tabCloseType").setType("ICloseType").setDescription(`see values in ICloseType`);
        attributeDefinitions.addInherited("enableDrag", "tabEnableDrag").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`allow user to drag tab to new location`);
        attributeDefinitions.addInherited("enableRename", "tabEnableRename").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`allow user to rename tabs by double clicking`);
        attributeDefinitions.addInherited("className", "tabClassName").setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`class applied to tab button`);
        attributeDefinitions.addInherited("contentClassName", "tabContentClassName").setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`class applied to tab content`);
        attributeDefinitions.addInherited("icon", "tabIcon").setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`the tab icon`);
        attributeDefinitions.addInherited("enableRenderOnDemand", "tabEnableRenderOnDemand").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether to avoid rendering component until tab is visible`);
        attributeDefinitions.addInherited("enablePopout", "tabEnablePopout").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setAlias("enableFloat").setDescription(`enable window popout (in popout capable browser), to show an icon in the tabset header also set the enablePopoutIcon attribute`);
        attributeDefinitions.addInherited("enablePopoutIcon", "tabEnablePopoutIcon").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether to show the popout icon in the tabset header if this tab enables popouts`);
        attributeDefinitions.addInherited("enablePopoutFloatIcon", "tabEnablePopoutFloatIcon").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether to show the popout float icon in the tabset header if this tab enables floating popouts`);
        attributeDefinitions.addInherited("enablePopoutOverlay", "tabEnablePopoutOverlay").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`if this tab will not work correctly in a popout window when the main window is backgrounded (inactive)
            then enabling this option will gray out this tab`);
        attributeDefinitions.addInherited("borderWidth", "tabBorderWidth").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`width when added to border, -1 will use border size`);
        attributeDefinitions.addInherited("borderHeight", "tabBorderHeight").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`height when added to border, -1 will use border size`);
        attributeDefinitions.addInherited("minWidth", "tabMinWidth").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`the min width of this tab`);
        attributeDefinitions.addInherited("minHeight", "tabMinHeight").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`the min height of this tab`);
        attributeDefinitions.addInherited("maxWidth", "tabMaxWidth").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`the max width of this tab`);
        attributeDefinitions.addInherited("maxHeight", "tabMaxHeight").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`the max height of this tab`);
        return attributeDefinitions;
    }
};
//#endregion
//#region src/view/Utils.tsx
/** @internal */ function $8041f202454d6b76$var$isDesktop() {
    return typeof window !== "undefined" && window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
}
/** @internal */ function $8041f202454d6b76$var$getRenderStateEx(controller, tabNode, iconAngle) {
    let leadingContent = void 0;
    const titleContent = tabNode.getName();
    const name = tabNode.getName();
    if (iconAngle === void 0) iconAngle = 0;
    if (leadingContent === void 0 && tabNode.getIcon() !== void 0) {
        if (iconAngle !== 0) leadingContent = /* @__PURE__ */ (0, $fRwNr.jsx)("img", {
            style: {
                width: "1em",
                height: "1em",
                transform: "rotate(" + iconAngle + "deg)"
            },
            src: tabNode.getIcon(),
            alt: "leadingContent"
        });
        else leadingContent = /* @__PURE__ */ (0, $fRwNr.jsx)("img", {
            style: {
                width: "1em",
                height: "1em"
            },
            src: tabNode.getIcon(),
            alt: "leadingContent"
        });
    }
    const renderState = {
        leading: leadingContent,
        content: titleContent,
        name: name,
        buttons: []
    };
    controller.customizeTab(tabNode, renderState);
    tabNode.setRenderedName(renderState.name);
    return renderState;
}
/** @internal */ function $8041f202454d6b76$var$isAuxMouseEvent(event) {
    let auxEvent = false;
    if (event.nativeEvent instanceof MouseEvent) {
        if (event.nativeEvent.button !== 0 || event.ctrlKey || event.altKey || event.metaKey || event.shiftKey) auxEvent = true;
    }
    return auxEvent;
}
function $8041f202454d6b76$var$enablePointerOnIFrames(enable, currentDocument) {
    const iframes = [
        ...$8041f202454d6b76$var$getElementsByTagName("iframe", currentDocument),
        ...$8041f202454d6b76$var$getElementsByTagName("webview", currentDocument)
    ];
    for (const iframe of iframes)iframe.style.pointerEvents = enable ? "auto" : "none";
}
function $8041f202454d6b76$var$getElementsByTagName(tag, currentDocument) {
    return [
        ...currentDocument.getElementsByTagName(tag)
    ];
}
var $8041f202454d6b76$var$Utils_dragging = false;
function $8041f202454d6b76$var$startDrag(doc, event, drag, dragEnd, dragCancel) {
    $8041f202454d6b76$var$Utils_dragging = true;
    event.preventDefault();
    const pointerMove = (ev)=>{
        ev.preventDefault();
        drag(ev.clientX, ev.clientY);
    };
    const pointerCancel = (ev)=>{
        ev.preventDefault();
        $8041f202454d6b76$var$Utils_dragging = false;
        dragCancel();
    };
    const pointerUp = ()=>{
        doc.removeEventListener("pointermove", pointerMove);
        doc.removeEventListener("pointerup", pointerUp);
        doc.removeEventListener("pointercancel", pointerCancel);
        $8041f202454d6b76$var$Utils_dragging = false;
        dragEnd();
    };
    doc.addEventListener("pointermove", pointerMove);
    doc.addEventListener("pointerup", pointerUp);
    doc.addEventListener("pointercancel", pointerCancel);
}
function $8041f202454d6b76$var$findParentLayout(layout) {
    let parentLayout = void 0;
    layout.getController().getModel().visitNodes((node)=>{
        if (node instanceof $8041f202454d6b76$export$8dbf7edd89edc19c && node.getSubLayoutId() === layout.getLayoutId()) parentLayout = node.getLayout();
    });
    return parentLayout;
}
function $8041f202454d6b76$var$canDockToLayout(node, layout) {
    const type = layout.getType();
    if (type === "window") return node.isAllowedInWindow();
    else if (type === "float") return true;
    else if (type === "tab") {
        const parentLayout = $8041f202454d6b76$var$findParentLayout(layout);
        if (parentLayout && parentLayout.getType() === "window" && !parentLayout.isMainLayout() && !node.isAllowedInWindow()) return false;
        if (node instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
            if (node.getSubLayoutId() !== void 0) return false;
        } else if (node instanceof $8041f202454d6b76$export$812bb9af945a59fa) {
            for (const child of node.getChildren())if (child.getSubLayoutId() !== void 0) return false;
        }
        return true;
    }
    return false;
}
function $8041f202454d6b76$var$copyInlineStyles(source, target) {
    const sourceStyle = source.getAttribute("style");
    if (sourceStyle === target.getAttribute("style")) return false;
    if (sourceStyle) target.setAttribute("style", sourceStyle);
    else target.removeAttribute("style");
    return true;
}
function $8041f202454d6b76$var$isSafari() {
    const userAgent = navigator.userAgent;
    return userAgent.includes("Safari") && !userAgent.includes("Chrome") && !userAgent.includes("Chromium");
}
function $8041f202454d6b76$var$getPageMetrics() {
    return {
        scrollTop: window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0,
        scrollLeft: window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0,
        fullHeight: Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight),
        fullWidth: Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.body.clientWidth, document.documentElement.clientWidth),
        viewportHeight: window.innerHeight || document.documentElement.clientHeight,
        viewportWidth: window.innerWidth || document.documentElement.clientWidth
    };
}
//#endregion
//#region src/model/RowNode.ts
var $8041f202454d6b76$export$6af91cd58ec2edf9 = class RowNode extends $8041f202454d6b76$export$85c928794f8d04d4 {
    static TYPE = "row";
    /** @internal */ static fromJson(json, model, layout) {
        const newLayoutNode = new RowNode(model, json);
        if (json.children != null) {
            for (const jsonChild of json.children)if (jsonChild.type === $8041f202454d6b76$export$812bb9af945a59fa.TYPE) {
                const child = $8041f202454d6b76$export$812bb9af945a59fa.fromJson(jsonChild, model, layout);
                newLayoutNode.addChild(child);
            } else if (jsonChild.type === RowNode.TYPE) {
                const child = RowNode.fromJson(jsonChild, model, layout);
                newLayoutNode.addChild(child);
            }
        }
        return newLayoutNode;
    }
    /** @internal */ static attributeDefinitions = RowNode.createAttributeDefinitions();
    /** @internal */ layout;
    /** @internal */ minHeight;
    /** @internal */ minWidth;
    /** @internal */ maxHeight;
    /** @internal */ maxWidth;
    /** @internal */ constructor(model, json){
        super(model);
        this.minHeight = 1;
        this.minWidth = 1;
        this.maxHeight = $8041f202454d6b76$export$2cef24a37c57bc8d;
        this.maxWidth = $8041f202454d6b76$export$2cef24a37c57bc8d;
        RowNode.attributeDefinitions.fromJson(json, this.attributes);
        this.normalizeWeights();
        model.addNode(this);
    }
    getWeight() {
        return this.attributes.weight;
    }
    toJson() {
        const json = {};
        RowNode.attributeDefinitions.toJson(json, this.attributes);
        json.children = [];
        for (const child of this.children)json.children.push(child.toJson());
        return json;
    }
    /** @internal */ getLayout() {
        if (this.layout) return this.layout;
        return super.getLayout();
    }
    /** @internal */ setLayout(layout) {
        this.layout = layout;
    }
    /** @internal */ setWeight(weight) {
        this.attributes.weight = weight;
    }
    /** @internal */ getSplitterBounds(index) {
        const h = this.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ;
        const c = this.getChildren();
        const ss = this.model.getSplitterSize();
        const fr = c[0].getRect();
        const lr = c[c.length - 1].getRect();
        let p = h ? [
            fr.x,
            lr.getRight()
        ] : [
            fr.y,
            lr.getBottom()
        ];
        const q = h ? [
            fr.x,
            lr.getRight()
        ] : [
            fr.y,
            lr.getBottom()
        ];
        for(let i = 0; i < index; i++){
            const n = c[i];
            p[0] += h ? n.getMinWidth() : n.getMinHeight();
            q[0] += h ? n.getMaxWidth() : n.getMaxHeight();
            if (i > 0) {
                p[0] += ss;
                q[0] += ss;
            }
        }
        for(let i = c.length - 1; i >= index; i--){
            const n = c[i];
            p[1] -= (h ? n.getMinWidth() : n.getMinHeight()) + ss;
            q[1] -= (h ? n.getMaxWidth() : n.getMaxHeight()) + ss;
        }
        p = [
            Math.max(q[1], p[0]),
            Math.min(q[0], p[1])
        ];
        return p;
    }
    /** @internal */ getSplitterInitials(index) {
        const h = this.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ;
        const c = this.getChildren();
        const ss = this.model.getSplitterSize();
        const initialSizes = [];
        let sum = 0;
        for(let i = 0; i < c.length; i++){
            const r = c[i].getRect();
            const s = h ? r.width : r.height;
            initialSizes.push(s);
            sum += s;
        }
        const startRect = c[index].getRect();
        const startPosition = (h ? startRect.x : startRect.y) - ss;
        return {
            initialSizes: initialSizes,
            sum: sum,
            startPosition: startPosition
        };
    }
    /** @internal */ calculateSplit(index, splitterPos, initialSizes, sum, startPosition) {
        const h = this.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ;
        const c = this.getChildren();
        const sn = c[index];
        const smax = h ? sn.getMaxWidth() : sn.getMaxHeight();
        const sizes = [
            ...initialSizes
        ];
        if (splitterPos < startPosition) {
            let shift = startPosition - splitterPos;
            let altShift = 0;
            if (sizes[index] + shift > smax) {
                altShift = sizes[index] + shift - smax;
                sizes[index] = smax;
            } else sizes[index] += shift;
            for(let i = index - 1; i >= 0; i--){
                const n = c[i];
                const m = h ? n.getMinWidth() : n.getMinHeight();
                if (sizes[i] - shift > m) {
                    sizes[i] -= shift;
                    break;
                } else {
                    shift -= sizes[i] - m;
                    sizes[i] = m;
                }
            }
            for(let i = index + 1; i < c.length; i++){
                const n = c[i];
                const m = h ? n.getMaxWidth() : n.getMaxHeight();
                if (sizes[i] + altShift < m) {
                    sizes[i] += altShift;
                    break;
                } else {
                    altShift -= m - sizes[i];
                    sizes[i] = m;
                }
            }
        } else {
            let shift = splitterPos - startPosition;
            let altShift = 0;
            if (sizes[index - 1] + shift > smax) {
                altShift = sizes[index - 1] + shift - smax;
                sizes[index - 1] = smax;
            } else sizes[index - 1] += shift;
            for(let i = index; i < c.length; i++){
                const n = c[i];
                const m = h ? n.getMinWidth() : n.getMinHeight();
                if (sizes[i] - shift > m) {
                    sizes[i] -= shift;
                    break;
                } else {
                    shift -= sizes[i] - m;
                    sizes[i] = m;
                }
            }
            for(let i = index - 1; i >= 0; i--){
                const n = c[i];
                const m = h ? n.getMaxWidth() : n.getMaxHeight();
                if (sizes[i] + altShift < m) {
                    sizes[i] += altShift;
                    break;
                } else {
                    altShift -= m - sizes[i];
                    sizes[i] = m;
                }
            }
        }
        return sizes.map((s)=>Math.max(.1, s) * 100 / sum);
    }
    /** @internal */ getMinSize(orientation) {
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return this.getMinWidth();
        else return this.getMinHeight();
    }
    /** @internal */ getMinWidth() {
        return this.minWidth;
    }
    /** @internal */ getMinHeight() {
        return this.minHeight;
    }
    /** @internal */ getMaxSize(orientation) {
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return this.getMaxWidth();
        else return this.getMaxHeight();
    }
    /** @internal */ getMaxWidth() {
        return this.maxWidth;
    }
    /** @internal */ getMaxHeight() {
        return this.maxHeight;
    }
    /** @internal */ calcMinMaxSize() {
        this.minHeight = 1;
        this.minWidth = 1;
        this.maxHeight = $8041f202454d6b76$export$2cef24a37c57bc8d;
        this.maxWidth = $8041f202454d6b76$export$2cef24a37c57bc8d;
        let first = true;
        for (const child of this.children){
            const c = child;
            c.calcMinMaxSize();
            if (this.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.VERT) {
                this.minHeight += c.getMinHeight();
                this.maxHeight += c.getMaxHeight();
                if (!first) {
                    this.minHeight += this.model.getSplitterSize();
                    this.maxHeight += this.model.getSplitterSize();
                }
                this.minWidth = Math.max(this.minWidth, c.getMinWidth());
                this.maxWidth = Math.min(this.maxWidth, c.getMaxWidth());
            } else {
                this.minWidth += c.getMinWidth();
                this.maxWidth += c.getMaxWidth();
                if (!first) {
                    this.minWidth += this.model.getSplitterSize();
                    this.maxWidth += this.model.getSplitterSize();
                }
                this.minHeight = Math.max(this.minHeight, c.getMinHeight());
                this.maxHeight = Math.min(this.maxHeight, c.getMaxHeight());
            }
            first = false;
        }
    }
    /** @internal */ tidy() {
        let i = 0;
        while(i < this.children.length){
            const child = this.children[i];
            if (child instanceof RowNode) {
                child.tidy();
                const childChildren = child.getChildren();
                if (childChildren.length === 0) this.removeChild(child);
                else if (childChildren.length === 1) {
                    const subchild = childChildren[0];
                    this.removeChild(child);
                    if (subchild instanceof RowNode) {
                        let subChildrenTotal = 0;
                        const subChildChildren = subchild.getChildren();
                        for (const ssc of subChildChildren)subChildrenTotal += ssc.getWeight();
                        for(let j = 0; j < subChildChildren.length; j++){
                            const subsubChild = subChildChildren[j];
                            subsubChild.setWeight(child.getWeight() * subsubChild.getWeight() / subChildrenTotal);
                            this.addChild(subsubChild, i + j);
                        }
                    } else {
                        subchild.setWeight(child.getWeight());
                        this.addChild(subchild, i);
                    }
                } else i++;
            } else if (child instanceof $8041f202454d6b76$export$812bb9af945a59fa && child.getChildren().length === 0) {
                if (child.isEnableDeleteWhenEmpty() && child.isEnableClose()) {
                    this.removeChild(child);
                    if (child === this.model.getMaximizedTabset(this.getLayoutId())) this.model.setMaximizedTabset(void 0, this.getLayoutId());
                } else i++;
            } else i++;
        }
        if (this === this.model.getRootRow(this.getLayoutId()) && this.children.length === 0) {
            if (this.getLayout()?.getType() !== "tab" && this.getLayoutId() !== $8041f202454d6b76$export$a1edc412be3e1841.MAIN_LAYOUT_ID) this.model.getLayouts().delete(this.getLayoutId());
            else {
                const callback = this.model.getOnCreateTabSet();
                let attrs = callback ? callback() : {};
                attrs = {
                    ...attrs,
                    selected: -1
                };
                const child = new $8041f202454d6b76$export$812bb9af945a59fa(this.model, attrs);
                this.model.setActiveTabset(child, this.getLayoutId());
                this.addChild(child);
            }
        }
    }
    /** @internal */ canDrop(dragNode, x, y) {
        const yy = y - this.rect.y;
        const xx = x - this.rect.x;
        const w = this.rect.width;
        const h = this.rect.height;
        const margin = 10;
        const half = this.model.isEnableEdgeDockIndicators() ? 50 : 9999;
        let dropInfo;
        const layout = this.getLayout();
        if (this.getLayoutId() !== $8041f202454d6b76$export$a1edc412be3e1841.MAIN_LAYOUT_ID && !$8041f202454d6b76$var$canDockToLayout(dragNode, layout)) return;
        if (this.model.isEnableEdgeDock() && this.parent === void 0) {
            if (x < this.rect.x + margin && yy > h / 2 - half && yy < h / 2 + half) {
                const dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.LEFT;
                const outlineRect = dockLocation.getDockRect(this.rect);
                outlineRect.width = outlineRect.width / 2;
                dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, -1, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT_EDGE);
            } else if (x > this.rect.getRight() - margin && yy > h / 2 - half && yy < h / 2 + half) {
                const dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.RIGHT;
                const outlineRect = dockLocation.getDockRect(this.rect);
                outlineRect.width = outlineRect.width / 2;
                outlineRect.x += outlineRect.width;
                dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, -1, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT_EDGE);
            } else if (y < this.rect.y + margin && xx > w / 2 - half && xx < w / 2 + half) {
                const dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.TOP;
                const outlineRect = dockLocation.getDockRect(this.rect);
                outlineRect.height = outlineRect.height / 2;
                dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, -1, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT_EDGE);
            } else if (y > this.rect.getBottom() - margin && xx > w / 2 - half && xx < w / 2 + half) {
                const dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM;
                const outlineRect = dockLocation.getDockRect(this.rect);
                outlineRect.height = outlineRect.height / 2;
                outlineRect.y += outlineRect.height;
                dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, -1, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT_EDGE);
            }
            if (dropInfo !== void 0) {
                if (!dragNode.canDockInto(dragNode, dropInfo)) return;
            }
        }
        return dropInfo;
    }
    /** @internal */ drop(dragNode, location, index) {
        const dockLocation = location;
        const parent = dragNode.getParent();
        if (parent) parent.removeChild(dragNode);
        if (parent !== void 0 && parent instanceof $8041f202454d6b76$export$812bb9af945a59fa) parent.setSelected(0);
        if (parent !== void 0 && parent instanceof $8041f202454d6b76$export$317342baaa5be054) parent.setSelected(-1);
        let node;
        if (dragNode instanceof $8041f202454d6b76$export$812bb9af945a59fa || dragNode instanceof RowNode) {
            node = dragNode;
            if (node instanceof RowNode && node.getOrientation() === this.getOrientation() && (location.getOrientation() === this.getOrientation() || location === $8041f202454d6b76$export$5bf830809a2e00b2.CENTER)) {
                node = new RowNode(this.model, {});
                node.addChild(dragNode);
            }
        } else {
            const callback = this.model.getOnCreateTabSet();
            const json = callback ? callback(dragNode) : {};
            node = new $8041f202454d6b76$export$812bb9af945a59fa(this.model, json);
            node.addChild(dragNode);
        }
        let size = this.children.reduce((sum, child)=>{
            return sum + child.getWeight();
        }, 0);
        if (size === 0) size = 100;
        node.setWeight(size / 3);
        const horz = !this.model.isRootOrientationVertical();
        if (dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.CENTER) {
            if (index === -1) this.addChild(node, this.children.length);
            else this.addChild(node, index);
        } else if (horz && dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.LEFT || !horz && dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.TOP) this.addChild(node, 0);
        else if (horz && dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.RIGHT || !horz && dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM) this.addChild(node);
        else if (horz && dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.TOP || !horz && dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.LEFT) {
            const vrow = new RowNode(this.model, {});
            const hrow = new RowNode(this.model, {});
            hrow.setWeight(75);
            node.setWeight(25);
            for (const child of this.children)hrow.addChild(child);
            this.removeAll();
            vrow.addChild(node);
            vrow.addChild(hrow);
            this.addChild(vrow);
        } else if (horz && dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM || !horz && dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.RIGHT) {
            const vrow = new RowNode(this.model, {});
            const hrow = new RowNode(this.model, {});
            hrow.setWeight(75);
            node.setWeight(25);
            for (const child of this.children)hrow.addChild(child);
            this.removeAll();
            vrow.addChild(hrow);
            vrow.addChild(node);
            this.addChild(vrow);
        }
        if (node instanceof $8041f202454d6b76$export$812bb9af945a59fa) this.model.setActiveTabset(node, this.getLayoutId());
        this.model.tidy();
    }
    /** @internal */ isEnableDrop() {
        return true;
    }
    /** @internal */ getAttributeDefinitions() {
        return RowNode.attributeDefinitions;
    }
    /** @internal */ updateAttrs(json) {
        RowNode.attributeDefinitions.update(json, this.attributes);
    }
    /** @internal */ static getAttributeDefinitions() {
        return RowNode.attributeDefinitions;
    }
    normalizeWeights() {
        let sum = 0;
        for (const n of this.children)sum += n.getWeight();
        if (sum === 0) sum = 1;
        for (const n of this.children){
            const node = n;
            node.setWeight(Math.max(.001, 100 * node.getWeight() / sum));
        }
    }
    /** @internal */ static createAttributeDefinitions() {
        const attributeDefinitions = new $8041f202454d6b76$var$Attributes();
        attributeDefinitions.add("type", RowNode.TYPE, true).setType($8041f202454d6b76$var$Attribute.STRING).setFixed();
        attributeDefinitions.add("id", void 0).setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`the unique id of the row, if left undefined a uuid will be assigned`);
        attributeDefinitions.add("weight", 100).setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`relative weight for sizing of this row in parent row`);
        return attributeDefinitions;
    }
};
//#endregion
//#region src/model/TabSetNode.ts
var $8041f202454d6b76$export$812bb9af945a59fa = class TabSetNode extends $8041f202454d6b76$export$85c928794f8d04d4 {
    static TYPE = "tabset";
    /** @internal */ static fromJson(json, model, layout) {
        const newLayoutNode = new TabSetNode(model, json);
        if (json.children != null) for (const jsonChild of json.children){
            const child = $8041f202454d6b76$export$8dbf7edd89edc19c.fromJson(jsonChild, model);
            newLayoutNode.addChild(child);
        }
        if (newLayoutNode.children.length === 0) newLayoutNode.setSelected(-1);
        if (json.maximized && json.maximized === true) layout.setMaximizedTabSet(newLayoutNode);
        if (json.active && json.active === true) layout.setActiveTabSet(newLayoutNode);
        return newLayoutNode;
    }
    static attributeDefinitions = TabSetNode.createAttributeDefinitions();
    tabStripRect = $8041f202454d6b76$export$c79fc6492f3af13d.empty();
    contentRect = $8041f202454d6b76$export$c79fc6492f3af13d.empty();
    calculatedMinHeight;
    calculatedMinWidth;
    calculatedMaxHeight;
    calculatedMaxWidth;
    /** @internal */ constructor(model, json){
        super(model);
        this.calculatedMinHeight = 0;
        this.calculatedMinWidth = 0;
        this.calculatedMaxHeight = 0;
        this.calculatedMaxWidth = 0;
        TabSetNode.attributeDefinitions.fromJson(json, this.attributes);
        model.addNode(this);
    }
    getName() {
        return this.getAttr("name");
    }
    isEnableActiveIcon() {
        return this.getAttr("enableActiveIcon");
    }
    getSelected() {
        const selected = this.attributes.selected;
        if (selected !== void 0) return selected;
        return -1;
    }
    getSelectedNode() {
        const selected = this.getSelected();
        if (selected !== -1) return this.children[selected];
    }
    getWeight() {
        return this.getAttr("weight");
    }
    getAttrMinWidth() {
        return this.getAttr("minWidth");
    }
    getAttrMinHeight() {
        return this.getAttr("minHeight");
    }
    getMinWidth() {
        return this.calculatedMinWidth;
    }
    getMinHeight() {
        return this.calculatedMinHeight;
    }
    /** @internal */ getMinSize(orientation) {
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return this.getMinWidth();
        else return this.getMinHeight();
    }
    getAttrMaxWidth() {
        return this.getAttr("maxWidth");
    }
    getAttrMaxHeight() {
        return this.getAttr("maxHeight");
    }
    getMaxWidth() {
        return this.calculatedMaxWidth;
    }
    getMaxHeight() {
        return this.calculatedMaxHeight;
    }
    /** @internal */ getMaxSize(orientation) {
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return this.getMaxWidth();
        else return this.getMaxHeight();
    }
    isCloseable() {
        let closeable = this.isEnableClose();
        if (closeable) closeable = super.isCloseable();
        return closeable;
    }
    /**
	* Returns the config attribute that can be used to store node specific data that
	* WILL be saved to the json. The config attribute should be changed via the action Actions.updateNodeAttributes rather
	* than directly, for example:
	* this.state.model.doAction(
	*   FlexLayout.Actions.updateNodeAttributes(node.getId(), {config:myConfigObject}));
	*/ getConfig() {
        return this.attributes.config;
    }
    isMaximized() {
        return this.model.getMaximizedTabset(this.getLayoutId()) === this;
    }
    isActive() {
        return this.model.getActiveTabset(this.getLayoutId()) === this;
    }
    isEnableDeleteWhenEmpty() {
        return this.getAttr("enableDeleteWhenEmpty");
    }
    isEnableDrop() {
        return this.getAttr("enableDrop");
    }
    isEnableTabStrip() {
        return this.getAttr("enableTabStrip");
    }
    isEnableTabWrap() {
        return this.getAttr("enableTabWrap");
    }
    isEnableDrag() {
        return this.getAttr("enableDrag");
    }
    isEnableDivide() {
        return this.getAttr("enableDivide");
    }
    isEnableMaximize() {
        return this.getAttr("enableMaximize");
    }
    isEnableClose() {
        return this.getAttr("enableClose");
    }
    isEnableCloseButton() {
        return this.getAttr("enableCloseButton");
    }
    isEnableSingleTabStretch() {
        return this.getAttr("enableSingleTabStretch");
    }
    isAutoSelectTab() {
        return this.getAttr("autoSelectTab");
    }
    isEnableTabScrollbar() {
        return this.getAttr("enableTabScrollbar");
    }
    getClassNameTabStrip() {
        return this.getAttr("classNameTabStrip");
    }
    getTabLocation() {
        return this.getAttr("tabLocation");
    }
    toJson() {
        const json = {};
        TabSetNode.attributeDefinitions.toJson(json, this.attributes);
        json.children = this.children.map((child)=>child.toJson());
        if (this.isActive()) json.active = true;
        if (this.isMaximized()) json.maximized = true;
        return json;
    }
    /** @internal */ calcMinMaxSize() {
        this.calculatedMinHeight = this.getAttrMinHeight();
        this.calculatedMinWidth = this.getAttrMinWidth();
        this.calculatedMaxHeight = this.getAttrMaxHeight();
        this.calculatedMaxWidth = this.getAttrMaxWidth();
        for (const child of this.children){
            const c = child;
            this.calculatedMinWidth = Math.max(this.calculatedMinWidth, c.getMinWidth());
            this.calculatedMinHeight = Math.max(this.calculatedMinHeight, c.getMinHeight());
            this.calculatedMaxWidth = Math.min(this.calculatedMaxWidth, c.getMaxWidth());
            this.calculatedMaxHeight = Math.min(this.calculatedMaxHeight, c.getMaxHeight());
        }
        this.calculatedMinHeight += this.tabStripRect.height;
        this.calculatedMaxHeight += this.tabStripRect.height;
    }
    /** @internal */ canMaximize() {
        if (this.isEnableMaximize()) {
            if (this.getModel().getMaximizedTabset(this.getLayoutId()) === this) return true;
            if (this.getParent() === this.getModel().getRootRow(this.getLayoutId()) && this.getModel().getRootRow(this.getLayoutId()).getChildren().length === 1) return false;
            return true;
        }
        return false;
    }
    /** @internal */ setContentRect(rect) {
        this.contentRect = rect;
    }
    /** @internal */ getContentRect() {
        return this.contentRect;
    }
    /** @internal */ setTabStripRect(rect) {
        this.tabStripRect = rect;
    }
    /** @internal */ setWeight(weight) {
        this.attributes.weight = weight;
    }
    /** @internal */ setSelected(index) {
        this.attributes.selected = index;
    }
    /** @internal */ canDrop(dragNode, x, y) {
        let dropInfo;
        const layout = this.getLayout();
        if (dragNode === this) {
            const dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.CENTER;
            const outlineRect = this.tabStripRect;
            dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, -1, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
        } else if (this.getLayoutId() !== $8041f202454d6b76$export$a1edc412be3e1841.MAIN_LAYOUT_ID && !$8041f202454d6b76$var$canDockToLayout(dragNode, layout)) return;
        else if (this.contentRect.contains(x, y)) {
            let dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.CENTER;
            if (this.model.getMaximizedTabset(this.getLayoutId()) === void 0) dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.getLocation(this.contentRect, x, y);
            const outlineRect = dockLocation.getDockRect(this.rect);
            dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, -1, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
        } else if (this.tabStripRect != null && this.tabStripRect.contains(x, y)) {
            let r;
            let yy;
            let h;
            if (this.children.length === 0) {
                r = this.tabStripRect.clone();
                yy = r.y + 3;
                h = r.height - 4;
                r.width = 2;
            } else {
                let child = this.children[0];
                r = child.getTabRect();
                yy = r.y;
                h = r.height;
                let p = this.tabStripRect.x;
                for(let i = 0; i < this.children.length; i++){
                    child = this.children[i];
                    r = child.getTabRect();
                    if (r.y !== yy) {
                        yy = r.y;
                        p = this.tabStripRect.x;
                    }
                    const childCenter = r.x + r.width / 2;
                    if (p <= x && x < childCenter && r.y < y && y < r.getBottom()) {
                        const dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.CENTER;
                        const outlineRect = new $8041f202454d6b76$export$c79fc6492f3af13d(r.x - 2, r.y, 3, r.height);
                        if (this.rect.x < r.x && r.x < this.rect.getRight()) {
                            dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, i, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
                            break;
                        } else return;
                    }
                    p = childCenter;
                }
            }
            if (dropInfo == null && r.getRight() < this.rect.getRight()) {
                const dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.CENTER;
                const outlineRect = new $8041f202454d6b76$export$c79fc6492f3af13d(r.getRight() - 2, yy, 3, h);
                dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, this.children.length, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
            }
        }
        if (!dragNode.canDockInto(dragNode, dropInfo)) return;
        return dropInfo;
    }
    /** @internal */ delete() {
        this.parent.removeChild(this);
    }
    /** @internal */ remove(node) {
        const removedIndex = this.removeChild(node);
        this.model.tidy();
        $8041f202454d6b76$var$adjustSelectedIndex(this, removedIndex);
    }
    /** @internal */ drop(dragNode, location, index, select) {
        const dockLocation = location;
        if (this === dragNode) return;
        const dragParent = dragNode.getParent();
        let fromIndex = 0;
        if (dragParent !== void 0) {
            fromIndex = dragParent.removeChild(dragNode);
            if (dragParent instanceof $8041f202454d6b76$export$317342baaa5be054 && dragParent.getSelected() === fromIndex) dragParent.setSelected(-1);
            else $8041f202454d6b76$var$adjustSelectedIndex(dragParent, fromIndex);
        }
        if (dragNode instanceof $8041f202454d6b76$export$8dbf7edd89edc19c && dragParent === this && fromIndex < index && index > 0) index--;
        if (dockLocation === $8041f202454d6b76$export$5bf830809a2e00b2.CENTER) {
            let insertPos = index;
            if (insertPos === -1) insertPos = this.children.length;
            if (dragNode instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
                this.addChild(dragNode, insertPos);
                if (select || select !== false && this.isAutoSelectTab()) this.setSelected(insertPos);
            } else if (dragNode instanceof $8041f202454d6b76$export$6af91cd58ec2edf9) dragNode.forEachNode((child, level)=>{
                if (child instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
                    this.addChild(child, insertPos);
                    insertPos++;
                }
            }, 0);
            else {
                for(let i = 0; i < dragNode.getChildren().length; i++){
                    const child = dragNode.getChildren()[i];
                    this.addChild(child, insertPos);
                    insertPos++;
                }
                if (this.getSelected() === -1 && this.children.length > 0) this.setSelected(0);
            }
            this.model.setActiveTabset(this, this.parent.getLayoutId());
        } else {
            let moveNode = dragNode;
            if (dragNode instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
                const callback = this.model.getOnCreateTabSet();
                moveNode = new TabSetNode(this.model, callback ? callback(dragNode) : {});
                moveNode.addChild(dragNode);
            } else if (dragNode instanceof $8041f202454d6b76$export$6af91cd58ec2edf9) {
                const parent = this.getParent();
                if (dragNode.getOrientation() === parent.getOrientation() && (location.getOrientation() === parent.getOrientation() || location === $8041f202454d6b76$export$5bf830809a2e00b2.CENTER)) {
                    const node = new $8041f202454d6b76$export$6af91cd58ec2edf9(this.model, {});
                    node.addChild(dragNode);
                    moveNode = node;
                }
            } else moveNode = dragNode;
            const parentRow = this.parent;
            const pos = parentRow.getChildren().indexOf(this);
            if (parentRow.getOrientation() === dockLocation.orientation) {
                moveNode.setWeight(this.getWeight() / 2);
                this.setWeight(this.getWeight() / 2);
                parentRow.addChild(moveNode, pos + dockLocation.indexPlus);
            } else {
                const newRow = new $8041f202454d6b76$export$6af91cd58ec2edf9(this.model, {});
                newRow.setWeight(this.getWeight());
                newRow.addChild(this);
                this.setWeight(50);
                moveNode.setWeight(50);
                newRow.addChild(moveNode, dockLocation.indexPlus);
                parentRow.removeChild(this);
                parentRow.addChild(newRow, pos);
            }
            if (moveNode instanceof TabSetNode) this.model.setActiveTabset(moveNode, this.getLayoutId());
        }
        this.model.tidy();
    }
    /** @internal */ updateAttrs(json) {
        TabSetNode.attributeDefinitions.update(json, this.attributes);
    }
    /** @internal */ getAttributeDefinitions() {
        return TabSetNode.attributeDefinitions;
    }
    /** @internal */ static getAttributeDefinitions() {
        return TabSetNode.attributeDefinitions;
    }
    /** @internal */ static createAttributeDefinitions() {
        const attributeDefinitions = new $8041f202454d6b76$var$Attributes();
        attributeDefinitions.add("type", TabSetNode.TYPE, true).setType($8041f202454d6b76$var$Attribute.STRING).setFixed();
        attributeDefinitions.add("id", void 0).setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`the unique id of the tab set, if left undefined a uuid will be assigned`);
        attributeDefinitions.add("weight", 100).setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`relative weight for sizing of this tabset in parent row`);
        attributeDefinitions.add("selected", 0).setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`index of selected/visible tab in tabset`);
        attributeDefinitions.add("name", void 0).setType($8041f202454d6b76$var$Attribute.STRING);
        attributeDefinitions.add("config", void 0).setType("any").setDescription(`a place to hold json config used in your own code`);
        attributeDefinitions.addInherited("enableDeleteWhenEmpty", "tabSetEnableDeleteWhenEmpty").setDescription(`whether to delete this tabset when is has no tabs`);
        attributeDefinitions.addInherited("enableDrop", "tabSetEnableDrop").setDescription(`allow user to drag tabs into this tabset`);
        attributeDefinitions.addInherited("enableDrag", "tabSetEnableDrag").setDescription(`allow user to drag tabs out this tabset`);
        attributeDefinitions.addInherited("enableDivide", "tabSetEnableDivide").setDescription(`allow user to drag tabs to region of this tabset, splitting into new tabset`);
        attributeDefinitions.addInherited("enableMaximize", "tabSetEnableMaximize").setDescription(`allow user to maximize tabset to fill view via maximize button`);
        attributeDefinitions.addInherited("enableClose", "tabSetEnableClose").setDescription(`can this tabset be closed`);
        attributeDefinitions.addInherited("enableCloseButton", "tabSetEnableCloseButton").setDescription(`if the tabset can be closed then show a close button`);
        attributeDefinitions.addInherited("enableSingleTabStretch", "tabSetEnableSingleTabStretch").setDescription(`if the tabset has only a single tab then stretch the single tab to fill area and display in a header style`);
        attributeDefinitions.addInherited("classNameTabStrip", "tabSetClassNameTabStrip").setDescription(`a class name to apply to the tab strip`);
        attributeDefinitions.addInherited("enableTabStrip", "tabSetEnableTabStrip").setDescription(`enable tab strip and allow multiple tabs in this tabset`);
        attributeDefinitions.addInherited("minWidth", "tabSetMinWidth").setDescription(`minimum width (in px) for this tabset`);
        attributeDefinitions.addInherited("minHeight", "tabSetMinHeight").setDescription(`minimum height (in px) for this tabset`);
        attributeDefinitions.addInherited("maxWidth", "tabSetMaxWidth").setDescription(`maximum width (in px) for this tabset`);
        attributeDefinitions.addInherited("maxHeight", "tabSetMaxHeight").setDescription(`maximum height (in px) for this tabset`);
        attributeDefinitions.addInherited("enableTabWrap", "tabSetEnableTabWrap").setDescription(`wrap tabs onto multiple lines`);
        attributeDefinitions.addInherited("tabLocation", "tabSetTabLocation").setDescription(`the location of the tabs either top or bottom`);
        attributeDefinitions.addInherited("autoSelectTab", "tabSetAutoSelectTab").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether to select new/moved tabs in tabset`);
        attributeDefinitions.addInherited("enableActiveIcon", "tabSetEnableActiveIcon").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether the active icon (*) should be displayed when the tabset is active`);
        attributeDefinitions.addInherited("enableTabScrollbar", "tabSetEnableTabScrollbar").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether to show a mini scrollbar for the tabs`);
        return attributeDefinitions;
    }
};
//#endregion
//#region src/model/Utils.ts
/** @internal */ function $8041f202454d6b76$var$adjustSelectedIndex(parent, removedIndex) {
    if (parent !== void 0 && (parent instanceof $8041f202454d6b76$export$812bb9af945a59fa || parent instanceof $8041f202454d6b76$export$317342baaa5be054)) {
        const selectedIndex = parent.getSelected();
        if (selectedIndex !== -1) {
            if (removedIndex === selectedIndex && parent.getChildren().length > 0) {
                if (removedIndex >= parent.getChildren().length) parent.setSelected(parent.getChildren().length - 1);
            } else if (removedIndex < selectedIndex) parent.setSelected(selectedIndex - 1);
            else if (removedIndex > selectedIndex) ;
            else parent.setSelected(-1);
        }
    }
}
function $8041f202454d6b76$var$randomUUID() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}
//#endregion
//#region src/model/BorderNode.ts
var $8041f202454d6b76$export$317342baaa5be054 = class BorderNode extends $8041f202454d6b76$export$85c928794f8d04d4 {
    static TYPE = "border";
    /** @internal */ static fromJson(json, model) {
        const border = new BorderNode($8041f202454d6b76$export$5bf830809a2e00b2.getByName(json.location), json, model);
        if (json.children) border.children = json.children.map((jsonChild)=>{
            const child = $8041f202454d6b76$export$8dbf7edd89edc19c.fromJson(jsonChild, model);
            child.setParent(border);
            return child;
        });
        return border;
    }
    /** @internal */ static attributeDefinitions = BorderNode.createAttributeDefinitions();
    /** @internal */ contentRect = $8041f202454d6b76$export$c79fc6492f3af13d.empty();
    /** @internal */ tabHeaderRect = $8041f202454d6b76$export$c79fc6492f3af13d.empty();
    /** @internal */ location;
    /** @internal */ constructor(location, json, model){
        super(model);
        this.location = location;
        this.attributes.id = `border_${location.getName()}`;
        BorderNode.attributeDefinitions.fromJson(json, this.attributes);
        model.addNode(this);
    }
    getLocation() {
        return this.location;
    }
    getClassName() {
        return this.getAttr("className");
    }
    isHorizontal() {
        return this.location.orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ;
    }
    getSize() {
        const defaultSize = this.getAttr("size");
        const selected = this.getSelected();
        if (selected === -1) return defaultSize;
        else {
            const tabNode = this.children[selected];
            const tabBorderSize = this.isHorizontal() ? tabNode.getAttr("borderWidth") : tabNode.getAttr("borderHeight");
            if (tabBorderSize === -1) return defaultSize;
            else return tabBorderSize;
        }
    }
    getMinSize() {
        const selectedNode = this.getSelectedNode();
        let min = this.getAttr("minSize");
        if (selectedNode) {
            const nodeMin = this.isHorizontal() ? selectedNode.getMinWidth() : selectedNode.getMinHeight();
            min = Math.max(min, nodeMin);
        }
        return min;
    }
    getMaxSize() {
        const selectedNode = this.getSelectedNode();
        let max = this.getAttr("maxSize");
        if (selectedNode) {
            const nodeMax = this.isHorizontal() ? selectedNode.getMaxWidth() : selectedNode.getMaxHeight();
            max = Math.min(max, nodeMax);
        }
        return max;
    }
    getSelected() {
        return this.attributes.selected;
    }
    isAutoHide() {
        return this.getAttr("enableAutoHide");
    }
    getSelectedNode() {
        if (this.getSelected() !== -1) return this.children[this.getSelected()];
    }
    getOrientation() {
        return this.location.getOrientation();
    }
    /**
	* Returns the config attribute that can be used to store node specific data that
	* WILL be saved to the json. The config attribute should be changed via the action Actions.updateNodeAttributes rather
	* than directly, for example:
	* this.state.model.doAction(
	*   FlexLayout.Actions.updateNodeAttributes(node.getId(), {config:myConfigObject}));
	*/ getConfig() {
        return this.attributes.config;
    }
    isMaximized() {
        return false;
    }
    isShowing() {
        return this.attributes.show;
    }
    toJson() {
        const json = {
            location: "bottom"
        };
        BorderNode.attributeDefinitions.toJson(json, this.attributes);
        json.location = this.location.getName();
        json.children = this.children.map((child)=>child.toJson());
        return json;
    }
    /** @internal */ isAutoSelectTab(whenOpen) {
        if (whenOpen == null) whenOpen = this.getSelected() !== -1;
        if (whenOpen) return this.getAttr("autoSelectTabWhenOpen");
        else return this.getAttr("autoSelectTabWhenClosed");
    }
    isEnableTabScrollbar() {
        return this.getAttr("enableTabScrollbar");
    }
    /** @internal */ setSelected(index) {
        this.attributes.selected = index;
    }
    /** @internal */ getTabHeaderRect() {
        return this.tabHeaderRect;
    }
    /** @internal */ setTabHeaderRect(r) {
        this.tabHeaderRect = r;
    }
    /** @internal */ getRect() {
        return this.tabHeaderRect;
    }
    /** @internal */ getContentRect() {
        return this.contentRect;
    }
    /** @internal */ setContentRect(r) {
        this.contentRect = r;
    }
    /** @internal */ isEnableDrop() {
        return this.getAttr("enableDrop");
    }
    /** @internal */ setSize(pos) {
        const selected = this.getSelected();
        if (selected === -1) this.attributes.size = pos;
        else {
            const tabNode = this.children[selected];
            if ((this.isHorizontal() ? tabNode.getAttr("borderWidth") : tabNode.getAttr("borderHeight")) === -1) this.attributes.size = pos;
            else if (this.isHorizontal()) tabNode.setBorderWidth(pos);
            else tabNode.setBorderHeight(pos);
        }
    }
    /** @internal */ updateAttrs(json) {
        BorderNode.attributeDefinitions.update(json, this.attributes);
    }
    /** @internal */ remove(node) {
        const removedIndex = this.removeChild(node);
        if (this.getSelected() !== -1) $8041f202454d6b76$var$adjustSelectedIndex(this, removedIndex);
    }
    /** @internal */ canDrop(dragNode, x, y) {
        if (!(dragNode instanceof $8041f202454d6b76$export$8dbf7edd89edc19c)) return;
        let dropInfo;
        const dockLocation = $8041f202454d6b76$export$5bf830809a2e00b2.CENTER;
        if (this.tabHeaderRect.contains(x, y)) {
            if (this.location.orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.VERT) {
                if (this.children.length > 0) {
                    let child = this.children[0];
                    let childRect = child.getTabRect();
                    const childY = childRect.y;
                    const childHeight = childRect.height;
                    let pos = this.tabHeaderRect.x;
                    for(let i = 0; i < this.children.length; i++){
                        child = this.children[i];
                        childRect = child.getTabRect();
                        const childCenter = childRect.x + childRect.width / 2;
                        if (x >= pos && x < childCenter) {
                            const outlineRect = new $8041f202454d6b76$export$c79fc6492f3af13d(childRect.x - 2, childY, 3, childHeight);
                            dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, i, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
                            break;
                        }
                        pos = childCenter;
                    }
                    if (dropInfo == null) {
                        const outlineRect = new $8041f202454d6b76$export$c79fc6492f3af13d(childRect.getRight() - 2, childY, 3, childHeight);
                        dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, this.children.length, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
                    }
                } else {
                    const outlineRect = new $8041f202454d6b76$export$c79fc6492f3af13d(this.tabHeaderRect.x + 1, this.tabHeaderRect.y + 2, 3, 18);
                    dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, 0, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
                }
            } else if (this.children.length > 0) {
                let child = this.children[0];
                let childRect = child.getTabRect();
                const childX = childRect.x;
                const childWidth = childRect.width;
                let pos = this.tabHeaderRect.y;
                for(let i = 0; i < this.children.length; i++){
                    child = this.children[i];
                    childRect = child.getTabRect();
                    const childCenter = childRect.y + childRect.height / 2;
                    if (y >= pos && y < childCenter) {
                        const outlineRect = new $8041f202454d6b76$export$c79fc6492f3af13d(childX, childRect.y - 2, childWidth, 3);
                        dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, i, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
                        break;
                    }
                    pos = childCenter;
                }
                if (dropInfo == null) {
                    const outlineRect = new $8041f202454d6b76$export$c79fc6492f3af13d(childX, childRect.getBottom() - 2, childWidth, 3);
                    dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, this.children.length, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
                }
            } else {
                const outlineRect = new $8041f202454d6b76$export$c79fc6492f3af13d(this.tabHeaderRect.x + 2, this.tabHeaderRect.y + 1, 18, 3);
                dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, 0, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
            }
            if (!dragNode.canDockInto(dragNode, dropInfo)) return;
        } else if (this.getSelected() !== -1 && this.contentRect.contains(x, y)) {
            const outlineRect = this.contentRect;
            dropInfo = new $8041f202454d6b76$export$e14a08f842f4256c(this, outlineRect, dockLocation, -1, $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
            if (!dragNode.canDockInto(dragNode, dropInfo)) return;
        }
        return dropInfo;
    }
    /** @internal */ drop(dragNode, location, index, select) {
        let fromIndex = 0;
        const dragParent = dragNode.getParent();
        if (dragParent !== void 0) {
            fromIndex = dragParent.removeChild(dragNode);
            if (dragParent !== this && dragParent instanceof BorderNode && dragParent.getSelected() === fromIndex) dragParent.setSelected(-1);
            else $8041f202454d6b76$var$adjustSelectedIndex(dragParent, fromIndex);
        }
        if (dragNode instanceof $8041f202454d6b76$export$8dbf7edd89edc19c && dragParent === this && fromIndex < index && index > 0) index--;
        let insertPos = index;
        if (insertPos === -1) insertPos = this.children.length;
        if (dragNode instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) this.addChild(dragNode, insertPos);
        if (select || select !== false && this.isAutoSelectTab()) this.setSelected(insertPos);
        this.model.tidy();
    }
    /** @internal */ getSplitterBounds(index, useMinSize = false) {
        const pBounds = [
            0,
            0
        ];
        const minSize = useMinSize ? this.getMinSize() : 0;
        const maxSize = useMinSize ? this.getMaxSize() : 99999;
        const rootRow = this.model.getRootRow($8041f202454d6b76$export$a1edc412be3e1841.MAIN_LAYOUT_ID);
        const innerRect = rootRow.getRect();
        const splitterSize = this.model.getSplitterSize();
        if (this.location === $8041f202454d6b76$export$5bf830809a2e00b2.TOP) {
            pBounds[0] = this.tabHeaderRect.getBottom() + minSize;
            const maxPos = this.tabHeaderRect.getBottom() + maxSize;
            pBounds[1] = Math.max(pBounds[0], innerRect.getBottom() - rootRow.getMinHeight() - splitterSize);
            pBounds[1] = Math.min(pBounds[1], maxPos);
        } else if (this.location === $8041f202454d6b76$export$5bf830809a2e00b2.LEFT) {
            pBounds[0] = this.tabHeaderRect.getRight() + minSize;
            const maxPos = this.tabHeaderRect.getRight() + maxSize;
            pBounds[1] = Math.max(pBounds[0], innerRect.getRight() - rootRow.getMinWidth() - splitterSize);
            pBounds[1] = Math.min(pBounds[1], maxPos);
        } else if (this.location === $8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM) {
            pBounds[1] = this.tabHeaderRect.y - minSize - splitterSize;
            const maxPos = this.tabHeaderRect.y - maxSize - splitterSize;
            pBounds[0] = Math.min(pBounds[1], innerRect.y + rootRow.getMinHeight());
            pBounds[0] = Math.max(pBounds[0], maxPos);
        } else if (this.location === $8041f202454d6b76$export$5bf830809a2e00b2.RIGHT) {
            pBounds[1] = this.tabHeaderRect.x - minSize - splitterSize;
            const maxPos = this.tabHeaderRect.x - maxSize - splitterSize;
            pBounds[0] = Math.min(pBounds[1], innerRect.x + rootRow.getMinWidth());
            pBounds[0] = Math.max(pBounds[0], maxPos);
        }
        return pBounds;
    }
    /** @internal */ calculateSplit(splitter, splitterPos) {
        const pBounds = this.getSplitterBounds(splitterPos);
        if (this.location === $8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM || this.location === $8041f202454d6b76$export$5bf830809a2e00b2.RIGHT) return Math.max(0, pBounds[1] - splitterPos);
        else return Math.max(0, splitterPos - pBounds[0]);
    }
    /** @internal */ getAttributeDefinitions() {
        return BorderNode.attributeDefinitions;
    }
    /** @internal */ static getAttributeDefinitions() {
        return BorderNode.attributeDefinitions;
    }
    /** @internal */ static createAttributeDefinitions() {
        const attributeDefinitions = new $8041f202454d6b76$var$Attributes();
        attributeDefinitions.add("type", BorderNode.TYPE, true).setType($8041f202454d6b76$var$Attribute.STRING).setFixed();
        attributeDefinitions.add("selected", -1).setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`index of selected/visible tab in border; -1 means no tab selected`);
        attributeDefinitions.add("show", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`show/hide this border`);
        attributeDefinitions.add("config", void 0).setType("any").setDescription(`a place to hold json config used in your own code`);
        attributeDefinitions.addInherited("enableDrop", "borderEnableDrop").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether tabs can be dropped into this border`);
        attributeDefinitions.addInherited("className", "borderClassName").setType($8041f202454d6b76$var$Attribute.STRING).setDescription(`class applied to tab button`);
        attributeDefinitions.addInherited("autoSelectTabWhenOpen", "borderAutoSelectTabWhenOpen").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether to select new/moved tabs in border when the border is already open`);
        attributeDefinitions.addInherited("autoSelectTabWhenClosed", "borderAutoSelectTabWhenClosed").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether to select new/moved tabs in border when the border is currently closed`);
        attributeDefinitions.addInherited("size", "borderSize").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`size of the tab area when selected`);
        attributeDefinitions.addInherited("minSize", "borderMinSize").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`the minimum size of the tab area`);
        attributeDefinitions.addInherited("maxSize", "borderMaxSize").setType($8041f202454d6b76$var$Attribute.NUMBER).setDescription(`the maximum size of the tab area`);
        attributeDefinitions.addInherited("enableAutoHide", "borderEnableAutoHide").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`hide border if it has zero tabs`);
        attributeDefinitions.addInherited("enableTabScrollbar", "borderEnableTabScrollbar").setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`whether to show a mini scrollbar for the tabs`);
        return attributeDefinitions;
    }
};
//#endregion
//#region src/model/BorderSet.ts
var $8041f202454d6b76$export$4779d9c20fbfdb65 = class BorderSet {
    /** @internal */ static fromJson(json, model) {
        const borderSet = new BorderSet(model);
        borderSet.borders = json.map((borderJson)=>$8041f202454d6b76$export$317342baaa5be054.fromJson(borderJson, model));
        for (const border of borderSet.borders)borderSet.borderMap.set(border.getLocation(), border);
        return borderSet;
    }
    /** @internal */ borders;
    /** @internal */ borderMap;
    /** @internal */ layoutHorizontal;
    /** @internal */ constructor(_model){
        this.borders = [];
        this.borderMap = /* @__PURE__ */ new Map();
        this.layoutHorizontal = true;
    }
    toJson() {
        return this.borders.map((borderNode)=>borderNode.toJson());
    }
    /** @internal */ getLayoutHorizontal() {
        return this.layoutHorizontal;
    }
    /** @internal */ getBorders() {
        return this.borders;
    }
    /** @internal */ getBorderMap() {
        return this.borderMap;
    }
    /** @internal */ forEachNode(fn) {
        for (const borderNode of this.borders){
            fn(borderNode, 0);
            for (const node of borderNode.getChildren())node.forEachNode(fn, 1);
        }
    }
    /** @internal */ setPaths() {
        for (const borderNode of this.borders){
            const path = "/border/" + borderNode.getLocation().getName();
            borderNode.setPath(path);
            let i = 0;
            for (const node of borderNode.getChildren()){
                node.setPath(path + "/t" + i);
                i++;
            }
        }
    }
    /** @internal */ findDropTargetNode(dragNode, x, y) {
        for (const border of this.borders)if (border.isShowing()) {
            const dropInfo = border.canDrop(dragNode, x, y);
            if (dropInfo !== void 0) return dropInfo;
        }
    }
};
//#endregion
//#region src/model/Layout.ts
/** @internal */ var $8041f202454d6b76$var$Layout$1 = class Layout$1 {
    _layoutId;
    _type;
    _rect;
    _controller;
    _rootRow;
    _maximizedTabSet;
    _activeTabSet;
    _toExportRectFunction;
    constructor(layoutId, type, rect){
        this._layoutId = layoutId;
        this._type = type;
        this._rect = rect;
        this._toExportRectFunction = (r, type)=>r;
    }
    visitNodes(fn) {
        this.getRootRow()?.forEachNode(fn, 0);
    }
    isMainLayout() {
        return this._layoutId === $8041f202454d6b76$export$a1edc412be3e1841.MAIN_LAYOUT_ID;
    }
    getLayoutId() {
        return this._layoutId;
    }
    getType() {
        return this._type;
    }
    setType(value) {
        this._type = value;
    }
    getRect() {
        return this._rect;
    }
    getController() {
        return this._controller;
    }
    getWindow() {
        return this._controller?.getCurrentWindow();
    }
    getRootRow() {
        return this._rootRow;
    }
    getMaximizedTabSet() {
        return this._maximizedTabSet;
    }
    getActiveTabSet() {
        return this._activeTabSet;
    }
    setRect(value) {
        this._rect = value;
    }
    setController(value) {
        this._controller = value;
    }
    getWindowId() {
        return this._controller?.getWindowId();
    }
    setRootRow(rowNode) {
        rowNode?.setLayout(this);
        this._rootRow = rowNode;
    }
    setMaximizedTabSet(value) {
        this._maximizedTabSet = value;
    }
    setActiveTabSet(value) {
        this._activeTabSet = value;
    }
    getToExportRectFunction() {
        return this._toExportRectFunction;
    }
    setToExportRectFunction(value) {
        this._toExportRectFunction = value;
    }
    toJson() {
        if (this.getType() === "window" && this.getWindow() && this.getWindow().screenTop > -10000) this.setRect(new $8041f202454d6b76$export$c79fc6492f3af13d(this.getWindow().screenLeft, this.getWindow().screenTop, this.getWindow().outerWidth, this.getWindow().outerHeight));
        return {
            type: this.getType(),
            layout: this.getRootRow().toJson(),
            rect: this.getType() === "tab" ? void 0 : this.getRect().toJson()
        };
    }
    static fromJson(layoutJson, model, layoutId) {
        const count = model.getLayouts().size;
        const rect = layoutJson.rect ? $8041f202454d6b76$export$c79fc6492f3af13d.fromJson(layoutJson.rect) : new $8041f202454d6b76$export$c79fc6492f3af13d(50 + 50 * count, 50 + 50 * count, 600, 400);
        rect.snap(10);
        const layout = new Layout$1(layoutId, layoutJson.type || "window", rect);
        layout.setRootRow($8041f202454d6b76$export$6af91cd58ec2edf9.fromJson(layoutJson.layout, model, layout));
        return layout;
    }
};
//#endregion
//#region src/model/Model.ts
/** @internal */ var $8041f202454d6b76$export$bd8332a8856a0d58 = 1;
/** @internal */ var $8041f202454d6b76$export$2cef24a37c57bc8d = 99999;
/**
* Class containing the Tree of Nodes used by the FlexLayout component
*/ var $8041f202454d6b76$export$a1edc412be3e1841 = class Model {
    static MAIN_LAYOUT_ID = "__main_layout_id__";
    /** @internal */ static attributeDefinitions = Model.createAttributeDefinitions();
    /** @internal */ attributes;
    /** @internal */ layouts;
    /** @internal */ borders;
    /** @internal */ changeListeners;
    /** @internal */ idMap;
    /** @internal */ mainLayout;
    /** @internal */ splitterSize;
    /** @internal */ onAllowDrop;
    /** @internal */ onCreateTabSet;
    /**
	* 'private' constructor. Use the static method Model.fromJson(json) to create a model
	*  @internal
	*/ constructor(){
        this.attributes = {};
        this.layouts = /* @__PURE__ */ new Map();
        this.borders = new $8041f202454d6b76$export$4779d9c20fbfdb65(this);
        this.idMap = /* @__PURE__ */ new Map();
        this.changeListeners = [];
        this.mainLayout = new $8041f202454d6b76$var$Layout$1(Model.MAIN_LAYOUT_ID, "window", $8041f202454d6b76$export$c79fc6492f3af13d.empty());
        this.layouts.set(Model.MAIN_LAYOUT_ID, this.mainLayout);
        this.splitterSize = 8;
    }
    /**
	* Update the node tree by performing the given action,
	* Actions should be generated via static methods on the Actions class
	* @param action the action to perform
	* @returns added Node for Actions.addTab, layoutId for createPopout
	*/ doAction(action) {
        let returnVal = void 0;
        switch(action.type){
            case $8041f202454d6b76$export$b52183d5cfb26dc9.ADD_TAB:
                {
                    const newNode = new $8041f202454d6b76$export$8dbf7edd89edc19c(this, action.data.json, true);
                    const toNode = this.idMap.get(action.data.toNode);
                    if (toNode instanceof $8041f202454d6b76$export$812bb9af945a59fa || toNode instanceof $8041f202454d6b76$export$317342baaa5be054 || toNode instanceof $8041f202454d6b76$export$6af91cd58ec2edf9) {
                        toNode.drop(newNode, $8041f202454d6b76$export$5bf830809a2e00b2.getByName(action.data.location), action.data.index, action.data.select);
                        returnVal = newNode;
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.MOVE_NODE:
                {
                    const fromNode = this.idMap.get(action.data.fromNode);
                    if (fromNode instanceof $8041f202454d6b76$export$8dbf7edd89edc19c || fromNode instanceof $8041f202454d6b76$export$812bb9af945a59fa || fromNode instanceof $8041f202454d6b76$export$6af91cd58ec2edf9) {
                        if (fromNode === this.getMaximizedTabset(fromNode.getLayoutId())) this.layouts.get(fromNode.getLayoutId()).setMaximizedTabSet(void 0);
                        const toNode = this.idMap.get(action.data.toNode);
                        if (toNode instanceof $8041f202454d6b76$export$812bb9af945a59fa || toNode instanceof $8041f202454d6b76$export$317342baaa5be054 || toNode instanceof $8041f202454d6b76$export$6af91cd58ec2edf9) toNode.drop(fromNode, $8041f202454d6b76$export$5bf830809a2e00b2.getByName(action.data.location), action.data.index, action.data.select);
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.DELETE_TAB:
                {
                    const node = this.idMap.get(action.data.node);
                    if (node instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) node.delete();
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.DELETE_TABSET:
                {
                    const node = this.idMap.get(action.data.node);
                    if (node instanceof $8041f202454d6b76$export$812bb9af945a59fa) {
                        const children = [
                            ...node.getChildren()
                        ];
                        for(let i = 0; i < children.length; i++){
                            const child = children[i];
                            if (child.isEnableClose()) child.delete();
                        }
                        if (node.getChildren().length === 0) node.delete();
                        this.tidy();
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.POPOUT_TABSET:
                {
                    const node = this.idMap.get(action.data.node);
                    if (node instanceof $8041f202454d6b76$export$812bb9af945a59fa) {
                        const isMaximized = node.isMaximized();
                        const oldLayout = node.getLayout();
                        const layoutId = $8041f202454d6b76$var$randomUUID();
                        const type = action.data.type || "window";
                        const layout = new $8041f202454d6b76$var$Layout$1(layoutId, type, oldLayout.getToExportRectFunction()(node.getRect(), type));
                        const row = $8041f202454d6b76$export$6af91cd58ec2edf9.fromJson({
                            type: "row"
                        }, this, layout);
                        layout.setRootRow(row);
                        this.layouts.set(layoutId, layout);
                        row.drop(node, $8041f202454d6b76$export$5bf830809a2e00b2.CENTER, 0);
                        if (isMaximized) this.mainLayout.setMaximizedTabSet(void 0);
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.POPOUT_TAB:
                {
                    const node = this.idMap.get(action.data.node);
                    if (node instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
                        const layoutId = $8041f202454d6b76$var$randomUUID();
                        const popoutRect = node.getParent().getContentRect();
                        const oldLayout = node.getLayout();
                        const type = action.data.type || "window";
                        const layout = new $8041f202454d6b76$var$Layout$1(layoutId, type, oldLayout.getToExportRectFunction()(popoutRect, type));
                        const tabsetId = $8041f202454d6b76$var$randomUUID();
                        const json = {
                            type: "row",
                            children: [
                                {
                                    type: "tabset",
                                    id: tabsetId
                                }
                            ]
                        };
                        const row = $8041f202454d6b76$export$6af91cd58ec2edf9.fromJson(json, this, layout);
                        layout.setRootRow(row);
                        this.layouts.set(layoutId, layout);
                        this.idMap.get(tabsetId).drop(node, $8041f202454d6b76$export$5bf830809a2e00b2.CENTER, 0, true);
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.SELECT_TAB:
                {
                    const tabNode = this.idMap.get(action.data.tabNode);
                    if (tabNode instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
                        const parent = tabNode.getParent();
                        const pos = parent.getChildren().indexOf(tabNode);
                        if (parent instanceof $8041f202454d6b76$export$317342baaa5be054) {
                            if (parent.getSelected() === pos) parent.setSelected(-1);
                            else parent.setSelected(pos);
                        } else if (parent instanceof $8041f202454d6b76$export$812bb9af945a59fa) {
                            if (parent.getSelected() !== pos) parent.setSelected(pos);
                            tabNode.getLayout().setActiveTabSet(parent);
                        }
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.SET_ACTIVE_TABSET:
                {
                    const layoutId = action.data.layoutId ? action.data.layoutId : Model.MAIN_LAYOUT_ID;
                    const layout = this.layouts.get(layoutId);
                    if (action.data.tabsetNode === void 0) layout.setActiveTabSet(void 0);
                    else {
                        const tabsetNode = this.idMap.get(action.data.tabsetNode);
                        if (tabsetNode instanceof $8041f202454d6b76$export$812bb9af945a59fa) layout.setActiveTabSet(tabsetNode);
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.ADJUST_WEIGHTS:
                {
                    const c = this.idMap.get(action.data.nodeId).getChildren();
                    for(let i = 0; i < c.length; i++)c[i].setWeight(action.data.weights[i]);
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.ADJUST_BORDER_SPLIT:
                {
                    const node = this.idMap.get(action.data.node);
                    if (node instanceof $8041f202454d6b76$export$317342baaa5be054) node.setSize(action.data.size);
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.MAXIMIZE_TOGGLE:
                {
                    const layoutId = action.data.layoutId ? action.data.layoutId : Model.MAIN_LAYOUT_ID;
                    const layout = this.layouts.get(layoutId);
                    const node = this.idMap.get(action.data.node);
                    if (node instanceof $8041f202454d6b76$export$812bb9af945a59fa) {
                        if (node === layout.getMaximizedTabSet()) layout.setMaximizedTabSet(void 0);
                        else {
                            layout.setMaximizedTabSet(node);
                            layout.setActiveTabSet(node);
                        }
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.UPDATE_MODEL_ATTRIBUTES:
                this.updateAttrs(action.data.json);
                break;
            case $8041f202454d6b76$export$b52183d5cfb26dc9.UPDATE_NODE_ATTRIBUTES:
                this.idMap.get(action.data.node).updateAttrs(action.data.json);
                break;
            case $8041f202454d6b76$export$b52183d5cfb26dc9.RENAME_TAB:
                {
                    const node = this.idMap.get(action.data.node);
                    if (node instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) node.setName(action.data.text);
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.CREATE_SUBLAYOUT:
                {
                    const layoutId = $8041f202454d6b76$var$randomUUID();
                    const layout = new $8041f202454d6b76$var$Layout$1(layoutId, action.data.type || "window", $8041f202454d6b76$export$c79fc6492f3af13d.fromJson(action.data.rect));
                    const row = $8041f202454d6b76$export$6af91cd58ec2edf9.fromJson(action.data.layout, this, layout);
                    layout.setRootRow(row);
                    this.layouts.set(layoutId, layout);
                    returnVal = layoutId;
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.CLOSE_POPOUT:
                {
                    const oldLayout = this.layouts.get(action.data.layoutId);
                    if (oldLayout) {
                        oldLayout.setType("float");
                        const r = this.mainLayout.getController().getDomRect();
                        oldLayout.setRect(new $8041f202454d6b76$export$c79fc6492f3af13d(r.width / 4, r.height / 4, r.width / 2, r.height / 2));
                    }
                    break;
                }
            case $8041f202454d6b76$export$b52183d5cfb26dc9.MOVE_POPOUT_TO_FRONT:
                {
                    const layoutId = action.data.layoutId;
                    const layout = this.layouts.get(layoutId);
                    if (layout) {
                        this.layouts.delete(layoutId);
                        this.layouts.set(layoutId, layout);
                    }
                    break;
                }
            default:
                break;
        }
        this.updateIdMap();
        for (const listener of this.changeListeners)listener(action);
        return returnVal;
    }
    /**
	* Get the currently active tabset node
	*/ getActiveTabset(layoutId = Model.MAIN_LAYOUT_ID) {
        const layout = this.layouts.get(layoutId);
        if (layout && layout.getActiveTabSet() && this.getNodeById(layout.getActiveTabSet().getId())) return layout.getActiveTabSet();
        else return;
    }
    /**
	* Get the currently maximized tabset node
	*/ getMaximizedTabset(layoutId = Model.MAIN_LAYOUT_ID) {
        return this.layouts.get(layoutId).getMaximizedTabSet();
    }
    /**
	* Gets the root RowNode of the model
	* @returns {RowNode}
	*/ getRootRow(layoutId = Model.MAIN_LAYOUT_ID) {
        return this.layouts.get(layoutId).getRootRow();
    }
    isRootOrientationVertical() {
        return this.attributes.rootOrientationVertical;
    }
    isEnableRotateBorderIcons() {
        return this.attributes.enableRotateBorderIcons;
    }
    /**
	* Gets the
	* @returns {BorderSet|*}
	*/ getBorderSet() {
        return this.borders;
    }
    /**
	* Visits all the nodes in the model and calls the given function for each
	* @param fn a function that takes visited node and a integer level as parameters
	*/ visitNodes(fn) {
        this.borders.forEachNode(fn);
        for (const [_, w] of this.layouts)w.getRootRow().forEachNode(fn, 0);
    }
    visitLayoutNodes(layoutId, fn) {
        if (this.layouts.has(layoutId)) {
            if (layoutId === Model.MAIN_LAYOUT_ID) this.borders.forEachNode(fn);
            this.layouts.get(layoutId).visitNodes(fn);
        }
    }
    /**
	* Gets a node by its id
	* @param id the id to find
	*/ getNodeById(id) {
        return this.idMap.get(id);
    }
    /**
	* Finds the first/top left tab set of the given node.
	* @param node The top node you want to begin searching from, deafults to the root node
	* @returns The first Tab Set
	*/ getFirstTabSet(node = this.layouts.get(Model.MAIN_LAYOUT_ID).getRootRow()) {
        const child = node.getChildren()[0];
        if (child instanceof $8041f202454d6b76$export$812bb9af945a59fa) return child;
        else return this.getFirstTabSet(child);
    }
    /**
	* Loads the model from the given json object
	* @param json the json model to load
	* @returns {Model} a new Model object
	*/ static fromJson(json) {
        const model = new Model();
        Model.attributeDefinitions.fromJson(json.global, model.attributes);
        if (json.borders) model.borders = $8041f202454d6b76$export$4779d9c20fbfdb65.fromJson(json.borders, model);
        const subLayouts = json.subLayouts || json.popouts;
        if (subLayouts) for(const layoutId in subLayouts){
            const layoutJson = subLayouts[layoutId];
            const layout = $8041f202454d6b76$var$Layout$1.fromJson(layoutJson, model, layoutId);
            model.layouts.set(layoutId, layout);
        }
        model.mainLayout.setRootRow($8041f202454d6b76$export$6af91cd58ec2edf9.fromJson(json.layout, model, model.mainLayout));
        model.tidy();
        return model;
    }
    /**
	* Converts the model to a json object
	* @returns {IJsonModel} json object that represents this model
	*/ toJson() {
        const global = {};
        Model.attributeDefinitions.toJson(global, this.attributes);
        this.visitNodes((node)=>{
            node.fireEvent("save", {});
        });
        const subLayouts = {};
        for (const [id, layout] of this.layouts)if (id !== Model.MAIN_LAYOUT_ID) subLayouts[id] = layout.toJson();
        return {
            global: global,
            borders: this.borders.toJson(),
            layout: this.mainLayout.getRootRow().toJson(),
            subLayouts: subLayouts
        };
    }
    getSplitterSize() {
        return this.splitterSize;
    }
    setSplitterSize(size) {
        this.splitterSize = size;
    }
    isEnableEdgeDock() {
        return this.attributes.enableEdgeDock;
    }
    isEnableEdgeDockIndicators() {
        return this.attributes.enableEdgeDockIndicators;
    }
    /**
	* Sets a function to allow/deny dropping a node
	* @param onAllowDrop function that takes the drag node and DropInfo and returns true if the drop is allowed
	*/ setOnAllowDrop(onAllowDrop) {
        this.onAllowDrop = onAllowDrop;
    }
    /**
	* set callback called when a new TabSet is created.
	* The tabNode can be undefined if it's the auto created first tabset in the root row (when the last
	* tab is deleted, the root tabset can be recreated)
	* @param onCreateTabSet 
	*/ setOnCreateTabSet(onCreateTabSet) {
        this.onCreateTabSet = onCreateTabSet;
    }
    addChangeListener(listener) {
        this.changeListeners.push(listener);
    }
    removeChangeListener(listener) {
        const pos = this.changeListeners.findIndex((l)=>l === listener);
        if (pos !== -1) this.changeListeners.splice(pos, 1);
    }
    toString() {
        return JSON.stringify(this.toJson());
    }
    /***********************internal ********************************/ /** @internal */ getMainLayout() {
        return this.mainLayout;
    }
    /** @internal */ getLayouts() {
        return this.layouts;
    }
    /** @internal */ sortLayouts() {
        const priority = {
            window: 1,
            tab: 2,
            float: 3
        };
        const sorted = Array.from(this.getLayouts().values()).sort((a, b)=>{
            return priority[a.getType()] - priority[b.getType()];
        });
        this.layouts.clear();
        sorted.forEach((layout)=>this.layouts.set(layout.getLayoutId(), layout));
    }
    /** @internal */ setActiveTabset(tabsetNode, layoutId) {
        const layout = this.layouts.get(layoutId);
        if (layout) {
            if (tabsetNode) layout.setActiveTabSet(tabsetNode);
            else layout.setActiveTabSet(void 0);
        }
    }
    /** @internal */ setMaximizedTabset(tabsetNode, layoutId) {
        const layout = this.layouts.get(layoutId);
        if (layout) {
            if (tabsetNode) layout.setMaximizedTabSet(tabsetNode);
            else layout.setMaximizedTabSet(void 0);
        }
    }
    /** @internal */ updateIdMap() {
        this.idMap.clear();
        this.visitNodes((node)=>{
            this.idMap.set(node.getId(), node);
        });
    }
    /** @internal */ addNode(node) {
        const id = node.getId();
        if (this.idMap.has(id)) throw new Error(`Error: each node must have a unique id, duplicate id:${node.getId()}`);
        this.idMap.set(id, node);
    }
    /** @internal */ findDropTargetNode(layoutId, dragNode, x, y) {
        let node = this.layouts.get(layoutId).getRootRow().findDropTargetNode(layoutId, dragNode, x, y);
        if (node === void 0 && layoutId === Model.MAIN_LAYOUT_ID) node = this.borders.findDropTargetNode(dragNode, x, y);
        return node;
    }
    /** @internal */ tidy() {
        for (const [_, layout] of this.layouts)layout.getRootRow().tidy();
    }
    /** @internal */ updateAttrs(json) {
        Model.attributeDefinitions.update(json, this.attributes);
    }
    /** @internal */ nextUniqueId() {
        return "#" + $8041f202454d6b76$var$randomUUID();
    }
    /** @internal */ getAttribute(name) {
        return this.attributes[name];
    }
    /** @internal */ getOnAllowDrop() {
        return this.onAllowDrop;
    }
    /** @internal */ getOnCreateTabSet() {
        return this.onCreateTabSet;
    }
    static toTypescriptInterfaces() {
        Model.attributeDefinitions.pairAttributes("RowNode", $8041f202454d6b76$export$6af91cd58ec2edf9.getAttributeDefinitions());
        Model.attributeDefinitions.pairAttributes("TabSetNode", $8041f202454d6b76$export$812bb9af945a59fa.getAttributeDefinitions());
        Model.attributeDefinitions.pairAttributes("TabNode", $8041f202454d6b76$export$8dbf7edd89edc19c.getAttributeDefinitions());
        Model.attributeDefinitions.pairAttributes("BorderNode", $8041f202454d6b76$export$317342baaa5be054.getAttributeDefinitions());
        const sb = [];
        sb.push(Model.attributeDefinitions.toTypescriptInterface("Global", void 0));
        sb.push($8041f202454d6b76$export$6af91cd58ec2edf9.getAttributeDefinitions().toTypescriptInterface("Row", Model.attributeDefinitions));
        sb.push($8041f202454d6b76$export$812bb9af945a59fa.getAttributeDefinitions().toTypescriptInterface("TabSet", Model.attributeDefinitions));
        sb.push($8041f202454d6b76$export$8dbf7edd89edc19c.getAttributeDefinitions().toTypescriptInterface("Tab", Model.attributeDefinitions));
        sb.push($8041f202454d6b76$export$317342baaa5be054.getAttributeDefinitions().toTypescriptInterface("Border", Model.attributeDefinitions));
        console.log(sb.join("\n"));
    }
    /** @internal */ static createAttributeDefinitions() {
        const attributeDefinitions = new $8041f202454d6b76$var$Attributes();
        attributeDefinitions.add("enableEdgeDock", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`enable docking to the edges of the layout`);
        attributeDefinitions.add("enableEdgeDockIndicators", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`show the edge indicators when dragging`);
        attributeDefinitions.add("rootOrientationVertical", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`the top level 'row' will layout horizontally by default, set this option true to make it layout vertically`);
        attributeDefinitions.add("enableRotateBorderIcons", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN).setDescription(`boolean indicating if tab icons should rotate with the text in the left and right borders`);
        attributeDefinitions.add("tabEnableClose", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabCloseType", 1).setType("ICloseType");
        attributeDefinitions.add("tabEnablePopout", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN).setAlias("tabEnableFloat");
        attributeDefinitions.add("tabEnablePopoutIcon", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabEnablePopoutFloatIcon", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabEnablePopoutOverlay", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabEnableDrag", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabEnableRename", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabContentClassName", void 0).setType($8041f202454d6b76$var$Attribute.STRING);
        attributeDefinitions.add("tabClassName", void 0).setType($8041f202454d6b76$var$Attribute.STRING);
        attributeDefinitions.add("tabIcon", void 0).setType($8041f202454d6b76$var$Attribute.STRING);
        attributeDefinitions.add("tabEnableRenderOnDemand", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabBorderWidth", -1).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabBorderHeight", -1).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabSetEnableDeleteWhenEmpty", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableDrop", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableDrag", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableDivide", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableMaximize", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableClose", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableCloseButton", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableSingleTabStretch", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetAutoSelectTab", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableActiveIcon", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetClassNameTabStrip", void 0).setType($8041f202454d6b76$var$Attribute.STRING);
        attributeDefinitions.add("tabSetEnableTabStrip", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetEnableTabWrap", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("tabSetTabLocation", "top").setType("ITabLocation");
        attributeDefinitions.add("tabMinWidth", 1).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabMinHeight", 1).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabSetMinWidth", 1).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabSetMinHeight", 1).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabMaxWidth", $8041f202454d6b76$export$2cef24a37c57bc8d).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabMaxHeight", $8041f202454d6b76$export$2cef24a37c57bc8d).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabSetMaxWidth", $8041f202454d6b76$export$2cef24a37c57bc8d).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabSetMaxHeight", $8041f202454d6b76$export$2cef24a37c57bc8d).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("tabSetEnableTabScrollbar", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("borderSize", 200).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("borderMinSize", 1).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("borderMaxSize", $8041f202454d6b76$export$2cef24a37c57bc8d).setType($8041f202454d6b76$var$Attribute.NUMBER);
        attributeDefinitions.add("borderEnableDrop", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("borderAutoSelectTabWhenOpen", true).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("borderAutoSelectTabWhenClosed", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("borderClassName", void 0).setType($8041f202454d6b76$var$Attribute.STRING);
        attributeDefinitions.add("borderEnableAutoHide", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        attributeDefinitions.add("borderEnableTabScrollbar", false).setType($8041f202454d6b76$var$Attribute.BOOLEAN);
        return attributeDefinitions;
    }
};
//#endregion
//#region src/view/Icons.tsx
var $8041f202454d6b76$var$style = {
    width: "1em",
    height: "1em",
    display: "flex",
    alignItems: "center"
};
var $8041f202454d6b76$export$cae179f078f4b4a4 = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        viewBox: "0 0 24 24",
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                stroke: "var(--color-icon)",
                fill: "var(--color-icon)",
                d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            })
        ]
    });
};
var $8041f202454d6b76$export$ad8cd11d6f0ad24c = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        viewBox: "0 0 24 24",
        fill: "var(--color-icon)",
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                stroke: "var(--color-icon)",
                d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
            })
        ]
    });
};
var $8041f202454d6b76$export$636a0ccc59ff4b45 = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        viewBox: "0 0 24 24",
        fill: "var(--color-icon)",
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                stroke: "var(--color-icon)",
                d: "M7 10l5 5 5-5z"
            })
        ]
    });
};
var $8041f202454d6b76$export$245c60722c6bebea = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            display: "block",
            width: 10,
            height: 10
        },
        preserveAspectRatio: "none",
        viewBox: "0 0 100 100",
        children: /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
            fill: "var(--color-edge-icon)",
            stroke: "var(--color-edge-icon)",
            d: "M10 30 L90 30 l-40 40 Z"
        })
    });
};
var $8041f202454d6b76$export$a837275bb5fcc92e = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        viewBox: "0 0 20 20",
        fill: "var(--color-icon)",
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                d: "M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                d: "M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"
            })
        ]
    });
};
var $8041f202454d6b76$export$5397056b5a472cd2 = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        viewBox: "0 0 20 20",
        fill: "var(--color-icon)",
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("rect", {
                x: "3",
                y: "10",
                width: "7",
                height: "7",
                rx: "1",
                fill: "none",
                stroke: "var(--color-icon)",
                strokeWidth: "1.5"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("rect", {
                x: "10",
                y: "3",
                width: "7",
                height: "7",
                rx: "1",
                fill: "none",
                stroke: "var(--color-icon)",
                strokeWidth: "1.5"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                d: "M6 14 L14 6",
                stroke: "var(--color-icon)",
                strokeWidth: "1.5",
                strokeLinecap: "round"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                d: "M10 6 h4 v4",
                fill: "none",
                stroke: "var(--color-icon)",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var $8041f202454d6b76$export$56d8a8da8edf546a = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        viewBox: "0 0 24 24",
        fill: "var(--color-icon)",
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                stroke: "var(--color-icon)",
                d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
            })
        ]
    });
};
var $8041f202454d6b76$export$2c138db10ecf1f6b = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        height: "24px",
        viewBox: "0 -960 960 960",
        width: "24px",
        children: /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
            fill: "var(--color-icon)",
            stroke: "var(--color-icon)",
            d: "M440-120v-264L254-197l-57-57 187-186H120v-80h264L197-706l57-57 186 187v-264h80v264l186-187 57 57-187 186h264v80H576l187 186-57 57-186-187v264h-80Z"
        })
    });
};
var $8041f202454d6b76$export$a6b7c34d56975de0 = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        height: "24px",
        viewBox: "0 0 24 24",
        fill: "var(--color-icon)",
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                stroke: "var(--color-icon)",
                d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
            })
        ]
    });
};
var $8041f202454d6b76$export$46e1d66043f363e6 = ()=>{
    return /* @__PURE__ */ (0, $fRwNr.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        style: $8041f202454d6b76$var$style,
        height: "24px",
        width: "24px",
        viewBox: "0 -960 960 960",
        fill: "var(--color-icon)",
        children: /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
            d: "M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"
        })
    });
};
var $8041f202454d6b76$export$ac4e8b8ca2b79f39 = (props)=>{
    return /* @__PURE__ */ (0, $fRwNr.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        style: $8041f202454d6b76$var$style,
        viewBox: "0 0 24 24",
        fill: "var(--color-icon)",
        children: /* @__PURE__ */ (0, $fRwNr.jsxs)("g", {
            children: [
                /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                    d: "M0,0h24v24H0V0z",
                    fill: "none"
                }),
                /* @__PURE__ */ (0, $fRwNr.jsx)("path", {
                    d: "M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
                })
            ]
        })
    });
};
//#endregion
//#region src/view/Overlay.tsx
/** @internal */ var $8041f202454d6b76$var$Overlay = (props)=>{
    const { controller: controller, show: show } = props;
    return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT_OVERLAY),
        style: {
            display: show ? "flex" : "none"
        }
    });
};
//#endregion
//#region src/view/I18nLabel.ts
var $8041f202454d6b76$export$e9d9efe81c96e81 = /* @__PURE__ */ function(I18nLabel) {
    I18nLabel["Close_Tab"] = "Close";
    I18nLabel["Close_Tabset"] = "Close tab set";
    I18nLabel["Active_Tabset"] = "Active tab set";
    I18nLabel["Move_Tabset"] = "Move tab set";
    I18nLabel["Move_Tabs"] = "Move tabs (?)";
    I18nLabel["Maximize"] = "Maximize tab set";
    I18nLabel["Restore"] = "Restore tab set";
    I18nLabel["Popout_Tab"] = "Popout selected tab";
    I18nLabel["Popout_Tab_Float"] = "Float selected tab";
    I18nLabel["Overflow_Menu_Tooltip"] = "Hidden tabs";
    I18nLabel["Error_rendering_component"] = "Error rendering component";
    I18nLabel["Error_rendering_component_retry"] = "Retry";
    return I18nLabel;
}({});
//#endregion
//#region src/view/TabButtonStamp.tsx
/** @internal */ var $8041f202454d6b76$var$TabButtonStamp = (props)=>{
    const { controller: controller, tabNode: tabNode } = props;
    const cm = controller.getClassName;
    const classNames = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_STAMP);
    const renderState = $8041f202454d6b76$var$getRenderStateEx(controller, tabNode);
    const content = renderState.content ? /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_CONTENT),
        children: renderState.content
    }) : tabNode.getNameForOverflowMenu();
    const leading = renderState.leading ? /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_LEADING),
        children: renderState.leading
    }) : null;
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        className: classNames,
        title: tabNode.getHelpText(),
        children: [
            leading,
            content
        ]
    });
};
//#endregion
//#region src/view/PopupMenu.tsx
/** @internal */ function $8041f202454d6b76$var$showPopup(triggerElement, parentNode, items, onSelect, controller) {
    const layoutDiv = controller.getRootDiv();
    const classNameMapper = controller.getClassName;
    const currentDocument = triggerElement.ownerDocument;
    const triggerRect = triggerElement.getBoundingClientRect();
    const layoutRect = layoutDiv?.getBoundingClientRect() ?? new DOMRect(0, 0, 100, 100);
    const elm = currentDocument.createElement("div");
    elm.className = classNameMapper($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__POPUP_MENU_CONTAINER);
    if (triggerRect.left < layoutRect.left + layoutRect.width / 2) elm.style.left = triggerRect.left - layoutRect.left + "px";
    else elm.style.right = layoutRect.right - triggerRect.right + "px";
    if (triggerRect.top < layoutRect.top + layoutRect.height / 2) elm.style.top = triggerRect.top - layoutRect.top + "px";
    else elm.style.bottom = layoutRect.bottom - triggerRect.bottom + "px";
    controller.showOverlayOnAllWindows(true);
    if (layoutDiv) layoutDiv.appendChild(elm);
    const onHide = ()=>{
        controller.hideControlInPortal();
        controller.showOverlayOnAllWindows(false);
        if (layoutDiv) layoutDiv.removeChild(elm);
        elm.removeEventListener("pointerdown", onElementPointerDown);
        currentDocument.removeEventListener("pointerdown", onDocPointerDown);
    };
    const onElementPointerDown = (event)=>{
        event.stopPropagation();
    };
    const onDocPointerDown = (_event)=>{
        onHide();
    };
    elm.addEventListener("pointerdown", onElementPointerDown);
    currentDocument.addEventListener("pointerdown", onDocPointerDown);
    controller.showControlInPortal(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$PopupMenu, {
        currentDocument: currentDocument,
        parentNode: parentNode,
        onSelect: onSelect,
        onHide: onHide,
        items: items,
        classNameMapper: classNameMapper,
        controller: controller
    }), elm);
}
/** @internal */ var $8041f202454d6b76$var$PopupMenu = (props)=>{
    const { parentNode: parentNode, items: items, onHide: onHide, onSelect: onSelect, classNameMapper: classNameMapper, controller: controller } = props;
    const divRef = (0, $lx97N.useRef)(null);
    (0, $lx97N.useEffect)(()=>{
        if (divRef.current) divRef.current.focus();
    }, []);
    const onItemClick = (item, event)=>{
        onSelect(item);
        onHide();
        event.stopPropagation();
    };
    const onDragStart = (event, node)=>{
        event.stopPropagation();
        controller.getDragDropManager().setDragNode(event.nativeEvent, node);
        setTimeout(()=>{
            onHide();
        }, 0);
    };
    const onDragEnd = (_event)=>{
        controller.getDragDropManager().clearDragMain();
    };
    const handleKeyDown = (event)=>{
        if (event.key === "Escape") onHide();
    };
    const itemElements = items.map((item, i)=>{
        let classes = classNameMapper($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__POPUP_MENU_ITEM);
        if (parentNode.getSelected() === item.index) classes += " " + classNameMapper($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__POPUP_MENU_ITEM__SELECTED);
        return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            className: classes,
            "data-layout-path": "/popup-menu/tb" + i,
            onClick: (event)=>onItemClick(item, event),
            draggable: true,
            onDragStart: (e)=>onDragStart(e, item.node),
            onDragEnd: onDragEnd,
            title: item.node.getHelpText(),
            children: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$TabButtonStamp, {
                tabNode: item.node,
                controller: controller
            })
        }, item.index);
    });
    return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: classNameMapper($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__POPUP_MENU),
        ref: divRef,
        tabIndex: 0,
        onKeyDown: handleKeyDown,
        "data-layout-path": "/popup-menu",
        children: itemElements
    });
};
//#endregion
//#region src/model/ICloseType.ts
var $8041f202454d6b76$export$92f33a959b683412 = /* @__PURE__ */ function(ICloseType) {
    ICloseType[ICloseType["Visible"] = 1] = "Visible";
    ICloseType[ICloseType["Always"] = 2] = "Always";
    ICloseType[ICloseType["Selected"] = 3] = "Selected";
    return ICloseType;
}({});
//#endregion
//#region src/view/TabButton.tsx
/** @internal */ var $8041f202454d6b76$var$TabButton = (props)=>{
    const { controller: controller, tabNode: tabNode, selected: selected, path: path } = props;
    const selfRef = $lx97N.useRef(null);
    const contentRef = $lx97N.useRef(null);
    const icons = controller.getIcons();
    $lx97N.useLayoutEffect(()=>{
        tabNode.setTabRect(controller.getBoundingClientRect(selfRef.current));
        if (controller.getEditingTab() === tabNode) contentRef.current.select();
    });
    const onDragStart = (event)=>{
        if (tabNode.isEnableDrag()) {
            event.stopPropagation();
            controller.getDragDropManager().setDragNode(event.nativeEvent, tabNode);
        } else event.preventDefault();
    };
    const onDragEnd = (_event)=>{
        controller.getDragDropManager().clearDragMain();
    };
    const onAuxMouseClick = (event)=>{
        if ($8041f202454d6b76$var$isAuxMouseEvent(event)) controller.auxMouseClick(tabNode, event);
    };
    const onContextMenu = (event)=>{
        controller.showContextMenu(tabNode, event);
    };
    const onClick = ()=>{
        controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.selectTab(tabNode.getId()));
    };
    const onDoubleClick = (event)=>{
        if (tabNode.isEnableRename()) {
            onRename();
            event.stopPropagation();
        }
    };
    const onRename = ()=>{
        controller.setEditingTab(tabNode);
        controller.getCurrentDocument().body.addEventListener("pointerdown", onEndEdit);
    };
    const onEndEdit = (event)=>{
        if (event.target !== contentRef.current) {
            controller.getCurrentDocument().body.removeEventListener("pointerdown", onEndEdit);
            controller.setEditingTab(void 0);
        }
    };
    const isClosable = ()=>{
        const closeType = tabNode.getCloseType();
        if (selected || closeType === $8041f202454d6b76$export$92f33a959b683412.Always) return true;
        if (closeType === $8041f202454d6b76$export$92f33a959b683412.Visible) {
            if (window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) return true;
        }
        return false;
    };
    const onClose = (event)=>{
        if (isClosable()) {
            controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.deleteTab(tabNode.getId()));
            event.stopPropagation();
        }
    };
    const onClosePointerDown = (event)=>{
        event.stopPropagation();
    };
    const onTextBoxPointerDown = (event)=>{
        event.stopPropagation();
    };
    const onTextBoxKeyPress = (event)=>{
        if (event.code === "Escape") controller.setEditingTab(void 0);
        else if (event.code === "Enter" || event.code === "NumpadEnter") {
            controller.setEditingTab(void 0);
            controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.renameTab(tabNode.getId(), event.target.value));
        }
    };
    const cm = controller.getClassName;
    const parentNode = tabNode.getParent();
    const isStretch = parentNode.isEnableSingleTabStretch() && parentNode.getChildren().length === 1;
    const baseClassName = isStretch ? $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_STRETCH : $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON;
    let classNames = cm(baseClassName);
    classNames += " " + cm(baseClassName + "_" + parentNode.getTabLocation());
    if (!isStretch) {
        if (selected) classNames += " " + cm(baseClassName + "--selected");
        else classNames += " " + cm(baseClassName + "--unselected");
    }
    if (tabNode.getClassName() !== void 0) classNames += " " + tabNode.getClassName();
    const renderState = $8041f202454d6b76$var$getRenderStateEx(controller, tabNode);
    let content = renderState.content ? /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_CONTENT),
        children: renderState.content
    }) : null;
    const leading = renderState.leading ? /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_LEADING),
        children: renderState.leading
    }) : null;
    if (controller.getEditingTab() === tabNode) content = /* @__PURE__ */ (0, $fRwNr.jsx)("input", {
        ref: contentRef,
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_TEXTBOX),
        "data-layout-path": path + "/textbox",
        type: "text",
        autoFocus: true,
        defaultValue: tabNode.getName(),
        onKeyDown: onTextBoxKeyPress,
        onPointerDown: onTextBoxPointerDown
    });
    if (tabNode.isCloseable() && !isStretch) {
        const closeTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Close_Tab);
        renderState.buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            "data-layout-path": path + "/button/close",
            title: closeTitle,
            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_TRAILING),
            onPointerDown: onClosePointerDown,
            onClick: onClose,
            children: typeof icons.close === "function" ? icons.close(tabNode) : icons.close
        }, "close"));
    }
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        ref: selfRef,
        "data-layout-path": path,
        className: classNames,
        onClick: onClick,
        onAuxClick: onAuxMouseClick,
        onContextMenu: onContextMenu,
        title: tabNode.getHelpText(),
        draggable: true,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        onDoubleClick: onDoubleClick,
        children: [
            leading,
            content,
            renderState.buttons
        ]
    });
};
//#endregion
//#region src/view/TabOverflowHook.tsx
/** @internal */ var $8041f202454d6b76$var$useTabOverflow = (controller, node, orientation, tabStripRef, miniScrollRef, tabClassName)=>{
    const [hiddenTabs, setHiddenTabs] = $lx97N.useState([]);
    const [isShowHiddenTabs, setShowHiddenTabs] = $lx97N.useState(false);
    const [isDockStickyButtons, setDockStickyButtons] = $lx97N.useState(false);
    const selfRef = $lx97N.useRef(null);
    const userControlledPositionRef = $lx97N.useRef(false);
    const updateHiddenTabsTimerRef = $lx97N.useRef(void 0);
    const hiddenTabsRef = $lx97N.useRef([]);
    const thumbInternalPos = $lx97N.useRef(0);
    const repositioningRef = $lx97N.useRef(false);
    $lx97N.useLayoutEffect(()=>{
        hiddenTabsRef.current = hiddenTabs;
    });
    const setScrollPosition = $lx97N.useCallback((p)=>{
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) tabStripRef.current.scrollLeft = p;
        else tabStripRef.current.scrollTop = p;
    }, [
        orientation,
        tabStripRef
    ]);
    const getScrollPosition = $lx97N.useCallback((elm)=>{
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return elm.scrollLeft;
        else return elm.scrollTop;
    }, [
        orientation
    ]);
    const getElementSize = $lx97N.useCallback((elm)=>{
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return elm.clientWidth;
        else return elm.clientHeight;
    }, [
        orientation
    ]);
    const getScrollSize = $lx97N.useCallback((elm)=>{
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return elm.scrollWidth;
        else return elm.scrollHeight;
    }, [
        orientation
    ]);
    const getSize = $lx97N.useCallback((rect)=>{
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return rect.width;
        else return rect.height;
    }, [
        orientation
    ]);
    const getNear = $lx97N.useCallback((rect)=>{
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return rect.x;
        else return rect.y;
    }, [
        orientation
    ]);
    const getFar = $lx97N.useCallback((rect)=>{
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) return rect.right;
        else return rect.bottom;
    }, [
        orientation
    ]);
    const findHiddenTabs = $lx97N.useCallback(()=>{
        const hidden = [];
        if (tabStripRef.current) {
            const strip = tabStripRef.current;
            const stripRect = strip.getBoundingClientRect();
            const visibleNear = getNear(stripRect) - 1;
            const visibleFar = getFar(stripRect) + 1;
            const tabContainer = strip.firstElementChild;
            let i = 0;
            Array.from(tabContainer.children).forEach((child)=>{
                const tabRect = child.getBoundingClientRect();
                if (child.classList.contains(tabClassName)) {
                    if (getNear(tabRect) < visibleNear || getFar(tabRect) > visibleFar) hidden.push(i);
                    i++;
                }
            });
        }
        return hidden;
    }, [
        tabClassName,
        tabStripRef,
        getNear,
        getFar
    ]);
    const updateScrollMetrics = $lx97N.useCallback(()=>{
        if (tabStripRef.current && miniScrollRef.current) {
            const t = tabStripRef.current;
            const s = miniScrollRef.current;
            const size = getElementSize(t);
            const scrollSize = getScrollSize(t);
            const position = getScrollPosition(t);
            if (scrollSize > size && scrollSize > 0) {
                let thumbSize = size * size / scrollSize;
                let adjust = 0;
                if (thumbSize < 20) {
                    adjust = 20 - thumbSize;
                    thumbSize = 20;
                }
                const thumbPos = position * (size - adjust) / scrollSize;
                if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) {
                    s.style.width = thumbSize + "px";
                    s.style.left = thumbPos + "px";
                } else {
                    s.style.height = thumbSize + "px";
                    s.style.top = thumbPos + "px";
                }
                s.style.display = "block";
            } else s.style.display = "none";
            if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) s.style.bottom = "0px";
            else s.style.right = "0px";
        }
    }, [
        orientation,
        tabStripRef,
        miniScrollRef,
        getElementSize,
        getScrollSize,
        getScrollPosition
    ]);
    const updateHiddenTabs = $lx97N.useCallback((isInitial = false)=>{
        const newHiddenTabs = findHiddenTabs();
        const showHidden = newHiddenTabs.length > 0;
        if (showHidden !== isShowHiddenTabs) setShowHiddenTabs(showHidden);
        if (isInitial) setHiddenTabs(newHiddenTabs);
        else if (updateHiddenTabsTimerRef.current === void 0) updateHiddenTabsTimerRef.current = setTimeout(()=>{
            const currentHiddenTabs = findHiddenTabs();
            if (!$8041f202454d6b76$var$arraysEqual(currentHiddenTabs, hiddenTabsRef.current)) setHiddenTabs(currentHiddenTabs);
            updateHiddenTabsTimerRef.current = void 0;
        }, 100);
    }, [
        findHiddenTabs,
        isShowHiddenTabs
    ]);
    const scrollIntoView = $lx97N.useCallback(()=>{
        const selectedTabNode = node.getSelectedNode();
        if (selectedTabNode && tabStripRef.current) {
            const stripRect = controller.getBoundingClientRect(tabStripRef.current);
            const selectedRect = selectedTabNode.getTabRect();
            let shift = getNear(stripRect) - getNear(selectedRect);
            if (shift > 0 || getSize(selectedRect) > getSize(stripRect)) {
                setScrollPosition(getScrollPosition(tabStripRef.current) - shift);
                repositioningRef.current = true;
            } else {
                shift = getFar(selectedRect) - getFar(stripRect);
                if (shift > 0) {
                    setScrollPosition(getScrollPosition(tabStripRef.current) + shift);
                    repositioningRef.current = true;
                }
            }
        }
    }, [
        node,
        controller,
        tabStripRef,
        getNear,
        getFar,
        getSize,
        getScrollPosition,
        setScrollPosition
    ]);
    const checkForOverflow = $lx97N.useCallback(()=>{
        if (tabStripRef.current) {
            const tabContainer = tabStripRef.current.firstElementChild;
            const offset = isDockStickyButtons ? 10 : 0;
            const dock = getElementSize(tabContainer) + offset > getElementSize(tabStripRef.current);
            if (dock !== isDockStickyButtons) setDockStickyButtons(dock);
        }
    }, [
        tabStripRef,
        isDockStickyButtons,
        getElementSize
    ]);
    const onScroll = $lx97N.useCallback(()=>{
        if (!repositioningRef.current) userControlledPositionRef.current = true;
        repositioningRef.current = false;
        updateScrollMetrics();
        updateHiddenTabs();
    }, [
        updateScrollMetrics,
        updateHiddenTabs
    ]);
    const onDragMove = $lx97N.useCallback((x, y)=>{
        if (tabStripRef.current && miniScrollRef.current) {
            const t = tabStripRef.current;
            const s = miniScrollRef.current;
            const size = getElementSize(t);
            const scrollSize = getScrollSize(t);
            const thumbSize = getElementSize(s);
            const r = t.getBoundingClientRect();
            let thumb;
            if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) thumb = x - r.x - thumbInternalPos.current;
            else thumb = y - r.y - thumbInternalPos.current;
            thumb = Math.max(0, Math.min(scrollSize - thumbSize, thumb));
            if (size > 0) setScrollPosition(thumb * scrollSize / size);
        }
    }, [
        tabStripRef,
        miniScrollRef,
        orientation,
        getElementSize,
        getScrollSize,
        setScrollPosition
    ]);
    const onDragEnd = $lx97N.useCallback(()=>{}, []);
    const onDragCancel = $lx97N.useCallback(()=>{}, []);
    const onScrollPointerDown = $lx97N.useCallback((event)=>{
        event.stopPropagation();
        miniScrollRef.current.setPointerCapture(event.pointerId);
        const r = miniScrollRef.current.getBoundingClientRect();
        if (orientation === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) thumbInternalPos.current = event.clientX - r.x;
        else thumbInternalPos.current = event.clientY - r.y;
        $8041f202454d6b76$var$startDrag(event.currentTarget.ownerDocument, event, onDragMove, onDragEnd, onDragCancel);
    }, [
        miniScrollRef,
        orientation,
        onDragMove,
        onDragEnd,
        onDragCancel
    ]);
    const onMouseWheel = $lx97N.useCallback((event)=>{
        if (tabStripRef.current) {
            if (node.getChildren().length === 0) return;
            let delta;
            if (Math.abs(event.deltaY) > 0) {
                delta = -event.deltaY;
                if (event.deltaMode === 1) delta *= 40;
                const newPos = getScrollPosition(tabStripRef.current) - delta;
                const maxScroll = getScrollSize(tabStripRef.current) - getElementSize(tabStripRef.current);
                setScrollPosition(Math.max(0, Math.min(maxScroll, newPos)));
                event.stopPropagation();
            }
        }
    }, [
        node,
        tabStripRef,
        getScrollPosition,
        getScrollSize,
        getElementSize,
        setScrollPosition
    ]);
    const onWheel = $lx97N.useCallback((event)=>{
        event.preventDefault();
    }, []);
    const nodeId = node.getId();
    const selectedNode = node.getSelectedNode();
    const rectWidth = node.getRect().width;
    const rectHeight = node.getRect().height;
    $lx97N.useLayoutEffect(()=>{
        if (tabStripRef.current) setScrollPosition(0);
    }, [
        nodeId,
        tabStripRef,
        setScrollPosition
    ]);
    $lx97N.useLayoutEffect(()=>{
        userControlledPositionRef.current = false;
    }, [
        selectedNode,
        rectWidth,
        rectHeight
    ]);
    $lx97N.useLayoutEffect(()=>{
        checkForOverflow();
        if (userControlledPositionRef.current === false) scrollIntoView();
        updateScrollMetrics();
        updateHiddenTabs(true);
        requestAnimationFrame(()=>{
            updateHiddenTabs();
        });
    }, [
        checkForOverflow,
        scrollIntoView,
        updateScrollMetrics,
        updateHiddenTabs,
        rectWidth,
        rectHeight,
        orientation,
        selectedNode
    ]);
    $lx97N.useEffect(()=>{
        const strip = selfRef.current;
        strip?.addEventListener("wheel", onWheel, {
            passive: false
        });
        return ()=>{
            strip?.removeEventListener("wheel", onWheel);
        };
    }, [
        onWheel
    ]);
    return {
        selfRef: selfRef,
        userControlledPositionRef: userControlledPositionRef,
        onScroll: onScroll,
        onScrollPointerDown: onScrollPointerDown,
        hiddenTabs: hiddenTabs,
        onMouseWheel: onMouseWheel,
        isDockStickyButtons: isDockStickyButtons,
        isShowHiddenTabs: isShowHiddenTabs
    };
};
function $8041f202454d6b76$var$arraysEqual(arr1, arr2) {
    return arr1.length === arr2.length && arr1.every((val, index)=>val === arr2[index]);
}
//#endregion
//#region src/view/TabSet.tsx
/** @internal */ var $8041f202454d6b76$var$TabSet = (props)=>{
    const { tabsetNode: tabsetNode, controller: controller } = props;
    const selfRef = $lx97N.useRef(null);
    const tabStripRef = $lx97N.useRef(null);
    const miniScrollRef = $lx97N.useRef(null);
    const tabStripInnerRef = $lx97N.useRef(null);
    const contentRef = $lx97N.useRef(null);
    const buttonBarRef = $lx97N.useRef(null);
    const overflowbuttonRef = $lx97N.useRef(null);
    const stickyButtonsRef = $lx97N.useRef(null);
    const icons = controller.getIcons();
    const { userControlledPositionRef: userControlledPositionRef, onScroll: onScroll, onScrollPointerDown: onScrollPointerDown, hiddenTabs: hiddenTabs, onMouseWheel: onMouseWheel, isDockStickyButtons: isDockStickyButtons, isShowHiddenTabs: isShowHiddenTabs } = $8041f202454d6b76$var$useTabOverflow(controller, tabsetNode, $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ, tabStripInnerRef, miniScrollRef, controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON));
    $lx97N.useLayoutEffect(()=>{
        if (selfRef.current) tabsetNode.setRect(controller.getBoundingClientRect(selfRef.current));
        if (tabStripRef.current) tabsetNode.setTabStripRect(controller.getBoundingClientRect(tabStripRef.current));
        if (contentRef.current) {
            const newContentRect = controller.getBoundingClientRect(contentRef.current);
            if (!tabsetNode.getContentRect().equalsWhenRounded(newContentRect) && !isNaN(newContentRect.x)) {
                tabsetNode.setContentRect(newContentRect);
                controller.setReLayout(true);
            }
        }
    });
    const onOverflowClick = (event)=>{
        const callback = controller.getShowOverflowMenu();
        const items = hiddenTabs.map((h)=>{
            return {
                index: h,
                node: tabsetNode.getChildren()[h]
            };
        });
        if (callback !== void 0) callback(tabsetNode, event, items, onOverflowItemSelect);
        else {
            const element = overflowbuttonRef.current;
            $8041f202454d6b76$var$showPopup(element, tabsetNode, items, onOverflowItemSelect, controller);
        }
        event.stopPropagation();
    };
    const onOverflowItemSelect = (item)=>{
        controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.selectTab(item.node.getId()));
        userControlledPositionRef.current = false;
    };
    const onDragStart = (event)=>{
        if (!controller.getEditingTab()) {
            if (tabsetNode.isEnableDrag()) {
                event.stopPropagation();
                controller.getDragDropManager().setDragNode(event.nativeEvent, tabsetNode);
            } else event.preventDefault();
        } else event.preventDefault();
    };
    const onPointerDown = (event)=>{
        if (!$8041f202454d6b76$var$isAuxMouseEvent(event)) controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.setActiveTabset(tabsetNode.getId(), controller.getLayoutId()));
    };
    const onAuxMouseClick = (event)=>{
        if ($8041f202454d6b76$var$isAuxMouseEvent(event)) controller.auxMouseClick(tabsetNode, event);
    };
    const onContextMenu = (event)=>{
        controller.showContextMenu(tabsetNode, event);
    };
    const onInterceptPointerDown = (event)=>{
        event.stopPropagation();
    };
    const onMaximizeToggle = (event)=>{
        if (tabsetNode.canMaximize()) controller.maximize(tabsetNode);
        event.stopPropagation();
    };
    const onClose = (event)=>{
        controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.deleteTabset(tabsetNode.getId()));
        event.stopPropagation();
    };
    const onCloseTab = (event)=>{
        controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.deleteTab(tabsetNode.getChildren()[0].getId()));
        event.stopPropagation();
    };
    const onPopoutWindow = (event)=>{
        if (selectedTabNode !== void 0) controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.popoutTab(selectedTabNode.getId(), "window"));
        event.stopPropagation();
    };
    const onPopoutFloat = (event)=>{
        if (selectedTabNode !== void 0) controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.popoutTab(selectedTabNode.getId(), "float"));
        event.stopPropagation();
    };
    const onDoubleClick = (event)=>{
        if (tabsetNode.canMaximize()) controller.maximize(tabsetNode);
    };
    const cm = controller.getClassName;
    const selectedTabNode = tabsetNode.getSelectedNode();
    const path = tabsetNode.getPath();
    const renderTabs = ()=>{
        const tabs = [];
        let lastOneSelected = false;
        if (tabsetNode.isEnableTabStrip()) {
            const isSingleTabStretched = tabsetNode.isEnableSingleTabStretch() && tabsetNode.getChildren().length === 1;
            for(let i = 0; i < tabsetNode.getChildren().length; i++){
                const child = tabsetNode.getChildren()[i];
                const isSelected = tabsetNode.getSelected() === i;
                let cns = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TAB_SPACER);
                if (i !== 0) cns += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TAB_DIVIDER);
                if (!tabsetNode.isEnableTabWrap() && !isSingleTabStretched) {
                    if (isSelected) cns += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TAB_DIVIDER_SELECTED_BEFORE);
                    else if (lastOneSelected) cns += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TAB_DIVIDER_SELECTED_AFTER);
                }
                tabs.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                    className: cns,
                    children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TAB_DIVIDER_INNER)
                    })
                }, "divider" + i));
                tabs.push(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$TabButton, {
                    controller: controller,
                    tabNode: child,
                    path: path + "/tb" + i,
                    selected: isSelected
                }, child.getId()));
                if (i === tabsetNode.getChildren().length - 1) {
                    cns = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TAB_SPACER);
                    if (!tabsetNode.isEnableTabWrap() && !isSingleTabStretched && isSelected) cns += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TAB_DIVIDER_SELECTED_AFTER);
                    tabs.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                        className: cns,
                        children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TAB_DIVIDER_INNER)
                        })
                    }, "divider" + (i + 1)));
                }
                lastOneSelected = isSelected;
            }
        }
        return tabs;
    };
    const renderButtons = (tabs)=>{
        let leading = void 0;
        let stickyButtons = [];
        let buttons = [];
        const renderState = {
            leading: leading,
            stickyButtons: stickyButtons,
            buttons: buttons,
            overflowPosition: void 0
        };
        controller.customizeTabSet(tabsetNode, renderState);
        leading = renderState.leading;
        stickyButtons = renderState.stickyButtons;
        buttons = renderState.buttons;
        const isTabStretch = tabsetNode.isEnableSingleTabStretch() && tabsetNode.getChildren().length === 1;
        let showClose = isTabStretch && tabsetNode.getChildren()[0].isCloseable() || tabsetNode.isCloseable();
        showClose = showClose && tabsetNode.isEnableCloseButton();
        if (renderState.overflowPosition === void 0) renderState.overflowPosition = stickyButtons.length;
        if (stickyButtons.length > 0) {
            if (!tabsetNode.isEnableTabWrap() && (isDockStickyButtons || isTabStretch)) buttons = [
                ...stickyButtons,
                ...buttons
            ];
            else tabs.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: stickyButtonsRef,
                onPointerDown: onInterceptPointerDown,
                onDragStart: (e)=>{
                    e.preventDefault();
                },
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_STICKY_BUTTONS_CONTAINER),
                children: stickyButtons
            }, "sticky_buttons_container"));
        }
        if (!tabsetNode.isEnableTabWrap()) {
            if (isShowHiddenTabs) {
                const overflowTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Overflow_Menu_Tooltip);
                let overflowContent;
                if (typeof icons.more === "function") {
                    const items = hiddenTabs.map((h)=>{
                        return {
                            index: h,
                            node: tabsetNode.getChildren()[h]
                        };
                    });
                    overflowContent = icons.more(tabsetNode, items);
                } else overflowContent = /* @__PURE__ */ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
                    children: [
                        icons.more,
                        /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_OVERFLOW_COUNT),
                            children: hiddenTabs.length > 0 ? hiddenTabs.length : ""
                        })
                    ]
                });
                buttons.splice(Math.min(renderState.overflowPosition, buttons.length), 0, /* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                    "data-layout-path": path + "/button/overflow",
                    ref: overflowbuttonRef,
                    className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_OVERFLOW),
                    title: overflowTitle,
                    onClick: onOverflowClick,
                    onPointerDown: onInterceptPointerDown,
                    children: overflowContent
                }, "overflowbutton"));
            }
        }
        if (selectedTabNode !== void 0) {
            if (selectedTabNode.isEnablePopoutFloatIcon()) {
                const popoutFloatTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Popout_Tab_Float);
                buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                    "data-layout-path": path + "/button/popout-float",
                    title: popoutFloatTitle,
                    className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON_FLOAT),
                    onClick: onPopoutFloat,
                    onPointerDown: onInterceptPointerDown,
                    children: typeof icons.popoutFloat === "function" ? icons.popoutFloat(selectedTabNode) : icons.popoutFloat
                }, "popout-float"));
            }
            if (controller.isSupportsPopout() && selectedTabNode.isAllowedInWindow() && selectedTabNode.isEnablePopoutIcon()) {
                const popoutTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Popout_Tab);
                buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                    "data-layout-path": path + "/button/popout",
                    title: popoutTitle,
                    className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON_FLOAT),
                    onClick: onPopoutWindow,
                    onPointerDown: onInterceptPointerDown,
                    children: typeof icons.popout === "function" ? icons.popout(selectedTabNode) : icons.popout
                }, "popout"));
            }
        }
        if (tabsetNode.canMaximize()) {
            const minTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Restore);
            const maxTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Maximize);
            buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                "data-layout-path": path + "/button/max",
                title: tabsetNode.isMaximized() ? minTitle : maxTitle,
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON_ + (tabsetNode.isMaximized() ? "max" : "min")),
                onClick: onMaximizeToggle,
                onPointerDown: onInterceptPointerDown,
                children: tabsetNode.isMaximized() ? typeof icons.restore === "function" ? icons.restore(tabsetNode) : icons.restore : typeof icons.maximize === "function" ? icons.maximize(tabsetNode) : icons.maximize
            }, "max"));
        }
        if (!tabsetNode.isMaximized() && showClose) {
            const title = isTabStretch ? controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Close_Tab) : controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Close_Tabset);
            buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                "data-layout-path": path + "/button/close",
                title: title,
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_BUTTON_CLOSE),
                onClick: isTabStretch ? onCloseTab : onClose,
                onPointerDown: onInterceptPointerDown,
                children: typeof icons.closeTabset === "function" ? icons.closeTabset(tabsetNode) : icons.closeTabset
            }, "close"));
        }
        if (tabsetNode.isActive() && tabsetNode.isEnableActiveIcon()) {
            const title = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Active_Tabset);
            buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                "data-layout-path": path + "/button/active",
                title: title,
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_ICON),
                children: typeof icons.activeTabset === "function" ? icons.activeTabset(tabsetNode) : icons.activeTabset
            }, "active"));
        }
        const buttonbar = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            ref: buttonBarRef,
            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR),
            onPointerDown: onInterceptPointerDown,
            onDragStart: (e)=>{
                e.preventDefault();
            },
            children: buttons
        }, "buttonbar");
        return {
            leading: leading,
            buttonbar: buttonbar
        };
    };
    const renderTabBar = (tabs, leading, buttonbar)=>{
        let tabStrip;
        let tabStripClasses = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TABBAR_OUTER);
        if (tabsetNode.getClassNameTabStrip() !== void 0) tabStripClasses += " " + tabsetNode.getClassNameTabStrip();
        tabStripClasses += " " + $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TABBAR_OUTER_ + tabsetNode.getTabLocation();
        if (tabsetNode.isActive()) tabStripClasses += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_SELECTED);
        if (tabsetNode.isMaximized()) tabStripClasses += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_MAXIMIZED);
        const isTabStretch = tabsetNode.isEnableSingleTabStretch() && tabsetNode.getChildren().length === 1;
        if (isTabStretch) {
            const tabNode = tabsetNode.getChildren()[0];
            if (tabNode.getTabSetClassName() !== void 0) tabStripClasses += " " + tabNode.getTabSetClassName();
        }
        let leadingContainer = void 0;
        if (leading) leadingContainer = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_LEADING),
            children: leading
        });
        if (tabsetNode.isEnableTabWrap()) {
            if (tabsetNode.isEnableTabStrip()) tabStrip = /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                className: tabStripClasses,
                style: {
                    flexWrap: "wrap",
                    gap: "1px",
                    marginTop: "2px"
                },
                ref: tabStripRef,
                "data-layout-path": path + "/tabstrip",
                onPointerDown: onPointerDown,
                onDoubleClick: onDoubleClick,
                onContextMenu: onContextMenu,
                onClick: onAuxMouseClick,
                onAuxClick: onAuxMouseClick,
                draggable: true,
                onDragStart: onDragStart,
                children: [
                    leadingContainer,
                    tabs,
                    /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                        style: {
                            flexGrow: 1
                        }
                    }),
                    buttonbar
                ]
            });
        } else if (tabsetNode.isEnableTabStrip()) {
            let miniScrollbar = void 0;
            if (tabsetNode.isEnableTabScrollbar()) miniScrollbar = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: miniScrollRef,
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__MINI_SCROLLBAR),
                onPointerDown: onScrollPointerDown
            });
            tabStrip = /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                className: tabStripClasses,
                ref: tabStripRef,
                "data-layout-path": path + "/tabstrip",
                onPointerDown: onPointerDown,
                onDoubleClick: onDoubleClick,
                onContextMenu: onContextMenu,
                onClick: onAuxMouseClick,
                onAuxClick: onAuxMouseClick,
                draggable: true,
                onWheel: onMouseWheel,
                onDragStart: onDragStart,
                children: [
                    leadingContainer,
                    /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__MINI_SCROLLBAR_CONTAINER),
                        children: [
                            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                                ref: tabStripInnerRef,
                                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TABBAR_INNER) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TABBAR_INNER_ + tabsetNode.getTabLocation()),
                                style: {
                                    overflowX: "auto",
                                    overflowY: "hidden"
                                },
                                onScroll: onScroll,
                                children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                                    style: {
                                        width: isTabStretch ? "100%" : "none"
                                    },
                                    className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TABBAR_INNER_TAB_CONTAINER) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_TABBAR_INNER_TAB_CONTAINER_ + tabsetNode.getTabLocation()),
                                    children: tabs
                                })
                            }),
                            miniScrollbar
                        ]
                    }),
                    buttonbar
                ]
            });
        }
        return tabStrip;
    };
    const renderContent = (tabStrip)=>{
        let emptyTabset;
        if (tabsetNode.getChildren().length === 0) {
            const placeHolderCallback = controller.getTabSetPlaceHolderCallback();
            if (placeHolderCallback) emptyTabset = placeHolderCallback(tabsetNode);
        }
        let content = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            ref: contentRef,
            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_CONTENT),
            children: emptyTabset
        });
        if (tabsetNode.getTabLocation() === "top") content = /* @__PURE__ */ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
            children: [
                tabStrip,
                content
            ]
        });
        else content = /* @__PURE__ */ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
            children: [
                content,
                tabStrip
            ]
        });
        return content;
    };
    const tabs = renderTabs();
    const { leading: leading, buttonbar: buttonbar } = renderButtons(tabs);
    const content = renderContent(renderTabBar(tabs, leading, buttonbar));
    const style = {
        flexGrow: Math.max(1, tabsetNode.getWeight() * 1e3),
        minWidth: tabsetNode.getMinWidth(),
        minHeight: tabsetNode.getMinHeight(),
        maxWidth: tabsetNode.getMaxWidth(),
        maxHeight: tabsetNode.getMaxHeight()
    };
    if (tabsetNode.getModel().getMaximizedTabset(controller.getLayoutId()) !== void 0 && !tabsetNode.isMaximized()) style.display = "none";
    const tabset = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        ref: selfRef,
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET_CONTAINER),
        style: style,
        children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TABSET),
            "data-layout-path": path,
            children: content
        })
    });
    if (tabsetNode.isMaximized()) {
        if (controller.getMainElement()) return (0, $1amKe.createPortal)(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            style: {
                position: "absolute",
                display: "flex",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0
            },
            children: tabset
        }), controller.getMainElement());
        else return tabset;
    } else return tabset;
};
//#endregion
//#region src/view/Splitter.tsx
/** @internal */ var $8041f202454d6b76$var$Splitter = (props)=>{
    const { controller: controller, node: node, index: index, horizontal: horizontal } = props;
    const selfRef = $lx97N.useRef(null);
    const extendedRef = $lx97N.useRef(null);
    const pBounds = $lx97N.useRef([]);
    const outlineDiv = $lx97N.useRef(void 0);
    const handleDiv = $lx97N.useRef(void 0);
    const dragStartX = $lx97N.useRef(0);
    const dragStartY = $lx97N.useRef(0);
    const initalSizes = $lx97N.useRef({
        initialSizes: [],
        sum: 0,
        startPosition: 0
    });
    const onTouchStart = $lx97N.useCallback((event)=>{
        event.preventDefault();
        event.stopImmediatePropagation();
    }, []);
    $lx97N.useEffect(()=>{
        const self = selfRef.current;
        const extended = extendedRef.current;
        self?.addEventListener("touchstart", onTouchStart, {
            passive: false
        });
        extended?.addEventListener("touchstart", onTouchStart, {
            passive: false
        });
        return ()=>{
            self?.removeEventListener("touchstart", onTouchStart);
            extended?.removeEventListener("touchstart", onTouchStart);
        };
    }, [
        onTouchStart
    ]);
    const onPointerDown = (event)=>{
        event.stopPropagation();
        if (node instanceof $8041f202454d6b76$export$6af91cd58ec2edf9) initalSizes.current = node.getSplitterInitials(index);
        $8041f202454d6b76$var$enablePointerOnIFrames(false, controller.getCurrentDocument());
        $8041f202454d6b76$var$startDrag(event.currentTarget.ownerDocument, event, onDragMove, onDragEnd, onDragCancel);
        pBounds.current = node.getSplitterBounds(index, true);
        const rootdiv = controller.getRootDiv();
        outlineDiv.current = controller.getCurrentDocument().createElement("div");
        outlineDiv.current.style.flexDirection = horizontal ? "row" : "column";
        outlineDiv.current.className = controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_DRAG) + (node instanceof $8041f202454d6b76$export$317342baaa5be054 ? " " + controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_BORDER) : "");
        outlineDiv.current.style.cursor = node.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.VERT ? "ns-resize" : "ew-resize";
        handleDiv.current = controller.getCurrentDocument().createElement("div");
        handleDiv.current.className = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_HANDLE) + " " + (horizontal ? cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_HANDLE_HORZ) : cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_HANDLE_VERT));
        outlineDiv.current.appendChild(handleDiv.current);
        const r = selfRef.current.getBoundingClientRect();
        const rect = new $8041f202454d6b76$export$c79fc6492f3af13d(r.x - controller.getDomRect().x, r.y - controller.getDomRect().y, r.width, r.height);
        dragStartX.current = event.clientX - r.x;
        dragStartY.current = event.clientY - r.y;
        rect.positionElement(outlineDiv.current);
        if (rootdiv) rootdiv.appendChild(outlineDiv.current);
    };
    const onDragCancel = ()=>{
        const rootdiv = controller.getRootDiv();
        if (rootdiv && outlineDiv.current) rootdiv.removeChild(outlineDiv.current);
        outlineDiv.current = void 0;
    };
    const onDragMove = (x, y)=>{
        if (outlineDiv.current) {
            const clientRect = controller.getDomRect();
            if (!clientRect) return;
            if (node.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.VERT) outlineDiv.current.style.top = getBoundPosition(y - clientRect.y - dragStartY.current) + "px";
            else outlineDiv.current.style.left = getBoundPosition(x - clientRect.x - dragStartX.current) + "px";
            if (controller.isRealtimeResize()) updateLayout(true);
        }
    };
    const onDragEnd = ()=>{
        if (outlineDiv.current) {
            updateLayout(false);
            const rootdiv = controller.getRootDiv();
            if (rootdiv && outlineDiv.current) rootdiv.removeChild(outlineDiv.current);
            outlineDiv.current = void 0;
        }
        $8041f202454d6b76$var$enablePointerOnIFrames(true, controller.getCurrentDocument());
    };
    const updateLayout = (realtime)=>{
        const redraw = ()=>{
            if (outlineDiv.current) {
                let value;
                if (node.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.VERT) value = outlineDiv.current.offsetTop;
                else value = outlineDiv.current.offsetLeft;
                if (node instanceof $8041f202454d6b76$export$317342baaa5be054) {
                    const pos = node.calculateSplit(node, value);
                    controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.adjustBorderSplit(node.getId(), pos));
                } else {
                    const init = initalSizes.current;
                    const weights = node.calculateSplit(index, value, init.initialSizes, init.sum, init.startPosition);
                    controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.adjustWeights(node.getId(), weights));
                }
            }
        };
        redraw();
    };
    const getBoundPosition = (p)=>{
        const bounds = pBounds.current;
        let rtn = p;
        if (p < bounds[0]) rtn = bounds[0];
        if (p > bounds[1]) rtn = bounds[1];
        return rtn;
    };
    const cm = controller.getClassName;
    const style = {
        cursor: horizontal ? "ew-resize" : "ns-resize",
        flexDirection: horizontal ? "column" : "row"
    };
    let className = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_ + node.getOrientation().getName());
    if (node instanceof $8041f202454d6b76$export$317342baaa5be054) className += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_BORDER);
    else if (node.getModel().getMaximizedTabset(controller.getLayoutId()) !== void 0) style.display = "none";
    if (!$8041f202454d6b76$var$isDesktop()) style["--splitter-active-size"] = `30px`;
    return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: className,
        style: style,
        ref: selfRef,
        "data-layout-path": node.getPath() + "/s" + (index - 1),
        onPointerDown: onPointerDown,
        children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_HANDLE) + " " + (horizontal ? cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_HANDLE_HORZ) : cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_HANDLE_VERT))
        })
    });
};
//#endregion
//#region src/view/Row.tsx
/** @internal */ var $8041f202454d6b76$var$Row = (props)=>{
    const { controller: controller, rowNode: rowNode } = props;
    const selfRef = $lx97N.useRef(null);
    const horizontal = rowNode.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ;
    $lx97N.useLayoutEffect(()=>{
        rowNode.setRect(controller.getBoundingClientRect(selfRef.current));
    });
    const items = [];
    let i = 0;
    for (const child of rowNode.getChildren()){
        if (i > 0) items.push(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$Splitter, {
            controller: controller,
            node: rowNode,
            index: i,
            horizontal: horizontal
        }, "splitter" + i));
        if (child instanceof $8041f202454d6b76$export$6af91cd58ec2edf9) items.push(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$Row, {
            controller: controller,
            rowNode: child
        }, child.getId()));
        else if (child instanceof $8041f202454d6b76$export$812bb9af945a59fa) items.push(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$TabSet, {
            controller: controller,
            tabsetNode: child
        }, child.getId()));
        i++;
    }
    const style = {
        flexGrow: Math.max(1, rowNode.getWeight() * 1e3),
        minWidth: rowNode.getMinWidth(),
        minHeight: rowNode.getMinHeight(),
        maxWidth: rowNode.getMaxWidth(),
        maxHeight: rowNode.getMaxHeight()
    };
    if (horizontal) style.flexDirection = "row";
    else style.flexDirection = "column";
    return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        ref: selfRef,
        className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__ROW),
        style: style,
        children: items
    });
};
//#endregion
//#region src/view/Tab.tsx
/** @internal */ var $8041f202454d6b76$var$Tab = (props)=>{
    const { controller: controller, selected: selected, tabNode: tabNode } = props;
    const selfRef = $lx97N.useRef(null);
    const firstSelect = $lx97N.useRef(true);
    const onPointerDown = $lx97N.useCallback(()=>{
        const parent = tabNode.getParent();
        if (parent instanceof $8041f202454d6b76$export$812bb9af945a59fa) {
            if (!parent.isActive()) controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.setActiveTabset(parent.getId(), controller.getLayoutId()));
        }
    }, [
        tabNode,
        controller
    ]);
    const parentNode = tabNode.getParent();
    const rect = parentNode.getContentRect();
    $lx97N.useLayoutEffect(()=>{
        const element = tabNode.getMoveableElement();
        selfRef.current.appendChild(element);
        const handleScroll = ()=>{
            tabNode.saveScrollPosition();
        };
        element.addEventListener("scroll", handleScroll);
        const self = selfRef.current;
        if (self) self.addEventListener("pointerdown", onPointerDown);
        return ()=>{
            if (self) self.removeEventListener("pointerdown", onPointerDown);
            if (controller.getModel().getNodeById(tabNode.getId())) {
                if (!tabNode.isEnableWindowReMount()) controller.getMainController()?.getMoveablesHome()?.appendChild(element);
            }
            element.removeEventListener("scroll", handleScroll);
            tabNode.setVisible(false);
        };
    }, [
        tabNode,
        controller,
        onPointerDown
    ]);
    $lx97N.useEffect(()=>{
        if (tabNode.isSelected()) {
            if (firstSelect.current) {
                tabNode.restoreScrollPosition();
                firstSelect.current = false;
            }
        }
    });
    tabNode.setRect(rect);
    const cm = controller.getClassName;
    const style = {};
    rect.styleWithPosition(style);
    let overlay = null;
    if (selected) {
        tabNode.setVisible(true);
        if (document.hidden && tabNode.isEnablePopoutOverlay()) {
            const overlayStyle = {};
            rect.styleWithPosition(overlayStyle);
            overlay = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                style: overlayStyle,
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_OVERLAY)
            });
        }
    } else {
        style.display = "none";
        tabNode.setVisible(false);
    }
    if (parentNode instanceof $8041f202454d6b76$export$812bb9af945a59fa) {
        if (tabNode.getModel().getMaximizedTabset(controller.getLayoutId()) !== void 0) {
            if (!parentNode.isMaximized()) style.display = "none";
        }
    }
    if (parentNode instanceof $8041f202454d6b76$export$317342baaa5be054) {
        if (!parentNode.isShowing()) style.display = "none";
    }
    let className = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB);
    if (parentNode instanceof $8041f202454d6b76$export$317342baaa5be054) {
        className += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BORDER);
        className += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BORDER_ + parentNode.getLocation().getName());
    }
    if (tabNode.getContentClassName() !== void 0) className += " " + tabNode.getContentClassName();
    return /* @__PURE__ */ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
        children: [
            overlay,
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: selfRef,
                style: style,
                className: className,
                "data-layout-path": tabNode.getPath()
            })
        ]
    });
};
//#endregion
//#region src/view/ErrorBoundary.tsx
/** @internal */ var $8041f202454d6b76$var$ErrorBoundary = class extends $lx97N.Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        console.debug(error);
        console.debug(errorInfo);
    }
    retry = ()=>{
        this.setState({
            hasError: false
        });
    };
    render() {
        if (this.state.hasError) return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            className: $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__ERROR_BOUNDARY_CONTAINER,
            children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                className: $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__ERROR_BOUNDARY_CONTENT,
                children: /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center"
                    },
                    children: [
                        this.props.message,
                        /* @__PURE__ */ (0, $fRwNr.jsx)("p", {
                            children: /* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                                onClick: this.retry,
                                children: this.props.retryText
                            })
                        })
                    ]
                })
            })
        });
        return this.props.children;
    }
};
//#endregion
//#region src/view/TabContentRenderer.tsx
var $8041f202454d6b76$var$TabContentRenderer = $lx97N.memo(({ controller: controller, tabNode: tabNode })=>{
    $8041f202454d6b76$var$TabContentRenderer.displayName = "TabContentRenderer";
    let content;
    if (tabNode.getComponent()) content = controller.getFactory()(tabNode);
    else if (tabNode.getSubLayoutId()) content = /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_LAYOUT_CONTAINER),
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$LayoutInternal, {
                ...controller.getProps(),
                layoutId: tabNode.getSubLayoutId(),
                mainLayoutController: controller.getMainController()
            }),
            ";"
        ]
    });
    return /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$ErrorBoundary, {
        message: controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Error_rendering_component),
        retryText: controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Error_rendering_component_retry),
        children: content
    });
}, $8041f202454d6b76$var$arePropsEqual$1);
function $8041f202454d6b76$var$arePropsEqual$1(prevProps, nextProps) {
    return !(nextProps.visible && (prevProps.windowId !== nextProps.windowId || prevProps.fullRedrawRevision !== nextProps.fullRedrawRevision || prevProps.parentRedrawRevision !== nextProps.parentRedrawRevision || nextProps.tabNode.getSubLayoutId() !== void 0));
}
//#endregion
//#region src/view/layout/DragDropManager.tsx
var $8041f202454d6b76$var$DragDropManager = class DragDropManager {
    static dragState = void 0;
    _controller;
    _dragEnterCount = 0;
    _dragging = false;
    _active = false;
    _dropInfo;
    _outlineDiv;
    _mainController;
    constructor(controller){
        this._controller = controller;
        this._mainController = controller.getMainController();
    }
    addTabWithDragAndDrop(event, json, onDrop) {
        const tempNode = $8041f202454d6b76$export$8dbf7edd89edc19c.fromJson(json, this._controller.getModel(), false);
        DragDropManager.dragState = new $8041f202454d6b76$var$DragState(this._controller.getMainController(), $8041f202454d6b76$var$DragSource.Add, tempNode, json, onDrop);
    }
    moveTabWithDragAndDrop(event, node) {
        this.setDragNode(event, node);
    }
    setDragNode = (event, node)=>{
        DragDropManager.dragState = new $8041f202454d6b76$var$DragState(this._controller.getMainController(), $8041f202454d6b76$var$DragSource.Internal, node, void 0, void 0);
        event.dataTransfer.setData("text/plain", "--flexlayout--");
        event.dataTransfer.effectAllowed = "copyMove";
        event.dataTransfer.dropEffect = "move";
        this._dragEnterCount = 0;
        this._controller.getModel().sortLayouts();
        if (node instanceof $8041f202454d6b76$export$812bb9af945a59fa) {
            let rendered = false;
            let content = this._controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Move_Tabset);
            if (node.getChildren().length > 0) content = this._controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Move_Tabs).replace("?", String(node.getChildren().length));
            if (this._controller.getProps().onRenderDragRect) {
                const dragComponent = this._controller.getProps().onRenderDragRect(content, node, void 0);
                if (dragComponent) {
                    this.setDragComponent(event, dragComponent, 10, 10);
                    rendered = true;
                }
            }
            if (!rendered) this.setDragComponent(event, content, 10, 10);
        } else {
            const element = event.target;
            if (element && typeof element.getBoundingClientRect === "function") {
                const rect = element.getBoundingClientRect();
                const offsetX = event.clientX - rect.left;
                const offsetY = event.clientY - rect.top;
                const parentNode = node?.getParent();
                const isInVerticalBorder = parentNode instanceof $8041f202454d6b76$export$317342baaa5be054 && parentNode.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ;
                const x = isInVerticalBorder ? 10 : offsetX;
                const y = isInVerticalBorder ? 10 : offsetY;
                let rendered = false;
                if (this._controller.getProps().onRenderDragRect) {
                    const content = /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$TabButtonStamp, {
                        controller: this._controller,
                        tabNode: node
                    }, node.getId());
                    const dragComponent = this._controller.getProps().onRenderDragRect(content, node, void 0);
                    if (dragComponent) {
                        this.setDragComponent(event, dragComponent, x, y);
                        rendered = true;
                    }
                }
                if (!rendered) {
                    if ($8041f202454d6b76$var$isSafari()) this.setDragComponent(event, /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$TabButtonStamp, {
                        tabNode: node,
                        controller: this._controller
                    }), x, y);
                    else event.dataTransfer.setDragImage(node.getTabStamp(), x, y);
                }
            }
        }
    };
    setDragComponent(event, component, x, y) {
        const dragElement = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            style: {
                position: "unset"
            },
            className: this._controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT) + " " + this._controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__DRAG_RECT),
            children: component
        });
        const currentDocument = this._controller.getCurrentDocument();
        const tempDiv = currentDocument.createElement("div");
        tempDiv.setAttribute("data-layout-path", "/drag-rectangle");
        tempDiv.style.position = "absolute";
        tempDiv.style.left = "-10000px";
        tempDiv.style.top = "-10000px";
        currentDocument.body.appendChild(tempDiv);
        (0, $jhfT6.createRoot)(tempDiv).render(dragElement);
        event.dataTransfer.setDragImage(tempDiv, x, y);
        setTimeout(()=>{
            currentDocument.body.removeChild(tempDiv);
        }, 0);
    }
    updateActive(event) {
        const layouts = Array.from(this._controller.getModel().getLayouts().values());
        let found = void 0;
        let foundTab = void 0;
        for(let i = layouts.length - 1; i >= 0; i--){
            const layout = layouts[i];
            const dragDropManager = layout.getController()?.getDragDropManager();
            if (dragDropManager) {
                if (dragDropManager.getDragEnterCount() > 0) {
                    if (layout.getType() === "tab") foundTab = layout;
                    else if (!found && !foundTab) found = layout;
                }
            }
        }
        if (foundTab) {
            const parentLayout = $8041f202454d6b76$var$findParentLayout(foundTab);
            if (found === parentLayout || !found) found = foundTab;
        }
        if (found) found.getController().getDragDropManager().setActive(true, event);
        for (const layout of layouts)if (layout !== found) layout.getController()?.getDragDropManager().setActive(false, event);
    }
    setActive(active, event) {
        if (this._active !== active) {
            this._active = active;
            if (this._active) this.onDragEnter(event);
            else this.onDragLeave(event);
        }
    }
    onDragEnterRaw = (event)=>{
        this._dragEnterCount++;
        this.updateActive(event);
    };
    onDragLeaveRaw = (event)=>{
        this._dragEnterCount--;
        this.updateActive(event);
    };
    clearDragMain() {
        this._controller.showOverlayOnAllWindows(false);
        for (const [, layout] of this._controller.getModel().getLayouts())if (layout.getController()) layout.getController().getDragDropManager().clearDragLocal();
    }
    clearDragLocal() {
        this._dragEnterCount = 0;
        this._active = false;
        this.clearDragLocalVisuals();
    }
    clearDragLocalVisuals() {
        this._controller.setState({
            showEdges: false
        });
        this._dragging = false;
        if (this._outlineDiv) {
            this._controller.getRootDiv().removeChild(this._outlineDiv);
            this._outlineDiv = void 0;
        }
    }
    onDragEnter = (event)=>{
        if (!DragDropManager.dragState && this._controller.getProps().onExternalDrag) {
            const externalDrag = this._controller.getProps().onExternalDrag(event);
            if (externalDrag) {
                const tempNode = $8041f202454d6b76$export$8dbf7edd89edc19c.fromJson(externalDrag.json, this._controller.getModel(), false);
                DragDropManager.dragState = new $8041f202454d6b76$var$DragState(this._controller.getMainController(), $8041f202454d6b76$var$DragSource.External, tempNode, externalDrag.json, externalDrag.onDrop);
            }
        }
        if (this._mainController !== DragDropManager.dragState?.mainLayoutController) return;
        if (DragDropManager.dragState) {
            event.preventDefault();
            this._dropInfo = void 0;
            const rootdiv = this._controller.getRootDiv();
            const currentDocument = this._controller.getCurrentDocument();
            this._outlineDiv = currentDocument.createElement("div");
            this._outlineDiv.className = this._controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__OUTLINE_RECT);
            this._outlineDiv.style.visibility = "hidden";
            const speed = this._controller.getTabDragSpeed();
            this._outlineDiv.style.transition = `top ${speed}s, left ${speed}s, width ${speed}s, height ${speed}s`;
            rootdiv.appendChild(this._outlineDiv);
            this._dragging = true;
            this._controller.showOverlayOnAllWindows(true);
            if (this._controller.getModel().getMaximizedTabset(this._controller.getLayoutId()) === void 0) this._controller.setState({
                showEdges: this._controller.getModel().isEnableEdgeDock()
            });
            const clientRect = this._controller.getRootDiv().getBoundingClientRect();
            new $8041f202454d6b76$export$c79fc6492f3af13d(event.clientX - clientRect.left, event.clientY - clientRect.top, 1, 1).positionElement(this._outlineDiv);
        }
    };
    onDragOver = (event)=>{
        if (this._mainController !== DragDropManager.dragState?.mainLayoutController) return;
        if (this._active) {
            const clientRect = this._controller.getRootDiv()?.getBoundingClientRect();
            const pos = {
                x: event.clientX - (clientRect?.left ?? 0),
                y: event.clientY - (clientRect?.top ?? 0)
            };
            this._controller.checkForBorderToShow(pos.x, pos.y);
            const dropInfo = this._controller.getModel().findDropTargetNode(this._controller.getLayoutId(), DragDropManager.dragState.dragNode, pos.x, pos.y);
            if (dropInfo) {
                event.preventDefault();
                this._dropInfo = dropInfo;
                if (this._outlineDiv) {
                    this._outlineDiv.className = this._controller.getClassName(dropInfo.className);
                    dropInfo.rect.positionElement(this._outlineDiv);
                    this._outlineDiv.style.visibility = "visible";
                }
            }
        }
    };
    onDragLeave = (event)=>{
        if (this._mainController !== DragDropManager.dragState?.mainLayoutController) return;
        this.clearDragLocalVisuals();
        if (this._controller.isMainLayout()) {
            let anyDragging = false;
            for (const [, layout] of this._controller.getModel().getLayouts())if (layout.getController()) {
                if (layout.getController().getDragDropManager().isDragging()) {
                    anyDragging = true;
                    break;
                }
            }
            if (anyDragging === false) this.clearDragMain();
        }
    };
    onDrop = (event)=>{
        if (this._mainController !== DragDropManager.dragState?.mainLayoutController) return;
        if (this._active) {
            event.preventDefault();
            const dragState = DragDropManager.dragState;
            if (this._dropInfo) {
                if (dragState.dragJson !== void 0) {
                    const newNode = this._controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.addTab(dragState.dragJson, this._dropInfo.node.getId(), this._dropInfo.location, this._dropInfo.index));
                    if (dragState.fnNewNodeDropped !== void 0) dragState.fnNewNodeDropped(newNode, event);
                } else if (dragState.dragNode !== void 0) this._controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.moveNode(dragState.dragNode.getId(), this._dropInfo.node.getId(), this._dropInfo.location, this._dropInfo.index));
            }
            this.clearDragMain();
            DragDropManager.dragState = void 0;
        }
        this._dragEnterCount = 0;
    };
    getDragEnterCount() {
        return this._dragEnterCount;
    }
    isDragging() {
        return this._dragging;
    }
};
var $8041f202454d6b76$var$DragSource = /* @__PURE__ */ function(DragSource) {
    DragSource["Internal"] = "internal";
    DragSource["External"] = "external";
    DragSource["Add"] = "add";
    return DragSource;
}({});
var $8041f202454d6b76$var$DragState = class {
    mainLayoutController;
    dragSource;
    dragNode;
    dragJson;
    fnNewNodeDropped;
    constructor(mainLayoutController, dragSource, dragNode, dragJson, fnNewNodeDropped){
        this.mainLayoutController = mainLayoutController;
        this.dragSource = dragSource;
        this.dragNode = dragNode;
        this.dragJson = dragJson;
        this.fnNewNodeDropped = fnNewNodeDropped;
    }
};
//#endregion
//#region src/view/layout/EdgeIndicators.tsx
var $8041f202454d6b76$var$EdgeIndicators = ({ controller: controller })=>{
    const edges = [];
    const arrowIcon = controller.getIcons().edgeArrow;
    if (controller.getState().showEdges && controller.getModel().isEnableEdgeDockIndicators()) {
        const r = controller.getModel().getRootRow(controller.getLayoutId()).getRect();
        const length = 100;
        const width = 10;
        const offset = 50;
        const className = controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__EDGE_RECT);
        const radius = 50;
        edges.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            style: {
                top: 0,
                left: r.width / 2 - offset,
                width: length,
                height: width,
                borderBottomLeftRadius: radius,
                borderBottomRightRadius: radius
            },
            className: className + " " + controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__EDGE_RECT_TOP),
            children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                style: {
                    transform: "rotate(180deg)"
                },
                children: arrowIcon
            })
        }, "North"));
        edges.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            style: {
                top: r.height / 2 - offset,
                left: 0,
                width: width,
                height: length,
                borderTopRightRadius: radius,
                borderBottomRightRadius: radius
            },
            className: className + " " + controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__EDGE_RECT_LEFT),
            children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                style: {
                    transform: "rotate(90deg)"
                },
                children: arrowIcon
            })
        }, "West"));
        edges.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            style: {
                top: r.height - width,
                left: r.width / 2 - offset,
                width: length,
                height: width,
                borderTopLeftRadius: radius,
                borderTopRightRadius: radius
            },
            className: className + " " + controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__EDGE_RECT_BOTTOM),
            children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                children: arrowIcon
            })
        }, "South"));
        edges.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            style: {
                top: r.height / 2 - offset,
                left: r.width - width,
                width: width,
                height: length,
                borderTopLeftRadius: radius,
                borderBottomLeftRadius: radius
            },
            className: className + " " + controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__EDGE_RECT_RIGHT),
            children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                style: {
                    transform: "rotate(-90deg)"
                },
                children: arrowIcon
            })
        }, "East"));
    }
    return /* @__PURE__ */ (0, $fRwNr.jsx)((0, $fRwNr.Fragment), {
        children: edges
    });
};
//#endregion
//#region src/view/PopoutWindow.tsx
/** @internal */ var $8041f202454d6b76$var$PopoutWindow = (props)=>{
    const { title: title, controller: controller, layout: layout, url: url, onCloseLayout: onCloseLayout, onSetWindow: onSetLayout, children: children } = props;
    const popoutWindow = $lx97N.useRef(null);
    const [content, setContent] = $lx97N.useState(void 0);
    const styleMap = $lx97N.useMemo(()=>/* @__PURE__ */ new Map(), []);
    const initializedRef = $lx97N.useRef(false);
    $lx97N.useLayoutEffect(()=>{
        if (!initializedRef.current && content) {
            initializedRef.current = true;
            controller.redrawLayout();
        }
    }, [
        content,
        controller
    ]);
    $lx97N.useLayoutEffect(()=>{
        if (!popoutWindow.current) {
            const layoutId = layout.getLayoutId();
            const rect = layout.getRect();
            popoutWindow.current = window.open(url, layoutId, `left=${rect.x},top=${rect.y},width=${rect.width},height=${rect.height}`);
            if (popoutWindow.current) {
                onSetLayout(layout, popoutWindow.current);
                window.addEventListener("beforeunload", ()=>{
                    if (popoutWindow.current) {
                        const closedWindow = popoutWindow.current;
                        popoutWindow.current = null;
                        closedWindow.close();
                    }
                });
                popoutWindow.current.addEventListener("load", ()=>{
                    if (popoutWindow.current) {
                        popoutWindow.current.focus();
                        popoutWindow.current.resizeTo(rect.width, rect.height);
                        popoutWindow.current.moveTo(rect.x, rect.y);
                        const popoutDocument = popoutWindow.current.document;
                        popoutDocument.title = title;
                        const popoutContent = popoutDocument.createElement("div");
                        popoutContent.className = $8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__FLOATING_WINDOW_CONTENT;
                        popoutDocument.body.appendChild(popoutContent);
                        $8041f202454d6b76$var$copyStyles(popoutDocument, styleMap).then(()=>{
                            setContent(popoutContent);
                        });
                        const observer = new MutationObserver((mutationsList)=>$8041f202454d6b76$var$handleStyleMutations(mutationsList, popoutDocument, styleMap));
                        observer.observe(document.head, {
                            childList: true
                        });
                        popoutWindow.current.addEventListener("beforeunload", ()=>{
                            if (popoutWindow.current) {
                                onCloseLayout(layout);
                                popoutWindow.current = null;
                                observer.disconnect();
                            }
                        });
                    }
                });
            } else {
                console.warn(`Unable to open window ${url}`);
                onCloseLayout(layout);
            }
        }
        return ()=>{
            popoutWindow.current?.close();
            popoutWindow.current = null;
        };
    }, [
        controller,
        layout,
        url,
        title,
        onCloseLayout,
        onSetLayout,
        styleMap
    ]);
    if (content !== void 0) return (0, $1amKe.createPortal)(children, content);
    else return null;
};
function $8041f202454d6b76$var$handleStyleMutations(mutationsList, popoutDocument, styleMap) {
    for (const mutation of mutationsList)if (mutation.type === "childList") {
        for (const addition of mutation.addedNodes)if (addition instanceof HTMLLinkElement || addition instanceof HTMLStyleElement) $8041f202454d6b76$var$copyStyle(popoutDocument, addition, styleMap);
        for (const removal of mutation.removedNodes)if (removal instanceof HTMLLinkElement || removal instanceof HTMLStyleElement) {
            const popoutStyle = styleMap.get(removal);
            if (popoutStyle) popoutDocument.head.removeChild(popoutStyle);
        }
    }
}
/** @internal */ function $8041f202454d6b76$var$copyStyles(popoutDoc, styleMap) {
    const promises = [];
    const styleElements = document.querySelectorAll("style, link[rel=\"stylesheet\"]");
    for (const element of styleElements)$8041f202454d6b76$var$copyStyle(popoutDoc, element, styleMap, promises);
    return Promise.all(promises);
}
/** @internal */ function $8041f202454d6b76$var$copyStyle(popoutDoc, element, styleMap, promises) {
    if (element instanceof HTMLLinkElement) {
        const linkElement = element.cloneNode(true);
        popoutDoc.head.appendChild(linkElement);
        styleMap.set(element, linkElement);
        if (promises) promises.push(new Promise((resolve)=>{
            linkElement.onload = ()=>resolve(true);
        }));
    } else if (element instanceof HTMLStyleElement) try {
        const styleElement = element.cloneNode(true);
        popoutDoc.head.appendChild(styleElement);
        styleMap.set(element, styleElement);
    } catch (e) {}
}
//#endregion
//#region src/view/FloatWindow.tsx
var $8041f202454d6b76$var$FloatWindowResizeDirection = /* @__PURE__ */ function(FloatWindowResizeDirection) {
    FloatWindowResizeDirection["North"] = "n";
    FloatWindowResizeDirection["South"] = "s";
    FloatWindowResizeDirection["East"] = "e";
    FloatWindowResizeDirection["West"] = "w";
    FloatWindowResizeDirection["NorthWest"] = "nw";
    FloatWindowResizeDirection["NorthEast"] = "ne";
    FloatWindowResizeDirection["SouthWest"] = "sw";
    FloatWindowResizeDirection["SouthEast"] = "se";
    return FloatWindowResizeDirection;
}($8041f202454d6b76$var$FloatWindowResizeDirection || {});
var $8041f202454d6b76$var$RESIZE_ZINDEX = 10;
var $8041f202454d6b76$var$RESIZE_MARGIN = -4;
var $8041f202454d6b76$var$RESIZE_EDGE_SIZE = 8;
var $8041f202454d6b76$var$RESIZE_CORNER_SIZE = 12;
var $8041f202454d6b76$var$RESIZE_SE_CORNER_SIZE = 12;
var $8041f202454d6b76$var$MIN_WIDTH = 150;
var $8041f202454d6b76$var$MIN_HEIGHT = 25;
/** @internal */ var $8041f202454d6b76$var$FloatWindow = (props)=>{
    const { controller: controller, layout: layout, children: children } = props;
    const [rect, setRect] = $lx97N.useState(layout.getRect());
    const cm = controller.getClassName;
    const selfRef = $lx97N.useRef(null);
    const headerRef = $lx97N.useRef(null);
    const nRef = $lx97N.useRef(null);
    const neRef = $lx97N.useRef(null);
    const eRef = $lx97N.useRef(null);
    const seRef = $lx97N.useRef(null);
    const sRef = $lx97N.useRef(null);
    const swRef = $lx97N.useRef(null);
    const wRef = $lx97N.useRef(null);
    const nwRef = $lx97N.useRef(null);
    const moveToFrontRef = $lx97N.useRef(false);
    const clampToDoc = $lx97N.useCallback((rect)=>{
        const layoutRect = $8041f202454d6b76$export$c79fc6492f3af13d.fromDomRect(controller.getRootDiv().getBoundingClientRect());
        let boundaryRect;
        if (controller.getProps().constrainFloatPanels) boundaryRect = new $8041f202454d6b76$export$c79fc6492f3af13d(0, 0, layoutRect.width, layoutRect.height);
        else {
            const page = $8041f202454d6b76$var$getPageMetrics();
            const width = Math.max(page.fullWidth, window.innerWidth);
            const height = Math.max(page.fullHeight, window.innerHeight);
            boundaryRect = new $8041f202454d6b76$export$c79fc6492f3af13d(-layoutRect.x, -layoutRect.y, width, height);
        }
        const clamped = rect.clone();
        clamped.clamp(boundaryRect);
        return clamped;
    }, [
        controller
    ]);
    const onTouchStart = $lx97N.useCallback((event)=>{
        event.preventDefault();
        event.stopImmediatePropagation();
    }, []);
    $lx97N.useEffect(()=>{
        const elements = [
            headerRef,
            nRef,
            neRef,
            eRef,
            seRef,
            sRef,
            swRef,
            wRef,
            nwRef
        ].map((r)=>r.current).filter((el)=>el !== null);
        elements.forEach((el)=>el.addEventListener("touchstart", onTouchStart, {
                passive: false
            }));
        return ()=>{
            elements.forEach((el)=>el.removeEventListener("touchstart", onTouchStart));
        };
    }, [
        onTouchStart
    ]);
    const initializedRef = $lx97N.useRef(false);
    $lx97N.useLayoutEffect(()=>{
        if (!initializedRef.current) {
            initializedRef.current = true;
            const clamped = clampToDoc(rect);
            if (!clamped.equals(rect)) {
                setRect(clamped);
                layout.setRect(clamped);
            }
        }
    }, [
        clampToDoc,
        rect,
        layout
    ]);
    $lx97N.useEffect(()=>{
        const onPointerDown = ()=>{
            const layouts = [
                ...controller.getModel().getLayouts()
            ];
            if (layout !== layouts[layouts.length - 1][1]) moveToFrontRef.current = true;
        };
        const onPointerUp = ()=>{
            if (moveToFrontRef.current) {
                setTimeout(()=>{
                    controller.moveWindowToFront(layout.getLayoutId());
                }, 10);
                moveToFrontRef.current = false;
            }
        };
        const current = selfRef.current;
        if (current) {
            current.addEventListener("pointerdown", onPointerDown, {
                capture: true
            });
            current.addEventListener("pointerup", onPointerUp);
        }
        return ()=>{
            if (current) {
                current.removeEventListener("pointerdown", onPointerDown, {
                    capture: true
                });
                current.removeEventListener("pointerup", onPointerUp);
            }
        };
    }, [
        controller,
        layout
    ]);
    const onPointerDownHeader = (e)=>{
        e.stopPropagation();
        const offset = {
            x: e.clientX - rect.x,
            y: e.clientY - rect.y
        };
        $8041f202454d6b76$var$startDrag(document, e, (x, y)=>{
            controller.showOverlayOnAllWindows(true);
            if (moveToFrontRef.current) {
                controller.moveWindowToFront(layout.getLayoutId());
                moveToFrontRef.current = false;
            }
            const clamped = clampToDoc(new $8041f202454d6b76$export$c79fc6492f3af13d(x - offset.x, y - offset.y, rect.width, rect.height));
            setRect(clamped);
            layout.setRect(clamped);
        }, ()=>{
            controller.redrawLayout();
            controller.showOverlayOnAllWindows(false);
        }, ()=>{});
    };
    const onPointerDownResize = (e, direction)=>{
        const startRect = rect;
        const startPos = {
            x: e.clientX,
            y: e.clientY
        };
        $8041f202454d6b76$var$startDrag(document, e, (x, y)=>{
            controller.showOverlayOnAllWindows(true);
            const dx = x - startPos.x;
            const dy = y - startPos.y;
            let newX = startRect.x;
            let newY = startRect.y;
            let newW = startRect.width;
            let newH = startRect.height;
            if (direction.includes("n")) {
                newY += dy;
                newH -= dy;
            }
            if (direction.includes("s")) newH += dy;
            if (direction.includes("w")) {
                newX += dx;
                newW -= dx;
            }
            if (direction.includes("e")) newW += dx;
            const clamped = clampToDoc(new $8041f202454d6b76$export$c79fc6492f3af13d(newX, newY, Math.max($8041f202454d6b76$var$MIN_WIDTH, newW), Math.max($8041f202454d6b76$var$MIN_HEIGHT, newH)));
            setRect(clamped);
            layout.setRect(clamped);
        }, ()=>{
            controller.redrawLayout();
            controller.showOverlayOnAllWindows(false);
        }, ()=>{});
        e.stopPropagation();
    };
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        ref: selfRef,
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__FLOAT_WINDOW),
        style: {
            left: rect.x,
            top: rect.y,
            width: rect.width,
            height: rect.height,
            position: "absolute"
        },
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: headerRef,
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__FLOAT_WINDOW_HEADER),
                onPointerDown: onPointerDownHeader,
                children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                    style: {
                        flexGrow: 1,
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                        style: {
                            width: 50,
                            height: 8,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-around",
                            opacity: .5
                        },
                        children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                            style: {
                                height: 2,
                                backgroundColor: "gray",
                                borderRadius: 1
                            }
                        })
                    })
                })
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__FLOAT_WINDOW_CONTENT),
                children: children
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: nRef,
                style: {
                    position: "absolute",
                    zIndex: $8041f202454d6b76$var$RESIZE_ZINDEX,
                    top: $8041f202454d6b76$var$RESIZE_MARGIN,
                    left: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    right: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    height: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    cursor: "ns-resize"
                },
                onPointerDown: (e)=>onPointerDownResize(e, $8041f202454d6b76$var$FloatWindowResizeDirection.North)
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: sRef,
                style: {
                    position: "absolute",
                    zIndex: $8041f202454d6b76$var$RESIZE_ZINDEX,
                    bottom: $8041f202454d6b76$var$RESIZE_MARGIN,
                    left: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    right: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    height: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    cursor: "ns-resize"
                },
                onPointerDown: (e)=>onPointerDownResize(e, $8041f202454d6b76$var$FloatWindowResizeDirection.South)
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: eRef,
                style: {
                    position: "absolute",
                    zIndex: $8041f202454d6b76$var$RESIZE_ZINDEX,
                    top: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    bottom: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    right: $8041f202454d6b76$var$RESIZE_MARGIN,
                    width: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    cursor: "ew-resize"
                },
                onPointerDown: (e)=>onPointerDownResize(e, $8041f202454d6b76$var$FloatWindowResizeDirection.East)
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: wRef,
                style: {
                    position: "absolute",
                    zIndex: $8041f202454d6b76$var$RESIZE_ZINDEX,
                    top: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    bottom: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    left: $8041f202454d6b76$var$RESIZE_MARGIN,
                    width: $8041f202454d6b76$var$RESIZE_EDGE_SIZE,
                    cursor: "ew-resize"
                },
                onPointerDown: (e)=>onPointerDownResize(e, $8041f202454d6b76$var$FloatWindowResizeDirection.West)
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: nwRef,
                style: {
                    position: "absolute",
                    zIndex: $8041f202454d6b76$var$RESIZE_ZINDEX,
                    top: $8041f202454d6b76$var$RESIZE_MARGIN,
                    left: $8041f202454d6b76$var$RESIZE_MARGIN,
                    width: $8041f202454d6b76$var$RESIZE_CORNER_SIZE,
                    height: $8041f202454d6b76$var$RESIZE_CORNER_SIZE,
                    cursor: "nwse-resize"
                },
                onPointerDown: (e)=>onPointerDownResize(e, $8041f202454d6b76$var$FloatWindowResizeDirection.NorthWest)
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: neRef,
                style: {
                    position: "absolute",
                    zIndex: $8041f202454d6b76$var$RESIZE_ZINDEX,
                    top: $8041f202454d6b76$var$RESIZE_MARGIN,
                    right: $8041f202454d6b76$var$RESIZE_MARGIN,
                    width: $8041f202454d6b76$var$RESIZE_CORNER_SIZE,
                    height: $8041f202454d6b76$var$RESIZE_CORNER_SIZE,
                    cursor: "nesw-resize"
                },
                onPointerDown: (e)=>onPointerDownResize(e, $8041f202454d6b76$var$FloatWindowResizeDirection.NorthEast)
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: swRef,
                style: {
                    position: "absolute",
                    zIndex: $8041f202454d6b76$var$RESIZE_ZINDEX,
                    bottom: $8041f202454d6b76$var$RESIZE_MARGIN,
                    left: $8041f202454d6b76$var$RESIZE_MARGIN,
                    width: $8041f202454d6b76$var$RESIZE_CORNER_SIZE,
                    height: $8041f202454d6b76$var$RESIZE_CORNER_SIZE,
                    cursor: "nesw-resize"
                },
                onPointerDown: (e)=>onPointerDownResize(e, $8041f202454d6b76$var$FloatWindowResizeDirection.SouthWest)
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: seRef,
                style: {
                    position: "absolute",
                    zIndex: $8041f202454d6b76$var$RESIZE_ZINDEX,
                    bottom: 0,
                    right: 0,
                    width: $8041f202454d6b76$var$RESIZE_SE_CORNER_SIZE,
                    height: $8041f202454d6b76$var$RESIZE_SE_CORNER_SIZE,
                    cursor: "nwse-resize"
                },
                onPointerDown: (e)=>onPointerDownResize(e, $8041f202454d6b76$var$FloatWindowResizeDirection.SouthEast)
            })
        ]
    });
};
//#endregion
//#region src/view/layout/FloatingWindowContainer.tsx
var $8041f202454d6b76$var$FloatingWindowContainer = ({ controller: controller })=>{
    const floatingLayouts = [];
    const layouts = controller.getModel().getLayouts();
    let windowPopoutId = 0;
    let floatPopoutZIndex = 2e3;
    for (const [layoutId, layout] of layouts)if (!layout.isMainLayout()) {
        if (layout.getType() === "window" && controller.isSupportsPopout()) {
            floatingLayouts.push(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$PopoutWindow, {
                controller: controller,
                layout: layout,
                title: controller.getPopoutWindowName() + " " + windowPopoutId,
                url: controller.getPopoutURL() + "?id=" + layoutId,
                onSetWindow: controller.onSetWindow,
                onCloseLayout: controller.onCloseLayout,
                children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                    className: controller.getProps().popoutClassName,
                    children: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$LayoutInternal, {
                        ...controller.getProps(),
                        layoutId: layoutId,
                        mainLayoutController: controller
                    })
                })
            }, layoutId));
            windowPopoutId++;
        } else if (layout.getType() === "float") {
            floatingLayouts.push(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$FloatWindow, {
                controller: controller,
                layout: layout,
                zIndex: floatPopoutZIndex,
                onCloseLayout: controller.onCloseLayout,
                children: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$LayoutInternal, {
                    ...controller.getProps(),
                    layoutId: layoutId,
                    mainLayoutController: controller
                })
            }, layoutId + "float"));
            floatPopoutZIndex++;
        }
    }
    return /* @__PURE__ */ (0, $fRwNr.jsx)((0, $fRwNr.Fragment), {
        children: floatingLayouts
    });
};
//#endregion
//#region src/view/BorderButton.tsx
/** @internal */ var $8041f202454d6b76$var$BorderButton = (props)=>{
    const { controller: controller, tabNode: tabNode, selected: selected, border: border, icons: icons, path: path } = props;
    const selfRef = $lx97N.useRef(null);
    const contentRef = $lx97N.useRef(null);
    const onDragStart = (event)=>{
        if (tabNode.isEnableDrag()) {
            event.stopPropagation();
            controller.getDragDropManager().setDragNode(event.nativeEvent, tabNode);
        } else event.preventDefault();
    };
    const onDragEnd = (event)=>{
        event.stopPropagation();
        controller.getDragDropManager().clearDragMain();
    };
    const onAuxMouseClick = (event)=>{
        if ($8041f202454d6b76$var$isAuxMouseEvent(event)) controller.auxMouseClick(tabNode, event);
    };
    const onContextMenu = (event)=>{
        controller.showContextMenu(tabNode, event);
    };
    const onClick = ()=>{
        controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.selectTab(tabNode.getId()));
    };
    const onEndEdit = (event)=>{
        if (event.target !== contentRef.current) {
            controller.getCurrentDocument().body.removeEventListener("pointerdown", onEndEdit);
            controller.setEditingTab(void 0);
        }
    };
    const isClosable = ()=>{
        const closeType = tabNode.getCloseType();
        if (selected || closeType === $8041f202454d6b76$export$92f33a959b683412.Always) return true;
        if (closeType === $8041f202454d6b76$export$92f33a959b683412.Visible) {
            if (window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) return true;
        }
        return false;
    };
    const onClose = (event)=>{
        if (isClosable()) {
            controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.deleteTab(tabNode.getId()));
            event.stopPropagation();
        }
    };
    const onClosePointerDown = (event)=>{
        event.stopPropagation();
    };
    $lx97N.useLayoutEffect(()=>{
        tabNode.setTabRect(controller.getBoundingClientRect(selfRef.current));
        if (controller.getEditingTab() === tabNode) contentRef.current.select();
    });
    const onTextBoxPointerDown = (event)=>{
        event.stopPropagation();
    };
    const onTextBoxKeyPress = (event)=>{
        if (event.code === "Escape") controller.setEditingTab(void 0);
        else if (event.code === "Enter" || event.code === "NumpadEnter") {
            controller.setEditingTab(void 0);
            controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.renameTab(tabNode.getId(), event.target.value));
        }
    };
    const cm = controller.getClassName;
    let classNames = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_BUTTON_ + border);
    if (selected) classNames += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_BUTTON__SELECTED);
    else classNames += " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_BUTTON__UNSELECTED);
    if (tabNode.getClassName() !== void 0) classNames += " " + tabNode.getClassName();
    let iconAngle = 0;
    if (tabNode.getModel().isEnableRotateBorderIcons() === false) {
        if (border === "left") iconAngle = 90;
        else if (border === "right") iconAngle = -90;
    }
    const renderState = $8041f202454d6b76$var$getRenderStateEx(controller, tabNode, iconAngle);
    let content = renderState.content ? /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_BUTTON_CONTENT),
        children: renderState.content
    }) : null;
    const leading = renderState.leading ? /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_BUTTON_LEADING),
        children: renderState.leading
    }) : null;
    if (controller.getEditingTab() === tabNode) content = /* @__PURE__ */ (0, $fRwNr.jsx)("input", {
        ref: contentRef,
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_TEXTBOX),
        "data-layout-path": path + "/textbox",
        type: "text",
        autoFocus: true,
        defaultValue: tabNode.getName(),
        onKeyDown: onTextBoxKeyPress,
        onPointerDown: onTextBoxPointerDown
    });
    if (tabNode.isCloseable()) {
        const closeTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Close_Tab);
        renderState.buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            "data-layout-path": path + "/button/close",
            title: closeTitle,
            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_BUTTON_TRAILING),
            onPointerDown: onClosePointerDown,
            onClick: onClose,
            children: typeof icons.close === "function" ? icons.close(tabNode) : icons.close
        }, "close"));
    }
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        ref: selfRef,
        "data-layout-path": path,
        className: classNames,
        onClick: onClick,
        onAuxClick: onAuxMouseClick,
        onContextMenu: onContextMenu,
        title: tabNode.getHelpText(),
        draggable: true,
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        children: [
            leading,
            content,
            renderState.buttons
        ]
    });
};
//#endregion
//#region src/view/BorderTabSet.tsx
/** @internal */ var $8041f202454d6b76$var$BorderTabSet = (props)=>{
    const { borderNode: borderNode, controller: controller, size: size } = props;
    const selfRef = $lx97N.useRef(null);
    const toolbarRef = $lx97N.useRef(null);
    const miniScrollRef = $lx97N.useRef(null);
    const overflowbuttonRef = $lx97N.useRef(null);
    const stickyButtonsRef = $lx97N.useRef(null);
    const tabStripInnerRef = $lx97N.useRef(null);
    const icons = controller.getIcons();
    const { userControlledPositionRef: userControlledPositionRef, onScroll: onScroll, onScrollPointerDown: onScrollPointerDown, hiddenTabs: hiddenTabs, onMouseWheel: onMouseWheel, isDockStickyButtons: isDockStickyButtons, isShowHiddenTabs: isShowHiddenTabs } = $8041f202454d6b76$var$useTabOverflow(controller, borderNode, $8041f202454d6b76$export$df54d73aa0ec5e82.flip(borderNode.getOrientation()), tabStripInnerRef, miniScrollRef, controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_BUTTON));
    $lx97N.useLayoutEffect(()=>{
        if (selfRef.current) borderNode.setTabHeaderRect(controller.getBoundingClientRect(selfRef.current));
    });
    const onAuxMouseClick = (event)=>{
        if ($8041f202454d6b76$var$isAuxMouseEvent(event)) controller.auxMouseClick(borderNode, event);
    };
    const onContextMenu = (event)=>{
        controller.showContextMenu(borderNode, event);
    };
    const onInterceptPointerDown = (event)=>{
        event.stopPropagation();
    };
    const onOverflowClick = (event)=>{
        const callback = controller.getShowOverflowMenu();
        const items = hiddenTabs.map((h)=>{
            return {
                index: h,
                node: borderNode.getChildren()[h]
            };
        });
        if (callback !== void 0) callback(borderNode, event, items, onOverflowItemSelect);
        else {
            const element = overflowbuttonRef.current;
            $8041f202454d6b76$var$showPopup(element, borderNode, items, onOverflowItemSelect, controller);
        }
        event.stopPropagation();
    };
    const onOverflowItemSelect = (item)=>{
        controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.selectTab(item.node.getId()));
        userControlledPositionRef.current = false;
    };
    const onPopoutWindow = (event)=>{
        const selectedTabNode = borderNode.getChildren()[borderNode.getSelected()];
        if (selectedTabNode !== void 0) controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.popoutTab(selectedTabNode.getId(), "window"));
        event.stopPropagation();
    };
    const onPopoutFloat = (event)=>{
        const selectedTabNode = borderNode.getChildren()[borderNode.getSelected()];
        if (selectedTabNode !== void 0) controller.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.popoutTab(selectedTabNode.getId(), "float"));
        event.stopPropagation();
    };
    const cm = controller.getClassName;
    const renderTabs = ()=>{
        const tabButtons = [];
        for(let i = 0; i < borderNode.getChildren().length; i++){
            const isSelected = borderNode.getSelected() === i;
            const child = borderNode.getChildren()[i];
            tabButtons.push(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$BorderButton, {
                controller: controller,
                border: borderNode.getLocation().getName(),
                tabNode: child,
                path: borderNode.getPath() + "/tb" + i,
                selected: isSelected,
                icons: icons
            }, child.getId()));
            if (i < borderNode.getChildren().length - 1) tabButtons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TAB_DIVIDER)
            }, "divider" + i));
        }
        return tabButtons;
    };
    const renderButtons = (tabButtons)=>{
        let leading = void 0;
        let buttons = [];
        let stickyButtons = [];
        const renderState = {
            leading: leading,
            buttons: buttons,
            stickyButtons: stickyButtons,
            overflowPosition: void 0
        };
        controller.customizeTabSet(borderNode, renderState);
        leading = renderState.leading;
        stickyButtons = renderState.stickyButtons;
        buttons = renderState.buttons;
        if (renderState.overflowPosition === void 0) renderState.overflowPosition = stickyButtons.length;
        if (stickyButtons.length > 0) {
            if (isDockStickyButtons) buttons = [
                ...stickyButtons,
                ...buttons
            ];
            else tabButtons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: stickyButtonsRef,
                onPointerDown: onInterceptPointerDown,
                onDragStart: (e)=>{
                    e.preventDefault();
                },
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_TOOLBAR_STICKY_BUTTONS_CONTAINER),
                children: stickyButtons
            }, "sticky_buttons_container"));
        }
        if (isShowHiddenTabs) {
            const overflowTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Overflow_Menu_Tooltip);
            let overflowContent;
            if (typeof icons.more === "function") {
                const items = hiddenTabs.map((h)=>{
                    return {
                        index: h,
                        node: borderNode.getChildren()[h]
                    };
                });
                overflowContent = icons.more(borderNode, items);
            } else overflowContent = /* @__PURE__ */ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
                children: [
                    icons.more,
                    /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_BUTTON_OVERFLOW_COUNT),
                        children: hiddenTabs.length > 0 ? hiddenTabs.length : ""
                    })
                ]
            });
            buttons.splice(Math.min(renderState.overflowPosition, buttons.length), 0, /* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                ref: overflowbuttonRef,
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_OVERFLOW) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_OVERFLOW_ + borderNode.getLocation().getName()),
                title: overflowTitle,
                onClick: onOverflowClick,
                onPointerDown: onInterceptPointerDown,
                children: overflowContent
            }, "overflowbutton"));
        }
        const selectedIndex = borderNode.getSelected();
        if (selectedIndex !== -1) {
            const selectedTabNode = borderNode.getChildren()[selectedIndex];
            if (selectedTabNode !== void 0 && controller.isMainLayout()) {
                if (selectedTabNode.isEnablePopoutFloatIcon()) {
                    const popoutFloatTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Popout_Tab_Float);
                    buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                        title: popoutFloatTitle,
                        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_FLOAT),
                        onClick: onPopoutFloat,
                        onPointerDown: onInterceptPointerDown,
                        children: typeof icons.popoutFloat === "function" ? icons.popoutFloat(selectedTabNode) : icons.popoutFloat
                    }, "popout-float"));
                }
                if (controller.isSupportsPopout() && selectedTabNode.isEnablePopoutIcon() && selectedTabNode.isAllowedInWindow()) {
                    const popoutTitle = controller.i18nName($8041f202454d6b76$export$e9d9efe81c96e81.Popout_Tab);
                    buttons.push(/* @__PURE__ */ (0, $fRwNr.jsx)("button", {
                        title: popoutTitle,
                        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR_BUTTON) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR_BUTTON_FLOAT),
                        onClick: onPopoutWindow,
                        onPointerDown: onInterceptPointerDown,
                        children: typeof icons.popout === "function" ? icons.popout(selectedTabNode) : icons.popout
                    }, "popout"));
                }
            }
        }
        const toolbar = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            ref: toolbarRef,
            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TOOLBAR_ + borderNode.getLocation().getName()),
            children: buttons
        }, "toolbar");
        return {
            leading: leading,
            toolbar: toolbar
        };
    };
    const tabButtons = renderTabs();
    const { leading: leading, toolbar: toolbar } = renderButtons(tabButtons);
    let borderClasses = cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_ + borderNode.getLocation().getName());
    if (borderNode.getClassName() !== void 0) borderClasses += " " + borderNode.getClassName();
    let innerStyle;
    let outerStyle;
    const borderHeight = size - 1;
    if (borderNode.getLocation() === $8041f202454d6b76$export$5bf830809a2e00b2.LEFT) {
        innerStyle = {
            right: "100%",
            top: 0
        };
        outerStyle = {
            width: borderHeight,
            overflowY: "auto"
        };
    } else if (borderNode.getLocation() === $8041f202454d6b76$export$5bf830809a2e00b2.RIGHT) {
        innerStyle = {
            left: "100%",
            top: 0
        };
        outerStyle = {
            width: borderHeight,
            overflowY: "auto"
        };
    } else {
        innerStyle = {
            left: 0
        };
        outerStyle = {
            height: borderHeight,
            overflowX: "auto"
        };
    }
    let miniScrollbar = void 0;
    if (borderNode.isEnableTabScrollbar()) miniScrollbar = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        ref: miniScrollRef,
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__MINI_SCROLLBAR),
        onPointerDown: onScrollPointerDown
    });
    let leadingContainer = void 0;
    if (leading) leadingContainer = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_LEADING),
        children: leading
    });
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        ref: selfRef,
        style: {
            display: "flex",
            flexDirection: borderNode.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.VERT ? "row" : "column"
        },
        className: borderClasses,
        "data-layout-path": borderNode.getPath(),
        onClick: onAuxMouseClick,
        onAuxClick: onAuxMouseClick,
        onContextMenu: onContextMenu,
        onWheel: onMouseWheel,
        children: [
            leadingContainer,
            /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__MINI_SCROLLBAR_CONTAINER),
                children: [
                    /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                        ref: tabStripInnerRef,
                        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_INNER) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_INNER_ + borderNode.getLocation().getName()),
                        style: outerStyle,
                        onScroll: onScroll,
                        children: /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                            style: innerStyle,
                            className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_INNER_TAB_CONTAINER) + " " + cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_INNER_TAB_CONTAINER_ + borderNode.getLocation().getName()),
                            children: tabButtons
                        })
                    }),
                    miniScrollbar
                ]
            }),
            toolbar
        ]
    });
};
//#endregion
//#region src/view/BorderTab.tsx
function $8041f202454d6b76$var$BorderTab(props) {
    const { controller: controller, borderNode: borderNode, show: show } = props;
    const selfRef = $lx97N.useRef(null);
    $lx97N.useLayoutEffect(()=>{
        const contentRect = controller.getBoundingClientRect(selfRef.current);
        if (!isNaN(contentRect.x) && contentRect.width > 0) {
            if (!borderNode.getContentRect().equalsWhenRounded(contentRect)) {
                borderNode.setContentRect(contentRect);
                controller.setReLayout(true);
            }
        }
    });
    let horizontal = true;
    const style = {};
    if (borderNode.getOrientation() === $8041f202454d6b76$export$df54d73aa0ec5e82.HORZ) {
        style.width = borderNode.getSize();
        style.minWidth = borderNode.getMinSize();
        style.maxWidth = borderNode.getMaxSize();
    } else {
        style.height = borderNode.getSize();
        style.minHeight = borderNode.getMinSize();
        style.maxHeight = borderNode.getMaxSize();
        horizontal = false;
    }
    style.display = show ? "flex" : "none";
    const className = controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_TAB_CONTENTS);
    if (borderNode.getLocation() === $8041f202454d6b76$export$5bf830809a2e00b2.LEFT || borderNode.getLocation() === $8041f202454d6b76$export$5bf830809a2e00b2.TOP) return /* @__PURE__ */ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: selfRef,
                style: style,
                className: className
            }),
            show && /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$Splitter, {
                controller: controller,
                node: borderNode,
                index: 0,
                horizontal: horizontal
            })
        ]
    });
    else return /* @__PURE__ */ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
        children: [
            show && /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$Splitter, {
                controller: controller,
                node: borderNode,
                index: 0,
                horizontal: horizontal
            }),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: selfRef,
                style: style,
                className: className
            })
        ]
    });
}
//#endregion
//#region src/view/layout/BorderContainer.tsx
var $8041f202454d6b76$var$BorderContainer = ({ controller: controller, inner: inner })=>{
    const classMain = controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT_MAIN);
    const borders = controller.getModel().getBorderSet().getBorderMap();
    if (controller.isMainLayout() && borders.size > 0) {
        const innerContent = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            className: classMain,
            ref: controller.getMainRef(),
            children: inner
        });
        const borderSetComponents = /* @__PURE__ */ new Map();
        const borderSetContentComponents = /* @__PURE__ */ new Map();
        for (const [_, location] of $8041f202454d6b76$export$5bf830809a2e00b2.values){
            const border = borders.get(location);
            if (border && border.isShowing() && (!border.isAutoHide() || border.isAutoHide() && (border.getChildren().length > 0 || controller.getState().showHiddenBorder === location))) {
                borderSetComponents.set(location, /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$BorderTabSet, {
                    controller: controller,
                    borderNode: border,
                    size: controller.getState().calculatedBorderBarSize
                }));
                borderSetContentComponents.set(location, /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$BorderTab, {
                    controller: controller,
                    borderNode: border,
                    show: border.getSelected() !== -1
                }));
            }
        }
        const classBorderOuter = controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT_BORDER_CONTAINER);
        const classBorderInner = controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT_BORDER_CONTAINER_INNER);
        if (controller.getModel().getBorderSet().getLayoutHorizontal()) {
            const innerWithBorderTabs = /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                className: classBorderInner,
                style: {
                    flexDirection: "column"
                },
                children: [
                    borderSetContentComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.TOP),
                    /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                        className: classBorderInner,
                        style: {
                            flexDirection: "row"
                        },
                        children: [
                            borderSetContentComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.LEFT),
                            innerContent,
                            borderSetContentComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.RIGHT)
                        ]
                    }),
                    borderSetContentComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM)
                ]
            });
            return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                className: classBorderOuter,
                style: {
                    flexDirection: "column"
                },
                children: [
                    borderSetComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.TOP),
                    /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                        className: classBorderInner,
                        style: {
                            flexDirection: "row"
                        },
                        children: [
                            borderSetComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.LEFT),
                            innerWithBorderTabs,
                            borderSetComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.RIGHT)
                        ]
                    }),
                    borderSetComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM)
                ]
            });
        } else {
            const innerWithBorderTabs = /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                className: classBorderInner,
                style: {
                    flexDirection: "row"
                },
                children: [
                    borderSetContentComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.LEFT),
                    /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                        className: classBorderInner,
                        style: {
                            flexDirection: "column"
                        },
                        children: [
                            borderSetContentComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.TOP),
                            innerContent,
                            borderSetContentComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM)
                        ]
                    }),
                    borderSetContentComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.RIGHT)
                ]
            });
            return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                className: classBorderOuter,
                style: {
                    flexDirection: "row"
                },
                children: [
                    borderSetComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.LEFT),
                    /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
                        className: classBorderInner,
                        style: {
                            flexDirection: "column"
                        },
                        children: [
                            borderSetComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.TOP),
                            innerWithBorderTabs,
                            borderSetComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM)
                        ]
                    }),
                    borderSetComponents.get($8041f202454d6b76$export$5bf830809a2e00b2.RIGHT)
                ]
            });
        }
    } else return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        className: classMain,
        ref: controller.getMainRef(),
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            display: "flex"
        },
        children: inner
    });
};
//#endregion
//#region src/view/DragTabButton.tsx
/** @internal */ var $8041f202454d6b76$var$DragTabButton = $lx97N.memo((props)=>{
    $8041f202454d6b76$var$DragTabButton.displayName = "DragTabButton";
    const { controller: controller, tabNode: tabNode } = props;
    const selfRef = $lx97N.useRef(null);
    $lx97N.useEffect(()=>{
        tabNode.setTabStamp(selfRef.current);
    }, [
        tabNode
    ]);
    const cm = controller.getClassName;
    return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        ref: selfRef,
        className: cm($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__DRAG_RECT),
        children: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$TabButtonStamp, {
            controller: controller,
            tabNode: tabNode
        }, tabNode.getId())
    });
}, $8041f202454d6b76$var$arePropsEqual);
function $8041f202454d6b76$var$arePropsEqual(prevProps, nextProps) {
    return nextProps.dragging;
}
//#endregion
//#region src/view/layout/LayoutInternal.tsx
/** @internal */ var $8041f202454d6b76$var$LayoutInternal = $lx97N.forwardRef((props, ref)=>{
    $8041f202454d6b76$var$LayoutInternal.displayName = "LayoutInternal";
    const [state, setStateRaw] = $lx97N.useState({
        rect: $8041f202454d6b76$export$c79fc6492f3af13d.empty(),
        editingTab: void 0,
        showEdges: false,
        showOverlay: false,
        calculatedBorderBarSize: 29,
        calculatedSplitterSize: 8,
        layoutRedrawRevision: 0,
        fullRedrawRevision: 0,
        showHiddenBorder: $8041f202454d6b76$export$5bf830809a2e00b2.CENTER
    });
    const setState = $lx97N.useCallback((update)=>{
        setStateRaw((prev)=>({
                ...prev,
                ...typeof update === "function" ? update(prev, props) : update
            }));
    }, [
        props
    ]);
    const layoutRef = $lx97N.useRef(null);
    const moveablesHomeRef = $lx97N.useRef(null);
    const findBorderBarSizeRef = $lx97N.useRef(null);
    const findSplitterSizeRef = $lx97N.useRef(null);
    const mainRef = $lx97N.useRef(null);
    const controller = $lx97N.useMemo(()=>new $8041f202454d6b76$var$LayoutController(props, state, setState), []);
    controller.setProps(props);
    controller.setStateRaw(state);
    controller.setSetState(setState);
    controller.setLayoutRef(layoutRef);
    controller.setMoveablesHomeRef(moveablesHomeRef);
    controller.setFindBorderBarSizeRef(findBorderBarSizeRef);
    controller.setFindSplitterSizeRef(findSplitterSizeRef);
    controller.setMainRef(mainRef);
    $lx97N.useImperativeHandle(ref, ()=>controller, [
        controller
    ]);
    $lx97N.useLayoutEffect(()=>{
        if (controller.isMainLayout()) controller.updateLayoutMetrics();
        if (controller.isReLayout()) {
            controller.redrawLayout();
            controller.setReLayout(false);
        }
    });
    $lx97N.useEffect(()=>{
        const currentDocument = layoutRef.current.ownerDocument;
        const currentWindow = currentDocument.defaultView;
        controller.setCurrentDocument(currentDocument);
        controller.setCurrentWindow(currentWindow);
        const resizeObserver = new currentWindow.ResizeObserver(()=>{
            currentWindow.requestAnimationFrame(()=>{
                controller.updateRect();
            });
        });
        resizeObserver.observe(layoutRef.current);
        const resizeListener = ()=>{
            controller.updateRect();
        };
        currentWindow.addEventListener("resize", resizeListener);
        const visibilityChange = ()=>{
            for (const [_, modelLayout] of controller.getProps().model.getLayouts())if (modelLayout.getController()) controller.redrawLayout();
        };
        document.addEventListener("visibilitychange", visibilityChange);
        return ()=>{
            resizeObserver.disconnect();
            currentWindow.removeEventListener("resize", resizeListener);
            document.removeEventListener("visibilitychange", visibilityChange);
        };
    }, [
        controller,
        layoutRef.current?.ownerDocument
    ]);
    $lx97N.useEffect(()=>{
        let styleObserver;
        if (!controller.isMainLayout() && controller.getLayout().getType() === "window") {
            const mainRootDiv = controller.getProps().mainLayoutController?.getRootDiv();
            if (mainRootDiv) {
                const sourceElement = mainRootDiv;
                const targetElement = layoutRef.current;
                $8041f202454d6b76$var$copyInlineStyles(sourceElement, targetElement);
                styleObserver = new MutationObserver(()=>{
                    if ($8041f202454d6b76$var$copyInlineStyles(sourceElement, targetElement)) controller.redrawLayout();
                });
                styleObserver.observe(sourceElement, {
                    attributeFilter: [
                        "style"
                    ]
                });
            }
        }
        return ()=>{
            if (styleObserver) styleObserver.disconnect();
        };
    }, [
        controller
    ]);
    $lx97N.useEffect(()=>{
        const currentModel = props.model;
        const layout = currentModel.getLayouts().get(controller.getLayoutId());
        layout.setController(controller);
        layout.setToExportRectFunction((r, type)=>{
            return type === "window" ? controller.getScreenRect(r) : controller.getRelativeRect(r);
        });
        controller.setLayout(layout);
        if (controller.isMainLayout()) {
            currentModel.addChangeListener(controller.onModelChange);
            return ()=>{
                currentModel.removeChangeListener(controller.onModelChange);
            };
        }
    }, [
        props.model,
        controller
    ]);
    const metrics = /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT_METRICS),
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: findBorderBarSizeRef,
                className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__BORDER_SIZER),
                children: "FindBorderBarSize"
            }, "findBorderBarSize"),
            /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
                ref: findSplitterSizeRef,
                className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__SPLITTER_ + "horz")
            }, "findSplitterSize")
        ]
    });
    if (!layoutRef.current) return /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
        ref: layoutRef,
        className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT),
        children: metrics
    });
    const model = props.model;
    const layoutId = controller.getLayoutId();
    model.getRootRow(layoutId).calcMinMaxSize();
    model.getRootRow(layoutId).setPaths("");
    if (controller.isMainLayout()) model.getBorderSet().setPaths();
    const overlay = /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$Overlay, {
        controller: controller,
        show: state.showOverlay
    }, "__overlay__");
    const outer = /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$BorderContainer, {
        controller: controller,
        inner: controller.renderLayout()
    });
    const tabs = controller.renderTabContainers();
    const reorderedTabs = controller.reorderComponents(tabs, controller.getOrderedTabIds());
    let floatingWindows = null;
    let reorderedTabContents = null;
    let dragTabButtons = null;
    let moveablesHome = null;
    if (controller.isMainLayout()) {
        floatingWindows = /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$FloatingWindowContainer, {
            controller: controller
        });
        reorderedTabContents = controller.reorderComponents(controller.renderTabContents(), controller.getOrderedTabMoveableIds());
        dragTabButtons = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT_TAB_STAMPS),
            children: controller.renderDragTabButtons()
        }, "__dragTabButtons__");
        moveablesHome = /* @__PURE__ */ (0, $fRwNr.jsx)("div", {
            ref: moveablesHomeRef,
            className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT_MOVEABLES_HOME)
        }, "__moveables_home__");
    }
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        ref: layoutRef,
        className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__LAYOUT),
        onDragEnter: controller.getDragDropManager().onDragEnterRaw,
        onDragLeave: controller.getDragDropManager().onDragLeaveRaw,
        onDragOver: controller.getDragDropManager().onDragOver,
        onDrop: controller.getDragDropManager().onDrop,
        children: [
            metrics,
            moveablesHome,
            overlay,
            outer,
            reorderedTabs,
            reorderedTabContents,
            state.portal,
            floatingWindows,
            dragTabButtons
        ]
    });
});
/** @internal */ var $8041f202454d6b76$var$LayoutController = class LayoutController {
    static Windows = /* @__PURE__ */ new Map();
    _props;
    _state;
    _setState;
    _layoutRef;
    _moveablesHomeRef;
    _findBorderBarSizeRef;
    _findSplitterSizeRef;
    _mainRef;
    _orderedTabIds;
    _orderedTabMoveableIds;
    _currentDocument;
    _currentWindow;
    _supportsPopout;
    _popoutURL;
    _icons;
    _dragDropManager;
    _layoutId;
    _layout;
    _mainController;
    _popoutWindowName;
    _cachedLayoutDOMRect;
    _reLayout;
    constructor(props, state, setState){
        this._props = props;
        this._state = state;
        this._setState = setState;
        this._orderedTabIds = [];
        this._orderedTabMoveableIds = [];
        this._supportsPopout = props.supportsPopout !== void 0 ? props.supportsPopout : $8041f202454d6b76$var$defaultSupportsPopout;
        this._popoutURL = props.popoutURL ? props.popoutURL : "popout.html";
        this._icons = {
            ...$8041f202454d6b76$var$defaultIcons,
            ...props.icons
        };
        this._layoutId = props.layoutId ? props.layoutId : $8041f202454d6b76$export$a1edc412be3e1841.MAIN_LAYOUT_ID;
        this._mainController = props.mainLayoutController ? props.mainLayoutController : this;
        this._dragDropManager = new $8041f202454d6b76$var$DragDropManager(this);
        this._layout = props.model.getLayouts().get(this._layoutId);
        this._layout.setController(this);
        this._popoutWindowName = props.popoutWindowName || "Popout Window";
        this._reLayout = false;
    }
    renderLayout() {
        this._cachedLayoutDOMRect = void 0;
        return /* @__PURE__ */ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
            children: [
                /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$Row, {
                    controller: this,
                    rowNode: this._props.model.getRootRow(this._layoutId)
                }, "__row__"),
                /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$EdgeIndicators, {
                    controller: this
                })
            ]
        });
    }
    renderTabContainers() {
        const tabs = /* @__PURE__ */ new Map();
        this._props.model.visitLayoutNodes(this._layoutId, (node)=>{
            if (node instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
                const tabNode = node;
                const isSelected = tabNode.isSelected();
                const isRendered = tabNode.isRendered();
                const isEnableRenderOnDemand = tabNode.isEnableRenderOnDemand();
                if (isRendered || isSelected || !isEnableRenderOnDemand) tabs.set(tabNode.getId(), /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$Tab, {
                    controller: this,
                    tabNode: tabNode,
                    selected: isSelected
                }, tabNode.getId()));
            }
        });
        return tabs;
    }
    renderTabContents() {
        const tabContents = /* @__PURE__ */ new Map();
        for (const [layoutId, layout] of this._props.model.getLayouts())this._props.model.visitLayoutNodes(layoutId, (node)=>{
            if (node instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
                const tabNode = node;
                const isSelected = tabNode.isSelected();
                const isRendered = tabNode.isRendered();
                const isEnableRenderOnDemand = tabNode.isEnableRenderOnDemand();
                const rect = tabNode.getParent().getContentRect();
                const visible = isSelected || !isEnableRenderOnDemand;
                if (isRendered || visible && rect.width > 0 && rect.height > 0) {
                    const element = tabNode.getMoveableElement();
                    const windowId = layout.getWindowId() || "";
                    const key = tabNode.getId() + (tabNode.isEnableWindowReMount() ? windowId : "");
                    tabContents.set(tabNode.getId(), (0, $1amKe.createPortal)(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$TabContentRenderer, {
                        controller: this,
                        tabNode: tabNode,
                        rect: rect,
                        windowId: windowId,
                        visible: visible,
                        fullRedrawRevision: this._state.fullRedrawRevision,
                        parentRedrawRevision: this._props.parentRedrawRevision
                    }, key), element, key));
                    tabNode.setRendered(true);
                }
            }
        });
        return tabContents;
    }
    renderDragTabButtons() {
        const dragTabButtons = [];
        this._props.model.visitNodes((node)=>{
            if (node instanceof $8041f202454d6b76$export$8dbf7edd89edc19c) {
                const child = node;
                dragTabButtons.push(/* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$DragTabButton, {
                    controller: this,
                    tabNode: child,
                    dragging: $8041f202454d6b76$var$Utils_dragging
                }, child.getId()));
            }
        });
        return dragTabButtons;
    }
    redrawLayout() {
        this._mainController?.setState((state)=>{
            return {
                layoutRedrawRevision: state.layoutRedrawRevision + 1
            };
        });
    }
    redrawLayoutAndTabContent(isLayoutRevision = true) {
        this._mainController?.setState((state)=>{
            return {
                fullRedrawRevision: state.fullRedrawRevision + 1
            };
        });
    }
    doAction(action) {
        if (this._props.onAction !== void 0) {
            const outcome = this._props.onAction(action);
            if (outcome !== void 0) return this._props.model.doAction(outcome);
            return;
        } else return this._props.model.doAction(action);
    }
    updateRect = ()=>{
        if (this._layoutRef.current) {
            let element = this._layoutRef.current;
            if (!this._layout.isMainLayout() && this._layout.getType() === "float") {
                const floatWindow = element.closest("." + this.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__FLOAT_WINDOW));
                if (floatWindow instanceof HTMLDivElement) element = floatWindow;
            }
            let rect = $8041f202454d6b76$export$c79fc6492f3af13d.fromDomRect(element.getBoundingClientRect());
            if (!this._layout.isMainLayout() && this._layout.getType() === "float") {
                const rootRect = this._mainController.getDomRect();
                rect = rect.relativeTo(rootRect);
            }
            if (!rect.equalsWhenRounded(this._state.rect) && rect.width !== 0 && rect.height !== 0) {
                this.setState({
                    rect: rect
                });
                this._layout.setRect(rect);
                if (!this._layout.isMainLayout()) this.redrawLayout();
            }
        }
    };
    onModelChange = (action)=>{
        if (action.type == $8041f202454d6b76$export$b52183d5cfb26dc9.DELETE_TAB && this._state.showHiddenBorder !== $8041f202454d6b76$export$5bf830809a2e00b2.CENTER) {
            if (this._props.model.getBorderSet().getBorderMap().get(this._state.showHiddenBorder).getChildren().length === 0) this._setState({
                showHiddenBorder: $8041f202454d6b76$export$5bf830809a2e00b2.CENTER
            });
        }
        this.redrawLayout();
        if (this._props.onModelChange) this._props.onModelChange(this._props.model, action);
    };
    reorderComponents(components, ids) {
        const nextIds = ids.filter((id)=>components.has(id));
        const nextIdsSet = new Set(nextIds);
        for (const id of components.keys())if (!nextIdsSet.has(id)) nextIds.push(id);
        ids.splice(0, ids.length, ...nextIds);
        return ids.map((id)=>components.get(id));
    }
    checkForBorderToShow(x, y) {
        const r = this.getBoundingClientRect(this._mainRef.current);
        const c = r.getCenter();
        const margin = 10;
        const offset = 50;
        let overEdge = false;
        if (this._props.model.isEnableEdgeDock() && this._state.showHiddenBorder === $8041f202454d6b76$export$5bf830809a2e00b2.CENTER) {
            if (y > c.y - offset && y < c.y + offset || x > c.x - offset && x < c.x + offset) overEdge = true;
        }
        let location = $8041f202454d6b76$export$5bf830809a2e00b2.CENTER;
        if (!overEdge) {
            if (x <= r.x + margin) location = $8041f202454d6b76$export$5bf830809a2e00b2.LEFT;
            else if (x >= r.getRight() - margin) location = $8041f202454d6b76$export$5bf830809a2e00b2.RIGHT;
            else if (y <= r.y + margin) location = $8041f202454d6b76$export$5bf830809a2e00b2.TOP;
            else if (y >= r.getBottom() - margin) location = $8041f202454d6b76$export$5bf830809a2e00b2.BOTTOM;
        }
        if (location !== this._state.showHiddenBorder) this.setState({
            showHiddenBorder: location
        });
    }
    updateLayoutMetrics = ()=>{
        if (this._findBorderBarSizeRef.current) {
            const borderBarSize = this._findBorderBarSizeRef.current.getBoundingClientRect().height;
            if (Math.abs(borderBarSize - this._state.calculatedBorderBarSize) > .5) this.setState({
                calculatedBorderBarSize: borderBarSize
            });
        }
        if (this._findSplitterSizeRef.current) {
            const splitterBarSize = this._findSplitterSizeRef.current.getBoundingClientRect().width;
            if (Math.abs(splitterBarSize - this._state.calculatedSplitterSize) > .5) {
                this._props.model.setSplitterSize(splitterBarSize);
                this.setState({
                    calculatedSplitterSize: splitterBarSize
                });
            }
        }
    };
    addTabWithDragAndDrop(event, json, onDrop) {
        this._dragDropManager.addTabWithDragAndDrop(event, json, onDrop);
    }
    moveTabWithDragAndDrop(event, node) {
        this._dragDropManager.moveTabWithDragAndDrop(event, node);
    }
    setDragComponent(event, component, x, y) {
        this._dragDropManager.setDragComponent(event, component, x, y);
    }
    getMoveablesHome() {
        return this._moveablesHomeRef.current;
    }
    getProps() {
        return this._props;
    }
    setProps(value) {
        this._props = value;
    }
    getState() {
        return this._state;
    }
    setStateRaw(value) {
        this._state = value;
    }
    setState(update) {
        this._setState(update);
    }
    setSetState(value) {
        this._setState = value;
    }
    getLayoutRef() {
        return this._layoutRef;
    }
    setLayoutRef(value) {
        this._layoutRef = value;
    }
    setMoveablesHomeRef(value) {
        this._moveablesHomeRef = value;
    }
    getFindBorderBarSizeRef() {
        return this._findBorderBarSizeRef;
    }
    setFindBorderBarSizeRef(value) {
        this._findBorderBarSizeRef = value;
    }
    getFindSplitterSizeRef() {
        return this._findBorderBarSizeRef;
    }
    setFindSplitterSizeRef(value) {
        this._findSplitterSizeRef = value;
    }
    getMainRef() {
        return this._mainRef;
    }
    setMainRef(value) {
        this._mainRef = value;
    }
    getOrderedTabIds() {
        return this._orderedTabIds;
    }
    getOrderedTabMoveableIds() {
        return this._orderedTabMoveableIds;
    }
    getCurrentDocument() {
        return this._currentDocument;
    }
    setCurrentDocument(value) {
        this._currentDocument = value;
    }
    getCurrentWindow() {
        return this._currentWindow;
    }
    setCurrentWindow(value) {
        this._currentWindow = value;
        if (value && !LayoutController.Windows.has(value)) LayoutController.Windows.set(value, $8041f202454d6b76$var$randomUUID());
    }
    getWindowId() {
        if (this.getCurrentWindow()) return LayoutController.Windows.get(this.getCurrentWindow());
    }
    isSupportsPopout() {
        return this._supportsPopout;
    }
    getPopoutURL() {
        return this._popoutURL;
    }
    getIcons() {
        return this._icons;
    }
    getDragDropManager() {
        return this._dragDropManager;
    }
    getLayoutId() {
        return this._layoutId;
    }
    getLayout() {
        return this._layout;
    }
    setLayout(value) {
        this._layout = value;
    }
    getMainController() {
        return this._mainController;
    }
    isMainLayout() {
        return this._layout.isMainLayout();
    }
    getPopoutWindowName() {
        return this._popoutWindowName;
    }
    isReLayout() {
        return this._reLayout;
    }
    setReLayout(value) {
        this._reLayout = value;
    }
    getBoundingClientRect(div) {
        const layoutRect = this.getDomRect();
        if (layoutRect) return $8041f202454d6b76$export$c79fc6492f3af13d.getBoundingClientRect(div).relativeTo(layoutRect);
        return $8041f202454d6b76$export$c79fc6492f3af13d.empty();
    }
    getClassName = (defaultClassName)=>{
        if (this._props.classNameMapper === void 0) return defaultClassName;
        else return this._props.classNameMapper(defaultClassName);
    };
    getDomRect() {
        if (this._cachedLayoutDOMRect !== void 0) return this._cachedLayoutDOMRect;
        if (this._layoutRef.current) {
            this._cachedLayoutDOMRect = $8041f202454d6b76$export$c79fc6492f3af13d.fromDomRect(this._layoutRef.current.getBoundingClientRect());
            return this._cachedLayoutDOMRect;
        } else return $8041f202454d6b76$export$c79fc6492f3af13d.empty();
    }
    getRootDiv() {
        return this._layoutRef.current;
    }
    getMainElement() {
        return this._mainRef.current;
    }
    getFactory() {
        return this._props.factory;
    }
    isRealtimeResize() {
        return this._props.realtimeResize ?? false;
    }
    setEditingTab(tabNode) {
        this.setState({
            editingTab: tabNode
        });
    }
    getEditingTab() {
        return this._state.editingTab;
    }
    getModel() {
        return this._props.model;
    }
    getTabDragSpeed() {
        return this._props.tabDragSpeed ? this._props.tabDragSpeed : .3;
    }
    onCloseLayout = (layout)=>{
        this.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.closePopout(layout.getLayoutId()));
    };
    onSetWindow = (layout, window1)=>{};
    getScreenRect(inRect) {
        const rect = inRect.clone();
        const layoutRect = this.getDomRect();
        const navHeight = 60;
        const navWidth = 2;
        rect.x = this._currentWindow.screenX + this._currentWindow.scrollX + navWidth / 2 + layoutRect.x + rect.x;
        rect.y = this._currentWindow.screenY + this._currentWindow.scrollY + (navHeight - navWidth / 2) + layoutRect.y + rect.y;
        rect.height += navHeight;
        rect.width += navWidth;
        return rect;
    }
    getRelativeRect(inRect) {
        const rect = inRect.clone();
        if (!this._layout.isMainLayout()) {
            const layoutRect = this._layout.getRect();
            rect.x += layoutRect.x;
            rect.y += layoutRect.y;
        }
        return rect;
    }
    moveWindowToFront(layoutId) {
        this.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.movePopoutToFront(layoutId));
    }
    addTabToTabSet(tabsetId, json) {
        if (this._props.model.getNodeById(tabsetId) !== void 0) return this.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.addTab(json, tabsetId, $8041f202454d6b76$export$5bf830809a2e00b2.CENTER, -1));
    }
    addTabToActiveTabSet(json) {
        const tabsetNode = this._props.model.getActiveTabset(this._layoutId);
        if (tabsetNode !== void 0) return this.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.addTab(json, tabsetNode.getId(), $8041f202454d6b76$export$5bf830809a2e00b2.CENTER, -1));
    }
    showControlInPortal = (control, element)=>{
        const portal = (0, $1amKe.createPortal)(control, element);
        this.setState({
            portal: portal
        });
    };
    hideControlInPortal = ()=>{
        this.setState({
            portal: void 0
        });
    };
    maximize(tabsetNode) {
        this.doAction($8041f202454d6b76$export$b52183d5cfb26dc9.maximizeToggle(tabsetNode.getId(), this.getLayoutId()));
    }
    customizeTab(tabNode, renderValues) {
        if (this._props.onRenderTab) this._props.onRenderTab(tabNode, renderValues);
    }
    customizeTabSet(tabSetNode, renderValues) {
        if (this._props.onRenderTabSet) this._props.onRenderTabSet(tabSetNode, renderValues);
    }
    i18nName(id, param) {
        let message;
        if (this._props.i18nMapper) message = this._props.i18nMapper(id, param);
        if (message === void 0) message = id + (param === void 0 ? "" : param);
        return message;
    }
    getShowOverflowMenu() {
        return this._props.onShowOverflowMenu;
    }
    getTabSetPlaceHolderCallback() {
        return this._props.onTabSetPlaceHolder;
    }
    showContextMenu(node, event) {
        if (this._props.onContextMenu) this._props.onContextMenu(node, event);
    }
    auxMouseClick(node, event) {
        if (this._props.onAuxMouseClick) this._props.onAuxMouseClick(node, event);
    }
    showOverlay(show) {
        this.setState({
            showOverlay: show
        });
        $8041f202454d6b76$var$enablePointerOnIFrames(!show, this._currentDocument);
    }
    showOverlayOnAllWindows(show) {
        for (const [, layout] of this._props.model.getLayouts())if (layout.getController()) layout.getController().showOverlay(show);
    }
};
var $8041f202454d6b76$var$defaultIcons = {
    close: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$cae179f078f4b4a4, {}),
    closeTabset: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$cae179f078f4b4a4, {}),
    closeFloatPopout: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$cae179f078f4b4a4, {}),
    popout: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$a837275bb5fcc92e, {}),
    popoutFloat: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$5397056b5a472cd2, {}),
    maximize: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$ad8cd11d6f0ad24c, {}),
    restore: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$56d8a8da8edf546a, {}),
    more: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$636a0ccc59ff4b45, {}),
    edgeArrow: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$245c60722c6bebea, {}),
    activeTabset: /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$export$2c138db10ecf1f6b, {})
};
var $8041f202454d6b76$var$defaultSupportsPopout = $8041f202454d6b76$var$isDesktop();
//#endregion
//#region src/view/Layout.tsx
/**
* A React component that hosts a multi-tabbed layout.
* @category Components
* @group Main Layout
*/ var $8041f202454d6b76$export$c84671f46d6a1ca = $lx97N.forwardRef((props, ref)=>{
    const controllerRef = (0, $lx97N.useRef)(null);
    const renderRevision = (0, $lx97N.useRef)(0);
    const lastModel = (0, $lx97N.useRef)(props.model);
    const key = (0, $lx97N.useRef)(0);
    if (lastModel.current !== props.model) {
        key.current++;
        lastModel.current = props.model;
    }
    $8041f202454d6b76$export$c84671f46d6a1ca.displayName = "Layout";
    (0, $lx97N.useImperativeHandle)(ref, ()=>({
            redraw: ()=>{
                controllerRef.current?.redrawLayoutAndTabContent();
            },
            addTabToTabSet: (tabsetId, json)=>{
                return controllerRef.current?.addTabToTabSet(tabsetId, json);
            },
            addTabWithDragAndDrop: (event, json, onDrop)=>{
                controllerRef.current?.addTabWithDragAndDrop(event, json, onDrop);
            },
            moveTabWithDragAndDrop: (event, node)=>{
                controllerRef.current?.moveTabWithDragAndDrop(event, node);
            },
            addTabToActiveTabSet: (json)=>{
                return controllerRef.current?.addTabToActiveTabSet(json);
            },
            setDragComponent: (event, component, x, y)=>{
                controllerRef.current?.setDragComponent(event, component, x, y);
            },
            getRootDiv: ()=>{
                return controllerRef.current.getRootDiv();
            }
        }));
    return /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$LayoutInternal, {
        ref: controllerRef,
        ...props,
        parentRedrawRevision: renderRevision.current++
    }, key.current);
});
var $8041f202454d6b76$export$d32e9d328a43d88b = "0.9.1";
//#endregion
//#region src/view/TabLayout.tsx
/**
* Component that can be used within the factory to render a tabs defined sublayout.
* This allows the sublayout to be surrounded by other controls, e.g. a header and footer bars
* 
* @category Components
* @group Main Layout
*/ var $8041f202454d6b76$export$5346bd046b210444 = (props)=>{
    const { tabNode: tabNode } = props;
    const controller = tabNode.getLayout().getController();
    if (!controller) return;
    return /* @__PURE__ */ (0, $fRwNr.jsxs)("div", {
        className: controller.getClassName($8041f202454d6b76$export$ba41d43e4a419565.FLEXLAYOUT__TAB_LAYOUT_CONTAINER_USER),
        children: [
            /* @__PURE__ */ (0, $fRwNr.jsx)($8041f202454d6b76$var$LayoutInternal, {
                ...controller.getProps(),
                layoutId: tabNode.getSubLayoutId(),
                mainLayoutController: controller.getMainController()
            }),
            ";"
        ]
    });
};




var $lx97N = parcelRequire("lx97N");

var $3bGoE = parcelRequire("3bGoE");

var $37w0r = parcelRequire("37w0r");

var $fRwNr = parcelRequire("fRwNr");
parcelRequire("lx97N");
function $53fb1bf72b92d037$export$2e2bcd8739ae039() {
    $53fb1bf72b92d037$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $53fb1bf72b92d037$export$2e2bcd8739ae039.apply(this, arguments);
}


function $7c6a7c90312158c1$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var $bqPQ9 = parcelRequire("bqPQ9");

var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");
var $3a392a0e60753bcc$var$ThemeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext({});
var $3a392a0e60753bcc$export$b631efc24e9d5e2f = $3a392a0e60753bcc$var$ThemeContext.Consumer, $3a392a0e60753bcc$var$Provider = $3a392a0e60753bcc$var$ThemeContext.Provider;
function $3a392a0e60753bcc$var$ThemeProvider(_ref) {
    var prefixes = _ref.prefixes, children = _ref.children;
    var copiedPrefixes = (0, $lx97N.useMemo)(function() {
        return (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, prefixes);
    }, [
        prefixes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement($3a392a0e60753bcc$var$Provider, {
        value: copiedPrefixes
    }, children);
}
function $3a392a0e60753bcc$export$7f387860ebffb32c(prefix, defaultPrefix) {
    var prefixes = (0, $lx97N.useContext)($3a392a0e60753bcc$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $3a392a0e60753bcc$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    var isClassy = Component.prototype && Component.prototype.isReactComponent; // If it's a functional component make sure we don't break it with a ref
    var _opts = opts, prefix = _opts.prefix, _opts$forwardRefAs = _opts.forwardRefAs, forwardRefAs = _opts$forwardRefAs === void 0 ? isClassy ? 'ref' : 'innerRef' : _opts$forwardRefAs;
    var Wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(_ref2, ref) {
        var props = (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, _ref2);
        props[forwardRefAs] = ref;
        var bsPrefix = $3a392a0e60753bcc$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, props, {
            bsPrefix: bsPrefix
        }));
    });
    Wrapped.displayName = "Bootstrap(" + (Component.displayName || Component.name) + ")";
    return Wrapped;
}
var $3a392a0e60753bcc$export$2e2bcd8739ae039 = $3a392a0e60753bcc$var$ThemeProvider;


var $5352788081a12c66$var$_excluded = [
    "bsPrefix",
    "variant",
    "animation",
    "size",
    "children",
    "as",
    "className"
];
var $5352788081a12c66$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, animation = _ref.animation, size = _ref.size, children = _ref.children, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, className = _ref.className, props = (0, $7c6a7c90312158c1$export$2e2bcd8739ae039)(_ref, $5352788081a12c66$var$_excluded);
    bsPrefix = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    var bsSpinnerPrefix = bsPrefix + "-" + animation;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({
        ref: ref
    }, props, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, bsSpinnerPrefix, size && bsSpinnerPrefix + "-" + size, variant && "text-" + variant)
    }), children);
});
$5352788081a12c66$var$Spinner.displayName = 'Spinner';
var $5352788081a12c66$export$2e2bcd8739ae039 = $5352788081a12c66$var$Spinner;



function $eda52aa0d1dd92cb$export$7c20be4c1d342248({ size: size = 'sm' }) {
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        className: "qep-loading-indicator",
        role: "status",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $5352788081a12c66$export$2e2bcd8739ae039), {
                animation: "grow",
                className: "dot dot-1",
                size: size
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $5352788081a12c66$export$2e2bcd8739ae039), {
                animation: "grow",
                className: "dot dot-2",
                size: size
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $5352788081a12c66$export$2e2bcd8739ae039), {
                animation: "grow",
                className: "dot dot-3",
                size: size
            })
        ]
    });
}



var $gH72i = parcelRequire("gH72i");

var $4Jj9n = parcelRequire("4Jj9n");
class $7d65f0551ed4a9a8$export$409d767525b8b122 {
    static get reportIntervalMs() {
        return 300000;
    }
    get isBypassed() {
        try {
            const isExplicitBypass = $4Jj9n?.env?.BYPASS_SCHEMA_LOGGER === 'true';
            return isExplicitBypass;
        } catch  {
            return false;
        }
    }
    /**
   * Logs a valibot validation failure.
   * Reports immediately on the first occurrence of a specific schema/source combination,
   * then consolidates subsequent errors into periodic summaries.
   */ log(source, schema, result, data, schemaName) {
        if (result.success) return;
        if (this.isBypassed) {
            console.error(`schema validation error: ${source}`, result, data);
            return;
        }
        let sourceSummary = this.statsMap.get(source);
        if (!sourceSummary) {
            sourceSummary = {
                schemasMap: new Map()
            };
            this.statsMap.set(source, sourceSummary);
        }
        let summary = sourceSummary.schemasMap.get(schema);
        if (!summary) {
            // Store schema name if provided or not already set
            if (schemaName && !schema.schemaName) schema.schemaName = schemaName;
            summary = {
                issues: new Map(),
                totalCount: 0,
                firstOccurrenceStack: new Error().stack,
                lastSeen: Date.now()
            };
            sourceSummary.schemasMap.set(schema, summary);
            // Log immediately on first occurrence
            this.reportImmediate(source, schema, result, data);
        }
        summary.totalCount++;
        summary.lastSeen = Date.now();
        for (const issue of result.issues){
            const path = this.normalizePath(issue.path);
            // Key includes path and expected to distinguish different issues on same path
            const key = `${path}::${issue.message}::${issue.expected}`;
            let issueStats = summary.issues.get(key);
            if (!issueStats) {
                issueStats = {
                    path: path,
                    message: issue.message,
                    expected: String(issue.expected),
                    receivedSamples: new Set(),
                    count: 0
                };
                summary.issues.set(key, issueStats);
            }
            issueStats.count++;
            // Limit number of distinct received samples
            if (issueStats.receivedSamples.size < 5) issueStats.receivedSamples.add(this.pruneReceivedValue(issue.received));
        }
        this.scheduleSummary();
    }
    scheduleSummary() {
        if (this.timer) return;
        this.timer = setTimeout(()=>{
            this.reportSummaries();
            this.timer = null;
        }, $7d65f0551ed4a9a8$export$409d767525b8b122.reportIntervalMs);
    }
    reportImmediate(source, schema, result, data) {
        if (result.success) return;
        const schemaName = schema.schemaName || schema.description || 'Anonymous Schema';
        const label = `[SchemaLogger] INITIAL ERROR: ${source} - ${schemaName}`;
        console.groupCollapsed(label);
        console.error(`First seen at ${new Date().toLocaleTimeString()}`);
        console.log('Issues:', result.issues);
        console.dir({
            source: source,
            schema: schema,
            data: data
        });
        console.groupEnd();
    }
    reportSummaries() {
        if (this.statsMap.size === 0) return;
        const time = new Date().toLocaleTimeString();
        console.group(`%c[SchemaLogger] Consolidated Validation Report - ${time}`, 'color: #3498db; font-weight: bold; font-size: 11px;');
        this.statsMap.forEach((sourceSummary, source)=>{
            console.group(`%c${source}`, 'color: #e67e22; font-weight: bold;');
            sourceSummary.schemasMap.forEach((summary, schema)=>{
                const schemaName = schema.schemaName || schema.description || 'Anonymous Schema';
                console.group(`%c${schemaName}: ${summary.totalCount} issues`, 'color: #e74c3c;');
                summary.issues.forEach((issue)=>{
                    const samples = Array.from(issue.receivedSamples);
                    const samplesStr = samples.map((s)=>{
                        if (s === null) return 'null';
                        if (s === undefined) return 'undefined';
                        return typeof s === 'string' ? `'${s}'` : JSON.stringify(s);
                    }).join(', ');
                    console.error(`'${issue.path}': Expected '${issue.expected}', received: [${samplesStr}]: ${issue.count} occurrences`);
                });
                if (summary.firstOccurrenceStack) {
                    console.groupCollapsed('Call Stack (First occurrence)');
                    console.log(summary.firstOccurrenceStack);
                    console.groupEnd();
                }
                console.groupEnd();
            });
            console.groupEnd();
        });
        console.groupEnd();
        this.statsMap.clear();
    }
    normalizePath(path) {
        if (!path || path.length === 0) return 'root';
        return path.map((p)=>{
            const { key: key } = p;
            if (typeof key === 'number' || typeof key === 'string' && /^\d+$/.test(key)) return '[]';
            return key;
        }).filter((p)=>p !== undefined).join('.').replaceAll('.[]', '[]') || 'root';
    }
    pruneReceivedValue(value) {
        if (value === null) return null;
        if (value === undefined) return undefined;
        if (typeof value === 'object') try {
            const str = JSON.stringify(value);
            if (str.length > 200) return str.slice(0, 200) + '...';
            return value;
        } catch  {
            return '[Object]';
        }
        return value;
    }
    constructor(){
        this.statsMap = new Map();
        this.timer = null;
    }
}
const $7d65f0551ed4a9a8$export$19e3b769b03aa80a = new $7d65f0551ed4a9a8$export$409d767525b8b122();


function $9e69feacc2576cdd$export$a7f1346be668a047(schemaInput, callback, source = 'unknown source', schemaName) {
    let schema;
    let finalSchemaName = schemaName;
    if (!schemaName && typeof schemaInput === 'object' && schemaInput !== null && !('type' in schemaInput) && !('kind' in schemaInput) && !('async' in schemaInput)) {
        const keys = Object.keys(schemaInput);
        const [namedSchemaEntry] = Object.entries(schemaInput);
        if (keys.length === 1 && namedSchemaEntry !== undefined) {
            const [namedSchemaKey, namedSchema] = namedSchemaEntry;
            finalSchemaName = namedSchemaKey;
            schema = namedSchema;
        } else schema = schemaInput;
    } else schema = schemaInput;
    return (error, data)=>{
        if (error) {
            callback(error, data);
            return;
        }
        const result = $gH72i.safeParse(schema, data);
        if (!result.success) {
            (0, $7d65f0551ed4a9a8$export$19e3b769b03aa80a).log(source, schema, result, data, finalSchemaName);
            callback(null, data);
            return;
        }
        callback(null, data);
    };
}
function $9e69feacc2576cdd$export$779d4719498a216c(schema, data) {
    return $gH72i.safeParse(schema, data);
}
const $9e69feacc2576cdd$export$4ad606be539b2df7 = $gH72i.custom((value)=>{
    // Literal Date object
    if (typeof value !== 'string') {
        if (value instanceof Date) return true;
        return false;
    }
    const date = new Date(value);
    // YYYY-MM-DD
    if (!isNaN(date.getTime())) {
        const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
        if (match) {
            const [_, year, month, day] = match;
            if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day)) return false;
        }
        return true;
    }
    // YYYYMMDD
    if (/^\d{8}$/.test(value)) {
        const year = Number(value.slice(0, 4));
        const month = Number(value.slice(4, 6));
        const day = Number(value.slice(6, 8));
        const dateObj = new Date(Date.UTC(year, month - 1, day));
        return dateObj.getUTCFullYear() === year && dateObj.getUTCMonth() + 1 === month && dateObj.getUTCDate() === day;
    }
    return false;
}, 'Invalid date string');
const $9e69feacc2576cdd$export$e6bdc9aac0205fd2 = $gH72i.custom((value)=>typeof value === 'string' && /^(\s*\w+\s*)(,\s*\w+\s*)*$|^\s*\w+\s*$/.test(value), 'Must be a comma-separated list or a single string');
const $9e69feacc2576cdd$export$4eb95f2c890de926 = (minVal = 0)=>$gH72i.pipe($gH72i.custom((value)=>typeof Number(value) === 'number' && !isNaN(Number(value)), 'Must be Number or number-parsable string'), $gH72i.transform(Number), $gH72i.minValue(minVal));
const $9e69feacc2576cdd$export$444e1cd7953d6ffa = (maxVal)=>$gH72i.pipe($gH72i.custom((value)=>typeof Number(value) === 'number' && !isNaN(Number(value)), 'Must be Number or number-parsable string'), $gH72i.transform(Number), $gH72i.maxValue(maxVal));
const $9e69feacc2576cdd$export$42f8cfe4e60dbf7d = (schema, jsonString)=>{
    try {
        const parsed = JSON.parse(jsonString);
        const result = $gH72i.safeParse(schema, parsed);
        return result.success;
    } catch  {
        return false;
    }
};
function $9e69feacc2576cdd$export$24b0629f1e123967(result) {
    if (result.success || !result.issues) return '';
    const issuesList = result.issues.map((issue)=>{
        const path = issue.path?.map((pathItem)=>pathItem.key).filter(Boolean).join('.') ?? '';
        return `[${path}]: received '${issue.received}', expected ${issue.expected}`;
    }).join('\n');
    return `\n{\n${issuesList}\n}`;
} /* v8 ignore stop */ 



var $l2Ecb = parcelRequire("l2Ecb");

var $19TnD = parcelRequire("19TnD");

var $evEIS = parcelRequire("evEIS");

var $fRwNr = parcelRequire("fRwNr");
parcelRequire("lx97N");
const $424ebeae788e048c$var$SvgAdd = (props)=>/*#__PURE__*/ (0, $fRwNr.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: 800,
        height: 800,
        viewBox: "0 0 27.963 27.963",
        ...props,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)("path", {
            d: "M13.98 0C6.259 0 0 6.26 0 13.982s6.259 13.981 13.98 13.981c7.725 0 13.983-6.26 13.983-13.981C27.963 6.26 21.705 0 13.98 0m7.122 16.059h-4.939v5.042h-4.299v-5.042H6.862V11.76h5.001v-4.9h4.299v4.9h4.939v4.299z"
        })
    });
var $424ebeae788e048c$export$2e2bcd8739ae039 = $424ebeae788e048c$var$SvgAdd;



var $d9gj3 = parcelRequire("d9gj3");
var $18erv = parcelRequire("18erv");

var $5Wk8r = parcelRequire("5Wk8r");
const $205bb7b61a2ef47c$var$getAppWorker = ()=>(0, $d9gj3.getQepSystem)().container?.applicationClient;
const $205bb7b61a2ef47c$var$initialState = {
    loading: true,
    activeWorkspace: {},
    systemNotifications: []
};
const $205bb7b61a2ef47c$export$8127e61763eee2ff = (0, $5Wk8r.createAsyncThunk)('application/loadAlgoDefinitions', async (_noop, { getState: _getState, dispatch: _dispatch })=>{
    await (0, $18erv.loadAlgos)();
});
const $205bb7b61a2ef47c$export$6ecb652b0e5a904d = (0, $5Wk8r.createAsyncThunk)('application/loadInitialState', async (_noop, { getState: _getState, dispatch: _dispatch })=>{
    const workspace = await $205bb7b61a2ef47c$var$getAppWorker().getActiveWorkspace();
    const workspaceMessage = workspace.message;
    const hasStorageError = workspaceMessage?.error !== undefined;
    const isUnsuccessful = workspaceMessage?.status === 'unsuccessful';
    if (hasStorageError || isUnsuccessful) throw new Error('Workspace storage request failed');
    return {
        workspace: workspaceMessage
    };
});
const $205bb7b61a2ef47c$var$randomString = Math.random().toString(36).slice(7);
const $205bb7b61a2ef47c$export$ebe11ca8cc8aae14 = (0, $5Wk8r.createAsyncThunk)('application/updateworkspacestate', async (workspace, { getState: _getState, dispatch: _dispatch })=>{
    workspace.windowID = $205bb7b61a2ef47c$var$randomString;
    await $205bb7b61a2ef47c$var$getAppWorker().saveworkspace(workspace);
    return {
        workspace: workspace
    };
});
const $205bb7b61a2ef47c$export$fb810b55f96d6b1e = (0, $5Wk8r.createAction)('activate-system-notification');
const $205bb7b61a2ef47c$export$97899410b0343732 = (0, $5Wk8r.createAction)('deactivate-system-notification');
const $205bb7b61a2ef47c$export$8a46c4da6b449425 = (0, $5Wk8r.createAction)('set-system-notifications');
const $205bb7b61a2ef47c$export$dca58f17277bcc93 = (0, $5Wk8r.createSlice)({
    name: 'application',
    initialState: $205bb7b61a2ef47c$var$initialState,
    extraReducers (builder) {
        builder.addCase($205bb7b61a2ef47c$export$6ecb652b0e5a904d.fulfilled, (state, { payload: payload })=>{
            state.activeWorkspace = payload.workspace;
        });
        builder.addCase($205bb7b61a2ef47c$export$fb810b55f96d6b1e, (state, { payload: payload })=>{
            state.systemNotifications = state.systemNotifications.filter((n)=>n.id !== payload.id);
            const notification = {
                ...payload,
                acknowledged: false
            };
            if (payload.level === 'critical') state.systemNotifications.unshift(notification);
            else state.systemNotifications.push(notification);
        });
        builder.addCase($205bb7b61a2ef47c$export$97899410b0343732, (state, { payload: payload })=>{
            state.systemNotifications = state.systemNotifications.filter((n)=>n.id !== payload);
        });
        builder.addCase($205bb7b61a2ef47c$export$8a46c4da6b449425, (state, { payload: payload })=>{
            state.systemNotifications = payload.map((n)=>({
                    ...n,
                    acknowledged: false
                }));
        });
    },
    reducers: {
        updateWorkspaceState (state, action) {
            state.activeWorkspace = action.payload;
        },
        acknowledgeSystemNotification (state, action) {
            const notification = state.systemNotifications.find((n)=>n.id === action.payload);
            if (notification) notification.acknowledged = true;
        }
    }
});
var $205bb7b61a2ef47c$export$2e2bcd8739ae039 = $205bb7b61a2ef47c$export$dca58f17277bcc93.reducer;
const $205bb7b61a2ef47c$export$669ddd1b9a2f2077 = (state)=>state.application.activeWorkspace;
const $205bb7b61a2ef47c$export$51357cc0c92823d1 = (state)=>state.application.systemNotifications;


/**
 * Presents the browser application picker, including bounded loading, retry,
 * filtering, and replacement of the selector tab with the chosen application.
 */ 
var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

function $cd51bb0a6d74d16e$export$a2db1876938cd11d(args) {
    const { value: value, minimumFractionDigits: minimumFractionDigits = 4, maximumFractionDigits: maximumFractionDigits, defaultValue: defaultValue = 0 } = args;
    if (value === undefined || value === null) return defaultValue;
    const numericValue = Number(value);
    if (Number.isFinite(numericValue)) return numericValue.toLocaleString('en-US', {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
    });
    return '';
}


const $9cfde315dda5b569$export$49f5bf502122d4f7 = ()=>globalThis.window.QEP.container;




const $d2a2fde1b0e0a2a8$var$appLoadTimeoutMs = 10000;
const $d2a2fde1b0e0a2a8$var$accentPalette = [
    '#4652c2',
    '#2f9e7e',
    '#c2682f',
    '#8b46c2',
    '#2f8bc2',
    '#c24676',
    '#5fa030',
    '#c2a02f'
];
/** Produces a stable accent color from an application's name. */ function $d2a2fde1b0e0a2a8$var$getAccent(name) {
    let hash = 0;
    for (const character of name){
        const code = character.codePointAt(0) ?? 0;
        hash = (hash * 31 + code) % 2147483647;
    }
    return $d2a2fde1b0e0a2a8$var$accentPalette[hash % $d2a2fde1b0e0a2a8$var$accentPalette.length];
}
/** Produces a compact label for an application's icon. */ function $d2a2fde1b0e0a2a8$var$getInitials(name) {
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    const first = parts[0][0] ?? '';
    const last = parts.at(-1)?.[0] ?? '';
    return (first + last).toUpperCase();
}
function $d2a2fde1b0e0a2a8$export$c01fc56470459c64({ layout: layout, model: model, tabId: tabId }) {
    const [apps, setApps] = (0, $lx97N.useState)([]);
    const [query, setQuery] = (0, $lx97N.useState)('');
    const [loading, setLoading] = (0, $lx97N.useState)(true);
    const [loadError, setLoadError] = (0, $lx97N.useState)(false);
    const searchInput = (0, $lx97N.useRef)(null);
    const retryButton = (0, $lx97N.useRef)(null);
    const activeRequestId = (0, $lx97N.useRef)(0);
    const cancelActiveLoad = (0, $lx97N.useRef)(undefined);
    /**
   * Loads applications within a fixed deadline, ignores stale completions, and
   * restores search focus only when a user-initiated retry succeeds.
   */ const loadApps = (0, $lx97N.useCallback)(async (restoreFocus)=>{
        activeRequestId.current += 1;
        const requestId = activeRequestId.current;
        cancelActiveLoad.current?.();
        setLoading(true);
        setLoadError(false);
        const abortController = new AbortController();
        let rejectOnAbort;
        const deadline = new Promise((_resolve, reject)=>{
            /** Settles the local race whenever timeout, retry, or unmount cancels this load. */ rejectOnAbort = ()=>{
                reject(new Error('Application list request timed out or was cancelled.'));
            };
            abortController.signal.addEventListener('abort', rejectOnAbort, {
                once: true
            });
        });
        /** Aborts the worker request and settles the already-observed local deadline. */ const cancelRequest = ()=>{
            abortController.abort(new Error('Application list request timed out or was cancelled.'));
        };
        const timeoutId = globalThis.setTimeout(cancelRequest, $d2a2fde1b0e0a2a8$var$appLoadTimeoutMs);
        cancelActiveLoad.current = cancelRequest;
        /** Captures synchronous container access failures in a promise that the race can observe. */ const requestApps = async ()=>{
            // The frontend-types submodule has not yet adopted the runtime client's cancellation option.
            const appClient = (0, $9cfde315dda5b569$export$49f5bf502122d4f7)().applicationClient.application;
            return appClient.getApplications(abortController.signal);
        };
        const appRequest = requestApps();
        try {
            const availableApps = await Promise.race([
                appRequest,
                deadline
            ]);
            if (activeRequestId.current !== requestId) return;
            // The legacy frontend-types contract says string, but the runtime client returns this object array.
            setApps(availableApps);
            if (restoreFocus) searchInput.current?.focus();
        } catch  {
            if (activeRequestId.current === requestId) setLoadError(true);
        } finally{
            globalThis.clearTimeout(timeoutId);
            if (rejectOnAbort) abortController.signal.removeEventListener('abort', rejectOnAbort);
            if (cancelActiveLoad.current === cancelRequest) cancelActiveLoad.current = undefined;
            if (activeRequestId.current === requestId) setLoading(false);
        }
    }, []);
    /** Starts the initial load and cancels its worker request when the selector unmounts. */ (0, $lx97N.useEffect)(()=>{
        loadApps(false);
        /** Invalidates the request and settles its deadline before unmounting. */ return ()=>{
            activeRequestId.current += 1;
            cancelActiveLoad.current?.();
            cancelActiveLoad.current = undefined;
        };
    }, [
        loadApps
    ]);
    /** Restores focus to Retry after either the initial load or another retry fails. */ (0, $lx97N.useEffect)(()=>{
        if (loadError && !loading) retryButton.current?.focus();
    }, [
        loadError,
        loading
    ]);
    /** Retries loading applications and restores search focus only after success. */ const handleRetry = (0, $lx97N.useCallback)(()=>{
        loadApps(true);
    }, [
        loadApps
    ]);
    const visibleApps = (0, $lx97N.useMemo)(()=>{
        const normalized = query.trim().toLowerCase();
        return apps.filter((component)=>component.enabled).filter((component)=>!normalized || component.name.toLowerCase().includes(normalized)).sort((a, b)=>a.name.localeCompare(b.name));
    }, [
        apps,
        query
    ]);
    /** Builds a click handler that replaces the selector with an application. */ function onClick(component) {
        return ()=>{
            if (!model.current || !layout.current) return;
            const node = model.current.getNodeById(tabId);
            const tabSetId = node?.getParent()?.getId();
            component.configs.linkerGroups = [
                'group1'
            ];
            if (tabSetId) layout.current.addTabToTabSet(tabSetId, (0, $27e6451b22bf09f3$export$a543b6e2fc959d7c)(component));
            else layout.current.addTabToActiveTabSet((0, $27e6451b22bf09f3$export$a543b6e2fc959d7c)(component));
            model.current.doAction((0, $8041f202454d6b76$export$b52183d5cfb26dc9).deleteTab(tabId));
        };
    }
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        className: "browser-component-selector",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "browser-component-selector-header",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("h1", {
                        className: "browser-component-selector-title",
                        children: "Open application"
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                        className: "browser-component-selector-subtitle",
                        children: "Choose an application to open in this tab."
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "browser-component-selector-search",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsxs)("svg", {
                                className: "browser-component-selector-search-icon",
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("circle", {
                                        cx: "11",
                                        cy: "11",
                                        r: "7"
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("line", {
                                        x1: "21",
                                        y1: "21",
                                        x2: "16.65",
                                        y2: "16.65"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("input", {
                                ref: searchInput,
                                type: "text",
                                className: "browser-component-selector-search-input",
                                placeholder: "Search applications",
                                value: query,
                                onChange: (event)=>{
                                    setQuery(event.target.value);
                                },
                                autoFocus: true
                            })
                        ]
                    })
                ]
            }),
            $d2a2fde1b0e0a2a8$var$renderBody({
                visibleApps: visibleApps,
                totalApps: apps.filter((component)=>component.enabled).length,
                loading: loading,
                loadError: loadError,
                onRetry: handleRetry,
                onClick: onClick,
                retryButton: retryButton
            })
        ]
    });
}
/** Renders loading, failure, empty, or application-list content. */ function $d2a2fde1b0e0a2a8$var$renderBody({ visibleApps: visibleApps, totalApps: totalApps, loading: loading, loadError: loadError, onRetry: onRetry, onClick: onClick, retryButton: retryButton }) {
    if (loading) return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "browser-component-selector-empty",
        role: "status",
        children: "Loading applications\u2026"
    });
    if (loadError) return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        className: "browser-component-selector-empty",
        role: "alert",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                children: "Unable to load applications."
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                ref: retryButton,
                type: "button",
                className: "browser-component-selector-retry",
                onClick: onRetry,
                children: "Retry"
            })
        ]
    });
    if (visibleApps.length === 0) {
        const message = totalApps === 0 ? 'No applications are available.' : 'No applications match your search.';
        return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
            className: "browser-component-selector-empty",
            children: message
        });
    }
    return /*#__PURE__*/ (0, $fRwNr.jsx)("ul", {
        className: "browser-component-selector-list",
        children: visibleApps.map((component)=>/*#__PURE__*/ (0, $fRwNr.jsx)("li", {
                className: "browser-component-selector-list-item",
                children: /*#__PURE__*/ (0, $fRwNr.jsxs)("button", {
                    type: "button",
                    className: "browser-component-selector-card",
                    onClick: onClick(component),
                    title: component.name,
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                            className: "browser-component-selector-icon",
                            style: {
                                backgroundColor: $d2a2fde1b0e0a2a8$var$getAccent(component.name)
                            },
                            "aria-hidden": "true",
                            children: $d2a2fde1b0e0a2a8$var$getInitials(component.name)
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                            className: "browser-component-selector-name",
                            children: component.name
                        })
                    ]
                })
            }, component.id))
    });
}


/** Provides the Browser toolbar, including ordered logout and API-service cleanup. */ 
var $fRwNr = parcelRequire("fRwNr");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $bo0T6 = parcelRequire("bo0T6");

var $8o5tH = parcelRequire("8o5tH");

var $fMSjE = parcelRequire("fMSjE");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $lx97N = parcelRequire("lx97N");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $f7ad26a55d813cb1$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $ffcf97026745e37e$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $lx97N.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $f7ad26a55d813cb1$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


var $1900d14ba699a20c$export$2e2bcd8739ae039 = (0, $ffcf97026745e37e$export$2e2bcd8739ae039);



var $lx97N = parcelRequire("lx97N");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $af5f790c3bb64471$var$useEventCallback(fn) {
    const ref = $lx97N.useRef(fn);
    (0, $dad405edc2b429da$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $lx97N.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $af5f790c3bb64471$export$2e2bcd8739ae039 = $af5f790c3bb64471$var$useEventCallback;


var $b5d1bb90cd0da3bf$export$2e2bcd8739ae039 = (0, $af5f790c3bb64471$export$2e2bcd8739ae039);



var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
'use client';
const $2a8396101347553a$var$UNINITIALIZED = {};
function $2a8396101347553a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $lx97N.useRef($2a8396101347553a$var$UNINITIALIZED);
    if (ref.current === $2a8396101347553a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $lx97N = parcelRequire("lx97N");
'use client';
const $b4c97e982039474b$var$EMPTY = [];
function $b4c97e982039474b$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $lx97N.useEffect(fn, $b4c97e982039474b$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $db0b344921e471bc$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $db0b344921e471bc$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $db0b344921e471bc$export$2e2bcd8739ae039() {
    const timeout = (0, $2a8396101347553a$export$2e2bcd8739ae039)($db0b344921e471bc$export$786b4da70f00938b.create).current;
    (0, $b4c97e982039474b$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $be3fcc796cf02b85$var$hadKeyboardEvent = true;
let $be3fcc796cf02b85$var$hadFocusVisibleRecently = false;
const $be3fcc796cf02b85$var$hadFocusVisibleRecentlyTimeout = new (0, $db0b344921e471bc$export$786b4da70f00938b)();
const $be3fcc796cf02b85$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $be3fcc796cf02b85$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $be3fcc796cf02b85$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $be3fcc796cf02b85$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $be3fcc796cf02b85$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $be3fcc796cf02b85$var$handlePointerDown() {
    $be3fcc796cf02b85$var$hadKeyboardEvent = false;
}
function $be3fcc796cf02b85$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($be3fcc796cf02b85$var$hadFocusVisibleRecently) $be3fcc796cf02b85$var$hadKeyboardEvent = true;
    }
}
function $be3fcc796cf02b85$var$prepare(doc) {
    doc.addEventListener('keydown', $be3fcc796cf02b85$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $be3fcc796cf02b85$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $be3fcc796cf02b85$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $be3fcc796cf02b85$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $be3fcc796cf02b85$var$handleVisibilityChange, true);
}
function $be3fcc796cf02b85$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $be3fcc796cf02b85$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $be3fcc796cf02b85$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $be3fcc796cf02b85$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $be3fcc796cf02b85$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $be3fcc796cf02b85$var$handleVisibilityChange, true);
}
function $be3fcc796cf02b85$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $be3fcc796cf02b85$var$hadKeyboardEvent || $be3fcc796cf02b85$var$focusTriggersKeyboardModality(target);
}
function $be3fcc796cf02b85$export$2e2bcd8739ae039() {
    const ref = $lx97N.useCallback((node)=>{
        if (node != null) $be3fcc796cf02b85$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $lx97N.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $be3fcc796cf02b85$var$hadFocusVisibleRecently = true;
            $be3fcc796cf02b85$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $be3fcc796cf02b85$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($be3fcc796cf02b85$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


var $5fbe03e0221974b0$export$2e2bcd8739ae039 = (0, $be3fcc796cf02b85$export$2e2bcd8739ae039);



var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");



var $fmTP4 = parcelRequire("fmTP4");

var $9Hxe6 = parcelRequire("9Hxe6");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $fRwNr = parcelRequire("fRwNr");
function $21f73b8bd985acc0$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $lx97N.useState(false);
    const rippleClassName = (0, $fmTP4.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $fmTP4.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $lx97N.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
            className: childClassName
        })
    });
}
var $21f73b8bd985acc0$export$2e2bcd8739ae039 = $21f73b8bd985acc0$var$Ripple;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $9f12e93717a899a0$export$b464606f735ab902(slot) {
    return (0, $h6nFM.default)('MuiTouchRipple', slot);
}
const $9f12e93717a899a0$var$touchRippleClasses = (0, $3OBXm.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $9f12e93717a899a0$export$2e2bcd8739ae039 = $9f12e93717a899a0$var$touchRippleClasses;



var $fRwNr = parcelRequire("fRwNr");
const $92a91faef5131fd5$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $92a91faef5131fd5$var$_ = (t)=>t, $92a91faef5131fd5$var$_t, $92a91faef5131fd5$var$_t2, $92a91faef5131fd5$var$_t3, $92a91faef5131fd5$var$_t4;
const $92a91faef5131fd5$var$DURATION = 550;
const $92a91faef5131fd5$export$95d0c9356b2231a3 = 80;
const $92a91faef5131fd5$var$enterKeyframe = (0, $9Hxe6.keyframes)($92a91faef5131fd5$var$_t || ($92a91faef5131fd5$var$_t = $92a91faef5131fd5$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $92a91faef5131fd5$var$exitKeyframe = (0, $9Hxe6.keyframes)($92a91faef5131fd5$var$_t2 || ($92a91faef5131fd5$var$_t2 = $92a91faef5131fd5$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $92a91faef5131fd5$var$pulsateKeyframe = (0, $9Hxe6.keyframes)($92a91faef5131fd5$var$_t3 || ($92a91faef5131fd5$var$_t3 = $92a91faef5131fd5$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $92a91faef5131fd5$export$f6b7418508c72c25 = (0, $7Ys8f.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $92a91faef5131fd5$export$676cfe7b12693c4b = (0, $7Ys8f.default)((0, $21f73b8bd985acc0$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($92a91faef5131fd5$var$_t4 || ($92a91faef5131fd5$var$_t4 = $92a91faef5131fd5$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $9f12e93717a899a0$export$2e2bcd8739ae039).rippleVisible, $92a91faef5131fd5$var$enterKeyframe, $92a91faef5131fd5$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).child, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).childLeaving, $92a91faef5131fd5$var$exitKeyframe, $92a91faef5131fd5$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).childPulsate, $92a91faef5131fd5$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $92a91faef5131fd5$var$TouchRipple = /*#__PURE__*/ $lx97N.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $hphT8.default)(props, $92a91faef5131fd5$var$_excluded);
    const [ripples, setRipples] = $lx97N.useState([]);
    const nextKey = $lx97N.useRef(0);
    const rippleCallback = $lx97N.useRef(null);
    $lx97N.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $lx97N.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = $lx97N.useRef(null);
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $lx97N.useRef(null);
    const container = $lx97N.useRef(null);
    $lx97N.useEffect(()=>{
        return ()=>{
            clearTimeout(startTimer.current);
        };
    }, []);
    const startCommit = $lx97N.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $fRwNr.jsx)($92a91faef5131fd5$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $fmTP4.default)(classes.ripple, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $fmTP4.default)(classes.rippleVisible, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $fmTP4.default)(classes.ripplePulsate, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $fmTP4.default)(classes.child, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $fmTP4.default)(classes.childLeaving, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $fmTP4.default)(classes.childPulsate, (0, $9f12e93717a899a0$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $92a91faef5131fd5$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $lx97N.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                startTimer.current = setTimeout(()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                }, $92a91faef5131fd5$export$95d0c9356b2231a3); // We have to make a tradeoff with this value.
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit
    ]);
    const pulsate = $lx97N.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $lx97N.useCallback((event, cb)=>{
        clearTimeout(startTimer.current);
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.current = setTimeout(()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, []);
    $lx97N.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($92a91faef5131fd5$export$f6b7418508c72c25, (0, $eR4tV.default)({
        className: (0, $fmTP4.default)((0, $9f12e93717a899a0$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $b187fb0b2f4345b8$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $92a91faef5131fd5$export$2e2bcd8739ae039 = $92a91faef5131fd5$var$TouchRipple;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $75bf9d2683c9f105$export$fccb0498dcd99783(slot) {
    return (0, $h6nFM.default)('MuiButtonBase', slot);
}
const $75bf9d2683c9f105$var$buttonBaseClasses = (0, $3OBXm.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $75bf9d2683c9f105$export$2e2bcd8739ae039 = $75bf9d2683c9f105$var$buttonBaseClasses;



var $fRwNr = parcelRequire("fRwNr");
const $efd008e102aecb23$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $efd008e102aecb23$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $8o5tH.default)(slots, (0, $75bf9d2683c9f105$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $efd008e102aecb23$export$7ec0dcc5e3cdcd36 = (0, $7Ys8f.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $75bf9d2683c9f105$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $efd008e102aecb23$var$ButtonBase = /*#__PURE__*/ $lx97N.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $hphT8.default)(props, $efd008e102aecb23$var$_excluded);
    const buttonRef = $lx97N.useRef(null);
    const rippleRef = $lx97N.useRef(null);
    const handleRippleRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $5fbe03e0221974b0$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $lx97N.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $lx97N.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $lx97N.useState(false);
    $lx97N.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $lx97N.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $b5d1bb90cd0da3bf$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $b5d1bb90cd0da3bf$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $lx97N.useRef(false);
    const handleKeyDown = (0, $b5d1bb90cd0da3bf$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $b5d1bb90cd0da3bf$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $eR4tV.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $efd008e102aecb23$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($efd008e102aecb23$export$7ec0dcc5e3cdcd36, (0, $eR4tV.default)({
        as: ComponentProp,
        className: (0, $fmTP4.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $fRwNr.jsx)((0, $92a91faef5131fd5$export$2e2bcd8739ae039), (0, $eR4tV.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $efd008e102aecb23$export$2e2bcd8739ae039 = $efd008e102aecb23$var$ButtonBase;



var $4BrfH = parcelRequire("4BrfH");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $74fe26fcb9e8d4a6$export$5a6f9035944c8119(slot) {
    return (0, $h6nFM.default)('MuiButton', slot);
}
const $74fe26fcb9e8d4a6$var$buttonClasses = (0, $3OBXm.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $74fe26fcb9e8d4a6$export$2e2bcd8739ae039 = $74fe26fcb9e8d4a6$var$buttonClasses;



var $lx97N = parcelRequire("lx97N");
/**
 * @ignore - internal component.
 */ const $79c3ca80fea5c13f$var$ButtonGroupContext = /*#__PURE__*/ $lx97N.createContext({});
var $79c3ca80fea5c13f$export$2e2bcd8739ae039 = $79c3ca80fea5c13f$var$ButtonGroupContext;



var $fRwNr = parcelRequire("fRwNr");
const $382d3fbeb1a714c1$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $382d3fbeb1a714c1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $4BrfH.default)(color)}`,
            `size${(0, $4BrfH.default)(size)}`,
            `${variant}Size${(0, $4BrfH.default)(size)}`,
            color === 'inherit' && 'colorInherit',
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'startIcon',
            `iconSize${(0, $4BrfH.default)(size)}`
        ],
        endIcon: [
            'endIcon',
            `iconSize${(0, $4BrfH.default)(size)}`
        ]
    };
    const composedClasses = (0, $8o5tH.default)(slots, (0, $74fe26fcb9e8d4a6$export$5a6f9035944c8119), classes);
    return (0, $eR4tV.default)({}, classes, composedClasses);
};
const $382d3fbeb1a714c1$var$commonIconStyles = (ownerState)=>(0, $eR4tV.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $382d3fbeb1a714c1$var$ButtonRoot = (0, $7Ys8f.default)((0, $efd008e102aecb23$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $4BrfH.default)(ownerState.color)}`],
            styles[`size${(0, $4BrfH.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $4BrfH.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $eR4tV.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $eR4tV.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fMSjE.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fMSjE.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fMSjE.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $eR4tV.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $74fe26fcb9e8d4a6$export$2e2bcd8739ae039).focusVisible}`]: (0, $eR4tV.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $74fe26fcb9e8d4a6$export$2e2bcd8739ae039).disabled}`]: (0, $eR4tV.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $fMSjE.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $74fe26fcb9e8d4a6$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $74fe26fcb9e8d4a6$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $382d3fbeb1a714c1$var$ButtonStartIcon = (0, $7Ys8f.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $4BrfH.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $382d3fbeb1a714c1$var$commonIconStyles(ownerState)));
const $382d3fbeb1a714c1$var$ButtonEndIcon = (0, $7Ys8f.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $4BrfH.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $382d3fbeb1a714c1$var$commonIconStyles(ownerState)));
const $382d3fbeb1a714c1$var$Button = /*#__PURE__*/ $lx97N.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $lx97N.useContext((0, $79c3ca80fea5c13f$export$2e2bcd8739ae039));
    const resolvedProps = (0, $bo0T6.default)(contextProps, inProps);
    const props = (0, $zetlx.default)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $hphT8.default)(props, $382d3fbeb1a714c1$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $382d3fbeb1a714c1$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $fRwNr.jsx)($382d3fbeb1a714c1$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $fRwNr.jsx)($382d3fbeb1a714c1$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($382d3fbeb1a714c1$var$ButtonRoot, (0, $eR4tV.default)({
        ownerState: ownerState,
        className: (0, $fmTP4.default)(contextProps.className, classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $fmTP4.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $382d3fbeb1a714c1$export$2e2bcd8739ae039 = $382d3fbeb1a714c1$var$Button;



var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");
var $a3de43725b7a590e$exports = {};
'use strict';

$a3de43725b7a590e$exports = (parcelRequire("f00Nn"));




var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");


var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");


function $f81ee7f8f1bf9284$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


var $8503c55da5b06e5f$export$2e2bcd8739ae039 = (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039);



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $lx97N = parcelRequire("lx97N");
/**
 * @ignore - internal component.
 */ const $1c0253fac6b4e78d$var$ListContext = /*#__PURE__*/ $lx97N.createContext({});
var $1c0253fac6b4e78d$export$2e2bcd8739ae039 = $1c0253fac6b4e78d$var$ListContext;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $7cc311b8eaf47b22$export$c6bd6795ed6e3203(slot) {
    return (0, $h6nFM.default)('MuiList', slot);
}
const $7cc311b8eaf47b22$var$listClasses = (0, $3OBXm.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $7cc311b8eaf47b22$export$2e2bcd8739ae039 = $7cc311b8eaf47b22$var$listClasses;



var $fRwNr = parcelRequire("fRwNr");
const $d00629bb40c8bf5d$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $d00629bb40c8bf5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $7cc311b8eaf47b22$export$c6bd6795ed6e3203), classes);
};
const $d00629bb40c8bf5d$var$ListRoot = (0, $7Ys8f.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $d00629bb40c8bf5d$var$List = /*#__PURE__*/ $lx97N.forwardRef(function List(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $hphT8.default)(props, $d00629bb40c8bf5d$var$_excluded);
    const context = $lx97N.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $eR4tV.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $d00629bb40c8bf5d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $1c0253fac6b4e78d$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)($d00629bb40c8bf5d$var$ListRoot, (0, $eR4tV.default)({
            as: component,
            className: (0, $fmTP4.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $d00629bb40c8bf5d$export$2e2bcd8739ae039 = $d00629bb40c8bf5d$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $e8cb7f89d6875d6a$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


var $9becf7a771945d7e$export$2e2bcd8739ae039 = (0, $e8cb7f89d6875d6a$export$2e2bcd8739ae039);




var $433e95a68b5f9382$export$2e2bcd8739ae039 = (0, $dad405edc2b429da$export$2e2bcd8739ae039);



var $fRwNr = parcelRequire("fRwNr");
const $fc820cb31c7f35e2$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $fc820cb31c7f35e2$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $fc820cb31c7f35e2$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $fc820cb31c7f35e2$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $fc820cb31c7f35e2$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$fc820cb31c7f35e2$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $fc820cb31c7f35e2$var$MenuList = /*#__PURE__*/ $lx97N.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $hphT8.default)(props, $fc820cb31c7f35e2$var$_excluded);
    const listRef = $lx97N.useRef(null);
    const textCriteriaRef = $lx97N.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $433e95a68b5f9382$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $lx97N.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, theme)=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $9becf7a771945d7e$export$2e2bcd8739ae039)((0, $8503c55da5b06e5f$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $8503c55da5b06e5f$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $fc820cb31c7f35e2$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fc820cb31c7f35e2$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $fc820cb31c7f35e2$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $fc820cb31c7f35e2$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $fc820cb31c7f35e2$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fc820cb31c7f35e2$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $fc820cb31c7f35e2$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $fc820cb31c7f35e2$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $fc820cb31c7f35e2$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $fc820cb31c7f35e2$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $fc820cb31c7f35e2$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $lx97N.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $lx97N.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $lx97N.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $lx97N.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d00629bb40c8bf5d$export$2e2bcd8739ae039), (0, $eR4tV.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $fc820cb31c7f35e2$export$2e2bcd8739ae039 = $fc820cb31c7f35e2$var$MenuList;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $fMSjE = parcelRequire("fMSjE");

var $7Ys8f = parcelRequire("7Ys8f");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $987e068cf394ee2d$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $987e068cf394ee2d$export$2e2bcd8739ae039 = $987e068cf394ee2d$var$getOverlayAlpha;



var $zetlx = parcelRequire("zetlx");


var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $f23739f7ad7cd513$export$29cdb466b9b6f20b(slot) {
    return (0, $h6nFM.default)('MuiPaper', slot);
}
const $f23739f7ad7cd513$var$paperClasses = (0, $3OBXm.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $f23739f7ad7cd513$export$2e2bcd8739ae039 = $f23739f7ad7cd513$var$paperClasses;



var $fRwNr = parcelRequire("fRwNr");
const $1cadb75bd3b63f19$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $1cadb75bd3b63f19$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $f23739f7ad7cd513$export$29cdb466b9b6f20b), classes);
};
const $1cadb75bd3b63f19$var$PaperRoot = (0, $7Ys8f.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $eR4tV.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $eR4tV.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $fMSjE.alpha)('#fff', (0, $987e068cf394ee2d$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $fMSjE.alpha)('#fff', (0, $987e068cf394ee2d$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $1cadb75bd3b63f19$var$Paper = /*#__PURE__*/ $lx97N.forwardRef(function Paper(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $hphT8.default)(props, $1cadb75bd3b63f19$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $1cadb75bd3b63f19$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($1cadb75bd3b63f19$var$PaperRoot, (0, $eR4tV.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fmTP4.default)(classes.root, className),
        ref: ref
    }, other));
});
var $1cadb75bd3b63f19$export$2e2bcd8739ae039 = $1cadb75bd3b63f19$var$Paper;



var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");


var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $4d18f4df28635949$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $969260a3a3554a15$export$2e2bcd8739ae039 = (0, $4d18f4df28635949$export$2e2bcd8739ae039);




function $9422cdc1bfa48026$export$2e2bcd8739ae039(node) {
    const doc = (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $374f94188c9418ac$export$2e2bcd8739ae039 = (0, $9422cdc1bfa48026$export$2e2bcd8739ae039);




var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");



var $hphT8 = parcelRequire("hphT8");

var $3W2J1 = parcelRequire("3W2J1");


var $lx97N = parcelRequire("lx97N");

var $1amKe = parcelRequire("1amKe");
var $0fe5b7c48b161f71$export$2e2bcd8739ae039 = {
    disabled: false
};




var $26ba52d29c76bcef$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $badd265dd569312b$export$bb38bb9a1161268 = 'unmounted';
var $badd265dd569312b$export$84cbff306f539230 = 'exited';
var $badd265dd569312b$export$df38205c966be359 = 'entering';
var $badd265dd569312b$export$78e9e6e3e014d60a = 'entered';
var $badd265dd569312b$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $badd265dd569312b$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $3W2J1.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $badd265dd569312b$export$84cbff306f539230;
                _this.appearStatus = $badd265dd569312b$export$df38205c966be359;
            } else initialStatus = $badd265dd569312b$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $badd265dd569312b$export$bb38bb9a1161268;
        else initialStatus = $badd265dd569312b$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $badd265dd569312b$export$bb38bb9a1161268) return {
            status: $badd265dd569312b$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $badd265dd569312b$export$df38205c966be359 && status !== $badd265dd569312b$export$78e9e6e3e014d60a) nextStatus = $badd265dd569312b$export$df38205c966be359;
            } else if (status === $badd265dd569312b$export$df38205c966be359 || status === $badd265dd569312b$export$78e9e6e3e014d60a) nextStatus = $badd265dd569312b$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $badd265dd569312b$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1amKe))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $26ba52d29c76bcef$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $badd265dd569312b$export$84cbff306f539230) this.setState({
            status: $badd265dd569312b$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1amKe))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $0fe5b7c48b161f71$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $badd265dd569312b$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $badd265dd569312b$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $badd265dd569312b$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1amKe))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $0fe5b7c48b161f71$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $badd265dd569312b$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $badd265dd569312b$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $badd265dd569312b$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1amKe))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $badd265dd569312b$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hphT8.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $d2f3945552f4b8f7$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Component);
$badd265dd569312b$var$Transition.contextType = (0, $d2f3945552f4b8f7$export$2e2bcd8739ae039);
$badd265dd569312b$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $badd265dd569312b$var$noop() {}
$badd265dd569312b$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $badd265dd569312b$var$noop,
    onEntering: $badd265dd569312b$var$noop,
    onEntered: $badd265dd569312b$var$noop,
    onExit: $badd265dd569312b$var$noop,
    onExiting: $badd265dd569312b$var$noop,
    onExited: $badd265dd569312b$var$noop
};
$badd265dd569312b$var$Transition.UNMOUNTED = $badd265dd569312b$export$bb38bb9a1161268;
$badd265dd569312b$var$Transition.EXITED = $badd265dd569312b$export$84cbff306f539230;
$badd265dd569312b$var$Transition.ENTERING = $badd265dd569312b$export$df38205c966be359;
$badd265dd569312b$var$Transition.ENTERED = $badd265dd569312b$export$78e9e6e3e014d60a;
$badd265dd569312b$var$Transition.EXITING = $badd265dd569312b$export$4aacc83d4d59139f;
var $badd265dd569312b$export$2e2bcd8739ae039 = $badd265dd569312b$var$Transition;


parcelRequire("lx97N");

var $43QO7 = parcelRequire("43QO7");

var $cbdKw = parcelRequire("cbdKw");

var $Rnxzq = parcelRequire("Rnxzq");
function $c7f2f300ef30ef70$export$2e2bcd8739ae039() {
    const theme = (0, $43QO7.default)((0, $cbdKw.default));
    return theme[0, $Rnxzq.default] || theme;
}


const $c7b83d6ef2be284a$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $c7b83d6ef2be284a$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}




var $fRwNr = parcelRequire("fRwNr");
const $760b1d006513ba2e$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $760b1d006513ba2e$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $760b1d006513ba2e$var$styles = {
    entering: {
        opacity: 1,
        transform: $760b1d006513ba2e$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $760b1d006513ba2e$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $760b1d006513ba2e$var$Grow = /*#__PURE__*/ $lx97N.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $badd265dd569312b$export$2e2bcd8739ae039) } = props, other = (0, $hphT8.default)(props, $760b1d006513ba2e$var$_excluded);
    const timer = $lx97N.useRef();
    const autoTimeout = $lx97N.useRef();
    const theme = (0, $c7f2f300ef30ef70$export$2e2bcd8739ae039)();
    const nodeRef = $lx97N.useRef(null);
    const handleRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $c7b83d6ef2be284a$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $c7b83d6ef2be284a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $760b1d006513ba2e$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $c7b83d6ef2be284a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $760b1d006513ba2e$var$isWebKit154 ? duration : duration * 0.666,
                delay: $760b1d006513ba2e$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $760b1d006513ba2e$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.current = setTimeout(next, autoTimeout.current || 0);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    $lx97N.useEffect(()=>{
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $fRwNr.jsx)(TransitionComponent, (0, $eR4tV.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $lx97N.cloneElement(children, (0, $eR4tV.default)({
                style: (0, $eR4tV.default)({
                    opacity: 0,
                    transform: $760b1d006513ba2e$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $760b1d006513ba2e$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$760b1d006513ba2e$var$Grow.muiSupportAuto = true;
var $760b1d006513ba2e$export$2e2bcd8739ae039 = $760b1d006513ba2e$var$Grow;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $a01e15adbd0be1f4$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}



var $8o5tH = parcelRequire("8o5tH");

var $lx97N = parcelRequire("lx97N");

var $1amKe = parcelRequire("1amKe");



var $fRwNr = parcelRequire("fRwNr");
function $38c1e3fad1a30f73$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base/react-portal/components-api/#portal)
 */ const $38c1e3fad1a30f73$var$Portal = /*#__PURE__*/ $lx97N.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $lx97N.useState(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $ffcf97026745e37e$export$2e2bcd8739ae039)(/*#__PURE__*/ $lx97N.isValidElement(children) ? children.ref : null, forwardedRef);
    (0, $dad405edc2b429da$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($38c1e3fad1a30f73$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $dad405edc2b429da$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $f7ad26a55d813cb1$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $f7ad26a55d813cb1$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $lx97N.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $lx97N.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $fRwNr.jsx)($lx97N.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $fRwNr.jsx)($lx97N.Fragment, {
        children: mountNode ? /*#__PURE__*/ $1amKe.createPortal(children, mountNode) : mountNode
    });
});
var $38c1e3fad1a30f73$export$2e2bcd8739ae039 = $38c1e3fad1a30f73$var$Portal;



// Is a vertical scrollbar displayed?
function $ad0188b21c8810e1$var$isOverflowing(container) {
    const doc = (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $9422cdc1bfa48026$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $ad0188b21c8810e1$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $ad0188b21c8810e1$var$getPaddingRight(element) {
    return parseInt((0, $9422cdc1bfa48026$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $ad0188b21c8810e1$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $ad0188b21c8810e1$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$ad0188b21c8810e1$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $ad0188b21c8810e1$export$e1bd0c6150f13d96(element, show);
    });
}
function $ad0188b21c8810e1$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $ad0188b21c8810e1$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($ad0188b21c8810e1$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $e8cb7f89d6875d6a$export$2e2bcd8739ae039)((0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$ad0188b21c8810e1$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$ad0188b21c8810e1$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(container).body;
        else {
            // Improve Gatsby support
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $9422cdc1bfa48026$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $ad0188b21c8810e1$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $ad0188b21c8810e1$export$2e2bcd8739ae039 {
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $ad0188b21c8810e1$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $ad0188b21c8810e1$var$getHiddenSiblings(container);
        $ad0188b21c8810e1$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $ad0188b21c8810e1$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $ad0188b21c8810e1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $ad0188b21c8810e1$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $ad0188b21c8810e1$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $ad0188b21c8810e1$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $ad0188b21c8810e1$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $ad0188b21c8810e1$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */ 
var $lx97N = parcelRequire("lx97N");



var $fRwNr = parcelRequire("fRwNr");
// Inspired by https://github.com/focus-trap/tabbable
const $ecec1857bd8a5b4e$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $ecec1857bd8a5b4e$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $ecec1857bd8a5b4e$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $ecec1857bd8a5b4e$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $ecec1857bd8a5b4e$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $ecec1857bd8a5b4e$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($ecec1857bd8a5b4e$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $ecec1857bd8a5b4e$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$ecec1857bd8a5b4e$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $ecec1857bd8a5b4e$var$defaultIsEnabled() {
    return true;
}
/**
 * Utility component that locks focus inside the component.
 *
 * Demos:
 *
 * - [Focus Trap](https://mui.com/base/react-focus-trap/)
 *
 * API:
 *
 * - [FocusTrap API](https://mui.com/base/react-focus-trap/components-api/#focus-trap)
 */ function $ecec1857bd8a5b4e$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $ecec1857bd8a5b4e$var$defaultGetTabbable, isEnabled: isEnabled = $ecec1857bd8a5b4e$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $lx97N.useRef(false);
    const sentinelStart = $lx97N.useRef(null);
    const sentinelEnd = $lx97N.useRef(null);
    const nodeToRestore = $lx97N.useRef(null);
    const reactFocusEventTarget = $lx97N.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $lx97N.useRef(false);
    const rootRef = $lx97N.useRef(null);
    // @ts-expect-error TODO upstream fix
    const handleRef = (0, $ffcf97026745e37e$export$2e2bcd8739ae039)(children.ref, rootRef);
    const lastKeydown = $lx97N.useRef(null);
    $lx97N.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $lx97N.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $lx97N.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(rootRef.current);
        const contain = (nativeEvent)=>{
            const { current: rootElement } = rootRef;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            if (!rootElement.contains(doc.activeElement)) {
                // if the focus event is not coming from inside the children's react tree, reset the refs
                if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
                else if (reactFocusEventTarget.current !== null) return;
                if (!activated.current) return;
                let tabbable = [];
                if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
                if (tabbable.length > 0) {
                    var _lastKeydown$current, _lastKeydown$current2;
                    const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                    const focusNext = tabbable[0];
                    const focusPrevious = tabbable[tabbable.length - 1];
                    if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                        if (isShiftTab) focusPrevious.focus();
                        else focusNext.focus();
                    }
                } else rootElement.focus();
            }
        };
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain(null);
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $lx97N.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $ecec1857bd8a5b4e$export$2e2bcd8739ae039 = $ecec1857bd8a5b4e$var$FocusTrap;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $2f4faf1d151036a4$export$67960e22b12a638d(slot) {
    return (0, $h6nFM.default)('MuiModal', slot);
}
const $2f4faf1d151036a4$var$modalClasses = (0, $3OBXm.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $2f4faf1d151036a4$export$2e2bcd8739ae039 = $2f4faf1d151036a4$var$modalClasses;



var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");


var $eR4tV = parcelRequire("eR4tV");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $469f9f719a324870$export$2e2bcd8739ae039(element) {
    return typeof element === 'string';
}


function $e9cfab20069234fb$export$2e2bcd8739ae039(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $469f9f719a324870$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $eR4tV.default)({}, otherProps, {
        ownerState: (0, $eR4tV.default)({}, otherProps.ownerState, ownerState)
    });
}



var $eR4tV = parcelRequire("eR4tV");

var $fmTP4 = parcelRequire("fmTP4");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $7536afe63846ce1b$export$2e2bcd8739ae039(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $13f756d973e825f7$export$2e2bcd8739ae039(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}


function $2b2340c33475672f$export$2e2bcd8739ae039(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $fmTP4.default)(externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className, className, additionalProps == null ? void 0 : additionalProps.className);
        const mergedStyle = (0, $eR4tV.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $eR4tV.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $7536afe63846ce1b$export$2e2bcd8739ae039)((0, $eR4tV.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $13f756d973e825f7$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $13f756d973e825f7$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $fmTP4.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $eR4tV.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $eR4tV.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $b9357fa837941d43$export$2e2bcd8739ae039(componentProps, ownerState) {
    if (typeof componentProps === 'function') return componentProps(ownerState);
    return componentProps;
}


const $ea513296a282d999$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState"
];
function $ea513296a282d999$export$2e2bcd8739ae039(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState } = parameters, rest = (0, $hphT8.default)(parameters, $ea513296a282d999$var$_excluded);
    const resolvedComponentsProps = (0, $b9357fa837941d43$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $2b2340c33475672f$export$2e2bcd8739ae039)((0, $eR4tV.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $ffcf97026745e37e$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $e9cfab20069234fb$export$2e2bcd8739ae039)(elementType, (0, $eR4tV.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}



var $lx97N = parcelRequire("lx97N");

var $fRwNr = parcelRequire("fRwNr");
const $6c243b273f6a200f$var$defaultContextValue = {
    disableDefaultClasses: false
};
const $6c243b273f6a200f$var$ClassNameConfiguratorContext = /*#__PURE__*/ $lx97N.createContext($6c243b273f6a200f$var$defaultContextValue);
function $6c243b273f6a200f$export$b0f7603cd2f9ee15(generateUtilityClass) {
    const { disableDefaultClasses: disableDefaultClasses } = $lx97N.useContext($6c243b273f6a200f$var$ClassNameConfiguratorContext);
    return (slot)=>{
        if (disableDefaultClasses) return '';
        return generateUtilityClass(slot);
    };
}
function $6c243b273f6a200f$export$2e2bcd8739ae039(props) {
    const { disableDefaultClasses: disableDefaultClasses, children: children } = props;
    const contextValue = $lx97N.useMemo(()=>({
            disableDefaultClasses: disableDefaultClasses != null ? disableDefaultClasses : false
        }), [
        disableDefaultClasses
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($6c243b273f6a200f$var$ClassNameConfiguratorContext.Provider, {
        value: contextValue,
        children: children
    });
}



var $fRwNr = parcelRequire("fRwNr");
const $afb1323a06a91fff$var$_excluded = [
    "children",
    "closeAfterTransition",
    "container",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "manager",
    "onBackdropClick",
    "onClose",
    "onKeyDown",
    "open",
    "onTransitionEnter",
    "onTransitionExited",
    "slotProps",
    "slots"
];
const $afb1323a06a91fff$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $6c243b273f6a200f$export$b0f7603cd2f9ee15)((0, $2f4faf1d151036a4$export$67960e22b12a638d)));
};
function $afb1323a06a91fff$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $afb1323a06a91fff$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $afb1323a06a91fff$var$defaultManager = new (0, $ad0188b21c8810e1$export$2e2bcd8739ae039)();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * *   [Dialog](https://mui.com/material-ui/api/dialog/)
 * *   [Drawer](https://mui.com/material-ui/api/drawer/)
 * *   [Menu](https://mui.com/material-ui/api/menu/)
 * *   [Popover](https://mui.com/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](https://mui.com/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base/react-modal/)
 *
 * API:
 *
 * - [Modal API](https://mui.com/base/react-modal/components-api/#modal)
 */ const $afb1323a06a91fff$var$Modal = /*#__PURE__*/ $lx97N.forwardRef(function Modal(props, forwardedRef) {
    var _props$ariaHidden, _slots$root;
    const { children: children, closeAfterTransition: closeAfterTransition = false, container: container, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, // private
    manager: managerProp = $afb1323a06a91fff$var$defaultManager, onBackdropClick: onBackdropClick, onClose: onClose, onKeyDown: onKeyDown, open: open, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $hphT8.default)(props, $afb1323a06a91fff$var$_excluded);
    // TODO: `modal`` must change its type in this file to match the type of methods
    // provided by `ModalManager`
    const manager = managerProp;
    const [exited, setExited] = $lx97N.useState(!open);
    const modal = $lx97N.useRef({});
    const mountNodeRef = $lx97N.useRef(null);
    const modalRef = $lx97N.useRef(null);
    const handleRef = (0, $ffcf97026745e37e$export$2e2bcd8739ae039)(modalRef, forwardedRef);
    const hasTransition = $afb1323a06a91fff$var$getHasTransition(children);
    const ariaHiddenProp = (_props$ariaHidden = props['aria-hidden']) != null ? _props$ariaHidden : true;
    const getDoc = ()=>(0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mountNode = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $af5f790c3bb64471$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $afb1323a06a91fff$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $lx97N.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $af5f790c3bb64471$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node || !modalRef.current) return;
        if (open && isTopModal()) handleMounted();
        else (0, $ad0188b21c8810e1$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $lx97N.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        manager,
        ariaHiddenProp
    ]);
    $lx97N.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $lx97N.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const ownerState = (0, $eR4tV.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        exited: exited,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const classes = $afb1323a06a91fff$var$useUtilityClasses(ownerState);
    const handleEnter = ()=>{
        setExited(false);
        if (onTransitionEnter) onTransitionEnter();
    };
    const handleExited = ()=>{
        setExited(true);
        if (onTransitionExited) onTransitionExited();
        if (closeAfterTransition) handleClose();
    };
    const handleBackdropClick = (event)=>{
        if (event.target !== event.currentTarget) return;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const handleKeyDown = (event)=>{
        if (onKeyDown) onKeyDown(event);
        // The handler doesn't take event.defaultPrevented into account:
        //
        // event.preventDefault() is meant to stop default behaviors like
        // clicking a checkbox to check it, hitting a button to submit a form,
        // and hitting left arrow to move the cursor in a text input etc.
        // Only special HTML elements have these default behaviors.
        if (event.key !== 'Escape' || !isTopModal()) return;
        if (!disableEscapeKeyDown) {
            // Swallow the event, in case someone is listening for the escape key on the body.
            event.stopPropagation();
            if (onClose) onClose(event, 'escapeKeyDown');
        }
    };
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        childProps.onEnter = (0, $a01e15adbd0be1f4$export$2e2bcd8739ae039)(handleEnter, children.props.onEnter);
        childProps.onExited = (0, $a01e15adbd0be1f4$export$2e2bcd8739ae039)(handleExited, children.props.onExited);
    }
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRef,
            role: 'presentation',
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: ownerState
    });
    const BackdropComponent = slots.backdrop;
    const backdropProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: BackdropComponent,
        externalSlotProps: slotProps.backdrop,
        additionalProps: {
            'aria-hidden': true,
            onClick: handleBackdropClick,
            open: open
        },
        className: classes.backdrop,
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $38c1e3fad1a30f73$export$2e2bcd8739ae039), {
        ref: handlePortalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)(Root, (0, $eR4tV.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $fRwNr.jsx)(BackdropComponent, (0, $eR4tV.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $ecec1857bd8a5b4e$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $lx97N.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $afb1323a06a91fff$export$2e2bcd8739ae039 = $afb1323a06a91fff$var$Modal;





var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");







var $fRwNr = parcelRequire("fRwNr");
const $8e91f84d1f9614e6$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $8e91f84d1f9614e6$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $8e91f84d1f9614e6$var$Fade = /*#__PURE__*/ $lx97N.forwardRef(function Fade(props, ref) {
    const theme = (0, $c7f2f300ef30ef70$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $badd265dd569312b$export$2e2bcd8739ae039) } = props, other = (0, $hphT8.default)(props, $8e91f84d1f9614e6$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $lx97N.useRef(null);
    const handleRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(nodeRef, children.ref, ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $c7b83d6ef2be284a$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $c7b83d6ef2be284a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $c7b83d6ef2be284a$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $fRwNr.jsx)(TransitionComponent, (0, $eR4tV.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $lx97N.cloneElement(children, (0, $eR4tV.default)({
                style: (0, $eR4tV.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $8e91f84d1f9614e6$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $8e91f84d1f9614e6$export$2e2bcd8739ae039 = $8e91f84d1f9614e6$var$Fade;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $62c275339b12648d$export$9927a91fd93152bd(slot) {
    return (0, $h6nFM.default)('MuiBackdrop', slot);
}
const $62c275339b12648d$var$backdropClasses = (0, $3OBXm.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $62c275339b12648d$export$2e2bcd8739ae039 = $62c275339b12648d$var$backdropClasses;



var $fRwNr = parcelRequire("fRwNr");
const $feb5457557a7f385$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $feb5457557a7f385$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $62c275339b12648d$export$9927a91fd93152bd), classes);
};
const $feb5457557a7f385$var$BackdropRoot = (0, $7Ys8f.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $feb5457557a7f385$var$Backdrop = /*#__PURE__*/ $lx97N.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $8e91f84d1f9614e6$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $hphT8.default)(props, $feb5457557a7f385$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $feb5457557a7f385$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $fRwNr.jsx)(TransitionComponent, (0, $eR4tV.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($feb5457557a7f385$var$BackdropRoot, (0, $eR4tV.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $fmTP4.default)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $eR4tV.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $feb5457557a7f385$export$2e2bcd8739ae039 = $feb5457557a7f385$var$Backdrop;



var $fRwNr = parcelRequire("fRwNr");
const $c25de88565c859da$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $c25de88565c859da$export$eb211a494147b724 = (0, $2f4faf1d151036a4$export$2e2bcd8739ae039);
const $c25de88565c859da$var$ModalRoot = (0, $7Ys8f.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $c25de88565c859da$var$ModalBackdrop = (0, $7Ys8f.default)((0, $feb5457557a7f385$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $c25de88565c859da$var$Modal = /*#__PURE__*/ $lx97N.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $zetlx.default)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $c25de88565c859da$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classes, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, onClose: onClose, open: open, slotProps: slotProps, slots: slots, theme: // eslint-disable-next-line react/prop-types
    theme } = props, other = (0, $hphT8.default)(props, $c25de88565c859da$var$_excluded);
    const [exited, setExited] = $lx97N.useState(true);
    const commonProps = {
        container: container,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted,
        onBackdropClick: onBackdropClick,
        onClose: onClose,
        open: open
    };
    const ownerState = (0, $eR4tV.default)({}, props, commonProps, {
        exited: exited
    });
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $c25de88565c859da$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $afb1323a06a91fff$export$2e2bcd8739ae039), (0, $eR4tV.default)({
        slots: {
            root: RootSlot,
            backdrop: BackdropSlot
        },
        slotProps: {
            root: ()=>(0, $eR4tV.default)({}, (0, $b9357fa837941d43$export$2e2bcd8739ae039)(rootSlotProps, ownerState), !(0, $469f9f719a324870$export$2e2bcd8739ae039)(RootSlot) && {
                    as: component,
                    theme: theme
                }, {
                    className: (0, $fmTP4.default)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
                }),
            backdrop: ()=>(0, $eR4tV.default)({}, BackdropProps, (0, $b9357fa837941d43$export$2e2bcd8739ae039)(backdropSlotProps, ownerState), {
                    className: (0, $fmTP4.default)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop)
                })
        },
        onTransitionEnter: ()=>setExited(false),
        onTransitionExited: ()=>setExited(true),
        ref: ref
    }, other, commonProps, {
        children: children
    }));
});
var $c25de88565c859da$export$2e2bcd8739ae039 = $c25de88565c859da$var$Modal;




var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $2f1d866ffd0dbf14$export$88f455dd56c95edb(slot) {
    return (0, $h6nFM.default)('MuiPopover', slot);
}
const $2f1d866ffd0dbf14$var$popoverClasses = (0, $3OBXm.default)('MuiPopover', [
    'root',
    'paper'
]);
var $2f1d866ffd0dbf14$export$2e2bcd8739ae039 = $2f1d866ffd0dbf14$var$popoverClasses;



var $fRwNr = parcelRequire("fRwNr");
const $5080206b1e96be41$var$_excluded = [
    "onEntering"
], $5080206b1e96be41$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
function $5080206b1e96be41$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $5080206b1e96be41$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $5080206b1e96be41$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $5080206b1e96be41$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $5080206b1e96be41$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $2f1d866ffd0dbf14$export$88f455dd56c95edb), classes);
};
const $5080206b1e96be41$var$PopoverRoot = (0, $7Ys8f.default)((0, $c25de88565c859da$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $5080206b1e96be41$var$PopoverPaper = (0, $7Ys8f.default)((0, $1cadb75bd3b63f19$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $5080206b1e96be41$var$Popover = /*#__PURE__*/ $lx97N.forwardRef(function Popover(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $760b1d006513ba2e$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {} } = props, TransitionProps = (0, $hphT8.default)(props.TransitionProps, $5080206b1e96be41$var$_excluded), other = (0, $hphT8.default)(props, $5080206b1e96be41$var$_excluded2);
    const paperRef = $lx97N.useRef();
    const handlePaperRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(paperRef, PaperProps.ref);
    const ownerState = (0, $eR4tV.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        PaperProps: PaperProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $5080206b1e96be41$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $lx97N.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $5080206b1e96be41$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $8503c55da5b06e5f$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $5080206b1e96be41$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $5080206b1e96be41$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $lx97N.useCallback((elemRect)=>{
        return {
            vertical: $5080206b1e96be41$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $5080206b1e96be41$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $lx97N.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $5080206b1e96be41$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $374f94188c9418ac$export$2e2bcd8739ae039)($5080206b1e96be41$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $5080206b1e96be41$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $lx97N.useState(open);
    const setPositioningStyles = $lx97N.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $lx97N.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $lx97N.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $lx97N.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $969260a3a3554a15$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $374f94188c9418ac$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $8503c55da5b06e5f$export$2e2bcd8739ae039)($5080206b1e96be41$var$resolveAnchorEl(anchorEl)).body : undefined);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($5080206b1e96be41$var$PopoverRoot, (0, $eR4tV.default)({
        BackdropProps: {
            invisible: true
        },
        className: (0, $fmTP4.default)(classes.root, className),
        container: container,
        open: open,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $fRwNr.jsx)(TransitionComponent, (0, $eR4tV.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $fRwNr.jsx)($5080206b1e96be41$var$PopoverPaper, (0, $eR4tV.default)({
                elevation: elevation
            }, PaperProps, {
                ref: handlePaperRef,
                className: (0, $fmTP4.default)(classes.paper, PaperProps.className)
            }, isPositioned ? undefined : {
                style: (0, $eR4tV.default)({}, PaperProps.style, {
                    opacity: 0
                })
            }, {
                ownerState: ownerState,
                children: children
            }))
        }))
    }));
});
var $5080206b1e96be41$export$2e2bcd8739ae039 = $5080206b1e96be41$var$Popover;



var $7Ys8f = parcelRequire("7Ys8f");


var $zetlx = parcelRequire("zetlx");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $78e081a99f71b785$export$2cf86a63a84fe23d(slot) {
    return (0, $h6nFM.default)('MuiMenu', slot);
}
const $78e081a99f71b785$var$menuClasses = (0, $3OBXm.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $78e081a99f71b785$export$2e2bcd8739ae039 = $78e081a99f71b785$var$menuClasses;



var $fRwNr = parcelRequire("fRwNr");
const $3c81bfb010f12d1e$var$_excluded = [
    "onEntering"
], $3c81bfb010f12d1e$var$_excluded2 = [
    "autoFocus",
    "children",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant"
];
const $3c81bfb010f12d1e$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $3c81bfb010f12d1e$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $3c81bfb010f12d1e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $78e081a99f71b785$export$2cf86a63a84fe23d), classes);
};
const $3c81bfb010f12d1e$var$MenuRoot = (0, $7Ys8f.default)((0, $5080206b1e96be41$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $3c81bfb010f12d1e$var$MenuPaper = (0, $7Ys8f.default)((0, $1cadb75bd3b63f19$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $3c81bfb010f12d1e$var$MenuMenuList = (0, $7Ys8f.default)((0, $fc820cb31c7f35e2$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $3c81bfb010f12d1e$var$Menu = /*#__PURE__*/ $lx97N.forwardRef(function Menu(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu' } = props, TransitionProps = (0, $hphT8.default)(props.TransitionProps, $3c81bfb010f12d1e$var$_excluded), other = (0, $hphT8.default)(props, $3c81bfb010f12d1e$var$_excluded2);
    const theme = (0, $c7f2f300ef30ef70$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const ownerState = (0, $eR4tV.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $3c81bfb010f12d1e$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $lx97N.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $lx97N.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $lx97N.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    return /*#__PURE__*/ (0, $fRwNr.jsx)($3c81bfb010f12d1e$var$MenuRoot, (0, $eR4tV.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $3c81bfb010f12d1e$var$RTL_ORIGIN : $3c81bfb010f12d1e$var$LTR_ORIGIN,
        PaperProps: (0, $eR4tV.default)({
            as: $3c81bfb010f12d1e$var$MenuPaper
        }, PaperProps, {
            classes: (0, $eR4tV.default)({}, PaperProps.classes, {
                root: classes.paper
            })
        }),
        className: classes.root,
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $eR4tV.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($3c81bfb010f12d1e$var$MenuMenuList, (0, $eR4tV.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $fmTP4.default)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $3c81bfb010f12d1e$export$2e2bcd8739ae039 = $3c81bfb010f12d1e$var$Menu;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");

var $fMSjE = parcelRequire("fMSjE");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");





var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $d3d04fec3a46301f$export$46f01d01378ec5a2(slot) {
    return (0, $h6nFM.default)('MuiDivider', slot);
}
const $d3d04fec3a46301f$var$dividerClasses = (0, $3OBXm.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $d3d04fec3a46301f$export$2e2bcd8739ae039 = $d3d04fec3a46301f$var$dividerClasses;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $d855c63041665b2e$export$81478e24460c57f2(slot) {
    return (0, $h6nFM.default)('MuiListItemIcon', slot);
}
const $d855c63041665b2e$var$listItemIconClasses = (0, $3OBXm.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $d855c63041665b2e$export$2e2bcd8739ae039 = $d855c63041665b2e$var$listItemIconClasses;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $460ff84df3ab4b93$export$1061006a0db3aeb5(slot) {
    return (0, $h6nFM.default)('MuiListItemText', slot);
}
const $460ff84df3ab4b93$var$listItemTextClasses = (0, $3OBXm.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $460ff84df3ab4b93$export$2e2bcd8739ae039 = $460ff84df3ab4b93$var$listItemTextClasses;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $d51cd3890aaf1ddf$export$515f8c67b5305377(slot) {
    return (0, $h6nFM.default)('MuiMenuItem', slot);
}
const $d51cd3890aaf1ddf$var$menuItemClasses = (0, $3OBXm.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $d51cd3890aaf1ddf$export$2e2bcd8739ae039 = $d51cd3890aaf1ddf$var$menuItemClasses;



var $fRwNr = parcelRequire("fRwNr");
const $d3dfe97e91db5364$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $d3dfe97e91db5364$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $d3dfe97e91db5364$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $8o5tH.default)(slots, (0, $d51cd3890aaf1ddf$export$515f8c67b5305377), classes);
    return (0, $eR4tV.default)({}, classes, composedClasses);
};
const $d3dfe97e91db5364$var$MenuItemRoot = (0, $7Ys8f.default)((0, $efd008e102aecb23$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $d3dfe97e91db5364$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $d51cd3890aaf1ddf$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fMSjE.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $d51cd3890aaf1ddf$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $fMSjE.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $d51cd3890aaf1ddf$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $fMSjE.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $fMSjE.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $d51cd3890aaf1ddf$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $d51cd3890aaf1ddf$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $d3d04fec3a46301f$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $d3d04fec3a46301f$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $460ff84df3ab4b93$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $460ff84df3ab4b93$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $d855c63041665b2e$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $eR4tV.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $d855c63041665b2e$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $d3dfe97e91db5364$var$MenuItem = /*#__PURE__*/ $lx97N.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $hphT8.default)(props, $d3dfe97e91db5364$var$_excluded);
    const context = $lx97N.useContext((0, $1c0253fac6b4e78d$export$2e2bcd8739ae039));
    const childContext = $lx97N.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $lx97N.useRef(null);
    (0, $433e95a68b5f9382$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $eR4tV.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $d3dfe97e91db5364$var$useUtilityClasses(props);
    const handleRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $1c0253fac6b4e78d$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($d3dfe97e91db5364$var$MenuItemRoot, (0, $eR4tV.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $fmTP4.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $fmTP4.default)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $d3dfe97e91db5364$export$2e2bcd8739ae039 = $d3dfe97e91db5364$var$MenuItem;


var $364831c49e4926fd$exports = {};
"use strict";
var $61a0415ce92f46da$exports = {};
function $61a0415ce92f46da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$61a0415ce92f46da$exports = $61a0415ce92f46da$var$_interopRequireDefault, $61a0415ce92f46da$exports.__esModule = true, $61a0415ce92f46da$exports["default"] = $61a0415ce92f46da$exports;


Object.defineProperty($364831c49e4926fd$exports, "__esModule", {
    value: true
});
$364831c49e4926fd$exports.default = void 0;

var $364831c49e4926fd$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $364831c49e4926fd$var$_default = (0, $364831c49e4926fd$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown');
$364831c49e4926fd$exports.default = $364831c49e4926fd$var$_default;



var $lx97N = parcelRequire("lx97N");

var $bqPQ9 = parcelRequire("bqPQ9");


var $d9gj3 = parcelRequire("d9gj3");

var $l2Ecb = parcelRequire("l2Ecb");
const $5629744cb1d83a68$var$postVersionRequest = (target, onVersion)=>{
    if (!target) return;
    const messageChannel = new MessageChannel();
    const handleMessage = (event)=>{
        const version = event.data?.version;
        if (typeof version === 'string' && version.length > 0) onVersion(version);
        messageChannel.port1.close?.();
    };
    if (typeof messageChannel.port1.addEventListener === 'function') {
        messageChannel.port1.addEventListener('message', handleMessage);
        messageChannel.port1.start();
    } else // eslint-disable-next-line unicorn/prefer-add-event-listener
    messageChannel.port1.onmessage = handleMessage;
    target.postMessage({
        topic: 'version'
    }, [
        messageChannel.port2
    ]);
};
const $5629744cb1d83a68$export$5b7220d0cd593d0 = (onVersion)=>{
    const serviceWorker = navigator?.serviceWorker;
    if (!serviceWorker) return;
    if (serviceWorker.controller) {
        $5629744cb1d83a68$var$postVersionRequest(serviceWorker.controller, onVersion);
        return;
    }
    const requestVersionFromReady = async ()=>{
        try {
            const registration = await serviceWorker.ready;
            $5629744cb1d83a68$var$postVersionRequest(registration.active ?? registration.waiting ?? registration.installing ?? undefined, onVersion);
        } catch  {
        // Ignore readiness failures when no active service worker is available.
        }
    };
    requestVersionFromReady();
};




var $fRwNr = parcelRequire("fRwNr");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");

var $fQojQ = parcelRequire("fQojQ");

var $d8uBH = parcelRequire("d8uBH");

var $j1oop = parcelRequire("j1oop");
var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $8zw8B = parcelRequire("8zw8B");

var $5sbKe = parcelRequire("5sbKe");
const $90f112fbce12cd6e$var$_excluded = [
    "sx"
];
const $90f112fbce12cd6e$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $5sbKe.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $90f112fbce12cd6e$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $hphT8.default)(props, $90f112fbce12cd6e$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $90f112fbce12cd6e$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $8zw8B.isPlainObject)(result)) return systemProps;
        return (0, $eR4tV.default)({}, systemProps, result);
    };
    else finalSx = (0, $eR4tV.default)({}, systemProps, inSx);
    return (0, $eR4tV.default)({}, otherProps, {
        sx: finalSx
    });
}



var $43QO7 = parcelRequire("43QO7");

var $fRwNr = parcelRequire("fRwNr");
'use client';
const $d8152ed42e85e9b2$var$_excluded = [
    "className",
    "component"
];
function $d8152ed42e85e9b2$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $d8uBH.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $j1oop.default));
    const Box = /*#__PURE__*/ $lx97N.forwardRef(function Box(inProps, ref) {
        const theme = (0, $43QO7.default)(defaultTheme);
        const _extendSxProp = (0, $90f112fbce12cd6e$export$2e2bcd8739ae039)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $hphT8.default)(_extendSxProp, $d8152ed42e85e9b2$var$_excluded);
        return /*#__PURE__*/ (0, $fRwNr.jsx)(BoxRoot, (0, $eR4tV.default)({
            as: component,
            ref: ref,
            className: (0, $fQojQ.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $aNn1w = parcelRequire("aNn1w");

var $aBr5J = parcelRequire("aBr5J");

var $Rnxzq = parcelRequire("Rnxzq");
const $d47fb49f85ffe081$var$defaultTheme = (0, $aBr5J.default)();
const $d47fb49f85ffe081$var$Box = (0, $d8152ed42e85e9b2$export$2e2bcd8739ae039)({
    themeId: (0, $Rnxzq.default),
    defaultTheme: $d47fb49f85ffe081$var$defaultTheme,
    defaultClassName: 'MuiBox-root',
    generateClassName: (0, $aNn1w.default).generate
});
var $d47fb49f85ffe081$export$2e2bcd8739ae039 = $d47fb49f85ffe081$var$Box;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");



var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");


// Source from https://github.com/alitaheri/normalize-scroll-left
let $050334f885489a07$var$cachedType;
function $050334f885489a07$export$a10970ffb6510128() {
    if ($050334f885489a07$var$cachedType) return $050334f885489a07$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $050334f885489a07$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $050334f885489a07$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $050334f885489a07$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $050334f885489a07$var$cachedType;
}
function $050334f885489a07$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $050334f885489a07$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $ba5ca04307e744fe$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $ba5ca04307e744fe$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $ba5ca04307e744fe$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");




var $fRwNr = parcelRequire("fRwNr");
const $db5d06c44dfffaa4$var$_excluded = [
    "onChange"
];
const $db5d06c44dfffaa4$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $db5d06c44dfffaa4$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $hphT8.default)(props, $db5d06c44dfffaa4$var$_excluded);
    const scrollbarHeight = $lx97N.useRef();
    const nodeRef = $lx97N.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $433e95a68b5f9382$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $969260a3a3554a15$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $374f94188c9418ac$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $lx97N.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", (0, $eR4tV.default)({
        style: $db5d06c44dfffaa4$var$styles,
        ref: nodeRef
    }, other));
}



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");
parcelRequire("lx97N");

var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $aa5e89f5721e24b3$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("lx97N");

var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $91d969da7c6db088$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');





var $zetlx = parcelRequire("zetlx");

var $7Ys8f = parcelRequire("7Ys8f");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $280bdc46d9e6f161$export$34861783d3c2eef8(slot) {
    return (0, $h6nFM.default)('MuiTabScrollButton', slot);
}
const $280bdc46d9e6f161$var$tabScrollButtonClasses = (0, $3OBXm.default)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $280bdc46d9e6f161$export$2e2bcd8739ae039 = $280bdc46d9e6f161$var$tabScrollButtonClasses;



var $fRwNr = parcelRequire("fRwNr");
const $2ac02503c0cb52bf$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $2ac02503c0cb52bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $280bdc46d9e6f161$export$34861783d3c2eef8), classes);
};
const $2ac02503c0cb52bf$var$TabScrollButtonRoot = (0, $7Ys8f.default)((0, $efd008e102aecb23$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $280bdc46d9e6f161$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $2ac02503c0cb52bf$var$TabScrollButton = /*#__PURE__*/ $lx97N.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $hphT8.default)(props, $2ac02503c0cb52bf$var$_excluded);
    const theme = (0, $c7f2f300ef30ef70$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const ownerState = (0, $eR4tV.default)({
        isRtl: isRtl
    }, props);
    const classes = $2ac02503c0cb52bf$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $aa5e89f5721e24b3$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $91d969da7c6db088$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $fRwNr.jsx)($2ac02503c0cb52bf$var$TabScrollButtonRoot, (0, $eR4tV.default)({
        component: "div",
        className: (0, $fmTP4.default)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $fRwNr.jsx)(StartButtonIcon, (0, $eR4tV.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $fRwNr.jsx)(EndButtonIcon, (0, $eR4tV.default)({}, endButtonIconProps))
    }));
});
var $2ac02503c0cb52bf$export$2e2bcd8739ae039 = $2ac02503c0cb52bf$var$TabScrollButton;




var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $0c05d23194d696e9$export$cdd93bd054dec359(slot) {
    return (0, $h6nFM.default)('MuiTabs', slot);
}
const $0c05d23194d696e9$var$tabsClasses = (0, $3OBXm.default)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $0c05d23194d696e9$export$2e2bcd8739ae039 = $0c05d23194d696e9$var$tabsClasses;





var $fRwNr = parcelRequire("fRwNr");
const $16f665bb55281646$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $16f665bb55281646$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $16f665bb55281646$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $16f665bb55281646$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $16f665bb55281646$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $0c05d23194d696e9$export$cdd93bd054dec359), classes);
};
const $16f665bb55281646$var$TabsRoot = (0, $7Ys8f.default)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $0c05d23194d696e9$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $0c05d23194d696e9$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eR4tV.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $0c05d23194d696e9$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $16f665bb55281646$var$TabsScroller = (0, $7Ys8f.default)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $16f665bb55281646$var$FlexContainer = (0, $7Ys8f.default)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $16f665bb55281646$var$TabsIndicator = (0, $7Ys8f.default)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $eR4tV.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $16f665bb55281646$var$TabsScrollbarSize = (0, $7Ys8f.default)((0, $db5d06c44dfffaa4$export$2e2bcd8739ae039), {
    name: 'MuiTabs',
    slot: 'ScrollbarSize'
})({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $16f665bb55281646$var$defaultIndicatorStyle = {};
let $16f665bb55281646$var$warnedOnceTabPresent = false;
const $16f665bb55281646$var$Tabs = /*#__PURE__*/ $lx97N.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $c7f2f300ef30ef70$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $2ac02503c0cb52bf$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $hphT8.default)(props, $16f665bb55281646$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $eR4tV.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $16f665bb55281646$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $lx97N.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $lx97N.useState($16f665bb55281646$var$defaultIndicatorStyle);
    const [displayScroll, setDisplayScroll] = $lx97N.useState({
        start: false,
        end: false
    });
    const [scrollerStyle, setScrollerStyle] = $lx97N.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $lx97N.useRef(null);
    const tabListRef = $lx97N.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $050334f885489a07$export$3c615b88e5d7e4f6)(tabsNode, theme.direction),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $b5d1bb90cd0da3bf$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $ba5ca04307e744fe$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $050334f885489a07$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $lx97N.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $fRwNr.jsx)($16f665bb55281646$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $fmTP4.default)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayScroll.start || displayScroll.end;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $fRwNr.jsx)(ScrollButtonComponent, (0, $eR4tV.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayScroll.start
        }, TabScrollButtonProps, {
            className: (0, $fmTP4.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $fRwNr.jsx)(ScrollButtonComponent, (0, $eR4tV.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayScroll.end
        }, TabScrollButtonProps, {
            className: (0, $fmTP4.default)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $b5d1bb90cd0da3bf$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $b5d1bb90cd0da3bf$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) {
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight, scrollWidth: scrollWidth, clientWidth: clientWidth } = tabsRef.current;
            let showStartScroll;
            let showEndScroll;
            if (vertical) {
                showStartScroll = scrollTop > 1;
                showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
            } else {
                const scrollLeft = (0, $050334f885489a07$export$3c615b88e5d7e4f6)(tabsRef.current, theme.direction);
                // use 1 for the potential rounding error with browser zooms.
                showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
                showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
            }
            if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) setDisplayScroll({
                start: showStartScroll,
                end: showEndScroll
            });
        }
    });
    $lx97N.useEffect(()=>{
        const handleResize = (0, $969260a3a3554a15$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) {
                updateIndicatorState();
                updateScrollButtonState();
            }
        });
        const win = (0, $374f94188c9418ac$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const handleTabsScroll = $lx97N.useMemo(()=>(0, $969260a3a3554a15$export$2e2bcd8739ae039)(()=>{
            updateScrollButtonState();
        }), [
        updateScrollButtonState
    ]);
    $lx97N.useEffect(()=>{
        return ()=>{
            handleTabsScroll.clear();
        };
    }, [
        handleTabsScroll
    ]);
    $lx97N.useEffect(()=>{
        setMounted(true);
    }, []);
    $lx97N.useEffect(()=>{
        updateIndicatorState();
        updateScrollButtonState();
    });
    $lx97N.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($16f665bb55281646$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $lx97N.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $fRwNr.jsx)($16f665bb55281646$var$TabsIndicator, (0, $eR4tV.default)({}, TabIndicatorProps, {
        className: (0, $fmTP4.default)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $eR4tV.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $lx97N.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $lx97N.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $lx97N.cloneElement(child, (0, $eR4tV.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $8503c55da5b06e5f$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $16f665bb55281646$var$moveFocus(list, currentFocus, $16f665bb55281646$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $16f665bb55281646$var$moveFocus(list, currentFocus, $16f665bb55281646$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $16f665bb55281646$var$moveFocus(list, null, $16f665bb55281646$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $16f665bb55281646$var$moveFocus(list, null, $16f665bb55281646$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($16f665bb55281646$var$TabsRoot, (0, $eR4tV.default)({
        className: (0, $fmTP4.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $fRwNr.jsxs)($16f665bb55281646$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                onScroll: handleTabsScroll,
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)($16f665bb55281646$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $16f665bb55281646$export$2e2bcd8739ae039 = $16f665bb55281646$var$Tabs;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");


var $4BrfH = parcelRequire("4BrfH");

var $zetlx = parcelRequire("zetlx");

var $7Ys8f = parcelRequire("7Ys8f");


var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $22cb5a5a37324e12$export$72aef224d6115253(slot) {
    return (0, $h6nFM.default)('MuiTab', slot);
}
const $22cb5a5a37324e12$var$tabClasses = (0, $3OBXm.default)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $22cb5a5a37324e12$export$2e2bcd8739ae039 = $22cb5a5a37324e12$var$tabClasses;



var $fRwNr = parcelRequire("fRwNr");
const $ee037eba9a6f2690$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $ee037eba9a6f2690$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $4BrfH.default)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $22cb5a5a37324e12$export$72aef224d6115253), classes);
};
const $ee037eba9a6f2690$var$TabRoot = (0, $7Ys8f.default)((0, $efd008e102aecb23$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $4BrfH.default)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $22cb5a5a37324e12$export$2e2bcd8739ae039).iconWrapper}`]: (0, $eR4tV.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $22cb5a5a37324e12$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $22cb5a5a37324e12$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $22cb5a5a37324e12$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $22cb5a5a37324e12$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $22cb5a5a37324e12$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $22cb5a5a37324e12$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $ee037eba9a6f2690$var$Tab = /*#__PURE__*/ $lx97N.forwardRef(function Tab(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $hphT8.default)(props, $ee037eba9a6f2690$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $ee037eba9a6f2690$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $lx97N.isValidElement(iconProp) ? /*#__PURE__*/ $lx97N.cloneElement(iconProp, {
        className: (0, $fmTP4.default)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($ee037eba9a6f2690$var$TabRoot, (0, $eR4tV.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $fmTP4.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $ee037eba9a6f2690$export$2e2bcd8739ae039 = $ee037eba9a6f2690$var$Tab;





var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fQojQ = parcelRequire("fQojQ");

var $8zw8B = parcelRequire("8zw8B");

var $h6nFM = parcelRequire("h6nFM");

var $8o5tH = parcelRequire("8o5tH");

var $hLuFn = parcelRequire("hLuFn");
const $5e7b869f6ed8bc12$var$styled = (0, $hLuFn.default)();
var $5e7b869f6ed8bc12$export$2e2bcd8739ae039 = $5e7b869f6ed8bc12$var$styled;



var $3VxPf = parcelRequire("3VxPf");


var $jT8G1 = parcelRequire("jT8G1");

var $l5e2T = parcelRequire("l5e2T");

var $c5nRf = parcelRequire("c5nRf");

var $fRwNr = parcelRequire("fRwNr");
const $cd4168cbfcea9252$var$_excluded = [
    "component",
    "direction",
    "spacing",
    "divider",
    "children",
    "className",
    "useFlexGap"
];
const $cd4168cbfcea9252$var$defaultTheme = (0, $jT8G1.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $cd4168cbfcea9252$var$defaultCreateStyledComponent = (0, $5e7b869f6ed8bc12$export$2e2bcd8739ae039)('div', {
    name: 'MuiStack',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
});
function $cd4168cbfcea9252$var$useThemePropsDefault(props) {
    return (0, $3VxPf.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $cd4168cbfcea9252$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $cd4168cbfcea9252$var$joinChildren(children, separator) {
    const childrenArray = $lx97N.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $lx97N.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $cd4168cbfcea9252$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $cd4168cbfcea9252$export$1d567c320f4763bc = ({ ownerState: ownerState, theme: theme })=>{
    let styles = (0, $eR4tV.default)({
        display: 'flex',
        flexDirection: 'column'
    }, (0, $l5e2T.handleBreakpoints)({
        theme: theme
    }, (0, $l5e2T.resolveBreakpointValues)({
        values: ownerState.direction,
        breakpoints: theme.breakpoints.values
    }), (propValue)=>({
            flexDirection: propValue
        })));
    if (ownerState.spacing) {
        const transformer = (0, $c5nRf.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $l5e2T.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $l5e2T.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $c5nRf.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$cd4168cbfcea9252$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $c5nRf.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $8zw8B.default)(styles, (0, $l5e2T.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $l5e2T.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
function $cd4168cbfcea9252$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $cd4168cbfcea9252$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $cd4168cbfcea9252$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $8o5tH.default)(slots, (slot)=>(0, $h6nFM.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($cd4168cbfcea9252$export$1d567c320f4763bc);
    const Stack = /*#__PURE__*/ $lx97N.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const props = (0, $90f112fbce12cd6e$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false } = props, other = (0, $hphT8.default)(props, $cd4168cbfcea9252$var$_excluded);
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $fRwNr.jsx)(StackRoot, (0, $eR4tV.default)({
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $fQojQ.default)(classes.root, className)
        }, other, {
            children: divider ? $cd4168cbfcea9252$var$joinChildren(children, divider) : children
        }));
    });
    return Stack;
}



var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");
const $2f943f6b64633db4$var$Stack = (0, $cd4168cbfcea9252$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $7Ys8f.default)('div', {
        name: 'MuiStack',
        slot: 'Root',
        overridesResolver: (props, styles)=>styles.root
    }),
    useThemeProps: (inProps)=>(0, $zetlx.default)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $2f943f6b64633db4$export$2e2bcd8739ae039 = $2f943f6b64633db4$var$Stack;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $fMSjE = parcelRequire("fMSjE");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");


var $4BrfH = parcelRequire("4BrfH");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $e321bd9539f5312a$export$5e8702d71474f093(slot) {
    return (0, $h6nFM.default)('MuiIconButton', slot);
}
const $e321bd9539f5312a$var$iconButtonClasses = (0, $3OBXm.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $e321bd9539f5312a$export$2e2bcd8739ae039 = $e321bd9539f5312a$var$iconButtonClasses;



var $fRwNr = parcelRequire("fRwNr");
const $aad80e9a9c3e4c99$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $aad80e9a9c3e4c99$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $4BrfH.default)(color)}`,
            edge && `edge${(0, $4BrfH.default)(edge)}`,
            `size${(0, $4BrfH.default)(size)}`
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $e321bd9539f5312a$export$5e8702d71474f093), classes);
};
const $aad80e9a9c3e4c99$var$IconButtonRoot = (0, $7Ys8f.default)((0, $efd008e102aecb23$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $4BrfH.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $4BrfH.default)(ownerState.edge)}`],
            styles[`size${(0, $4BrfH.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fMSjE.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $eR4tV.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $eR4tV.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $eR4tV.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fMSjE.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $e321bd9539f5312a$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $aad80e9a9c3e4c99$var$IconButton = /*#__PURE__*/ $lx97N.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $hphT8.default)(props, $aad80e9a9c3e4c99$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $aad80e9a9c3e4c99$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($aad80e9a9c3e4c99$var$IconButtonRoot, (0, $eR4tV.default)({
        className: (0, $fmTP4.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children
    }));
});
var $aad80e9a9c3e4c99$export$2e2bcd8739ae039 = $aad80e9a9c3e4c99$var$IconButton;


var $702c5c85d45cae88$exports = {};
"use strict";

Object.defineProperty($702c5c85d45cae88$exports, "__esModule", {
    value: true
});
$702c5c85d45cae88$exports.default = void 0;

var $702c5c85d45cae88$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $702c5c85d45cae88$var$_default = (0, $702c5c85d45cae88$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
$702c5c85d45cae88$exports.default = $702c5c85d45cae88$var$_default;



var $lx97N = parcelRequire("lx97N");

var $4z7Fu = parcelRequire("4z7Fu");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $4BrfH = parcelRequire("4BrfH");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $91958d6999d9c9f9$export$24c1f8f60cbac79e(slot) {
    return (0, $h6nFM.default)('MuiTypography', slot);
}
const $91958d6999d9c9f9$var$typographyClasses = (0, $3OBXm.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $91958d6999d9c9f9$export$2e2bcd8739ae039 = $91958d6999d9c9f9$var$typographyClasses;



var $fRwNr = parcelRequire("fRwNr");
const $05476049bba0344f$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $05476049bba0344f$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $4BrfH.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $91958d6999d9c9f9$export$24c1f8f60cbac79e), classes);
};
const $05476049bba0344f$export$140e2f5526d3cad8 = (0, $7Ys8f.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $4BrfH.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        margin: 0
    }, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $05476049bba0344f$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $05476049bba0344f$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $05476049bba0344f$var$transformDeprecatedColors = (color)=>{
    return $05476049bba0344f$var$colorTransformations[color] || color;
};
const $05476049bba0344f$var$Typography = /*#__PURE__*/ $lx97N.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $05476049bba0344f$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $90f112fbce12cd6e$export$2e2bcd8739ae039)((0, $eR4tV.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $05476049bba0344f$var$defaultVariantMapping } = props, other = (0, $hphT8.default)(props, $05476049bba0344f$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $05476049bba0344f$var$defaultVariantMapping[variant]) || 'span';
    const classes = $05476049bba0344f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($05476049bba0344f$export$140e2f5526d3cad8, (0, $eR4tV.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $fmTP4.default)(classes.root, className)
    }, other));
});
var $05476049bba0344f$export$2e2bcd8739ae039 = $05476049bba0344f$var$Typography;



var $jZinT = parcelRequire("jZinT");

var $d9gj3 = parcelRequire("d9gj3");

var $l2Ecb = parcelRequire("l2Ecb");


var $fRwNr = parcelRequire("fRwNr");

var $3bGoE = parcelRequire("3bGoE");

var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $jZinT = parcelRequire("jZinT");

var $3bGoE = parcelRequire("3bGoE");

var $d9gj3 = parcelRequire("d9gj3");
var $lx97N = parcelRequire("lx97N");

var $5TEPR = parcelRequire("5TEPR");

var $cMUKM = parcelRequire("cMUKM");

var $eb2wJ = parcelRequire("eb2wJ");

var $bubCT = parcelRequire("bubCT");

var $SHyp9 = parcelRequire("SHyp9");
var $752b40ab4f3c0f58$var$_client, $752b40ab4f3c0f58$var$_currentResult, $752b40ab4f3c0f58$var$_currentMutation, $752b40ab4f3c0f58$var$_mutateOptions, $752b40ab4f3c0f58$var$_MutationObserver_instances, $752b40ab4f3c0f58$var$updateResult_fn, $752b40ab4f3c0f58$var$notify_fn;
var $752b40ab4f3c0f58$export$d3c1860ee66f291a = class extends (0, $bubCT.Subscribable) {
    constructor(client, options){
        super();
        (0, $5TEPR.__privateAdd)(this, $752b40ab4f3c0f58$var$_MutationObserver_instances);
        (0, $5TEPR.__privateAdd)(this, $752b40ab4f3c0f58$var$_client);
        (0, $5TEPR.__privateAdd)(this, $752b40ab4f3c0f58$var$_currentResult);
        (0, $5TEPR.__privateAdd)(this, $752b40ab4f3c0f58$var$_currentMutation);
        (0, $5TEPR.__privateAdd)(this, $752b40ab4f3c0f58$var$_mutateOptions);
        (0, $5TEPR.__privateSet)(this, $752b40ab4f3c0f58$var$_client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, $5TEPR.__privateMethod)(this, $752b40ab4f3c0f58$var$_MutationObserver_instances, $752b40ab4f3c0f58$var$updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_client).defaultMutationOptions(options);
        if (!(0, $SHyp9.shallowEqualObjects)(this.options, prevOptions)) (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, $SHyp9.hashKey)(prevOptions.mutationKey) !== (0, $SHyp9.hashKey)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, $5TEPR.__privateMethod)(this, $752b40ab4f3c0f58$var$_MutationObserver_instances, $752b40ab4f3c0f58$var$updateResult_fn).call(this);
        (0, $5TEPR.__privateMethod)(this, $752b40ab4f3c0f58$var$_MutationObserver_instances, $752b40ab4f3c0f58$var$notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentResult);
    }
    reset() {
        var _a;
        (_a = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $5TEPR.__privateSet)(this, $752b40ab4f3c0f58$var$_currentMutation, void 0);
        (0, $5TEPR.__privateMethod)(this, $752b40ab4f3c0f58$var$_MutationObserver_instances, $752b40ab4f3c0f58$var$updateResult_fn).call(this);
        (0, $5TEPR.__privateMethod)(this, $752b40ab4f3c0f58$var$_MutationObserver_instances, $752b40ab4f3c0f58$var$notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, $5TEPR.__privateSet)(this, $752b40ab4f3c0f58$var$_mutateOptions, options);
        (_a = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation)) == null || _a.removeObserver(this);
        (0, $5TEPR.__privateSet)(this, $752b40ab4f3c0f58$var$_currentMutation, (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_client).getMutationCache().build((0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_client), this.options));
        (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation).addObserver(this);
        return (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation).execute(variables);
    }
};
$752b40ab4f3c0f58$var$_client = new WeakMap();
$752b40ab4f3c0f58$var$_currentResult = new WeakMap();
$752b40ab4f3c0f58$var$_currentMutation = new WeakMap();
$752b40ab4f3c0f58$var$_mutateOptions = new WeakMap();
$752b40ab4f3c0f58$var$_MutationObserver_instances = new WeakSet();
$752b40ab4f3c0f58$var$updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentMutation)) == null ? void 0 : _a.state) ?? (0, $cMUKM.getDefaultState)();
    (0, $5TEPR.__privateSet)(this, $752b40ab4f3c0f58$var$_currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
$752b40ab4f3c0f58$var$notify_fn = function(action) {
    (0, $eb2wJ.notifyManager).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_mutateOptions) && this.hasListeners()) {
            const variables = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentResult).variables;
            const context = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentResult).context;
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, context);
                (_d = (_c = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_mutateOptions)).onError) == null || _f.call(_e, action.error, variables, context);
                (_h = (_g = (0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, $5TEPR.__privateGet)(this, $752b40ab4f3c0f58$var$_currentResult));
        });
    });
};


var $SHyp9 = parcelRequire("SHyp9");
var $eb2wJ = parcelRequire("eb2wJ");

var $k4snv = parcelRequire("k4snv");
"use client";
function $7fb27f6f38aaafef$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $k4snv.useQueryClient)(queryClient);
    const [observer] = $lx97N.useState(()=>new (0, $752b40ab4f3c0f58$export$d3c1860ee66f291a)(client, options));
    $lx97N.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $lx97N.useSyncExternalStore($lx97N.useCallback((onStoreChange)=>observer.subscribe((0, $eb2wJ.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $lx97N.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $SHyp9.noop));
    }, [
        observer
    ]);
    if (result.error && (0, $SHyp9.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}


var $EuolY = parcelRequire("EuolY");
var $k4snv = parcelRequire("k4snv");

var $d9gj3 = parcelRequire("d9gj3");

var $37w0r = parcelRequire("37w0r");

var $lx97N = parcelRequire("lx97N");
function $4c2764743176540f$export$bbd7d970555e2952() {
    return (0, $EuolY.useQuery)({
        queryKey: [
            'preferences'
        ],
        async queryFn () {
            try {
                const { data: data } = await (0, $d9gj3.getQepSystem)().container.config.getPreference();
                return data;
            } catch (error) {
                (0, $d9gj3.getQepSystem)().notification.local.error(error);
                throw error;
            }
        }
    });
}
function $4c2764743176540f$export$7b8091fb31b80ed6(key) {
    const preferences = $4c2764743176540f$export$bbd7d970555e2952();
    const preference = preferences.data ? preferences.data[key] : undefined;
    return {
        ...preferences,
        preference: preference
    };
}
function $4c2764743176540f$export$8b52da386ffd1e1f() {
    const queryClient = (0, $k4snv.useQueryClient)();
    return (0, $lx97N.useCallback)(async ()=>queryClient.invalidateQueries({
            queryKey: [
                'preferences'
            ]
        }), [
        queryClient
    ]);
}
function $4c2764743176540f$export$f21c408c0e7893f(key) {
    const queryClient = (0, $k4snv.useQueryClient)();
    const successNotificationRef = (0, $lx97N.useRef)();
    (0, $lx97N.useEffect)(()=>()=>{
            successNotificationRef.current?.cancel();
            successNotificationRef.current = undefined;
        }, []);
    const notifySuccess = (message)=>{
        successNotificationRef.current ??= (0, $37w0r.debounce)((successMessage)=>{
            (0, $d9gj3.getQepSystem)().notification.local.success(successMessage);
        }, 700);
        successNotificationRef.current(message);
    };
    return (0, $7fb27f6f38aaafef$export$609860bf8b0084c)({
        async mutationFn (value) {
            return new Promise((resolve, reject)=>{
                (0, $d9gj3.getQepSystem)().container.config.setPreference({
                    field: key,
                    value: value
                }, (error, result)=>{
                    if (error) {
                        (0, $d9gj3.getQepSystem)().notification.local.error(error);
                        reject(error);
                        return;
                    }
                    notifySuccess('Preference updated successfully');
                    queryClient.setQueryData([
                        'preferences'
                    ], (_old)=>result);
                    resolve(result);
                });
            });
        },
        async onMutate (value) {
            await queryClient.cancelQueries({
                queryKey: [
                    'preferences'
                ]
            });
            const previous = queryClient.getQueryData([
                'preferences'
            ]);
            queryClient.setQueryData([
                'preferences'
            ], (old)=>({
                    ...old,
                    [key]: value
                }));
            return {
                previous: previous
            };
        },
        onError (error, _variables, context) {
            queryClient.setQueryData([
                'preferences'
            ], context?.previous);
            (0, $d9gj3.getQepSystem)().notification.local.error(error);
        }
    });
}



var $fRwNr = parcelRequire("fRwNr");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $9Hxe6 = parcelRequire("9Hxe6");

var $4BrfH = parcelRequire("4BrfH");

var $zetlx = parcelRequire("zetlx");

var $7Ys8f = parcelRequire("7Ys8f");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $ee1fe93cb956052b$export$29cad1383b3f235d(slot) {
    return (0, $h6nFM.default)('MuiCircularProgress', slot);
}
const $ee1fe93cb956052b$var$circularProgressClasses = (0, $3OBXm.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $ee1fe93cb956052b$export$2e2bcd8739ae039 = $ee1fe93cb956052b$var$circularProgressClasses;



var $fRwNr = parcelRequire("fRwNr");
const $700f8a41bf2e5737$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $700f8a41bf2e5737$var$_ = (t)=>t, $700f8a41bf2e5737$var$_t, $700f8a41bf2e5737$var$_t2, $700f8a41bf2e5737$var$_t3, $700f8a41bf2e5737$var$_t4;
const $700f8a41bf2e5737$var$SIZE = 44;
const $700f8a41bf2e5737$var$circularRotateKeyframe = (0, $9Hxe6.keyframes)($700f8a41bf2e5737$var$_t || ($700f8a41bf2e5737$var$_t = $700f8a41bf2e5737$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $700f8a41bf2e5737$var$circularDashKeyframe = (0, $9Hxe6.keyframes)($700f8a41bf2e5737$var$_t2 || ($700f8a41bf2e5737$var$_t2 = $700f8a41bf2e5737$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $700f8a41bf2e5737$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $4BrfH.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $4BrfH.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $ee1fe93cb956052b$export$29cad1383b3f235d), classes);
};
const $700f8a41bf2e5737$var$CircularProgressRoot = (0, $7Ys8f.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $4BrfH.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eR4tV.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $9Hxe6.css)($700f8a41bf2e5737$var$_t3 || ($700f8a41bf2e5737$var$_t3 = $700f8a41bf2e5737$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $700f8a41bf2e5737$var$circularRotateKeyframe));
const $700f8a41bf2e5737$var$CircularProgressSVG = (0, $7Ys8f.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $700f8a41bf2e5737$var$CircularProgressCircle = (0, $7Ys8f.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $4BrfH.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $eR4tV.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $9Hxe6.css)($700f8a41bf2e5737$var$_t4 || ($700f8a41bf2e5737$var$_t4 = $700f8a41bf2e5737$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $700f8a41bf2e5737$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $700f8a41bf2e5737$var$CircularProgress = /*#__PURE__*/ $lx97N.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $hphT8.default)(props, $700f8a41bf2e5737$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $700f8a41bf2e5737$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($700f8a41bf2e5737$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $fRwNr.jsx)($700f8a41bf2e5737$var$CircularProgressRoot, (0, $eR4tV.default)({
        className: (0, $fmTP4.default)(classes.root, className),
        style: (0, $eR4tV.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($700f8a41bf2e5737$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$700f8a41bf2e5737$var$SIZE / 2} ${$700f8a41bf2e5737$var$SIZE / 2} ${$700f8a41bf2e5737$var$SIZE} ${$700f8a41bf2e5737$var$SIZE}`,
            children: /*#__PURE__*/ (0, $fRwNr.jsx)($700f8a41bf2e5737$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $700f8a41bf2e5737$var$SIZE,
                cy: $700f8a41bf2e5737$var$SIZE,
                r: ($700f8a41bf2e5737$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $700f8a41bf2e5737$export$2e2bcd8739ae039 = $700f8a41bf2e5737$var$CircularProgress;



function $f0467d39715594a4$export$7c20be4c1d342248() {
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "loading-indicator",
        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $700f8a41bf2e5737$export$2e2bcd8739ae039), {
            size: 75
        })
    });
}



var $5Wk8r = parcelRequire("5Wk8r");
const $91046a48017d37a4$export$f5d8f10e3125d1a3 = (0, $5Wk8r.createAction)('qepPreferences/setDefaultAlgoDuration');



const $430c28a06e15e22f$var$defaultAlgoDurationMinutes = 15;
const $430c28a06e15e22f$var$minAlgoDurationMinutes = 1;
const $430c28a06e15e22f$var$maxAlgoDurationMinutes = 420;
const $430c28a06e15e22f$var$invalidAlgoDurationMessage = 'Algo duration is invalid';
/** Parses a candidate default algo duration when it is a whole minute count inside the supported seven-hour range. */ function $430c28a06e15e22f$var$parseValidDefaultAlgoDuration(value) {
    const trimmedValue = value.trim();
    if (!/^\d+$/.test(trimmedValue)) return undefined;
    const duration = Number(trimmedValue);
    return Number.isInteger(duration) && duration >= $430c28a06e15e22f$var$minAlgoDurationMinutes && duration <= $430c28a06e15e22f$var$maxAlgoDurationMinutes ? duration : undefined;
}
/** Converts primitive preference payloads to strings while treating unsupported stored shapes as invalid input. */ function $430c28a06e15e22f$var$stringifyDefaultAlgoDuration(rawValue) {
    if (rawValue === null || rawValue === undefined) return String($430c28a06e15e22f$var$defaultAlgoDurationMinutes);
    return typeof rawValue === 'number' || typeof rawValue === 'string' ? String(rawValue) : '';
}
/** Converts saved preference data into the controlled input value, falling back to the product default for invalid stored data. */ function $430c28a06e15e22f$var$normalizeLoadedDefaultAlgoDuration(rawValue) {
    const parsedDuration = $430c28a06e15e22f$var$parseValidDefaultAlgoDuration($430c28a06e15e22f$var$stringifyDefaultAlgoDuration(rawValue));
    return String(parsedDuration ?? $430c28a06e15e22f$var$defaultAlgoDurationMinutes);
}
/** Resolves user-entered input to the value that may be persisted, using 15 for blank or zero per Preferences behavior. */ function $430c28a06e15e22f$var$resolveDefaultAlgoDurationForSave(value) {
    const trimmedValue = value.trim();
    if (trimmedValue === '' || trimmedValue === '0') return $430c28a06e15e22f$var$defaultAlgoDurationMinutes;
    return $430c28a06e15e22f$var$parseValidDefaultAlgoDuration(trimmedValue);
}
/** Renders QEP preferences and keeps the default algo duration within the range Order Entry supports. */ const $430c28a06e15e22f$var$qepPrefs = ()=>{
    const { data: data, isFetching: isFetching } = (0, $4c2764743176540f$export$bbd7d970555e2952)();
    const dispatch = (0, $3bGoE.useDispatch)();
    const selectedDefaultAlgoDuration = (0, $3bGoE.useSelector)((state)=>state.qepPreferencesReducer.defaultAlgoDuration);
    const [hasError, setHasError] = (0, $lx97N.useState)(false);
    const [localValue, setLocalValue] = (0, $lx97N.useState)('');
    const [revertValue, setRevertValue] = (0, $lx97N.useState)(String($430c28a06e15e22f$var$defaultAlgoDurationMinutes));
    const timeoutRef = (0, $lx97N.useRef)(null);
    (0, $lx97N.useEffect)(()=>{
        if (isFetching) return;
        const finalValue = $430c28a06e15e22f$var$normalizeLoadedDefaultAlgoDuration(data?.['qep.defaultAlgoDuration']);
        const numericFinal = Number(finalValue);
        dispatch((0, $91046a48017d37a4$export$f5d8f10e3125d1a3)({
            duration: numericFinal,
            initialLoad: true
        }));
        setLocalValue(finalValue);
        setRevertValue(finalValue);
    }, [
        data,
        dispatch,
        isFetching
    ]);
    const handleSave = (valueToSave = localValue)=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        const durationToSave = $430c28a06e15e22f$var$resolveDefaultAlgoDurationForSave(valueToSave);
        if (durationToSave === undefined) {
            setHasError(true);
            setLocalValue(revertValue);
            (0, $d9gj3.getQepSystem)().notification.local.error($430c28a06e15e22f$var$invalidAlgoDurationMessage);
            return;
        }
        const nextValue = String(durationToSave);
        if (localValue !== nextValue) setLocalValue(nextValue);
        setRevertValue(nextValue);
        if (durationToSave !== selectedDefaultAlgoDuration) dispatch((0, $91046a48017d37a4$export$f5d8f10e3125d1a3)({
            duration: durationToSave
        }));
        setHasError(false);
    };
    const hasData = selectedDefaultAlgoDuration !== null && selectedDefaultAlgoDuration !== undefined;
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "qep-preferences",
        children: isFetching || !hasData ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f0467d39715594a4$export$7c20be4c1d342248), {}) : /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsx)("label", {
                    children: "Default Algo Duration (in minutes)"
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $jZinT.QEPInput), {
                    className: hasError ? 'error' : '',
                    type: "number",
                    value: localValue,
                    placeholder: String($430c28a06e15e22f$var$defaultAlgoDurationMinutes),
                    min: $430c28a06e15e22f$var$minAlgoDurationMinutes,
                    max: $430c28a06e15e22f$var$maxAlgoDurationMinutes,
                    step: 1,
                    onFocus: (event)=>{
                        event.target.select();
                    },
                    onKeyDown: (event)=>{
                        if (event.key === 'Enter') handleSave();
                        else if (event.key === 'Escape') {
                            setLocalValue(revertValue);
                            setHasError(false);
                        }
                    },
                    onBlur: (event)=>{
                        const { value: value, validity: validity } = event.target;
                        if (validity.badInput || !/^\d*$/.test(value)) {
                            setHasError(true);
                            (0, $d9gj3.getQepSystem)().notification.local.error($430c28a06e15e22f$var$invalidAlgoDurationMessage);
                            return;
                        }
                        handleSave(value);
                    },
                    onChange: (event)=>{
                        const { value: value, validity: validity } = event.target;
                        if (validity.badInput || !/^\d*$/.test(value)) return;
                        const durationToSave = $430c28a06e15e22f$var$resolveDefaultAlgoDurationForSave(value);
                        if (durationToSave === undefined) return;
                        if (value === '0') {
                            handleSave(String($430c28a06e15e22f$var$defaultAlgoDurationMinutes));
                            return;
                        }
                        const nextValue = value === '' ? value : String(durationToSave);
                        setLocalValue(nextValue);
                        setHasError(false);
                        if (timeoutRef.current) clearTimeout(timeoutRef.current);
                        if (nextValue !== '') timeoutRef.current = setTimeout(()=>{
                            handleSave(nextValue);
                        }, 700);
                    }
                })
            ]
        })
    });
};
var $430c28a06e15e22f$export$2e2bcd8739ae039 = $430c28a06e15e22f$var$qepPrefs;


/* v8 ignore start */ 
var $5Wk8r = parcelRequire("5Wk8r");


var $d9gj3 = parcelRequire("d9gj3");

const $13862b5b013dd4b3$var$defaultQepPreferencesState = {
    defaultAlgoDuration: 15
};
const $13862b5b013dd4b3$var$initialState = $13862b5b013dd4b3$var$defaultQepPreferencesState;
let $13862b5b013dd4b3$var$debounceSuccessNotif;
const $13862b5b013dd4b3$export$e4fa0fd9bfe5af18 = (0, $5Wk8r.createReducer)($13862b5b013dd4b3$var$initialState, (builder)=>{
    builder.addCase((0, $91046a48017d37a4$export$f5d8f10e3125d1a3), (state, action)=>{
        state.defaultAlgoDuration = action.payload.duration;
        if (action.payload.initialLoad) return;
        (0, $d9gj3.getQepSystem)().container.config.setPreference({
            field: 'qep.defaultAlgoDuration',
            value: action.payload.duration
        }, (error, _response)=>{
            if (error) {
                (0, $d9gj3.getQepSystem)().notification.local.error(error);
                return;
            }
            $13862b5b013dd4b3$var$debounceSuccessNotif ||= (0, $969260a3a3554a15$export$2e2bcd8739ae039)((0, $d9gj3.getQepSystem)().notification.local.success, 700);
            $13862b5b013dd4b3$var$debounceSuccessNotif('Default algo duration updated successfully');
        });
    });
});
const $13862b5b013dd4b3$export$6f57813fe9f31bf9 = (0, $5Wk8r.configureStore)({
    reducer: {
        qepPreferencesReducer: $13862b5b013dd4b3$export$e4fa0fd9bfe5af18
    }
});


 /* v8 ignore stop */ 

const $e5c0e727af7c8f5f$var$QepUserPreferences = ()=>/*#__PURE__*/ (0, $fRwNr.jsx)((0, $3bGoE.Provider), {
        store: (0, $13862b5b013dd4b3$export$6f57813fe9f31bf9),
        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $430c28a06e15e22f$export$2e2bcd8739ae039), {})
    });
var $e5c0e727af7c8f5f$export$2e2bcd8739ae039 = $e5c0e727af7c8f5f$var$QepUserPreferences;



var $fRwNr = parcelRequire("fRwNr");

var $3bGoE = parcelRequire("3bGoE");

var $fRwNr = parcelRequire("fRwNr");

var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");

var $4RND8 = parcelRequire("4RND8");
var $70a7e71b10be4ef0$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $70a7e71b10be4ef0$var$_extends() {
    return $70a7e71b10be4ef0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $70a7e71b10be4ef0$var$_extends.apply(null, arguments);
}
function $70a7e71b10be4ef0$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $70a7e71b10be4ef0$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $70a7e71b10be4ef0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $70a7e71b10be4ef0$var$Search = /*#__PURE__*/ (0, $lx97N.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $70a7e71b10be4ef0$var$_objectWithoutProperties(_ref, $70a7e71b10be4ef0$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("svg", $70a7e71b10be4ef0$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-search',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("path", {
        d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
    }));
});
$70a7e71b10be4ef0$var$Search.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string
};
var $70a7e71b10be4ef0$export$2e2bcd8739ae039 = $70a7e71b10be4ef0$var$Search;


var $lx97N = parcelRequire("lx97N");

var $4RND8 = parcelRequire("4RND8");
var $5a9634875c1ae04e$var$_excluded = [
    "color",
    "size",
    "title",
    "className"
];
function $5a9634875c1ae04e$var$_extends() {
    return $5a9634875c1ae04e$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a9634875c1ae04e$var$_extends.apply(null, arguments);
}
function $5a9634875c1ae04e$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $5a9634875c1ae04e$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $5a9634875c1ae04e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5a9634875c1ae04e$var$XLg = /*#__PURE__*/ (0, $lx97N.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? '1em' : _ref$size, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$className = _ref.className, className = _ref$className === void 0 ? '' : _ref$className, rest = $5a9634875c1ae04e$var$_objectWithoutProperties(_ref, $5a9634875c1ae04e$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("svg", $5a9634875c1ae04e$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        width: size,
        height: size,
        fill: color,
        className: [
            'bi',
            'bi-x-lg',
            className
        ].filter(Boolean).join(' ')
    }, rest), title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("title", null, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement("path", {
        d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
    }));
});
$5a9634875c1ae04e$var$XLg.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).number
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string
};
var $5a9634875c1ae04e$export$2e2bcd8739ae039 = $5a9634875c1ae04e$var$XLg;



var $jZinT = parcelRequire("jZinT");

function $cdd1b1ae4a2957eb$export$a345fca6f7b09bfb({ search: search = '', placeholder: placeholder, className: className, onChange: onChange, onClear: onClear, shouldReset: shouldReset = false }) {
    const inputField = (0, $lx97N.useRef)(null);
    const [searchTerm, setSearchTerm] = (0, $lx97N.useState)(search);
    const handleClear = (e)=>{
        setSearchTerm('');
        onClear(e);
    };
    (0, $lx97N.useEffect)(()=>{
        if (shouldReset) handleClear();
    }, [
        shouldReset
    ]);
    (0, $lx97N.useEffect)(()=>{
        onChange(searchTerm);
    }, [
        onChange,
        searchTerm
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        className: `qep-searchfield ${className}`,
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $70a7e71b10be4ef0$export$2e2bcd8739ae039), {
                className: "overlay-icons left"
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $jZinT.QEPInput), {
                ref: inputField,
                className: "prepend-icon",
                value: searchTerm,
                type: "text",
                placeholder: placeholder,
                onChange: (e)=>{
                    setSearchTerm(e.target.value);
                }
            }),
            searchTerm && /*#__PURE__*/ (0, $fRwNr.jsx)((0, $5a9634875c1ae04e$export$2e2bcd8739ae039), {
                className: "overlay-icons right clear",
                onClick: handleClear
            })
        ]
    });
}



var $lx97N = parcelRequire("lx97N");

var $3bGoE = parcelRequire("3bGoE");

/** Owns Trade Products preference loading and ordered persistence into the shared defaults API. */ 
var $5Wk8r = parcelRequire("5Wk8r");

var $d9gj3 = parcelRequire("d9gj3");
var $9vFCJ = parcelRequire("9vFCJ");

var $l2Ecb = parcelRequire("l2Ecb");
const $06537821e73c7d3c$var$defaultDefaultPreferencesState = {
    fetchedAccounts: false,
    fetchedProducts: false,
    accounts: [],
    products: []
};
const $06537821e73c7d3c$var$initialState = $06537821e73c7d3c$var$defaultDefaultPreferencesState;
const $06537821e73c7d3c$export$212bb2fc580a90a8 = (0, $5Wk8r.createAsyncThunk)('getDefaults', async ()=>(0, $d9gj3.getQepSystem)().apiServices.defaults.getDefaults());
const $06537821e73c7d3c$export$d5d451a14adbc067 = (0, $5Wk8r.createAsyncThunk)('getAccounts', async ()=>{
    const accounts = await (0, $9vFCJ.getUserAccountsFromTraderDB)();
    return accounts;
});
const $06537821e73c7d3c$var$persistDefaults = (0, $5Wk8r.createAsyncThunk)('setDefaults', async (products)=>{
    const qepSystem = (0, $d9gj3.getQepSystem)();
    if (!qepSystem?.apiServices?.defaults?.setDefaults) throw new Error('setDefaults API method not available');
    return qepSystem.apiServices.defaults.setDefaults(products);
});
const $06537821e73c7d3c$export$9cf58ddd33ee79a8 = (0, $5Wk8r.createReducer)($06537821e73c7d3c$var$initialState, (builder)=>{
    builder.addCase($06537821e73c7d3c$export$212bb2fc580a90a8.fulfilled, (state, { payload: payload })=>{
        state.products = payload;
        state.fetchedProducts = true;
    }).addCase($06537821e73c7d3c$export$212bb2fc580a90a8.rejected, (state)=>{
        state.fetchedProducts = true;
    }).addCase($06537821e73c7d3c$export$d5d451a14adbc067.fulfilled, (state, { payload: payload })=>{
        state.accounts = payload;
        state.fetchedAccounts = true;
    }).addCase($06537821e73c7d3c$export$d5d451a14adbc067.rejected, (state)=>{
        state.fetchedAccounts = true;
    }).addCase($06537821e73c7d3c$var$persistDefaults.fulfilled, (state, { payload: payload })=>{
        if (payload.products) state.products = payload.products;
    });
});
const $06537821e73c7d3c$var$reducer = {
    defaultsPreferencesReducer: $06537821e73c7d3c$export$9cf58ddd33ee79a8
};
const $06537821e73c7d3c$var$isDevToolsEnabled = (0, $l2Ecb.getAppEnv)() !== 'production' && (0, $l2Ecb.getAppEnv)() !== 'preprod';
function $06537821e73c7d3c$export$c1554632bcaa6ca8() {
    return (0, $5Wk8r.configureStore)({
        reducer: $06537821e73c7d3c$var$reducer,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware({
                serializableCheck: false
            }),
        devTools: $06537821e73c7d3c$var$isDevToolsEnabled,
        preloadedState: {}
    });
}
const $06537821e73c7d3c$export$fc32eaa55249941f = $06537821e73c7d3c$export$c1554632bcaa6ca8();
/** Returns the stable API product key used to locate one authoritative product. */ function $06537821e73c7d3c$var$getProductKey(product) {
    return `${product.rootSymbol}\\${product.segmentMic}`;
}
/** Normalizes optional product fields into the complete defaults persistence payload. */ function $06537821e73c7d3c$var$buildProductDefault(product) {
    return {
        accountId: product.defaultAccount ?? '',
        icebergDisplayQty: typeof product.icebergDisplayQty === 'number' && Number.isFinite(product.icebergDisplayQty) ? product.icebergDisplayQty : 0,
        isAcctSetByUser: product.acctSetByUser ?? false,
        isIceberg: product.isIceberg ?? false,
        isQtySetByUser: product.qtySetByUser ?? false,
        product: $06537821e73c7d3c$var$getProductKey(product),
        qty: product.defaultQty ?? 0
    };
}
/** Applies one UI change intent to the latest product without replacing unrelated defaults fields. */ function $06537821e73c7d3c$var$applyProductDefaultChange(product, change) {
    const productDefault = $06537821e73c7d3c$var$buildProductDefault(product);
    switch(change.kind){
        case 'account':
            return {
                ...productDefault,
                accountId: change.value,
                isAcctSetByUser: true
            };
        case 'displayQuantity':
            return {
                ...productDefault,
                icebergDisplayQty: change.value
            };
        case 'iceberg':
            return {
                ...productDefault,
                icebergDisplayQty: change.value ? productDefault.icebergDisplayQty : 0,
                isIceberg: change.value
            };
        case 'quantity':
            return {
                ...productDefault,
                isQtySetByUser: true,
                qty: change.value
            };
    }
}
function $06537821e73c7d3c$export$162d8a29fc03fc4d() {
    let queueTail = Promise.resolve();
    /** Queues one field-level change and resolves with its authoritative defaults response. */ return (change)=>async (dispatch, getState)=>{
            const previousOperation = queueTail;
            let releaseQueue;
            queueTail = new Promise((resolve)=>{
                releaseQueue = resolve;
            });
            await previousOperation;
            try {
                const product = getState().defaultsPreferencesReducer.products.find((candidate)=>$06537821e73c7d3c$var$getProductKey(candidate) === change.product);
                if (!product) throw new Error(`Cannot update defaults for unavailable product ${change.product}`);
                const response = await dispatch($06537821e73c7d3c$var$persistDefaults([
                    $06537821e73c7d3c$var$applyProductDefaultChange(product, change)
                ])).unwrap();
                await (0, $d9gj3.getQepSystem)().container.applicationClient.broadcast('defaults_updated', response.products);
                return response;
            } finally{
                releaseQueue();
            }
        };
}
const $06537821e73c7d3c$export$f1052df5e0b37e05 = $06537821e73c7d3c$export$162d8a29fc03fc4d();



var $fRwNr = parcelRequire("fRwNr");

var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $eR4tV = parcelRequire("eR4tV");


var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");




parcelRequire("lx97N");

function $fb0021de13c3a756$export$2e2bcd8739ae039() {
    var theme = (0, $fe3cbcbcc4b394ba$export$2e2bcd8739ae039)() || (0, $843a8f57ee0b12dc$export$2e2bcd8739ae039);
    return theme;
}


var $64f24436fd4c18e5$var$TRANSITION_DURATION = 4; // seconds
var $64f24436fd4c18e5$export$9dd6ff9ea0189349 = function styles(theme) {
    var getColor = function getColor(color) {
        return theme.palette.type === 'light' ? (0, $65a40c6bd53abec5$export$c0816ed86df316af)(color, 0.62) : (0, $65a40c6bd53abec5$export$4b073707ff63303)(color, 0.5);
    };
    var backgroundPrimary = getColor(theme.palette.primary.main);
    var backgroundSecondary = getColor(theme.palette.secondary.main);
    return {
        /* Styles applied to the root element. */ root: {
            position: 'relative',
            overflow: 'hidden',
            height: 4,
            '@media print': {
                colorAdjust: 'exact'
            }
        },
        /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */ colorPrimary: {
            backgroundColor: backgroundPrimary
        },
        /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */ colorSecondary: {
            backgroundColor: backgroundSecondary
        },
        /* Styles applied to the root element if `variant="determinate"`. */ determinate: {},
        /* Styles applied to the root element if `variant="indeterminate"`. */ indeterminate: {},
        /* Styles applied to the root element if `variant="buffer"`. */ buffer: {
            backgroundColor: 'transparent'
        },
        /* Styles applied to the root element if `variant="query"`. */ query: {
            transform: 'rotate(180deg)'
        },
        /* Styles applied to the additional bar element if `variant="buffer"`. */ dashed: {
            position: 'absolute',
            marginTop: 0,
            height: '100%',
            width: '100%',
            animation: '$buffer 3s infinite linear'
        },
        /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */ dashedColorPrimary: {
            backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
            backgroundSize: '10px 10px',
            backgroundPosition: '0 -23px'
        },
        /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */ dashedColorSecondary: {
            backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
            backgroundSize: '10px 10px',
            backgroundPosition: '0 -23px'
        },
        /* Styles applied to the layered bar1 and bar2 elements. */ bar: {
            width: '100%',
            position: 'absolute',
            left: 0,
            bottom: 0,
            top: 0,
            transition: 'transform 0.2s linear',
            transformOrigin: 'left'
        },
        /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */ barColorPrimary: {
            backgroundColor: theme.palette.primary.main
        },
        /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */ barColorSecondary: {
            backgroundColor: theme.palette.secondary.main
        },
        /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */ bar1Indeterminate: {
            width: 'auto',
            animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
        },
        /* Styles applied to the bar1 element if `variant="determinate"`. */ bar1Determinate: {
            transition: "transform .".concat($64f24436fd4c18e5$var$TRANSITION_DURATION, "s linear")
        },
        /* Styles applied to the bar1 element if `variant="buffer"`. */ bar1Buffer: {
            zIndex: 1,
            transition: "transform .".concat($64f24436fd4c18e5$var$TRANSITION_DURATION, "s linear")
        },
        /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */ bar2Indeterminate: {
            width: 'auto',
            animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
        },
        /* Styles applied to the bar2 element if `variant="buffer"`. */ bar2Buffer: {
            transition: "transform .".concat($64f24436fd4c18e5$var$TRANSITION_DURATION, "s linear")
        },
        // Legends:
        // || represents the viewport
        // -  represents a light background
        // x  represents a dark background
        '@keyframes indeterminate1': {
            //  |-----|---x-||-----||-----|
            '0%': {
                left: '-35%',
                right: '100%'
            },
            //  |-----|-----||-----||xxxx-|
            '60%': {
                left: '100%',
                right: '-90%'
            },
            '100%': {
                left: '100%',
                right: '-90%'
            }
        },
        '@keyframes indeterminate2': {
            //  |xxxxx|xxxxx||-----||-----|
            '0%': {
                left: '-200%',
                right: '100%'
            },
            //  |-----|-----||-----||-x----|
            '60%': {
                left: '107%',
                right: '-8%'
            },
            '100%': {
                left: '107%',
                right: '-8%'
            }
        },
        '@keyframes buffer': {
            '0%': {
                opacity: 1,
                backgroundPosition: '0 -23px'
            },
            '50%': {
                opacity: 0,
                backgroundPosition: '0 -23px'
            },
            '100%': {
                opacity: 1,
                backgroundPosition: '-200px -23px'
            }
        }
    };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var $64f24436fd4c18e5$var$LinearProgress = /*#__PURE__*/ $lx97N.forwardRef(function LinearProgress(props, ref) {
    var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? 'primary' : _props$color, value = props.value, valueBuffer = props.valueBuffer, _props$variant = props.variant, variant = _props$variant === void 0 ? 'indeterminate' : _props$variant, other = (0, $c6acedbaaa8a0e98$export$2e2bcd8739ae039)(props, [
        "classes",
        "className",
        "color",
        "value",
        "valueBuffer",
        "variant"
    ]);
    var theme = (0, $fb0021de13c3a756$export$2e2bcd8739ae039)();
    var rootProps = {};
    var inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            var transform = value - 100;
            if (theme.direction === 'rtl') transform = -transform;
            inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            var _transform = (valueBuffer || 0) - 100;
            if (theme.direction === 'rtl') _transform = -_transform;
            inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
        }
    }
    return /*#__PURE__*/ $lx97N.createElement("div", (0, $eR4tV.default)({
        className: (0, $fmTP4.default)(classes.root, classes["color".concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(color))], className, {
            'determinate': classes.determinate,
            'indeterminate': classes.indeterminate,
            'buffer': classes.buffer,
            'query': classes.query
        }[variant]),
        role: "progressbar"
    }, rootProps, {
        ref: ref
    }, other), variant === 'buffer' ? /*#__PURE__*/ $lx97N.createElement("div", {
        className: (0, $fmTP4.default)(classes.dashed, classes["dashedColor".concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(color))])
    }) : null, /*#__PURE__*/ $lx97N.createElement("div", {
        className: (0, $fmTP4.default)(classes.bar, classes["barColor".concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
            'determinate': classes.bar1Determinate,
            'buffer': classes.bar1Buffer
        }[variant]),
        style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/ $lx97N.createElement("div", {
        className: (0, $fmTP4.default)(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [
            classes["color".concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(color))],
            classes.bar2Buffer
        ] : classes["barColor".concat((0, $cb77ab8202ccfa22$export$2e2bcd8739ae039)(color))]),
        style: inlineStyles.bar2
    }));
});
var $64f24436fd4c18e5$export$2e2bcd8739ae039 = (0, $766b7176cd69abd5$export$2e2bcd8739ae039)($64f24436fd4c18e5$export$9dd6ff9ea0189349, {
    name: 'MuiLinearProgress'
})($64f24436fd4c18e5$var$LinearProgress);



var $9vFCJ = parcelRequire("9vFCJ");

var $cckdX = parcelRequire("cckdX");
const $1e9c2f618fcdc64e$export$335bcbd9927bb4bb = (accounts, accountId)=>{
    let traderDbAccount = accounts.find((acc)=>acc.id === accountId);
    if (!traderDbAccount && accounts[0].id.includes('-')) {
        console.warn('WARNING: Account IDs contain dashes but old saved defaults do not. This is a dangerous comparison');
        traderDbAccount = accounts.find((acc)=>acc.id.replaceAll('-', '') === accountId);
    }
    if (traderDbAccount) {
        const tradingAccount = {
            accountId: traderDbAccount?.neovestAccount,
            id: traderDbAccount.id,
            tradeIntentionId: traderDbAccount.tradeIntentions.length > 0 ? traderDbAccount.tradeIntentions[0].id : '',
            execCode: traderDbAccount?.code,
            accountCode: traderDbAccount?.code,
            description: traderDbAccount?.description,
            memo: traderDbAccount.memo || '',
            clearingString: traderDbAccount?.clearingString,
            notes: [
                traderDbAccount.tradeIntentions[0]?.tradeIntentionName || '',
                traderDbAccount.customText2 || '',
                traderDbAccount.customText3 || ''
            ],
            products: traderDbAccount?.productSpecifications.map((product)=>product.symbol)
        };
        return tradingAccount;
    }
};
const $1e9c2f618fcdc64e$export$c7104f5acad85356 = (accounts, symbol)=>{
    const { segmentMic: segmentMic } = symbol;
    const rootSymbol = symbol.secType === (0, $cckdX.SecurityTypes).Option ? symbol.underlyingRootSymbol ?? symbol.rootSymbol : symbol.rootSymbol;
    const results = accounts.filter((acc)=>{
        const result = acc.productSpecifications?.find((spec)=>spec.symbol === rootSymbol && spec.exchangeName === segmentMic);
        return Boolean(result);
    });
    return results;
};


const $876528fe07563bf3$export$139cde87e304488d = (account)=>{
    const accountSelect = {
        account: account,
        memo: account.memo,
        tradeIntention: account.tradeIntentions[0],
        customText2: account.customText2,
        customText3: account.customText3
    };
    return accountSelect;
};
const $876528fe07563bf3$export$1f974c752a5b2a76 = (account)=>{
    const accountSelect = {
        account: account,
        memo: account.memo,
        tradeIntention: account.tradeIntentions[0],
        customText2: account.customText2,
        customText3: account.customText3
    };
    return accountSelect;
};



var $fRwNr = parcelRequire("fRwNr");

var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $bqPQ9 = parcelRequire("bqPQ9");



var $bqPQ9 = parcelRequire("bqPQ9");

var $lx97N = parcelRequire("lx97N");
var $78ec52a4e3cdfd1d$var$matchesImpl;
function $78ec52a4e3cdfd1d$export$2e2bcd8739ae039(node, selector) {
    if (!$78ec52a4e3cdfd1d$var$matchesImpl) {
        var body = document.body;
        var nativeMatch = body.matches || body.matchesSelector || body.webkitMatchesSelector || body.mozMatchesSelector || body.msMatchesSelector;
        $78ec52a4e3cdfd1d$var$matchesImpl = function matchesImpl(n, s) {
            return nativeMatch.call(n, s);
        };
    }
    return $78ec52a4e3cdfd1d$var$matchesImpl(node, selector);
}


var $e756898da11911b9$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $e756898da11911b9$export$2e2bcd8739ae039(element, selector) {
    return $e756898da11911b9$var$toArray(element.querySelectorAll(selector));
}


/* eslint-disable no-return-assign */ var $c36f36ded4bef1c0$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $7e72389cdcb8fa2e$export$63fefd044b2bc624 = false;
var $7e72389cdcb8fa2e$export$a614c6b395900f69 = false;
try {
    var $7e72389cdcb8fa2e$var$options = {
        get passive () {
            return $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $7e72389cdcb8fa2e$export$a614c6b395900f69 = $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
        window.addEventListener('test', $7e72389cdcb8fa2e$var$options, $7e72389cdcb8fa2e$var$options);
        window.removeEventListener('test', $7e72389cdcb8fa2e$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7e72389cdcb8fa2e$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$7e72389cdcb8fa2e$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$7e72389cdcb8fa2e$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $7e72389cdcb8fa2e$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $7e72389cdcb8fa2e$export$2e2bcd8739ae039 = $7e72389cdcb8fa2e$var$addEventListener;



var $lx97N = parcelRequire("lx97N");

var $4RND8 = parcelRequire("4RND8");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");
var $0e34bdc1602f642d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e34bdc1602f642d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$0e34bdc1602f642d$exports = $0e34bdc1602f642d$var$invariant;


var $00c67cd92a689ee9$var$noop = function noop() {};
function $00c67cd92a689ee9$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $00c67cd92a689ee9$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $00c67cd92a689ee9$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$00c67cd92a689ee9$export$26cbf8c37e721e67(prop)] = $00c67cd92a689ee9$var$noop;
        var handler;
    });
    return propTypes;
}
function $00c67cd92a689ee9$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $00c67cd92a689ee9$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $00c67cd92a689ee9$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $fe0042ae49f115d3$var$_toPropertyKey(arg) {
    var key = $fe0042ae49f115d3$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $fe0042ae49f115d3$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $fe0042ae49f115d3$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $lx97N.useRef)(propValue !== undefined);
    var _useState = (0, $lx97N.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $lx97N.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $fe0042ae49f115d3$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$00c67cd92a689ee9$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $hphT8.default)(_ref, [
            $00c67cd92a689ee9$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($fe0042ae49f115d3$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $fe0042ae49f115d3$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $eR4tV.default)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $3W2J1 = parcelRequire("3W2J1");

var $lx97N = parcelRequire("lx97N");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $c982951dec9de7c3$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $c982951dec9de7c3$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $00c67cd92a689ee9$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($00c67cd92a689ee9$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($0e34bdc1602f642d$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $3W2J1.default)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $eR4tV.default)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$00c67cd92a689ee9$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $eR4tV.default)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$00c67cd92a689ee9$export$12ae2baa35bd9b8b(props, key) && $00c67cd92a689ee9$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$00c67cd92a689ee9$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $hphT8.default)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $eR4tV.default)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Component);
    (0, $51cb67738c4a415e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $eR4tV.default)({
        innerRef: function innerRef() {}
    }, $00c67cd92a689ee9$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(UncontrolledComponent, (0, $eR4tV.default)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $c982951dec9de7c3$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $c982951dec9de7c3$export$2e2bcd8739ae039(newComponent, (0, $eR4tV.default)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $lx97N = parcelRequire("lx97N");
function $1eae21dd06ab5fce$export$2e2bcd8739ae039(value) {
    const ref = (0, $lx97N.useRef)(null);
    (0, $lx97N.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $lx97N = parcelRequire("lx97N");
function $3ad5f120052443ff$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $lx97N.useReducer)((state)=>!state, false);
    return dispatch;
}



var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $83fbf50010d244d9$var$useCommittedRef(value) {
    const ref = (0, $lx97N.useRef)(value);
    (0, $lx97N.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $83fbf50010d244d9$export$2e2bcd8739ae039 = $83fbf50010d244d9$var$useCommittedRef;


function $144b1b88ba290421$export$2e2bcd8739ae039(fn) {
    const ref = (0, $83fbf50010d244d9$export$2e2bcd8739ae039)(fn);
    return (0, $lx97N.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


function $c15b2b4e98b7c32e$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $144b1b88ba290421$export$2e2bcd8739ae039)(listener);
    (0, $lx97N.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}



var $lx97N = parcelRequire("lx97N");
function $9884dc53e7e0df00$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $lx97N.useCallback)(()=>document, []);
    return (0, $c15b2b4e98b7c32e$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}




var $lx97N = parcelRequire("lx97N");
var $c10172ed8b4a7672$var$DropdownContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext(null);
var $c10172ed8b4a7672$export$2e2bcd8739ae039 = $c10172ed8b4a7672$var$DropdownContext;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $4RND8 = parcelRequire("4RND8");

var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
function $b33aa3497bd26704$export$2e2bcd8739ae039() {
    return (0, $lx97N.useState)(null);
}




var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
function $2abb596085444e5b$export$2e2bcd8739ae039() {
    const mounted = (0, $lx97N.useRef)(true);
    const isMounted = (0, $lx97N.useRef)(()=>mounted.current);
    (0, $lx97N.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $976e7463583c341b$var$useSafeState(state) {
    const isMounted = (0, $2abb596085444e5b$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $lx97N.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $976e7463583c341b$export$2e2bcd8739ae039 = $976e7463583c341b$var$useSafeState;



function $3b8fe2dc5ff68c07$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $d73e6687a1d925d1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b2a82a0945aa8fd0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b2a82a0945aa8fd0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $049d14be9b4f15bb$export$8960430cfd85939f = Math.max;
var $049d14be9b4f15bb$export$96ec731ed4dcb222 = Math.min;
var $049d14be9b4f15bb$export$2077e0241d6afd3c = Math.round;



function $17847447eb3676eb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $3822c5a08263882b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
}


function $28398e533bd4cb4a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3822c5a08263882b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0c96e22a9b1659c4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $edb26c5020cedcb8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $37108a593d5d5f50$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $d62284b4ca370c21$export$2e2bcd8739ae039(element) {
    return (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $94c820df5d403ed2$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element)) >= 0;
}




function $939c0e8e0ce2cee6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $f85bc6099bdeb764$export$2e2bcd8739ae039(element) {
    if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $8debf15f2d350881$var$getTrueOffsetParent(element) {
    if (!(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8debf15f2d350881$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    if (isIE && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element);
    if ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8debf15f2d350881$export$2e2bcd8739ae039(element) {
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $94c820df5d403ed2$export$2e2bcd8739ae039)(offsetParent) && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $8debf15f2d350881$var$getContainingBlock(element) || window;
}


function $f69c37e7bc9eb348$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max) {
    return (0, $049d14be9b4f15bb$export$8960430cfd85939f)(min, (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(value, max));
}
function $32a9692ec37d141e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $559cca984964a2c1$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $4e3f355f6e420d75$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $559cca984964a2c1$export$2e2bcd8739ae039)(), paddingObject);
}


function $868fda9c4887b436$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $961d5315ffabf519$export$1e95b668f3b82d = 'top';
var $961d5315ffabf519$export$40e543e69a8b3fbb = 'bottom';
var $961d5315ffabf519$export$79ffe56a765070d2 = 'right';
var $961d5315ffabf519$export$eabcd2c8791e7bf4 = 'left';
var $961d5315ffabf519$export$dfb5619354ba860 = 'auto';
var $961d5315ffabf519$export$aec2ce47c367b8c3 = [
    $961d5315ffabf519$export$1e95b668f3b82d,
    $961d5315ffabf519$export$40e543e69a8b3fbb,
    $961d5315ffabf519$export$79ffe56a765070d2,
    $961d5315ffabf519$export$eabcd2c8791e7bf4
];
var $961d5315ffabf519$export$b3571188c770cc5a = 'start';
var $961d5315ffabf519$export$bd5df0f255a350f8 = 'end';
var $961d5315ffabf519$export$390fd549c5303b4d = 'clippingParents';
var $961d5315ffabf519$export$d7b7311ec04a3e8f = 'viewport';
var $961d5315ffabf519$export$ae5ab1c730825774 = 'popper';
var $961d5315ffabf519$export$ca50aac9f3ba507f = 'reference';
var $961d5315ffabf519$export$368f9a87e87fa4e1 = /*#__PURE__*/ $961d5315ffabf519$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []);
var $961d5315ffabf519$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($961d5315ffabf519$export$aec2ce47c367b8c3, [
    $961d5315ffabf519$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $961d5315ffabf519$export$421679a7c3d56e = 'beforeRead';
var $961d5315ffabf519$export$aafa59e2e03f2942 = 'read';
var $961d5315ffabf519$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $961d5315ffabf519$export$c65e99957a05207c = 'beforeMain';
var $961d5315ffabf519$export$f22da7240b7add18 = 'main';
var $961d5315ffabf519$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $961d5315ffabf519$export$8d4d2d70e7d46032 = 'beforeWrite';
var $961d5315ffabf519$export$68d8715fc104d294 = 'write';
var $961d5315ffabf519$export$70a6e5159acce2e6 = 'afterWrite';
var $961d5315ffabf519$export$d087d3878fdf71d5 = [
    $961d5315ffabf519$export$421679a7c3d56e,
    $961d5315ffabf519$export$aafa59e2e03f2942,
    $961d5315ffabf519$export$6964f6c886723980,
    $961d5315ffabf519$export$c65e99957a05207c,
    $961d5315ffabf519$export$f22da7240b7add18,
    $961d5315ffabf519$export$bab79516f2d662fe,
    $961d5315ffabf519$export$8d4d2d70e7d46032,
    $961d5315ffabf519$export$68d8715fc104d294,
    $961d5315ffabf519$export$70a6e5159acce2e6
];


var $48ddd81393695a53$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
};
function $48ddd81393695a53$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $48ddd81393695a53$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $48ddd81393695a53$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $48ddd81393695a53$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $48ddd81393695a53$var$arrow,
    effect: $48ddd81393695a53$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $41cccd7fabe05f63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $bbe366718497d634$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bbe366718497d634$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bbe366718497d634$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var sideY = (0, $961d5315ffabf519$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(popper);
            if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || placement === (0, $961d5315ffabf519$export$79ffe56a765070d2)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideY = (0, $961d5315ffabf519$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || placement === (0, $961d5315ffabf519$export$40e543e69a8b3fbb)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideX = (0, $961d5315ffabf519$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bbe366718497d634$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bbe366718497d634$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $bbe366718497d634$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bbe366718497d634$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $bbe366718497d634$var$computeStyles,
    data: {}
};



var $7bec2a6e2c97de64$var$passive = {
    passive: true
};
function $7bec2a6e2c97de64$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bec2a6e2c97de64$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $7bec2a6e2c97de64$var$effect,
    data: {}
};


var $895264d7f1285abd$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $895264d7f1285abd$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $895264d7f1285abd$var$hash[matched];
    });
}



var $3190ee6894c64586$var$hash = {
    start: 'end',
    end: 'start'
};
function $3190ee6894c64586$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3190ee6894c64586$var$hash[matched];
    });
}








function $e826853427a61d24$export$2e2bcd8739ae039(node) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $53712d9fbfe608a5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)).left + (0, $e826853427a61d24$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $4c6294ad0a5a884e$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3822c5a08263882b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $32cb83235cf6af6b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e826853427a61d24$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $c3a6bf84ff18f738$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $a31d6136541392dc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node) && (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(node)) return node;
    return $a31d6136541392dc$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(node));
}





function $c6fcb9ddb0a619f3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a31d6136541392dc$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6fcb9ddb0a619f3$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(target)));
}










function $2f76e9cca25369aa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $3ed34baa7075c065$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) ? (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $4c6294ad0a5a884e$export$2e2bcd8739ae039)(element, strategy)) : (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) ? $3ed34baa7075c065$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $32cb83235cf6af6b$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3ed34baa7075c065$var$getClippingParents(element) {
    var clippingParents = (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) ? (0, $8debf15f2d350881$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3ed34baa7075c065$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3ed34baa7075c065$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3ed34baa7075c065$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5abf2ff6da597e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $961d5315ffabf519$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $961d5315ffabf519$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $961d5315ffabf519$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $961d5315ffabf519$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $961d5315ffabf519$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $961d5315ffabf519$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f4983c2f7b82930e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $961d5315ffabf519$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $961d5315ffabf519$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? (0, $961d5315ffabf519$export$ca50aac9f3ba507f) : (0, $961d5315ffabf519$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3ed34baa7075c065$export$2e2bcd8739ae039)((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $961d5315ffabf519$export$79ffe56a765070d2),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $961d5315ffabf519$export$1e95b668f3b82d),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $5f0f7fd33e6df374$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $961d5315ffabf519$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $961d5315ffabf519$export$368f9a87e87fa4e1) : (0, $961d5315ffabf519$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $961d5315ffabf519$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7261bb7a28c6c261$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7261bb7a28c6c261$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $895264d7f1285abd$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7261bb7a28c6c261$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860) ? (0, $5f0f7fd33e6df374$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$b3571188c770cc5a);
        var isVertical = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $961d5315ffabf519$export$79ffe56a765070d2) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7261bb7a28c6c261$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7261bb7a28c6c261$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $d7d2695ea28b2aa6$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d7d2695ea28b2aa6$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $961d5315ffabf519$export$1e95b668f3b82d),
        (0, $961d5315ffabf519$export$79ffe56a765070d2),
        (0, $961d5315ffabf519$export$40e543e69a8b3fbb),
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d7d2695ea28b2aa6$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d7d2695ea28b2aa6$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d7d2695ea28b2aa6$var$hide
};




function $6137a161b4896709$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6137a161b4896709$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $961d5315ffabf519$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $6137a161b4896709$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6137a161b4896709$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6137a161b4896709$var$offset
};



function $fd3370820cf4bcb1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fd3370820cf4bcb1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $fd3370820cf4bcb1$var$popperOffsets,
    data: {}
};





function $45abdfcc61968a12$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $9d3c739e2059661f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $45abdfcc61968a12$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $559cca984964a2c1$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8debf15f2d350881$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $049d14be9b4f15bb$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $32a9692ec37d141e$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9d3c739e2059661f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9d3c739e2059661f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $9f852250855e3d87$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b434581b465cb432$export$2e2bcd8739ae039(node) {
    if (node === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node) || !(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node)) return (0, $e826853427a61d24$export$2e2bcd8739ae039)(node);
    else return (0, $9f852250855e3d87$export$2e2bcd8739ae039)(node);
}








function $dbf000ff4b3c4664$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dbf000ff4b3c4664$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent) && $dbf000ff4b3c4664$var$isElementScaled(offsetParent);
    var documentElement = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b434581b465cb432$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $7fa7d91227c213a7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7fa7d91227c213a7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7fa7d91227c213a7$var$order(modifiers); // order based on phase
    return (0, $961d5315ffabf519$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $348b53990a67b9f2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $79e2fb482cad3d90$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b0054ad10f2e8753$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b0054ad10f2e8753$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b0054ad10f2e8753$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b0054ad10f2e8753$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b0054ad10f2e8753$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(reference) ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7fa7d91227c213a7$export$2e2bcd8739ae039)((0, $79e2fb482cad3d90$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $dbf000ff4b3c4664$export$2e2bcd8739ae039)(reference, (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $348b53990a67b9f2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b0054ad10f2e8753$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b0054ad10f2e8753$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


var $9bc00056aef56695$export$8f7491d57c8f97a9 = (0, $b0054ad10f2e8753$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $d7d2695ea28b2aa6$export$2e2bcd8739ae039),
        (0, $fd3370820cf4bcb1$export$2e2bcd8739ae039),
        (0, $bbe366718497d634$export$2e2bcd8739ae039),
        (0, $7bec2a6e2c97de64$export$2e2bcd8739ae039),
        (0, $6137a161b4896709$export$2e2bcd8739ae039),
        (0, $7261bb7a28c6c261$export$2e2bcd8739ae039),
        (0, $9d3c739e2059661f$export$2e2bcd8739ae039),
        (0, $48ddd81393695a53$export$2e2bcd8739ae039)
    ]
});


var $52839e6acb2e70d1$var$initialPopperStyles = function initialPopperStyles(position) {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
};
var $52839e6acb2e70d1$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false
}; // In order to satisfy the current usage of options, including undefined
var $52839e6acb2e70d1$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: function effect(_ref) {
        var state = _ref.state;
        return function() {
            var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
            if ('removeAttribute' in reference) {
                var ids = (reference.getAttribute('aria-describedby') || '').split(',').filter(function(id) {
                    return id.trim() !== popper.id;
                });
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        };
    },
    fn: function fn(_ref2) {
        var _popper$getAttribute;
        var state = _ref2.state;
        var _state$elements2 = state.elements, popper = _state$elements2.popper, reference = _state$elements2.reference;
        var role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            var ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? ids + "," + popper.id : popper.id);
        }
    }
};
var $52839e6acb2e70d1$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {boolean=}    options.eventsEnabled have Popper listen on window resize events to reposition the element
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $52839e6acb2e70d1$var$usePopper(referenceElement, popperElement, _temp) {
    var _ref3 = _temp === void 0 ? {} : _temp, _ref3$enabled = _ref3.enabled, enabled = _ref3$enabled === void 0 ? true : _ref3$enabled, _ref3$placement = _ref3.placement, placement = _ref3$placement === void 0 ? 'bottom' : _ref3$placement, _ref3$strategy = _ref3.strategy, strategy = _ref3$strategy === void 0 ? 'absolute' : _ref3$strategy, _ref3$modifiers = _ref3.modifiers, modifiers = _ref3$modifiers === void 0 ? $52839e6acb2e70d1$var$EMPTY_MODIFIERS : _ref3$modifiers, config = (0, $hphT8.default)(_ref3, [
        "enabled",
        "placement",
        "strategy",
        "modifiers"
    ]);
    var popperInstanceRef = (0, $lx97N.useRef)();
    var update = (0, $lx97N.useCallback)(function() {
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    var forceUpdate = (0, $lx97N.useCallback)(function() {
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    var _useSafeState = (0, $976e7463583c341b$export$2e2bcd8739ae039)((0, $lx97N.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: $52839e6acb2e70d1$var$initialPopperStyles(strategy),
            arrow: {}
        }
    })), popperState = _useSafeState[0], setState = _useSafeState[1];
    var updateModifier = (0, $lx97N.useMemo)(function() {
        return {
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref4) {
                var state = _ref4.state;
                var styles = {};
                var attributes = {};
                Object.keys(state.elements).forEach(function(element) {
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        };
    }, [
        update,
        forceUpdate,
        setState
    ]);
    (0, $lx97N.useEffect)(function() {
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                updateModifier,
                $52839e6acb2e70d1$var$disabledApplyStylesModifier
            ])
        }); // intentionally NOT re-running on new modifiers
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        strategy,
        placement,
        updateModifier,
        enabled
    ]);
    (0, $lx97N.useEffect)(function() {
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $9bc00056aef56695$export$8f7491d57c8f97a9)(referenceElement, popperElement, (0, $eR4tV.default)({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [].concat(modifiers, [
                $52839e6acb2e70d1$var$ariaDescribedByModifier,
                updateModifier
            ])
        }));
        return function() {
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState(function(s) {
                    return (0, $eR4tV.default)({}, s, {
                        attributes: {},
                        styles: {
                            popper: $52839e6acb2e70d1$var$initialPopperStyles(strategy)
                        }
                    });
                });
            }
        }; // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $52839e6acb2e70d1$export$2e2bcd8739ae039 = $52839e6acb2e70d1$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $97c75dca58f4c376$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $1570e8bef8c3dfba$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $1570e8bef8c3dfba$export$2e2bcd8739ae039 = $1570e8bef8c3dfba$var$removeEventListener;


function $e30c1a8b3e180f01$var$listen(node, eventName, handler, options) {
    (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $e30c1a8b3e180f01$export$2e2bcd8739ae039 = $e30c1a8b3e180f01$var$listen;



var $lx97N = parcelRequire("lx97N");

var $9abc3dc86fc6eb1f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9abc3dc86fc6eb1f$var$__DEV__ = false;
var $9abc3dc86fc6eb1f$var$warning = function() {};
if ($9abc3dc86fc6eb1f$var$__DEV__) {
    var $9abc3dc86fc6eb1f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9abc3dc86fc6eb1f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9abc3dc86fc6eb1f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$9abc3dc86fc6eb1f$exports = $9abc3dc86fc6eb1f$var$warning;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $e2f451e3d449ae45$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $1amKe = parcelRequire("1amKe");
function $84b48d98d8a33c31$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) return (0, (/*@__PURE__*/$parcel$interopDefault($1amKe))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}


var $06bf98fa76b6d07e$export$2e2bcd8739ae039 = function(componentOrElement) {
    return (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)((0, $84b48d98d8a33c31$export$2e2bcd8739ae039)(componentOrElement));
};


var $e4b7752ab851bca9$var$escapeKeyCode = 27;
var $e4b7752ab851bca9$var$noop = function noop() {};
function $e4b7752ab851bca9$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $e4b7752ab851bca9$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $e4b7752ab851bca9$var$getRefTarget = function getRefTarget(ref) {
    return ref && ('current' in ref ? ref.current : ref);
};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $e4b7752ab851bca9$var$useRootClose(ref, onRootClose, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, disabled = _ref.disabled, _ref$clickTrigger = _ref.clickTrigger, clickTrigger = _ref$clickTrigger === void 0 ? 'click' : _ref$clickTrigger;
    var preventMouseRootCloseRef = (0, $lx97N.useRef)(false);
    var onClose = onRootClose || $e4b7752ab851bca9$var$noop;
    var handleMouseCapture = (0, $lx97N.useCallback)(function(e) {
        var _e$composedPath$;
        var currentTarget = $e4b7752ab851bca9$var$getRefTarget(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($9abc3dc86fc6eb1f$exports)))(!!currentTarget, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node");
        preventMouseRootCloseRef.current = !currentTarget || $e4b7752ab851bca9$var$isModifiedEvent(e) || !$e4b7752ab851bca9$var$isLeftClickEvent(e) || !!(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, (_e$composedPath$ = e.composedPath == null ? void 0 : e.composedPath()[0]) != null ? _e$composedPath$ : e.target);
    }, [
        ref
    ]);
    var handleMouse = (0, $144b1b88ba290421$export$2e2bcd8739ae039)(function(e) {
        if (!preventMouseRootCloseRef.current) onClose(e);
    });
    var handleKeyUp = (0, $144b1b88ba290421$export$2e2bcd8739ae039)(function(e) {
        if (e.keyCode === $e4b7752ab851bca9$var$escapeKeyCode) onClose(e);
    });
    (0, $lx97N.useEffect)(function() {
        if (disabled || ref == null) return undefined; // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        var currentEvent = window.event;
        var doc = (0, $06bf98fa76b6d07e$export$2e2bcd8739ae039)($e4b7752ab851bca9$var$getRefTarget(ref)); // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        var removeMouseCaptureListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        var removeMouseListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        var removeKeyupListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, 'keyup', function(e) {
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        var mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map(function(el) {
            return (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(el, 'mousemove', $e4b7752ab851bca9$var$noop);
        });
        return function() {
            removeMouseCaptureListener();
            removeMouseListener();
            removeKeyupListener();
            mobileSafariHackListeners.forEach(function(remove) {
                return remove();
            });
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleMouse,
        handleKeyUp
    ]);
}
var $e4b7752ab851bca9$export$2e2bcd8739ae039 = $e4b7752ab851bca9$var$useRootClose;



var $eR4tV = parcelRequire("eR4tV");
function $008336747dfddba9$export$ba6dad097c8f5c38(modifiers) {
    var result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
     // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach(function(m) {
        result[m.name] = m;
    });
    return result;
}
function $008336747dfddba9$export$af3a999d4a134c86(map) {
    if (map === void 0) map = {};
    if (Array.isArray(map)) return map;
    return Object.keys(map).map(function(k) {
        map[k].name = k;
        return map[k];
    });
}
function $008336747dfddba9$export$2e2bcd8739ae039(_ref) {
    var _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    var enabled = _ref.enabled, enableEvents = _ref.enableEvents, placement = _ref.placement, flip = _ref.flip, offset = _ref.offset, fixed = _ref.fixed, containerPadding = _ref.containerPadding, arrowElement = _ref.arrowElement, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig;
    var modifiers = $008336747dfddba9$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return (0, $eR4tV.default)({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $008336747dfddba9$export$af3a999d4a134c86((0, $eR4tV.default)({}, modifiers, {
            eventListeners: {
                enabled: enableEvents
            },
            preventOverflow: (0, $eR4tV.default)({}, modifiers.preventOverflow, {
                options: containerPadding ? (0, $eR4tV.default)({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: (0, $eR4tV.default)({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: (0, $eR4tV.default)({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: (0, $eR4tV.default)({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: (0, $eR4tV.default)({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}


var $9b8eb0d42f9320b9$var$noop = function noop() {};
function $9b8eb0d42f9320b9$export$133c4d08f3775d64(options) {
    if (options === void 0) options = {};
    var context = (0, $lx97N.useContext)((0, $c10172ed8b4a7672$export$2e2bcd8739ae039));
    var _useCallbackRef = (0, $b33aa3497bd26704$export$2e2bcd8739ae039)(), arrowElement = _useCallbackRef[0], attachArrowRef = _useCallbackRef[1];
    var hasShownRef = (0, $lx97N.useRef)(false);
    var _options = options, flip = _options.flip, offset = _options.offset, rootCloseEvent = _options.rootCloseEvent, _options$fixed = _options.fixed, fixed = _options$fixed === void 0 ? false : _options$fixed, _options$popperConfig = _options.popperConfig, popperConfig = _options$popperConfig === void 0 ? {} : _options$popperConfig, _options$usePopper = _options.usePopper, shouldUsePopper = _options$usePopper === void 0 ? !!context : _options$usePopper;
    var show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    var alignEnd = (context == null ? void 0 : context.alignEnd) == null ? options.alignEnd : context.alignEnd;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    var handleClose = function handleClose(e) {
        context == null || context.toggle(false, e);
    };
    var _ref = context || {}, drop = _ref.drop, setMenu = _ref.setMenu, menuElement = _ref.menuElement, toggleElement = _ref.toggleElement;
    var placement = alignEnd ? 'bottom-end' : 'bottom-start';
    if (drop === 'up') placement = alignEnd ? 'top-end' : 'top-start';
    else if (drop === 'right') placement = alignEnd ? 'right-end' : 'right-start';
    else if (drop === 'left') placement = alignEnd ? 'left-end' : 'left-start';
    var popper = (0, $52839e6acb2e70d1$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $008336747dfddba9$export$2e2bcd8739ae039)({
        placement: placement,
        enabled: !!(shouldUsePopper && show),
        enableEvents: show,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    var menuProps = (0, $eR4tV.default)({
        ref: setMenu || $9b8eb0d42f9320b9$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    var metadata = {
        show: show,
        alignEnd: alignEnd,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? (0, $eR4tV.default)({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $e4b7752ab851bca9$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
var $9b8eb0d42f9320b9$var$propTypes = {
    /**
   * A render prop that returns a Menu element. The `props`
   * argument should spread through to **a component that can accept a ref**.
   *
   * @type {Function ({
   *   show: boolean,
   *   alignEnd: boolean,
   *   close: (?SyntheticEvent) => void,
   *   placement: Placement,
   *   update: () => void,
   *   forceUpdate: () => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *     aria-labelledby: ?string
   *   },
   *   arrowProps: {
   *     ref: (?HTMLElement) => void,
   *     style: { [string]: string | number },
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func.isRequired,
    /**
   * Controls the visible state of the menu, generally this is
   * provided by the parent `Dropdown` component,
   * but may also be specified as a prop directly.
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * Aligns the dropdown menu to the 'end' of it's placement position.
   * Generally this is provided by the parent `Dropdown` component,
   * but may also be specified as a prop directly.
   */ alignEnd: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * Enables the Popper.js `flip` modifier, allowing the Dropdown to
   * automatically adjust it's placement in case of overlap with the viewport or toggle.
   * Refer to the [flip docs](https://popper.js.org/popper-documentation.html#modifiers..flip.enabled) for more info
   */ flip: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    usePopper: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOf([
        true,
        false
    ]),
    /**
   * A set of popper options and props passed directly to react-popper's Popper component.
   */ popperConfig: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
    /**
   * Override the default event used by RootCloseWrapper.
   */ rootCloseEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string
};
var $9b8eb0d42f9320b9$var$defaultProps = {
    usePopper: true
};
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $9b8eb0d42f9320b9$var$DropdownMenu(_ref2) {
    var children = _ref2.children, options = (0, $hphT8.default)(_ref2, [
        "children"
    ]);
    var _useDropdownMenu = $9b8eb0d42f9320b9$export$133c4d08f3775d64(options), props = _useDropdownMenu[0], meta = _useDropdownMenu[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Fragment, null, meta.hasShown ? children(props, meta) : null);
}
$9b8eb0d42f9320b9$var$DropdownMenu.displayName = 'ReactOverlaysDropdownMenu';
$9b8eb0d42f9320b9$var$DropdownMenu.propTypes = $9b8eb0d42f9320b9$var$propTypes;
$9b8eb0d42f9320b9$var$DropdownMenu.defaultProps = $9b8eb0d42f9320b9$var$defaultProps;
var /** @component */ $9b8eb0d42f9320b9$export$2e2bcd8739ae039 = $9b8eb0d42f9320b9$var$DropdownMenu;



var $4RND8 = parcelRequire("4RND8");

var $lx97N = parcelRequire("lx97N");

var $314017411db3bcbf$var$noop = function noop() {};
function $314017411db3bcbf$export$96df6c7c5036b9a2() {
    var _ref = (0, $lx97N.useContext)((0, $c10172ed8b4a7672$export$2e2bcd8739ae039)) || {}, _ref$show = _ref.show, show = _ref$show === void 0 ? false : _ref$show, _ref$toggle = _ref.toggle, toggle = _ref$toggle === void 0 ? $314017411db3bcbf$var$noop : _ref$toggle, setToggle = _ref.setToggle;
    var handleClick = (0, $lx97N.useCallback)(function(e) {
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    return [
        {
            ref: setToggle || $314017411db3bcbf$var$noop,
            onClick: handleClick,
            'aria-haspopup': true,
            'aria-expanded': !!show
        },
        {
            show: show,
            toggle: toggle
        }
    ];
}
var $314017411db3bcbf$var$propTypes = {
    /**
   * A render prop that returns a Toggle element. The `props`
   * argument should spread through to **a component that can accept a ref**. Use
   * the `onToggle` argument to toggle the menu open or closed
   *
   * @type {Function ({
   *   show: boolean,
   *   toggle: (show: boolean) => void,
   *   props: {
   *     ref: (?HTMLElement) => void,
   *     aria-haspopup: true
   *     aria-expanded: boolean
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func.isRequired
};
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $314017411db3bcbf$var$DropdownToggle(_ref2) {
    var children = _ref2.children;
    var _useDropdownToggle = $314017411db3bcbf$export$96df6c7c5036b9a2(), props = _useDropdownToggle[0], meta = _useDropdownToggle[1];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Fragment, null, children(props, meta));
}
$314017411db3bcbf$var$DropdownToggle.displayName = 'ReactOverlaysDropdownToggle';
$314017411db3bcbf$var$DropdownToggle.propTypes = $314017411db3bcbf$var$propTypes;
var /** @component */ $314017411db3bcbf$export$2e2bcd8739ae039 = $314017411db3bcbf$var$DropdownToggle;


var $d47a2c7511b5d2c5$var$propTypes = {
    /**
   * A render prop that returns the root dropdown element. The `props`
   * argument should spread through to an element containing _both_ the
   * menu and toggle in order to handle keyboard events for focus management.
   *
   * @type {Function ({
   *   props: {
   *     onKeyDown: (SyntheticEvent) => void,
   *   },
   * }) => React.Element}
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).node,
    /**
   * Determines the direction and location of the Menu in relation to it's Toggle.
   */ drop: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOf([
        'up',
        'left',
        'right',
        'down'
    ]),
    /**
   * Controls the focus behavior for when the Dropdown is opened. Set to
   * `true` to always focus the first menu item, `keyboard` to focus only when
   * navigating via the keyboard, or `false` to disable completely
   *
   * The Default behavior is `false` **unless** the Menu has a `role="menu"`
   * where it will default to `keyboard` to match the recommended [ARIA Authoring practices](https://www.w3.org/TR/wai-aria-practices-1.1/#menubutton).
   */ focusFirstItemOnShow: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOf([
        false,
        true,
        'keyboard'
    ]),
    /**
   * A css slector string that will return __focusable__ menu items.
   * Selectors should be relative to the menu component:
   * e.g. ` > li:not('.disabled')`
   */ itemSelector: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    /**
   * Align the menu to the 'end' side of the placement side of the Dropdown toggle. The default placement is `top-start` or `bottom-start`.
   */ alignEnd: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */ show: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * Sets the initial show position of the Dropdown.
   */ defaultShow: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `show` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```ts static
   * function(
   *   isOpen: boolean,
   *   event: SyntheticEvent,
   * ): void
   * ```
   *
   * @controllable show
   */ onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func
};
function $d47a2c7511b5d2c5$var$useRefWithUpdate() {
    var forceUpdate = (0, $3ad5f120052443ff$export$2e2bcd8739ae039)();
    var ref = (0, $lx97N.useRef)(null);
    var attachRef = (0, $lx97N.useCallback)(function(element) {
        ref.current = element; // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $d47a2c7511b5d2c5$var$Dropdown(_ref) {
    var drop = _ref.drop, alignEnd = _ref.alignEnd, defaultShow = _ref.defaultShow, rawShow = _ref.show, rawOnToggle = _ref.onToggle, _ref$itemSelector = _ref.itemSelector, itemSelector = _ref$itemSelector === void 0 ? '* > *' : _ref$itemSelector, focusFirstItemOnShow = _ref.focusFirstItemOnShow, children = _ref.children;
    var _useUncontrolledProp = (0, $fe0042ae49f115d3$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle), show = _useUncontrolledProp[0], onToggle = _useUncontrolledProp[1]; // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    var _useRefWithUpdate = $d47a2c7511b5d2c5$var$useRefWithUpdate(), menuRef = _useRefWithUpdate[0], setMenu = _useRefWithUpdate[1];
    var menuElement = menuRef.current;
    var _useRefWithUpdate2 = $d47a2c7511b5d2c5$var$useRefWithUpdate(), toggleRef = _useRefWithUpdate2[0], setToggle = _useRefWithUpdate2[1];
    var toggleElement = toggleRef.current;
    var lastShow = (0, $1eae21dd06ab5fce$export$2e2bcd8739ae039)(show);
    var lastSourceEvent = (0, $lx97N.useRef)(null);
    var focusInDropdown = (0, $lx97N.useRef)(false);
    var toggle = (0, $lx97N.useCallback)(function(nextShow, event) {
        onToggle(nextShow, event);
    }, [
        onToggle
    ]);
    var context = (0, $lx97N.useMemo)(function() {
        return {
            toggle: toggle,
            drop: drop,
            show: show,
            alignEnd: alignEnd,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        };
    }, [
        toggle,
        drop,
        show,
        alignEnd,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(document.activeElement);
    var focusToggle = (0, $144b1b88ba290421$export$2e2bcd8739ae039)(function() {
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    var maybeFocusFirst = (0, $144b1b88ba290421$export$2e2bcd8739ae039)(function() {
        var type = lastSourceEvent.current;
        var focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $78ec52a4e3cdfd1d$export$2e2bcd8739ae039)(menuRef.current, '[role=menu]') ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        var first = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $lx97N.useEffect)(function() {
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        } // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $lx97N.useEffect)(function() {
        lastSourceEvent.current = null;
    });
    var getNextFocusedChild = function getNextFocusedChild(current, offset) {
        if (!menuRef.current) return null;
        var items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        var index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $9884dc53e7e0df00$export$2e2bcd8739ae039)('keydown', function(event) {
        var _menuRef$current, _toggleRef$current;
        var key = event.key;
        var target = event.target;
        var fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        var fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target); // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        var isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu)) return;
        if (!fromMenu && !fromToggle) return;
        if (!menuRef.current && key === 'Tab') return;
        lastSourceEvent.current = event.type;
        switch(key){
            case 'ArrowUp':
                var next = getNextFocusedChild(target, -1);
                if (next && next.focus) next.focus();
                event.preventDefault();
                return;
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, event);
                else {
                    var _next = getNextFocusedChild(target, 1);
                    if (_next && _next.focus) _next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(document, 'keyup', function(e) {
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, event);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                event.preventDefault();
                event.stopPropagation();
                onToggle(false, event);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $c10172ed8b4a7672$export$2e2bcd8739ae039).Provider, {
        value: context
    }, children);
}
$d47a2c7511b5d2c5$var$Dropdown.displayName = 'ReactOverlaysDropdown';
$d47a2c7511b5d2c5$var$Dropdown.propTypes = $d47a2c7511b5d2c5$var$propTypes;
$d47a2c7511b5d2c5$var$Dropdown.Menu = (0, $9b8eb0d42f9320b9$export$2e2bcd8739ae039);
$d47a2c7511b5d2c5$var$Dropdown.Toggle = (0, $314017411db3bcbf$export$2e2bcd8739ae039);
var $d47a2c7511b5d2c5$export$2e2bcd8739ae039 = $d47a2c7511b5d2c5$var$Dropdown;







var $bqPQ9 = parcelRequire("bqPQ9");

var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");
var $d7b9013820928791$var$SelectableContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext(null);
var $d7b9013820928791$export$eef49b42fde998a3 = function makeEventKey(eventKey, href) {
    if (href === void 0) href = null;
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $d7b9013820928791$export$2e2bcd8739ae039 = $d7b9013820928791$var$SelectableContext;




var $lx97N = parcelRequire("lx97N");
var $d590982e5c051e85$var$NavContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext(null);
$d590982e5c051e85$var$NavContext.displayName = 'NavContext';
var $d590982e5c051e85$export$2e2bcd8739ae039 = $d590982e5c051e85$var$NavContext;





var $lx97N = parcelRequire("lx97N");
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $81236a534f9baa80$var$createChainedFunction() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    return funcs.filter(function(f) {
        return f != null;
    }).reduce(function(acc, f) {
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            // @ts-ignore
            acc.apply(this, args); // @ts-ignore
            f.apply(this, args);
        };
    }, null);
}
var $81236a534f9baa80$export$2e2bcd8739ae039 = $81236a534f9baa80$var$createChainedFunction;


var $f5da0df6644ce0a9$var$_excluded = [
    "as",
    "disabled",
    "onKeyDown"
];
function $f5da0df6644ce0a9$var$isTrivialHref(href) {
    return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, DropdownItems, etc.
 */ var $f5da0df6644ce0a9$var$SafeAnchor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'a' : _ref$as, disabled = _ref.disabled, onKeyDown = _ref.onKeyDown, props = (0, $7c6a7c90312158c1$export$2e2bcd8739ae039)(_ref, $f5da0df6644ce0a9$var$_excluded);
    var handleClick = function handleClick(event) {
        var href = props.href, onClick = props.onClick;
        if (disabled || $f5da0df6644ce0a9$var$isTrivialHref(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        if (onClick) onClick(event);
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if ($f5da0df6644ce0a9$var$isTrivialHref(props.href)) {
        props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
        // otherwise, the cursor incorrectly styled (except with role='button')
        props.href = props.href || '#';
    }
    if (disabled) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({
        ref: ref
    }, props, {
        onClick: handleClick,
        onKeyDown: (0, $81236a534f9baa80$export$2e2bcd8739ae039)(handleKeyDown, onKeyDown)
    }));
});
$f5da0df6644ce0a9$var$SafeAnchor.displayName = 'SafeAnchor';
var $f5da0df6644ce0a9$export$2e2bcd8739ae039 = $f5da0df6644ce0a9$var$SafeAnchor;


var $eca3633eb94edb4a$var$_excluded = [
    "bsPrefix",
    "className",
    "children",
    "eventKey",
    "disabled",
    "href",
    "onClick",
    "onSelect",
    "active",
    "as"
];
var $eca3633eb94edb4a$var$defaultProps = {
    as: (0, $f5da0df6644ce0a9$export$2e2bcd8739ae039),
    disabled: false
};
var $eca3633eb94edb4a$var$DropdownItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, children = _ref.children, eventKey = _ref.eventKey, disabled = _ref.disabled, href = _ref.href, onClick = _ref.onClick, onSelect = _ref.onSelect, propActive = _ref.active, Component = _ref.as, props = (0, $7c6a7c90312158c1$export$2e2bcd8739ae039)(_ref, $eca3633eb94edb4a$var$_excluded);
    var prefix = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    var onSelectCtx = (0, $lx97N.useContext)((0, $d7b9013820928791$export$2e2bcd8739ae039));
    var navContext = (0, $lx97N.useContext)((0, $d590982e5c051e85$export$2e2bcd8739ae039));
    var _ref2 = navContext || {}, activeKey = _ref2.activeKey;
    var key = (0, $d7b9013820928791$export$eef49b42fde998a3)(eventKey, href);
    var active = propActive == null && key != null ? (0, $d7b9013820928791$export$eef49b42fde998a3)(activeKey) === key : propActive;
    var handleClick = (0, $144b1b88ba290421$export$2e2bcd8739ae039)(function(event) {
        // SafeAnchor handles the disabled case, but we handle it here
        // for other components
        if (disabled) return;
        if (onClick) onClick(event);
        if (onSelectCtx) onSelectCtx(key, event);
        if (onSelect) onSelect(key, event);
    });
    return(/*#__PURE__*/ // "TS2604: JSX element type 'Component' does not have any construct or call signatures."
    // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        href: href,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, prefix, active && 'active', disabled && 'disabled'),
        onClick: handleClick
    }), children));
});
$eca3633eb94edb4a$var$DropdownItem.displayName = 'DropdownItem';
$eca3633eb94edb4a$var$DropdownItem.defaultProps = $eca3633eb94edb4a$var$defaultProps;
var $eca3633eb94edb4a$export$2e2bcd8739ae039 = $eca3633eb94edb4a$var$DropdownItem;





var $bqPQ9 = parcelRequire("bqPQ9");

var $4RND8 = parcelRequire("4RND8");

var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");
const $e56555f462cc66b3$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $e56555f462cc66b3$export$c9058316764c140e(refA, refB) {
    const a = $e56555f462cc66b3$var$toFnRef(refA);
    const b = $e56555f462cc66b3$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $e56555f462cc66b3$var$useMergedRefs(refA, refB) {
    return (0, $lx97N.useMemo)(()=>$e56555f462cc66b3$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $e56555f462cc66b3$export$2e2bcd8739ae039 = $e56555f462cc66b3$var$useMergedRefs;




var $lx97N = parcelRequire("lx97N");
var $0a5b2d4ab0a117ed$var$context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createContext(null);
$0a5b2d4ab0a117ed$var$context.displayName = 'NavbarContext';
var $0a5b2d4ab0a117ed$export$2e2bcd8739ae039 = $0a5b2d4ab0a117ed$var$context;




parcelRequire("lx97N");

function $a6c54c90e04a6318$export$2e2bcd8739ae039(ref, componentName) {
    var warningRef;
    return ref; // eslint-disable-next-line react-hooks/rules-of-hooks
}



var $lx97N = parcelRequire("lx97N");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $bb7f18969320ba30$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}



function $af018ae24f36c1d8$var$getMargins(element) {
    var styles = window.getComputedStyle(element);
    var top = parseFloat(styles.marginTop) || 0;
    var right = parseFloat(styles.marginRight) || 0;
    var bottom = parseFloat(styles.marginBottom) || 0;
    var left = parseFloat(styles.marginLeft) || 0;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function $af018ae24f36c1d8$export$2e2bcd8739ae039() {
    var overlayRef = (0, $lx97N.useRef)(null);
    var margins = (0, $lx97N.useRef)(null);
    var arrowMargins = (0, $lx97N.useRef)(null);
    var popoverClass = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(undefined, 'popover');
    var dropdownMenuClass = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(undefined, 'dropdown-menu');
    var callback = (0, $lx97N.useCallback)(function(overlay) {
        if (!overlay || !((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlay, popoverClass) || (0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlay, dropdownMenuClass))) return;
        margins.current = $af018ae24f36c1d8$var$getMargins(overlay);
        overlay.style.margin = '0';
        overlayRef.current = overlay;
    }, [
        popoverClass,
        dropdownMenuClass
    ]);
    var offset = (0, $lx97N.useMemo)(function() {
        return {
            name: 'offset',
            options: {
                offset: function offset(_ref) {
                    var placement = _ref.placement;
                    if (!margins.current) return [
                        0,
                        0
                    ];
                    var _margins$current = margins.current, top = _margins$current.top, left = _margins$current.left, bottom = _margins$current.bottom, right = _margins$current.right;
                    switch(placement.split('-')[0]){
                        case 'top':
                            return [
                                0,
                                bottom
                            ];
                        case 'left':
                            return [
                                0,
                                right
                            ];
                        case 'bottom':
                            return [
                                0,
                                top
                            ];
                        case 'right':
                            return [
                                0,
                                left
                            ];
                        default:
                            return [
                                0,
                                0
                            ];
                    }
                }
            }
        };
    }, [
        margins
    ]);
    var arrow = (0, $lx97N.useMemo)(function() {
        return {
            name: 'arrow',
            options: {
                padding: function padding() {
                    // The options here are used for Popper 2.8.4 and up.
                    // For earlier version, padding is handled in popoverArrowMargins below.
                    if (!arrowMargins.current) return 0;
                    var _arrowMargins$current = arrowMargins.current, top = _arrowMargins$current.top, right = _arrowMargins$current.right;
                    var padding = top || right;
                    return {
                        top: padding,
                        left: padding,
                        right: padding,
                        bottom: padding
                    };
                }
            }
        };
    }, [
        arrowMargins
    ]); // Converts popover arrow margin to arrow modifier padding
    var popoverArrowMargins = (0, $lx97N.useMemo)(function() {
        return {
            name: 'popoverArrowMargins',
            enabled: true,
            phase: 'main',
            fn: function fn() {
                return undefined;
            },
            requiresIfExists: [
                'arrow'
            ],
            effect: function effect(_ref2) {
                var state = _ref2.state;
                if (!overlayRef.current || !state.elements.arrow || !(0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return undefined;
                if (state.modifiersData['arrow#persistent']) {
                    // @popperjs/core <= 2.8.3 uses arrow#persistent to pass padding to arrow modifier.
                    var _getMargins = $af018ae24f36c1d8$var$getMargins(state.elements.arrow), top = _getMargins.top, right = _getMargins.right;
                    var padding = top || right;
                    state.modifiersData['arrow#persistent'].padding = {
                        top: padding,
                        left: padding,
                        right: padding,
                        bottom: padding
                    };
                } else // @popperjs/core >= 2.8.4 gets the padding from the arrow modifier options,
                // so we'll get the margins here, and let the arrow modifier above pass
                // it to popper.
                arrowMargins.current = $af018ae24f36c1d8$var$getMargins(state.elements.arrow);
                state.elements.arrow.style.margin = '0';
                return function() {
                    if (state.elements.arrow) state.elements.arrow.style.margin = '';
                };
            }
        };
    }, [
        popoverClass
    ]);
    return [
        callback,
        [
            offset,
            arrow,
            popoverArrowMargins
        ]
    ];
}


var $002cdb88906ccba0$var$_excluded = [
    "bsPrefix",
    "className",
    "align",
    "alignRight",
    "rootCloseEvent",
    "flip",
    "show",
    "renderOnMount",
    "as",
    "popperConfig"
];
var $002cdb88906ccba0$var$alignDirection = (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOf([
    'left',
    'right'
]);
var $002cdb88906ccba0$export$5dd51d61a30477bc = (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
    $002cdb88906ccba0$var$alignDirection,
    (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).shape({
        sm: $002cdb88906ccba0$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).shape({
        md: $002cdb88906ccba0$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).shape({
        lg: $002cdb88906ccba0$var$alignDirection
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).shape({
        xl: $002cdb88906ccba0$var$alignDirection
    })
]);
var $002cdb88906ccba0$var$defaultProps = {
    align: 'left',
    alignRight: false,
    flip: true
};
var $002cdb88906ccba0$var$DropdownMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, className = _ref.className, align = _ref.align, alignRight = _ref.alignRight, rootCloseEvent = _ref.rootCloseEvent, flip = _ref.flip, showProps = _ref.show, renderOnMount = _ref.renderOnMount, _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, popperConfig = _ref.popperConfig, props = (0, $7c6a7c90312158c1$export$2e2bcd8739ae039)(_ref, $002cdb88906ccba0$var$_excluded);
    var isNavbar = (0, $lx97N.useContext)((0, $0a5b2d4ab0a117ed$export$2e2bcd8739ae039));
    var prefix = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    var _usePopperMarginModif = (0, $af018ae24f36c1d8$export$2e2bcd8739ae039)(), popperRef = _usePopperMarginModif[0], marginModifiers = _usePopperMarginModif[1];
    var alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            var keys = Object.keys(align);
            if (keys.length) {
                var brkPoint = keys[0];
                var direction = align[brkPoint]; // .dropdown-menu-right is required for responsively aligning
                // left in addition to align left classes.
                // Reuse alignRight to toggle the class below.
                alignRight = direction === 'left';
                alignClasses.push(prefix + "-" + brkPoint + "-" + direction);
            }
        } else if (align === 'right') alignRight = true;
    }
    var _useDropdownMenu = (0, $9b8eb0d42f9320b9$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        alignEnd: alignRight,
        usePopper: !isNavbar && alignClasses.length === 0,
        popperConfig: (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, popperConfig, {
            modifiers: marginModifiers.concat((popperConfig == null ? void 0 : popperConfig.modifiers) || [])
        })
    }), menuProps = _useDropdownMenu[0], _useDropdownMenu$ = _useDropdownMenu[1], hasShown = _useDropdownMenu$.hasShown, popper = _useDropdownMenu$.popper, show = _useDropdownMenu$.show, alignEnd = _useDropdownMenu$.alignEnd, toggle = _useDropdownMenu$.toggle;
    menuProps.ref = (0, $e56555f462cc66b3$export$2e2bcd8739ae039)(popperRef, (0, $e56555f462cc66b3$export$2e2bcd8739ae039)((0, $a6c54c90e04a6318$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref));
    if (!hasShown && !renderOnMount) return null; // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = function() {
            return toggle == null ? void 0 : toggle(false);
        };
        menuProps.alignRight = alignEnd;
    }
    var style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, props.style, menuProps.style);
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, props, menuProps, {
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9))).apply(void 0, [
            className,
            prefix,
            show && 'show',
            alignEnd && prefix + "-right"
        ].concat(alignClasses))
    }));
});
$002cdb88906ccba0$var$DropdownMenu.displayName = 'DropdownMenu';
$002cdb88906ccba0$var$DropdownMenu.defaultProps = $002cdb88906ccba0$var$defaultProps;
var $002cdb88906ccba0$export$2e2bcd8739ae039 = $002cdb88906ccba0$var$DropdownMenu;





var $bqPQ9 = parcelRequire("bqPQ9");
var $22c3622b37f8fad7$exports = {};
'use strict';
Object.defineProperty($22c3622b37f8fad7$exports, "__esModule", {
    value: true
});
$22c3622b37f8fad7$exports.default = $22c3622b37f8fad7$var$isRequiredForA11y;
function $22c3622b37f8fad7$var$isRequiredForA11y(validator) {
    return function validate(props, propName, componentName, location, propFullName) {
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
        for(var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)args[_key - 5] = arguments[_key];
        return validator.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(args));
    };
}
$22c3622b37f8fad7$exports = $22c3622b37f8fad7$exports['default'];



var $lx97N = parcelRequire("lx97N");





var $bqPQ9 = parcelRequire("bqPQ9");

var $lx97N = parcelRequire("lx97N");


var $06a6a32525048fee$var$_excluded = [
    "bsPrefix",
    "variant",
    "size",
    "active",
    "className",
    "block",
    "type",
    "as"
];
var $06a6a32525048fee$var$defaultProps = {
    variant: 'primary',
    active: false,
    disabled: false
};
var $06a6a32525048fee$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, variant = _ref.variant, size = _ref.size, active = _ref.active, className = _ref.className, block = _ref.block, type = _ref.type, as = _ref.as, props = (0, $7c6a7c90312158c1$export$2e2bcd8739ae039)(_ref, $06a6a32525048fee$var$_excluded);
    var prefix = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(bsPrefix, 'btn');
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, prefix, active && 'active', variant && prefix + "-" + variant, block && prefix + "-block", size && prefix + "-" + size);
    if (props.href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $f5da0df6644ce0a9$export$2e2bcd8739ae039), (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, props, {
        as: as,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(classes, props.disabled && 'disabled')
    }));
    if (ref) props.ref = ref;
    if (type) props.type = type;
    else if (!as) props.type = 'button';
    var Component = as || 'button';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, props, {
        className: classes
    }));
});
$06a6a32525048fee$var$Button.displayName = 'Button';
$06a6a32525048fee$var$Button.defaultProps = $06a6a32525048fee$var$defaultProps;
var $06a6a32525048fee$export$2e2bcd8739ae039 = $06a6a32525048fee$var$Button;




var $e39af698d5b99f7a$var$_excluded = [
    "bsPrefix",
    "split",
    "className",
    "childBsPrefix",
    "as"
];
var $e39af698d5b99f7a$var$DropdownToggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, split = _ref.split, className = _ref.className, childBsPrefix = _ref.childBsPrefix, _ref$as = _ref.as, Component = _ref$as === void 0 ? (0, $06a6a32525048fee$export$2e2bcd8739ae039) : _ref$as, props = (0, $7c6a7c90312158c1$export$2e2bcd8739ae039)(_ref, $e39af698d5b99f7a$var$_excluded);
    var prefix = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    var _useDropdownToggle = (0, $314017411db3bcbf$export$96df6c7c5036b9a2)(), toggleProps = _useDropdownToggle[0];
    toggleProps.ref = (0, $e56555f462cc66b3$export$2e2bcd8739ae039)(toggleProps.ref, (0, $a6c54c90e04a6318$export$2e2bcd8739ae039)(ref, 'DropdownToggle')); // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, prefix, split && prefix + "-split")
    }, toggleProps, props));
});
$e39af698d5b99f7a$var$DropdownToggle.displayName = 'DropdownToggle';
var $e39af698d5b99f7a$export$2e2bcd8739ae039 = $e39af698d5b99f7a$var$DropdownToggle;







var $bqPQ9 = parcelRequire("bqPQ9");
var $36a74089419190fe$var$rHyphen = /-(.)/g;
function $36a74089419190fe$export$2e2bcd8739ae039(string) {
    return string.replace($36a74089419190fe$var$rHyphen, function(_, chr) {
        return chr.toUpperCase();
    });
}



var $lx97N = parcelRequire("lx97N");

var $6526e4f0adaa760e$var$_excluded = [
    "className",
    "bsPrefix",
    "as"
];
var $6526e4f0adaa760e$var$pascalCase = function pascalCase(str) {
    return str[0].toUpperCase() + (0, $36a74089419190fe$export$2e2bcd8739ae039)(str).slice(1);
};
function $6526e4f0adaa760e$export$2e2bcd8739ae039(prefix, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$displayName = _ref.displayName, displayName = _ref$displayName === void 0 ? $6526e4f0adaa760e$var$pascalCase(prefix) : _ref$displayName, Component = _ref.Component, defaultProps = _ref.defaultProps;
    var BsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(_ref2, ref) {
        var className = _ref2.className, bsPrefix = _ref2.bsPrefix, _ref2$as = _ref2.as, Tag = _ref2$as === void 0 ? Component || 'div' : _ref2$as, props = (0, $7c6a7c90312158c1$export$2e2bcd8739ae039)(_ref2, $6526e4f0adaa760e$var$_excluded);
        var resolvedPrefix = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(bsPrefix, prefix);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Tag, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, resolvedPrefix)
        }, props));
    });
    BsComponent.defaultProps = defaultProps;
    BsComponent.displayName = displayName;
    return BsComponent;
}


var $7b8061eec9f45780$var$_excluded = [
    "bsPrefix",
    "drop",
    "show",
    "className",
    "alignRight",
    "onSelect",
    "onToggle",
    "focusFirstItemOnShow",
    "as",
    "navbar"
];
var $7b8061eec9f45780$var$DropdownHeader = (0, $6526e4f0adaa760e$export$2e2bcd8739ae039)('dropdown-header', {
    defaultProps: {
        role: 'heading'
    }
});
var $7b8061eec9f45780$var$DropdownDivider = (0, $6526e4f0adaa760e$export$2e2bcd8739ae039)('dropdown-divider', {
    defaultProps: {
        role: 'separator'
    }
});
var $7b8061eec9f45780$var$DropdownItemText = (0, $6526e4f0adaa760e$export$2e2bcd8739ae039)('dropdown-item-text', {
    Component: 'span'
});
var $7b8061eec9f45780$var$defaultProps = {
    navbar: false
};
var $7b8061eec9f45780$var$Dropdown = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(function(pProps, ref) {
    var _useUncontrolled = (0, $fe0042ae49f115d3$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    }), bsPrefix = _useUncontrolled.bsPrefix, drop = _useUncontrolled.drop, show = _useUncontrolled.show, className = _useUncontrolled.className, alignRight = _useUncontrolled.alignRight, onSelect = _useUncontrolled.onSelect, onToggle = _useUncontrolled.onToggle, focusFirstItemOnShow = _useUncontrolled.focusFirstItemOnShow, _useUncontrolled$as = _useUncontrolled.as, Component = _useUncontrolled$as === void 0 ? 'div' : _useUncontrolled$as, _4 = _useUncontrolled.navbar, props = (0, $7c6a7c90312158c1$export$2e2bcd8739ae039)(_useUncontrolled, $7b8061eec9f45780$var$_excluded);
    var onSelectCtx = (0, $lx97N.useContext)((0, $d7b9013820928791$export$2e2bcd8739ae039));
    var prefix = (0, $3a392a0e60753bcc$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    var handleToggle = (0, $144b1b88ba290421$export$2e2bcd8739ae039)(function(nextShow, event, source) {
        if (source === void 0) source = event.type;
        if (event.currentTarget === document && (source !== 'keydown' || event.key === 'Escape')) source = 'rootClose';
        if (onToggle) onToggle(nextShow, event, {
            source: source
        });
    });
    var handleSelect = (0, $144b1b88ba290421$export$2e2bcd8739ae039)(function(key, event) {
        if (onSelectCtx) onSelectCtx(key, event);
        if (onSelect) onSelect(key, event);
        handleToggle(false, event, 'select');
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $d7b9013820928791$export$2e2bcd8739ae039).Provider, {
        value: handleSelect
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, $d47a2c7511b5d2c5$export$2e2bcd8739ae039), {
        drop: drop,
        show: show,
        alignEnd: alignRight,
        onToggle: handleToggle,
        focusFirstItemOnShow: focusFirstItemOnShow,
        itemSelector: "." + prefix + "-item:not(.disabled):not(:disabled)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(Component, (0, $53fb1bf72b92d037$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, show && 'show', (!drop || drop === 'down') && prefix, drop === 'up' && 'dropup', drop === 'right' && 'dropright', drop === 'left' && 'dropleft')
    }))));
});
$7b8061eec9f45780$var$Dropdown.displayName = 'Dropdown';
$7b8061eec9f45780$var$Dropdown.defaultProps = $7b8061eec9f45780$var$defaultProps;
$7b8061eec9f45780$var$Dropdown.Divider = $7b8061eec9f45780$var$DropdownDivider;
$7b8061eec9f45780$var$Dropdown.Header = $7b8061eec9f45780$var$DropdownHeader;
$7b8061eec9f45780$var$Dropdown.Item = (0, $eca3633eb94edb4a$export$2e2bcd8739ae039);
$7b8061eec9f45780$var$Dropdown.ItemText = $7b8061eec9f45780$var$DropdownItemText;
$7b8061eec9f45780$var$Dropdown.Menu = (0, $002cdb88906ccba0$export$2e2bcd8739ae039);
$7b8061eec9f45780$var$Dropdown.Toggle = (0, $e39af698d5b99f7a$export$2e2bcd8739ae039);
var $7b8061eec9f45780$export$2e2bcd8739ae039 = $7b8061eec9f45780$var$Dropdown;



var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");

var $1amKe = parcelRequire("1amKe");
function $740e1b02f8b0d5ed$export$602eac185826482c(props) {
    const [container] = (0, $lx97N.useState)(()=>document.createElement('div'));
    const { className: className, id: id, onOutsideClick: onOutsideClick, style: style, outsideClickOmitElements: outsideClickOmitElements = [] } = props;
    const outsideClick = (0, $lx97N.useCallback)((evt)=>{
        const elementsToCheck = [
            container
        ].concat(outsideClickOmitElements.map(({ current: current })=>current).filter((x)=>x !== null));
        if (onOutsideClick && !elementsToCheck.some((el)=>el.contains(evt?.target))) onOutsideClick(evt);
    }, [
        container,
        outsideClickOmitElements,
        onOutsideClick
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (style == null) container.setAttribute('style', '');
        else {
            container.setAttribute('style', '');
            for(const cssProperty in style)if (Object.hasOwn(style, cssProperty)) container.style[cssProperty] = style[cssProperty];
        }
    }, [
        container,
        style
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (id) container.setAttribute('id', id);
        else container.removeAttribute('id');
    }, [
        container,
        id
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (className) container.setAttribute('class', className);
        else container.removeAttribute('class');
    }, [
        container,
        className
    ]);
    (0, $lx97N.useEffect)(()=>{
        document.body.addEventListener('click', outsideClick);
        return ()=>{
            document.body.removeEventListener('click', outsideClick);
        };
    }, [
        outsideClick
    ]);
    (0, $lx97N.useEffect)(()=>{
        document.body.append(container);
        return ()=>{
            container.remove();
            document.body.removeEventListener('click', outsideClick);
        };
    }, []);
    return /*#__PURE__*/ (0, $1amKe.createPortal)(props.children, container);
}


var $5e6212b9b854c53f$exports = {};
"use strict";
// Basic
var $5e6212b9b854c53f$var$__createBinding = $5e6212b9b854c53f$exports && $5e6212b9b854c53f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e6212b9b854c53f$var$__exportStar = $5e6212b9b854c53f$exports && $5e6212b9b854c53f$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5e6212b9b854c53f$var$__createBinding(exports1, m, p);
};
Object.defineProperty($5e6212b9b854c53f$exports, "__esModule", {
    value: true
});

$5e6212b9b854c53f$var$__exportStar((parcelRequire("gBE7E")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("fxj72")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("18O95")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("6Qk6Y")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("hCvn3")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("aLLdg")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("3SsWc")), $5e6212b9b854c53f$exports);

// Utility types
$5e6212b9b854c53f$var$__exportStar((parcelRequire("5FoaD")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("6di5Y")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("826Qt")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("5znkU")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("3ivQF")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("7umGY")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("c711O")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("cuyV5")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("3aT4k")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("iWv1Y")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("ijG0x")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("80sFx")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("7eoVv")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("lEwRe")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("2gpfs")), $5e6212b9b854c53f$exports);

// Mark wrapper types
$5e6212b9b854c53f$var$__exportStar((parcelRequire("3Vkxu")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("dzp8H")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("2VTlv")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("2dPh2")), $5e6212b9b854c53f$exports);

// Deep wrapper types
$5e6212b9b854c53f$var$__exportStar((parcelRequire("f44sE")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("TEUFO")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("4CV9C")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("iwjHh")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("9MlXy")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("jcaqX")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("lvWIJ")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("kmyGy")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("gCqEc")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("e3rMY")), $5e6212b9b854c53f$exports);

// Key types
$5e6212b9b854c53f$var$__exportStar((parcelRequire("frWrQ")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("jr6el")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("iqHHC")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("79rLu")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("hsXeS")), $5e6212b9b854c53f$exports);

// Type checkers
$5e6212b9b854c53f$var$__exportStar((parcelRequire("hBBzx")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("jl7Pe")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("1RCnq")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("qC0PA")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("iZKF6")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("aBdu0")), $5e6212b9b854c53f$exports);

// Arrays and Tuples
$5e6212b9b854c53f$var$__exportStar((parcelRequire("4JBhu")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("gKJpE")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("eBqIe")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("cRANn")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("lFRTu")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("84Gvd")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("gLPd5")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("fAOwX")), $5e6212b9b854c53f$exports);

// Change case
$5e6212b9b854c53f$var$__exportStar((parcelRequire("1NWUE")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("1VUzl")), $5e6212b9b854c53f$exports);

// Function types
$5e6212b9b854c53f$var$__exportStar((parcelRequire("jCvsV")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("aaPpl")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("ZqD5T")), $5e6212b9b854c53f$exports);

// Utility functions
$5e6212b9b854c53f$var$__exportStar((parcelRequire("iAhPK")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("8QX3Q")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("hNUEX")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("b7U2G")), $5e6212b9b854c53f$exports);

$5e6212b9b854c53f$var$__exportStar((parcelRequire("jUUFV")), $5e6212b9b854c53f$exports);

// Build-in types
$5e6212b9b854c53f$var$__exportStar((parcelRequire("kOUOq")), $5e6212b9b854c53f$exports);



var $lx97N = parcelRequire("lx97N");
function $f334b8aa83e452cb$export$742d109d376a5f9c(pos, padding = 0) {
    const minX = scrollX + padding;
    const maxX = scrollX + innerWidth - padding;
    const minY = scrollY + padding;
    const maxY = scrollY + innerHeight - padding;
    if (pos.left >= minX && pos.right <= maxX && pos.top >= minY && pos.bottom <= maxY) return pos;
    const updated = {
        ...pos
    };
    if (pos.left < minX) {
        updated.left = minX;
        if (minX + pos.width > maxX) {
            updated.right = maxX;
            updated.width = updated.right - updated.left;
        } else updated.right = minX + pos.width;
    } else if (pos.right > maxX) {
        updated.right = maxX;
        if (maxX - pos.width < minX) {
            updated.left = minX;
            updated.width = updated.right - updated.left;
        } else updated.left = maxX - pos.width;
    }
    if (pos.top < minY) {
        updated.top = minY;
        if (minY + pos.height > maxY) {
            updated.bottom = maxY;
            updated.height = updated.bottom - updated.top;
        } else updated.bottom = minY + pos.height;
    } else if (pos.bottom > maxY) {
        updated.bottom = maxY;
        if (maxY - pos.height < minY) {
            updated.top = minY;
            updated.height = updated.bottom - updated.top;
        } else updated.top = maxY - pos.height;
    }
    return updated;
}


const $354d3f329f2d8989$export$8f043fac12039c38 = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: 0,
    height: 0
};
function $354d3f329f2d8989$export$1ee1474ec30a3ba1(element) {
    const rect = element.getBoundingClientRect();
    return {
        top: rect.top + window.scrollY,
        right: rect.right + window.scrollX,
        bottom: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width,
        height: rect.height
    };
}



var $lx97N = parcelRequire("lx97N");
function $e4626085a6a9ad0b$export$eb9739a41f343665() {
    const [nonce, setNonce] = (0, $lx97N.useState)(0);
    const triggerChange = (0, $lx97N.useCallback)(()=>{
        setNonce(nonce + 1);
    }, [
        nonce
    ]);
    return triggerChange;
}


function $3e21be74d564d85d$export$2c54258d8bcc9e50(pos, width, height) {
    const updated = {
        ...pos
    };
    if (width != null) {
        updated.width = width;
        updated.right = pos.left + width;
    }
    if (height != null) {
        updated.height = height;
        updated.bottom = pos.top + height;
    }
    return updated;
}


function $ca7aede4e5dcaacf$export$458a9c11d1806c6d(pos, translateX, translateY) {
    const updated = {
        ...pos
    };
    updated.left += translateX;
    updated.right += translateX;
    updated.top += translateY;
    updated.bottom += translateY;
    return updated;
}


function $e17239922722c3a5$var$getTranslateX(anchor, pos) {
    switch(anchor){
        case 'Bottom':
            return 0;
        case 'Right':
            return pos.width;
        default:
            throw new (0, $5e6212b9b854c53f$exports.UnreachableCaseError)(anchor);
    }
}
function $e17239922722c3a5$var$getTranslateY(anchor, pos) {
    switch(anchor){
        case 'Right':
            return 0;
        case 'Bottom':
            return pos.height;
        default:
            throw new (0, $5e6212b9b854c53f$exports.UnreachableCaseError)(anchor);
    }
}
function $e17239922722c3a5$export$aa756028c6395a46(target, overlay, anchor = 'Bottom') {
    const [overlayPos, setOverlayPos] = (0, $lx97N.useState)((0, $354d3f329f2d8989$export$8f043fac12039c38));
    const recalculate = (0, $e4626085a6a9ad0b$export$eb9739a41f343665)();
    (0, $lx97N.useEffect)(()=>{
        if (target.current != null && overlay.current != null) {
            const listPos = (0, $354d3f329f2d8989$export$1ee1474ec30a3ba1)(overlay.current);
            let pos = (0, $354d3f329f2d8989$export$1ee1474ec30a3ba1)(target.current);
            pos = (0, $ca7aede4e5dcaacf$export$458a9c11d1806c6d)(pos, $e17239922722c3a5$var$getTranslateX(anchor, pos), $e17239922722c3a5$var$getTranslateY(anchor, pos));
            pos = (0, $3e21be74d564d85d$export$2c54258d8bcc9e50)(pos, listPos.width, listPos.height);
            pos = (0, $f334b8aa83e452cb$export$742d109d376a5f9c)(pos);
            setOverlayPos(pos);
        }
    }, [
        anchor,
        target,
        overlay,
        recalculate
    ]);
    return [
        overlayPos,
        recalculate
    ];
}



function $21b65b89550892f2$var$thunkFromMany(...args) {
    return (...called)=>{
        for (const thunk of args)thunk(...called);
    };
}
function $21b65b89550892f2$var$listen(...args) {
    document.addEventListener(...args);
    return ()=>{
        document.removeEventListener(...args);
    };
}
function $21b65b89550892f2$export$28c660c63b792dea({ id: id, parentRef: parentRef, children: children, className: className, backgroundColor: backgroundColor, textColor: textColor }) {
    const tooltipId = `tooltip-${id}`;
    const tooltipRef = (0, $lx97N.useRef)(null);
    const [overlayPos, recalculate] = (0, $e17239922722c3a5$export$aa756028c6395a46)(parentRef, tooltipRef, 'Right');
    const [visible, setVisible] = (0, $lx97N.useState)(false);
    (0, $lx97N.useEffect)(()=>{
        function handleActiveArea(fn) {
            return (evt)=>{
                if (parentRef.current === null) return;
                if (evt.target === parentRef.current || parentRef.current.contains(evt.target)) {
                    fn();
                    recalculate();
                }
            };
        }
        const onActivate = handleActiveArea(()=>setVisible(true));
        const onDeactivate = handleActiveArea(()=>setVisible(false));
        return $21b65b89550892f2$var$thunkFromMany($21b65b89550892f2$var$listen('mouseover', onActivate, true), $21b65b89550892f2$var$listen('mouseout', onDeactivate, false));
    }, [
        parentRef,
        recalculate
    ]);
    const style = {
        top: `${overlayPos.top}px`,
        left: `${overlayPos.left}px`,
        backgroundColor: undefined,
        color: undefined
    };
    if (backgroundColor) style.backgroundColor = backgroundColor;
    if (textColor) style.color = textColor;
    return visible ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $740e1b02f8b0d5ed$export$602eac185826482c), {
        className: "shared-tooltip-overlay",
        style: style,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
            role: "tooltip",
            ref: tooltipRef,
            id: tooltipId,
            className: className,
            children: children
        })
    }) : null;
}



var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $bqPQ9 = parcelRequire("bqPQ9");
/**
 * The full list of Material Icons can be found here https://fonts.google.com/icons
 */ 
var $fRwNr = parcelRequire("fRwNr");
parcelRequire("lx97N");

var $bqPQ9 = parcelRequire("bqPQ9");

var $37w0r = parcelRequire("37w0r");

function $2fb22e7c49507fb9$export$f04a61298a47a40f({ name: name, className: className, onClick: onClick, testId: testId = '', outlined: outlined = false, label: label, disabled: disabled = false }) {
    return (0, $37w0r.isFunction)(onClick) ? /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
        "data-testid": testId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))('icon-button', 'material-icons', 'qep-icon', className, {
            'material-icons-outlined': outlined
        }, disabled ? 'disabled' : ''),
        onClick: ()=>onClick(),
        "aria-label": label,
        disabled: disabled,
        children: name
    }) : /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
        "data-testid": testId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))('material-icons', 'qep-icon', className, {
            'material-icons-outlined': outlined
        }, disabled ? 'disabled' : ''),
        children: name
    });
}



var $jZinT = parcelRequire("jZinT");

const $891095072eae630d$export$c1b020d7028bfc5a = /*#__PURE__*/ (0, $lx97N.forwardRef)(function Inputfield({ id: id = '', value: value = '', placeholder: placeholder, onChange: onChange, onClickIcon: onClickIcon = ()=>{}, canClickIcon: canClickIcon = false, iconType: iconType = 'clear', className: className, disabled: disabled = false, autoFocus: autoFocus = false, allowSpecialCharacters: allowSpecialCharacters = true, maxLength: maxLength }, ref) {
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))('qep-inputfield', className),
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $jZinT.QEPInput), {
                id: id,
                ref: ref,
                type: "text",
                value: value,
                placeholder: placeholder,
                onChange: (e)=>onChange(e.target.value),
                disabled: disabled,
                autoFocus: autoFocus,
                allowSpecialCharacters: allowSpecialCharacters,
                maxLength: maxLength
            }),
            canClickIcon && /*#__PURE__*/ (0, $fRwNr.jsx)((0, $2fb22e7c49507fb9$export$f04a61298a47a40f), {
                testId: `${id}-icon`,
                className: "overlay-icons right",
                name: iconType,
                onClick: ()=>onClickIcon()
            })
        ]
    });
});



var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

const $5865ecd84ee9ea11$var$SearchableDropdownToggle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef(({ onChange: onChange, placeholder: placeholder, ...props }, ref)=>/*#__PURE__*/ (0, $fRwNr.jsx)((0, $891095072eae630d$export$c1b020d7028bfc5a), {
        id: "searchable-account-dropdown",
        ref: ref,
        value: props.value || '',
        onChange: onChange,
        placeholder: placeholder,
        autoFocus: true,
        ...props
    }));
var $5865ecd84ee9ea11$export$2e2bcd8739ae039 = $5865ecd84ee9ea11$var$SearchableDropdownToggle;



function $6d6c4d0122241297$var$DropdownItem({ id: id, name: name, description: description }) {
    const parentRef = (0, $lx97N.useRef)(null);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $7b8061eec9f45780$export$2e2bcd8739ae039).Item, {
        eventKey: id,
        "data-testid": id,
        ref: parentRef,
        id: `dropdown-item-${id}`,
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                className: "dropdown-menu-text",
                children: name
            }),
            description ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $21b65b89550892f2$export$28c660c63b792dea), {
                id: id,
                parentRef: parentRef,
                className: "dropdown-tooltip",
                children: description
            }) : null
        ]
    });
}
const $6d6c4d0122241297$var$EMPTY_ID = '@@Dropdown/Empty';
const $6d6c4d0122241297$export$bfd5360b2df29b09 = '@@Dropdown/Custom';
function $6d6c4d0122241297$export$931cbfb6bfb85fc({ id: id, items: items, selectedItem: selectedItem, defaultItem: defaultItem, custom: custom, onChange: onChange = ()=>{}, onCustom: onCustom, className: className = '', placeholder: placeholder = 'Select option', emptyMessage: emptyMessage = 'No options available', disabled: disabled = false, testId: testId = 'dropdown', endAdornment: endAdornment, isFlex: isFlex, searchable: searchable = false, customMaxLength: customMaxLength, customAllowSpecialCharacters: customAllowSpecialCharacters = true }) {
    const [filter, setFilter] = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useState('');
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useState(false);
    items = onCustom ? [
        ...items,
        {
            id: $6d6c4d0122241297$export$bfd5360b2df29b09,
            name: 'Custom'
        }
    ] : items;
    const displayItem = items.find((item)=>item.id === selectedItem) ?? (items.length === 0 ? {
        name: emptyMessage
    } : {
        name: placeholder
    });
    items = items.length === 0 ? [
        {
            id: $6d6c4d0122241297$var$EMPTY_ID,
            name: emptyMessage
        }
    ] : items;
    const filteredItems = filter === '' ? items : items.filter((i)=>{
        const searchValue = filter.toLowerCase();
        return i.name.toLowerCase().includes(searchValue) || i.code?.toLowerCase().includes(searchValue);
    });
    const handleChange = (0, $lx97N.useCallback)((id)=>{
        if (id !== $6d6c4d0122241297$var$EMPTY_ID) {
            onChange(id ?? defaultItem ?? '');
            if (id === $6d6c4d0122241297$export$bfd5360b2df29b09) onCustom?.('');
        }
    }, [
        onChange,
        onCustom,
        defaultItem
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (!open) setFilter('');
    }, [
        open
    ]);
    const removeCustom = (0, $lx97N.useCallback)(()=>{
        onChange(defaultItem ?? '');
        onCustom?.(null);
    }, [
        onChange,
        onCustom,
        defaultItem
    ]);
    if (selectedItem === $6d6c4d0122241297$export$bfd5360b2df29b09) return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $891095072eae630d$export$c1b020d7028bfc5a), {
        id: id,
        autoFocus: true,
        value: custom ?? undefined,
        iconType: "undo",
        placeholder: "Custom",
        canClickIcon: true,
        onClickIcon: removeCustom,
        onChange: (value)=>onCustom?.(value),
        maxLength: customMaxLength,
        allowSpecialCharacters: customAllowSpecialCharacters
    });
    const SearchableMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).forwardRef((props, ref)=>/*#__PURE__*/ (0, $fRwNr.jsx)((0, $5865ecd84ee9ea11$export$2e2bcd8739ae039), {
            ref: ref,
            value: filter,
            onChange: setFilter,
            placeholder: displayItem.code ?? displayItem.name,
            ...props
        }));
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))('qep-dropdown', className),
        style: {
            flex: isFlex ? 1 : ''
        },
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $7b8061eec9f45780$export$2e2bcd8739ae039), {
            onSelect: handleChange,
            "data-testid": testId,
            onToggle: (show)=>{
                setOpen(show);
            },
            children: [
                open ? searchable ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $7b8061eec9f45780$export$2e2bcd8739ae039).Toggle, {
                    bsPrefix: "no-carrot",
                    as: SearchableMenu
                }) : /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $7b8061eec9f45780$export$2e2bcd8739ae039).Toggle, {
                    id: id,
                    disabled: disabled,
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                            className: "dropdown-display-text",
                            children: displayItem.code ? displayItem.code : displayItem.name ?? ''
                        }),
                        endAdornment && /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                            className: "end-adornment",
                            children: endAdornment
                        })
                    ]
                }) : /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $7b8061eec9f45780$export$2e2bcd8739ae039).Toggle, {
                    id: id,
                    disabled: disabled,
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                            className: "dropdown-display-text",
                            children: displayItem.code ? displayItem.code : displayItem.name ?? ''
                        }),
                        endAdornment && /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                            className: "end-adornment",
                            children: endAdornment
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $7b8061eec9f45780$export$2e2bcd8739ae039).Menu, {
                    className: searchable ? 'fixed' : '',
                    children: filteredItems.map((item)=>/*#__PURE__*/ (0, $fRwNr.jsx)($6d6c4d0122241297$var$DropdownItem, {
                            ...item
                        }, item.id))
                })
            ]
        })
    });
}




var $dOkZL = parcelRequire("dOkZL");

const $15af75126aa6835a$export$1d3608e3fc9963fd = (account, value)=>({
        ...value,
        account: account,
        tradeIntention: account.tradeIntentions[0],
        customText2: account.customText2 || '',
        customText3: account.customText3 || ''
    });
function $15af75126aa6835a$export$2e2bcd8739ae039(props) {
    const { accounts: accounts, value: value, onChange: onChange = ()=>{}, placeholder: placeholder, invalidAccountTextFields: invalidFields, setAccountTextFieldInvalid: setFieldInvalidState } = props;
    if (!value) return null;
    const accountDropDownItems = accounts.map(({ id: id, code: code, description: description })=>({
            id: id,
            code: code,
            name: description,
            description: `Acct: ${code}`
        }));
    const getAccountById = (id)=>accounts.find((account)=>account.id === id);
    const account = getAccountById(value?.account?.id);
    const tradeIntentions = account?.tradeIntentions || [];
    const tradeIntentionDropDownItems = tradeIntentions?.map((tradeIntention)=>({
            id: tradeIntention.id,
            name: tradeIntention.tradeIntentionName
        })) || [];
    const onChangeAccount = (id)=>{
        const account = getAccountById(id);
        if (!account) return;
        const newValue = $15af75126aa6835a$export$1d3608e3fc9963fd(account, value || null);
        onChange(newValue);
    };
    const changeValue = (name, updatedValue)=>{
        if (typeof updatedValue === 'string' && (name === 'memo' || name === 'customText2')) {
            if (!(0, $dOkZL.isValidAccountText)(updatedValue)) {
                setFieldInvalidState(name, true);
                (0, $dOkZL.notifyInvalidAccountText)(updatedValue);
                return;
            }
            setFieldInvalidState(name, false);
        }
        onChange({
            ...value,
            [name]: updatedValue
        });
    };
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        style: {
            width: '100%',
            height: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: `qep-account-selector ${props.classes || ''}`.trim(),
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "selector-section",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $6d6c4d0122241297$export$931cbfb6bfb85fc), {
                                className: "code-selector",
                                id: "account-code-selector",
                                selectedItem: value?.account?.id || '',
                                items: accountDropDownItems,
                                emptyMessage: "No accounts available",
                                onChange: onChangeAccount,
                                searchable: true,
                                placeholder: placeholder || 'Select Option'
                            }),
                            props.showSelectedLabel && /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                                className: "account",
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("i", {
                                        children: "Acc."
                                    }),
                                    "\xa0",
                                    account?.code
                                ]
                            })
                        ]
                    }),
                    !props.blockCustomization && /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $891095072eae630d$export$c1b020d7028bfc5a), {
                            id: "memo-field",
                            value: value?.memo,
                            inputClassName: invalidFields.memo ? 'error' : '',
                            className: "memo",
                            iconType: "undo",
                            placeholder: "Memo",
                            canClickIcon: !!value?.memo,
                            onClickIcon: ()=>changeValue('memo', ''),
                            onChange: (value)=>changeValue('memo', value),
                            allowSpecialCharacters: false,
                            maxLength: 200
                        })
                    })
                ]
            }),
            !props.blockCustomization && /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "flex qep-orderentry-account-selector",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $6d6c4d0122241297$export$931cbfb6bfb85fc), {
                            id: "trade-intentions",
                            className: "code-selector",
                            items: tradeIntentionDropDownItems,
                            selectedItem: value?.tradeIntention?.id || '',
                            onChange: (id)=>changeValue('tradeIntention', tradeIntentions.find((ti)=>ti.id === id)),
                            customAllowSpecialCharacters: false,
                            customMaxLength: 200
                        })
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $891095072eae630d$export$c1b020d7028bfc5a), {
                            id: "customText2",
                            value: value?.customText2,
                            inputClassName: invalidFields.customText2 ? 'error' : '',
                            className: "note",
                            iconType: "undo",
                            placeholder: "Custom Text 2",
                            canClickIcon: account?.customText2 !== value?.customText2,
                            onClickIcon: ()=>changeValue('customText2', account?.customText2),
                            onChange: (value)=>changeValue('customText2', value),
                            allowSpecialCharacters: false,
                            maxLength: 200
                        })
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $891095072eae630d$export$c1b020d7028bfc5a), {
                            id: "customText3",
                            value: value?.customText3,
                            className: "note",
                            iconType: "undo",
                            placeholder: "Custom Text 3",
                            canClickIcon: account?.customText3 !== value?.customText3,
                            onClickIcon: ()=>changeValue('customText3', account?.customText3),
                            onChange: (value)=>changeValue('customText3', value),
                            allowSpecialCharacters: false,
                            maxLength: 200
                        })
                    })
                ]
            })
        ]
    });
}



var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $c0UaQ = parcelRequire("c0UaQ");


var $dOkZL = parcelRequire("dOkZL");
/**
 * Creates selected account defaults from an existing leg account or first account fallback.
 */ function $84ad039cac3b757e$var$resolveInitialAccountSelectorValue(accounts, leg) {
    if (accounts.length === 0) return undefined;
    if (leg?.account) {
        const legAccount = leg.account;
        const [tradeIntentionName = '', customText2 = '', customText3 = ''] = legAccount.notes ?? [];
        const account = accounts.find((account)=>account.id === legAccount.id || account.neovestAccount === legAccount.accountId && account.code === legAccount.execCode) ?? accounts[0];
        const tradeIntentions = account.tradeIntentions ?? [];
        let tradeIntention;
        if (legAccount.tradeIntentionId) tradeIntention = tradeIntentions.find((ti)=>ti.id === legAccount.tradeIntentionId);
        else tradeIntention = tradeIntentions.find((ti)=>ti.tradeIntentionName === tradeIntentionName);
        return {
            account: account,
            memo: legAccount.memo,
            tradeIntention: tradeIntention,
            customText1: tradeIntentionName === tradeIntention?.tradeIntentionName ? undefined : tradeIntentionName,
            customText2: customText2,
            customText3: customText3
        };
    }
    return (0, $876528fe07563bf3$export$1f974c752a5b2a76)(accounts[0]);
}
/**
 * Maps selected account model into shared order details modal draft values.
 */ function $84ad039cac3b757e$var$mapSelectedAccountToDetails(accountSelectorValue) {
    return {
        memo: accountSelectorValue.memo ?? '',
        customTag1: accountSelectorValue.customText1 ?? accountSelectorValue.tradeIntention?.tradeIntentionName ?? '',
        customTag2: accountSelectorValue.customText2 ?? '',
        customTag3: accountSelectorValue.customText3 ?? ''
    };
}
/**
 * Converts shared order details values back into the selected account shape expected by consumers.
 */ function $84ad039cac3b757e$var$mapDetailsToSelectedAccount(currentValue, details) {
    const matchedTradeIntention = (currentValue.account.tradeIntentions ?? []).find((tradeIntention)=>tradeIntention.tradeIntentionName === details.customTag1);
    return {
        ...currentValue,
        memo: details.memo ?? '',
        tradeIntention: matchedTradeIntention,
        customText1: matchedTradeIntention ? undefined : details.customTag1 ?? '',
        customText2: details.customTag2 ?? '',
        customText3: details.customTag3 ?? ''
    };
}
/**
 * Validates free text fields before submitting account detail edits.
 */ function $84ad039cac3b757e$var$validateDetails(details) {
    for (const value of [
        details.memo,
        details.customTag1,
        details.customTag2
    ])if (typeof value === 'string' && !(0, $dOkZL.isValidAccountText)(value)) {
        (0, $dOkZL.notifyInvalidAccountText)(value);
        return false;
    }
    return true;
}
var $84ad039cac3b757e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $lx97N.memo)(function AccountSelectModal({ accounts: accounts = [], leg: leg, submitted: submitted = false, show: show = false, onCancel: onCancel = ()=>{}, onContinue: onContinue = ()=>{} }) {
    const [accountSelectorValue, setAccountSelectorValue] = (0, $lx97N.useState)();
    /**
   * Handles modal save and forwards selected account updates when valid.
   */ const handleSave = (details)=>{
        if (submitted || !accountSelectorValue) return;
        if (!$84ad039cac3b757e$var$validateDetails(details)) return;
        const nextSelectedAccount = $84ad039cac3b757e$var$mapDetailsToSelectedAccount(accountSelectorValue, details);
        onContinue(nextSelectedAccount);
    };
    (0, $lx97N.useEffect)(()=>{
        if (!show) return;
        setAccountSelectorValue($84ad039cac3b757e$var$resolveInitialAccountSelectorValue(accounts, leg));
    }, [
        accounts,
        leg,
        show
    ]);
    if (!show || !accountSelectorValue) return null;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $c0UaQ.default), {
        initialDetails: $84ad039cac3b757e$var$mapSelectedAccountToDetails(accountSelectorValue),
        customTag1Options: (accountSelectorValue.account.tradeIntentions ?? []).map((ti)=>ti.tradeIntentionName),
        onClose: onCancel,
        onSave: handleSave
    });
});


const $3e9503773636c6e2$var$sortByDescription = (accounts)=>accounts.sort((accA, accB)=>accA?.description?.localeCompare(accB?.description));
const $3e9503773636c6e2$export$54ce32906d15f0b6 = (props)=>{
    const { accountsConfig: accountsConfig, selectedAccount: selectedAccount, editingAccount: editingAccount = false, placeholder: placeholder, showSelectedLabel: showSelectedLabel = true, tradeable: tradeable = false, allowEmpty: allowEmpty = false } = props;
    const [allAccounts, setAllAccounts] = (0, $lx97N.useState)(accountsConfig?.accounts || []);
    const [accounts, setAccounts] = (0, $lx97N.useState)(accountsConfig?.accounts || []);
    const [accountSelectorValue, setAccountSelectorValue] = (0, $lx97N.useState)();
    const [isLoading, setIsLoading] = (0, $lx97N.useState)(!accountsConfig?.accounts);
    const [editAccountDetails, setEditAccountDetails] = (0, $lx97N.useState)(null);
    const [isEditModalOpen, setIsEditModalOpen] = (0, $lx97N.useState)(false);
    const [submittedEdit, setSubmittedEdit] = (0, $lx97N.useState)(false);
    const [inlineAccountTextInvalidFields, setInlineAccountTextInvalidFields] = (0, $lx97N.useState)({
        memo: false,
        customText2: false
    });
    /**
   * Resolves the best available account details payload for the edit modal.
   */ const getAccountDetailsForModal = (0, $lx97N.useCallback)(()=>{
        const fallbackAccount = accounts[0];
        const resolvedSelectedAccount = accountSelectorValue ?? selectedAccount ?? (fallbackAccount ? (0, $876528fe07563bf3$export$139cde87e304488d)(fallbackAccount) : undefined);
        if (!resolvedSelectedAccount?.account) return null;
        const hydratedAccount = allAccounts.find((account)=>account.id === resolvedSelectedAccount.account.id) ?? resolvedSelectedAccount.account;
        const accountDetails = structuredClone(hydratedAccount) ?? {};
        // @ts-expect-error
        if (resolvedSelectedAccount.customText1) accountDetails.customText1 = resolvedSelectedAccount.customText1;
        if (resolvedSelectedAccount.customText2) accountDetails.customText2 = resolvedSelectedAccount.customText2;
        if (resolvedSelectedAccount.customText3) accountDetails.customText3 = resolvedSelectedAccount.customText3;
        if (resolvedSelectedAccount.memo) accountDetails.memo = resolvedSelectedAccount.memo;
        if (resolvedSelectedAccount?.tradeIntention) accountDetails.tradeIntentionId = resolvedSelectedAccount.tradeIntention.id;
        accountDetails.notes = [
            resolvedSelectedAccount.customText1 ?? resolvedSelectedAccount.tradeIntention?.tradeIntentionName ?? '',
            resolvedSelectedAccount.customText2 ?? resolvedSelectedAccount.account.customText2,
            resolvedSelectedAccount.customText3 ?? resolvedSelectedAccount.account.customText3
        ];
        return {
            account: accountDetails
        };
    }, [
        accountSelectorValue,
        selectedAccount,
        accounts,
        allAccounts
    ]);
    (0, $lx97N.useEffect)(()=>{
        const fetchAccounts = async ()=>{
            try {
                let tempAccounts = await (0, $9vFCJ.getUserAccountsFromTraderDB)();
                if (tradeable) tempAccounts = tempAccounts.filter((acc)=>acc.action === 'Trading').sort((a, b)=>a.code.localeCompare(b.code));
                setAllAccounts($3e9503773636c6e2$var$sortByDescription(tempAccounts));
                if (accountsConfig?.productForFiltering) {
                    const newAccounts = (0, $1e9c2f618fcdc64e$export$c7104f5acad85356)(tempAccounts, accountsConfig?.productForFiltering);
                    if (newAccounts.length > 0) {
                        tempAccounts = newAccounts;
                        setAccounts($3e9503773636c6e2$var$sortByDescription(tempAccounts));
                    }
                } else setAccounts($3e9503773636c6e2$var$sortByDescription(tempAccounts));
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching accounts in account selector', error);
            }
        };
        if (!accountsConfig?.accounts && accounts.length === 0) fetchAccounts();
    }, []);
    (0, $lx97N.useEffect)(()=>{
        if (accounts?.length !== 0) setIsLoading(false);
        if (accounts && accounts.length > 0 && !selectedAccount && !allowEmpty) {
            const startAccount = {
                account: accounts[0],
                tradeIntention: accounts[0].tradeIntentions[0],
                memo: accounts[0].memo,
                customText2: accounts[0].customText2,
                customText3: accounts[0].customText3
            };
            setAccountSelectorValue(startAccount);
            props?.onChange(startAccount);
        }
    }, [
        accounts
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (accountsConfig?.productForFiltering) {
            const newAccounts = (0, $1e9c2f618fcdc64e$export$c7104f5acad85356)(allAccounts, accountsConfig?.productForFiltering);
            setAccounts($3e9503773636c6e2$var$sortByDescription(newAccounts));
            if (allowEmpty) newAccounts.unshift({
                id: '',
                code: 'No default strategy',
                description: 'No default strategy',
                tradeIntentions: [],
                customText2: '',
                customText3: '',
                memo: '',
                isActive: true,
                action: 'Trading',
                isGDP: true,
                neovestAccount: '',
                exchangeName: '',
                clearingString: '',
                lei: '',
                productSpecifications: []
            });
            if (!allowEmpty) {
                const currentAccount = newAccounts.find((acc)=>acc.id === selectedAccount?.account?.id);
                if (!currentAccount && newAccounts.length > 0) props.onChange((0, $876528fe07563bf3$export$139cde87e304488d)(newAccounts[0]));
            }
        } else setAccounts($3e9503773636c6e2$var$sortByDescription(allAccounts));
    }, [
        accountsConfig?.productForFiltering
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (!selectedAccount) return;
        setAccountSelectorValue(selectedAccount);
        setSubmittedEdit(false);
        setEditAccountDetails(null);
    }, [
        selectedAccount
    ]);
    (0, $lx97N.useEffect)(()=>{
        setSubmittedEdit(false);
        if (editingAccount) {
            const nextEditAccountDetails = getAccountDetailsForModal();
            setEditAccountDetails(nextEditAccountDetails);
            setIsEditModalOpen(true);
        } else {
            setEditAccountDetails(null);
            setIsEditModalOpen(false);
        }
    }, [
        editingAccount,
        getAccountDetailsForModal
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "loader-container",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        children: "Loading accounts..."
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: "loader",
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $64f24436fd4c18e5$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            !isLoading && /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $84ad039cac3b757e$export$2e2bcd8739ae039), {
                        accounts: allAccounts,
                        show: isEditModalOpen,
                        leg: editAccountDetails,
                        submitted: submittedEdit,
                        onCancel: ()=>{
                            setIsEditModalOpen(false);
                            setEditAccountDetails(null);
                            if (props.onCancel) props.onCancel();
                        },
                        onContinue: (account)=>{
                            setAccountSelectorValue(account);
                            setSubmittedEdit(true);
                            setIsEditModalOpen(false);
                            setEditAccountDetails(null);
                            if (props.onChange) props.onChange(account);
                        }
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $15af75126aa6835a$export$2e2bcd8739ae039), {
                        classes: props.classes,
                        "data-testid": "account-selector",
                        blockCustomization: props.blockCustomization,
                        showSelectedLabel: showSelectedLabel,
                        accounts: accounts,
                        value: accountSelectorValue,
                        invalidAccountTextFields: inlineAccountTextInvalidFields,
                        setAccountTextFieldInvalid: (key, invalid)=>{
                            setInlineAccountTextInvalidFields((current)=>({
                                    ...current,
                                    [key]: invalid
                                }));
                        },
                        onChange: (value)=>{
                            setAccountSelectorValue(value);
                            if (props.onChange) props.onChange(value);
                        },
                        placeholder: placeholder
                    })
                ]
            })
        ]
    });
};



var $lx97N = parcelRequire("lx97N");

/** Renders the authoritative default-account selection for a tradable symbol. */ const $f4c60670bfc0b8f0$var$AccountSelectorDropdown = (props)=>{
    const { tradableSymbol: symbol, accounts: accounts } = props;
    // @ts-expect-error Empty object will render as no selection - 'No default strategy'
    const [selectionInAccounts, setSelectionInAccounts] = (0, $lx97N.useState)({});
    /** Mirrors authoritative account updates so API responses cannot leave the dropdown showing stale state. */ (0, $lx97N.useEffect)(()=>{
        const acc = accounts.find((acc)=>acc.id === symbol.defaultAccount);
        if (acc) // @ts-expect-error Additional properties not required because account details can't be edited on this screen
        setSelectionInAccounts({
            account: acc
        });
        else // @ts-expect-error Empty object renders the supported "No default strategy" selection
        setSelectionInAccounts({});
    }, [
        accounts,
        symbol.defaultAccount
    ]);
    /** Propagates a resolved account, or undefined on clear so the parent removes the saved default. */ const _handleChange = (value)=>{
        if (value?.account === undefined || value.account.id === '') props.handleChange(undefined, symbol);
        else {
            const account = accounts.find((acc)=>acc.id === value?.account?.id);
            if (account) props.handleChange(account, symbol);
        }
    };
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "dropdown-container",
        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $3e9503773636c6e2$export$54ce32906d15f0b6), {
            accountsConfig: {
                accounts: accounts.filter((acc)=>acc.action === 'Trading'),
                productForFiltering: symbol
            },
            allowEmpty: true,
            blockCustomization: true,
            showSelectedLabel: false,
            selectedAccount: selectionInAccounts,
            onChange: _handleChange
        })
    });
};
var $f4c60670bfc0b8f0$export$2e2bcd8739ae039 = $f4c60670bfc0b8f0$var$AccountSelectorDropdown;



var $fRwNr = parcelRequire("fRwNr");

var $jZinT = parcelRequire("jZinT");

var $lx97N = parcelRequire("lx97N");
/** Renders an iceberg display-quantity control that preserves accepted input until blur resolves the edit. */ const $26d9a478978bf163$var$DefaultDisplayQuantitySetter = ({ tradableSymbol: symbol, handleChange: handleChange })=>{
    const [displayQty, setDisplayQty] = (0, $lx97N.useState)(symbol.icebergDisplayQty ? String(symbol.icebergDisplayQty) : '0');
    const hasUnsavedEdit = (0, $lx97N.useRef)(false);
    const hasInvalidEdit = (0, $lx97N.useRef)(false);
    /** Applies authoritative API updates when no edit is pending so the field does not retain a stale value. */ (0, $lx97N.useEffect)(()=>{
        if (!hasUnsavedEdit.current) setDisplayQty(symbol.icebergDisplayQty ? String(symbol.icebergDisplayQty) : '0');
    }, [
        symbol.icebergDisplayQty,
        symbol.rootSymbol,
        symbol.segmentMic
    ]);
    /** Stores a valid non-negative edit and marks it dirty so authoritative updates cannot overwrite it. */ const onDisplayQtyChanged = (event)=>{
        const newQty = Number(event.target.value);
        if (Number.isNaN(newQty) || newQty < 0) {
            hasInvalidEdit.current = true;
            return;
        }
        hasInvalidEdit.current = false;
        hasUnsavedEdit.current = true;
        setDisplayQty(event.target.value);
    };
    /** Ends the edit lifecycle, restoring rejected edits or committing an accepted quantity while iceberg remains enabled. */ const onDisplayQtyBlur = (event)=>{
        const hasAcceptedEdit = hasUnsavedEdit.current;
        hasUnsavedEdit.current = false;
        if (hasInvalidEdit.current) {
            hasInvalidEdit.current = false;
            setDisplayQty(symbol.icebergDisplayQty ? String(symbol.icebergDisplayQty) : '0');
            return;
        }
        if (!hasAcceptedEdit) return;
        if (!symbol.isIceberg) return;
        const inputValue = event.target.value;
        const numberValue = Number(inputValue);
        if (inputValue && !Number.isNaN(numberValue) && numberValue > 0) {
            setDisplayQty(inputValue);
            handleChange(numberValue, symbol);
        } else {
            setDisplayQty('0');
            handleChange(0, symbol);
        }
    };
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $jZinT.QEPInput), {
        className: "qty-input display-qty-input",
        "data-testid": "display-qty-input",
        disabled: !symbol.isIceberg,
        onBlur: onDisplayQtyBlur,
        onChange: onDisplayQtyChanged,
        pattern: "[0-9]*",
        type: "number",
        value: displayQty
    });
};
var $26d9a478978bf163$export$2e2bcd8739ae039 = $26d9a478978bf163$var$DefaultDisplayQuantitySetter;



var $fRwNr = parcelRequire("fRwNr");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $fMSjE = parcelRequire("fMSjE");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $4BrfH = parcelRequire("4BrfH");

var $7Ys8f = parcelRequire("7Ys8f");

var $lx97N = parcelRequire("lx97N");
'use client';
function $3ac700b5451647a1$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $lx97N.useRef(controlled !== undefined);
    const [valueState, setValue] = $lx97N.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $lx97N.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


var $f9ce6d6ffea51c2d$export$2e2bcd8739ae039 = (0, $3ac700b5451647a1$export$2e2bcd8739ae039);



var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
/**
 * @ignore - internal component.
 */ const $310a9171fbf7ef74$var$FormControlContext = /*#__PURE__*/ $lx97N.createContext(undefined);
var $310a9171fbf7ef74$export$2e2bcd8739ae039 = $310a9171fbf7ef74$var$FormControlContext;


function $0e15e81f11442689$export$2e2bcd8739ae039() {
    return $lx97N.useContext((0, $310a9171fbf7ef74$export$2e2bcd8739ae039));
}




var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $f31fc05108bb4ba5$export$baa0faa0c7ad8085(slot) {
    return (0, $h6nFM.default)('PrivateSwitchBase', slot);
}
const $f31fc05108bb4ba5$var$switchBaseClasses = (0, $3OBXm.default)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $f31fc05108bb4ba5$export$2e2bcd8739ae039 = $f31fc05108bb4ba5$var$switchBaseClasses;



var $fRwNr = parcelRequire("fRwNr");
const $e22bef36a3e221e8$var$_excluded = [
    "autoFocus",
    "checked",
    "checkedIcon",
    "className",
    "defaultChecked",
    "disabled",
    "disableFocusRipple",
    "edge",
    "icon",
    "id",
    "inputProps",
    "inputRef",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "readOnly",
    "required",
    "tabIndex",
    "type",
    "value"
];
const $e22bef36a3e221e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $4BrfH.default)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $f31fc05108bb4ba5$export$baa0faa0c7ad8085), classes);
};
const $e22bef36a3e221e8$var$SwitchBaseRoot = (0, $7Ys8f.default)((0, $efd008e102aecb23$export$2e2bcd8739ae039))(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        padding: 9,
        borderRadius: '50%'
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }));
const $e22bef36a3e221e8$var$SwitchBaseInput = (0, $7Ys8f.default)('input')({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $e22bef36a3e221e8$var$SwitchBase = /*#__PURE__*/ $lx97N.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, className: className, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value } = props, other = (0, $hphT8.default)(props, $e22bef36a3e221e8$var$_excluded);
    const [checked, setCheckedState] = (0, $f9ce6d6ffea51c2d$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $0e15e81f11442689$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = (0, $eR4tV.default)({}, props, {
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    });
    const classes = $e22bef36a3e221e8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($e22bef36a3e221e8$var$SwitchBaseRoot, (0, $eR4tV.default)({
        component: "span",
        className: (0, $fmTP4.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        tabIndex: null,
        role: undefined,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)($e22bef36a3e221e8$var$SwitchBaseInput, (0, $eR4tV.default)({
                autoFocus: autoFocus,
                checked: checkedProp,
                defaultChecked: defaultChecked,
                className: classes.input,
                disabled: disabled,
                id: hasLabelFor ? id : undefined,
                name: name,
                onChange: handleInputChange,
                readOnly: readOnly,
                ref: inputRef,
                required: required,
                ownerState: ownerState,
                tabIndex: tabIndex,
                type: type
            }, type === 'checkbox' && value === undefined ? {} : {
                value: value
            }, inputProps)),
            checked ? checkedIcon : icon
        ]
    }));
});
var $e22bef36a3e221e8$export$2e2bcd8739ae039 = $e22bef36a3e221e8$var$SwitchBase;


parcelRequire("lx97N");

var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $52879f093d3eec0e$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("lx97N");

var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $55159b4aa6cb0c25$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("lx97N");

var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $4693a11466d908a9$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');



var $4BrfH = parcelRequire("4BrfH");

var $zetlx = parcelRequire("zetlx");

var $7Ys8f = parcelRequire("7Ys8f");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $1470d7161e5351f9$export$6c57c6e16b4063b(slot) {
    return (0, $h6nFM.default)('MuiCheckbox', slot);
}
const $1470d7161e5351f9$var$checkboxClasses = (0, $3OBXm.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary'
]);
var $1470d7161e5351f9$export$2e2bcd8739ae039 = $1470d7161e5351f9$var$checkboxClasses;



var $fRwNr = parcelRequire("fRwNr");
const $b1261094ff8b92e7$var$_excluded = [
    "checkedIcon",
    "color",
    "icon",
    "indeterminate",
    "indeterminateIcon",
    "inputProps",
    "size",
    "className"
];
const $b1261094ff8b92e7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $4BrfH.default)(color)}`
        ]
    };
    const composedClasses = (0, $8o5tH.default)(slots, (0, $1470d7161e5351f9$export$6c57c6e16b4063b), classes);
    return (0, $eR4tV.default)({}, classes, composedClasses);
};
const $b1261094ff8b92e7$var$CheckboxRoot = (0, $7Ys8f.default)((0, $e22bef36a3e221e8$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            ownerState.color !== 'default' && styles[`color${(0, $4BrfH.default)(ownerState.color)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${ownerState.color === 'default' ? theme.vars.palette.action.activeChannel : theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $fMSjE.alpha)(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.color !== 'default' && {
        [`&.${(0, $1470d7161e5351f9$export$2e2bcd8739ae039).checked}, &.${(0, $1470d7161e5351f9$export$2e2bcd8739ae039).indeterminate}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $1470d7161e5351f9$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }));
const $b1261094ff8b92e7$var$defaultCheckedIcon = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $55159b4aa6cb0c25$export$2e2bcd8739ae039), {});
const $b1261094ff8b92e7$var$defaultIcon = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $52879f093d3eec0e$export$2e2bcd8739ae039), {});
const $b1261094ff8b92e7$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $4693a11466d908a9$export$2e2bcd8739ae039), {});
const $b1261094ff8b92e7$var$Checkbox = /*#__PURE__*/ $lx97N.forwardRef(function Checkbox(inProps, ref) {
    var _icon$props$fontSize, _indeterminateIcon$pr;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $b1261094ff8b92e7$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $b1261094ff8b92e7$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $b1261094ff8b92e7$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', className: className } = props, other = (0, $hphT8.default)(props, $b1261094ff8b92e7$var$_excluded);
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: color,
        indeterminate: indeterminate,
        size: size
    });
    const classes = $b1261094ff8b92e7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($b1261094ff8b92e7$var$CheckboxRoot, (0, $eR4tV.default)({
        type: "checkbox",
        inputProps: (0, $eR4tV.default)({
            'data-indeterminate': indeterminate
        }, inputProps),
        icon: /*#__PURE__*/ $lx97N.cloneElement(icon, {
            fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
        }),
        checkedIcon: /*#__PURE__*/ $lx97N.cloneElement(indeterminateIcon, {
            fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
        }),
        ownerState: ownerState,
        ref: ref,
        className: (0, $fmTP4.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $b1261094ff8b92e7$export$2e2bcd8739ae039 = $b1261094ff8b92e7$var$Checkbox;


parcelRequire("lx97N");
const $3b1f18bd4102cdc3$var$DefaultIcebergSetter = ({ tradableSymbol: symbol, handleChange: handleChange })=>{
    const onIcebergChanged = (_event, checked)=>{
        handleChange(checked, symbol);
    };
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $b1261094ff8b92e7$export$2e2bcd8739ae039), {
        checked: Boolean(symbol.isIceberg),
        className: "iceberg-checkbox",
        "data-testid": "iceberg-checkbox",
        onChange: onIcebergChanged
    });
};
var $3b1f18bd4102cdc3$export$2e2bcd8739ae039 = $3b1f18bd4102cdc3$var$DefaultIcebergSetter;



var $fRwNr = parcelRequire("fRwNr");

var $jZinT = parcelRequire("jZinT");

var $lx97N = parcelRequire("lx97N");
/** Renders a default-quantity control that preserves accepted input until blur resolves the edit. */ const $7a1aad134170dbc1$var$DefaultQtySetter = (props)=>{
    const { tradableSymbol: symbol } = props;
    const [qty, setQty] = (0, $lx97N.useState)(symbol.defaultQty ? String(symbol.defaultQty) : '0');
    const hasUnsavedEdit = (0, $lx97N.useRef)(false);
    const hasInvalidEdit = (0, $lx97N.useRef)(false);
    /** Applies authoritative API updates when no edit is pending so the field does not retain a stale value. */ (0, $lx97N.useEffect)(()=>{
        if (!hasUnsavedEdit.current) setQty(symbol.defaultQty ? String(symbol.defaultQty) : '0');
    }, [
        symbol.defaultQty,
        symbol.rootSymbol,
        symbol.segmentMic
    ]);
    /** Stores a valid non-negative edit and marks it dirty so authoritative updates cannot overwrite it. */ const _handleChange = (event)=>{
        const newQty = Number(event.target.value);
        if (Number.isNaN(newQty) || newQty < 0) {
            hasInvalidEdit.current = true;
            return;
        }
        hasInvalidEdit.current = false;
        hasUnsavedEdit.current = true;
        setQty(event.target.value);
    };
    /** Ends the edit lifecycle, restoring rejected edits or committing an accepted quantity on blur. */ const setDefaultQty = (event)=>{
        const hasAcceptedEdit = hasUnsavedEdit.current;
        hasUnsavedEdit.current = false;
        if (hasInvalidEdit.current) {
            hasInvalidEdit.current = false;
            setQty(symbol.defaultQty ? String(symbol.defaultQty) : '0');
            return;
        }
        if (!hasAcceptedEdit) return;
        const inputValue = event.target.value;
        const numberValue = Number(inputValue);
        if (inputValue && !Number.isNaN(numberValue) && numberValue > 0) {
            setQty(inputValue);
            props.handleChange(numberValue, symbol);
        } else {
            setQty('0');
            props.handleChange(0, symbol);
        }
    };
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $jZinT.QEPInput), {
        className: `qty-input ${Number.isNaN(Number(qty)) ? 'error' : ''}`,
        onBlur: setDefaultQty,
        onChange: _handleChange,
        pattern: "[0-9]*",
        type: "number",
        value: qty
    });
};
var $7a1aad134170dbc1$export$2e2bcd8739ae039 = $7a1aad134170dbc1$var$DefaultQtySetter;



const $0cccfcaa834ed1b6$var$App = ()=>{
    const dispatch = (0, $3bGoE.useDispatch)();
    const allProducts = (0, $3bGoE.useSelector)((state)=>state.defaultsPreferencesReducer.products);
    const accounts = (0, $3bGoE.useSelector)((state)=>state.defaultsPreferencesReducer.accounts);
    const hasFetchAccounts = (0, $3bGoE.useSelector)((state)=>state.defaultsPreferencesReducer.fetchedAccounts);
    const hasFetchedDefaults = (0, $3bGoE.useSelector)((state)=>state.defaultsPreferencesReducer.fetchedProducts);
    const [searchText, setSearchText] = (0, $lx97N.useState)('');
    const [products, setProducts] = (0, $lx97N.useState)(undefined);
    const [filteredProducts, setFilteredProducts] = (0, $lx97N.useState)(undefined);
    const isLoading = !hasFetchAccounts || !hasFetchedDefaults;
    (0, $lx97N.useEffect)(()=>{
        if (!hasFetchedDefaults) dispatch((0, $06537821e73c7d3c$export$212bb2fc580a90a8)());
        if (!hasFetchAccounts) dispatch((0, $06537821e73c7d3c$export$d5d451a14adbc067)());
    }, []);
    const getViableAccountsForProduct = (symbol)=>{
        const viableAccounts = [];
        for (const acc of accounts)if (acc.productSpecifications && acc.productSpecifications.length > 0) {
            const prodSpec = acc.productSpecifications.find((spec)=>spec.exchangeName === symbol.segmentMic && spec.symbol === symbol.rootSymbol);
            if (prodSpec) viableAccounts.push(acc);
        }
        return viableAccounts;
    };
    (0, $lx97N.useEffect)(()=>{
        const newProducts = [];
        if (allProducts.length > 0 && accounts?.length > 0) for (const product of allProducts){
            const viableAccounts = getViableAccountsForProduct(product);
            if (viableAccounts.length > 0) newProducts.push({
                symbol: product,
                accounts: viableAccounts
            });
        }
        if (!isLoading) setProducts(newProducts);
    }, [
        allProducts,
        accounts,
        isLoading
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (searchText !== '') filterProducts();
    }, [
        searchText
    ]);
    (0, $lx97N.useEffect)(()=>{
        filterProducts();
    }, [
        products
    ]);
    const getProductName = (product)=>{
        if (product.symbolName) return `${product.symbolName} - (${product.rootSymbol})`;
        return `${product.rootSymbol}\\${product.segmentMic}`;
    };
    /** Dispatches one ordered save and consumes the intentionally UI-silent rejection. */ const saveProductDefaultChange = (change)=>{
        // Event handlers cannot await persistence, so consume failures while the queue releases itself.
        // eslint-disable-next-line promise/prefer-await-to-then
        dispatch((0, $06537821e73c7d3c$export$f1052df5e0b37e05)(change)).catch(()=>undefined);
    };
    /** Queues an account change without capturing the row's other potentially stale fields. */ const setAccountOnProduct = (value, sym)=>{
        if (allProducts.length > 0) saveProductDefaultChange({
            kind: 'account',
            product: `${sym.rootSymbol}\\${sym.segmentMic}`,
            value: value?.id ?? ''
        });
    };
    /** Queues a valid quantity change while preserving all fields accepted by earlier saves. */ const setQtyOnProduct = (value, sym)=>{
        if (allProducts.length > 0) {
            const newQty = value;
            // Always save if we have a valid number, even if it's the same (to ensure persistence)
            if (!Number.isNaN(newQty)) saveProductDefaultChange({
                kind: 'quantity',
                product: `${sym.rootSymbol}\\${sym.segmentMic}`,
                value: newQty
            });
        }
    };
    /** Queues an iceberg toggle and lets the store derive its display-quantity semantics. */ const setIcebergOnProduct = (value, sym)=>{
        if (allProducts.length > 0) saveProductDefaultChange({
            kind: 'iceberg',
            product: `${sym.rootSymbol}\\${sym.segmentMic}`,
            value: value
        });
    };
    /** Queues a non-negative iceberg display quantity for the selected product. */ const setDisplayQtyOnProduct = (value, sym)=>{
        if (allProducts.length > 0) {
            const newQty = Number(value);
            if (!Number.isNaN(newQty) && newQty >= 0) saveProductDefaultChange({
                kind: 'displayQuantity',
                product: `${sym.rootSymbol}\\${sym.segmentMic}`,
                value: newQty
            });
        }
    };
    const clearFilter = ()=>{
        setSearchText('');
        setFilteredProducts(products);
    };
    const filterProducts = ()=>{
        const search = searchText.toLowerCase();
        if (search === '') setFilteredProducts(products);
        else {
            const filtered = products?.filter((entry)=>{
                const product = entry.symbol;
                const productNameInTable = getProductName(product);
                return productNameInTable.toLowerCase().includes(search) || product.rootSymbol.toLowerCase().includes(search) || product.segmentMic.toLowerCase().includes(search) || product.symbolName?.toLowerCase().includes(search);
            });
            setFilteredProducts(filtered);
        }
    };
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "product-default-content",
        children: isLoading || products === null ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f0467d39715594a4$export$7c20be4c1d342248), {}) : products !== undefined && products.length <= 0 ? /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
            className: "no-results",
            children: "No tradable products available."
        }) : /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                    className: "search-container",
                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $cdd1b1ae4a2957eb$export$a345fca6f7b09bfb), {
                        placeholder: "Search for product",
                        onChange: (value)=>{
                            if (value === '') clearFilter();
                            setSearchText(value);
                        },
                        onClear: ()=>{}
                    })
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("table", {
                    className: "header-table",
                    children: /*#__PURE__*/ (0, $fRwNr.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $fRwNr.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)("th", {
                                    children: "Product"
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsx)("th", {
                                    children: "Default Quantity"
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsx)("th", {
                                    children: "Iceberg"
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsx)("th", {
                                    children: "Display Quantity"
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsx)("th", {
                                    children: "Default Strategy"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                    className: "product-list",
                    children: [
                        filteredProducts?.length === 0 && /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                            className: "no-results",
                            children: "There are no products matching this search"
                        }),
                        filteredProducts && filteredProducts.length > 0 && /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                            className: "product-table",
                            children: /*#__PURE__*/ (0, $fRwNr.jsx)("table", {
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)("tbody", {
                                    children: filteredProducts.map((entry)=>{
                                        const product = entry.symbol;
                                        return /*#__PURE__*/ (0, $fRwNr.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $fRwNr.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                                        className: "product-name",
                                                        children: getProductName(product)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fRwNr.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                                        className: "product-qty",
                                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $7a1aad134170dbc1$export$2e2bcd8739ae039), {
                                                            tradableSymbol: product,
                                                            handleChange: setQtyOnProduct
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fRwNr.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $3b1f18bd4102cdc3$export$2e2bcd8739ae039), {
                                                        tradableSymbol: product,
                                                        handleChange: setIcebergOnProduct
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fRwNr.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $26d9a478978bf163$export$2e2bcd8739ae039), {
                                                        tradableSymbol: product,
                                                        handleChange: setDisplayQtyOnProduct
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fRwNr.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                                        className: "product-account",
                                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f4c60670bfc0b8f0$export$2e2bcd8739ae039), {
                                                            tradableSymbol: product,
                                                            accounts: entry.accounts,
                                                            handleChange: setAccountOnProduct
                                                        })
                                                    })
                                                })
                                            ]
                                        }, `${product.rootSymbol}\\${product.segmentMic}`);
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var $0cccfcaa834ed1b6$export$2e2bcd8739ae039 = $0cccfcaa834ed1b6$var$App;


/* v8 ignore start */ 
 /* v8 ignore stop */ 

const $0d92478b409d0e1a$var$Defaults = ()=>/*#__PURE__*/ (0, $fRwNr.jsx)((0, $3bGoE.Provider), {
        store: (0, $06537821e73c7d3c$export$fc32eaa55249941f),
        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $0cccfcaa834ed1b6$export$2e2bcd8739ae039), {})
    });
var $0d92478b409d0e1a$export$2e2bcd8739ae039 = $0d92478b409d0e1a$var$Defaults;



var $fRwNr = parcelRequire("fRwNr");




function $6c30678239ad05ae$export$41dc20f57fbc2963() {
    const { preference: preference, isLoading: isLoading } = (0, $4c2764743176540f$export$7b8091fb31b80ed6)('orderBook.keepArmed');
    const mutation = (0, $4c2764743176540f$export$f21c408c0e7893f)('orderBook.keepArmed');
    if (isLoading) return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f0467d39715594a4$export$7c20be4c1d342248), {});
    const keepArmed = mutation.variables ?? Boolean(preference);
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "orderBookPreferences",
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
            className: "orderBookPreferences__input",
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $b1261094ff8b92e7$export$2e2bcd8739ae039), {
                    id: "order-book-keep-armed",
                    disabled: mutation.isPending,
                    checked: keepArmed,
                    onChange: (event)=>{
                        mutation.mutate(event.target.checked);
                    }
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("label", {
                    htmlFor: "order-book-keep-armed",
                    children: "Default Armed"
                })
            ]
        })
    });
}



var $fRwNr = parcelRequire("fRwNr");

var $d9gj3 = parcelRequire("d9gj3");
const $a8617325549fb624$export$3771ac88bb5cd94e = 'columnPreferences';
const $a8617325549fb624$export$e99a044cc82a0e89 = 1;
const $a8617325549fb624$var$MATCH_GROUPS = {
    account: [
        'account',
        'strategy',
        'executiontag',
        'defaultstrategy'
    ],
    ask: [
        'ask'
    ],
    askSize: [
        'asksize'
    ],
    averageFillPrice: [
        'averagefillpx',
        'averagefillprice',
        'avgfillpx',
        'avgfillprice'
    ],
    bid: [
        'bid'
    ],
    bidSize: [
        'bidsize'
    ],
    broker: [
        'broker'
    ],
    businessUnit: [
        'businessunit'
    ],
    callPut: [
        'callput',
        'putcall'
    ],
    currency: [
        'currency',
        'ccy'
    ],
    description: [
        'description',
        'memo'
    ],
    displayQuantity: [
        'displayqty',
        'displayquantity'
    ],
    exchange: [
        'exchange',
        'exch',
        'segmentmic'
    ],
    expirationDate: [
        'expiry',
        'expirationdate',
        'expiretime',
        'maturitymonthyear'
    ],
    last: [
        'last',
        'currentprice',
        'orderpx',
        'orderprice'
    ],
    price: [
        'price',
        'px',
        'stopprice',
        'strike'
    ],
    quantity: [
        'qty',
        'quantity',
        'orderqty',
        'currentposition',
        'position'
    ],
    side: [
        'side',
        'orderside',
        'direction'
    ],
    status: [
        'status'
    ],
    symbol: [
        'symbol',
        'product',
        'uniquesymbol',
        'name',
        'refsymbol',
        'fixsymbol',
        'exchangesymbol'
    ],
    tif: [
        'tif',
        'timeinforce'
    ],
    trader: [
        'trader',
        'traderid'
    ],
    type: [
        'type',
        'ordertype',
        'securitytype',
        'algotype'
    ],
    volume: [
        'volume',
        'totaltraded',
        'lastquantity',
        'totalfillqty',
        'fillqty',
        'filledqty',
        'leavesqty'
    ]
};
const $a8617325549fb624$var$MATCH_GROUP_LOOKUP = Object.entries($a8617325549fb624$var$MATCH_GROUPS).reduce((result, [group, aliases])=>{
    for (const alias of aliases)result[alias] = group;
    return result;
}, {});
const $a8617325549fb624$var$EMPTY_PREFERENCES = {
    version: $a8617325549fb624$export$e99a044cc82a0e89,
    apps: {}
};
function $a8617325549fb624$var$compactToken(value) {
    return value.toLowerCase().replaceAll(/[^a-z\d]+/g, ' ').trim().replaceAll(/\s+/g, '');
}
function $a8617325549fb624$var$getMatchTokens(value) {
    const compactValue = $a8617325549fb624$var$compactToken(value);
    if (compactValue === '') return [];
    const tokens = new Set([
        `exact:${compactValue}`
    ]);
    const group = $a8617325549fb624$var$MATCH_GROUP_LOOKUP[compactValue];
    if (group) tokens.add(`group:${group}`);
    return [
        ...tokens
    ];
}
function $a8617325549fb624$var$getColumnMatchTokens(column) {
    return new Set([
        ...$a8617325549fb624$var$getMatchTokens(column.id),
        ...$a8617325549fb624$var$getMatchTokens(column.label)
    ]);
}
function $a8617325549fb624$var$getMatchScore(sourceColumn, targetColumn) {
    const sourceId = $a8617325549fb624$var$compactToken(sourceColumn.id);
    const sourceLabel = $a8617325549fb624$var$compactToken(sourceColumn.label);
    const targetId = $a8617325549fb624$var$compactToken(targetColumn.id);
    const targetLabel = $a8617325549fb624$var$compactToken(targetColumn.label);
    if (sourceId !== '' && sourceId === targetId) return 400;
    if (sourceLabel !== '' && sourceLabel === targetLabel) return 300;
    if (sourceId !== '' && sourceId === targetLabel || sourceLabel !== '' && sourceLabel === targetId) return 220;
    const sourceTokens = $a8617325549fb624$var$getColumnMatchTokens(sourceColumn);
    const targetTokens = $a8617325549fb624$var$getColumnMatchTokens(targetColumn);
    let score = 0;
    for (const token of sourceTokens)if (targetTokens.has(token)) score += token.startsWith('group:') ? 40 : 80;
    return score;
}
function $a8617325549fb624$var$sanitizeColumnPreferenceColumn(value) {
    if (!value || typeof value !== 'object') return undefined;
    const candidate = value;
    if (typeof candidate.id !== 'string' || typeof candidate.label !== 'string' || typeof candidate.visible !== 'boolean') return undefined;
    return {
        id: candidate.id,
        label: candidate.label,
        visible: candidate.visible,
        locked: candidate.locked === true
    };
}
function $a8617325549fb624$var$sanitizeColumnPreferenceSet(value) {
    if (!value || typeof value !== 'object') return undefined;
    const candidate = value;
    if (!Array.isArray(candidate.columns)) return undefined;
    const columns = candidate.columns.map($a8617325549fb624$var$sanitizeColumnPreferenceColumn).filter((column)=>column !== undefined);
    return {
        sourceAppId: typeof candidate.sourceAppId === 'string' ? candidate.sourceAppId : undefined,
        columns: columns
    };
}
function $a8617325549fb624$export$3c0c35d3e3f58bb5(value) {
    if (!value || typeof value !== 'object') return $a8617325549fb624$var$EMPTY_PREFERENCES;
    const candidate = value;
    const global = $a8617325549fb624$var$sanitizeColumnPreferenceSet(candidate.global);
    const apps = Object.entries(candidate.apps ?? {}).reduce((result, [appId, set])=>{
        const sanitizedSet = $a8617325549fb624$var$sanitizeColumnPreferenceSet(set);
        if (sanitizedSet) result[appId] = sanitizedSet;
        return result;
    }, {});
    return {
        version: $a8617325549fb624$export$e99a044cc82a0e89,
        ...global ? {
            global: global
        } : {},
        apps: apps
    };
}
function $a8617325549fb624$export$116bc8482036b9d8(columns, sourceAppId) {
    return {
        ...sourceAppId ? {
            sourceAppId: sourceAppId
        } : {},
        columns: columns.map((column)=>({
                id: column.id,
                label: column.label,
                visible: column.visible,
                ...column.locked ? {
                    locked: true
                } : {}
            }))
    };
}
function $a8617325549fb624$export$3d620d626dfe8760(preferences, scope, set) {
    const sanitized = $a8617325549fb624$export$3c0c35d3e3f58bb5(preferences);
    if (scope === 'global') return {
        ...sanitized,
        ...set ? {
            global: set
        } : {},
        ...set ? {} : {
            global: undefined
        }
    };
    const apps = {
        ...sanitized.apps
    };
    if (set) apps[scope] = set;
    else delete apps[scope];
    return {
        ...sanitized,
        apps: apps
    };
}
function $a8617325549fb624$export$d5d2962233419d86(preferences, appId) {
    const sanitized = $a8617325549fb624$export$3c0c35d3e3f58bb5(preferences);
    return sanitized.apps?.[appId] ?? sanitized.global;
}
function $a8617325549fb624$export$d11afc3edf749e0c(columns) {
    return columns.reduce((result, column)=>{
        const id = (column.colId ?? column.field ?? '').trim();
        const label = (column.headerName ?? id).trim();
        if (id === '' || label === '') return result;
        result.push({
            id: id,
            label: label,
            visible: !(column.initialHide ?? column.hide ?? column.hidden),
            locked: column.lockVisible === true
        });
        return result;
    }, []);
}
function $a8617325549fb624$export$39b53377f57a2647(defaultColumns, preferenceSet) {
    if (!preferenceSet || preferenceSet.columns.length === 0) return defaultColumns.map((column)=>({
            ...column
        }));
    const matchedIds = new Set();
    const orderedColumns = [];
    for (const sourceColumn of preferenceSet.columns){
        let bestMatch;
        let bestScore = 0;
        for (const targetColumn of defaultColumns){
            if (matchedIds.has(targetColumn.id)) continue;
            const score = $a8617325549fb624$var$getMatchScore(sourceColumn, targetColumn);
            if (score > bestScore) {
                bestScore = score;
                bestMatch = targetColumn;
            }
        }
        if (!bestMatch || bestScore === 0) continue;
        matchedIds.add(bestMatch.id);
        orderedColumns.push({
            ...bestMatch,
            visible: bestMatch.locked ? true : sourceColumn.visible
        });
    }
    for (const column of defaultColumns)if (!matchedIds.has(column.id)) orderedColumns.push({
        ...column
    });
    return orderedColumns;
}
function $a8617325549fb624$export$71a81bedf0e60de6(defaultColumns, preferenceSet, sourceAppId) {
    return $a8617325549fb624$export$116bc8482036b9d8($a8617325549fb624$export$39b53377f57a2647(defaultColumns, preferenceSet), sourceAppId ?? preferenceSet.sourceAppId);
}
function $a8617325549fb624$export$f3d6db6414f0f292(columns) {
    return columns.map((column)=>({
            colId: column.id,
            hide: column.locked ? false : !column.visible
        }));
}
/**
 * Rewrites recognized legacy preference ids before score-based matching. An exact current label
 * disambiguates historical duplicate ids, while unmatched labels retain the caller's canonical alias.
 */ function $a8617325549fb624$var$migrateColumnPreferenceSetIds(defaultColumns, preferenceSet, aliases) {
    const targetIdsByLabel = new Map();
    const ambiguousLabels = new Set();
    const aliasedTargetIds = new Set(Object.values(aliases));
    for (const column of defaultColumns){
        if (!aliasedTargetIds.has(column.id)) continue;
        const label = $a8617325549fb624$var$compactToken(column.label);
        if (targetIdsByLabel.has(label)) ambiguousLabels.add(label);
        else targetIdsByLabel.set(label, column.id);
    }
    /** Maps one recognized historical id to its unambiguous current id without changing saved metadata. */ const migratePreferenceColumn = (column)=>{
        const aliasedId = aliases[column.id];
        if (aliasedId === undefined) return {
            ...column
        };
        const label = $a8617325549fb624$var$compactToken(column.label);
        const labelMatchedId = ambiguousLabels.has(label) ? undefined : targetIdsByLabel.get(label);
        return {
            ...column,
            id: labelMatchedId ?? aliasedId
        };
    };
    return {
        ...preferenceSet,
        columns: preferenceSet.columns.map(migratePreferenceColumn)
    };
}
function $a8617325549fb624$export$5ffd791c2a727e46(columnState, aliases) {
    if (!columnState) return undefined;
    const canonicalIds = new Set(columnState.filter((column)=>aliases[column.colId] === undefined || aliases[column.colId] === column.colId).map((column)=>aliases[column.colId] ?? column.colId));
    const migratedIds = new Set();
    return columnState.reduce((result, column)=>{
        const migratedId = aliases[column.colId] ?? column.colId;
        const isLegacyAlias = migratedId !== column.colId;
        if (migratedIds.has(migratedId) || isLegacyAlias && canonicalIds.has(migratedId)) return result;
        migratedIds.add(migratedId);
        result.push({
            ...column,
            colId: migratedId
        });
        return result;
    }, []);
}
async function $a8617325549fb624$export$5998c99c4280feaa(appId, columns, aliases = {}) {
    try {
        const response = await (0, $d9gj3.getQepSystem)().container.config.getPreference();
        if (!response) return undefined;
        const preferences = $a8617325549fb624$export$3c0c35d3e3f58bb5(response.data?.[$a8617325549fb624$export$3771ac88bb5cd94e]);
        const preferenceSet = $a8617325549fb624$export$d5d2962233419d86(preferences, appId);
        if (!preferenceSet) return undefined;
        const defaultColumns = $a8617325549fb624$export$d11afc3edf749e0c(columns);
        const migratedPreferenceSet = $a8617325549fb624$var$migrateColumnPreferenceSetIds(defaultColumns, preferenceSet, aliases);
        const resolvedColumns = $a8617325549fb624$export$39b53377f57a2647(defaultColumns, migratedPreferenceSet);
        return $a8617325549fb624$export$f3d6db6414f0f292(resolvedColumns);
    } catch  {
        return undefined;
    }
}


var $d9gj3 = parcelRequire("d9gj3");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");

var $4BrfH = parcelRequire("4BrfH");




var $7Ys8f = parcelRequire("7Ys8f");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $eaa7b7844b336b10$export$4b135a4b3a6c4550(slot) {
    return (0, $h6nFM.default)('MuiInputAdornment', slot);
}
const $eaa7b7844b336b10$var$inputAdornmentClasses = (0, $3OBXm.default)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $eaa7b7844b336b10$export$2e2bcd8739ae039 = $eaa7b7844b336b10$var$inputAdornmentClasses;



var $zetlx = parcelRequire("zetlx");

var $fRwNr = parcelRequire("fRwNr");
var $e28b683e771ff52d$var$_span;
const $e28b683e771ff52d$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $e28b683e771ff52d$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $4BrfH.default)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $e28b683e771ff52d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $4BrfH.default)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $4BrfH.default)(size)}`
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $eaa7b7844b336b10$export$4b135a4b3a6c4550), classes);
};
const $e28b683e771ff52d$var$InputAdornmentRoot = (0, $7Ys8f.default)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $e28b683e771ff52d$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $eaa7b7844b336b10$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $eaa7b7844b336b10$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $e28b683e771ff52d$var$InputAdornment = /*#__PURE__*/ $lx97N.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $hphT8.default)(props, $e28b683e771ff52d$var$_excluded);
    const muiFormControl = (0, $0e15e81f11442689$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $eR4tV.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $e28b683e771ff52d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $310a9171fbf7ef74$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($e28b683e771ff52d$var$InputAdornmentRoot, (0, $eR4tV.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fmTP4.default)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05476049bba0344f$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $e28b683e771ff52d$var$_span || ($e28b683e771ff52d$var$_span = /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $e28b683e771ff52d$export$2e2bcd8739ae039 = $e28b683e771ff52d$var$InputAdornment;


var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");


var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $8o5tH = parcelRequire("8o5tH");

var $8zw8B = parcelRequire("8zw8B");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $43Mr2 = parcelRequire("43Mr2");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");


var $1amKe = parcelRequire("1amKe");


var $fRwNr = parcelRequire("fRwNr");
const $56c96ed778539460$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $56c96ed778539460$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $56c96ed778539460$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $56c96ed778539460$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0 || obj.outerHeightStyle === 0 && !obj.overflow;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/base/react-textarea-autosize/)
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/base/react-textarea-autosize/components-api/#textarea-autosize)
 */ const $56c96ed778539460$var$TextareaAutosize = /*#__PURE__*/ $lx97N.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $hphT8.default)(props, $56c96ed778539460$var$_excluded);
    const { current: isControlled } = $lx97N.useRef(value != null);
    const inputRef = $lx97N.useRef(null);
    const handleRef = (0, $ffcf97026745e37e$export$2e2bcd8739ae039)(forwardedRef, inputRef);
    const shadowRef = $lx97N.useRef(null);
    const renders = $lx97N.useRef(0);
    const [state, setState] = $lx97N.useState({
        outerHeightStyle: 0
    });
    const getUpdatedState = $lx97N.useCallback(()=>{
        const input = inputRef.current;
        const containerWindow = (0, $9422cdc1bfa48026$export$2e2bcd8739ae039)(input);
        const computedStyle = containerWindow.getComputedStyle(input);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0
        };
        const inputShallow = shadowRef.current;
        inputShallow.style.width = computedStyle.width;
        inputShallow.value = input.value || props.placeholder || 'x';
        if (inputShallow.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        inputShallow.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $56c96ed778539460$var$getStyleValue(computedStyle.paddingBottom) + $56c96ed778539460$var$getStyleValue(computedStyle.paddingTop);
        const border = $56c96ed778539460$var$getStyleValue(computedStyle.borderBottomWidth) + $56c96ed778539460$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = inputShallow.scrollHeight;
        // Measure height of a textarea with a single row
        inputShallow.value = 'x';
        const singleRowHeight = inputShallow.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflow = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflow: overflow
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const updateState = (prevState, newState)=>{
        const { outerHeightStyle: outerHeightStyle, overflow: overflow } = newState;
        // Need a large enough difference to update the height.
        // This prevents infinite rendering loop.
        if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
            renders.current += 1;
            return {
                overflow: overflow,
                outerHeightStyle: outerHeightStyle
            };
        }
        return prevState;
    };
    const syncHeight = $lx97N.useCallback(()=>{
        const newState = getUpdatedState();
        if ($56c96ed778539460$var$isEmpty(newState)) return;
        setState((prevState)=>{
            return updateState(prevState, newState);
        });
    }, [
        getUpdatedState
    ]);
    const syncHeightWithFlushSync = ()=>{
        const newState = getUpdatedState();
        if ($56c96ed778539460$var$isEmpty(newState)) return;
        // In React 18, state updates in a ResizeObserver's callback are happening after the paint which causes flickering
        // when doing some visual updates in it. Using flushSync ensures that the dom will be painted after the states updates happen
        // Related issue - https://github.com/facebook/react/issues/24331
        $1amKe.flushSync(()=>{
            setState((prevState)=>{
                return updateState(prevState, newState);
            });
        });
    };
    $lx97N.useEffect(()=>{
        const handleResize = (0, $4d18f4df28635949$export$2e2bcd8739ae039)(()=>{
            renders.current = 0;
            // If the TextareaAutosize component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/32640
            if (inputRef.current) syncHeightWithFlushSync();
        });
        let resizeObserver;
        const input = inputRef.current;
        const containerWindow = (0, $9422cdc1bfa48026$export$2e2bcd8739ae039)(input);
        containerWindow.addEventListener('resize', handleResize);
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(input);
        }
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    });
    (0, $dad405edc2b429da$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    $lx97N.useEffect(()=>{
        renders.current = 0;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        renders.current = 0;
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("textarea", (0, $eR4tV.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: (0, $eR4tV.default)({
                    height: state.outerHeightStyle,
                    // Need a large enough difference to allow scrolling.
                    // This prevents infinite rendering loop.
                    overflow: state.overflow ? 'hidden' : undefined
                }, style)
            }, other)),
            /*#__PURE__*/ (0, $fRwNr.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: shadowRef,
                tabIndex: -1,
                style: (0, $eR4tV.default)({}, $56c96ed778539460$var$styles.shadow, style, {
                    padding: 0
                })
            })
        ]
    });
});
var $56c96ed778539460$export$2e2bcd8739ae039 = $56c96ed778539460$var$TextareaAutosize;


var $8o5tH = parcelRequire("8o5tH");
function $7909972769f1686f$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}





var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $4BrfH = parcelRequire("4BrfH");



var $eR4tV = parcelRequire("eR4tV");
parcelRequire("lx97N");



var $cbdKw = parcelRequire("cbdKw");

var $Rnxzq = parcelRequire("Rnxzq");

var $fRwNr = parcelRequire("fRwNr");
function $fb44a39ec20eb47f$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $22e6415d7ae3c92f$export$2e2bcd8739ae039), (0, $eR4tV.default)({}, props, {
        defaultTheme: (0, $cbdKw.default),
        themeId: (0, $Rnxzq.default)
    }));
}
var $fb44a39ec20eb47f$export$2e2bcd8739ae039 = $fb44a39ec20eb47f$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $800fd3a8d2348980$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $800fd3a8d2348980$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($800fd3a8d2348980$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $800fd3a8d2348980$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $800fd3a8d2348980$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $ed822df52cb2806c$export$ef57d5c8ca2278f6(slot) {
    return (0, $h6nFM.default)('MuiInputBase', slot);
}
const $ed822df52cb2806c$var$inputBaseClasses = (0, $3OBXm.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $ed822df52cb2806c$export$2e2bcd8739ae039 = $ed822df52cb2806c$var$inputBaseClasses;



var $fRwNr = parcelRequire("fRwNr");
const $8b449e18f3a23ccb$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $8b449e18f3a23ccb$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $4BrfH.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $8b449e18f3a23ccb$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $8b449e18f3a23ccb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4BrfH.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size === 'small' && 'sizeSmall',
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $ed822df52cb2806c$export$ef57d5c8ca2278f6), classes);
};
const $8b449e18f3a23ccb$export$298a043133d72a38 = (0, $7Ys8f.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $8b449e18f3a23ccb$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $ed822df52cb2806c$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $eR4tV.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $8b449e18f3a23ccb$export$a1ad29c901026019 = (0, $7Ys8f.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $8b449e18f3a23ccb$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $eR4tV.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $eR4tV.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $ed822df52cb2806c$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $ed822df52cb2806c$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $8b449e18f3a23ccb$var$inputGlobalStyles = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $fb44a39ec20eb47f$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $8b449e18f3a23ccb$var$InputBase = /*#__PURE__*/ $lx97N.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $hphT8.default)(props, $8b449e18f3a23ccb$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $lx97N.useRef(value != null);
    const inputRef = $lx97N.useRef();
    const handleInputRefWarning = $lx97N.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $lx97N.useState(false);
    const muiFormControl = (0, $0e15e81f11442689$export$2e2bcd8739ae039)();
    const fcs = (0, $7909972769f1686f$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $lx97N.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $lx97N.useCallback((obj)=>{
        if ((0, $800fd3a8d2348980$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $433e95a68b5f9382$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $43Mr2.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $lx97N.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick && !fcs.disabled) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $eR4tV.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $eR4tV.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $56c96ed778539460$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $lx97N.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $8b449e18f3a23ccb$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $8b449e18f3a23ccb$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $8b449e18f3a23ccb$export$a1ad29c901026019;
    inputProps = (0, $eR4tV.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $8b449e18f3a23ccb$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $fRwNr.jsxs)(Root, (0, $eR4tV.default)({}, rootProps, !(0, $469f9f719a324870$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $eR4tV.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $fmTP4.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $310a9171fbf7ef74$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)(Input, (0, $eR4tV.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $469f9f719a324870$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $eR4tV.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $fmTP4.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $eR4tV.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $8b449e18f3a23ccb$export$2e2bcd8739ae039 = $8b449e18f3a23ccb$var$InputBase;



var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $eR4tV = parcelRequire("eR4tV");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");

function $700b25bff810c6be$export$cdb270390122322b(slot) {
    return (0, $h6nFM.default)('MuiInput', slot);
}
const $700b25bff810c6be$var$inputClasses = (0, $eR4tV.default)({}, (0, $ed822df52cb2806c$export$2e2bcd8739ae039), (0, $3OBXm.default)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $700b25bff810c6be$export$2e2bcd8739ae039 = $700b25bff810c6be$var$inputClasses;




var $fRwNr = parcelRequire("fRwNr");
const $5ec3f695d6f4510a$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $5ec3f695d6f4510a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8o5tH.default)(slots, (0, $700b25bff810c6be$export$cdb270390122322b), classes);
    return (0, $eR4tV.default)({}, classes, composedClasses);
};
const $5ec3f695d6f4510a$var$InputRoot = (0, $7Ys8f.default)((0, $8b449e18f3a23ccb$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8b449e18f3a23ccb$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $eR4tV.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&:after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $700b25bff810c6be$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $700b25bff810c6be$export$2e2bcd8739ae039).error}`]: {
            '&:before, &:after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&:before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $700b25bff810c6be$export$2e2bcd8739ae039).disabled}, .${(0, $700b25bff810c6be$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $700b25bff810c6be$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $5ec3f695d6f4510a$var$InputInput = (0, $7Ys8f.default)((0, $8b449e18f3a23ccb$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $8b449e18f3a23ccb$export$cf507b112810e72d)
})({});
const $5ec3f695d6f4510a$var$Input = /*#__PURE__*/ $lx97N.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $hphT8.default)(props, $5ec3f695d6f4510a$var$_excluded);
    const classes = $5ec3f695d6f4510a$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $8zw8B.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $5ec3f695d6f4510a$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $5ec3f695d6f4510a$var$InputInput;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8b449e18f3a23ccb$export$2e2bcd8739ae039), (0, $eR4tV.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$5ec3f695d6f4510a$var$Input.muiName = 'Input';
var $5ec3f695d6f4510a$export$2e2bcd8739ae039 = $5ec3f695d6f4510a$var$Input;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");

var $8zw8B = parcelRequire("8zw8B");


var $8o5tH = parcelRequire("8o5tH");


var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $eR4tV = parcelRequire("eR4tV");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");

function $6b79d8675af985be$export$3331e419f1a48437(slot) {
    return (0, $h6nFM.default)('MuiFilledInput', slot);
}
const $6b79d8675af985be$var$filledInputClasses = (0, $eR4tV.default)({}, (0, $ed822df52cb2806c$export$2e2bcd8739ae039), (0, $3OBXm.default)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $6b79d8675af985be$export$2e2bcd8739ae039 = $6b79d8675af985be$var$filledInputClasses;




var $fRwNr = parcelRequire("fRwNr");
const $e1fee03347962435$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e1fee03347962435$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8o5tH.default)(slots, (0, $6b79d8675af985be$export$3331e419f1a48437), classes);
    return (0, $eR4tV.default)({}, classes, composedClasses);
};
const $e1fee03347962435$var$FilledInputRoot = (0, $7Ys8f.default)((0, $8b449e18f3a23ccb$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $8b449e18f3a23ccb$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $eR4tV.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $6b79d8675af985be$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $6b79d8675af985be$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&:after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $6b79d8675af985be$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $6b79d8675af985be$export$2e2bcd8739ae039).error}`]: {
            '&:before, &:after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&:before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $6b79d8675af985be$export$2e2bcd8739ae039).disabled}, .${(0, $6b79d8675af985be$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $6b79d8675af985be$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $eR4tV.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }));
});
const $e1fee03347962435$var$FilledInputInput = (0, $7Ys8f.default)((0, $8b449e18f3a23ccb$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $8b449e18f3a23ccb$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
const $e1fee03347962435$var$FilledInput = /*#__PURE__*/ $lx97N.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $hphT8.default)(props, $e1fee03347962435$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $e1fee03347962435$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $8zw8B.default)(slotProps != null ? slotProps : componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e1fee03347962435$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e1fee03347962435$var$FilledInputInput;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8b449e18f3a23ccb$export$2e2bcd8739ae039), (0, $eR4tV.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e1fee03347962435$var$FilledInput.muiName = 'Input';
var $e1fee03347962435$export$2e2bcd8739ae039 = $e1fee03347962435$var$FilledInput;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");



var $8o5tH = parcelRequire("8o5tH");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");
parcelRequire("lx97N");


var $7Ys8f = parcelRequire("7Ys8f");

var $fRwNr = parcelRequire("fRwNr");
var $87a88903530e6e9f$var$_span;
const $87a88903530e6e9f$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $87a88903530e6e9f$var$NotchedOutlineRoot = (0, $7Ys8f.default)('fieldset')({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $87a88903530e6e9f$var$NotchedOutlineLegend = (0, $7Ys8f.default)('legend')(({ ownerState: ownerState, theme: theme })=>(0, $eR4tV.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $eR4tV.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $87a88903530e6e9f$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $hphT8.default)(props, $87a88903530e6e9f$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $eR4tV.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $fRwNr.jsx)($87a88903530e6e9f$var$NotchedOutlineRoot, (0, $eR4tV.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($87a88903530e6e9f$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                children: label
            }) : $87a88903530e6e9f$var$_span || ($87a88903530e6e9f$var$_span = /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}





var $7Ys8f = parcelRequire("7Ys8f");

var $eR4tV = parcelRequire("eR4tV");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");

function $e3a202becb2a8ec4$export$89922944c7227687(slot) {
    return (0, $h6nFM.default)('MuiOutlinedInput', slot);
}
const $e3a202becb2a8ec4$var$outlinedInputClasses = (0, $eR4tV.default)({}, (0, $ed822df52cb2806c$export$2e2bcd8739ae039), (0, $3OBXm.default)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $e3a202becb2a8ec4$export$2e2bcd8739ae039 = $e3a202becb2a8ec4$var$outlinedInputClasses;




var $zetlx = parcelRequire("zetlx");

var $fRwNr = parcelRequire("fRwNr");
const $7af0170bc02b6262$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $7af0170bc02b6262$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $8o5tH.default)(slots, (0, $e3a202becb2a8ec4$export$89922944c7227687), classes);
    return (0, $eR4tV.default)({}, classes, composedClasses);
};
const $7af0170bc02b6262$var$OutlinedInputRoot = (0, $7Ys8f.default)((0, $8b449e18f3a23ccb$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $8b449e18f3a23ccb$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $eR4tV.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $e3a202becb2a8ec4$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $e3a202becb2a8ec4$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $e3a202becb2a8ec4$export$2e2bcd8739ae039).focused} .${(0, $e3a202becb2a8ec4$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $e3a202becb2a8ec4$export$2e2bcd8739ae039).error} .${(0, $e3a202becb2a8ec4$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $e3a202becb2a8ec4$export$2e2bcd8739ae039).disabled} .${(0, $e3a202becb2a8ec4$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $eR4tV.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $7af0170bc02b6262$var$NotchedOutlineRoot = (0, $7Ys8f.default)((0, $87a88903530e6e9f$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $7af0170bc02b6262$var$OutlinedInputInput = (0, $7Ys8f.default)((0, $8b449e18f3a23ccb$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $8b449e18f3a23ccb$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $7af0170bc02b6262$var$OutlinedInput = /*#__PURE__*/ $lx97N.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $hphT8.default)(props, $7af0170bc02b6262$var$_excluded);
    const classes = $7af0170bc02b6262$var$useUtilityClasses(props);
    const muiFormControl = (0, $0e15e81f11442689$export$2e2bcd8739ae039)();
    const fcs = (0, $7909972769f1686f$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'required'
        ]
    });
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $7af0170bc02b6262$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $7af0170bc02b6262$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8b449e18f3a23ccb$export$2e2bcd8739ae039), (0, $eR4tV.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $fRwNr.jsx)($7af0170bc02b6262$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $eR4tV.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$7af0170bc02b6262$var$OutlinedInput.muiName = 'Input';
var $7af0170bc02b6262$export$2e2bcd8739ae039 = $7af0170bc02b6262$var$OutlinedInput;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $8o5tH = parcelRequire("8o5tH");

var $fmTP4 = parcelRequire("fmTP4");



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");



var $4BrfH = parcelRequire("4BrfH");

var $zetlx = parcelRequire("zetlx");

var $7Ys8f = parcelRequire("7Ys8f");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $3ac55ce36de78c56$export$f7d501e40371cd17(slot) {
    return (0, $h6nFM.default)('MuiFormLabel', slot);
}
const $3ac55ce36de78c56$var$formLabelClasses = (0, $3OBXm.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $3ac55ce36de78c56$export$2e2bcd8739ae039 = $3ac55ce36de78c56$var$formLabelClasses;



var $fRwNr = parcelRequire("fRwNr");
const $bf15575ea67fd28f$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $bf15575ea67fd28f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $4BrfH.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $3ac55ce36de78c56$export$f7d501e40371cd17), classes);
};
const $bf15575ea67fd28f$export$aa5bc7f8a4705b27 = (0, $7Ys8f.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $eR4tV.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $3ac55ce36de78c56$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $3ac55ce36de78c56$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $3ac55ce36de78c56$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $bf15575ea67fd28f$var$AsteriskComponent = (0, $7Ys8f.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $3ac55ce36de78c56$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $bf15575ea67fd28f$var$FormLabel = /*#__PURE__*/ $lx97N.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $hphT8.default)(props, $bf15575ea67fd28f$var$_excluded);
    const muiFormControl = (0, $0e15e81f11442689$export$2e2bcd8739ae039)();
    const fcs = (0, $7909972769f1686f$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $bf15575ea67fd28f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($bf15575ea67fd28f$export$aa5bc7f8a4705b27, (0, $eR4tV.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fmTP4.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $fRwNr.jsxs)($bf15575ea67fd28f$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $bf15575ea67fd28f$export$2e2bcd8739ae039 = $bf15575ea67fd28f$var$FormLabel;



var $zetlx = parcelRequire("zetlx");

var $7Ys8f = parcelRequire("7Ys8f");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $9e0a5628cca3ec93$export$c1c4b4545ad2ea5f(slot) {
    return (0, $h6nFM.default)('MuiInputLabel', slot);
}
const $9e0a5628cca3ec93$var$inputLabelClasses = (0, $3OBXm.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $9e0a5628cca3ec93$export$2e2bcd8739ae039 = $9e0a5628cca3ec93$var$inputLabelClasses;



var $fRwNr = parcelRequire("fRwNr");
const $4b24deceb4d85894$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $4b24deceb4d85894$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size === 'small' && 'sizeSmall',
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $8o5tH.default)(slots, (0, $9e0a5628cca3ec93$export$c1c4b4545ad2ea5f), classes);
    return (0, $eR4tV.default)({}, classes, composedClasses);
};
const $4b24deceb4d85894$var$InputLabelRoot = (0, $7Ys8f.default)((0, $bf15575ea67fd28f$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $3ac55ce36de78c56$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $eR4tV.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $eR4tV.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $eR4tV.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $4b24deceb4d85894$var$InputLabel = /*#__PURE__*/ $lx97N.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $zetlx.default)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $hphT8.default)(props, $4b24deceb4d85894$var$_excluded);
    const muiFormControl = (0, $0e15e81f11442689$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $7909972769f1686f$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required'
        ]
    });
    const ownerState = (0, $eR4tV.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required
    });
    const classes = $4b24deceb4d85894$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($4b24deceb4d85894$var$InputLabelRoot, (0, $eR4tV.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $fmTP4.default)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $4b24deceb4d85894$export$2e2bcd8739ae039 = $4b24deceb4d85894$var$InputLabel;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");

var $zetlx = parcelRequire("zetlx");

var $7Ys8f = parcelRequire("7Ys8f");


var $4BrfH = parcelRequire("4BrfH");

var $lx97N = parcelRequire("lx97N");
function $d99104c3e0aef740$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $lx97N.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $a27d181418ab3f5a$export$2e2bcd8739ae039 = (0, $d99104c3e0aef740$export$2e2bcd8739ae039);




var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $ad34934f9a9d0f42$export$149c8b8bab2289d1(slot) {
    return (0, $h6nFM.default)('MuiFormControl', slot);
}
const $ad34934f9a9d0f42$var$formControlClasses = (0, $3OBXm.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $ad34934f9a9d0f42$export$2e2bcd8739ae039 = $ad34934f9a9d0f42$var$formControlClasses;



var $fRwNr = parcelRequire("fRwNr");
const $bf1ac48a3f4d70de$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $bf1ac48a3f4d70de$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $4BrfH.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $ad34934f9a9d0f42$export$149c8b8bab2289d1), classes);
};
const $bf1ac48a3f4d70de$var$FormControlRoot = (0, $7Ys8f.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $eR4tV.default)({}, styles.root, styles[`margin${(0, $4BrfH.default)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $eR4tV.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $bf1ac48a3f4d70de$var$FormControl = /*#__PURE__*/ $lx97N.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $hphT8.default)(props, $bf1ac48a3f4d70de$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $bf1ac48a3f4d70de$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $lx97N.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $lx97N.Children.forEach(children, (child)=>{
            if (!(0, $a27d181418ab3f5a$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $a27d181418ab3f5a$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $800fd3a8d2348980$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $lx97N.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $lx97N.Children.forEach(children, (child)=>{
            if (!(0, $a27d181418ab3f5a$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $800fd3a8d2348980$export$d652b828d7fdeff8)(child.props, true) || (0, $800fd3a8d2348980$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $lx97N.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $lx97N.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $310a9171fbf7ef74$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($bf1ac48a3f4d70de$var$FormControlRoot, (0, $eR4tV.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $fmTP4.default)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $bf1ac48a3f4d70de$export$2e2bcd8739ae039 = $bf1ac48a3f4d70de$var$FormControl;



var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");



var $7Ys8f = parcelRequire("7Ys8f");

var $4BrfH = parcelRequire("4BrfH");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $53336ccace5e1209$export$a394fa61b1d583a9(slot) {
    return (0, $h6nFM.default)('MuiFormHelperText', slot);
}
const $53336ccace5e1209$var$formHelperTextClasses = (0, $3OBXm.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $53336ccace5e1209$export$2e2bcd8739ae039 = $53336ccace5e1209$var$formHelperTextClasses;



var $zetlx = parcelRequire("zetlx");

var $fRwNr = parcelRequire("fRwNr");
var $4cca126c1260ecb3$var$_span;
const $4cca126c1260ecb3$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $4cca126c1260ecb3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $4BrfH.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $53336ccace5e1209$export$a394fa61b1d583a9), classes);
};
const $4cca126c1260ecb3$var$FormHelperTextRoot = (0, $7Ys8f.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $4BrfH.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $53336ccace5e1209$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $53336ccace5e1209$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $4cca126c1260ecb3$var$FormHelperText = /*#__PURE__*/ $lx97N.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $hphT8.default)(props, $4cca126c1260ecb3$var$_excluded);
    const muiFormControl = (0, $0e15e81f11442689$export$2e2bcd8739ae039)();
    const fcs = (0, $7909972769f1686f$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $eR4tV.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $4cca126c1260ecb3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($4cca126c1260ecb3$var$FormHelperTextRoot, (0, $eR4tV.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $fmTP4.default)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $4cca126c1260ecb3$var$_span || ($4cca126c1260ecb3$var$_span = /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $4cca126c1260ecb3$export$2e2bcd8739ae039 = $4cca126c1260ecb3$var$FormHelperText;



var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8zw8B = parcelRequire("8zw8B");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $43Mr2 = parcelRequire("43Mr2");

var $lx97N = parcelRequire("lx97N");



var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");


var $4BrfH = parcelRequire("4BrfH");


var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $4BrfH = parcelRequire("4BrfH");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $506467f4fa6780cf$export$1ee13051fd9e2ab5(slot) {
    return (0, $h6nFM.default)('MuiNativeSelect', slot);
}
const $506467f4fa6780cf$var$nativeSelectClasses = (0, $3OBXm.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $506467f4fa6780cf$export$2e2bcd8739ae039 = $506467f4fa6780cf$var$nativeSelectClasses;



var $7Ys8f = parcelRequire("7Ys8f");

var $fRwNr = parcelRequire("fRwNr");
const $87fa919fa0fa2619$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $87fa919fa0fa2619$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $4BrfH.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $506467f4fa6780cf$export$1ee13051fd9e2ab5), classes);
};
const $87fa919fa0fa2619$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $eR4tV.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $eR4tV.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $506467f4fa6780cf$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $87fa919fa0fa2619$var$NativeSelectSelect = (0, $7Ys8f.default)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $7Ys8f.rootShouldForwardProp),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $506467f4fa6780cf$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($87fa919fa0fa2619$export$c1eccd1617458c87);
const $87fa919fa0fa2619$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $eR4tV.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $506467f4fa6780cf$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $87fa919fa0fa2619$var$NativeSelectIcon = (0, $7Ys8f.default)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $4BrfH.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($87fa919fa0fa2619$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $87fa919fa0fa2619$var$NativeSelectInput = /*#__PURE__*/ $lx97N.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $hphT8.default)(props, $87fa919fa0fa2619$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $87fa919fa0fa2619$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)($87fa919fa0fa2619$var$NativeSelectSelect, (0, $eR4tV.default)({
                ownerState: ownerState,
                className: (0, $fmTP4.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $fRwNr.jsx)($87fa919fa0fa2619$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $87fa919fa0fa2619$export$2e2bcd8739ae039 = $87fa919fa0fa2619$var$NativeSelectInput;




var $7Ys8f = parcelRequire("7Ys8f");



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $253e803694cee4e6$export$2c0c1ee5a3392e(slot) {
    return (0, $h6nFM.default)('MuiSelect', slot);
}
const $253e803694cee4e6$var$selectClasses = (0, $3OBXm.default)('MuiSelect', [
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $253e803694cee4e6$export$2e2bcd8739ae039 = $253e803694cee4e6$var$selectClasses;



var $fRwNr = parcelRequire("fRwNr");
var $be309449a68ce95f$var$_span;
const $be309449a68ce95f$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $be309449a68ce95f$var$SelectSelect = (0, $7Ys8f.default)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $253e803694cee4e6$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $253e803694cee4e6$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $253e803694cee4e6$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $253e803694cee4e6$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $87fa919fa0fa2619$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $253e803694cee4e6$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $be309449a68ce95f$var$SelectIcon = (0, $7Ys8f.default)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $4BrfH.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $87fa919fa0fa2619$export$e7a817afd12a40d0));
const $be309449a68ce95f$var$SelectNativeInput = (0, $7Ys8f.default)('input', {
    shouldForwardProp: (prop)=>(0, $7Ys8f.slotShouldForwardProp)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $be309449a68ce95f$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $be309449a68ce95f$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $be309449a68ce95f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $4BrfH.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $253e803694cee4e6$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $be309449a68ce95f$var$SelectInput = /*#__PURE__*/ $lx97N.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $hphT8.default)(props, $be309449a68ce95f$var$_excluded);
    const [value, setValueState] = (0, $f9ce6d6ffea51c2d$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $f9ce6d6ffea51c2d$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $lx97N.useRef(null);
    const displayRef = $lx97N.useRef(null);
    const [displayNode, setDisplayNode] = $lx97N.useState(null);
    const { current: isOpenControlled } = $lx97N.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $lx97N.useState();
    const handleRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $lx97N.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $lx97N.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $lx97N.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $lx97N.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $lx97N.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $8503c55da5b06e5f$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $lx97N.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $800fd3a8d2348980$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $lx97N.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $43Mr2.default)(2));
            selected = value.some((v)=>$be309449a68ce95f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $be309449a68ce95f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $lx97N.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $eR4tV.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $be309449a68ce95f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)($be309449a68ce95f$var$SelectSelect, (0, $eR4tV.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "button",
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $fmTP4.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $be309449a68ce95f$var$isEmpty(display) ? $be309449a68ce95f$var$_span || ($be309449a68ce95f$var$_span = /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $fRwNr.jsx)($be309449a68ce95f$var$SelectNativeInput, (0, $eR4tV.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $fRwNr.jsx)($be309449a68ce95f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $3c81bfb010f12d1e$export$2e2bcd8739ae039), (0, $eR4tV.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $eR4tV.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    disableListWrap: true
                }, MenuProps.MenuListProps),
                PaperProps: (0, $eR4tV.default)({}, MenuProps.PaperProps, {
                    style: (0, $eR4tV.default)({
                        minWidth: menuMinWidth
                    }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
                }),
                children: items
            }))
        ]
    });
});
var $be309449a68ce95f$export$2e2bcd8739ae039 = $be309449a68ce95f$var$SelectInput;




parcelRequire("lx97N");

var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $003899a5af038460$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');







var $zetlx = parcelRequire("zetlx");


var $7Ys8f = parcelRequire("7Ys8f");

var $fRwNr = parcelRequire("fRwNr");
const $9ffe87b3c00b21a6$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
];
const $9ffe87b3c00b21a6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $9ffe87b3c00b21a6$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $7Ys8f.rootShouldForwardProp)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $9ffe87b3c00b21a6$var$StyledInput = (0, $7Ys8f.default)((0, $5ec3f695d6f4510a$export$2e2bcd8739ae039), $9ffe87b3c00b21a6$var$styledRootConfig)('');
const $9ffe87b3c00b21a6$var$StyledOutlinedInput = (0, $7Ys8f.default)((0, $7af0170bc02b6262$export$2e2bcd8739ae039), $9ffe87b3c00b21a6$var$styledRootConfig)('');
const $9ffe87b3c00b21a6$var$StyledFilledInput = (0, $7Ys8f.default)((0, $e1fee03347962435$export$2e2bcd8739ae039), $9ffe87b3c00b21a6$var$styledRootConfig)('');
const $9ffe87b3c00b21a6$var$Select = /*#__PURE__*/ $lx97N.forwardRef(function Select(inProps, ref) {
    const props = (0, $zetlx.default)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $003899a5af038460$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $hphT8.default)(props, $9ffe87b3c00b21a6$var$_excluded);
    const inputComponent = native ? (0, $87fa919fa0fa2619$export$2e2bcd8739ae039) : (0, $be309449a68ce95f$export$2e2bcd8739ae039);
    const muiFormControl = (0, $0e15e81f11442689$export$2e2bcd8739ae039)();
    const fcs = (0, $7909972769f1686f$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $eR4tV.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $9ffe87b3c00b21a6$var$useUtilityClasses(ownerState);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $fRwNr.jsx)($9ffe87b3c00b21a6$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $fRwNr.jsx)($9ffe87b3c00b21a6$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $fRwNr.jsx)($9ffe87b3c00b21a6$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(ref, InputComponent.ref);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($lx97N.Fragment, {
        children: /*#__PURE__*/ $lx97N.cloneElement(InputComponent, (0, $eR4tV.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $eR4tV.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $eR4tV.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $8zw8B.default)(classes, inputProps.classes) : classes
            }, input ? input.props.inputProps : {})
        }, multiple && native && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $fmTP4.default)(InputComponent.props.className, className)
        }, !input && {
            variant: variant
        }, other))
    });
});
$9ffe87b3c00b21a6$var$Select.muiName = 'Select';
var $9ffe87b3c00b21a6$export$2e2bcd8739ae039 = $9ffe87b3c00b21a6$var$Select;



var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $5ffba3c45727d541$export$c1bdcbaf0596aeda(slot) {
    return (0, $h6nFM.default)('MuiTextField', slot);
}
const $5ffba3c45727d541$var$textFieldClasses = (0, $3OBXm.default)('MuiTextField', [
    'root'
]);
var $5ffba3c45727d541$export$2e2bcd8739ae039 = $5ffba3c45727d541$var$textFieldClasses;



var $fRwNr = parcelRequire("fRwNr");
const $9e73d3de5eb0002c$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $9e73d3de5eb0002c$var$variantComponent = {
    standard: (0, $5ec3f695d6f4510a$export$2e2bcd8739ae039),
    filled: (0, $e1fee03347962435$export$2e2bcd8739ae039),
    outlined: (0, $7af0170bc02b6262$export$2e2bcd8739ae039)
};
const $9e73d3de5eb0002c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $5ffba3c45727d541$export$c1bdcbaf0596aeda), classes);
};
const $9e73d3de5eb0002c$var$TextFieldRoot = (0, $7Ys8f.default)((0, $bf1ac48a3f4d70de$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $9e73d3de5eb0002c$var$TextField = /*#__PURE__*/ $lx97N.forwardRef(function TextField(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $hphT8.default)(props, $9e73d3de5eb0002c$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $9e73d3de5eb0002c$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $a879fbe3b7cb644f$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $9e73d3de5eb0002c$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $fRwNr.jsx)(InputComponent, (0, $eR4tV.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        onClick: onClick,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($9e73d3de5eb0002c$var$TextFieldRoot, (0, $eR4tV.default)({
        className: (0, $fmTP4.default)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $fRwNr.jsx)((0, $4b24deceb4d85894$export$2e2bcd8739ae039), (0, $eR4tV.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $9ffe87b3c00b21a6$export$2e2bcd8739ae039), (0, $eR4tV.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $fRwNr.jsx)((0, $4cca126c1260ecb3$export$2e2bcd8739ae039), (0, $eR4tV.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $9e73d3de5eb0002c$export$2e2bcd8739ae039 = $9e73d3de5eb0002c$var$TextField;


var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");


var $8o5tH = parcelRequire("8o5tH");

var $fMSjE = parcelRequire("fMSjE");

var $7Ys8f = parcelRequire("7Ys8f");


var $zetlx = parcelRequire("zetlx");

var $4BrfH = parcelRequire("4BrfH");


var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $hphT8 = parcelRequire("hphT8");

var $lx97N = parcelRequire("lx97N");







// and applies them to the HTMLElements such as popper and arrow
function $de04f959dc6fc8a8$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) || !(0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $de04f959dc6fc8a8$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) || !(0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $de04f959dc6fc8a8$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $de04f959dc6fc8a8$var$applyStyles,
    effect: $de04f959dc6fc8a8$var$effect,
    requires: [
        'computeStyles'
    ]
};









var $ea48f4f61b10800e$export$d34966752335dd47 = [
    (0, $7bec2a6e2c97de64$export$2e2bcd8739ae039),
    (0, $fd3370820cf4bcb1$export$2e2bcd8739ae039),
    (0, $bbe366718497d634$export$2e2bcd8739ae039),
    (0, $de04f959dc6fc8a8$export$2e2bcd8739ae039),
    (0, $6137a161b4896709$export$2e2bcd8739ae039),
    (0, $7261bb7a28c6c261$export$2e2bcd8739ae039),
    (0, $9d3c739e2059661f$export$2e2bcd8739ae039),
    (0, $48ddd81393695a53$export$2e2bcd8739ae039),
    (0, $d7d2695ea28b2aa6$export$2e2bcd8739ae039)
];
var $ea48f4f61b10800e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b0054ad10f2e8753$export$ed5e13716264f202)({
    defaultModifiers: $ea48f4f61b10800e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules




var $8o5tH = parcelRequire("8o5tH");


var $h6nFM = parcelRequire("h6nFM");

var $3OBXm = parcelRequire("3OBXm");
function $931d7bdb9e0ce52d$export$1b69b6cd0fa638a1(slot) {
    return (0, $h6nFM.default)('MuiPopper', slot);
}
const $931d7bdb9e0ce52d$var$popperClasses = (0, $3OBXm.default)('MuiPopper', [
    'root'
]);
var $931d7bdb9e0ce52d$export$2e2bcd8739ae039 = $931d7bdb9e0ce52d$var$popperClasses;





var $fRwNr = parcelRequire("fRwNr");
const $9fd14aa6f09dab51$var$_excluded = [
    "anchorEl",
    "children",
    "direction",
    "disablePortal",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "slotProps",
    "slots",
    "TransitionProps",
    "ownerState"
], $9fd14aa6f09dab51$var$_excluded2 = [
    "anchorEl",
    "children",
    "container",
    "direction",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "style",
    "transition",
    "slotProps",
    "slots"
];
function $9fd14aa6f09dab51$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $9fd14aa6f09dab51$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $9fd14aa6f09dab51$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $9fd14aa6f09dab51$var$isVirtualElement(element) {
    return !$9fd14aa6f09dab51$var$isHTMLElement(element);
}
const $9fd14aa6f09dab51$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $6c243b273f6a200f$export$b0f7603cd2f9ee15)((0, $931d7bdb9e0ce52d$export$1b69b6cd0fa638a1)));
};
const $9fd14aa6f09dab51$var$defaultPopperOptions = {};
const $9fd14aa6f09dab51$var$PopperTooltip = /*#__PURE__*/ $lx97N.forwardRef(function PopperTooltip(props, forwardedRef) {
    var _slots$root;
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps } = props, other = (0, $hphT8.default)(props, $9fd14aa6f09dab51$var$_excluded);
    const tooltipRef = $lx97N.useRef(null);
    const ownRef = (0, $ffcf97026745e37e$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $lx97N.useRef(null);
    const handlePopperRef = (0, $ffcf97026745e37e$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $lx97N.useRef(handlePopperRef);
    (0, $dad405edc2b429da$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $lx97N.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $9fd14aa6f09dab51$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $lx97N.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $lx97N.useState($9fd14aa6f09dab51$var$resolveAnchorEl(anchorEl));
    $lx97N.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $lx97N.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($9fd14aa6f09dab51$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $dad405edc2b429da$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $ea48f4f61b10800e$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, (0, $eR4tV.default)({
            placement: rtlPlacement
        }, popperOptions, {
            modifiers: popperModifiers
        }));
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $9fd14aa6f09dab51$var$useUtilityClasses();
    const Root = (_slots$root = slots.root) != null ? _slots$root : 'div';
    const rootProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $fRwNr.jsx)(Root, (0, $eR4tV.default)({}, rootProps, {
        children: typeof children === 'function' ? children(childProps) : children
    }));
});
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 *
 * Demos:
 *
 * - [Popper](https://mui.com/base/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/base/react-popper/components-api/#popper)
 */ const $9fd14aa6f09dab51$var$Popper = /*#__PURE__*/ $lx97N.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $9fd14aa6f09dab51$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {} } = props, other = (0, $hphT8.default)(props, $9fd14aa6f09dab51$var$_excluded2);
    const [exited, setExited] = $lx97N.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $9fd14aa6f09dab51$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $9fd14aa6f09dab51$var$isHTMLElement(resolvedAnchorEl) ? (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $f81ee7f8f1bf9284$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $38c1e3fad1a30f73$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($9fd14aa6f09dab51$var$PopperTooltip, (0, $eR4tV.default)({
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots
        }, other, {
            style: (0, $eR4tV.default)({
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display
            }, style),
            TransitionProps: transitionProps,
            children: children
        }))
    });
});
var $9fd14aa6f09dab51$export$2e2bcd8739ae039 = $9fd14aa6f09dab51$var$Popper;



var $jQQSa = parcelRequire("jQQSa");



var $lx97N = parcelRequire("lx97N");

var $7Ys8f = parcelRequire("7Ys8f");
var $zetlx = parcelRequire("zetlx");

var $fRwNr = parcelRequire("fRwNr");
const $f6613b84ba031cfb$var$_excluded = [
    "anchorEl",
    "component",
    "components",
    "componentsProps",
    "container",
    "disablePortal",
    "keepMounted",
    "modifiers",
    "open",
    "placement",
    "popperOptions",
    "popperRef",
    "transition",
    "slots",
    "slotProps"
];
const $f6613b84ba031cfb$var$PopperRoot = (0, $7Ys8f.default)((0, $9fd14aa6f09dab51$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $f6613b84ba031cfb$var$Popper = /*#__PURE__*/ $lx97N.forwardRef(function Popper(inProps, ref) {
    var _slots$root;
    const theme = (0, $jQQSa.default)();
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps } = props, other = (0, $hphT8.default)(props, $f6613b84ba031cfb$var$_excluded);
    const RootComponent = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components == null ? void 0 : components.Root;
    const otherProps = (0, $eR4tV.default)({
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition
    }, other);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($f6613b84ba031cfb$var$PopperRoot, (0, $eR4tV.default)({
        as: component,
        direction: theme == null ? void 0 : theme.direction,
        slots: {
            root: RootComponent
        },
        slotProps: slotProps != null ? slotProps : componentsProps
    }, otherProps, {
        ref: ref
    }));
});
var $f6613b84ba031cfb$export$2e2bcd8739ae039 = $f6613b84ba031cfb$var$Popper;





var $37b236c89e6cba14$export$2e2bcd8739ae039 = (0, $a879fbe3b7cb644f$export$2e2bcd8739ae039);





var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $c8adbc028275ee2f$export$837848f5f6cee923(slot) {
    return (0, $h6nFM.default)('MuiTooltip', slot);
}
const $c8adbc028275ee2f$var$tooltipClasses = (0, $3OBXm.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $c8adbc028275ee2f$export$2e2bcd8739ae039 = $c8adbc028275ee2f$var$tooltipClasses;



var $fRwNr = parcelRequire("fRwNr");
const $824bfd70ec70846a$var$_excluded = [
    "arrow",
    "children",
    "classes",
    "components",
    "componentsProps",
    "describeChild",
    "disableFocusListener",
    "disableHoverListener",
    "disableInteractive",
    "disableTouchListener",
    "enterDelay",
    "enterNextDelay",
    "enterTouchDelay",
    "followCursor",
    "id",
    "leaveDelay",
    "leaveTouchDelay",
    "onClose",
    "onOpen",
    "open",
    "placement",
    "PopperComponent",
    "PopperProps",
    "slotProps",
    "slots",
    "title",
    "TransitionComponent",
    "TransitionProps"
];
function $824bfd70ec70846a$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $824bfd70ec70846a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $4BrfH.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $c8adbc028275ee2f$export$837848f5f6cee923), classes);
};
const $824bfd70ec70846a$var$TooltipPopper = (0, $7Ys8f.default)((0, $f6613b84ba031cfb$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})(({ theme: theme, ownerState: ownerState, open: open })=>(0, $eR4tV.default)({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none'
    }, !ownerState.disableInteractive && {
        pointerEvents: 'auto'
    }, !open && {
        pointerEvents: 'none'
    }, ownerState.arrow && {
        [`&[data-popper-placement*="bottom"] .${(0, $c8adbc028275ee2f$export$2e2bcd8739ae039).arrow}`]: {
            top: 0,
            marginTop: '-0.71em',
            '&::before': {
                transformOrigin: '0 100%'
            }
        },
        [`&[data-popper-placement*="top"] .${(0, $c8adbc028275ee2f$export$2e2bcd8739ae039).arrow}`]: {
            bottom: 0,
            marginBottom: '-0.71em',
            '&::before': {
                transformOrigin: '100% 0'
            }
        },
        [`&[data-popper-placement*="right"] .${(0, $c8adbc028275ee2f$export$2e2bcd8739ae039).arrow}`]: (0, $eR4tV.default)({}, !ownerState.isRtl ? {
            left: 0,
            marginLeft: '-0.71em'
        } : {
            right: 0,
            marginRight: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '100% 100%'
            }
        }),
        [`&[data-popper-placement*="left"] .${(0, $c8adbc028275ee2f$export$2e2bcd8739ae039).arrow}`]: (0, $eR4tV.default)({}, !ownerState.isRtl ? {
            right: 0,
            marginRight: '-0.71em'
        } : {
            left: 0,
            marginLeft: '-0.71em'
        }, {
            height: '1em',
            width: '0.71em',
            '&::before': {
                transformOrigin: '0 0'
            }
        })
    }));
const $824bfd70ec70846a$var$TooltipTooltip = (0, $7Ys8f.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $4BrfH.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $fMSjE.alpha)(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium
    }, ownerState.arrow && {
        position: 'relative',
        margin: 0
    }, ownerState.touch && {
        padding: '8px 16px',
        fontSize: theme.typography.pxToRem(14),
        lineHeight: `${$824bfd70ec70846a$var$round(16 / 14)}em`,
        fontWeight: theme.typography.fontWeightRegular
    }, {
        [`.${(0, $c8adbc028275ee2f$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: (0, $eR4tV.default)({
            transformOrigin: 'right center'
        }, !ownerState.isRtl ? (0, $eR4tV.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        }) : (0, $eR4tV.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        })),
        [`.${(0, $c8adbc028275ee2f$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: (0, $eR4tV.default)({
            transformOrigin: 'left center'
        }, !ownerState.isRtl ? (0, $eR4tV.default)({
            marginLeft: '14px'
        }, ownerState.touch && {
            marginLeft: '24px'
        }) : (0, $eR4tV.default)({
            marginRight: '14px'
        }, ownerState.touch && {
            marginRight: '24px'
        })),
        [`.${(0, $c8adbc028275ee2f$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: (0, $eR4tV.default)({
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        }, ownerState.touch && {
            marginBottom: '24px'
        }),
        [`.${(0, $c8adbc028275ee2f$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: (0, $eR4tV.default)({
            transformOrigin: 'center top',
            marginTop: '14px'
        }, ownerState.touch && {
            marginTop: '24px'
        })
    }));
const $824bfd70ec70846a$var$TooltipArrow = (0, $7Ys8f.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow',
    overridesResolver: (props, styles)=>styles.arrow
})(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : (0, $fMSjE.alpha)(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    }));
let $824bfd70ec70846a$var$hystersisOpen = false;
let $824bfd70ec70846a$var$hystersisTimer = null;
let $824bfd70ec70846a$var$cursorPosition = {
    x: 0,
    y: 0
};
function $824bfd70ec70846a$export$b9ee5a7ace0541f8() {
    $824bfd70ec70846a$var$hystersisOpen = false;
    clearTimeout($824bfd70ec70846a$var$hystersisTimer);
}
function $824bfd70ec70846a$var$composeEventHandler(handler, eventHandler) {
    return (event)=>{
        if (eventHandler) eventHandler(event);
        handler(event);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $824bfd70ec70846a$var$Tooltip = /*#__PURE__*/ $lx97N.forwardRef(function Tooltip(inProps, ref) {
    var _ref, _slots$popper, _ref2, _ref3, _slots$transition, _ref4, _slots$tooltip, _ref5, _slots$arrow, _slotProps$popper, _ref6, _slotProps$popper2, _slotProps$transition, _slotProps$tooltip, _ref7, _slotProps$tooltip2, _slotProps$arrow, _ref8, _slotProps$arrow2;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: children, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp = (0, $760b1d006513ba2e$export$2e2bcd8739ae039), TransitionProps: TransitionProps } = props, other = (0, $hphT8.default)(props, $824bfd70ec70846a$var$_excluded);
    const theme = (0, $c7f2f300ef30ef70$export$2e2bcd8739ae039)();
    const isRtl = theme.direction === 'rtl';
    const [childNode, setChildNode] = $lx97N.useState();
    const [arrowRef, setArrowRef] = $lx97N.useState(null);
    const ignoreNonTouchEvents = $lx97N.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = $lx97N.useRef();
    const enterTimer = $lx97N.useRef();
    const leaveTimer = $lx97N.useRef();
    const touchTimer = $lx97N.useRef();
    const [openState, setOpenState] = (0, $f9ce6d6ffea51c2d$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $37b236c89e6cba14$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $lx97N.useRef();
    const stopTouchInteraction = $lx97N.useCallback(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        clearTimeout(touchTimer.current);
    }, []);
    $lx97N.useEffect(()=>{
        return ()=>{
            clearTimeout(closeTimer.current);
            clearTimeout(enterTimer.current);
            clearTimeout(leaveTimer.current);
            stopTouchInteraction();
        };
    }, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        clearTimeout($824bfd70ec70846a$var$hystersisTimer);
        $824bfd70ec70846a$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $b5d1bb90cd0da3bf$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        clearTimeout($824bfd70ec70846a$var$hystersisTimer);
        $824bfd70ec70846a$var$hystersisTimer = setTimeout(()=>{
            $824bfd70ec70846a$var$hystersisOpen = false;
        }, 800 + leaveDelay);
        setOpenState(false);
        if (onClose && open) onClose(event);
        clearTimeout(closeTimer.current);
        closeTimer.current = setTimeout(()=>{
            ignoreNonTouchEvents.current = false;
        }, theme.transitions.duration.shortest);
    });
    const handleEnter = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        if (enterDelay || $824bfd70ec70846a$var$hystersisOpen && enterNextDelay) enterTimer.current = setTimeout(()=>{
            handleOpen(event);
        }, $824bfd70ec70846a$var$hystersisOpen ? enterNextDelay : enterDelay);
        else handleOpen(event);
    };
    const handleLeave = (event)=>{
        clearTimeout(enterTimer.current);
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveDelay);
    };
    const { isFocusVisibleRef: isFocusVisibleRef, onBlur: handleBlurVisible, onFocus: handleFocusVisible, ref: focusVisibleRef } = (0, $5fbe03e0221974b0$export$2e2bcd8739ae039)();
    // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
    // We just need to re-render the Tooltip if the focus-visible state changes.
    const [, setChildIsFocusVisible] = $lx97N.useState(false);
    const handleBlur = (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) {
            setChildIsFocusVisible(false);
            handleLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setChildIsFocusVisible(true);
            handleEnter(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleMouseOver = handleEnter;
    const handleMouseLeave = handleLeave;
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        clearTimeout(leaveTimer.current);
        clearTimeout(closeTimer.current);
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.current = setTimeout(()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleEnter(event);
        }, enterTouchDelay);
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        clearTimeout(leaveTimer.current);
        leaveTimer.current = setTimeout(()=>{
            handleClose(event);
        }, leaveTouchDelay);
    };
    $lx97N.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            // IE11, Edge (prior to using Bink?) use 'Esc'
            if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $1900d14ba699a20c$export$2e2bcd8739ae039)(children.ref, focusVisibleRef, setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    if (!title && title !== 0) open = false;
    const popperRef = $lx97N.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $824bfd70ec70846a$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = (0, $eR4tV.default)({}, nameOrDescProps, other, children.props, {
        className: (0, $fmTP4.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef
    }, followCursor ? {
        onMouseMove: handleMouseMove
    } : {});
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $824bfd70ec70846a$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $824bfd70ec70846a$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $824bfd70ec70846a$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $824bfd70ec70846a$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const popperOptions = $lx97N.useMemo(()=>{
        var _PopperProps$popperOp;
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        return (0, $eR4tV.default)({}, PopperProps.popperOptions, {
            modifiers: tooltipModifiers
        });
    }, [
        arrowRef,
        PopperProps
    ]);
    const ownerState = (0, $eR4tV.default)({}, props, {
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    });
    const classes = $824bfd70ec70846a$var$useUtilityClasses(ownerState);
    const PopperComponent = (_ref = (_slots$popper = slots.popper) != null ? _slots$popper : components.Popper) != null ? _ref : $824bfd70ec70846a$var$TooltipPopper;
    const TransitionComponent = (_ref2 = (_ref3 = (_slots$transition = slots.transition) != null ? _slots$transition : components.Transition) != null ? _ref3 : TransitionComponentProp) != null ? _ref2 : (0, $760b1d006513ba2e$export$2e2bcd8739ae039);
    const TooltipComponent = (_ref4 = (_slots$tooltip = slots.tooltip) != null ? _slots$tooltip : components.Tooltip) != null ? _ref4 : $824bfd70ec70846a$var$TooltipTooltip;
    const ArrowComponent = (_ref5 = (_slots$arrow = slots.arrow) != null ? _slots$arrow : components.Arrow) != null ? _ref5 : $824bfd70ec70846a$var$TooltipArrow;
    const popperProps = (0, $e9cfab20069234fb$export$2e2bcd8739ae039)(PopperComponent, (0, $eR4tV.default)({}, PopperProps, (_slotProps$popper = slotProps.popper) != null ? _slotProps$popper : componentsProps.popper, {
        className: (0, $fmTP4.default)(classes.popper, PopperProps == null ? void 0 : PopperProps.className, (_ref6 = (_slotProps$popper2 = slotProps.popper) != null ? _slotProps$popper2 : componentsProps.popper) == null ? void 0 : _ref6.className)
    }), ownerState);
    const transitionProps = (0, $e9cfab20069234fb$export$2e2bcd8739ae039)(TransitionComponent, (0, $eR4tV.default)({}, TransitionProps, (_slotProps$transition = slotProps.transition) != null ? _slotProps$transition : componentsProps.transition), ownerState);
    const tooltipProps = (0, $e9cfab20069234fb$export$2e2bcd8739ae039)(TooltipComponent, (0, $eR4tV.default)({}, (_slotProps$tooltip = slotProps.tooltip) != null ? _slotProps$tooltip : componentsProps.tooltip, {
        className: (0, $fmTP4.default)(classes.tooltip, (_ref7 = (_slotProps$tooltip2 = slotProps.tooltip) != null ? _slotProps$tooltip2 : componentsProps.tooltip) == null ? void 0 : _ref7.className)
    }), ownerState);
    const tooltipArrowProps = (0, $e9cfab20069234fb$export$2e2bcd8739ae039)(ArrowComponent, (0, $eR4tV.default)({}, (_slotProps$arrow = slotProps.arrow) != null ? _slotProps$arrow : componentsProps.arrow, {
        className: (0, $fmTP4.default)(classes.arrow, (_ref8 = (_slotProps$arrow2 = slotProps.arrow) != null ? _slotProps$arrow2 : componentsProps.arrow) == null ? void 0 : _ref8.className)
    }), ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)($lx97N.Fragment, {
        children: [
            /*#__PURE__*/ $lx97N.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $fRwNr.jsx)(PopperComponent, (0, $eR4tV.default)({
                as: PopperComponentProp != null ? PopperComponentProp : (0, $f6613b84ba031cfb$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $824bfd70ec70846a$var$cursorPosition.y,
                            left: $824bfd70ec70846a$var$cursorPosition.x,
                            right: $824bfd70ec70846a$var$cursorPosition.x,
                            bottom: $824bfd70ec70846a$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true
            }, interactiveWrapperListeners, popperProps, {
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $fRwNr.jsx)(TransitionComponent, (0, $eR4tV.default)({
                        timeout: theme.transitions.duration.shorter
                    }, TransitionPropsInner, transitionProps, {
                        children: /*#__PURE__*/ (0, $fRwNr.jsxs)(TooltipComponent, (0, $eR4tV.default)({}, tooltipProps, {
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $fRwNr.jsx)(ArrowComponent, (0, $eR4tV.default)({}, tooltipArrowProps, {
                                    ref: setArrowRef
                                })) : null
                            ]
                        }))
                    }))
            }))
        ]
    });
});
var $824bfd70ec70846a$export$2e2bcd8739ae039 = $824bfd70ec70846a$var$Tooltip;


var $eb0846882f605c09$exports = {};
"use strict";

Object.defineProperty($eb0846882f605c09$exports, "__esModule", {
    value: true
});
$eb0846882f605c09$exports.default = void 0;

var $eb0846882f605c09$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $eb0846882f605c09$var$_default = (0, $eb0846882f605c09$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
$eb0846882f605c09$exports.default = $eb0846882f605c09$var$_default;


var $630cf1ba6302e89e$exports = {};
"use strict";

Object.defineProperty($630cf1ba6302e89e$exports, "__esModule", {
    value: true
});
$630cf1ba6302e89e$exports.default = void 0;

var $630cf1ba6302e89e$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $630cf1ba6302e89e$var$_default = (0, $630cf1ba6302e89e$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
$630cf1ba6302e89e$exports.default = $630cf1ba6302e89e$var$_default;



var $dc0428a5efda2a98$exports = {};
"use strict";

Object.defineProperty($dc0428a5efda2a98$exports, "__esModule", {
    value: true
});
$dc0428a5efda2a98$exports.default = void 0;

var $dc0428a5efda2a98$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $dc0428a5efda2a98$var$_default = (0, $dc0428a5efda2a98$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("circle", {
    cx: "12",
    cy: "12",
    r: "8"
}), 'FiberManualRecord');
$dc0428a5efda2a98$exports.default = $dc0428a5efda2a98$var$_default;


var $2022a969a40c7ea8$exports = {};
"use strict";

Object.defineProperty($2022a969a40c7ea8$exports, "__esModule", {
    value: true
});
$2022a969a40c7ea8$exports.default = void 0;

var $2022a969a40c7ea8$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $2022a969a40c7ea8$var$_default = (0, $2022a969a40c7ea8$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
}), 'Lock');
$2022a969a40c7ea8$exports.default = $2022a969a40c7ea8$var$_default;


var $e195de697ccdd4e5$exports = {};
"use strict";

Object.defineProperty($e195de697ccdd4e5$exports, "__esModule", {
    value: true
});
$e195de697ccdd4e5$exports.default = void 0;

var $e195de697ccdd4e5$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $e195de697ccdd4e5$var$_default = (0, $e195de697ccdd4e5$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M6.99 11 3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
}), 'SwapHoriz');
$e195de697ccdd4e5$exports.default = $e195de697ccdd4e5$var$_default;



var $lx97N = parcelRequire("lx97N");
const $21a681dddb143fa0$var$column = (id, label, visible = true)=>({
        id: id,
        label: label,
        visible: visible
    });
const $21a681dddb143fa0$var$columnPreferenceAppDefinitions = [
    {
        id: 'orderEntry',
        label: 'Order Entry 1.0',
        description: 'Basket order ticket defaults',
        columns: [
            $21a681dddb143fa0$var$column('direction', 'Side'),
            $21a681dddb143fa0$var$column('instrument', 'Product'),
            $21a681dddb143fa0$var$column('quantity', 'Qty'),
            $21a681dddb143fa0$var$column('strategy', 'Strategy'),
            $21a681dddb143fa0$var$column('description', 'Description'),
            $21a681dddb143fa0$var$column('prices.snapshot.bid.size', 'Bid Size'),
            $21a681dddb143fa0$var$column('prices.snapshot.bid.price', 'Bid'),
            $21a681dddb143fa0$var$column('prices.snapshot.ask.price', 'Ask'),
            $21a681dddb143fa0$var$column('prices.snapshot.ask.size', 'Ask Size'),
            $21a681dddb143fa0$var$column('prices', 'Gross Notional'),
            $21a681dddb143fa0$var$column('symbol.expiry', 'Expiry')
        ]
    },
    {
        id: 'orderSummary',
        label: 'Order Summary',
        description: 'Main summary grid defaults',
        columns: [
            $21a681dddb143fa0$var$column('strategy', 'Strategy'),
            $21a681dddb143fa0$var$column('symbol', 'Symbol'),
            $21a681dddb143fa0$var$column('callPut', 'Call/Put', false),
            $21a681dddb143fa0$var$column('side', 'Side'),
            $21a681dddb143fa0$var$column('status', 'Status'),
            $21a681dddb143fa0$var$column('orderQty', 'Order Qty'),
            $21a681dddb143fa0$var$column('displayQuantity', 'Display Qty'),
            $21a681dddb143fa0$var$column('totalFillQty', 'Total Fill Qty'),
            $21a681dddb143fa0$var$column('orderPrice', 'Order Px'),
            $21a681dddb143fa0$var$column('averageFillPrice', 'Average Fill Px'),
            $21a681dddb143fa0$var$column('strikePrice', 'Strike'),
            $21a681dddb143fa0$var$column('orderType', 'Order Type'),
            $21a681dddb143fa0$var$column('traderId', 'Trader'),
            $21a681dddb143fa0$var$column('orderId', 'Algo/Order ID'),
            $21a681dddb143fa0$var$column('algoType', 'Algo Type'),
            $21a681dddb143fa0$var$column('exchange', 'Exchange'),
            $21a681dddb143fa0$var$column('memo', 'Memo', false),
            $21a681dddb143fa0$var$column('customText1', 'Custom Text 1'),
            $21a681dddb143fa0$var$column('customText2', 'Custom Text 2'),
            $21a681dddb143fa0$var$column('customText3', 'Custom Text 3'),
            $21a681dddb143fa0$var$column('platform', 'Platform'),
            $21a681dddb143fa0$var$column('account', 'Account'),
            $21a681dddb143fa0$var$column('businessUnit', 'Business Unit'),
            $21a681dddb143fa0$var$column('timeInForce', 'TIF'),
            $21a681dddb143fa0$var$column('expirationDate', 'Expiration Date'),
            $21a681dddb143fa0$var$column('stopPrice', 'Stop-Price'),
            $21a681dddb143fa0$var$column('transactionTime', 'Transaction Time'),
            $21a681dddb143fa0$var$column('duration', 'Duration'),
            $21a681dddb143fa0$var$column('endTime', 'End Time'),
            $21a681dddb143fa0$var$column('broker', 'Broker', false)
        ]
    },
    {
        id: 'inventory',
        label: 'Inventory',
        description: 'Position and greeks grid defaults',
        columns: [
            $21a681dddb143fa0$var$column('account', 'Strategy'),
            $21a681dddb143fa0$var$column('uniqueSymbol', 'Symbol'),
            $21a681dddb143fa0$var$column('symbol.rootSymbol', 'Ref Symbol', false),
            $21a681dddb143fa0$var$column('contractSymbol', 'Exchange Symbol', false),
            $21a681dddb143fa0$var$column('symbol.segmentMic', 'Exchange', false),
            $21a681dddb143fa0$var$column('symbol.secType', 'Security Type', false),
            $21a681dddb143fa0$var$column('currentPosition', 'Current Position'),
            $21a681dddb143fa0$var$column('totalTraded', 'Total Traded'),
            $21a681dddb143fa0$var$column('currentPrice', 'Current Price'),
            $21a681dddb143fa0$var$column('newPL', 'PnL (USD)'),
            $21a681dddb143fa0$var$column('buyTotalTraded', 'Buy Total Traded', false),
            $21a681dddb143fa0$var$column('buyAveragePrice', 'Avg Buy Px'),
            $21a681dddb143fa0$var$column('buyPL', 'Buy PnL', false),
            $21a681dddb143fa0$var$column('sellTotalTraded', 'Sell Total Traded', false),
            $21a681dddb143fa0$var$column('sellAveragePrice', 'Avg Sell Px'),
            $21a681dddb143fa0$var$column('sellPL', 'Sell PnL', false),
            $21a681dddb143fa0$var$column('businessUnit', 'Business Unit', false),
            $21a681dddb143fa0$var$column('delta', 'Delta'),
            $21a681dddb143fa0$var$column('gamma', 'Gamma'),
            $21a681dddb143fa0$var$column('vega', 'Vega'),
            $21a681dddb143fa0$var$column('theta', 'Theta')
        ]
    },
    {
        id: 'tickerGrid',
        label: 'Ticker Grid',
        description: 'Watchlist grid defaults',
        columns: [
            $21a681dddb143fa0$var$column('name', 'Symbol'),
            $21a681dddb143fa0$var$column('exchangeSymbol', 'Exchange Symbol', false),
            $21a681dddb143fa0$var$column('product.description', 'Description'),
            $21a681dddb143fa0$var$column('prices.lastTrade.price', 'Last'),
            $21a681dddb143fa0$var$column('change', 'Change'),
            $21a681dddb143fa0$var$column('changePercent', 'Chng %'),
            $21a681dddb143fa0$var$column('prices.bid.price', 'Bid'),
            $21a681dddb143fa0$var$column('prices.bid.size', 'Bid Size'),
            $21a681dddb143fa0$var$column('prices.ask.price', 'Ask'),
            $21a681dddb143fa0$var$column('prices.ask.size', 'Ask Size'),
            $21a681dddb143fa0$var$column('prices.lastTrade.size', 'Last Quantity'),
            $21a681dddb143fa0$var$column('prices.lastTrade.dailyCumulativeVolume', 'Volume'),
            $21a681dddb143fa0$var$column('prices.high', 'High'),
            $21a681dddb143fa0$var$column('prices.low', 'Low'),
            $21a681dddb143fa0$var$column('prices.open', 'Open'),
            $21a681dddb143fa0$var$column('prices.previousDailySettlement.settlementPrice', 'Previous Settlement Price'),
            $21a681dddb143fa0$var$column('prices.previousDailySettlement.settlementStatus', 'Settlement Status'),
            $21a681dddb143fa0$var$column('prices.previousDailySettlement.settlementTimeUtc', 'Settlement Time(UTC)'),
            $21a681dddb143fa0$var$column('prices.openInterest', 'Open Interest'),
            $21a681dddb143fa0$var$column('product.expiry', 'Expiry Date'),
            $21a681dddb143fa0$var$column('prices.lastTrade.timeUtc', 'Time of last trade'),
            $21a681dddb143fa0$var$column('product.secType', 'Security Type'),
            $21a681dddb143fa0$var$column('product.currency', 'Currency'),
            $21a681dddb143fa0$var$column('product.strikePrice', 'Strike Price'),
            $21a681dddb143fa0$var$column('product.callPut', 'Put/Call')
        ]
    },
    {
        id: 'orderBlotter',
        label: 'Order Blotter',
        description: 'Execution history and lifecycle grid defaults',
        columns: [
            $21a681dddb143fa0$var$column('traderId', 'Trader'),
            $21a681dddb143fa0$var$column('orderSide', 'Side'),
            $21a681dddb143fa0$var$column('uniqueSymbol', 'Unique Symbol'),
            $21a681dddb143fa0$var$column('orderPrice', 'Order Px'),
            $21a681dddb143fa0$var$column('orderQuantity', 'Order Qty'),
            $21a681dddb143fa0$var$column('account', 'Account'),
            $21a681dddb143fa0$var$column('executionTag', 'Strategy'),
            $21a681dddb143fa0$var$column('customText1', 'Custom Text 1'),
            $21a681dddb143fa0$var$column('customText2', 'Custom Text 2'),
            $21a681dddb143fa0$var$column('customText3', 'Custom Text 3'),
            $21a681dddb143fa0$var$column('orderType', 'Type'),
            $21a681dddb143fa0$var$column('timeInForce', 'TIF'),
            $21a681dddb143fa0$var$column('status', 'Status'),
            $21a681dddb143fa0$var$column('totalFilled', 'Total Fill Qty'),
            $21a681dddb143fa0$var$column('leavesQuantity', 'Leaves Qty'),
            $21a681dddb143fa0$var$column('averagePrice', 'Average Fill Px'),
            $21a681dddb143fa0$var$column('transactionTime', 'Transaction Time Local'),
            $21a681dddb143fa0$var$column('orderId', 'Order ID'),
            $21a681dddb143fa0$var$column('algoRunId', 'Algo ID'),
            $21a681dddb143fa0$var$column('displayQuantity', 'Display Qty', false),
            $21a681dddb143fa0$var$column('root', 'Root Symbol', false),
            $21a681dddb143fa0$var$column('fillQTY', 'Fill Qty', false),
            $21a681dddb143fa0$var$column('fillQuantity', 'Last Partial Fill Qty', false),
            $21a681dddb143fa0$var$column('fillPrice', 'Last Partial Fill Px', false),
            $21a681dddb143fa0$var$column('broker', 'Broker', false),
            $21a681dddb143fa0$var$column('segmentMic', 'Exch', false),
            $21a681dddb143fa0$var$column('orderSource', 'Platform', false),
            $21a681dddb143fa0$var$column('memo', 'Memo', false),
            $21a681dddb143fa0$var$column('strikePrice', 'Strike', false),
            $21a681dddb143fa0$var$column('callPut', 'Call/Put', false),
            $21a681dddb143fa0$var$column('clientOrderId', 'Client Order Id', false),
            $21a681dddb143fa0$var$column('fixSymbol', 'Fix Symbol', false),
            $21a681dddb143fa0$var$column('sendingTimeUTC', 'Sending Time Local', false),
            $21a681dddb143fa0$var$column('senderSubId', 'Sender Sub Id', false),
            $21a681dddb143fa0$var$column('description', 'Description', false),
            $21a681dddb143fa0$var$column('maturityMonthYear', 'Maturity Month/Year', false),
            $21a681dddb143fa0$var$column('expirationDate', 'Expiration Date', false),
            $21a681dddb143fa0$var$column('expireTime', 'Expire Time', false),
            $21a681dddb143fa0$var$column('stopPrice', 'Stop Price', false),
            $21a681dddb143fa0$var$column('cfiCode', 'CFI Code', false),
            $21a681dddb143fa0$var$column('businessUnit', 'Business Unit', false),
            $21a681dddb143fa0$var$column('smpId', 'SMP ID', false),
            $21a681dddb143fa0$var$column('internalFilledQty', 'Internal Filled Qty', false),
            $21a681dddb143fa0$var$column('internalAveragePrice', 'Internal Avg Price', false),
            $21a681dddb143fa0$var$column('venueFilledQty', 'External Filled Qty', false),
            $21a681dddb143fa0$var$column('venueAveragePrice', 'External Avg Price', false)
        ]
    },
    {
        id: 'options',
        label: 'Options',
        description: 'Options chain grid defaults',
        columns: [
            $21a681dddb143fa0$var$column('call.dailyCumulativeVolume', 'Call Volume', false),
            $21a681dddb143fa0$var$column('call.settlementPrice', 'Call Settle Px', false),
            $21a681dddb143fa0$var$column('call.vol', 'Call Mid Vol', false),
            $21a681dddb143fa0$var$column('call.askVol', 'Call Ask Vol', false),
            $21a681dddb143fa0$var$column('call.bidVol', 'Call Bid Vol', false),
            $21a681dddb143fa0$var$column('call.theta', 'Call Theta'),
            $21a681dddb143fa0$var$column('call.vega', 'Call Vega'),
            $21a681dddb143fa0$var$column('call.gamma', 'Call Gamma'),
            $21a681dddb143fa0$var$column('call.delta', 'Call Delta'),
            $21a681dddb143fa0$var$column('call.openInterest', 'Call Open Interest'),
            $21a681dddb143fa0$var$column('call.fittedVol', 'Call Fitted Vol'),
            $21a681dddb143fa0$var$column('call.bidSize', 'Call Bid Size'),
            $21a681dddb143fa0$var$column('call.bid', 'Call Bid'),
            $21a681dddb143fa0$var$column('call.fittedPrice', 'Call Fitted Price'),
            $21a681dddb143fa0$var$column('call.ask', 'Call Ask'),
            $21a681dddb143fa0$var$column('call.askSize', 'Call Ask Size'),
            $21a681dddb143fa0$var$column('strike', 'Strike'),
            $21a681dddb143fa0$var$column('put.bidSize', 'Put Bid Size'),
            $21a681dddb143fa0$var$column('put.bid', 'Put Bid'),
            $21a681dddb143fa0$var$column('put.fittedPrice', 'Put Fitted Price'),
            $21a681dddb143fa0$var$column('put.ask', 'Put Ask'),
            $21a681dddb143fa0$var$column('put.askSize', 'Put Ask Size'),
            $21a681dddb143fa0$var$column('put.fittedVol', 'Put Fitted Vol'),
            $21a681dddb143fa0$var$column('put.openInterest', 'Put Open Interest'),
            $21a681dddb143fa0$var$column('put.delta', 'Put Delta'),
            $21a681dddb143fa0$var$column('put.gamma', 'Put Gamma'),
            $21a681dddb143fa0$var$column('put.vega', 'Put Vega'),
            $21a681dddb143fa0$var$column('put.theta', 'Put Theta'),
            $21a681dddb143fa0$var$column('put.bidVol', 'Put Bid Vol', false),
            $21a681dddb143fa0$var$column('put.askVol', 'Put Ask Vol', false),
            $21a681dddb143fa0$var$column('put.vol', 'Put Mid Vol', false),
            $21a681dddb143fa0$var$column('put.settlementPrice', 'Put Settle Px', false),
            $21a681dddb143fa0$var$column('put.dailyCumulativeVolume', 'Put Volume', false)
        ]
    },
    {
        id: 'algoManager',
        label: 'Algo Manager',
        description: 'Algo monitoring grid defaults',
        columns: [
            $21a681dddb143fa0$var$column('algoRunId', 'Algo ID'),
            $21a681dddb143fa0$var$column('createdDate', 'Date'),
            $21a681dddb143fa0$var$column('accountInfo.traderId', 'Trader'),
            $21a681dddb143fa0$var$column('algoType', 'Algo Type'),
            $21a681dddb143fa0$var$column('algoStatus', 'Status'),
            $21a681dddb143fa0$var$column('symbolsWithQTY', 'Symbols'),
            $21a681dddb143fa0$var$column('algoMetrics.targetQuantityOverall', 'Order Quantity'),
            $21a681dddb143fa0$var$column('algoMetrics.tradedQuantityOverall', 'Traded Quantity'),
            $21a681dddb143fa0$var$column('algoMetrics', 'Remaining Quantity'),
            $21a681dddb143fa0$var$column('estimatedTCA', 'Estimated TCA', false),
            $21a681dddb143fa0$var$column('executionMetrics.runningCost.dollarsValue', 'Run Cost'),
            $21a681dddb143fa0$var$column('totalSaving', 'Total Saving', false),
            $21a681dddb143fa0$var$column('exchange', 'Exchange', false),
            $21a681dddb143fa0$var$column('currency', 'CCY', false),
            $21a681dddb143fa0$var$column('broker_code', 'Broker', false)
        ]
    }
];
const $21a681dddb143fa0$export$17a9beea7f245bbc = [
    ...$21a681dddb143fa0$var$columnPreferenceAppDefinitions
].sort((firstApp, secondApp)=>firstApp.label.localeCompare(secondApp.label));
const $21a681dddb143fa0$export$fb5f00fd8a32f1b0 = {};
for (const app of $21a681dddb143fa0$export$17a9beea7f245bbc)$21a681dddb143fa0$export$fb5f00fd8a32f1b0[app.id] = app;



const $05aef1763dbe2d5b$var$legacyOrderEntryAppId = 'orderEntry';
const $05aef1763dbe2d5b$var$legacyOrderEntryFeature = 'orderEntry1.0';
const $05aef1763dbe2d5b$var$invalidDefaultColumnMessage = 'At least one default column is required.';
const $05aef1763dbe2d5b$var$lockedColumnIdsByAppId = {
    orderEntry: [
        'direction',
        'instrument',
        'quantity',
        'strategy'
    ]
};
function $05aef1763dbe2d5b$var$cloneColumn(column) {
    return {
        ...column
    };
}
function $05aef1763dbe2d5b$var$cloneColumns(columns) {
    return columns.map((column)=>$05aef1763dbe2d5b$var$cloneColumn(column));
}
function $05aef1763dbe2d5b$var$getLockedColumnIds(appId) {
    return $05aef1763dbe2d5b$var$lockedColumnIdsByAppId[appId] ?? [];
}
function $05aef1763dbe2d5b$var$isLockedColumn(appId, columnId) {
    return $05aef1763dbe2d5b$var$getLockedColumnIds(appId).includes(columnId);
}
/**
 * Returns the preference apps that are available in the current environment
 * without changing the persisted catalog or any stored legacy preferences.
 */ function $05aef1763dbe2d5b$var$getVisibleColumnPreferenceApps() {
    const isLegacyOrderEntryEnabled = (0, $d9gj3.getQepSystem)().container.canUseFeature($05aef1763dbe2d5b$var$legacyOrderEntryFeature);
    return (0, $21a681dddb143fa0$export$17a9beea7f245bbc).filter((app)=>app.id !== $05aef1763dbe2d5b$var$legacyOrderEntryAppId || isLegacyOrderEntryEnabled);
}
/**
 * Selects the first visible preference app so a hidden legacy app is never
 * opened by default outside the environments where it is available.
 */ function $05aef1763dbe2d5b$var$getDefaultSelectedAppId(apps) {
    return apps[0]?.id ?? '';
}
function $05aef1763dbe2d5b$export$d859d72b10c9a984(app, layout) {
    const lockedColumnIds = $05aef1763dbe2d5b$var$getLockedColumnIds(app.id);
    if (lockedColumnIds.length === 0) return {
        available: $05aef1763dbe2d5b$var$cloneColumns(layout.available),
        current: $05aef1763dbe2d5b$var$cloneColumns(layout.current)
    };
    const lockedColumnIdSet = new Set(lockedColumnIds);
    const defaultColumnsById = new Map(app.columns.map((column)=>[
            column.id,
            column
        ]));
    const currentColumnsById = new Map(layout.current.map((column)=>[
            column.id,
            column
        ]));
    const availableColumnsById = new Map(layout.available.map((column)=>[
            column.id,
            column
        ]));
    const missingAvailableColumns = app.columns.filter((column)=>!lockedColumnIdSet.has(column.id) && !currentColumnsById.has(column.id) && !availableColumnsById.has(column.id)).map((column)=>$05aef1763dbe2d5b$var$cloneColumn(column));
    return {
        current: [
            ...lockedColumnIds.map((columnId)=>currentColumnsById.get(columnId) ?? availableColumnsById.get(columnId) ?? defaultColumnsById.get(columnId)).filter((column)=>column !== undefined).map((column)=>({
                    ...$05aef1763dbe2d5b$var$cloneColumn(column),
                    visible: true
                })),
            ...layout.current.filter((column)=>!lockedColumnIdSet.has(column.id)).map((column)=>$05aef1763dbe2d5b$var$cloneColumn(column))
        ],
        available: [
            ...layout.available.filter((column)=>!lockedColumnIdSet.has(column.id)).map((column)=>$05aef1763dbe2d5b$var$cloneColumn(column)),
            ...missingAvailableColumns
        ]
    };
}
function $05aef1763dbe2d5b$var$getDefaultLayout(app) {
    return $05aef1763dbe2d5b$export$d859d72b10c9a984(app, {
        available: $05aef1763dbe2d5b$var$cloneColumns(app.columns.filter((column)=>!column.visible)),
        current: $05aef1763dbe2d5b$var$cloneColumns(app.columns.filter((column)=>column.visible))
    });
}
function $05aef1763dbe2d5b$export$81d804bee3ccc69e(preferences, appId) {
    const app = (0, $21a681dddb143fa0$export$fb5f00fd8a32f1b0)[appId];
    if (!app) return {
        available: [],
        current: []
    };
    const resolvedColumns = (0, $a8617325549fb624$export$39b53377f57a2647)(app.columns, (0, $a8617325549fb624$export$d5d2962233419d86)(preferences, appId));
    return $05aef1763dbe2d5b$export$d859d72b10c9a984(app, {
        available: $05aef1763dbe2d5b$var$cloneColumns(resolvedColumns.filter((column)=>!column.visible)),
        current: $05aef1763dbe2d5b$var$cloneColumns(resolvedColumns.filter((column)=>column.visible))
    });
}
function $05aef1763dbe2d5b$export$923698dda00451ea(preferences, appId, layout) {
    const app = (0, $21a681dddb143fa0$export$fb5f00fd8a32f1b0)[appId];
    let normalizedLayout;
    if (app) normalizedLayout = $05aef1763dbe2d5b$export$d859d72b10c9a984(app, layout);
    else normalizedLayout = {
        available: $05aef1763dbe2d5b$var$cloneColumns(layout.available),
        current: $05aef1763dbe2d5b$var$cloneColumns(layout.current)
    };
    const nextColumns = [
        ...normalizedLayout.current.map((column)=>({
                ...column,
                visible: true
            })),
        ...normalizedLayout.available.map((column)=>({
                ...column,
                visible: false
            }))
    ];
    return (0, $a8617325549fb624$export$3d620d626dfe8760)(preferences, appId, (0, $a8617325549fb624$export$116bc8482036b9d8)(nextColumns, appId));
}
function $05aef1763dbe2d5b$var$sortColumns(columns) {
    return $05aef1763dbe2d5b$var$cloneColumns(columns).sort((firstColumn, secondColumn)=>firstColumn.label.localeCompare(secondColumn.label));
}
function $05aef1763dbe2d5b$var$getNextSortMode(sortMode) {
    switch(sortMode){
        case 'default':
            return 'asc';
        case 'asc':
            return 'desc';
        case 'desc':
            return 'default';
    }
}
function $05aef1763dbe2d5b$export$e1774a6f4950e75b(columns, sortMode, defaultColumns) {
    if (sortMode === 'asc') return $05aef1763dbe2d5b$var$sortColumns(columns);
    if (sortMode === 'desc') return $05aef1763dbe2d5b$var$sortColumns(columns).reverse();
    const columnOrder = new Map(defaultColumns.map((column, index)=>[
            column.id,
            index
        ]));
    return $05aef1763dbe2d5b$var$cloneColumns(columns).sort((firstColumn, secondColumn)=>(columnOrder.get(firstColumn.id) ?? 0) - (columnOrder.get(secondColumn.id) ?? 0));
}
function $05aef1763dbe2d5b$var$getAppButtonTooltipTitle(isInvalid, hasUnsavedChanges) {
    if (isInvalid) return $05aef1763dbe2d5b$var$invalidDefaultColumnMessage;
    return hasUnsavedChanges ? 'Unsaved Changes' : '';
}
function $05aef1763dbe2d5b$var$getCurrentRowClassName(isDimmed, isLocked, isDropTarget) {
    return `column-preferences__row column-preferences__row--current ${isDimmed ? 'is-dimmed' : ''} ${isLocked ? 'is-locked' : ''} ${isDropTarget ? 'is-drop-target' : ''}`;
}
function $05aef1763dbe2d5b$var$insertColumn(columns, column, targetColumnId) {
    const nextColumns = $05aef1763dbe2d5b$var$cloneColumns(columns);
    const targetIndex = targetColumnId === undefined ? -1 : nextColumns.findIndex((currentColumn)=>currentColumn.id === targetColumnId);
    if (targetIndex === -1) nextColumns.push($05aef1763dbe2d5b$var$cloneColumn(column));
    else nextColumns.splice(targetIndex, 0, $05aef1763dbe2d5b$var$cloneColumn(column));
    return nextColumns;
}
function $05aef1763dbe2d5b$var$moveColumn(layout, sourceList, targetList, columnId, targetColumnId) {
    if (sourceList === targetList && columnId === targetColumnId) return {
        available: $05aef1763dbe2d5b$var$cloneColumns(layout.available),
        current: $05aef1763dbe2d5b$var$cloneColumns(layout.current)
    };
    const sourceColumns = $05aef1763dbe2d5b$var$cloneColumns(layout[sourceList]);
    const targetColumns = sourceList === targetList ? sourceColumns : $05aef1763dbe2d5b$var$cloneColumns(layout[targetList]);
    const sourceIndex = sourceColumns.findIndex((column)=>column.id === columnId);
    if (sourceIndex === -1) return {
        available: $05aef1763dbe2d5b$var$cloneColumns(layout.available),
        current: $05aef1763dbe2d5b$var$cloneColumns(layout.current)
    };
    const [movedColumn] = sourceColumns.splice(sourceIndex, 1);
    if (sourceList === targetList) return {
        ...layout,
        [sourceList]: $05aef1763dbe2d5b$var$insertColumn(sourceColumns, movedColumn, targetColumnId)
    };
    return {
        ...layout,
        [sourceList]: sourceColumns,
        [targetList]: $05aef1763dbe2d5b$var$insertColumn(targetColumns, movedColumn, targetColumnId)
    };
}
function $05aef1763dbe2d5b$var$matchesFilter(column, searchText) {
    return column.label.toLowerCase().includes(searchText.trim().toLowerCase());
}
function $05aef1763dbe2d5b$export$216fc1e605b7596b() {
    const { preference: preference, isLoading: isLoading } = (0, $4c2764743176540f$export$7b8091fb31b80ed6)((0, $a8617325549fb624$export$3771ac88bb5cd94e));
    const mutation = (0, $4c2764743176540f$export$f21c408c0e7893f)((0, $a8617325549fb624$export$3771ac88bb5cd94e));
    const savedPreferences = (0, $lx97N.useMemo)(()=>(0, $a8617325549fb624$export$3c0c35d3e3f58bb5)(preference), [
        preference
    ]);
    const [draftPreferences, setDraftPreferences] = (0, $lx97N.useState)(savedPreferences);
    const visibleColumnPreferenceApps = $05aef1763dbe2d5b$var$getVisibleColumnPreferenceApps();
    const [selectedAppId, setSelectedAppId] = (0, $lx97N.useState)(()=>$05aef1763dbe2d5b$var$getDefaultSelectedAppId(visibleColumnPreferenceApps));
    const [searchText, setSearchText] = (0, $lx97N.useState)('');
    const [dragState, setDragState] = (0, $lx97N.useState)();
    const [dropTarget, setDropTarget] = (0, $lx97N.useState)();
    const [availableSortMode, setAvailableSortMode] = (0, $lx97N.useState)('default');
    const [currentSortMode, setCurrentSortMode] = (0, $lx97N.useState)('default');
    (0, $lx97N.useEffect)(()=>{
        setDraftPreferences(savedPreferences);
    }, [
        savedPreferences
    ]);
    const activeApp = visibleColumnPreferenceApps.find((app)=>app.id === selectedAppId) ?? visibleColumnPreferenceApps[0];
    const activeAppId = activeApp?.id ?? '';
    const activeAppColumns = activeApp?.columns ?? [];
    const layout = (0, $lx97N.useMemo)(()=>activeApp ? $05aef1763dbe2d5b$export$81d804bee3ccc69e(draftPreferences, activeApp.id) : {
            available: [],
            current: []
        }, [
        activeApp,
        draftPreferences
    ]);
    const normalizedSearchText = searchText.trim().toLowerCase();
    const filteredAvailableColumns = (0, $lx97N.useMemo)(()=>{
        if (normalizedSearchText === '') return layout.available;
        return layout.available.filter((column)=>$05aef1763dbe2d5b$var$matchesFilter(column, normalizedSearchText));
    }, [
        layout.available,
        normalizedSearchText
    ]);
    const filteredCurrentColumns = (0, $lx97N.useMemo)(()=>{
        if (normalizedSearchText === '') return layout.current;
        return layout.current.filter((column)=>$05aef1763dbe2d5b$var$matchesFilter(column, normalizedSearchText));
    }, [
        layout.current,
        normalizedSearchText
    ]);
    const filteredRemovableCurrentColumns = (0, $lx97N.useMemo)(()=>filteredCurrentColumns.filter((column)=>!$05aef1763dbe2d5b$var$isLockedColumn(activeAppId, column.id)), [
        activeAppId,
        filteredCurrentColumns
    ]);
    const unsavedAppIds = (0, $lx97N.useMemo)(()=>new Set(visibleColumnPreferenceApps.filter((app)=>JSON.stringify($05aef1763dbe2d5b$export$81d804bee3ccc69e(draftPreferences, app.id)) !== JSON.stringify($05aef1763dbe2d5b$export$81d804bee3ccc69e(savedPreferences, app.id))).map((app)=>app.id)), [
        draftPreferences,
        savedPreferences,
        visibleColumnPreferenceApps
    ]);
    const invalidAppIds = (0, $lx97N.useMemo)(()=>new Set(visibleColumnPreferenceApps.filter((app)=>$05aef1763dbe2d5b$export$81d804bee3ccc69e(draftPreferences, app.id).current.length === 0).map((app)=>app.id)), [
        draftPreferences,
        visibleColumnPreferenceApps
    ]);
    const persistedState = JSON.stringify(savedPreferences);
    const draftState = JSON.stringify(draftPreferences);
    const isDirty = persistedState !== draftState;
    const hasValidationErrors = invalidAppIds.size > 0;
    const updateLayout = (updater)=>{
        if (!activeApp) return;
        setDraftPreferences((currentPreferences)=>$05aef1763dbe2d5b$export$923698dda00451ea(currentPreferences, activeApp.id, updater($05aef1763dbe2d5b$export$81d804bee3ccc69e(currentPreferences, activeApp.id))));
    };
    const moveColumnBetweenLists = (sourceList, targetList, columnId, targetColumnId)=>{
        if (sourceList === 'available' || targetList === 'available') setAvailableSortMode('default');
        if (sourceList === 'current' || targetList === 'current') setCurrentSortMode('default');
        updateLayout((currentLayout)=>$05aef1763dbe2d5b$var$moveColumn(currentLayout, sourceList, targetList, columnId, targetColumnId));
    };
    const handleListDrop = (targetList)=>{
        if (!dragState) return;
        moveColumnBetweenLists(dragState.sourceList, targetList, dragState.columnId, dropTarget?.list === targetList ? dropTarget.columnId : undefined);
        setDragState(undefined);
        setDropTarget(undefined);
    };
    const handleDefaultReset = ()=>{
        if (!activeApp) return;
        setAvailableSortMode('default');
        setCurrentSortMode('default');
        setDraftPreferences((currentPreferences)=>$05aef1763dbe2d5b$export$923698dda00451ea(currentPreferences, activeApp.id, $05aef1763dbe2d5b$var$getDefaultLayout(activeApp)));
    };
    const getSortEndIcon = (sortMode)=>/*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
            className: "column-preferences__sort-icon",
            "aria-hidden": "true",
            children: [
                sortMode === 'asc' && /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($630cf1ba6302e89e$exports))), {
                    fontSize: "inherit"
                }),
                sortMode === 'desc' && /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eb0846882f605c09$exports))), {
                    fontSize: "inherit"
                })
            ]
        });
    if (isLoading) return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $eda52aa0d1dd92cb$export$7c20be4c1d342248), {});
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "column-preferences",
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $2f943f6b64633db4$export$2e2bcd8739ae039), {
            spacing: 2,
            className: "column-preferences__content",
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05476049bba0344f$export$2e2bcd8739ae039), {
                            variant: "h6",
                            children: "Columns"
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05476049bba0344f$export$2e2bcd8739ae039), {
                            variant: "body2",
                            className: "column-preferences__subtitle",
                            sx: {
                                fontSize: '11px',
                                lineHeight: 1.4
                            },
                            children: "Choose an app, then drag or double-click columns between the lists to build the default layout. Saved changes apply to newly opened app screens."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("hr", {
                    className: "column-preferences__divider",
                    "aria-hidden": "true"
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                    className: "column-preferences__app-grid",
                    "aria-label": "Column preference apps",
                    children: visibleColumnPreferenceApps.map((app)=>{
                        const hasUnsavedChanges = unsavedAppIds.has(app.id);
                        const isInvalid = invalidAppIds.has(app.id);
                        const tooltipTitle = $05aef1763dbe2d5b$var$getAppButtonTooltipTitle(isInvalid, hasUnsavedChanges);
                        const appButton = /*#__PURE__*/ (0, $fRwNr.jsxs)("button", {
                            type: "button",
                            className: `column-preferences__app-button ${activeApp?.id === app.id ? 'selected' : ''} ${isInvalid ? 'invalid' : ''}`,
                            "aria-label": `${app.label} columns`,
                            "aria-pressed": activeApp?.id === app.id,
                            onClick: ()=>{
                                setSelectedAppId(app.id);
                                setSearchText('');
                                setDragState(undefined);
                                setDropTarget(undefined);
                                setAvailableSortMode('default');
                                setCurrentSortMode('default');
                            },
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                    className: "column-preferences__app-button-title",
                                    children: app.label
                                }),
                                hasUnsavedChanges && /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                    className: "column-preferences__app-button-indicator",
                                    "aria-label": `${app.label} has unsaved changes`,
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dc0428a5efda2a98$exports))), {
                                        fontSize: "inherit"
                                    })
                                })
                            ]
                        }, app.id);
                        if (tooltipTitle === '') return appButton;
                        return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $824bfd70ec70846a$export$2e2bcd8739ae039), {
                            title: tooltipTitle,
                            placement: "top",
                            slotProps: {
                                tooltip: {
                                    sx: {
                                        fontSize: '12px'
                                    }
                                }
                            },
                            children: /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                className: "column-preferences__app-button-tooltip",
                                children: appButton
                            })
                        }, app.id);
                    })
                }),
                /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                    className: "column-preferences__builder",
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsxs)("section", {
                            className: "column-preferences__panel",
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05476049bba0344f$export$2e2bcd8739ae039), {
                                    variant: "subtitle2",
                                    className: "column-preferences__panel-title",
                                    sx: {
                                        fontSize: '11px'
                                    },
                                    children: "Available Columns"
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                    className: "column-preferences__panel-controls",
                                    children: [
                                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                            size: "small",
                                            variant: "text",
                                            endIcon: getSortEndIcon(availableSortMode),
                                            className: "column-preferences__sort-button",
                                            "aria-label": "Cycle available columns sort order",
                                            onClick: ()=>{
                                                const nextSortMode = $05aef1763dbe2d5b$var$getNextSortMode(availableSortMode);
                                                setAvailableSortMode(nextSortMode);
                                                updateLayout((currentLayout)=>({
                                                        ...currentLayout,
                                                        available: $05aef1763dbe2d5b$export$e1774a6f4950e75b(currentLayout.available, nextSortMode, activeAppColumns)
                                                    }));
                                            },
                                            children: "Sort"
                                        }),
                                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $9e73d3de5eb0002c$export$2e2bcd8739ae039), {
                                            size: "small",
                                            label: "Filter",
                                            value: searchText,
                                            onChange: (event)=>{
                                                setSearchText(event.target.value);
                                            },
                                            className: "column-preferences__filter",
                                            InputProps: normalizedSearchText === '' ? undefined : {
                                                endAdornment: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $e28b683e771ff52d$export$2e2bcd8739ae039), {
                                                    position: "end",
                                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $aad80e9a9c3e4c99$export$2e2bcd8739ae039), {
                                                        "aria-label": "Clear filter",
                                                        edge: "end",
                                                        size: "small",
                                                        onClick: ()=>{
                                                            setSearchText('');
                                                        },
                                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($702c5c85d45cae88$exports))), {
                                                            fontSize: "small"
                                                        })
                                                    })
                                                })
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                    className: "column-preferences__list-shell",
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                        className: `column-preferences__list ${dropTarget?.list === 'available' && !dropTarget.columnId ? 'is-drop-target-end' : ''}`,
                                        "data-testid": "column-preferences-available-list",
                                        onDragOver: (event)=>{
                                            event.preventDefault();
                                            if (event.target === event.currentTarget) setDropTarget({
                                                list: 'available'
                                            });
                                        },
                                        onDrop: (event)=>{
                                            event.preventDefault();
                                            handleListDrop('available');
                                        },
                                        children: filteredAvailableColumns.length === 0 ? /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                            className: "column-preferences__empty",
                                            children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05476049bba0344f$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                children: normalizedSearchText === '' ? 'No available columns.' : 'No available columns match this filter.'
                                            })
                                        }) : filteredAvailableColumns.map((column)=>/*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                                className: `column-preferences__row ${dropTarget?.list === 'available' && dropTarget.columnId === column.id ? 'is-drop-target' : ''}`,
                                                draggable: true,
                                                onDoubleClick: ()=>{
                                                    moveColumnBetweenLists('available', 'current', column.id);
                                                },
                                                onDragStart: (event)=>{
                                                    event.dataTransfer.effectAllowed = 'move';
                                                    setDragState({
                                                        columnId: column.id,
                                                        sourceList: 'available'
                                                    });
                                                },
                                                onDragEnd: ()=>{
                                                    setDragState(undefined);
                                                    setDropTarget(undefined);
                                                },
                                                onDragEnter: ()=>{
                                                    setDropTarget({
                                                        list: 'available',
                                                        columnId: column.id
                                                    });
                                                },
                                                onDragOver: (event)=>{
                                                    event.preventDefault();
                                                },
                                                onDrop: (event)=>{
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    if (!dragState) return;
                                                    moveColumnBetweenLists(dragState.sourceList, 'available', dragState.columnId, column.id);
                                                    setDragState(undefined);
                                                    setDropTarget(undefined);
                                                },
                                                children: /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                                    className: "column-preferences__row-label",
                                                    children: column.label
                                                })
                                            }, column.id))
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                            className: "column-preferences__transfer-indicator",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e195de697ccdd4e5$exports))), {
                                fontSize: "inherit"
                            })
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsxs)("section", {
                            className: "column-preferences__panel",
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05476049bba0344f$export$2e2bcd8739ae039), {
                                    variant: "subtitle2",
                                    className: "column-preferences__panel-title",
                                    sx: {
                                        fontSize: '11px'
                                    },
                                    children: "Current Layout"
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                    className: "column-preferences__panel-controls",
                                    children: [
                                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                            size: "small",
                                            variant: "outlined",
                                            disabled: normalizedSearchText === '' ? layout.available.length === 0 : filteredAvailableColumns.length === 0,
                                            onClick: ()=>{
                                                setAvailableSortMode('default');
                                                setCurrentSortMode('default');
                                                updateLayout((currentLayout)=>{
                                                    const columnsToAdd = normalizedSearchText === '' ? currentLayout.available : currentLayout.available.filter((column)=>$05aef1763dbe2d5b$var$matchesFilter(column, normalizedSearchText));
                                                    if (columnsToAdd.length === 0) return {
                                                        available: $05aef1763dbe2d5b$var$cloneColumns(currentLayout.available),
                                                        current: $05aef1763dbe2d5b$var$cloneColumns(currentLayout.current)
                                                    };
                                                    return {
                                                        available: normalizedSearchText === '' ? [] : currentLayout.available.filter((column)=>!$05aef1763dbe2d5b$var$matchesFilter(column, normalizedSearchText)).map((column)=>$05aef1763dbe2d5b$var$cloneColumn(column)),
                                                        current: [
                                                            ...$05aef1763dbe2d5b$var$cloneColumns(currentLayout.current),
                                                            ...$05aef1763dbe2d5b$var$cloneColumns(columnsToAdd)
                                                        ]
                                                    };
                                                });
                                            },
                                            children: normalizedSearchText === '' ? 'Add All' : 'Add Filtered'
                                        }),
                                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                            size: "small",
                                            variant: "outlined",
                                            disabled: normalizedSearchText === '' ? layout.current.filter((column)=>!$05aef1763dbe2d5b$var$isLockedColumn(activeAppId, column.id)).length === 0 : filteredRemovableCurrentColumns.length === 0,
                                            onClick: ()=>{
                                                setAvailableSortMode('default');
                                                setCurrentSortMode('default');
                                                updateLayout((currentLayout)=>{
                                                    const shouldRemoveColumn = (column)=>!$05aef1763dbe2d5b$var$isLockedColumn(activeAppId, column.id) && (normalizedSearchText === '' || $05aef1763dbe2d5b$var$matchesFilter(column, normalizedSearchText));
                                                    const columnsToRemove = currentLayout.current.filter((column)=>shouldRemoveColumn(column));
                                                    if (columnsToRemove.length === 0) return {
                                                        available: $05aef1763dbe2d5b$var$cloneColumns(currentLayout.available),
                                                        current: $05aef1763dbe2d5b$var$cloneColumns(currentLayout.current)
                                                    };
                                                    return {
                                                        available: [
                                                            ...$05aef1763dbe2d5b$var$cloneColumns(currentLayout.available),
                                                            ...$05aef1763dbe2d5b$var$cloneColumns(columnsToRemove)
                                                        ],
                                                        current: currentLayout.current.filter((column)=>!shouldRemoveColumn(column)).map((column)=>$05aef1763dbe2d5b$var$cloneColumn(column))
                                                    };
                                                });
                                            },
                                            children: normalizedSearchText === '' ? 'Remove All' : 'Remove Filtered'
                                        }),
                                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                            size: "small",
                                            variant: "outlined",
                                            onClick: handleDefaultReset,
                                            children: "Default"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                    className: "column-preferences__list-shell",
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                        className: `column-preferences__list column-preferences__list--current ${dropTarget?.list === 'current' && !dropTarget.columnId ? 'is-drop-target-end' : ''}`,
                                        "data-testid": "column-preferences-current-list",
                                        onDragOver: (event)=>{
                                            event.preventDefault();
                                            if (event.target === event.currentTarget) setDropTarget({
                                                list: 'current'
                                            });
                                        },
                                        onDrop: (event)=>{
                                            event.preventDefault();
                                            handleListDrop('current');
                                        },
                                        children: layout.current.length === 0 ? /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                            className: "column-preferences__empty",
                                            children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05476049bba0344f$export$2e2bcd8739ae039), {
                                                variant: "body2",
                                                children: "No columns are currently selected."
                                            })
                                        }) : layout.current.map((column)=>{
                                            const isDimmed = normalizedSearchText !== '' && !$05aef1763dbe2d5b$var$matchesFilter(column, normalizedSearchText);
                                            const isLocked = $05aef1763dbe2d5b$var$isLockedColumn(activeAppId, column.id);
                                            const isDropTarget = dropTarget?.list === 'current' && dropTarget.columnId === column.id;
                                            return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                                className: $05aef1763dbe2d5b$var$getCurrentRowClassName(isDimmed, isLocked, isDropTarget),
                                                draggable: !isLocked,
                                                onDoubleClick: ()=>{
                                                    if (!isLocked) moveColumnBetweenLists('current', 'available', column.id);
                                                },
                                                onDragStart: (event)=>{
                                                    if (isLocked) {
                                                        event.preventDefault();
                                                        return;
                                                    }
                                                    event.dataTransfer.effectAllowed = 'move';
                                                    setDragState({
                                                        columnId: column.id,
                                                        sourceList: 'current'
                                                    });
                                                },
                                                onDragEnd: ()=>{
                                                    setDragState(undefined);
                                                    setDropTarget(undefined);
                                                },
                                                onDragEnter: ()=>{
                                                    if (!isLocked) setDropTarget({
                                                        list: 'current',
                                                        columnId: column.id
                                                    });
                                                },
                                                onDragOver: (event)=>{
                                                    event.preventDefault();
                                                },
                                                onDrop: (event)=>{
                                                    event.preventDefault();
                                                    event.stopPropagation();
                                                    if (!dragState || isLocked) return;
                                                    moveColumnBetweenLists(dragState.sourceList, 'current', dragState.columnId, column.id);
                                                    setDragState(undefined);
                                                    setDropTarget(undefined);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                                        className: "column-preferences__row-label",
                                                        children: column.label
                                                    }),
                                                    isLocked && /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                                        className: "column-preferences__row-lock",
                                                        "aria-label": "Locked column",
                                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2022a969a40c7ea8$exports))), {
                                                            fontSize: "inherit"
                                                        })
                                                    })
                                                ]
                                            }, column.id);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $2f943f6b64633db4$export$2e2bcd8739ae039), {
                    direction: "row",
                    spacing: 1,
                    justifyContent: "flex-end",
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                            variant: "text",
                            disabled: !isDirty || mutation.isPending,
                            onClick: ()=>{
                                setDraftPreferences(savedPreferences);
                            },
                            children: "Discard"
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                            variant: "contained",
                            disabled: !isDirty || mutation.isPending || hasValidationErrors,
                            onClick: ()=>{
                                mutation.mutate(draftPreferences);
                            },
                            children: "Save changes"
                        })
                    ]
                })
            ]
        })
    });
}


const $3c61bb782faaee34$var$style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 750,
    height: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 0
};
const $3c61bb782faaee34$var$closeStyles = {
    position: 'absolute',
    height: 31,
    width: 31,
    right: 0
};
const $3c61bb782faaee34$export$7cc290b358f7fb0a = (swVersion)=>{
    const { appVersion: appVersion } = globalThis;
    const appEnv = (0, $l2Ecb.getAppEnv)();
    if (!appEnv) return `${appVersion}:${swVersion}`;
    switch(appEnv){
        case 'local':
            return `local:${appVersion}:${swVersion}`;
        case 'development':
            return `development:${appVersion}:${swVersion}`;
        case 'staging':
            return `staging:${appVersion}:${swVersion}`;
        case 'preprod':
            return `preprod:${appVersion}:${swVersion}`;
        default:
            return `${appVersion}:${swVersion}`;
    }
};
function $3c61bb782faaee34$var$CustomTabPanel(props) {
    const { children: children, value: value, index: index, ...other } = props;
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        role: "tabpanel",
        hidden: value !== index,
        id: `preferences-tabpanel-${index}`,
        "aria-labelledby": `preferences-tab-${index}`,
        style: {
            height: '100%'
        },
        ...other,
        children: value === index && /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d47fb49f85ffe081$export$2e2bcd8739ae039), {
            sx: {
                p: 3,
                height: '100%'
            },
            children: children
        })
    });
}
function $3c61bb782faaee34$var$a11yProps(index) {
    return {
        id: `preferences-tab-${index}`,
        'aria-controls': `preferences-tabpanel-${index}`
    };
}
function $3c61bb782faaee34$export$e4b04d74d864122c(props) {
    const [value, setValue] = (0, $lx97N.useState)(0);
    const { open: open, onClose: onClose } = props;
    // Feature-flagged Columns preferences tab. When the flag is disabled we
    // hide the Tab control and its corresponding CustomTabPanel entirely so
    // the ColumnPreferences tree never mounts.
    const canUseColumnsPreferences = (0, $d9gj3.getQepSystem)().container.canUseFeature('preferencesColumnsTab');
    const isColumnsTab = canUseColumnsPreferences && value === 3;
    const modalStyle = {
        ...$3c61bb782faaee34$var$style,
        height: isColumnsTab ? 'min(800px, 80vh)' : 400,
        maxHeight: '80vh'
    };
    const handleChange = (_event, newValue)=>{
        setValue(newValue);
    };
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $c25de88565c859da$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        "aria-labelledby": "preferences-modal-title",
        "aria-describedby": "preferences-modal-description",
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $d47fb49f85ffe081$export$2e2bcd8739ae039), {
            sx: modalStyle,
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $2f943f6b64633db4$export$2e2bcd8739ae039), {
                    direction: "row",
                    sx: {
                        height: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $2f943f6b64633db4$export$2e2bcd8739ae039), {
                            direction: "column",
                            sx: {
                                borderRight: 1,
                                borderColor: 'divider',
                                flexShrink: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d47fb49f85ffe081$export$2e2bcd8739ae039), {
                                    sx: {
                                        p: 2
                                    },
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05476049bba0344f$export$2e2bcd8739ae039), {
                                        variant: "h6",
                                        children: "Preferences"
                                    })
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $16f665bb55281646$export$2e2bcd8739ae039), {
                                    value: value,
                                    onChange: handleChange,
                                    "aria-label": "preference tabs",
                                    orientation: "vertical",
                                    children: [
                                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $ee037eba9a6f2690$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'end'
                                            },
                                            label: "QEP",
                                            ...$3c61bb782faaee34$var$a11yProps(0)
                                        }),
                                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $ee037eba9a6f2690$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'end'
                                            },
                                            label: "Trade Products",
                                            ...$3c61bb782faaee34$var$a11yProps(1)
                                        }),
                                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $ee037eba9a6f2690$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'end'
                                            },
                                            label: "Order Book",
                                            ...$3c61bb782faaee34$var$a11yProps(2)
                                        }),
                                        canUseColumnsPreferences && /*#__PURE__*/ (0, $fRwNr.jsx)((0, $ee037eba9a6f2690$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'end'
                                            },
                                            label: "Columns",
                                            ...$3c61bb782faaee34$var$a11yProps(3)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $2f943f6b64633db4$export$2e2bcd8739ae039), {
                            sx: {
                                flexGrow: 1,
                                overflow: 'auto'
                            },
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)($3c61bb782faaee34$var$CustomTabPanel, {
                                    value: value,
                                    index: 0,
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $e5c0e727af7c8f5f$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsx)($3c61bb782faaee34$var$CustomTabPanel, {
                                    value: value,
                                    index: 1,
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $0d92478b409d0e1a$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $fRwNr.jsx)($3c61bb782faaee34$var$CustomTabPanel, {
                                    value: value,
                                    index: 2,
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $6c30678239ad05ae$export$41dc20f57fbc2963), {})
                                }),
                                canUseColumnsPreferences && /*#__PURE__*/ (0, $fRwNr.jsx)($3c61bb782faaee34$var$CustomTabPanel, {
                                    value: value,
                                    index: 3,
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $05aef1763dbe2d5b$export$216fc1e605b7596b), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsx)((0, $aad80e9a9c3e4c99$export$2e2bcd8739ae039), {
                            sx: $3c61bb782faaee34$var$closeStyles,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($702c5c85d45cae88$exports))), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)($3c61bb782faaee34$var$FakeUser, {})
            ]
        })
    });
}
const $3c61bb782faaee34$var$validateIsEmail = (email)=>{
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
};
const $3c61bb782faaee34$var$FakeUser = ()=>{
    const [newUser, setNewUser] = (0, $lx97N.useState)('');
    const [creds, setCreds] = (0, $lx97N.useState)(undefined);
    const [appLabel, setAppLabel] = (0, $lx97N.useState)('');
    const serviceWorkerVersionRef = (0, $lx97N.useRef)('');
    (0, $lx97N.useEffect)(()=>{
        const fetchCreds = async ()=>{
            const creds = await $3c61bb782faaee34$var$getCreds();
            setCreds(creds);
        };
        fetchCreds();
    }, []);
    // Need to know the user information to display the preferences
    const submitUser = (0, $lx97N.useCallback)(()=>{
        if (!$3c61bb782faaee34$var$validateIsEmail(newUser)) return;
        const updateInfo = async ()=>{
            await (0, (/*@__PURE__*/$parcel$interopDefault($4z7Fu)))('POST', (0, $l2Ecb.getApiServer)() + '/api/auth/fake').set('x-qep-session-id', creds?.sessionId ?? '').type('form').withCredentials().send({
                user: newUser
            });
        };
        updateInfo();
    }, [
        newUser
    ]);
    const updateUser = (0, $lx97N.useCallback)(()=>{
        submitUser();
    }, [
        newUser
    ]);
    (0, $lx97N.useEffect)(()=>{
        const syncAppLabel = ()=>{
            setAppLabel($3c61bb782faaee34$export$7cc290b358f7fb0a(serviceWorkerVersionRef.current));
        };
        syncAppLabel();
        (0, $5629744cb1d83a68$export$5b7220d0cd593d0)((version)=>{
            serviceWorkerVersionRef.current = version;
            syncAppLabel();
        });
        const intervalId = globalThis.setInterval(()=>{
            if ((0, $l2Ecb.getAppEnv)()) {
                syncAppLabel();
                globalThis.clearInterval(intervalId);
            }
        }, 250);
        return ()=>{
            globalThis.clearInterval(intervalId);
        };
    }, []);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        children: "Current User:"
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        children: `${creds?.upn}::${creds?.traderId}`
                    })
                ]
            }),
            creds?.upn?.toLowerCase() === 'ryan_sharp@cargill.com' ? /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        style: {
                            paddingRight: '10px'
                        },
                        children: "fake user"
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $jZinT.QEPInput), {
                        style: {
                            color: 'white',
                            marginRight: '10px'
                        },
                        onChange: (event)=>{
                            setNewUser(event.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                        onClick: updateUser,
                        children: "Update Session with user"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                children: appLabel
            })
        ]
    });
};
const $3c61bb782faaee34$var$getCreds = async ()=>new Promise((resolve, reject)=>{
        (0, $d9gj3.getQepSystem)().container.authentication.getCurrentCredentials((error, credentials)=>{
            if (error) {
                reject(error);
                return;
            }
            resolve(credentials.credentials ?? credentials);
        });
    });


var $ded74e28f6d46edb$exports = {};
$ded74e28f6d46edb$exports = new URL("../darkLogo.406eb4a0.png", import.meta.url).toString();



var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");

var $37w0r = parcelRequire("37w0r");

var $cckdX = parcelRequire("cckdX");


var $d9gj3 = parcelRequire("d9gj3");

var $fRwNr = parcelRequire("fRwNr");
parcelRequire("lx97N");

var $1f0784e6b0098301$export$83c7e170da8a1660 = /*#__PURE__*/ function(StatusClass) {
    StatusClass["OK"] = "ok";
    StatusClass["WARNING"] = "warning";
    StatusClass["ERROR"] = "error";
    return StatusClass;
}({});
var $1f0784e6b0098301$export$1cff19bc692fb8bb = /*#__PURE__*/ function(StatusIconAssetLocation) {
    StatusIconAssetLocation["NONE"] = "";
    StatusIconAssetLocation["OK"] = "/assets/img/success.svg";
    StatusIconAssetLocation["WARNING"] = "/assets/img/warning.svg";
    StatusIconAssetLocation["ERROR"] = "/assets/img/error.svg";
    return StatusIconAssetLocation;
}({});
var $1f0784e6b0098301$export$ccff7fe96c96c97 = /*#__PURE__*/ function(StatusText) {
    StatusText["NONE"] = "";
    StatusText["OK"] = "Connected";
    StatusText["WARNING"] = "Warnings";
    StatusText["ERROR"] = "Critical";
    return StatusText;
}({});


function $e23c8cdc63c5685a$export$73ca67757763d5ff(parameters) {
    const { open: open, statusClass: statusClass, classes: classes } = parameters;
    const getKeyFromStatus = (status, keysFrom)=>{
        let collection = [];
        switch(keysFrom){
            case 'icons':
                collection = Object.entries((0, $1f0784e6b0098301$export$1cff19bc692fb8bb));
                break;
            case 'text':
                collection = Object.entries((0, $1f0784e6b0098301$export$ccff7fe96c96c97));
                break;
        }
        if (collection !== null && open) {
            const value = collection.find(([key])=>key.toLowerCase() === status.toLowerCase())?.[1];
            return value === null ? undefined : value;
        }
        return undefined;
    };
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: `${classes ?? ''} network-status ${open ? 'expanded' : ''} ${statusClass}'`.trim(),
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
            className: `status-container ${statusClass} ${open ? '' : 'hidden'}`,
            children: [
                open && /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                    className: "expanded-info",
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsx)("img", {
                            className: "status-icon",
                            src: getKeyFromStatus(statusClass, 'icons') ?? (0, $1f0784e6b0098301$export$1cff19bc692fb8bb).NONE
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                            className: "status-text",
                            children: getKeyFromStatus(statusClass, 'text')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                    className: `network-status-indicator ${statusClass}`,
                    children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: `indicator-inner ${statusClass}`
                    })
                })
            ]
        })
    });
}




/* eslint-disable @typescript-eslint/naming-convention */ const $45c7904ad4c163e8$var$displayNames = {
    MDR1: 'Streaming Prices 1',
    MDR2: 'Streaming Prices 2',
    MySQL: 'Blotter',
    QEP_DCR: 'Real-Time Orders',
    QEP_OMS: 'Order Manager',
    HTTPCLIENT: 'HTTP Client',
    httpServer: 'HTTP Server'
};
/* eslint-enable @typescript-eslint/naming-convention */ function $45c7904ad4c163e8$var$toDisplayName(componentName) {
    return $45c7904ad4c163e8$var$displayNames[componentName] ?? componentName;
}
function $45c7904ad4c163e8$var$getStatusClass(status) {
    switch(status.statusInfoString.toLowerCase()){
        case (0, $cckdX.CONNECTIVITY_STATUSES).OPEN.toLowerCase():
        case (0, $cckdX.CONNECTIVITY_STATUSES).READY.toLowerCase():
            return (0, $1f0784e6b0098301$export$83c7e170da8a1660).OK;
        case (0, $cckdX.CONNECTIVITY_STATUSES).SLOW.toLowerCase():
            return (0, $1f0784e6b0098301$export$83c7e170da8a1660).WARNING;
        case (0, $cckdX.CONNECTIVITY_STATUSES).CLOSED.toLowerCase():
            return (0, $1f0784e6b0098301$export$83c7e170da8a1660).WARNING;
        default:
            return (0, $1f0784e6b0098301$export$83c7e170da8a1660).ERROR;
    }
}
function $45c7904ad4c163e8$export$ed6c55f90c1d06ca() {
    const currentGlobalState = (0, $lx97N.useRef)((0, $1f0784e6b0098301$export$83c7e170da8a1660).WARNING);
    const [menuItems, setMenuItems] = (0, $lx97N.useState)([]);
    const [overallStatus, setOverallStatus] = (0, $lx97N.useState)((0, $1f0784e6b0098301$export$83c7e170da8a1660).OK);
    // eslint-disable-next-line @typescript-eslint/no-restricted-types
    const popoverRef = (0, $lx97N.useRef)(null);
    const [anchorElement, setAnchorElement] = (0, $lx97N.useState)(undefined);
    const open = Boolean(anchorElement);
    function handlePopoverOpen(event) {
        setAnchorElement(event.currentTarget);
    }
    (0, $lx97N.useEffect)(()=>{
        let cancelTimeout;
        function checkIfClosePopover(event) {
            if (!anchorElement) return;
            const inAnchor = Boolean(anchorElement?.contains(event.target));
            const inPopover = Boolean(popoverRef.current?.contains(event.target));
            if (inAnchor || inPopover) clearTimeout(cancelTimeout);
            else {
                clearTimeout(cancelTimeout);
                cancelTimeout = setTimeout(()=>{
                    setAnchorElement(undefined);
                }, 90);
            }
        }
        document.addEventListener('mouseenter', checkIfClosePopover, true);
        return ()=>{
            clearTimeout(cancelTimeout);
            document.removeEventListener('mouseenter', checkIfClosePopover, true);
        };
    }, [
        anchorElement,
        setAnchorElement
    ]);
    (0, $lx97N.useEffect)(()=>{
        const handleStatusesChange = (0, $37w0r.debounce)((statuses = [])=>{
            const newMenuItems = [];
            let worstState = (0, $1f0784e6b0098301$export$83c7e170da8a1660).OK;
            for (const connectionStatus of statuses){
                const status = $45c7904ad4c163e8$var$getStatusClass(connectionStatus);
                if (status === (0, $1f0784e6b0098301$export$83c7e170da8a1660).WARNING) {
                    if (worstState !== (0, $1f0784e6b0098301$export$83c7e170da8a1660).ERROR) worstState = (0, $1f0784e6b0098301$export$83c7e170da8a1660).WARNING;
                    const status = getItemRow(connectionStatus);
                    if (status !== undefined) newMenuItems.push(status);
                } else if (status === (0, $1f0784e6b0098301$export$83c7e170da8a1660).ERROR) {
                    worstState = (0, $1f0784e6b0098301$export$83c7e170da8a1660).ERROR;
                    const status = getItemRow(connectionStatus);
                    if (status !== undefined) newMenuItems.push(status);
                }
            }
            // If switching back to a 'Connected' state, make sure the menu is closed
            // before hiding the menu button
            if (worstState === (0, $1f0784e6b0098301$export$83c7e170da8a1660).OK && currentGlobalState.current !== (0, $1f0784e6b0098301$export$83c7e170da8a1660).OK) currentGlobalState.current = (0, $1f0784e6b0098301$export$83c7e170da8a1660).OK;
            else if (worstState !== currentGlobalState.current) currentGlobalState.current = worstState;
            setOverallStatus(worstState);
            setMenuItems(newMenuItems);
        }, 500);
        const unsubscribe = (0, $d9gj3.getQepSystem)().connectivity.listenToStatusesChange(handleStatusesChange);
        return ()=>{
            unsubscribe();
            handleStatusesChange.cancel();
        };
    }, []);
    const getItemRow = (connectionStatus)=>{
        switch(connectionStatus.statusInfoString.toLowerCase()){
            case (0, $cckdX.CONNECTIVITY_STATUSES).CLOSED.toLowerCase():
                return {
                    icon: (0, $1f0784e6b0098301$export$1cff19bc692fb8bb).ERROR,
                    text: `${$45c7904ad4c163e8$var$toDisplayName(connectionStatus.componentName)} connection cannot be established`
                };
            case (0, $cckdX.CONNECTIVITY_STATUSES).OPEN.toLowerCase():
            case (0, $cckdX.CONNECTIVITY_STATUSES).READY.toLowerCase():
                return;
            default:
                return {
                    icon: (0, $1f0784e6b0098301$export$1cff19bc692fb8bb).WARNING,
                    text: `${$45c7904ad4c163e8$var$toDisplayName(connectionStatus.componentName)} is in a ${connectionStatus.statusInfoString} state`
                };
        }
    };
    return /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                id: "menu-container",
                className: "menu-container",
                onMouseEnter: handlePopoverOpen,
                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $e23c8cdc63c5685a$export$73ca67757763d5ff), {
                    open: open,
                    statusClass: overallStatus
                })
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f6613b84ba031cfb$export$2e2bcd8739ae039), {
                id: "network-status-menu",
                className: "status-menu-main",
                open: open && menuItems.length > 0,
                anchorEl: anchorElement,
                children: /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                    className: "statuses",
                    ref: popoverRef,
                    children: [
                        /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                            className: `status-overview ${overallStatus}`
                        }),
                        /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                            className: "status-list-content",
                            children: /*#__PURE__*/ (0, $fRwNr.jsx)("ul", {
                                children: menuItems.map((item, i)=>/*#__PURE__*/ (0, $fRwNr.jsxs)("li", {
                                        children: [
                                            /*#__PURE__*/ (0, $fRwNr.jsx)("img", {
                                                src: item.icon
                                            }),
                                            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                                children: item.text
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    ]
                })
            })
        ]
    });
}



var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");


var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $lx97N = parcelRequire("lx97N");
'use client';
const $501eec7566f1e8fb$var$usePreviousProps = (value)=>{
    const ref = $lx97N.useRef({});
    $lx97N.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
};
var $501eec7566f1e8fb$export$2e2bcd8739ae039 = $501eec7566f1e8fb$var$usePreviousProps;



var $8o5tH = parcelRequire("8o5tH");

function $0f88570dc3563353$export$2e2bcd8739ae039(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $501eec7566f1e8fb$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}




var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $4BrfH = parcelRequire("4BrfH");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $b6ba119d7653620f$export$aaccef17e6dab084(slot) {
    return (0, $h6nFM.default)('MuiBadge', slot);
}
const $b6ba119d7653620f$var$badgeClasses = (0, $3OBXm.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $b6ba119d7653620f$export$2e2bcd8739ae039 = $b6ba119d7653620f$var$badgeClasses;



var $fRwNr = parcelRequire("fRwNr");
const $8be87b9583ac791b$var$_excluded = [
    "anchorOrigin",
    "className",
    "classes",
    "component",
    "components",
    "componentsProps",
    "children",
    "overlap",
    "color",
    "invisible",
    "max",
    "badgeContent",
    "slots",
    "slotProps",
    "showZero",
    "variant"
];
const $8be87b9583ac791b$var$RADIUS_STANDARD = 10;
const $8be87b9583ac791b$var$RADIUS_DOT = 4;
const $8be87b9583ac791b$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $4BrfH.default)(anchorOrigin.vertical)}${(0, $4BrfH.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $4BrfH.default)(anchorOrigin.vertical)}${(0, $4BrfH.default)(anchorOrigin.horizontal)}${(0, $4BrfH.default)(overlap)}`,
            `overlap${(0, $4BrfH.default)(overlap)}`,
            color !== 'default' && `color${(0, $4BrfH.default)(color)}`
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $b6ba119d7653620f$export$aaccef17e6dab084), classes);
};
const $8be87b9583ac791b$var$BadgeRoot = (0, $7Ys8f.default)('span', {
    name: 'MuiBadge',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $8be87b9583ac791b$var$BadgeBadge = (0, $7Ys8f.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $4BrfH.default)(ownerState.anchorOrigin.vertical)}${(0, $4BrfH.default)(ownerState.anchorOrigin.horizontal)}${(0, $4BrfH.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $4BrfH.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $8be87b9583ac791b$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $8be87b9583ac791b$var$RADIUS_STANDARD * 2,
        borderRadius: $8be87b9583ac791b$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        })
    }, ownerState.color !== 'default' && {
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main,
        color: (theme.vars || theme).palette[ownerState.color].contrastText
    }, ownerState.variant === 'dot' && {
        borderRadius: $8be87b9583ac791b$var$RADIUS_DOT,
        height: $8be87b9583ac791b$var$RADIUS_DOT * 2,
        minWidth: $8be87b9583ac791b$var$RADIUS_DOT * 2,
        padding: 0
    }, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular' && {
        top: 0,
        right: 0,
        transform: 'scale(1) translate(50%, -50%)',
        transformOrigin: '100% 0%',
        [`&.${(0, $b6ba119d7653620f$export$2e2bcd8739ae039).invisible}`]: {
            transform: 'scale(0) translate(50%, -50%)'
        }
    }, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular' && {
        bottom: 0,
        right: 0,
        transform: 'scale(1) translate(50%, 50%)',
        transformOrigin: '100% 100%',
        [`&.${(0, $b6ba119d7653620f$export$2e2bcd8739ae039).invisible}`]: {
            transform: 'scale(0) translate(50%, 50%)'
        }
    }, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular' && {
        top: 0,
        left: 0,
        transform: 'scale(1) translate(-50%, -50%)',
        transformOrigin: '0% 0%',
        [`&.${(0, $b6ba119d7653620f$export$2e2bcd8739ae039).invisible}`]: {
            transform: 'scale(0) translate(-50%, -50%)'
        }
    }, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular' && {
        bottom: 0,
        left: 0,
        transform: 'scale(1) translate(-50%, 50%)',
        transformOrigin: '0% 100%',
        [`&.${(0, $b6ba119d7653620f$export$2e2bcd8739ae039).invisible}`]: {
            transform: 'scale(0) translate(-50%, 50%)'
        }
    }, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular' && {
        top: '14%',
        right: '14%',
        transform: 'scale(1) translate(50%, -50%)',
        transformOrigin: '100% 0%',
        [`&.${(0, $b6ba119d7653620f$export$2e2bcd8739ae039).invisible}`]: {
            transform: 'scale(0) translate(50%, -50%)'
        }
    }, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular' && {
        bottom: '14%',
        right: '14%',
        transform: 'scale(1) translate(50%, 50%)',
        transformOrigin: '100% 100%',
        [`&.${(0, $b6ba119d7653620f$export$2e2bcd8739ae039).invisible}`]: {
            transform: 'scale(0) translate(50%, 50%)'
        }
    }, ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular' && {
        top: '14%',
        left: '14%',
        transform: 'scale(1) translate(-50%, -50%)',
        transformOrigin: '0% 0%',
        [`&.${(0, $b6ba119d7653620f$export$2e2bcd8739ae039).invisible}`]: {
            transform: 'scale(0) translate(-50%, -50%)'
        }
    }, ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular' && {
        bottom: '14%',
        left: '14%',
        transform: 'scale(1) translate(-50%, 50%)',
        transformOrigin: '0% 100%',
        [`&.${(0, $b6ba119d7653620f$export$2e2bcd8739ae039).invisible}`]: {
            transform: 'scale(0) translate(-50%, 50%)'
        }
    }, ownerState.invisible && {
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.leavingScreen
        })
    }));
const $8be87b9583ac791b$var$Badge = /*#__PURE__*/ $lx97N.forwardRef(function Badge(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$badge, _slotProps$root, _slotProps$badge;
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp = {
        vertical: 'top',
        horizontal: 'right'
    }, className: className, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard' } = props, other = (0, $hphT8.default)(props, $8be87b9583ac791b$var$_excluded);
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $0f88570dc3563353$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $501eec7566f1e8fb$export$2e2bcd8739ae039)({
        anchorOrigin: anchorOriginProp,
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOrigin = anchorOriginProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = (0, $eR4tV.default)({}, props, {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    });
    const classes = $8be87b9583ac791b$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $8be87b9583ac791b$var$BadgeRoot;
    const BadgeSlot = (_ref2 = (_slots$badge = slots == null ? void 0 : slots.badge) != null ? _slots$badge : components.Badge) != null ? _ref2 : $8be87b9583ac791b$var$BadgeBadge;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const badgeSlotProps = (_slotProps$badge = slotProps == null ? void 0 : slotProps.badge) != null ? _slotProps$badge : componentsProps.badge;
    const rootProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $fmTP4.default)(rootSlotProps == null ? void 0 : rootSlotProps.className, classes.root, className)
    });
    const badgeProps = (0, $ea513296a282d999$export$2e2bcd8739ae039)({
        elementType: BadgeSlot,
        externalSlotProps: badgeSlotProps,
        ownerState: ownerState,
        className: (0, $fmTP4.default)(classes.badge, badgeSlotProps == null ? void 0 : badgeSlotProps.className)
    });
    return /*#__PURE__*/ (0, $fRwNr.jsxs)(RootSlot, (0, $eR4tV.default)({}, rootProps, {
        children: [
            children,
            /*#__PURE__*/ (0, $fRwNr.jsx)(BadgeSlot, (0, $eR4tV.default)({}, badgeProps, {
                children: displayValue
            }))
        ]
    }));
});
var $8be87b9583ac791b$export$2e2bcd8739ae039 = $8be87b9583ac791b$var$Badge;


var $80cd42b97061b43a$exports = {};
"use strict";

Object.defineProperty($80cd42b97061b43a$exports, "__esModule", {
    value: true
});
$80cd42b97061b43a$exports.default = void 0;

var $80cd42b97061b43a$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $80cd42b97061b43a$var$_default = (0, $80cd42b97061b43a$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
}), 'Notifications');
$80cd42b97061b43a$exports.default = $80cd42b97061b43a$var$_default;





var $cckdX = parcelRequire("cckdX");

var $alcuF = parcelRequire("alcuF");
var $d9gj3 = parcelRequire("d9gj3");

var $l2Ecb = parcelRequire("l2Ecb");


var $19TnD = parcelRequire("19TnD");

var $evEIS = parcelRequire("evEIS");


var $3bGoE = parcelRequire("3bGoE");


var $fRwNr = parcelRequire("fRwNr");
parcelRequire("lx97N");




var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $89f89302edf8b901$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');


var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $a4a75e7ba2af7063$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $8fb26529a116b144$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
}), 'Logout');


var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $d6fe0d3fed4ba2bd$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
}), 'ShoppingCart');


var $3EewP = parcelRequire("3EewP");

var $fRwNr = parcelRequire("fRwNr");
var $72e25588aac500fd$export$2e2bcd8739ae039 = (0, $3EewP.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "m3.5 18.49 6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
}), 'ShowChart');



var $cckdX = parcelRequire("cckdX");

var $d9gj3 = parcelRequire("d9gj3");

function $9df27c120aaccfc4$var$isQepNotificationStatus(status) {
    return Object.values((0, $cckdX.QEPNotificationStatus)).includes(status);
}
const $9df27c120aaccfc4$export$df5c6cccb198f23 = (status)=>{
    if (!$9df27c120aaccfc4$var$isQepNotificationStatus(status)) return '';
    switch(status){
        case (0, $cckdX.QEPNotificationStatus).CRITICAL:
            return 'browser-notification-critical';
        case (0, $cckdX.QEPNotificationStatus).HIGH:
            return 'browser-notification-high';
        case (0, $cckdX.QEPNotificationStatus).MEDIUM:
            return 'browser-notification-medium';
        case (0, $cckdX.QEPNotificationStatus).LOW:
            return 'browser-notification-low';
        case (0, $cckdX.QEPNotificationStatus).SYSTEM:
            return 'browser-notification-system';
    }
};
function $9df27c120aaccfc4$var$isQepNotificationType(type) {
    return Object.values((0, $cckdX.QEPNotificationType)).includes(type);
}
const $9df27c120aaccfc4$var$getTypeIcon = (type)=>{
    if (!$9df27c120aaccfc4$var$isQepNotificationType(type)) return null;
    switch(type){
        case (0, $cckdX.QEPNotificationType).ORDER:
            return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d6fe0d3fed4ba2bd$export$2e2bcd8739ae039), {
                className: "browser-notification-type-icon"
            });
        case (0, $cckdX.QEPNotificationType).ALGO:
            return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $72e25588aac500fd$export$2e2bcd8739ae039), {
                className: "browser-notification-type-icon"
            });
        case (0, $cckdX.QEPNotificationType).ALERT:
            return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $a4a75e7ba2af7063$export$2e2bcd8739ae039), {
                className: "browser-notification-type-icon"
            });
        case (0, $cckdX.QEPNotificationType).SYSTEM:
            return null;
    }
};
const $9df27c120aaccfc4$var$NotificationCard = ({ notification: notification, viewedNotifications: viewedNotifications, flashingNotification: flashingNotification, onRemove: onRemove, onReportIssue: onReportIssue, onLogout: onLogout, setFlashingNotification: setFlashingNotification, setViewedNotifications: setViewedNotifications })=>/*#__PURE__*/ (0, $fRwNr.jsxs)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
        className: `browser-notification-item ${$9df27c120aaccfc4$export$df5c6cccb198f23(notification.status || (0, $cckdX.QEPNotificationStatus).LOW)}`,
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                style: {
                    display: 'flex',
                    flex: 1,
                    alignItems: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: `browser-notification-priority-indicator ${$9df27c120aaccfc4$export$df5c6cccb198f23(notification.status || (0, $cckdX.QEPNotificationStatus).LOW)}`,
                        style: {
                            backgroundColor: 'var(--base-color)'
                        }
                    }),
                    $9df27c120aaccfc4$var$getTypeIcon(notification.type),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $824bfd70ec70846a$export$2e2bcd8739ae039), {
                                title: /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                    style: {
                                        fontSize: 14
                                    },
                                    children: notification.title
                                }),
                                arrow: true,
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                    className: "browser-notification-title",
                                    style: {
                                        maxWidth: 150,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap'
                                    },
                                    children: notification.title
                                })
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                className: "browser-notification-timestamp",
                                children: new Date(notification.timestamp).toLocaleString()
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $824bfd70ec70846a$export$2e2bcd8739ae039), {
                                title: notification.longDescription,
                                arrow: true,
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                    className: "browser-notification-description",
                                    children: notification.shortDescription
                                })
                            })
                        ]
                    }),
                    notification.actions && /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: "browser-notification-actions",
                        style: {
                            marginLeft: 'auto',
                            display: 'flex',
                            gap: 8
                        },
                        children: notification.actions.map((action, index)=>{
                            if (action.type === (0, $cckdX.QEPNotificationActionType).SHARE) return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                onClick: (event)=>{
                                    event.stopPropagation();
                                    (0, $d9gj3.getQepSystem)().container.linker.publishOrOpenWindow(action.data);
                                },
                                children: action.label
                            }, index);
                            if (action.type === (0, $cckdX.QEPNotificationActionType).QEP_ACTION) {
                                let icon;
                                let label = '';
                                switch(action.data){
                                    case (0, $cckdX.QEPSystemAction).LOGOUT:
                                        icon = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8fb26529a116b144$export$2e2bcd8739ae039), {});
                                        label = 'Logout';
                                        break;
                                    case (0, $cckdX.QEPSystemAction).OPEN_ISSUE_REPORTER:
                                        icon = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $a4a75e7ba2af7063$export$2e2bcd8739ae039), {});
                                        label = 'Report Issue';
                                        break;
                                    default:
                                        break;
                                }
                                return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                    onClick: (event)=>{
                                        event.stopPropagation();
                                        if (action.data === (0, $cckdX.QEPSystemAction).OPEN_ISSUE_REPORTER) onReportIssue();
                                        else if (action.data === (0, $cckdX.QEPSystemAction).LOGOUT) onLogout();
                                    },
                                    title: label,
                                    children: icon
                                }, index);
                            }
                            return null;
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $89f89302edf8b901$export$2e2bcd8739ae039), {
                className: "browser-notification-close-button",
                onClick: ()=>{
                    setViewedNotifications(viewedNotifications.filter((id)=>id !== String(notification.id)));
                    onRemove(notification.id ?? '');
                    if (flashingNotification?.id === notification.id) setFlashingNotification(undefined);
                }
            })
        ]
    }, notification.id);
var $9df27c120aaccfc4$export$2e2bcd8739ae039 = $9df27c120aaccfc4$var$NotificationCard;



var $5Wk8r = parcelRequire("5Wk8r");
/**
 * Owns the Notification Center's in-memory Redux state, authentication readiness, and local ingestion.
 * Notification state is intentionally not persisted through notification CRUD APIs.
 */ 
var $5Wk8r = parcelRequire("5Wk8r");

var $cckdX = parcelRequire("cckdX");


var $cckdX = parcelRequire("cckdX");
function $c03d5a972fc4bba5$var$processOrder(notification, notificationUpdate, previousNotification) {
    const order = notificationUpdate?.payload;
    const isCriticalRejection = Number(order.msgType) === 9;
    if (order.status !== previousNotification?.payload?.status) notification.isRead = false;
    else if (previousNotification && !isCriticalRejection) {
        notification.hasNotified = true;
        notification.isRead = previousNotification.isRead;
    }
    let orderStatus = Number(order.status);
    if (Number.isNaN(Number(order.status))) orderStatus = order.status ?? '';
    if (isCriticalRejection) {
        notification.status = (0, $cckdX.QEPNotificationStatus).CRITICAL;
        return;
    }
    switch(orderStatus){
        case (0, $cckdX.OrderState).ORDERSTATE_REJECTED:
            notification.status = (0, $cckdX.QEPNotificationStatus).CRITICAL;
            break;
        case (0, $cckdX.OrderState).ORDERSTATE_CANCELED:
            notification.status = (0, $cckdX.QEPNotificationStatus).HIGH;
            break;
        case (0, $cckdX.OrderState).ORDERSTATE_CANCEL_REJECTED:
            notification.status = (0, $cckdX.QEPNotificationStatus).CRITICAL;
            break;
        case (0, $cckdX.OrderState).ORDERSTATE_FILLED:
            notification.status = (0, $cckdX.QEPNotificationStatus).MEDIUM;
            break;
        case (0, $cckdX.OrderState).ORDERSTATE_PARTIAL_FILLED:
            notification.status = (0, $cckdX.QEPNotificationStatus).MEDIUM;
            break;
        default:
            break;
    }
}
const $c03d5a972fc4bba5$export$7b8a4b79552d2ec1 = (notificationUpdate, previousNotification)=>{
    const notification = {
        id: notificationUpdate.id,
        type: notificationUpdate.type,
        title: notificationUpdate.title,
        shortDescription: notificationUpdate.shortDescription ?? '',
        longDescription: notificationUpdate.longDescription,
        payload: notificationUpdate.payload,
        isRead: true,
        hasNotified: false,
        status: (0, $cckdX.QEPNotificationStatus).LOW,
        timestamp: new Date().toISOString()
    };
    switch(notificationUpdate.type){
        case (0, $cckdX.QEPNotificationType).ALERT:
            break;
        case (0, $cckdX.QEPNotificationType).SYSTEM:
            break;
        case (0, $cckdX.QEPNotificationType).ORDER:
            $c03d5a972fc4bba5$var$processOrder(notification, notificationUpdate, previousNotification);
            break;
        case (0, $cckdX.QEPNotificationType).ALGO:
            {
                const algo = notificationUpdate?.payload;
                if (algo.algoStatus !== previousNotification?.payload?.algoStatus) notification.isRead = false;
                else if (previousNotification) {
                    notification.hasNotified = true;
                    notification.isRead = previousNotification.isRead;
                }
                // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
                switch(algo.algoStatus){
                    case (0, $cckdX.AlgoStatusString).ALGOSTATUS_ABORTED_BY_SYSTEM:
                        notification.status = (0, $cckdX.QEPNotificationStatus).CRITICAL;
                        break;
                    case (0, $cckdX.AlgoStatusString).ALGOSTATUS_ABORTED:
                        notification.status = (0, $cckdX.QEPNotificationStatus).HIGH;
                        break;
                    case (0, $cckdX.AlgoStatusString).ALGOSTATUS_ERROR:
                        notification.status = (0, $cckdX.QEPNotificationStatus).CRITICAL;
                        break;
                    case (0, $cckdX.AlgoStatusString).ALGOSTATUS_PAUSED:
                        notification.status = (0, $cckdX.QEPNotificationStatus).MEDIUM;
                        break;
                    case (0, $cckdX.AlgoStatusString).ALGOSTATUS_INCOMPLETE_REACHED_END_TIME:
                        notification.status = (0, $cckdX.QEPNotificationStatus).MEDIUM;
                        break;
                    case (0, $cckdX.AlgoStatusString).ALGOSTATUS_INCOMPLETE_MARKET_CLOSED:
                        notification.status = (0, $cckdX.QEPNotificationStatus).MEDIUM;
                        break;
                    default:
                        notification.status = (0, $cckdX.QEPNotificationStatus).LOW;
                        break;
                }
                break;
            }
    }
    notification.actions = $c03d5a972fc4bba5$var$buildOrderActionPayload(notificationUpdate) ?? previousNotification?.actions ?? [];
    return notification;
};
function $c03d5a972fc4bba5$var$buildOrderActionPayload(notification) {
    if (notification?.payload?.algoRunId) return $c03d5a972fc4bba5$var$buildAlgoActions(notification);
    if (notification?.payload?.orderId) return $c03d5a972fc4bba5$var$buildOrderActions(notification);
    return [];
}
const $c03d5a972fc4bba5$var$buildOrderActions = (notification)=>{
    const order = notification?.payload;
    const actionPayload = {
        type: (0, $cckdX.QEPNotificationActionType).SHARE,
        label: 'Clone',
        data: {}
    };
    actionPayload.data = {
        componentType: (0, $cckdX.ComponentType).ORDER_ENTRY,
        dataType: (0, $cckdX.LinkerDataType).ORDER,
        data: order,
        meta: {}
    };
    return [
        actionPayload
    ];
};
const $c03d5a972fc4bba5$var$buildAlgoActions = (notification)=>{
    const actionPayload = {
        type: (0, $cckdX.QEPNotificationActionType).SHARE,
        label: 'Clone',
        data: {}
    };
    actionPayload.data = {
        componentType: (0, $cckdX.ComponentType).ORDER_ENTRY,
        dataType: (0, $cckdX.LinkerDataType).ALGO,
        data: {
            algoRunId: notification.payload?.algoRunId
        },
        meta: {}
    };
    return [
        actionPayload
    ];
};


const $faa7d48a62ed25bb$var$initialState = {
    notifications: [],
    user: undefined,
    loaded: false,
    flashingNotification: undefined
};
const $faa7d48a62ed25bb$var$getAuthInfo = async ()=>{
    const browser = (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)();
    const authInfo = await browser.applicationClient.getAuthInfo();
    if (authInfo) return authInfo;
    return new Promise((resolve)=>{
        const onAuthChange = async (message)=>{
            if (message.message) {
                const authInfo = await browser.applicationClient.getAuthInfo();
                if (!authInfo) return;
                resolve(authInfo);
                browser.applicationClient.removeListener(browser.applicationClient.APPLICATION_EVENTS.AUTH.AUTH_STATUS_CHANGE.topic, onAuthChange);
            }
        };
        browser.applicationClient.addListener(browser.applicationClient.APPLICATION_EVENTS.AUTH.AUTH_STATUS_CHANGE.topic, onAuthChange);
    });
};
const $faa7d48a62ed25bb$export$a5712b47707ed1a0 = (0, $5Wk8r.createAsyncThunk)('notifications/loadNotifications', async (_, { rejectWithValue: rejectWithValue })=>{
    try {
        const authInfo = await $faa7d48a62ed25bb$var$getAuthInfo();
        // You can fetch notifications here if needed, e.g.:
        // const notifications = await fetchNotifications(authInfo);
        return {
            user: authInfo /* , notifications */ 
        };
    } catch (error) {
        return rejectWithValue(error);
    }
});
const $faa7d48a62ed25bb$export$6ff06b226c32675c = (0, $5Wk8r.createAsyncThunk)('notifications/addIncomingNotification', async (notification, { dispatch: dispatch, getState: getState, rejectWithValue: rejectWithValue })=>{
    try {
        const state = getState();
        const existing = state.notifications.notifications.find((item)=>item.id === notification.id);
        const processed = (0, $c03d5a972fc4bba5$export$7b8a4b79552d2ec1)(notification, existing);
        dispatch($faa7d48a62ed25bb$export$c7def531c087da85(processed));
        return processed;
    } catch (error) {
        return rejectWithValue(error);
    }
});
const $faa7d48a62ed25bb$var$notificationsSlice = (0, $5Wk8r.createSlice)({
    name: 'notifications',
    initialState: $faa7d48a62ed25bb$var$initialState,
    reducers: {
        setNotifications (state, action) {
            state.notifications = action.payload;
            // Determine flashing notification
            const unreadNotifications = action.payload.filter((n)=>!n.isRead);
            // Find newest unread CRITICAL or SYSTEM notification
            const criticalOrSystem = unreadNotifications.filter((n)=>n.status === (0, $cckdX.QEPNotificationStatus).CRITICAL || n.type === (0, $cckdX.QEPNotificationType).SYSTEM).sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
            if (criticalOrSystem.length > 0) state.flashingNotification = criticalOrSystem[0];
            else if (unreadNotifications.length > 0) {
                // Fallback to newest unread notification
                const sorted = unreadNotifications.sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
                state.flashingNotification = sorted[0];
            } else state.flashingNotification = undefined;
        },
        setFlashingNotification (state, action) {
            state.flashingNotification = action.payload;
        },
        addNotification (state, action) {
            const existingIndex = state.notifications.findIndex((n)=>n.id === action.payload.id);
            if (existingIndex === -1) state.notifications.push(action.payload);
            else state.notifications[existingIndex] = action.payload;
            state.notifications.sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
            // Update flashing notification
            const unreadNotifications = state.notifications.filter((n)=>!n.isRead);
            const criticalOrSystem = unreadNotifications.filter((n)=>n.status === (0, $cckdX.QEPNotificationStatus).CRITICAL || n.type === (0, $cckdX.QEPNotificationType).SYSTEM).sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
            if (criticalOrSystem.length > 0) state.flashingNotification = criticalOrSystem[0];
            else if (unreadNotifications.length > 0) {
                const sorted = unreadNotifications.sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
                state.flashingNotification = sorted[0];
            } else state.flashingNotification = undefined;
        },
        removeNotification (state, action) {
            state.notifications = state.notifications.filter((n)=>n.id !== action.payload);
            // Update flashing notification
            const unreadNotifications = state.notifications.filter((n)=>!n.isRead);
            const criticalOrSystem = unreadNotifications.filter((n)=>n.status === (0, $cckdX.QEPNotificationStatus).CRITICAL || n.type === (0, $cckdX.QEPNotificationType).SYSTEM).sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
            if (criticalOrSystem.length > 0) state.flashingNotification = criticalOrSystem[0];
            else if (unreadNotifications.length > 0) {
                const sorted = unreadNotifications.sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
                state.flashingNotification = sorted[0];
            } else state.flashingNotification = undefined;
        },
        clearNotifications (state) {
            state.notifications = [];
            state.flashingNotification = undefined;
        },
        /** Marks every locally stored notification as read and clears the flashing indicator. */ markAllAsRead (state) {
            state.notifications = state.notifications.map((n)=>({
                    ...n,
                    isRead: true
                }));
            state.flashingNotification = undefined;
        }
    },
    extraReducers (builder) {
        builder.addCase($faa7d48a62ed25bb$export$a5712b47707ed1a0.pending, (state)=>{
            state.loaded = false;
        }).addCase($faa7d48a62ed25bb$export$a5712b47707ed1a0.fulfilled, (state, action)=>{
            state.user = action.payload.user;
            // state.notifications = action.payload.notifications || [];
            state.loaded = true;
        }).addCase($faa7d48a62ed25bb$export$a5712b47707ed1a0.rejected, (state)=>{
            state.loaded = false;
        });
    }
});
const { setNotifications: $faa7d48a62ed25bb$export$c53275bee200c32a, addNotification: $faa7d48a62ed25bb$export$c7def531c087da85, removeNotification: $faa7d48a62ed25bb$export$92eb0ea44f8c9242, clearNotifications: $faa7d48a62ed25bb$export$b65f4a3c4931e367, markAllAsRead: $faa7d48a62ed25bb$export$45de1630b4d84a29, setFlashingNotification: $faa7d48a62ed25bb$export$5cbab8109acd4bbb } = $faa7d48a62ed25bb$var$notificationsSlice.actions;
const $faa7d48a62ed25bb$export$bee6154092e86884 = (state)=>state.notifications.flashingNotification;
var $faa7d48a62ed25bb$export$2e2bcd8739ae039 = $faa7d48a62ed25bb$var$notificationsSlice.reducer;


const $2ef2f2312c04b122$var$store = (0, $5Wk8r.configureStore)({
    reducer: {
        notifications: (0, $faa7d48a62ed25bb$export$2e2bcd8739ae039)
    }
});
var $2ef2f2312c04b122$export$2e2bcd8739ae039 = $2ef2f2312c04b122$var$store;




var $cckdX = parcelRequire("cckdX");
const $c1b91f6bcafd183b$export$9d7e1e59b633c631 = (order, user)=>{
    if (!order || order.traderId !== user.traderId) return;
    return {
        id: order.orderId,
        type: (0, $cckdX.QEPNotificationType).ORDER,
        title: `${$c1b91f6bcafd183b$export$8df45f5244e8def3(order)}`,
        shortDescription: `${order.orderId} updated`,
        payload: order,
        status: (0, $cckdX.QEPNotificationStatus).LOW,
        timestamp: new Date().toISOString()
    };
};
const $c1b91f6bcafd183b$export$426aa10fb7004d30 = (algo, user)=>{
    if (!algo || algo.accountInfo?.traderId !== user.traderId) return;
    return {
        id: algo.algoRunId,
        type: (0, $cckdX.QEPNotificationType).ALGO,
        title: `${$c1b91f6bcafd183b$export$9d9dc38f0bb5f4e1(algo)}`,
        shortDescription: `${algo.algoRunId} updated`,
        payload: algo,
        status: (0, $cckdX.QEPNotificationStatus).LOW,
        timestamp: new Date().toISOString()
    };
};
const $c1b91f6bcafd183b$export$9d9dc38f0bb5f4e1 = (algo)=>`Algo ${algo.algoRunId}-${$c1b91f6bcafd183b$var$getHummanReadableAlgoStatus(algo)}`;
const $c1b91f6bcafd183b$export$dda23b8ded24fde0 = (order)=>`Order ${order.orderId}-`;
const $c1b91f6bcafd183b$export$8df45f5244e8def3 = (order)=>{
    if ($c1b91f6bcafd183b$var$getHummanReadableOrderStatus(order) === '') return '';
    return `${$c1b91f6bcafd183b$export$dda23b8ded24fde0(order)}${$c1b91f6bcafd183b$var$getHummanReadableOrderStatus(order)}`;
};
const $c1b91f6bcafd183b$var$getHummanReadableAlgoStatus = (algo)=>{
    const { algoStatus: algoStatus } = algo;
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    switch(algoStatus){
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_ABORTED_BY_SYSTEM:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_ABORTED_BY_SYSTEM;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_ABORTED:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_ABORTED;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_ERROR:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_ERROR;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_PAUSED:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_PAUSED;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_INCOMPLETE_REACHED_END_TIME:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_INCOMPLETE_REACHED_END_TIME;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_INCOMPLETE_MARKET_CLOSED:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_INCOMPLETE_MARKET_CLOSED;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_RUNNING:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_RUNNING;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_COMPLETE:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_COMPLETE;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_INITIALIZED:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_INITIALIZED;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_RESUME_REQUESTED:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_RESUME_REQUESTED;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_PAUSE_REQUESTED:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_PAUSE_REQUESTED;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_LAUNCH_REQUESTED:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_LAUNCH_REQUESTED;
        case (0, $cckdX.AlgoStatusString).ALGOSTATUS_ABORT_REQUESTED:
            return (0, $cckdX.AlgoStatusStringHumanReadable).ALGOSTATUS_ABORT_REQUESTED;
        default:
            return algoStatus;
    }
};
const $c1b91f6bcafd183b$var$getHummanReadableOrderStatus = (order)=>{
    let value = Number(order?.status);
    if (Number.isNaN(value)) value = order?.status ?? '';
    switch(value){
        case (0, $cckdX.OrderState).ORDERSTATE_ACKNOWLEDGED:
            return 'ACKNOWLEDGE';
        case (0, $cckdX.OrderState).ORDERSTATE_FILLED:
            return 'FILLED';
        case (0, $cckdX.OrderState).ORDERSTATE_PARTIAL_FILLED:
            return 'PARTIAL';
        case (0, $cckdX.OrderState).ORDERSTATE_PENDING_NEW:
            return 'PENDING NEW';
        case (0, $cckdX.OrderState).ORDERSTATE_NEW:
            return 'OPEN';
        case (0, $cckdX.OrderState).ORDERSTATE_CANCELED:
            return 'CANCELED';
        case (0, $cckdX.OrderState).ORDERSTATE_PENDING_CANCEL:
            return 'PENDING CANCEL';
        case (0, $cckdX.OrderState).ORDERSTATE_REJECTED:
            return 'REJECTED';
        case (0, $cckdX.OrderState).ORDERSTATE_PENDING_REPLACE:
            return 'PENDING REPLACE';
        case (0, $cckdX.OrderState).ORDERSTATE_EXPIRED:
            return 'EXPIRED';
        case (0, $cckdX.OrderState).ORDERSTATE_DONE_FOR_DAY:
            return 'DONE FOR THE DAY';
        case (0, $cckdX.OrderState).ORDERSTATE_STOPPED:
            return 'STOPPED';
        case (0, $cckdX.OrderState).ORDERSTATE_SUSPENDED:
            return 'SUSPENDED';
        case (0, $cckdX.OrderState).ORDERSTATE_CALCULATED:
            return 'CALCULCATED';
        case (0, $cckdX.OrderState).ORDERSTATE_ACCEPTED_FOR_BIDDING:
            return 'ACCEPTED';
        default:
            return '';
    }
};


const $44d83aaeea01a713$var$delegatedLocalToastById = new Map();
const $44d83aaeea01a713$var$delegatedLocalToastCleanupTimers = new Map();
/** Accepts notification traffic only from this Browser window or an exact owned iframe on a configured QEP origin. */ const $44d83aaeea01a713$var$isTrustedNotificationEvent = (event)=>{
    if (event.source === globalThis && event.origin === globalThis.location.origin) return true;
    const trustedFrontendOrigins = (0, $evEIS.resolveTrustedFrontendOrigins)((0, $l2Ecb.getFileServer)(), globalThis.location.origin);
    for (const iframe of document.querySelectorAll('iframe')){
        const iframeOrigin = (0, $evEIS.resolveHttpOrigin)(iframe.src, document.baseURI);
        if (iframe.contentWindow === event.source && iframeOrigin === event.origin && trustedFrontendOrigins.has(event.origin)) return true;
    }
    return false;
};
const $44d83aaeea01a713$var$delegatedLocalToastMapTtlMs = 10000;
/**
 * Clears the auto-cleanup timer for a delegated toast id so manual dismiss does not leak timers.
 */ function $44d83aaeea01a713$var$cleanupDelegatedToastTimer(id) {
    const timer = $44d83aaeea01a713$var$delegatedLocalToastCleanupTimers.get(id);
    if (timer !== undefined) clearTimeout(timer);
    $44d83aaeea01a713$var$delegatedLocalToastCleanupTimers.delete(id);
}
/**
 * Handles postMessage from embedded component iframes that delegate WINDOW Noty toasts to the shell
 * so they render above all component surfaces (e.g. algo monitoring). Also handles programmatic dismiss.
 */ function $44d83aaeea01a713$var$handleDelegatedLocalToastMessage(message) {
    if (message.type === (0, $19TnD.notificationMessageTypes).localToast) {
        const { method: method, title: title, id: id } = message.data;
        $44d83aaeea01a713$var$cleanupDelegatedToastTimer(id);
        const qep = (0, $d9gj3.getQepSystem)();
        const notyHandle = qep.notification.local[method](title);
        if (notyHandle && typeof notyHandle.close === 'function') {
            $44d83aaeea01a713$var$delegatedLocalToastById.set(id, notyHandle);
            const timer = setTimeout(()=>{
                $44d83aaeea01a713$var$delegatedLocalToastById.delete(id);
                $44d83aaeea01a713$var$delegatedLocalToastCleanupTimers.delete(id);
            }, $44d83aaeea01a713$var$delegatedLocalToastMapTtlMs);
            $44d83aaeea01a713$var$delegatedLocalToastCleanupTimers.set(id, timer);
        }
        return;
    }
    if (message.type === (0, $19TnD.notificationMessageTypes).localDismiss) {
        const { id: id } = message.data;
        $44d83aaeea01a713$var$cleanupDelegatedToastTimer(id);
        const entry = $44d83aaeea01a713$var$delegatedLocalToastById.get(id);
        $44d83aaeea01a713$var$delegatedLocalToastById.delete(id);
        entry?.close();
    }
}
const $44d83aaeea01a713$var$NotificationCenter = ({ logout: logout = ()=>{}, reportIssue: reportIssue = ()=>{} })=>{
    const dispatch = (0, $3bGoE.useDispatch)();
    const notifications = (0, $3bGoE.useSelector)((state)=>state.notifications.notifications);
    const runningAlgosRef = (0, $lx97N.useRef)({});
    const loaded = (0, $3bGoE.useSelector)((state)=>state.notifications.loaded);
    const user = (0, $3bGoE.useSelector)((state)=>state.notifications.user);
    const flashingNotification = (0, $3bGoE.useSelector)((0, $faa7d48a62ed25bb$export$bee6154092e86884));
    const [anchorElement, setAnchorElement] = (0, $lx97N.useState)(undefined);
    const [viewedNotifications, setViewedNotifications] = (0, $lx97N.useState)([]);
    const [typeFilter, setTypeFilter] = (0, $lx97N.useState)(undefined);
    const [textFilter, setTextFilter] = (0, $lx97N.useState)('');
    const notificationTypes = [
        (0, $cckdX.QEPNotificationType).ORDER,
        (0, $cckdX.QEPNotificationType).ALGO,
        (0, $cckdX.QEPNotificationType).ALERT,
        (0, $cckdX.QEPNotificationType).SYSTEM
    ];
    /** Removes expired notifications from the Browser's in-memory notification state. */ const removeOldNotifications = ()=>{
        const sevenDaysAgo = new Date(new Date().setDate(new Date().getDate() - 7));
        const updatedNotifications = notifications.filter((notification)=>new Date(notification.timestamp).getTime() > sevenDaysAgo.getTime());
        dispatch((0, $faa7d48a62ed25bb$export$c53275bee200c32a)(updatedNotifications));
    };
    // Load auth info and notifications on mount
    (0, $lx97N.useEffect)(()=>{
        dispatch((0, $faa7d48a62ed25bb$export$a5712b47707ed1a0)());
    }, [
        dispatch
    ]);
    // Wait for authentication to load before subscribing to order updates.
    (0, $lx97N.useEffect)(()=>{
        if (!loaded) return;
        if (!(0, $d9gj3.getQepSystem)()?.apiServices?.orderSummary?.subscribeToOrderSummary) return ()=>{
        // no-op
        };
        const unsubscribe = (0, $d9gj3.getQepSystem)().apiServices.orderSummary.subscribeToOrderSummary((error, orders)=>{
            if (error) {
                console.error('Error subscribing to order summary', error);
                return;
            }
            if (orders?.topic === 'UPDATE' && !Array.isArray(orders.payload)) {
                const { payload: payload } = orders;
                const orderPayload = payload;
                if (orderPayload.orderId && Number(orderPayload.msgType) === 9) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    dispatch((0, $faa7d48a62ed25bb$export$6ff06b226c32675c)({
                        id: orderPayload.orderId,
                        type: (0, $cckdX.QEPNotificationType).ORDER,
                        title: `${(0, $c1b91f6bcafd183b$export$dda23b8ded24fde0)(orderPayload)}ACTION REJECTED`,
                        shortDescription: `${orderPayload.orderId} action rejected`,
                        payload: orderPayload,
                        status: (0, $cckdX.QEPNotificationStatus).CRITICAL,
                        timestamp: new Date().toISOString()
                    }));
                    return;
                }
                let notificationInfo;
                if (typeof payload.algoRunId === 'string' && typeof payload.algoStatus === 'string') {
                    if (runningAlgosRef?.current[payload.algoRunId] && runningAlgosRef?.current[payload.algoRunId].trim() === payload.algoStatus.trim()) return;
                    runningAlgosRef.current[payload.algoRunId] = payload.algoStatus.trim();
                    notificationInfo = (0, $c1b91f6bcafd183b$export$426aa10fb7004d30)(payload, user);
                } else notificationInfo = (0, $c1b91f6bcafd183b$export$9d7e1e59b633c631)(orderPayload, user);
                if (!notificationInfo) return;
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                dispatch((0, $faa7d48a62ed25bb$export$6ff06b226c32675c)(notificationInfo));
            }
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        dispatch,
        loaded,
        user
    ]);
    (0, $lx97N.useEffect)(()=>{
        const stopTimer = (0, $alcuF.callAtTime)(()=>{
            removeOldNotifications();
        }, new Date(new Date().setHours(17, 35, 0, 0)));
        return ()=>{
            stopTimer();
        };
    }, [
        notifications
    ]);
    /** Opens the menu and marks every visible notification as read in local state. */ const handleOpen = (event)=>{
        setAnchorElement(event.currentTarget);
        dispatch((0, $faa7d48a62ed25bb$export$5cbab8109acd4bbb)(undefined)); // Stop flashing when the menu is opened
        setViewedNotifications(notifications.map((n)=>String(n.id)));
        const notisToMarkRead = notifications.filter((n)=>!n.isRead);
        if (notisToMarkRead.length > 0) dispatch((0, $faa7d48a62ed25bb$export$45de1630b4d84a29)());
    };
    (0, $lx97N.useEffect)(()=>{
        window.addEventListener('message', handleNotification);
        return ()=>{
            window.removeEventListener('message', handleNotification);
        };
    }, [
        notifications
    ]);
    function handleNotification(event) {
        if (!$44d83aaeea01a713$var$isTrustedNotificationEvent(event)) return;
        const parseResult = (0, $9e69feacc2576cdd$export$779d4719498a216c)((0, $19TnD.notificationPostMessageSchema), event.data);
        if (!parseResult.success) return;
        const message = parseResult.output;
        if (message.type === (0, $19TnD.notificationMessageTypes).localToast || message.type === (0, $19TnD.notificationMessageTypes).localDismiss) {
            $44d83aaeea01a713$var$handleDelegatedLocalToastMessage(message);
            return;
        }
        if (message.type === (0, $19TnD.notificationMessageTypes).notification) {
            // Preserve nullable legacy status values accepted by the shared wire schema at the local ingestion boundary.
            const notification = {
                ...message.data,
                status: message.data.status
            };
            dispatch((0, $faa7d48a62ed25bb$export$6ff06b226c32675c)(notification));
        }
    }
    const handleClose = ()=>{
        setAnchorElement(undefined);
    };
    const getSortedNotifications = (0, $lx97N.useCallback)(()=>{
        // Sort notifications by status priority, then by timestamp (descending)
        const priority = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            CRITICAL: 1,
            SYSTEM: 2,
            HIGH: 3,
            MEDIUM: 4,
            LOW: 5
        };
        return [
            ...notifications
        ].sort((a, b)=>{
            const statusDiff = priority[a.status] - priority[b.status];
            if (statusDiff !== 0) return statusDiff;
            // Newest first
            return (Number(b.timestamp) || 0) - (Number(a.timestamp) || 0);
        });
    }, [
        notifications
    ]);
    const sortedNotifications = getSortedNotifications();
    const filteredNotifications = sortedNotifications.filter((n)=>{
        const matchesType = typeFilter ? n.type === typeFilter : true;
        const matchesText = textFilter.trim() === '' || n.title?.toLowerCase().includes(textFilter.toLowerCase()) || n.shortDescription?.toLowerCase().includes(textFilter.toLowerCase());
        return matchesType && matchesText;
    });
    /** Removes one notification from the Browser's local notification state. */ const handleRemoveNotification = (id)=>{
        dispatch((0, $faa7d48a62ed25bb$export$92eb0ea44f8c9242)(id));
    };
    /** Clears all notifications and their flashing indicator from local state. */ const handleRemoveAll = ()=>{
        dispatch((0, $faa7d48a62ed25bb$export$b65f4a3c4931e367)());
        dispatch((0, $faa7d48a62ed25bb$export$5cbab8109acd4bbb)(undefined));
    };
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        className: "browser-notification-container",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "browser-notification-icon-button-container",
                children: [
                    flashingNotification && /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: `${(0, $9df27c120aaccfc4$export$df5c6cccb198f23)(flashingNotification.status)} browser-notification-flashing`,
                        children: flashingNotification.title
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $aad80e9a9c3e4c99$export$2e2bcd8739ae039), {
                        color: "inherit",
                        onClick: handleOpen,
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8be87b9583ac791b$export$2e2bcd8739ae039), {
                            badgeContent: notifications.filter((n)=>!n.isRead).length,
                            color: "error",
                            children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($80cd42b97061b43a$exports))), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $3c81bfb010f12d1e$export$2e2bcd8739ae039), {
                anchorEl: anchorElement,
                open: Boolean(anchorElement),
                onClose: handleClose,
                classes: {
                    paper: 'browser-notification-menu'
                },
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 8,
                            padding: '8px 16px',
                            borderBottom: '1px solid #eee',
                            alignItems: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                variant: typeFilter === undefined ? 'contained' : 'outlined',
                                size: "small",
                                onClick: ()=>{
                                    setTypeFilter(undefined);
                                },
                                children: "All"
                            }),
                            notificationTypes.map((type)=>/*#__PURE__*/ (0, $fRwNr.jsx)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                    variant: typeFilter === type ? 'contained' : 'outlined',
                                    size: "small",
                                    onClick: ()=>{
                                        setTypeFilter(type);
                                    },
                                    children: type
                                }, type)),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("input", {
                                type: "text",
                                placeholder: "Filter notifications...",
                                value: textFilter,
                                onChange: (event)=>{
                                    setTextFilter(event.target.value);
                                },
                                style: {
                                    flex: 1,
                                    minWidth: 120,
                                    maxWidth: 220,
                                    marginLeft: 8,
                                    padding: '4px 8px',
                                    borderRadius: 4,
                                    border: '1px solid #ccc',
                                    fontSize: 14
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        style: {
                            maxHeight: 400,
                            overflowY: 'auto'
                        },
                        children: filteredNotifications.length === 0 ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
                            disabled: true,
                            children: "No active notifications"
                        }) : filteredNotifications.map((notification)=>/*#__PURE__*/ (0, $fRwNr.jsx)((0, $9df27c120aaccfc4$export$2e2bcd8739ae039), {
                                notification: notification,
                                viewedNotifications: viewedNotifications,
                                flashingNotification: flashingNotification,
                                onRemove: handleRemoveNotification,
                                onReportIssue: reportIssue,
                                onLogout: logout,
                                setFlashingNotification: (0, $faa7d48a62ed25bb$export$5cbab8109acd4bbb),
                                setViewedNotifications: setViewedNotifications
                            }, notification.id))
                    }),
                    filteredNotifications.length > 0 && /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
                        disabled: notifications.length === 0,
                        onClick: ()=>{
                            setViewedNotifications([]);
                            dispatch((0, $faa7d48a62ed25bb$export$5cbab8109acd4bbb)(undefined));
                            handleRemoveAll();
                            setAnchorElement(undefined);
                        },
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                            children: "Clear All"
                        })
                    }, "clear-all")
                ]
            })
        ]
    });
};
const $44d83aaeea01a713$var$NotificationCenterWithProvider = (props)=>/*#__PURE__*/ (0, $fRwNr.jsx)((0, $3bGoE.Provider), {
        store: (0, $2ef2f2312c04b122$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $fRwNr.jsx)($44d83aaeea01a713$var$NotificationCenter, {
            ...props
        })
    });
var $44d83aaeea01a713$export$2e2bcd8739ae039 = $44d83aaeea01a713$var$NotificationCenterWithProvider;




var $fRwNr = parcelRequire("fRwNr");

var $3bGoE = parcelRequire("3bGoE");

var $lx97N = parcelRequire("lx97N");

var $bqPQ9 = parcelRequire("bqPQ9");

var $d9gj3 = parcelRequire("d9gj3");


var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");






var $bqPQ9 = parcelRequire("bqPQ9");

var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");

var $fRwNr = parcelRequire("fRwNr");
const $44ed8c9df76b33d2$var$_excluded = [
    "as",
    "disabled"
];
function $44ed8c9df76b33d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $44ed8c9df76b33d2$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $44ed8c9df76b33d2$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $44ed8c9df76b33d2$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $44ed8c9df76b33d2$var$Button = /*#__PURE__*/ $lx97N.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $44ed8c9df76b33d2$var$_objectWithoutPropertiesLoose(_ref, $44ed8c9df76b33d2$var$_excluded);
    const [buttonProps, { tagName: Component }] = $44ed8c9df76b33d2$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $fRwNr.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$44ed8c9df76b33d2$var$Button.displayName = 'Button';
var $44ed8c9df76b33d2$export$2e2bcd8739ae039 = $44ed8c9df76b33d2$var$Button;



var $lx97N = parcelRequire("lx97N");

var $fRwNr = parcelRequire("fRwNr");
"use client";
const $f584805e599bccff$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $f584805e599bccff$export$ff817e17bad2e091 = 'xs';
const $f584805e599bccff$var$ThemeContext = /*#__PURE__*/ $lx97N.createContext({
    prefixes: {},
    breakpoints: $f584805e599bccff$export$666ad80b5007f835,
    minBreakpoint: $f584805e599bccff$export$ff817e17bad2e091
});
const { Consumer: $f584805e599bccff$export$b631efc24e9d5e2f, Provider: $f584805e599bccff$var$Provider } = $f584805e599bccff$var$ThemeContext;
function $f584805e599bccff$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $f584805e599bccff$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $f584805e599bccff$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $lx97N.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($f584805e599bccff$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $f584805e599bccff$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $lx97N.useContext)($f584805e599bccff$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $f584805e599bccff$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $lx97N.useContext)($f584805e599bccff$var$ThemeContext);
    return breakpoints;
}
function $f584805e599bccff$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $lx97N.useContext)($f584805e599bccff$var$ThemeContext);
    return minBreakpoint;
}
function $f584805e599bccff$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $lx97N.useContext)($f584805e599bccff$var$ThemeContext);
    return dir === 'rtl';
}
function $f584805e599bccff$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $lx97N.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $f584805e599bccff$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $fRwNr.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $f584805e599bccff$export$2e2bcd8739ae039 = $f584805e599bccff$var$ThemeProvider;



var $fRwNr = parcelRequire("fRwNr");
"use client";
const $27f93f777abc2e58$var$Button = /*#__PURE__*/ $lx97N.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $f584805e599bccff$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $44ed8c9df76b33d2$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $fRwNr.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$27f93f777abc2e58$var$Button.displayName = 'Button';
var $27f93f777abc2e58$export$2e2bcd8739ae039 = $27f93f777abc2e58$var$Button;



var $3bGoE = parcelRequire("3bGoE");


const $de5fad2e6cd1bd0b$var$actionRelativeBase = 'https://qep-system-notification.invalid';
/** Returns supported external or same-origin action URLs and rejects executable or ambiguous schemes. */ function $de5fad2e6cd1bd0b$var$getSafeActionHref(rawHref) {
    const href = rawHref.trim();
    try {
        const url = new URL(href, $de5fad2e6cd1bd0b$var$actionRelativeBase);
        if (href.startsWith('/') || href.startsWith('\\')) return url.origin === $de5fad2e6cd1bd0b$var$actionRelativeBase ? href : undefined;
        return url.protocol === 'http:' || url.protocol === 'https:' ? href : undefined;
    } catch  {
        return undefined;
    }
}
const $de5fad2e6cd1bd0b$var$style = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 425,
    height: 300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    outline: 'none',
    p: 0
};
const $de5fad2e6cd1bd0b$var$titleStyles = {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: 2,
    fontSize: 22
};
const $de5fad2e6cd1bd0b$var$messageStyles = {
    width: '100%',
    flexGrow: 1,
    overflow: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    px: 2,
    fontSize: 18,
    height: '100%'
};
const $de5fad2e6cd1bd0b$var$actionStyles = {
    width: '100%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    p: 2
};
const $de5fad2e6cd1bd0b$var$closeStyles = {
    position: 'absolute',
    height: 31,
    width: 31,
    right: 0
};
function $de5fad2e6cd1bd0b$export$447506709eea98bf({ open: open, handleClose: handleClose, notificationId: notificationId }) {
    /** Closes a critical notification and reports its identifier so the caller can acknowledge it. */ const acknowledge = (0, $lx97N.useCallback)(()=>{
        handleClose(notificationId);
    }, [
        handleClose,
        notificationId
    ]);
    /** Closes a non-critical notification without acknowledging it. */ const dismiss = ()=>{
        handleClose();
    };
    const notifications = (0, $3bGoE.useSelector)((0, $205bb7b61a2ef47c$export$51357cc0c92823d1));
    const notification = notifications.find((n)=>n.id === notificationId);
    if (!notification) return null;
    const acknowledgeRequired = notification.level === 'critical';
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $c25de88565c859da$export$2e2bcd8739ae039), {
        open: open,
        onClose: acknowledgeRequired ? undefined : dismiss,
        disableEscapeKeyDown: true,
        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d47fb49f85ffe081$export$2e2bcd8739ae039), {
            sx: $de5fad2e6cd1bd0b$var$style,
            children: /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $2f943f6b64633db4$export$2e2bcd8739ae039), {
                direction: "row",
                sx: {
                    height: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $2f943f6b64633db4$export$2e2bcd8739ae039), {
                        direction: "column",
                        sx: {
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d47fb49f85ffe081$export$2e2bcd8739ae039), {
                                sx: {
                                    ...$de5fad2e6cd1bd0b$var$titleStyles,
                                    color: acknowledgeRequired ? '#f00' : '#f80'
                                },
                                children: notification.title
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d47fb49f85ffe081$export$2e2bcd8739ae039), {
                                sx: $de5fad2e6cd1bd0b$var$messageStyles,
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                    children: String(notification.message)
                                })
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $2f943f6b64633db4$export$2e2bcd8739ae039), {
                                sx: $de5fad2e6cd1bd0b$var$actionStyles,
                                direction: "row",
                                children: [
                                    notification.actions?.map((action)=>{
                                        const actionLabel = String(action.label ?? '');
                                        const actionHref = $de5fad2e6cd1bd0b$var$getSafeActionHref(String(action.href ?? ''));
                                        if (!actionHref) return null;
                                        return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $27f93f777abc2e58$export$2e2bcd8739ae039), {
                                            size: "lg",
                                            variant: "secondary",
                                            className: "browser-system-notification-secondary-button",
                                            href: actionHref,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: actionLabel
                                        }, actionLabel);
                                    }),
                                    acknowledgeRequired ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $27f93f777abc2e58$export$2e2bcd8739ae039), {
                                        className: "browser-system-notification-close-button",
                                        size: "lg",
                                        onClick: acknowledge,
                                        children: "Acknowledge"
                                    }) : /*#__PURE__*/ (0, $fRwNr.jsx)((0, $27f93f777abc2e58$export$2e2bcd8739ae039), {
                                        className: "browser-system-notification-close-button",
                                        size: "lg",
                                        onClick: dismiss,
                                        children: "Close"
                                    })
                                ]
                            })
                        ]
                    }),
                    acknowledgeRequired ? null : /*#__PURE__*/ (0, $fRwNr.jsx)((0, $aad80e9a9c3e4c99$export$2e2bcd8739ae039), {
                        sx: $de5fad2e6cd1bd0b$var$closeStyles,
                        onClick: dismiss,
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($702c5c85d45cae88$exports))), {})
                    })
                ]
            })
        })
    });
}



function $96350a2f54eec2ce$export$dcdc273622d7aadd() {
    const [open, setOpen] = (0, $lx97N.useState)(false);
    const [activeNotification, setActiveNotification] = (0, $lx97N.useState)(undefined);
    const dispatch = (0, $3bGoE.useDispatch)();
    const notifications = (0, $3bGoE.useSelector)((0, $205bb7b61a2ef47c$export$51357cc0c92823d1));
    (0, $lx97N.useEffect)(()=>{
        /** Dispatches each validated subscription action into the browser application store. */ const handleSystemNotification = (action)=>{
            dispatch(action);
        };
        const unsubscribe = (0, $d9gj3.getQepSystem)().apiServices.notifications.subscribeToSystemNotifications(handleSystemNotification);
        /** Releases the live callback when React disposes the effect, preventing stale subscribers. */ const cleanupSubscription = ()=>{
            unsubscribe();
        };
        return cleanupSubscription;
    }, [
        dispatch
    ]);
    (0, $lx97N.useEffect)(()=>{
        const critical = notifications.find((n)=>n.level === 'critical' && !n.acknowledged);
        if (!open && !activeNotification && critical) {
            setOpen(true);
            setActiveNotification(String(critical.id));
        }
    }, [
        notifications,
        open,
        activeNotification
    ]);
    if (notifications.length === 0) return null;
    return /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                className: "browser-system-notification-list",
                children: notifications.map((notification)=>{
                    const notificationId = String(notification.id);
                    return /*#__PURE__*/ (0, $fRwNr.jsx)("a", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))('browser-system-notification-item', {
                            'browser-system-notification-critical': notification.level === 'critical'
                        }),
                        onClick: ()=>{
                            setOpen(true);
                            setActiveNotification(notificationId);
                        },
                        children: notification.title
                    }, notificationId);
                })
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $de5fad2e6cd1bd0b$export$447506709eea98bf), {
                open: open,
                notificationId: activeNotification,
                handleClose: (notificationId)=>{
                    setOpen(false);
                    if (notificationId) dispatch((0, $205bb7b61a2ef47c$export$dca58f17277bcc93).actions.acknowledgeSystemNotification(notificationId));
                }
            })
        ]
    });
}



var $fRwNr = parcelRequire("fRwNr");


var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");

var $fMSjE = parcelRequire("fMSjE");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");


var $fRwNr = parcelRequire("fRwNr");
const $6634167556f24bbd$var$_excluded = [
    "absolute",
    "children",
    "className",
    "component",
    "flexItem",
    "light",
    "orientation",
    "role",
    "textAlign",
    "variant"
];
const $6634167556f24bbd$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $d3d04fec3a46301f$export$46f01d01378ec5a2), classes);
};
const $6634167556f24bbd$var$DividerRoot = (0, $7Ys8f.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin'
    }, ownerState.absolute && {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%'
    }, ownerState.light && {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.dividerChannel} / 0.08)` : (0, $fMSjE.alpha)(theme.palette.divider, 0.08)
    }, ownerState.variant === 'inset' && {
        marginLeft: 72
    }, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2)
    }, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    }, ownerState.orientation === 'vertical' && {
        height: '100%',
        borderBottomWidth: 0,
        borderRightWidth: 'thin'
    }, ownerState.flexItem && {
        alignSelf: 'stretch',
        height: 'auto'
    }), ({ ownerState: ownerState })=>(0, $eR4tV.default)({}, ownerState.children && {
        display: 'flex',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        border: 0,
        '&::before, &::after': {
            content: '""',
            alignSelf: 'center'
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({}, ownerState.children && ownerState.orientation !== 'vertical' && {
        '&::before, &::after': {
            width: '100%',
            borderTop: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({}, ownerState.children && ownerState.orientation === 'vertical' && {
        flexDirection: 'column',
        '&::before, &::after': {
            height: '100%',
            borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`
        }
    }), ({ ownerState: ownerState })=>(0, $eR4tV.default)({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '90%'
        },
        '&::after': {
            width: '10%'
        }
    }, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
        '&::before': {
            width: '10%'
        },
        '&::after': {
            width: '90%'
        }
    }));
const $6634167556f24bbd$var$DividerWrapper = (0, $7Ys8f.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`
    }, ownerState.orientation === 'vertical' && {
        paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
        paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
    }));
const $6634167556f24bbd$var$Divider = /*#__PURE__*/ $lx97N.forwardRef(function Divider(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, component: component = children ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, orientation: orientation = 'horizontal', role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth' } = props, other = (0, $hphT8.default)(props, $6634167556f24bbd$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    });
    const classes = $6634167556f24bbd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($6634167556f24bbd$var$DividerRoot, (0, $eR4tV.default)({
        as: component,
        className: (0, $fmTP4.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: children ? /*#__PURE__*/ (0, $fRwNr.jsx)($6634167556f24bbd$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    }));
});
var $6634167556f24bbd$export$2e2bcd8739ae039 = $6634167556f24bbd$var$Divider;




var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $lx97N = parcelRequire("lx97N");


var $fmTP4 = parcelRequire("fmTP4");

var $8o5tH = parcelRequire("8o5tH");

var $7Ys8f = parcelRequire("7Ys8f");

var $zetlx = parcelRequire("zetlx");

var $4BrfH = parcelRequire("4BrfH");

var $3OBXm = parcelRequire("3OBXm");

var $h6nFM = parcelRequire("h6nFM");
function $3be2ea2801e44d3c$export$6816d4fc0981ec7(slot) {
    return (0, $h6nFM.default)('MuiListSubheader', slot);
}
const $3be2ea2801e44d3c$var$listSubheaderClasses = (0, $3OBXm.default)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $3be2ea2801e44d3c$export$2e2bcd8739ae039 = $3be2ea2801e44d3c$var$listSubheaderClasses;



var $fRwNr = parcelRequire("fRwNr");
const $8ca241c96869ff26$var$_excluded = [
    "className",
    "color",
    "component",
    "disableGutters",
    "disableSticky",
    "inset"
];
const $8ca241c96869ff26$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $4BrfH.default)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $8o5tH.default)(slots, (0, $3be2ea2801e44d3c$export$6816d4fc0981ec7), classes);
};
const $8ca241c96869ff26$var$ListSubheaderRoot = (0, $7Ys8f.default)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $4BrfH.default)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $eR4tV.default)({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14)
    }, ownerState.color === 'primary' && {
        color: (theme.vars || theme).palette.primary.main
    }, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.inset && {
        paddingLeft: 72
    }, !ownerState.disableSticky && {
        position: 'sticky',
        top: 0,
        zIndex: 1,
        backgroundColor: (theme.vars || theme).palette.background.paper
    }));
const $8ca241c96869ff26$var$ListSubheader = /*#__PURE__*/ $lx97N.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $zetlx.default)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false } = props, other = (0, $hphT8.default)(props, $8ca241c96869ff26$var$_excluded);
    const ownerState = (0, $eR4tV.default)({}, props, {
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    });
    const classes = $8ca241c96869ff26$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $fRwNr.jsx)($8ca241c96869ff26$var$ListSubheaderRoot, (0, $eR4tV.default)({
        as: component,
        className: (0, $fmTP4.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other));
});
$8ca241c96869ff26$var$ListSubheader.muiSkipListHighlight = true;
var $8ca241c96869ff26$export$2e2bcd8739ae039 = $8ca241c96869ff26$var$ListSubheader;





var $a27aa5731dfa2868$exports = {};
"use strict";

Object.defineProperty($a27aa5731dfa2868$exports, "__esModule", {
    value: true
});
$a27aa5731dfa2868$exports.default = void 0;

var $a27aa5731dfa2868$var$_createSvgIcon = $61a0415ce92f46da$exports((parcelRequire("dFcVn")));

var $fRwNr = parcelRequire("fRwNr");
var $a27aa5731dfa2868$var$_default = (0, $a27aa5731dfa2868$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $fRwNr.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
$a27aa5731dfa2868$exports.default = $a27aa5731dfa2868$var$_default;




var $lx97N = parcelRequire("lx97N");

var $bqPQ9 = parcelRequire("bqPQ9");
const $2f53e3b93bc665a6$export$1ec99054f1a43d1d = [
    {
        id: 'ny-new-york',
        label: 'New York (NYSE/Nasdaq)',
        location: 'New York',
        timeZone: 'America/New_York'
    },
    {
        id: 'chicago-cme',
        label: 'Chicago (CME)',
        location: 'Chicago',
        timeZone: 'America/Chicago'
    },
    {
        id: 'minneapolis',
        label: 'Minneapolis',
        location: 'Minneapolis',
        timeZone: 'America/Chicago'
    },
    {
        id: 'toronto-tsx',
        label: 'Toronto (TSX)',
        location: 'Toronto',
        timeZone: 'America/Toronto'
    },
    {
        id: 'london-lse',
        label: 'London (LSE)',
        location: 'London',
        timeZone: 'Europe/London'
    },
    {
        id: 'frankfurt-xetra',
        label: 'Frankfurt (Xetra)',
        location: 'Frankfurt',
        timeZone: 'Europe/Berlin'
    },
    {
        id: 'paris-euronext',
        label: 'Paris (Euronext)',
        location: 'Paris',
        timeZone: 'Europe/Paris'
    },
    {
        id: 'zurich-six',
        label: 'Zurich (SIX)',
        location: 'Zurich',
        timeZone: 'Europe/Zurich'
    },
    {
        id: 'geneva',
        label: 'Geneva',
        location: 'Geneva',
        timeZone: 'Europe/Zurich'
    },
    {
        id: 'milan-borsa',
        label: 'Milan (Borsa Italiana)',
        location: 'Milan',
        timeZone: 'Europe/Rome'
    },
    {
        id: 'sao-paolo-b3',
        label: "S\xe3o Paulo (B3)",
        location: "S\xe3o Paulo",
        timeZone: 'America/Sao_Paulo'
    },
    {
        id: 'mumbai-nse',
        label: 'Mumbai (NSE/BSE)',
        location: 'Mumbai',
        timeZone: 'Asia/Kolkata'
    },
    {
        id: 'singapore-sgx',
        label: 'Singapore (SGX)',
        location: 'Singapore',
        timeZone: 'Asia/Singapore'
    },
    {
        id: 'hong-kong-hkex',
        label: 'Hong Kong (HKEX)',
        location: 'Hong Kong',
        timeZone: 'Asia/Hong_Kong'
    },
    {
        id: 'shanghai-sse',
        label: 'Shanghai (SSE)',
        location: 'Shanghai',
        timeZone: 'Asia/Shanghai'
    },
    {
        id: 'tokyo-tse',
        label: 'Tokyo (TSE)',
        location: 'Tokyo',
        timeZone: 'Asia/Tokyo'
    },
    {
        id: 'sydney-asx',
        label: 'Sydney (ASX)',
        location: 'Sydney',
        timeZone: 'Australia/Sydney'
    },
    {
        id: 'melbourne-asx',
        label: 'Melbourne (ASX)',
        location: 'Melbourne',
        timeZone: 'Australia/Melbourne'
    }
];



var $lx97N = parcelRequire("lx97N");
function $e88a56de87a10809$export$3a404aece3dff2fa(tickMs = 1000) {
    const [now, setNow] = (0, $lx97N.useState)(()=>new Date());
    (0, $lx97N.useEffect)(()=>{
        let intervalId;
        let timeoutId;
        const schedule = ()=>{
            const current = Date.now();
            const untilNextTick = tickMs - current % tickMs;
            timeoutId = setTimeout(()=>{
                setNow(new Date());
                intervalId = setInterval(()=>{
                    setNow(new Date());
                }, tickMs);
            }, untilNextTick);
        };
        schedule();
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
            if (intervalId) clearInterval(intervalId);
        };
    }, [
        tickMs
    ]);
    return now;
}



// Map of class names from `timezone-clocks.scss` which provides shorter names to type (especially for those referenced multiple times) and
// also allows for easier refactoring of class names in the future since we can update them all in one place.
const $7405a7edf99c0e17$var$tzc = {
    root: 'timezone-clocks',
    menuControlWrap: 'timezone-clocks__menu-control-wrap',
    addButton: 'timezone-clocks__add-button',
    hourFormatToggle: 'timezone-clocks__hour-format-toggle',
    hourFormatOption: 'timezone-clocks__hour-format-option',
    hourFormatOptionPressed: 'timezone-clocks__hour-format-option--pressed',
    menuHourFormatWrap: 'timezone-clocks__menu-hour-format-wrap',
    clocksShell: 'timezone-clocks__clocks-shell',
    clocksShellScrollable: 'timezone-clocks__clocks-shell--scrollable',
    clocksScroller: 'timezone-clocks__clocks-scroller',
    clocksScrollContent: 'timezone-clocks__clocks-scroll-content',
    clocksRow: 'timezone-clocks__clocks-row',
    clocksScrollbarWrap: 'timezone-clocks__clocks-scrollbar-wrap',
    clocksScrollbar: 'timezone-clocks__clocks-scrollbar',
    clock: 'timezone-clocks__clock',
    clockDragging: 'timezone-clocks__clock--dragging',
    time: 'timezone-clocks__time',
    location: 'timezone-clocks__location',
    remove: 'timezone-clocks__remove',
    menuItem: 'timezone-clocks__menu-item',
    menuCheckbox: 'timezone-clocks__menu-checkbox',
    menuDivider: 'timezone-clocks__menu-divider'
};
const $7405a7edf99c0e17$var$storageKey = 'toolbar.timezoneClocks.selected';
const $7405a7edf99c0e17$var$hour12StorageKey = 'toolbar.timezoneClocks.hour12';
const $7405a7edf99c0e17$var$defaultSelectedIds = [
    'minneapolis'
];
const $7405a7edf99c0e17$var$clockWidthPx = 118;
const $7405a7edf99c0e17$var$clockGapPx = 8;
const $7405a7edf99c0e17$var$clockScrollStepPx = $7405a7edf99c0e17$var$clockWidthPx + $7405a7edf99c0e17$var$clockGapPx;
function $7405a7edf99c0e17$var$isBrowserEnvironment() {
    return globalThis.window !== undefined;
}
function $7405a7edf99c0e17$var$safeParseBoolean(value) {
    if (value === undefined) return undefined;
    if (value === 'true') return true;
    if (value === 'false') return false;
    return undefined;
}
function $7405a7edf99c0e17$var$exchangeFromLabel(label) {
    const match = /\(([^)]+)\)\s*$/.exec(label);
    return match?.[1];
}
function $7405a7edf99c0e17$var$safeParseSelected(value) {
    if (!value) return [];
    try {
        const parsed = JSON.parse(value);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((x)=>typeof x === 'string');
    } catch  {
        return [];
    }
}
function $7405a7edf99c0e17$var$sanitizeSelectedIds(value) {
    const validIds = new Set((0, $2f53e3b93bc665a6$export$1ec99054f1a43d1d).map((tz)=>tz.id));
    return value.filter((id, index)=>validIds.has(id) && value.indexOf(id) === index);
}
function $7405a7edf99c0e17$var$formatTime(now, timeZone, options) {
    return new Intl.DateTimeFormat('en-GB', {
        timeZone: timeZone,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: options?.hour12 ?? false
    }).format(now);
}
function $7405a7edf99c0e17$var$moveItem(items, fromIndex, toIndex) {
    if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return items;
    const next = [
        ...items
    ];
    const [moved] = next.splice(fromIndex, 1);
    next.splice(toIndex, 0, moved);
    return next;
}
function $7405a7edf99c0e17$export$3db7fbc5607e8424() {
    const now = (0, $e88a56de87a10809$export$3a404aece3dff2fa)(1000);
    const rootRef = (0, $lx97N.useRef)(null);
    const clocksScrollerRef = (0, $lx97N.useRef)(null);
    const clocksRowRef = (0, $lx97N.useRef)(null);
    const lastDragPointRef = (0, $lx97N.useRef)(undefined);
    const draggingIdRef = (0, $lx97N.useRef)(undefined);
    const previewInsertIndexRef = (0, $lx97N.useRef)(undefined);
    const dragMetricsRef = (0, $lx97N.useRef)(undefined);
    const didDropRef = (0, $lx97N.useRef)(false);
    const selectedIdsRef = (0, $lx97N.useRef)([]);
    const [anchorElement, setAnchorElement] = (0, $lx97N.useState)(undefined);
    const [menuAnchorPosition, setMenuAnchorPosition] = (0, $lx97N.useState)(undefined);
    const menuOpen = Boolean(anchorElement);
    const [draggingId, setDraggingId] = (0, $lx97N.useState)(undefined);
    const [previewInsertIndex, setPreviewInsertIndex] = (0, $lx97N.useState)(undefined);
    const [scrollMetrics, setScrollMetrics] = (0, $lx97N.useState)({
        maxScrollLeft: 0,
        scrollLeft: 0
    });
    const [use12Hour, setUse12Hour] = (0, $lx97N.useState)(()=>{
        if (!$7405a7edf99c0e17$var$isBrowserEnvironment()) return false;
        return $7405a7edf99c0e17$var$safeParseBoolean(globalThis.localStorage.getItem($7405a7edf99c0e17$var$hour12StorageKey) ?? undefined) ?? false;
    });
    const [selectedIds, setSelectedIds] = (0, $lx97N.useState)(()=>{
        if (!$7405a7edf99c0e17$var$isBrowserEnvironment()) return $7405a7edf99c0e17$var$defaultSelectedIds;
        const rawSelected = globalThis.localStorage.getItem($7405a7edf99c0e17$var$storageKey);
        if (rawSelected === null) return $7405a7edf99c0e17$var$defaultSelectedIds;
        return $7405a7edf99c0e17$var$sanitizeSelectedIds($7405a7edf99c0e17$var$safeParseSelected(rawSelected));
    });
    (0, $lx97N.useEffect)(()=>{
        if (!$7405a7edf99c0e17$var$isBrowserEnvironment()) return;
        globalThis.localStorage.setItem($7405a7edf99c0e17$var$storageKey, JSON.stringify(selectedIds));
    }, [
        selectedIds
    ]);
    (0, $lx97N.useEffect)(()=>{
        selectedIdsRef.current = selectedIds;
    }, [
        selectedIds
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (!$7405a7edf99c0e17$var$isBrowserEnvironment()) return;
        globalThis.localStorage.setItem($7405a7edf99c0e17$var$hour12StorageKey, String(use12Hour));
    }, [
        use12Hour
    ]);
    const selectedTimezones = (0, $lx97N.useMemo)(()=>{
        const byId = new Map((0, $2f53e3b93bc665a6$export$1ec99054f1a43d1d).map((tz)=>[
                tz.id,
                tz
            ]));
        return selectedIds.map((id)=>byId.get(id)).filter(Boolean);
    }, [
        selectedIds
    ]);
    const selectedIdSet = (0, $lx97N.useMemo)(()=>new Set(selectedIds), [
        selectedIds
    ]);
    const menuTimezones = (0, $lx97N.useMemo)(()=>[
            ...(0, $2f53e3b93bc665a6$export$1ec99054f1a43d1d)
        ].sort((a, b)=>a.location.localeCompare(b.location)), []);
    const syncScrollMetrics = (0, $lx97N.useCallback)(()=>{
        const scrollElement = clocksScrollerRef.current;
        const rowElement = clocksRowRef.current;
        if (!scrollElement) return;
        const viewportWidth = scrollElement.clientWidth;
        const fromScrollPort = scrollElement.scrollWidth - scrollElement.clientWidth;
        const contentWidth = rowElement ? Math.max(rowElement.scrollWidth, rowElement.offsetWidth) : 0;
        const fromRow = contentWidth - viewportWidth;
        const overflow = Math.max(fromScrollPort, fromRow);
        const maxScrollLeft = Math.max(0, Math.round(overflow));
        const { scrollLeft: currentScrollLeft } = scrollElement;
        if (currentScrollLeft > maxScrollLeft) scrollElement.scrollLeft = maxScrollLeft;
        const { scrollLeft: scrollLeft } = scrollElement;
        setScrollMetrics((previousMetrics)=>{
            const nextMetrics = {
                maxScrollLeft: maxScrollLeft,
                scrollLeft: scrollLeft
            };
            if (previousMetrics.maxScrollLeft === nextMetrics.maxScrollLeft && previousMetrics.scrollLeft === nextMetrics.scrollLeft) return previousMetrics;
            return nextMetrics;
        });
    }, []);
    (0, $lx97N.useLayoutEffect)(()=>{
        syncScrollMetrics();
    }, [
        selectedTimezones.length,
        syncScrollMetrics
    ]);
    (0, $lx97N.useEffect)(()=>{
        const scrollElement = clocksScrollerRef.current;
        const rowElement = clocksRowRef.current;
        if (!scrollElement) return;
        syncScrollMetrics();
        if (typeof ResizeObserver === 'undefined') {
            const onResize = ()=>{
                syncScrollMetrics();
            };
            globalThis.window?.addEventListener('resize', onResize);
            return ()=>{
                globalThis.window?.removeEventListener('resize', onResize);
            };
        }
        const observer = new ResizeObserver(()=>{
            syncScrollMetrics();
        });
        observer.observe(scrollElement);
        if (rowElement) observer.observe(rowElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        selectedTimezones.length,
        syncScrollMetrics
    ]);
    function openMenu(event) {
        const rect = event.currentTarget.getBoundingClientRect();
        setMenuAnchorPosition({
            top: rect.bottom,
            left: rect.left
        });
        setAnchorElement(event.currentTarget);
    }
    function closeMenu() {
        setAnchorElement(undefined);
        setMenuAnchorPosition(undefined);
    }
    function toggleClock(id) {
        setSelectedIds((previous)=>previous.includes(id) ? previous.filter((x)=>x !== id) : [
                ...previous,
                id
            ]);
    }
    const allSelected = (0, $lx97N.useMemo)(()=>(0, $2f53e3b93bc665a6$export$1ec99054f1a43d1d).every((tz)=>selectedIdSet.has(tz.id)), [
        selectedIdSet
    ]);
    const someSelected = selectedIds.length > 0;
    function toggleSelectAll() {
        setSelectedIds(allSelected ? [] : menuTimezones.map((tz)=>tz.id));
    }
    function removeClock(id) {
        setSelectedIds((previous)=>previous.filter((x)=>x !== id));
    }
    function isDraggedOutsideToolbar(event) {
        const root = rootRef.current;
        if (!root) return false;
        const rect = root.getBoundingClientRect();
        const thresholdPx = 12;
        const clientY = event.clientY ?? lastDragPointRef.current?.clientY ?? 0;
        return clientY < rect.top - thresholdPx || clientY > rect.bottom + thresholdPx;
    }
    function reorderClocks(fromId, toId) {
        if (fromId === toId) return;
        const fromIndex = selectedIdsRef.current.indexOf(fromId);
        const toIndex = selectedIdsRef.current.indexOf(toId);
        if (fromIndex === -1 || toIndex === -1) return;
        setSelectedIds((previous)=>$7405a7edf99c0e17$var$moveItem(previous, fromIndex, toIndex));
    }
    function reorderClocksByInsertIndex(fromId, toIndex, sourceIds = selectedIdsRef.current) {
        const fromIndex = sourceIds.indexOf(fromId);
        if (fromIndex === -1) return;
        const next = [
            ...sourceIds
        ];
        const [removed] = next.splice(fromIndex, 1);
        const boundedTarget = Math.max(0, Math.min(toIndex, next.length));
        next.splice(boundedTarget, 0, removed);
        setSelectedIds(next);
    }
    function getInsertIndexFromHover(overId, clientX, target, sourceId) {
        const overIndex = selectedIdsRef.current.indexOf(overId);
        const sourceIndex = selectedIdsRef.current.indexOf(sourceId);
        if (overIndex === -1 || sourceIndex === -1) return undefined;
        const rect = target.getBoundingClientRect();
        if (rect.width <= 0) return undefined;
        const dragMetrics = dragMetricsRef.current;
        let isAfterThreshold;
        if (dragMetrics) {
            const draggedLeft = clientX - dragMetrics.offsetX;
            const draggedRight = draggedLeft + dragMetrics.width;
            const overlapWidth = Math.max(0, Math.min(draggedRight, rect.right) - Math.max(draggedLeft, rect.left));
            const overlapRatio = overlapWidth / rect.width;
            if (overlapRatio < 0.3) return undefined;
            isAfterThreshold = sourceIndex < overIndex;
        } else isAfterThreshold = clientX - rect.left >= rect.width * 0.3;
        let insertIndex = overIndex + (isAfterThreshold ? 1 : 0);
        if (sourceIndex < insertIndex) insertIndex -= 1;
        return Math.max(0, Math.min(insertIndex, selectedIds.length - 1));
    }
    function getClockOffset(index) {
        if (!draggingId || previewInsertIndex === undefined) return 0;
        const sourceIndex = selectedIds.indexOf(draggingId);
        if (sourceIndex === -1 || previewInsertIndex === sourceIndex || index === sourceIndex) return 0;
        if (previewInsertIndex > sourceIndex && index > sourceIndex && index <= previewInsertIndex) return -$7405a7edf99c0e17$var$clockScrollStepPx;
        if (previewInsertIndex < sourceIndex && index >= previewInsertIndex && index < sourceIndex) return $7405a7edf99c0e17$var$clockScrollStepPx;
        return 0;
    }
    function commitReorder(fromId, fallbackToId) {
        const insertIndex = previewInsertIndexRef.current;
        if (insertIndex !== undefined) {
            reorderClocksByInsertIndex(fromId, insertIndex, selectedIdsRef.current);
            return;
        }
        if (fallbackToId && fromId !== fallbackToId) reorderClocks(fromId, fallbackToId);
    }
    const { maxScrollLeft: maxScrollLeft, scrollLeft: scrollLeft } = scrollMetrics;
    const isScrollable = maxScrollLeft >= 2;
    const rangeValue = Math.min(scrollLeft, maxScrollLeft);
    function handleScrollbarChange(event) {
        const scrollElement = clocksScrollerRef.current;
        if (!scrollElement) return;
        scrollElement.scrollLeft = Number(event.currentTarget.value);
        syncScrollMetrics();
    }
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        ref: rootRef,
        className: $7405a7edf99c0e17$var$tzc.root,
        "data-testid": "timezone-clocks",
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))($7405a7edf99c0e17$var$tzc.clocksShell, {
                    [$7405a7edf99c0e17$var$tzc.clocksShellScrollable]: isScrollable
                }),
                "data-testid": "timezone-clocks-shell",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        ref: clocksScrollerRef,
                        className: $7405a7edf99c0e17$var$tzc.clocksScroller,
                        "data-testid": "timezone-clocks-scroller",
                        onDragOver: (event)=>{
                            event.preventDefault();
                            event.dataTransfer.dropEffect = 'move';
                        },
                        onDrop: (event)=>{
                            event.preventDefault();
                            const transferId = event.dataTransfer.getData('text/plain');
                            const fromId = transferId.length > 0 ? transferId : draggingIdRef.current ?? draggingId;
                            if (fromId) {
                                didDropRef.current = true;
                                commitReorder(fromId);
                            }
                            setDraggingId(undefined);
                            draggingIdRef.current = undefined;
                            previewInsertIndexRef.current = undefined;
                            dragMetricsRef.current = undefined;
                            setPreviewInsertIndex(undefined);
                            lastDragPointRef.current = undefined;
                        },
                        onScroll: ()=>{
                            syncScrollMetrics();
                        },
                        onWheel: (event)=>{
                            if (!event.shiftKey) return;
                            event.preventDefault();
                            const element = clocksScrollerRef.current;
                            if (!element) return;
                            const delta = event.deltaY + event.deltaX;
                            element.scrollLeft += delta;
                            requestAnimationFrame(()=>{
                                syncScrollMetrics();
                            });
                        },
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                            className: $7405a7edf99c0e17$var$tzc.clocksScrollContent,
                            children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                ref: clocksRowRef,
                                className: $7405a7edf99c0e17$var$tzc.clocksRow,
                                "data-testid": "timezone-clocks-row",
                                children: selectedTimezones.map((tz, index)=>/*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))($7405a7edf99c0e17$var$tzc.clock, {
                                            [$7405a7edf99c0e17$var$tzc.clockDragging]: draggingId === tz.id
                                        }),
                                        "data-testid": `timezone-clock-${tz.id}`,
                                        draggable: true,
                                        style: {
                                            transform: `translateX(${getClockOffset(index)}px)`
                                        },
                                        onDragStart: (event)=>{
                                            setDraggingId(tz.id);
                                            draggingIdRef.current = tz.id;
                                            didDropRef.current = false;
                                            setPreviewInsertIndex(undefined);
                                            previewInsertIndexRef.current = undefined;
                                            const rect = event.currentTarget.getBoundingClientRect();
                                            const width = rect.width > 0 ? rect.width : $7405a7edf99c0e17$var$clockWidthPx;
                                            const rawOffsetX = event.clientX - rect.left;
                                            const fallbackOffsetX = width / 2;
                                            const offsetX = Number.isFinite(rawOffsetX) ? Math.min(width, Math.max(0, rawOffsetX)) : fallbackOffsetX;
                                            dragMetricsRef.current = {
                                                offsetX: offsetX,
                                                width: width
                                            };
                                            lastDragPointRef.current = {
                                                clientX: event.clientX,
                                                clientY: event.clientY
                                            };
                                            event.dataTransfer.setData('text/plain', tz.id);
                                            event.dataTransfer.effectAllowed = 'move';
                                        },
                                        onDrag: (event)=>{
                                            lastDragPointRef.current = {
                                                clientX: event.clientX,
                                                clientY: event.clientY
                                            };
                                        },
                                        onDragEnd: (event)=>{
                                            if (isDraggedOutsideToolbar(event)) removeClock(tz.id);
                                            else if (!didDropRef.current) {
                                                const fromId = draggingIdRef.current ?? draggingId ?? tz.id;
                                                if (fromId) commitReorder(fromId);
                                            }
                                            didDropRef.current = false;
                                            setDraggingId(undefined);
                                            draggingIdRef.current = undefined;
                                            previewInsertIndexRef.current = undefined;
                                            dragMetricsRef.current = undefined;
                                            setPreviewInsertIndex(undefined);
                                            lastDragPointRef.current = undefined;
                                        },
                                        onDragOver: (event)=>{
                                            event.preventDefault();
                                            event.dataTransfer.dropEffect = 'move';
                                            const fromId = draggingIdRef.current ?? draggingId ?? event.dataTransfer.getData('text/plain');
                                            if (!fromId) return;
                                            // Ignore hover calculations on the dragged clock itself so we keep
                                            // the last valid preview position from neighboring clocks.
                                            if (fromId === tz.id) return;
                                            const insertIndex = getInsertIndexFromHover(tz.id, event.clientX, event.currentTarget, fromId);
                                            if (insertIndex !== undefined) {
                                                previewInsertIndexRef.current = insertIndex;
                                                setPreviewInsertIndex(insertIndex);
                                            }
                                        },
                                        onDrop: (event)=>{
                                            event.preventDefault();
                                            event.stopPropagation();
                                            const transferId = event.dataTransfer.getData('text/plain');
                                            const fromId = transferId.length > 0 ? transferId : draggingIdRef.current ?? draggingId;
                                            if (fromId) {
                                                didDropRef.current = true;
                                                commitReorder(fromId, tz.id);
                                            }
                                            setDraggingId(undefined);
                                            draggingIdRef.current = undefined;
                                            previewInsertIndexRef.current = undefined;
                                            dragMetricsRef.current = undefined;
                                            setPreviewInsertIndex(undefined);
                                            lastDragPointRef.current = undefined;
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $aad80e9a9c3e4c99$export$2e2bcd8739ae039), {
                                                className: $7405a7edf99c0e17$var$tzc.remove,
                                                size: "small",
                                                "aria-label": `Remove ${tz.location} clock`,
                                                onClick: ()=>{
                                                    removeClock(tz.id);
                                                },
                                                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($702c5c85d45cae88$exports))), {
                                                    fontSize: "inherit"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                                className: $7405a7edf99c0e17$var$tzc.time,
                                                "data-testid": `timezone-clock-time-${tz.id}`,
                                                children: $7405a7edf99c0e17$var$formatTime(now, tz.timeZone, {
                                                    hour12: use12Hour
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                                className: $7405a7edf99c0e17$var$tzc.location,
                                                children: [
                                                    tz.location,
                                                    $7405a7edf99c0e17$var$exchangeFromLabel(tz.label) ? ` (${$7405a7edf99c0e17$var$exchangeFromLabel(tz.label)})` : null
                                                ]
                                            })
                                        ]
                                    }, tz.id))
                            })
                        })
                    }),
                    isScrollable ? /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: $7405a7edf99c0e17$var$tzc.clocksScrollbarWrap,
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)("input", {
                            "aria-label": "Scroll timezone clocks",
                            className: $7405a7edf99c0e17$var$tzc.clocksScrollbar,
                            "data-testid": "timezone-clocks-scrollbar",
                            max: maxScrollLeft,
                            min: 0,
                            onChange: handleScrollbarChange,
                            onInput: handleScrollbarChange,
                            step: 1,
                            type: "range",
                            value: rangeValue
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                className: $7405a7edf99c0e17$var$tzc.menuControlWrap,
                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $824bfd70ec70846a$export$2e2bcd8739ae039), {
                    title: "Timezones/Exchanges",
                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $aad80e9a9c3e4c99$export$2e2bcd8739ae039), {
                        className: $7405a7edf99c0e17$var$tzc.addButton,
                        size: "small",
                        "aria-label": "Add timezone clock",
                        onClick: openMenu,
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a27aa5731dfa2868$exports))), {
                            fontSize: "inherit"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $3c81bfb010f12d1e$export$2e2bcd8739ae039), {
                id: "timezone-clocks-menu",
                anchorEl: anchorElement ?? null,
                anchorReference: menuAnchorPosition ? 'anchorPosition' : 'anchorEl',
                anchorPosition: menuAnchorPosition ?? undefined,
                open: menuOpen,
                onClose: closeMenu,
                MenuListProps: {
                    'aria-label': 'Timezone clocks',
                    dense: true
                },
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8ca241c96869ff26$export$2e2bcd8739ae039), {
                        disableSticky: true,
                        className: $7405a7edf99c0e17$var$tzc.menuHourFormatWrap,
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                            onMouseDown: (event)=>{
                                event.stopPropagation();
                            },
                            onClick: (event)=>{
                                event.stopPropagation();
                            },
                            children: /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                className: $7405a7edf99c0e17$var$tzc.hourFormatToggle,
                                role: "group",
                                "aria-label": "Clock time format",
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                                        type: "button",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))($7405a7edf99c0e17$var$tzc.hourFormatOption, {
                                            [$7405a7edf99c0e17$var$tzc.hourFormatOptionPressed]: !use12Hour
                                        }),
                                        "aria-pressed": !use12Hour,
                                        "aria-label": "24 hour time",
                                        onClick: (event)=>{
                                            event.stopPropagation();
                                            setUse12Hour(false);
                                        },
                                        children: "24"
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                                        type: "button",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))($7405a7edf99c0e17$var$tzc.hourFormatOption, {
                                            [$7405a7edf99c0e17$var$tzc.hourFormatOptionPressed]: use12Hour
                                        }),
                                        "aria-pressed": use12Hour,
                                        "aria-label": "12 hour with AM and PM",
                                        onClick: (event)=>{
                                            event.stopPropagation();
                                            setUse12Hour(true);
                                        },
                                        children: "12"
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
                        className: $7405a7edf99c0e17$var$tzc.menuItem,
                        onClick: ()=>{
                            toggleSelectAll();
                        },
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $b1261094ff8b92e7$export$2e2bcd8739ae039), {
                                size: "small",
                                checked: allSelected,
                                indeterminate: someSelected && !allSelected,
                                className: $7405a7edf99c0e17$var$tzc.menuCheckbox,
                                inputProps: {
                                    'aria-label': 'Select all timezones'
                                },
                                onClick: (event)=>{
                                    event.stopPropagation();
                                    toggleSelectAll();
                                }
                            }),
                            "Select all"
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $6634167556f24bbd$export$2e2bcd8739ae039), {
                        className: $7405a7edf99c0e17$var$tzc.menuDivider
                    }),
                    menuTimezones.map((tz)=>/*#__PURE__*/ (0, $fRwNr.jsxs)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
                            className: $7405a7edf99c0e17$var$tzc.menuItem,
                            onClick: ()=>{
                                toggleClock(tz.id);
                            },
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $b1261094ff8b92e7$export$2e2bcd8739ae039), {
                                    size: "small",
                                    checked: selectedIdSet.has(tz.id),
                                    className: $7405a7edf99c0e17$var$tzc.menuCheckbox,
                                    inputProps: {
                                        'aria-label': tz.label
                                    },
                                    onClick: (event)=>{
                                        event.stopPropagation();
                                        toggleClock(tz.id);
                                    }
                                }),
                                tz.label
                            ]
                        }, tz.id))
                ]
            })
        ]
    });
}
const $7405a7edf99c0e17$export$e2f3423030d766d0 = {
    storageKey: $7405a7edf99c0e17$var$storageKey,
    hour12StorageKey: $7405a7edf99c0e17$var$hour12StorageKey,
    safeParseBoolean: $7405a7edf99c0e17$var$safeParseBoolean,
    safeParseSelected: $7405a7edf99c0e17$var$safeParseSelected,
    sanitizeSelectedIds: $7405a7edf99c0e17$var$sanitizeSelectedIds,
    exchangeFromLabel: $7405a7edf99c0e17$var$exchangeFromLabel,
    moveItem: $7405a7edf99c0e17$var$moveItem,
    formatTime: $7405a7edf99c0e17$var$formatTime
};


const $9eb9aabf400d1bf8$var$tradeAllocationFeature = 'tradeAllocation';
const $9eb9aabf400d1bf8$var$supportFeature = 'support';

/** Loads Trade Allocation only after an approved non-production user opens it. */ async function $9eb9aabf400d1bf8$var$loadTradeAllocationModal() {
    const { TradeAllocationModal: TradeAllocationModal } = await (parcelRequire("aPqHS"));
    return {
        default: TradeAllocationModal
    };
}
const $9eb9aabf400d1bf8$var$TradeAllocationModal = /*#__PURE__*/ (0, $lx97N.lazy)($9eb9aabf400d1bf8$var$loadTradeAllocationModal);
const $9eb9aabf400d1bf8$var$getAppLabel = (swVersion)=>{
    const { appVersion: appVersion } = globalThis;
    switch((0, $l2Ecb.getAppEnv)()){
        case 'local':
            return `local:${appVersion}:${swVersion}`;
        case 'development':
            return `development:${appVersion}:${swVersion}`;
        case 'staging':
            return `staging:${appVersion}:${swVersion}`;
        case 'preprod':
            return `preprod:${appVersion}:${swVersion}`;
        case undefined:
            return '';
        default:
            return '';
    }
};
function $9eb9aabf400d1bf8$export$4c260019440d418f({ layout: layout }) {
    const [anchorElement, setAnchorElement] = (0, $lx97N.useState)(undefined);
    const [preferencesModalOpen, setPreferencesModalOpen] = (0, $lx97N.useState)(false);
    const [tradeAllocationModalOpen, setTradeAllocationModalOpen] = (0, $lx97N.useState)(false);
    const [appLabel, setAppLabel] = (0, $lx97N.useState)('');
    const serviceWorkerVersionRef = (0, $lx97N.useRef)('');
    const open = Boolean(anchorElement);
    const tradeAllocationAvailable = (0, $d9gj3.getQepSystem)().container.canUseFeature($9eb9aabf400d1bf8$var$tradeAllocationFeature);
    const supportAvailable = (0, $d9gj3.getQepSystem)().container.canUseFeature($9eb9aabf400d1bf8$var$supportFeature);
    const handleClick = (event)=>{
        setAnchorElement(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorElement(undefined);
    };
    function openPreferencesModal() {
        setPreferencesModalOpen(true);
        handleClose();
    }
    function openIssueReporter() {
        window.open('https://pages.git.cglcloud.com/qep/support/');
        handleClose();
    }
    /** Opens the Trade Allocation chunk only when the preload enables the feature. */ function openTradeAllocationModal() {
        if (!tradeAllocationAvailable) return;
        setTradeAllocationModalOpen(true);
        handleClose();
    }
    /** Closes and unmounts Trade Allocation so its lazy-loaded UI is released. */ function closeTradeAllocationModal() {
        setTradeAllocationModalOpen(false);
    }
    /**
   * Completes server logout before disposing API services used by the logout request.
   * The logout promise is contained to prevent a failed request from becoming an unhandled UI rejection,
   * and cleanup still runs after either outcome while the legacy confirmation modal remains skipped.
   */ function logout() {
        handleClose();
        (async ()=>{
            try {
                await (0, $d9gj3.getQepSystem)().container.authentication.logout();
            } catch (error) {
                console.error('Failed to log out', error);
            } finally{
                (0, $b70d5c68bc353deb$export$b7d6753c864dd3cf)();
            }
        })();
    }
    (0, $lx97N.useEffect)(()=>{
        const syncAppLabel = ()=>{
            setAppLabel($9eb9aabf400d1bf8$var$getAppLabel(serviceWorkerVersionRef.current));
        };
        syncAppLabel();
        (0, $5629744cb1d83a68$export$5b7220d0cd593d0)((version)=>{
            serviceWorkerVersionRef.current = version;
            syncAppLabel();
        });
        const intervalId = globalThis.setInterval(()=>{
            if ((0, $l2Ecb.getAppEnv)()) {
                syncAppLabel();
                globalThis.clearInterval(intervalId);
            }
        }, 250);
        return ()=>{
            globalThis.clearInterval(intervalId);
        };
    }, []);
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $49c44fb299ddf6a4$export$dd147bee413758f6), {
        children: /*#__PURE__*/ (0, $fRwNr.jsx)("header", {
            className: "browser-toolbar-surface",
            "aria-label": "QEP application header",
            children: /*#__PURE__*/ (0, $fRwNr.jsxs)("ul", {
                className: "browser-toolbar",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("li", {
                        className: "browser-toolbar-segment",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $382d3fbeb1a714c1$export$2e2bcd8739ae039), {
                                id: "qep-button",
                                "aria-label": "Open QEP menu",
                                "aria-controls": open ? 'basic-menu' : undefined,
                                "aria-haspopup": "true",
                                "aria-expanded": open ? 'true' : undefined,
                                onClick: handleClick,
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)("img", {
                                            className: "browser-toolbar-logo",
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ded74e28f6d46edb$exports))),
                                            alt: "logo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($364831c49e4926fd$exports))), {
                                        className: "browser-toolbar-arrow-down"
                                    })
                                ]
                            }),
                            appLabel ? /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                className: "browser-toolbar-environment-label",
                                children: appLabel
                            }) : null,
                            /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $3c81bfb010f12d1e$export$2e2bcd8739ae039), {
                                id: "qep-menu",
                                anchorEl: anchorElement,
                                open: open,
                                onClose: handleClose,
                                MenuListProps: {
                                    'aria-labelledby': 'qep-button'
                                },
                                children: [
                                    tradeAllocationAvailable ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
                                        onClick: openTradeAllocationModal,
                                        children: "Trade Allocation"
                                    }) : null,
                                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
                                        onClick: openPreferencesModal,
                                        children: "Preferences"
                                    }),
                                    supportAvailable ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
                                        onClick: openIssueReporter,
                                        children: "Support"
                                    }) : null,
                                    /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d3dfe97e91db5364$export$2e2bcd8739ae039), {
                                        onClick: logout,
                                        children: "Log out"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $3c61bb782faaee34$export$e4b04d74d864122c), {
                                open: preferencesModalOpen,
                                onClose: ()=>{
                                    setPreferencesModalOpen(false);
                                }
                            }),
                            tradeAllocationAvailable && tradeAllocationModalOpen ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $lx97N.Suspense), {
                                fallback: null,
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)($9eb9aabf400d1bf8$var$TradeAllocationModal, {
                                    open: true,
                                    onClose: closeTradeAllocationModal
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))('browser-toolbar-segment', 'browser-toolbar-center'),
                        children: [
                            (0, $d9gj3.getQepSystem)().container.canUseFeature('systemNotifications') ? /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                className: "browser-toolbar-system-notifications",
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $96350a2f54eec2ce$export$dcdc273622d7aadd), {})
                            }) : null,
                            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                className: "browser-toolbar-clocks-slot",
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $7405a7edf99c0e17$export$3db7fbc5607e8424), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("li", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($bqPQ9)))('browser-toolbar-segment', 'browser-toolbar-right'),
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $44d83aaeea01a713$export$2e2bcd8739ae039), {
                                logout: logout,
                                reportIssue: openIssueReporter
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)((0, $45c7904ad4c163e8$export$ed6c55f90c1d06ca), {})
                        ]
                    })
                ]
            })
        })
    });
}




var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");




var $fRwNr = parcelRequire("fRwNr");
parcelRequire("lx97N");
const $1d89655c07e83e27$var$SvgChainlink = (props)=>/*#__PURE__*/ (0, $fRwNr.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        viewBox: "0 0 491.494 491.494",
        ...props,
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("path", {
                d: "m476.419 53.917-38.855-38.86c-20.06-20.05-52.705-20.06-72.775 0l-126.295 126.3c-9.72 9.71-15.07 22.64-15.07 36.38 0 13.75 5.35 26.67 15.07 36.39l14.48-14.48c-5.85-5.85-9.07-13.63-9.07-21.91 0-8.27 3.22-16.05 9.07-21.9l126.295-126.3c12.08-12.08 31.735-12.08 43.815 0l38.855 38.86c5.85 5.85 9.075 13.63 9.075 21.91 0 8.27-3.22 16.05-9.075 21.9l-126.29 126.3c-11.71 11.7-32.115 11.7-43.815 0l-14.48 14.48c9.715 9.72 22.64 15.08 36.385 15.08s26.67-5.36 36.39-15.08l126.29-126.3c9.72-9.71 15.075-22.63 15.075-36.38s-5.355-26.669-15.075-36.39M252.974 277.368l-14.48 14.48c5.85 5.85 9.07 13.63 9.07 21.91 0 8.27-3.22 16.05-9.07 21.9l-126.295 126.3c-12.08 12.08-31.735 12.08-43.815 0l-38.855-38.86c-12.08-12.08-12.08-31.74 0-43.82l126.29-126.29c11.71-11.7 32.115-11.7 43.815 0l14.48-14.48c-9.715-9.72-22.64-15.08-36.385-15.08s-26.67 5.36-36.39 15.08l-126.29 126.29c-20.065 20.07-20.065 52.71 0 72.78l38.855 38.86c10.035 10.03 23.21 15.04 36.39 15.04 13.175 0 26.355-5.01 36.385-15.04l126.295-126.3c9.72-9.71 15.07-22.64 15.07-36.38 0-13.75-5.35-26.67-15.07-36.39"
            }),
            /*#__PURE__*/ (0, $fRwNr.jsx)("path", {
                d: "m170.476 306.525 136.016-136.016 14.482 14.481-136.017 136.016z"
            })
        ]
    });
var $1d89655c07e83e27$export$2e2bcd8739ae039 = $1d89655c07e83e27$var$SvgChainlink;


/* eslint-disable @typescript-eslint/naming-convention */ var $d186cacbb2c7caf0$export$e8e05299eafa8dc7 = /*#__PURE__*/ function(MessageRequestType) {
    MessageRequestType["publish"] = "publish";
    MessageRequestType["subscribe"] = "subscribe";
    MessageRequestType["request"] = "request";
    MessageRequestType["response"] = "response";
    MessageRequestType["broadCast"] = "broadCast";
    return MessageRequestType;
}({});
const $d186cacbb2c7caf0$export$33666ec5cb14837d = {
    AUTH: {
        INITIALIZE: {
            topic: 'initialize',
            messageType: 'publish'
        },
        AUTH_STATUS: {
            topic: 'auth_status',
            messageType: 'request'
        },
        AUTH_STATUS_CHANGE: {
            topic: 'auth_status_change',
            messageType: 'request'
        },
        LOAD_AUTH_SCREEN: {
            topic: 'auth_screen',
            messageType: 'publish'
        }
    },
    WORKSPACE: {
        GET_ACTIVE_WORKSPACE: {
            topic: 'get_active_workspace',
            messageType: 'request'
        },
        SAVE_WORKSPACE: {
            topic: 'save_workspace',
            messageType: 'request'
        }
    },
    SETTINGS: 'settings',
    PREFERENCES: 'preferences',
    WORKSPACES: 'workspaces',
    APPLICATIONS: 'applications'
};
var $d186cacbb2c7caf0$export$69f683232f4f6610 = /*#__PURE__*/ function(DefaultLinkerGroupKeys) {
    DefaultLinkerGroupKeys["GROUP_1"] = "group1";
    DefaultLinkerGroupKeys["GROUP_2"] = "group2";
    DefaultLinkerGroupKeys["GROUP_3"] = "group3";
    return DefaultLinkerGroupKeys;
}({});





var $lx97N = parcelRequire("lx97N");


var $37w0r = parcelRequire("37w0r");

function $4a15f7fb218fe444$var$isMessageWithGroupId(message) {
    return message?.message?.groupId !== undefined;
}
function $4a15f7fb218fe444$export$2e2bcd8739ae039(node) {
    const linkerGroupsRef = (0, $lx97N.useRef)([]);
    const [linkerGroups, setLinkGroups] = (0, $lx97N.useState)([]);
    (0, $lx97N.useEffect)(()=>{
        const { applicationClient: applicationClient } = (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)();
        const { browserContextId: browserContextId } = applicationClient;
        const updateConfig = (newLinkerGroups)=>{
            const myConfigObject = node.getConfig();
            myConfigObject.linkerGroups = newLinkerGroups;
            setLinkGroups(newLinkerGroups);
            node.getModel().doAction((0, $8041f202454d6b76$export$b52183d5cfb26dc9).updateNodeAttributes(node.getId(), {
                config: myConfigObject
            }));
        };
        const windowLinkRegistered = (message)=>{
            if ($4a15f7fb218fe444$var$isMessageWithGroupId(message) && !linkerGroupsRef.current.includes(message.message.groupId)) {
                const newLinkerGroups = (0, (/*@__PURE__*/$parcel$interopDefault($37w0r))).clone(linkerGroupsRef.current);
                newLinkerGroups.push(message.message.groupId);
                linkerGroupsRef.current = newLinkerGroups;
                updateConfig(newLinkerGroups);
            }
        };
        const windowLinkUnregistered = (message)=>{
            if ($4a15f7fb218fe444$var$isMessageWithGroupId(message) && linkerGroupsRef.current.includes(message.message.groupId)) {
                let newLinkerGroups = (0, (/*@__PURE__*/$parcel$interopDefault($37w0r))).clone(linkerGroupsRef.current);
                newLinkerGroups = newLinkerGroups.filter((groupId)=>groupId !== message.message.groupId);
                linkerGroupsRef.current = newLinkerGroups;
                updateConfig(newLinkerGroups);
            }
        };
        const myConfigObject = node.getConfig();
        if (myConfigObject?.linkerGroups && Array.isArray(myConfigObject.linkerGroups) && myConfigObject?.linkerGroups?.length) {
            for (const groupId of myConfigObject.linkerGroups)(0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().linker.registerLink(groupId, node.getId(), myConfigObject.componentId);
            linkerGroupsRef.current = myConfigObject.linkerGroups;
            setLinkGroups(myConfigObject.linkerGroups);
        }
        (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().applicationClient.subscribe(`linker-${browserContextId}-${node.getId()}-registerLink`, windowLinkRegistered);
        (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().applicationClient.subscribe(`linker-${browserContextId}-${node.getId()}-unregisterLink`, windowLinkUnregistered);
        return ()=>{
            (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().applicationClient.unSubscribe(`linker-${browserContextId}-${node.getId()}-registerLink`, windowLinkRegistered);
            (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().applicationClient.unSubscribe(`linker-${browserContextId}-${node.getId()}-unregisterLink`, windowLinkUnregistered);
        };
    }, []);
    return linkerGroups;
}


const $6144036ef99e20eb$var$linkerClasses = {
    customDropdownMenu: 'browser-linker-dropdown-menu',
    linkGroup: 'browser-linker-link-group',
    linkIcon: 'browser-linker-link-icon',
    overlay: 'browser-linker-overlay'
};
const $6144036ef99e20eb$var$iconClasses = [
    'browser-linker-icon-1',
    'browser-linker-icon-2',
    'browser-linker-icon-3'
];
const $6144036ef99e20eb$var$tabIconClasses = [
    'browser-linker-tab-icon-1',
    'browser-linker-tab-icon-2',
    'browser-linker-tab-icon-3'
];
/*
    Dynamically creates linker groups from types making it easier to change defaults in the future.
    But also allows for linker group names to be more globally available.
*/ const $6144036ef99e20eb$var$linkerGroupList = {};
for (const [i, key] of Object.keys((0, $d186cacbb2c7caf0$export$69f683232f4f6610)).entries()){
    const groupName = `${key.slice(0, 1)}${key.slice(1).replace('_', ' ').toLowerCase()}`;
    const groupKey = (0, $d186cacbb2c7caf0$export$69f683232f4f6610)[key];
    $6144036ef99e20eb$var$linkerGroupList[groupKey] = {
        icon: $6144036ef99e20eb$var$iconClasses[i],
        tabIcon: $6144036ef99e20eb$var$tabIconClasses[i],
        name: groupName
    };
}
function $6144036ef99e20eb$export$2e2bcd8739ae039({ node: node }) {
    const [id, SetId] = (0, $lx97N.useState)(Math.random().toString(36).slice(7));
    // const [linkerGroups, setLinkerGroups] = useState<string[]>([]);
    const linkerGroups = (0, $4a15f7fb218fe444$export$2e2bcd8739ae039)(node);
    const dropdownRef = (0, $lx97N.useRef)(null);
    const buttonRef = (0, $lx97N.useRef)(null);
    const [overlayPos, recalculate] = (0, $e17239922722c3a5$export$aa756028c6395a46)(buttonRef, dropdownRef);
    const [showDropdown, setShowDropdown] = (0, $lx97N.useState)(false);
    const handleDropdownClick = (event)=>{
        recalculate();
        setShowDropdown(!showDropdown);
    };
    const getLinkerIcon = ()=>{
        if (linkerGroups.length === 0) return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $1d89655c07e83e27$export$2e2bcd8739ae039), {
            id: `icon_${id}`,
            className: $6144036ef99e20eb$var$linkerClasses.linkIcon
        });
        return linkerGroups.map((groupId)=>/*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                className: $6144036ef99e20eb$var$linkerGroupList[groupId].tabIcon
            }, groupId));
    };
    const getGroupIndex = (groupId)=>linkerGroups.indexOf(groupId);
    const setLinkerGroup = async (groupId)=>{
        const groupIndex = getGroupIndex(groupId);
        const newLinkerGroups = await (groupIndex === -1 ? (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().linker.registerLink(groupId, node.getId()) : (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().linker.deRegisterLink(groupId, node.getId()));
        const myConfigObject = node.getConfig();
        myConfigObject.linkerGroups = newLinkerGroups;
        node.getModel().doAction((0, $8041f202454d6b76$export$b52183d5cfb26dc9).updateNodeAttributes(node.getId(), {
            config: myConfigObject
        }));
    };
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        ref: buttonRef,
        style: {
            position: 'relative',
            zIndex: 1050
        },
        "data-testid": `linker-button-${node.getName()}`,
        children: [
            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                onClick: handleDropdownClick,
                id: id,
                children: getLinkerIcon()
            }),
            showDropdown && /*#__PURE__*/ (0, $fRwNr.jsx)((0, $740e1b02f8b0d5ed$export$602eac185826482c), {
                outsideClickOmitElements: [
                    dropdownRef,
                    buttonRef
                ],
                className: $6144036ef99e20eb$var$linkerClasses.overlay,
                style: {
                    top: `${overlayPos.top}px`,
                    left: `${overlayPos.left}px`
                },
                onOutsideClick: ()=>{
                    setShowDropdown(false);
                },
                children: /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                    "data-testid": "linker-menu",
                    ref: dropdownRef,
                    className: $6144036ef99e20eb$var$linkerClasses.customDropdownMenu,
                    children: Object.entries($6144036ef99e20eb$var$linkerGroupList).map(([key, value])=>/*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                            className: $6144036ef99e20eb$var$linkerClasses.linkGroup,
                            onClick: async ()=>{
                                await setLinkerGroup(key);
                                setShowDropdown(false);
                            },
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                    className: value.icon
                                }),
                                value.name
                            ]
                        }, key))
                })
            })
        ]
    });
}



/** Renders the polished QEP Assistant and connects its in-memory conversation to the authenticated qep-mcp chat API. */ 
var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");
/**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('react').ReactElement<{}>} ReactElement
 * @typedef {import('unified').PluggableList} PluggableList
 * @typedef {import('hast').Root} Root
 * @typedef {import('./rehype-filter.js').Options} FilterOptions
 * @typedef {import('./ast-to-react.js').Options} TransformOptions
 *
 * @typedef CoreOptions
 * @property {string} children
 *
 * @typedef PluginOptions
 * @property {PluggableList} [remarkPlugins=[]]
 * @property {PluggableList} [rehypePlugins=[]]
 * @property {import('remark-rehype').Options} [remarkRehypeOptions={}]
 *
 * @typedef LayoutOptions
 * @property {string} [className]
 *
 * @typedef {CoreOptions & PluginOptions & LayoutOptions & FilterOptions & TransformOptions} ReactMarkdownOptions
 *
 * @typedef Deprecation
 * @property {string} id
 * @property {string} [to]
 */ 
var $lx97N = parcelRequire("lx97N");
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {import('./minurl.shared.js').URL} URL
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {Record<string, unknown> & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {'ascii' | 'utf8' | 'utf-8' | 'utf16le' | 'ucs2' | 'ucs-2' | 'base64' | 'base64url' | 'latin1' | 'binary' | 'hex'} BufferEncoding
 *   Encodings supported by the buffer class.
 *
 *   This is a copy of the types from Node, copied to prevent Node globals from
 *   being needed.
 *   Copied from: <https://github.com/DefinitelyTyped/DefinitelyTyped/blob/90a4ec8/types/node/buffer.d.ts#L170>
 *
 * @typedef {Options | URL | Value | VFile} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {Value | null | undefined} [value]
 *   Set `value`.
 * @property {string | null | undefined} [cwd]
 *   Set `cwd`.
 * @property {Array<string> | null | undefined} [history]
 *   Set `history`.
 * @property {URL | string | null | undefined} [path]
 *   Set `path`.
 * @property {string | null | undefined} [basename]
 *   Set `basename`.
 * @property {string | null | undefined} [stem]
 *   Set `stem`.
 * @property {string | null | undefined} [extname]
 *   Set `extname`.
 * @property {string | null | undefined} [dirname]
 *   Set `dirname`.
 * @property {Data | null | undefined} [data]
 *   Set `data`.
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/58819f0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {{[key: string]: unknown} & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template {ReporterSettings} Settings
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ var $1613063649aee840$exports = {};
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ $1613063649aee840$exports = function isBuffer(obj) {
    return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Point} Point
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Position | PositionLike | Point | PointLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $c2800647e46698b3$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $c2800647e46698b3$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $c2800647e46698b3$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $c2800647e46698b3$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $c2800647e46698b3$var$point(point) {
    return $c2800647e46698b3$var$index(point && point.line) + ':' + $c2800647e46698b3$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $c2800647e46698b3$var$position(pos) {
    return $c2800647e46698b3$var$point(pos && pos.start) + '-' + $c2800647e46698b3$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $c2800647e46698b3$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $8d82e3e29a1417e2$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // To do: next major: expose `undefined` everywhere instead of `null`.
    constructor(reason, place, origin){
        /** @type {[string | null, string | null]} */ const parts = [
            null,
            null
        ];
        /** @type {Position} */ let position = {
            // @ts-expect-error: we always follows the structure of `position`.
            start: {
                line: null,
                column: null
            },
            // @ts-expect-error: "
            end: {
                line: null,
                column: null
            }
        };
        super();
        if (typeof place === 'string') {
            origin = place;
            place = undefined;
        }
        if (typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) parts[1] = origin;
            else {
                parts[0] = origin.slice(0, index);
                parts[1] = origin.slice(index + 1);
            }
        }
        if (place) {
            // Node.
            if ('type' in place || 'position' in place) {
                if (place.position) // To do: next major: deep clone.
                // @ts-expect-error: looks like a position.
                position = place.position;
            } else if ('start' in place || 'end' in place) // @ts-expect-error: looks like a position.
            // To do: next major: deep clone.
            position = place;
            else if ('line' in place || 'column' in place) // To do: next major: deep clone.
            position.start = place;
        }
        // Fields from `Error`.
        /**
     * Serialized positional info of error.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $c2800647e46698b3$export$c304dd45fe166145)(place) || '1:1';
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = typeof reason === 'object' ? reason.message : reason;
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = '';
        if (typeof reason === 'object' && reason.stack) this.stack = reason.stack;
        /**
     * Reason for message.
     *
     * > 👉 **Note**: you should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /* eslint-disable no-unused-expressions */ /**
     * State of problem.
     *
     * * `true` — marks associated file as no longer processable (error)
     * * `false` — necessitates a (potential) change (warning)
     * * `null | undefined` — for things that might not need changing (info)
     *
     * @type {boolean | null | undefined}
     */ this.fatal;
        /**
     * Starting line of error.
     *
     * @type {number | null}
     */ this.line = position.start.line;
        /**
     * Starting column of error.
     *
     * @type {number | null}
     */ this.column = position.start.column;
        /**
     * Full unist position.
     *
     * @type {Position | null}
     */ this.position = position;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | null}
     */ this.source = parts[0];
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | null}
     */ this.ruleId = parts[1];
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | null}
     */ this.file;
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | null}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | null}
     */ this.expected;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | null}
     */ this.url;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | null}
     */ this.note;
    /* eslint-enable no-unused-expressions */ }
}
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.file = '';
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.name = '';
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.reason = '';
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.message = '';
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.stack = '';
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.fatal = null;
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.column = null;
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.line = null;
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.source = null;
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.ruleId = null;
$8d82e3e29a1417e2$export$752e5c445fe834ef.prototype.position = null;


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $76dc8763f1906fc2$export$bb654e07daaf8c3a = {
    basename: $76dc8763f1906fc2$var$basename,
    dirname: $76dc8763f1906fc2$var$dirname,
    extname: $76dc8763f1906fc2$var$extname,
    join: $76dc8763f1906fc2$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $76dc8763f1906fc2$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
    $76dc8763f1906fc2$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (ext === path) return '';
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.charCodeAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $76dc8763f1906fc2$var$dirname(path) {
    $76dc8763f1906fc2$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.charCodeAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.charCodeAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.charCodeAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $76dc8763f1906fc2$var$extname(path) {
    $76dc8763f1906fc2$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.charCodeAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $76dc8763f1906fc2$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $76dc8763f1906fc2$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $76dc8763f1906fc2$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $76dc8763f1906fc2$var$normalize(path) {
    $76dc8763f1906fc2$var$assertPath(path);
    const absolute = path.charCodeAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $76dc8763f1906fc2$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.charCodeAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $76dc8763f1906fc2$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.charCodeAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.charCodeAt(result.length - 1) !== 46 /* `.` */  || result.charCodeAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $76dc8763f1906fc2$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $925a52fec1b90daa$export$97a5aaf482767187 = {
    cwd: $925a52fec1b90daa$var$cwd
};
function $925a52fec1b90daa$var$cwd() {
    return '/';
}


/// <reference lib="dom" />
/**
 * @typedef URL
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} origin
 * @property {string} password
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {any} searchParams
 * @property {string} username
 * @property {() => string} toString
 * @property {() => string} toJSON
 */ /**
 * Check if `fileUrlOrPath` looks like a URL.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/fcf8ba4/lib/internal/url.js#L1501>
function $e03de5c8a9f67c93$export$8304a22d431f958(fileUrlOrPath) {
    return fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && // @ts-expect-error: indexable.
    fileUrlOrPath.href && // @ts-expect-error: indexable.
    fileUrlOrPath.origin;
}


function $c01c6a0463602ee5$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $e03de5c8a9f67c93$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $c01c6a0463602ee5$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $c01c6a0463602ee5$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.charCodeAt(index) === 37 /* `%` */  && pathname.charCodeAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.charCodeAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 *
 * @type {Array<'basename' | 'dirname' | 'extname' | 'history' | 'path' | 'stem'>}
 */ const $64ce9a830b94da6b$var$order = [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $64ce9a830b94da6b$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if (typeof value === 'string' || $64ce9a830b94da6b$var$buffer(value)) options = {
            value: value
        };
        else if ((0, $e03de5c8a9f67c93$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else options = value;
        /**
     * Place to store custom information (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * List of filepaths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $925a52fec1b90daa$export$97a5aaf482767187).cwd();
        /* eslint-disable no-unused-expressions */ /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $64ce9a830b94da6b$var$order.length){
            const prop = $64ce9a830b94da6b$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === 'history' ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$64ce9a830b94da6b$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */ set path(path) {
        if ((0, $e03de5c8a9f67c93$export$8304a22d431f958)(path)) path = (0, $c01c6a0463602ee5$export$9b2b676c902de799)(path);
        $64ce9a830b94da6b$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the parent path (example: `'~'`).
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */ set dirname(dirname) {
        $64ce9a830b94da6b$var$assertPath(this.basename, 'dirname');
        this.path = (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).join(dirname || '', this.basename);
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */ get basename() {
        return typeof this.path === 'string' ? (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set basename(basename) {
        $64ce9a830b94da6b$var$assertNonEmpty(basename, 'basename');
        $64ce9a830b94da6b$var$assertPart(basename, 'basename');
        this.path = (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).join(this.dirname || '', basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   */ get extname() {
        return typeof this.path === 'string' ? (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */ set extname(extname) {
        $64ce9a830b94da6b$var$assertPart(extname, 'extname');
        $64ce9a830b94da6b$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.charCodeAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */ get stem() {
        return typeof this.path === 'string' ? (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */ set stem(stem) {
        $64ce9a830b94da6b$var$assertNonEmpty(stem, 'stem');
        $64ce9a830b94da6b$var$assertPart(stem, 'stem');
        this.path = (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).join(this.dirname || '', stem + (this.extname || ''));
    }
    /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        return (this.value || '').toString(encoding || undefined);
    }
    /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(reason, place, origin) {
        const message = new (0, $8d82e3e29a1417e2$export$752e5c445fe834ef)(reason, place, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = null;
        return message;
    }
    /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */ fail(reason, place, origin) {
        const message = this.message(reason, place, origin);
        message.fatal = true;
        throw message;
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {void}
 *   Nothing.
 */ function $64ce9a830b94da6b$var$assertPart(part, name) {
    if (part && part.includes((0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $76dc8763f1906fc2$export$bb654e07daaf8c3a).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $64ce9a830b94da6b$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $64ce9a830b94da6b$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is a buffer.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Buffer}
 *   Whether `value` is a Node.js buffer.
 */ function $64ce9a830b94da6b$var$buffer(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($1613063649aee840$exports)))(value);
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('vfile').VFileCompatible} VFileCompatible
 * @typedef {import('vfile').VFileValue} VFileValue
 * @typedef {import('..').Processor} Processor
 * @typedef {import('..').Plugin} Plugin
 * @typedef {import('..').Preset} Preset
 * @typedef {import('..').Pluggable} Pluggable
 * @typedef {import('..').PluggableList} PluggableList
 * @typedef {import('..').Transformer} Transformer
 * @typedef {import('..').Parser} Parser
 * @typedef {import('..').Compiler} Compiler
 * @typedef {import('..').RunCallback} RunCallback
 * @typedef {import('..').ProcessCallback} ProcessCallback
 *
 * @typedef Context
 * @property {Node} tree
 * @property {VFile} file
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $9f07c614b2a686d3$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}



var $adfeb8f4e98e800c$exports = {};
'use strict';
var $adfeb8f4e98e800c$var$hasOwn = Object.prototype.hasOwnProperty;
var $adfeb8f4e98e800c$var$toStr = Object.prototype.toString;
var $adfeb8f4e98e800c$var$defineProperty = Object.defineProperty;
var $adfeb8f4e98e800c$var$gOPD = Object.getOwnPropertyDescriptor;
var $adfeb8f4e98e800c$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $adfeb8f4e98e800c$var$toStr.call(arr) === '[object Array]';
};
var $adfeb8f4e98e800c$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $adfeb8f4e98e800c$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $adfeb8f4e98e800c$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $adfeb8f4e98e800c$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $adfeb8f4e98e800c$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $adfeb8f4e98e800c$var$setProperty = function setProperty(target, options) {
    if ($adfeb8f4e98e800c$var$defineProperty && options.name === '__proto__') $adfeb8f4e98e800c$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $adfeb8f4e98e800c$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$adfeb8f4e98e800c$var$hasOwn.call(obj, name)) return void 0;
        else if ($adfeb8f4e98e800c$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $adfeb8f4e98e800c$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$adfeb8f4e98e800c$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $adfeb8f4e98e800c$var$getProperty(target, name);
            copy = $adfeb8f4e98e800c$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($adfeb8f4e98e800c$var$isPlainObject(copy) || (copyIsArray = $adfeb8f4e98e800c$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $adfeb8f4e98e800c$var$isArray(src) ? src : [];
                    } else clone = src && $adfeb8f4e98e800c$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $adfeb8f4e98e800c$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $adfeb8f4e98e800c$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};


function $329350557b958064$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $5407be871f1dce80$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $5407be871f1dce80$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $5407be871f1dce80$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}



const $18b4b78c0087b74e$export$7cc1b2fe10c52bb = $18b4b78c0087b74e$var$base().freeze();
const $18b4b78c0087b74e$var$own = {}.hasOwnProperty;
// Function to create the first processor.
/**
 * @returns {Processor}
 */ function $18b4b78c0087b74e$var$base() {
    const transformers = (0, $5407be871f1dce80$export$91b56f5ca106aa43)();
    /** @type {Processor['attachers']} */ const attachers = [];
    /** @type {Record<string, unknown>} */ let namespace = {};
    /** @type {boolean|undefined} */ let frozen;
    let freezeIndex = -1;
    // Data management.
    // @ts-expect-error: overloads are handled.
    processor.data = data;
    processor.Parser = undefined;
    processor.Compiler = undefined;
    // Lock.
    processor.freeze = freeze;
    // Plugins.
    processor.attachers = attachers;
    // @ts-expect-error: overloads are handled.
    processor.use = use;
    // API.
    processor.parse = parse;
    processor.stringify = stringify;
    // @ts-expect-error: overloads are handled.
    processor.run = run;
    processor.runSync = runSync;
    // @ts-expect-error: overloads are handled.
    processor.process = process;
    processor.processSync = processSync;
    // Expose.
    return processor;
    // Create a new processor based on the processor in the current scope.
    /** @type {Processor} */ function processor() {
        const destination = $18b4b78c0087b74e$var$base();
        let index = -1;
        while(++index < attachers.length)destination.use(...attachers[index]);
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($adfeb8f4e98e800c$exports)))(true, {}, namespace));
        return destination;
    }
    /**
   * @param {string|Record<string, unknown>} [key]
   * @param {unknown} [value]
   * @returns {unknown}
   */ function data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $18b4b78c0087b74e$var$assertUnfrozen('data', frozen);
                namespace[key] = value;
                return processor;
            }
            // Get `key`.
            return $18b4b78c0087b74e$var$own.call(namespace, key) && namespace[key] || null;
        }
        // Set space.
        if (key) {
            $18b4b78c0087b74e$var$assertUnfrozen('data', frozen);
            namespace = key;
            return processor;
        }
        // Get space.
        return namespace;
    }
    /** @type {Processor['freeze']} */ function freeze() {
        if (frozen) return processor;
        while(++freezeIndex < attachers.length){
            const [attacher, ...options] = attachers[freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            /** @type {Transformer|void} */ const transformer = attacher.call(processor, ...options);
            if (typeof transformer === 'function') transformers.use(transformer);
        }
        frozen = true;
        freezeIndex = Number.POSITIVE_INFINITY;
        return processor;
    }
    /**
   * @param {Pluggable|null|undefined} [value]
   * @param {...unknown} options
   * @returns {Processor}
   */ function use(value, ...options) {
        /** @type {Record<string, unknown>|undefined} */ let settings;
        $18b4b78c0087b74e$var$assertUnfrozen('use', frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, ...options);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        if (settings) namespace.settings = Object.assign(namespace.settings || {}, settings);
        return processor;
        /**
     * @param {import('..').Pluggable<unknown[]>} value
     * @returns {void}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...options] = value;
                    addPlugin(plugin, ...options);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {void}
     */ function addPreset(result) {
            addList(result.plugins);
            if (result.settings) settings = Object.assign(settings || {}, result.settings);
        }
        /**
     * @param {PluggableList|null|undefined} [plugins]
     * @returns {void}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {...unknown} [value]
     * @returns {void}
     */ function addPlugin(plugin, value) {
            let index = -1;
            /** @type {Processor['attachers'][number]|undefined} */ let entry;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entry = attachers[index];
                break;
            }
            if (entry) {
                if ((0, $329350557b958064$export$2e2bcd8739ae039)(entry[1]) && (0, $329350557b958064$export$2e2bcd8739ae039)(value)) value = (0, (/*@__PURE__*/$parcel$interopDefault($adfeb8f4e98e800c$exports)))(true, entry[1], value);
                entry[1] = value;
            } else // @ts-expect-error: fine.
            attachers.push([
                ...arguments
            ]);
        }
    }
    /** @type {Processor['parse']} */ function parse(doc) {
        processor.freeze();
        const file = $18b4b78c0087b74e$var$vfile(doc);
        const Parser = processor.Parser;
        $18b4b78c0087b74e$var$assertParser('parse', Parser);
        if ($18b4b78c0087b74e$var$newable(Parser, 'parse')) // @ts-expect-error: `newable` checks this.
        return new Parser(String(file), file).parse();
        // @ts-expect-error: `newable` checks this.
        return Parser(String(file), file) // eslint-disable-line new-cap
        ;
    }
    /** @type {Processor['stringify']} */ function stringify(node, doc) {
        processor.freeze();
        const file = $18b4b78c0087b74e$var$vfile(doc);
        const Compiler = processor.Compiler;
        $18b4b78c0087b74e$var$assertCompiler('stringify', Compiler);
        $18b4b78c0087b74e$var$assertNode(node);
        if ($18b4b78c0087b74e$var$newable(Compiler, 'compile')) // @ts-expect-error: `newable` checks this.
        return new Compiler(node, file).compile();
        // @ts-expect-error: `newable` checks this.
        return Compiler(node, file) // eslint-disable-line new-cap
        ;
    }
    /**
   * @param {Node} node
   * @param {VFileCompatible|RunCallback} [doc]
   * @param {RunCallback} [callback]
   * @returns {Promise<Node>|void}
   */ function run(node, doc, callback) {
        $18b4b78c0087b74e$var$assertNode(node);
        processor.freeze();
        if (!callback && typeof doc === 'function') {
            callback = doc;
            doc = undefined;
        }
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((node: Node) => void)} resolve
     * @param {(error: Error) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            // @ts-expect-error: `doc` can’t be a callback anymore, we checked.
            transformers.run(node, $18b4b78c0087b74e$var$vfile(doc), done);
            /**
       * @param {Error|null} error
       * @param {Node} tree
       * @param {VFile} file
       * @returns {void}
       */ function done(error, tree, file) {
                tree = tree || node;
                if (error) reject(error);
                else if (resolve) resolve(tree);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, tree, file);
            }
        }
    }
    /** @type {Processor['runSync']} */ function runSync(node, file) {
        /** @type {Node|undefined} */ let result;
        /** @type {boolean|undefined} */ let complete;
        processor.run(node, file, done);
        $18b4b78c0087b74e$var$assertDone('runSync', 'run', complete);
        // @ts-expect-error: we either bailed on an error or have a tree.
        return result;
        /**
     * @param {Error|null} [error]
     * @param {Node} [tree]
     * @returns {void}
     */ function done(error, tree) {
            (0, $9f07c614b2a686d3$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * @param {VFileCompatible} doc
   * @param {ProcessCallback} [callback]
   * @returns {Promise<VFile>|undefined}
   */ function process(doc, callback) {
        processor.freeze();
        $18b4b78c0087b74e$var$assertParser('process', processor.Parser);
        $18b4b78c0087b74e$var$assertCompiler('process', processor.Compiler);
        if (!callback) return new Promise(executor);
        executor(null, callback);
        /**
     * @param {null|((file: VFile) => void)} resolve
     * @param {(error?: Error|null|undefined) => void} reject
     * @returns {void}
     */ function executor(resolve, reject) {
            const file = $18b4b78c0087b74e$var$vfile(doc);
            processor.run(processor.parse(file), file, (error, tree, file)=>{
                if (error || !tree || !file) done(error);
                else {
                    /** @type {unknown} */ const result = processor.stringify(tree, file);
                    if (result === undefined || result === null) ;
                    else if ($18b4b78c0087b74e$var$looksLikeAVFileValue(result)) file.value = result;
                    else file.result = result;
                    done(error, file);
                }
            });
            /**
       * @param {Error|null|undefined} [error]
       * @param {VFile|undefined} [file]
       * @returns {void}
       */ function done(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else // @ts-expect-error: `callback` is defined if `resolve` is not.
                callback(null, file);
            }
        }
    }
    /** @type {Processor['processSync']} */ function processSync(doc) {
        /** @type {boolean|undefined} */ let complete;
        processor.freeze();
        $18b4b78c0087b74e$var$assertParser('processSync', processor.Parser);
        $18b4b78c0087b74e$var$assertCompiler('processSync', processor.Compiler);
        const file = $18b4b78c0087b74e$var$vfile(doc);
        processor.process(file, done);
        $18b4b78c0087b74e$var$assertDone('processSync', 'process', complete);
        return file;
        /**
     * @param {Error|null|undefined} [error]
     * @returns {void}
     */ function done(error) {
            complete = true;
            (0, $9f07c614b2a686d3$export$dd911e13ecb11e05)(error);
        }
    }
}
/**
 * Check if `value` is a constructor.
 *
 * @param {unknown} value
 * @param {string} name
 * @returns {boolean}
 */ function $18b4b78c0087b74e$var$newable(value, name) {
    return typeof value === 'function' && // Prototypes do exist.
    // type-coverage:ignore-next-line
    value.prototype && // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    // type-coverage:ignore-next-line
    ($18b4b78c0087b74e$var$keys(value.prototype) || name in value.prototype);
}
/**
 * Check if `value` is an object with keys.
 *
 * @param {Record<string, unknown>} value
 * @returns {boolean}
 */ function $18b4b78c0087b74e$var$keys(value) {
    /** @type {string} */ let key;
    for(key in value){
        if ($18b4b78c0087b74e$var$own.call(value, key)) return true;
    }
    return false;
}
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $18b4b78c0087b74e$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `Parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $18b4b78c0087b74e$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `Compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $18b4b78c0087b74e$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $18b4b78c0087b74e$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $329350557b958064$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $18b4b78c0087b74e$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {VFileCompatible} [value]
 * @returns {VFile}
 */ function $18b4b78c0087b74e$var$vfile(value) {
    return $18b4b78c0087b74e$var$looksLikeAVFile(value) ? value : new (0, $64ce9a830b94da6b$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {VFileCompatible} [value]
 * @returns {value is VFile}
 */ function $18b4b78c0087b74e$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is VFileValue}
 */ function $18b4b78c0087b74e$var$looksLikeAVFileValue(value) {
    return typeof value === 'string' || (0, (/*@__PURE__*/$parcel$interopDefault($1613063649aee840$exports)))(value);
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} Options
 */ /**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').StaticPhrasingContent} StaticPhrasingContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').HTML} HTML
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Root | Content} Node
 * @typedef {Extract<Node, UnistParent>} Parent
 *
 * @typedef {Omit<UnistParent, 'type' | 'children'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | undefined | null | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {void}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Node | Fragment>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {<Key extends keyof CompileData>(key: Key) => CompileData[Key]} getData
 *   Get data from the key/value store.
 * @property {<Key extends keyof CompileData>(key: Key, value?: CompileData[Key]) => void} setData
 *   Set data into the key/value store.
 * @property {(this: CompileContext) => void} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {<Kind extends Node>(this: CompileContext, node: Kind, token: Token, onError?: OnEnterError) => Kind} enter
 *   Enter a token.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => Node} exit
 *   Exit a token.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ // To do: micromark: create a registry of tokens?
// To do: next major: don’t return given `Node` from `enter`.
// To do: next major: remove setter/getter.
/**
 * @typedef {import('mdast').Root|import('mdast').Content} Node
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s.
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML.
 */ /** @type {Options} */ const $f93ecd636863ff21$var$emptyOptions = {};
function $f93ecd636863ff21$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $f93ecd636863ff21$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $f93ecd636863ff21$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $f93ecd636863ff21$var$one(value, includeImageAlt, includeHtml) {
    if ($f93ecd636863ff21$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $f93ecd636863ff21$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $f93ecd636863ff21$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $f93ecd636863ff21$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $f93ecd636863ff21$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Node}
 *   Whether `value` is a node.
 */ function $f93ecd636863ff21$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ /**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {void}
 *   Nothing.
 */ function $d06a2a6a4e8d369a$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $d06a2a6a4e8d369a$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $d06a2a6a4e8d369a$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


const $b1e4c4fe60fa07a2$var$hasOwnProperty = {}.hasOwnProperty;
function $b1e4c4fe60fa07a2$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$b1e4c4fe60fa07a2$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $b1e4c4fe60fa07a2$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $b1e4c4fe60fa07a2$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$b1e4c4fe60fa07a2$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $b1e4c4fe60fa07a2$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {void}
 */ function $b1e4c4fe60fa07a2$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $d06a2a6a4e8d369a$export$869882364835d202)(existing, 0, 0, before);
}
function $b1e4c4fe60fa07a2$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$b1e4c4fe60fa07a2$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {void}
 */ function $b1e4c4fe60fa07a2$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $b1e4c4fe60fa07a2$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 */ // This module is generated by `script/`.
//
// CommonMark handles attention (emphasis, strong) markers based on what comes
// before or after them.
// One such difference is if those characters are Unicode punctuation.
// This script is generated from the Unicode data.
/**
 * Regular expression that matches a unicode punctuation character.
 */ const $eae469b42035dfc0$export$85b5101f24802e8c = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/;


const $0e0efac6dff74a8f$export$d65d6b62c24d5436 = $0e0efac6dff74a8f$var$regexCheck(/[A-Za-z]/);
const $0e0efac6dff74a8f$export$75c76db11865a9f4 = $0e0efac6dff74a8f$var$regexCheck(/[\dA-Za-z]/);
const $0e0efac6dff74a8f$export$4397998b34fe597d = $0e0efac6dff74a8f$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $0e0efac6dff74a8f$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $0e0efac6dff74a8f$export$ca8b5b1a6c320e6e = $0e0efac6dff74a8f$var$regexCheck(/\d/);
const $0e0efac6dff74a8f$export$eca2752363989806 = $0e0efac6dff74a8f$var$regexCheck(/[\dA-Fa-f]/);
const $0e0efac6dff74a8f$export$35794a7d1db99380 = $0e0efac6dff74a8f$var$regexCheck(/[!-/:-@[-`{-~]/);
function $0e0efac6dff74a8f$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $0e0efac6dff74a8f$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $0e0efac6dff74a8f$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $0e0efac6dff74a8f$export$aa04114dd888a7a0 = $0e0efac6dff74a8f$var$regexCheck((0, $eae469b42035dfc0$export$85b5101f24802e8c));
const $0e0efac6dff74a8f$export$a0ff789c034ffdf4 = $0e0efac6dff74a8f$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $0e0efac6dff74a8f$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && regex.test(String.fromCharCode(code));
    }
}


function $a05c2eee5bad6ea2$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $39e760912b01def4$export$a7db06668cad9adb = {
    tokenize: $39e760912b01def4$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $39e760912b01def4$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, contentStart, 'linePrefix');
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter('paragraph');
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter('chunkText', {
            contentType: 'text',
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit('chunkText');
            effects.exit('paragraph');
            effects.consume(code);
            return;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit('chunkText');
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $d2a73748e5f16937$export$5a7bfc01df82fcd1 = {
    tokenize: $d2a73748e5f16937$var$initializeDocument
};
/** @type {Construct} */ const $d2a73748e5f16937$var$containerConstruct = {
    tokenize: $d2a73748e5f16937$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $d2a73748e5f16937$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === 'chunkFlow') {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $d06a2a6a4e8d369a$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($d2a73748e5f16937$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($d2a73748e5f16937$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter('chunkFlow', {
            contentType: 'flow',
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit('chunkFlow'), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit('chunkFlow'));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {void}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === 'chunkFlow') {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $d06a2a6a4e8d369a$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {void}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d2a73748e5f16937$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), 'linePrefix', this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $076254b4b7f28510$export$d50d28ce3ab2a612 = {
    tokenize: $076254b4b7f28510$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $076254b4b7f28510$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, after, 'linePrefix')(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $4332904054d5e6f6$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === 'chunkFlow' && events[index - 1][1].type === 'listItemPrefix') {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'lineEndingBlank') otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === 'content') while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === 'content') break;
                if (subevents[otherIndex][1].type === 'chunkText') {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $4332904054d5e6f6$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === 'lineEnding' || otherEvent[1].type === 'lineEndingBlank') {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events[lineIndex][1].type = 'lineEndingBlank';
                        otherEvent[1].type = 'lineEnding';
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $d06a2a6a4e8d369a$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $4332904054d5e6f6$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $d06a2a6a4e8d369a$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $8da145a122253ab6$export$a7db06668cad9adb = {
    tokenize: $8da145a122253ab6$var$tokenizeContent,
    resolve: $8da145a122253ab6$var$resolveContent
};
/** @type {Construct} */ const $8da145a122253ab6$var$continuationConstruct = {
    tokenize: $8da145a122253ab6$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $8da145a122253ab6$var$resolveContent(events) {
    (0, $4332904054d5e6f6$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8da145a122253ab6$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter('content');
        previous = effects.enter('chunkContent', {
            contentType: 'content'
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) return effects.check($8da145a122253ab6$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit('chunkContent');
        effects.exit('content');
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit('chunkContent');
        previous.next = effects.enter('chunkContent', {
            contentType: 'content',
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8da145a122253ab6$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit('chunkContent');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, prefixed, 'linePrefix');
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $7fd74848ec51c1a3$export$ccc7b0636abaffc3 = {
    tokenize: $7fd74848ec51c1a3$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $7fd74848ec51c1a3$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $076254b4b7f28510$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $8da145a122253ab6$export$a7db06668cad9adb), afterConstruct)), 'linePrefix')));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEndingBlank');
        effects.consume(code);
        effects.exit('lineEndingBlank');
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $0fb1f790d7f753f3$export$50397835cbfdbc24 = {
    resolveAll: $0fb1f790d7f753f3$var$createResolver()
};
const $0fb1f790d7f753f3$export$22b082955e083ec3 = $0fb1f790d7f753f3$var$initializeFactory('string');
const $0fb1f790d7f753f3$export$6f093cfa640b7166 = $0fb1f790d7f753f3$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $0fb1f790d7f753f3$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $0fb1f790d7f753f3$var$createResolver(field === 'text' ? $0fb1f790d7f753f3$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter('data');
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit('data');
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $0fb1f790d7f753f3$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === 'data') {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== 'data') {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $0fb1f790d7f753f3$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === 'lineEnding') && events[eventIndex - 1][1].type === 'data') {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? 'lineSuffix' : 'hardBreakTrailing',
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {void}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {void}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $7e72526cb55d43c6$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $dcadfc7f857f9c95$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | void}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $7e72526cb55d43c6$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $dcadfc7f857f9c95$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $dcadfc7f857f9c95$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {void}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {void}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : 'tokenize' in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {void}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $d06a2a6a4e8d369a$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {void}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {void}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $dcadfc7f857f9c95$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $dcadfc7f857f9c95$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = '\r';
                break;
            case -4:
                value = '\n';
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? ' ' : '\t';
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = ' ';
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


var $65765e65ab996dda$exports = {};

$parcel$export($65765e65ab996dda$exports, "document", () => $65765e65ab996dda$export$5a7bfc01df82fcd1);
$parcel$export($65765e65ab996dda$exports, "contentInitial", () => $65765e65ab996dda$export$5a2181fb44b58173);
$parcel$export($65765e65ab996dda$exports, "flowInitial", () => $65765e65ab996dda$export$cf8bead395eff824);
$parcel$export($65765e65ab996dda$exports, "flow", () => $65765e65ab996dda$export$ccc7b0636abaffc3);
$parcel$export($65765e65ab996dda$exports, "string", () => $65765e65ab996dda$export$22b082955e083ec3);
$parcel$export($65765e65ab996dda$exports, "text", () => $65765e65ab996dda$export$6f093cfa640b7166);
$parcel$export($65765e65ab996dda$exports, "insideSpan", () => $65765e65ab996dda$export$d44f260a3f9b69f5);
$parcel$export($65765e65ab996dda$exports, "attentionMarkers", () => $65765e65ab996dda$export$b9c0b60d74426aea);
$parcel$export($65765e65ab996dda$exports, "disable", () => $65765e65ab996dda$export$e20fbacbb41798b);
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $6055f54ea3c57143$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code) || (0, $0e0efac6dff74a8f$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $0e0efac6dff74a8f$export$aa04114dd888a7a0)(code)) return 2;
}



const $7f03a73b7c5efa5e$export$45b92471da762af7 = {
    name: 'attention',
    tokenize: $7f03a73b7c5efa5e$var$tokenizeAttention,
    resolveAll: $7f03a73b7c5efa5e$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ function $7f03a73b7c5efa5e$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $7f03a73b7c5efa5e$var$movePoint(start, -use);
            $7f03a73b7c5efa5e$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? 'strongSequence' : 'emphasisSequence',
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? 'strongText' : 'emphasisText',
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? 'strong' : 'emphasis',
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(nextEvents, (0, $7e72526cb55d43c6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $d06a2a6a4e8d369a$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7f03a73b7c5efa5e$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $6055f54ea3c57143$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $6055f54ea3c57143$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {void}
 */ function $7f03a73b7c5efa5e$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $e16146206eb2750a$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $e16146206eb2750a$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $e16146206eb2750a$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('autolink');
        effects.enter('autolinkMarker');
        effects.consume(code);
        effects.exit('autolinkMarker');
        effects.enter('autolinkProtocol');
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit('autolinkProtocol');
            effects.enter('autolinkMarker');
            effects.consume(code);
            effects.exit('autolinkMarker');
            effects.exit('autolink');
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $0e0efac6dff74a8f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $0e0efac6dff74a8f$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit('autolinkProtocol').type = 'autolinkEmail';
            effects.enter('autolinkMarker');
            effects.consume(code);
            effects.exit('autolinkMarker');
            effects.exit('autolink');
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $6f214667b226e36f$export$200dcd0a5903c968 = {
    name: 'blockQuote',
    tokenize: $6f214667b226e36f$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $6f214667b226e36f$var$tokenizeBlockQuoteContinuation
    },
    exit: $6f214667b226e36f$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6f214667b226e36f$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter('blockQuote', {
                    _container: true
                });
                state.open = true;
            }
            effects.enter('blockQuotePrefix');
            effects.enter('blockQuoteMarker');
            effects.consume(code);
            effects.exit('blockQuoteMarker');
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.enter('blockQuotePrefixWhitespace');
            effects.consume(code);
            effects.exit('blockQuotePrefixWhitespace');
            effects.exit('blockQuotePrefix');
            return ok;
        }
        effects.exit('blockQuotePrefix');
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6f214667b226e36f$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, contBefore, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($6f214667b226e36f$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $6f214667b226e36f$var$exit(effects) {
    effects.exit('blockQuote');
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $948a96e1c6f62fdc$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $948a96e1c6f62fdc$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $948a96e1c6f62fdc$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('characterEscape');
        effects.enter('escapeMarker');
        effects.consume(code);
        effects.exit('escapeMarker');
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $0e0efac6dff74a8f$export$35794a7d1db99380)(code)) {
            effects.enter('characterEscapeValue');
            effects.consume(code);
            effects.exit('characterEscapeValue');
            effects.exit('characterEscape');
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * Map of named character references.
 *
 * @type {Record<string, string>}
 */ const $082eea842a54ecda$export$ec810d1aafce79a7 = {
    AElig: "\xc6",
    AMP: '&',
    Aacute: "\xc1",
    Abreve: "\u0102",
    Acirc: "\xc2",
    Acy: "\u0410",
    Afr: "\uD835\uDD04",
    Agrave: "\xc0",
    Alpha: "\u0391",
    Amacr: "\u0100",
    And: "\u2A53",
    Aogon: "\u0104",
    Aopf: "\uD835\uDD38",
    ApplyFunction: "\u2061",
    Aring: "\xc5",
    Ascr: "\uD835\uDC9C",
    Assign: "\u2254",
    Atilde: "\xc3",
    Auml: "\xc4",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    Barwed: "\u2306",
    Bcy: "\u0411",
    Because: "\u2235",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    Bfr: "\uD835\uDD05",
    Bopf: "\uD835\uDD39",
    Breve: "\u02D8",
    Bscr: "\u212C",
    Bumpeq: "\u224E",
    CHcy: "\u0427",
    COPY: "\xa9",
    Cacute: "\u0106",
    Cap: "\u22D2",
    CapitalDifferentialD: "\u2145",
    Cayleys: "\u212D",
    Ccaron: "\u010C",
    Ccedil: "\xc7",
    Ccirc: "\u0108",
    Cconint: "\u2230",
    Cdot: "\u010A",
    Cedilla: "\xb8",
    CenterDot: "\xb7",
    Cfr: "\u212D",
    Chi: "\u03A7",
    CircleDot: "\u2299",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    Colon: "\u2237",
    Colone: "\u2A74",
    Congruent: "\u2261",
    Conint: "\u222F",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    Coproduct: "\u2210",
    CounterClockwiseContourIntegral: "\u2233",
    Cross: "\u2A2F",
    Cscr: "\uD835\uDC9E",
    Cup: "\u22D3",
    CupCap: "\u224D",
    DD: "\u2145",
    DDotrahd: "\u2911",
    DJcy: "\u0402",
    DScy: "\u0405",
    DZcy: "\u040F",
    Dagger: "\u2021",
    Darr: "\u21A1",
    Dashv: "\u2AE4",
    Dcaron: "\u010E",
    Dcy: "\u0414",
    Del: "\u2207",
    Delta: "\u0394",
    Dfr: "\uD835\uDD07",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: '`',
    DiacriticalTilde: "\u02DC",
    Diamond: "\u22C4",
    DifferentialD: "\u2146",
    Dopf: "\uD835\uDD3B",
    Dot: "\xa8",
    DotDot: "\u20DC",
    DotEqual: "\u2250",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    Downarrow: "\u21D3",
    Dscr: "\uD835\uDC9F",
    Dstrok: "\u0110",
    ENG: "\u014A",
    ETH: "\xd0",
    Eacute: "\xc9",
    Ecaron: "\u011A",
    Ecirc: "\xca",
    Ecy: "\u042D",
    Edot: "\u0116",
    Efr: "\uD835\uDD08",
    Egrave: "\xc8",
    Element: "\u2208",
    Emacr: "\u0112",
    EmptySmallSquare: "\u25FB",
    EmptyVerySmallSquare: "\u25AB",
    Eogon: "\u0118",
    Eopf: "\uD835\uDD3C",
    Epsilon: "\u0395",
    Equal: "\u2A75",
    EqualTilde: "\u2242",
    Equilibrium: "\u21CC",
    Escr: "\u2130",
    Esim: "\u2A73",
    Eta: "\u0397",
    Euml: "\xcb",
    Exists: "\u2203",
    ExponentialE: "\u2147",
    Fcy: "\u0424",
    Ffr: "\uD835\uDD09",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    Fopf: "\uD835\uDD3D",
    ForAll: "\u2200",
    Fouriertrf: "\u2131",
    Fscr: "\u2131",
    GJcy: "\u0403",
    GT: '>',
    Gamma: "\u0393",
    Gammad: "\u03DC",
    Gbreve: "\u011E",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    Gcy: "\u0413",
    Gdot: "\u0120",
    Gfr: "\uD835\uDD0A",
    Gg: "\u22D9",
    Gopf: "\uD835\uDD3E",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    Gt: "\u226B",
    HARDcy: "\u042A",
    Hacek: "\u02C7",
    Hat: '^',
    Hcirc: "\u0124",
    Hfr: "\u210C",
    HilbertSpace: "\u210B",
    Hopf: "\u210D",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    Hstrok: "\u0126",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    IEcy: "\u0415",
    IJlig: "\u0132",
    IOcy: "\u0401",
    Iacute: "\xcd",
    Icirc: "\xce",
    Icy: "\u0418",
    Idot: "\u0130",
    Ifr: "\u2111",
    Igrave: "\xcc",
    Im: "\u2111",
    Imacr: "\u012A",
    ImaginaryI: "\u2148",
    Implies: "\u21D2",
    Int: "\u222C",
    Integral: "\u222B",
    Intersection: "\u22C2",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    Iogon: "\u012E",
    Iopf: "\uD835\uDD40",
    Iota: "\u0399",
    Iscr: "\u2110",
    Itilde: "\u0128",
    Iukcy: "\u0406",
    Iuml: "\xcf",
    Jcirc: "\u0134",
    Jcy: "\u0419",
    Jfr: "\uD835\uDD0D",
    Jopf: "\uD835\uDD41",
    Jscr: "\uD835\uDCA5",
    Jsercy: "\u0408",
    Jukcy: "\u0404",
    KHcy: "\u0425",
    KJcy: "\u040C",
    Kappa: "\u039A",
    Kcedil: "\u0136",
    Kcy: "\u041A",
    Kfr: "\uD835\uDD0E",
    Kopf: "\uD835\uDD42",
    Kscr: "\uD835\uDCA6",
    LJcy: "\u0409",
    LT: '<',
    Lacute: "\u0139",
    Lambda: "\u039B",
    Lang: "\u27EA",
    Laplacetrf: "\u2112",
    Larr: "\u219E",
    Lcaron: "\u013D",
    Lcedil: "\u013B",
    Lcy: "\u041B",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    LeftRightArrow: "\u2194",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    Leftarrow: "\u21D0",
    Leftrightarrow: "\u21D4",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    LessLess: "\u2AA1",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    Lfr: "\uD835\uDD0F",
    Ll: "\u22D8",
    Lleftarrow: "\u21DA",
    Lmidot: "\u013F",
    LongLeftArrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    LongRightArrow: "\u27F6",
    Longleftarrow: "\u27F8",
    Longleftrightarrow: "\u27FA",
    Longrightarrow: "\u27F9",
    Lopf: "\uD835\uDD43",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    Lscr: "\u2112",
    Lsh: "\u21B0",
    Lstrok: "\u0141",
    Lt: "\u226A",
    Map: "\u2905",
    Mcy: "\u041C",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    MinusPlus: "\u2213",
    Mopf: "\uD835\uDD44",
    Mscr: "\u2133",
    Mu: "\u039C",
    NJcy: "\u040A",
    Nacute: "\u0143",
    Ncaron: "\u0147",
    Ncedil: "\u0145",
    Ncy: "\u041D",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: '\n',
    Nfr: "\uD835\uDD11",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    Not: "\u2AEC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    Nscr: "\uD835\uDCA9",
    Ntilde: "\xd1",
    Nu: "\u039D",
    OElig: "\u0152",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Ocy: "\u041E",
    Odblac: "\u0150",
    Ofr: "\uD835\uDD12",
    Ograve: "\xd2",
    Omacr: "\u014C",
    Omega: "\u03A9",
    Omicron: "\u039F",
    Oopf: "\uD835\uDD46",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    Or: "\u2A54",
    Oscr: "\uD835\uDCAA",
    Oslash: "\xd8",
    Otilde: "\xd5",
    Otimes: "\u2A37",
    Ouml: "\xd6",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    PartialD: "\u2202",
    Pcy: "\u041F",
    Pfr: "\uD835\uDD13",
    Phi: "\u03A6",
    Pi: "\u03A0",
    PlusMinus: "\xb1",
    Poincareplane: "\u210C",
    Popf: "\u2119",
    Pr: "\u2ABB",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    Prime: "\u2033",
    Product: "\u220F",
    Proportion: "\u2237",
    Proportional: "\u221D",
    Pscr: "\uD835\uDCAB",
    Psi: "\u03A8",
    QUOT: '"',
    Qfr: "\uD835\uDD14",
    Qopf: "\u211A",
    Qscr: "\uD835\uDCAC",
    RBarr: "\u2910",
    REG: "\xae",
    Racute: "\u0154",
    Rang: "\u27EB",
    Rarr: "\u21A0",
    Rarrtl: "\u2916",
    Rcaron: "\u0158",
    Rcedil: "\u0156",
    Rcy: "\u0420",
    Re: "\u211C",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    Rfr: "\u211C",
    Rho: "\u03A1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    Rightarrow: "\u21D2",
    Ropf: "\u211D",
    RoundImplies: "\u2970",
    Rrightarrow: "\u21DB",
    Rscr: "\u211B",
    Rsh: "\u21B1",
    RuleDelayed: "\u29F4",
    SHCHcy: "\u0429",
    SHcy: "\u0428",
    SOFTcy: "\u042C",
    Sacute: "\u015A",
    Sc: "\u2ABC",
    Scaron: "\u0160",
    Scedil: "\u015E",
    Scirc: "\u015C",
    Scy: "\u0421",
    Sfr: "\uD835\uDD16",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    Sigma: "\u03A3",
    SmallCircle: "\u2218",
    Sopf: "\uD835\uDD4A",
    Sqrt: "\u221A",
    Square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    Sscr: "\uD835\uDCAE",
    Star: "\u22C6",
    Sub: "\u22D0",
    Subset: "\u22D0",
    SubsetEqual: "\u2286",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    Sup: "\u22D1",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    Supset: "\u22D1",
    THORN: "\xde",
    TRADE: "\u2122",
    TSHcy: "\u040B",
    TScy: "\u0426",
    Tab: '\t',
    Tau: "\u03A4",
    Tcaron: "\u0164",
    Tcedil: "\u0162",
    Tcy: "\u0422",
    Tfr: "\uD835\uDD17",
    Therefore: "\u2234",
    Theta: "\u0398",
    ThickSpace: "\u205F\u200A",
    ThinSpace: "\u2009",
    Tilde: "\u223C",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    Topf: "\uD835\uDD4B",
    TripleDot: "\u20DB",
    Tscr: "\uD835\uDCAF",
    Tstrok: "\u0166",
    Uacute: "\xda",
    Uarr: "\u219F",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    Ubreve: "\u016C",
    Ucirc: "\xdb",
    Ucy: "\u0423",
    Udblac: "\u0170",
    Ufr: "\uD835\uDD18",
    Ugrave: "\xd9",
    Umacr: "\u016A",
    UnderBar: '_',
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    Uopf: "\uD835\uDD4C",
    UpArrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    UpEquilibrium: "\u296E",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    Uparrow: "\u21D1",
    Updownarrow: "\u21D5",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    Upsilon: "\u03A5",
    Uring: "\u016E",
    Uscr: "\uD835\uDCB0",
    Utilde: "\u0168",
    Uuml: "\xdc",
    VDash: "\u22AB",
    Vbar: "\u2AEB",
    Vcy: "\u0412",
    Vdash: "\u22A9",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    Verbar: "\u2016",
    Vert: "\u2016",
    VerticalBar: "\u2223",
    VerticalLine: '|',
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    Vopf: "\uD835\uDD4D",
    Vscr: "\uD835\uDCB1",
    Vvdash: "\u22AA",
    Wcirc: "\u0174",
    Wedge: "\u22C0",
    Wfr: "\uD835\uDD1A",
    Wopf: "\uD835\uDD4E",
    Wscr: "\uD835\uDCB2",
    Xfr: "\uD835\uDD1B",
    Xi: "\u039E",
    Xopf: "\uD835\uDD4F",
    Xscr: "\uD835\uDCB3",
    YAcy: "\u042F",
    YIcy: "\u0407",
    YUcy: "\u042E",
    Yacute: "\xdd",
    Ycirc: "\u0176",
    Ycy: "\u042B",
    Yfr: "\uD835\uDD1C",
    Yopf: "\uD835\uDD50",
    Yscr: "\uD835\uDCB4",
    Yuml: "\u0178",
    ZHcy: "\u0416",
    Zacute: "\u0179",
    Zcaron: "\u017D",
    Zcy: "\u0417",
    Zdot: "\u017B",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    Zfr: "\u2128",
    Zopf: "\u2124",
    Zscr: "\uD835\uDCB5",
    aacute: "\xe1",
    abreve: "\u0103",
    ac: "\u223E",
    acE: "\u223E\u0333",
    acd: "\u223F",
    acirc: "\xe2",
    acute: "\xb4",
    acy: "\u0430",
    aelig: "\xe6",
    af: "\u2061",
    afr: "\uD835\uDD1E",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    alpha: "\u03B1",
    amacr: "\u0101",
    amalg: "\u2A3F",
    amp: '&',
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    aogon: "\u0105",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apE: "\u2A70",
    apacir: "\u2A6F",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    approx: "\u2248",
    approxeq: "\u224A",
    aring: "\xe5",
    ascr: "\uD835\uDCB6",
    ast: '*',
    asymp: "\u2248",
    asympeq: "\u224D",
    atilde: "\xe3",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    bNot: "\u2AED",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    barvee: "\u22BD",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bnot: "\u2310",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxDL: "\u2557",
    boxDR: "\u2554",
    boxDl: "\u2556",
    boxDr: "\u2553",
    boxH: "\u2550",
    boxHD: "\u2566",
    boxHU: "\u2569",
    boxHd: "\u2564",
    boxHu: "\u2567",
    boxUL: "\u255D",
    boxUR: "\u255A",
    boxUl: "\u255C",
    boxUr: "\u2559",
    boxV: "\u2551",
    boxVH: "\u256C",
    boxVL: "\u2563",
    boxVR: "\u2560",
    boxVh: "\u256B",
    boxVl: "\u2562",
    boxVr: "\u255F",
    boxbox: "\u29C9",
    boxdL: "\u2555",
    boxdR: "\u2552",
    boxdl: "\u2510",
    boxdr: "\u250C",
    boxh: "\u2500",
    boxhD: "\u2565",
    boxhU: "\u2568",
    boxhd: "\u252C",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxuL: "\u255B",
    boxuR: "\u2558",
    boxul: "\u2518",
    boxur: "\u2514",
    boxv: "\u2502",
    boxvH: "\u256A",
    boxvL: "\u2561",
    boxvR: "\u255E",
    boxvh: "\u253C",
    boxvl: "\u2524",
    boxvr: "\u251C",
    bprime: "\u2035",
    breve: "\u02D8",
    brvbar: "\xa6",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: '\\',
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    bumpeq: "\u224F",
    cacute: "\u0107",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    ccaps: "\u2A4D",
    ccaron: "\u010D",
    ccedil: "\xe7",
    ccirc: "\u0109",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    cdot: "\u010B",
    cedil: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    centerdot: "\xb7",
    cfr: "\uD835\uDD20",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    chi: "\u03C7",
    cir: "\u25CB",
    cirE: "\u29C3",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledR: "\xae",
    circledS: "\u24C8",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    clubs: "\u2663",
    clubsuit: "\u2663",
    colon: ':',
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ',',
    commat: '@',
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    conint: "\u222E",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    copy: "\xa9",
    copysr: "\u2117",
    crarr: "\u21B5",
    cross: "\u2717",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    dArr: "\u21D3",
    dHar: "\u2965",
    dagger: "\u2020",
    daleth: "\u2138",
    darr: "\u2193",
    dash: "\u2010",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    dcaron: "\u010F",
    dcy: "\u0434",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    ddotseq: "\u2A77",
    deg: "\xb0",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    dfr: "\uD835\uDD21",
    dharl: "\u21C3",
    dharr: "\u21C2",
    diam: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: '$',
    dopf: "\uD835\uDD55",
    dot: "\u02D9",
    doteq: "\u2250",
    doteqdot: "\u2251",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    downarrow: "\u2193",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    dscr: "\uD835\uDCB9",
    dscy: "\u0455",
    dsol: "\u29F6",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    eDDot: "\u2A77",
    eDot: "\u2251",
    eacute: "\xe9",
    easter: "\u2A6E",
    ecaron: "\u011B",
    ecir: "\u2256",
    ecirc: "\xea",
    ecolon: "\u2255",
    ecy: "\u044D",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    emptyv: "\u2205",
    emsp13: "\u2004",
    emsp14: "\u2005",
    emsp: "\u2003",
    eng: "\u014B",
    ensp: "\u2002",
    eogon: "\u0119",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    equals: '=',
    equest: "\u225F",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erDot: "\u2253",
    erarr: "\u2971",
    escr: "\u212F",
    esdot: "\u2250",
    esim: "\u2242",
    eta: "\u03B7",
    eth: "\xf0",
    euml: "\xeb",
    euro: "\u20AC",
    excl: '!',
    exist: "\u2203",
    expectation: "\u2130",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    fjlig: 'fj',
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    fopf: "\uD835\uDD57",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    fscr: "\uD835\uDCBB",
    gE: "\u2267",
    gEl: "\u2A8C",
    gacute: "\u01F5",
    gamma: "\u03B3",
    gammad: "\u03DD",
    gap: "\u2A86",
    gbreve: "\u011F",
    gcirc: "\u011D",
    gcy: "\u0433",
    gdot: "\u0121",
    ge: "\u2265",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    gfr: "\uD835\uDD24",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    gjcy: "\u0453",
    gl: "\u2277",
    glE: "\u2A92",
    gla: "\u2AA5",
    glj: "\u2AA4",
    gnE: "\u2269",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    gopf: "\uD835\uDD58",
    grave: '`',
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    gt: '>',
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    hArr: "\u21D4",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    hardcy: "\u044A",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    hbar: "\u210F",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    hfr: "\uD835\uDD25",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    hstrok: "\u0127",
    hybull: "\u2043",
    hyphen: "\u2010",
    iacute: "\xed",
    ic: "\u2063",
    icirc: "\xee",
    icy: "\u0438",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    ifr: "\uD835\uDD26",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    ijlig: "\u0133",
    imacr: "\u012B",
    image: "\u2111",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    intercal: "\u22BA",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    iocy: "\u0451",
    iogon: "\u012F",
    iopf: "\uD835\uDD5A",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isinE: "\u22F9",
    isindot: "\u22F5",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    itilde: "\u0129",
    iukcy: "\u0456",
    iuml: "\xef",
    jcirc: "\u0135",
    jcy: "\u0439",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    jopf: "\uD835\uDD5B",
    jscr: "\uD835\uDCBF",
    jsercy: "\u0458",
    jukcy: "\u0454",
    kappa: "\u03BA",
    kappav: "\u03F0",
    kcedil: "\u0137",
    kcy: "\u043A",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    khcy: "\u0445",
    kjcy: "\u045C",
    kopf: "\uD835\uDD5C",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    lArr: "\u21D0",
    lAtail: "\u291B",
    lBarr: "\u290E",
    lE: "\u2266",
    lEg: "\u2A8B",
    lHar: "\u2962",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    lambda: "\u03BB",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    laquo: "\xab",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: '{',
    lbrack: '[',
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    lcaron: "\u013E",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: '{',
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    le: "\u2264",
    leftarrow: "\u2190",
    leftarrowtail: "\u21A2",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    leftthreetimes: "\u22CB",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    lessgtr: "\u2276",
    lesssim: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    ljcy: "\u0459",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    llhard: "\u296B",
    lltri: "\u25FA",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnE: "\u2268",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    longleftarrow: "\u27F5",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: '_',
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: '(',
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    lscr: "\uD835\uDCC1",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: '[',
    lsquo: "\u2018",
    lsquor: "\u201A",
    lstrok: "\u0142",
    lt: '<',
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltrPar: "\u2996",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    mDDot: "\u223A",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    mcy: "\u043C",
    mdash: "\u2014",
    measuredangle: "\u2221",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: '*',
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nGg: "\u22D9\u0338",
    nGt: "\u226B\u20D2",
    nGtv: "\u226B\u0338",
    nLeftarrow: "\u21CD",
    nLeftrightarrow: "\u21CE",
    nLl: "\u22D8\u0338",
    nLt: "\u226A\u20D2",
    nLtv: "\u226A\u0338",
    nRightarrow: "\u21CF",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nabla: "\u2207",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    ncaron: "\u0148",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    neArr: "\u21D7",
    nearhk: "\u2924",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    nexist: "\u2204",
    nexists: "\u2204",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    ngsim: "\u2275",
    ngt: "\u226F",
    ngtr: "\u226F",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlE: "\u2266\u0338",
    nlarr: "\u219A",
    nldr: "\u2025",
    nle: "\u2270",
    nleftarrow: "\u219A",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nlsim: "\u2274",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nmid: "\u2224",
    nopf: "\uD835\uDD5F",
    not: "\xac",
    notin: "\u2209",
    notinE: "\u22F9\u0338",
    notindot: "\u22F5\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    nu: "\u03BD",
    num: '#',
    numero: "\u2116",
    numsp: "\u2007",
    nvDash: "\u22AD",
    nvHarr: "\u2904",
    nvap: "\u224D\u20D2",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwArr: "\u21D6",
    nwarhk: "\u2923",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    oS: "\u24C8",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    ocirc: "\xf4",
    ocy: "\u043E",
    odash: "\u229D",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    oelig: "\u0153",
    ofcir: "\u29BF",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    omacr: "\u014D",
    omega: "\u03C9",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    operp: "\u29B9",
    oplus: "\u2295",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oscr: "\u2134",
    oslash: "\xf8",
    osol: "\u2298",
    otilde: "\xf5",
    otimes: "\u2297",
    otimesas: "\u2A36",
    ouml: "\xf6",
    ovbar: "\u233D",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    pcy: "\u043F",
    percnt: '%',
    period: '.',
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    pfr: "\uD835\uDD2D",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: '+',
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    pointint: "\u2A15",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    pr: "\u227A",
    prE: "\u2AB3",
    prap: "\u2AB7",
    prcue: "\u227C",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    prime: "\u2032",
    primes: "\u2119",
    prnE: "\u2AB5",
    prnap: "\u2AB9",
    prnsim: "\u22E8",
    prod: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    pscr: "\uD835\uDCC5",
    psi: "\u03C8",
    puncsp: "\u2008",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: '?',
    questeq: "\u225F",
    quot: '"',
    rAarr: "\u21DB",
    rArr: "\u21D2",
    rAtail: "\u291C",
    rBarr: "\u290F",
    rHar: "\u2964",
    race: "\u223D\u0331",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: '}',
    rbrack: ']',
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    rcaron: "\u0159",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: '}',
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    reg: "\xae",
    rfisht: "\u297D",
    rfloor: "\u230B",
    rfr: "\uD835\uDD2F",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    rho: "\u03C1",
    rhov: "\u03F1",
    rightarrow: "\u2192",
    rightarrowtail: "\u21A3",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    rightthreetimes: "\u22CC",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    rpar: ')',
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    rsaquo: "\u203A",
    rscr: "\uD835\uDCC7",
    rsh: "\u21B1",
    rsqb: ']',
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    ruluhar: "\u2968",
    rx: "\u211E",
    sacute: "\u015B",
    sbquo: "\u201A",
    sc: "\u227B",
    scE: "\u2AB4",
    scap: "\u2AB8",
    scaron: "\u0161",
    sccue: "\u227D",
    sce: "\u2AB0",
    scedil: "\u015F",
    scirc: "\u015D",
    scnE: "\u2AB6",
    scnap: "\u2ABA",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    seArr: "\u21D8",
    searhk: "\u2925",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ';',
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    shchcy: "\u0449",
    shcy: "\u0448",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    shy: "\xad",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    softcy: "\u044C",
    sol: '/',
    solb: "\u29C4",
    solbar: "\u233F",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    square: "\u25A1",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    sub: "\u2282",
    subE: "\u2AC5",
    subdot: "\u2ABD",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    sum: "\u2211",
    sung: "\u266A",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    sup: "\u2283",
    supE: "\u2AC6",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supe: "\u2287",
    supedot: "\u2AC4",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swArr: "\u21D9",
    swarhk: "\u2926",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    target: "\u2316",
    tau: "\u03C4",
    tbrk: "\u23B4",
    tcaron: "\u0165",
    tcedil: "\u0163",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    therefore: "\u2234",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    thinsp: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    thorn: "\xfe",
    tilde: "\u02DC",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    tscr: "\uD835\uDCC9",
    tscy: "\u0446",
    tshcy: "\u045B",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    uArr: "\u21D1",
    uHar: "\u2963",
    uacute: "\xfa",
    uarr: "\u2191",
    ubrcy: "\u045E",
    ubreve: "\u016D",
    ucirc: "\xfb",
    ucy: "\u0443",
    udarr: "\u21C5",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    ufr: "\uD835\uDD32",
    ugrave: "\xf9",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    umacr: "\u016B",
    uml: "\xa8",
    uogon: "\u0173",
    uopf: "\uD835\uDD66",
    uparrow: "\u2191",
    updownarrow: "\u2195",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    upsi: "\u03C5",
    upsih: "\u03D2",
    upsilon: "\u03C5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    uring: "\u016F",
    urtri: "\u25F9",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vArr: "\u21D5",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    vDash: "\u22A8",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    vcy: "\u0432",
    vdash: "\u22A2",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    verbar: '|',
    vert: '|',
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    vzigzag: "\u299A",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    wfr: "\uD835\uDD34",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    yacute: "\xfd",
    yacy: "\u044F",
    ycirc: "\u0177",
    ycy: "\u044B",
    yen: "\xa5",
    yfr: "\uD835\uDD36",
    yicy: "\u0457",
    yopf: "\uD835\uDD6A",
    yscr: "\uD835\uDCCE",
    yucy: "\u044E",
    yuml: "\xff",
    zacute: "\u017A",
    zcaron: "\u017E",
    zcy: "\u0437",
    zdot: "\u017C",
    zeetrf: "\u2128",
    zeta: "\u03B6",
    zfr: "\uD835\uDD37",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    zopf: "\uD835\uDD6B",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
};


// To do: next major: use `Object.hasOwn`.
const $734902b983770639$var$own = {}.hasOwnProperty;
function $734902b983770639$export$289b6a6320f709b4(value) {
    return $734902b983770639$var$own.call((0, $082eea842a54ecda$export$ec810d1aafce79a7), value) ? (0, $082eea842a54ecda$export$ec810d1aafce79a7)[value] : false;
}



const $00fe69b047057e21$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $00fe69b047057e21$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $00fe69b047057e21$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('characterReference');
        effects.enter('characterReferenceMarker');
        effects.consume(code);
        effects.exit('characterReferenceMarker');
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter('characterReferenceMarkerNumeric');
            effects.consume(code);
            effects.exit('characterReferenceMarkerNumeric');
            return numeric;
        }
        effects.enter('characterReferenceValue');
        max = 31;
        test = (0, $0e0efac6dff74a8f$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter('characterReferenceMarkerHexadecimal');
            effects.consume(code);
            effects.exit('characterReferenceMarkerHexadecimal');
            effects.enter('characterReferenceValue');
            max = 6;
            test = (0, $0e0efac6dff74a8f$export$eca2752363989806);
            return value;
        }
        effects.enter('characterReferenceValue');
        max = 7;
        test = (0, $0e0efac6dff74a8f$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit('characterReferenceValue');
            if (test === (0, $0e0efac6dff74a8f$export$75c76db11865a9f4) && !(0, $734902b983770639$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter('characterReferenceMarker');
            effects.consume(code);
            effects.exit('characterReferenceMarker');
            effects.exit('characterReference');
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $9187b09b56472dee$var$nonLazyContinuation = {
    tokenize: $9187b09b56472dee$var$tokenizeNonLazyContinuation,
    partial: true
};
const $9187b09b56472dee$export$c23e4921f8d87e7c = {
    name: 'codeFenced',
    tokenize: $9187b09b56472dee$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9187b09b56472dee$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === 'linePrefix' ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter('codeFenced');
        effects.enter('codeFencedFence');
        effects.enter('codeFencedFenceSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit('codeFencedFenceSequence');
        return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, infoBefore, 'whitespace')(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFencedFence');
            return self.interrupt ? ok(code) : effects.check($9187b09b56472dee$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter('codeFencedFenceInfo');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return infoBefore(code);
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceInfo');
            return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, metaBefore, 'whitespace')(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter('codeFencedFenceMeta');
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            effects.exit('codeFencedFenceMeta');
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, beforeContentChunk, 'linePrefix', initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) return effects.check($9187b09b56472dee$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter('codeFlowValue');
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFlowValue');
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit('codeFenced');
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter('codeFencedFence');
            return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter('codeFencedFenceSequence');
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit('codeFencedFenceSequence');
                return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, 'whitespace')(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
                effects.exit('codeFencedFence');
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9187b09b56472dee$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $6e144c9fca93ae94$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $6e144c9fca93ae94$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $6e144c9fca93ae94$var$furtherStart = {
    tokenize: $6e144c9fca93ae94$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6e144c9fca93ae94$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter('codeIndented');
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, afterPrefix, 'linePrefix', 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) return effects.attempt($6e144c9fca93ae94$var$furtherStart, atBreak, after)(code);
        effects.enter('codeFlowValue');
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('codeFlowValue');
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit('codeIndented');
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6e144c9fca93ae94$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, afterPrefix, 'linePrefix', 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'linePrefix' && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $58b19d1b9032d781$export$d24f93e715f9df88 = {
    name: 'codeText',
    tokenize: $58b19d1b9032d781$var$tokenizeCodeText,
    resolve: $58b19d1b9032d781$var$resolveCodeText,
    previous: $58b19d1b9032d781$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $58b19d1b9032d781$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === 'lineEnding' || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === 'lineEnding' || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === 'codeTextData') {
            // Then we have padding.
            events[headEnterIndex][1].type = 'codeTextPadding';
            events[tailExitIndex][1].type = 'codeTextPadding';
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== 'lineEnding') enter = index;
        } else if (index === tailExitIndex || events[index][1].type === 'lineEnding') {
            events[enter][1].type = 'codeTextData';
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $58b19d1b9032d781$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === 'characterEscape';
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $58b19d1b9032d781$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('codeText');
        effects.enter('codeTextSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit('codeTextSequence');
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter('codeTextSequence');
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return between;
        }
        // Data.
        effects.enter('codeTextData');
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('codeTextData');
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit('codeTextSequence');
            effects.exit('codeText');
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = 'codeTextData';
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $3448837652743de7$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $0e0efac6dff74a8f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit('chunkString');
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code))) {
            effects.exit('chunkString');
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $0e0efac6dff74a8f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $085d77918cb094ce$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return atBreak;
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $f45edd17b1387428$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, atBreak, 'linePrefix');
        }
        effects.enter('chunkString', {
            contentType: 'string'
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('chunkString');
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $2228285dc419c682$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            seen = true;
            return start;
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, start, seen ? 'linePrefix' : 'lineSuffix')(code);
        return ok(code);
    }
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $17f5554bde97fbe8$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, ' ')// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


const $00cfe910da5aa029$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $00cfe910da5aa029$var$tokenizeDefinition
};
/** @type {Construct} */ const $00cfe910da5aa029$var$titleBefore = {
    tokenize: $00cfe910da5aa029$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $00cfe910da5aa029$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter('definition');
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $085d77918cb094ce$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, 'definitionLabel', 'definitionLabelMarker', 'definitionLabelString')(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $17f5554bde97fbe8$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter('definitionMarker');
            effects.consume(code);
            effects.exit('definitionMarker');
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code) ? (0, $2228285dc419c682$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $3448837652743de7$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, 'definitionDestination', 'definitionDestinationLiteral', 'definitionDestinationLiteralMarker', 'definitionDestinationRaw', 'definitionDestinationString')(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($00cfe910da5aa029$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, afterWhitespace, 'whitespace')(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('definition');
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $00cfe910da5aa029$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code) ? (0, $2228285dc419c682$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $f45edd17b1387428$export$f970569cc855e483)(effects, titleAfter, nok, 'definitionTitle', 'definitionTitleMarker', 'definitionTitleString')(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, 'whitespace')(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $f1711030ca70bc89$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $f1711030ca70bc89$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f1711030ca70bc89$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('hardBreakEscape');
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('hardBreakEscape');
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $8da6e076ec72e157$export$3871e9deb360695c = {
    name: 'headingAtx',
    tokenize: $8da6e076ec72e157$var$tokenizeHeadingAtx,
    resolve: $8da6e076ec72e157$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $8da6e076ec72e157$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === 'whitespace') contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === 'whitespace') contentEnd -= 2;
    if (events[contentEnd][1].type === 'atxHeadingSequence' && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === 'whitespace')) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: 'atxHeadingText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: 'chunkText',
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: 'text'
        };
        (0, $d06a2a6a4e8d369a$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $8da6e076ec72e157$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter('atxHeading');
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('atxHeadingSequence');
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code)) {
            effects.exit('atxHeadingSequence');
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter('atxHeadingSequence');
            return sequenceFurther(code);
        }
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('atxHeading');
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, atBreak, 'whitespace')(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter('atxHeadingText');
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit('atxHeadingSequence');
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code)) {
            effects.exit('atxHeadingText');
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $03820b223b6d3541$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $03820b223b6d3541$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $0059e0f79553be09$export$476ac411cb7d0d8f = {
    name: 'htmlFlow',
    tokenize: $0059e0f79553be09$var$tokenizeHtmlFlow,
    resolveTo: $0059e0f79553be09$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $0059e0f79553be09$var$blankLineBefore = {
    tokenize: $0059e0f79553be09$var$tokenizeBlankLineBefore,
    partial: true
};
const $0059e0f79553be09$var$nonLazyContinuationStart = {
    tokenize: $0059e0f79553be09$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $0059e0f79553be09$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === 'htmlFlow') break;
    }
    if (index > 1 && events[index - 2][1].type === 'linePrefix') {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0059e0f79553be09$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('htmlFlow');
        effects.enter('htmlFlowData');
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = 'CDATA[';
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $03820b223b6d3541$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $03820b223b6d3541$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit('htmlFlowData');
            return effects.check($0059e0f79553be09$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('htmlFlowData');
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($0059e0f79553be09$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter('htmlFlowData');
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $03820b223b6d3541$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('htmlFlowData');
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit('htmlFlow');
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0059e0f79553be09$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.enter('lineEnding');
            effects.consume(code);
            effects.exit('lineEnding');
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0059e0f79553be09$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return effects.attempt((0, $076254b4b7f28510$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $ae3f7214b26cfc88$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $ae3f7214b26cfc88$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ae3f7214b26cfc88$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('htmlText');
        effects.enter('htmlTextData');
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = 'CDATA[';
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $0e0efac6dff74a8f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit('htmlTextData');
            effects.exit('htmlText');
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit('htmlTextData');
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter('htmlTextData');
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $50b0dc4a98ffc0e2$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    tokenize: $50b0dc4a98ffc0e2$var$tokenizeLabelEnd,
    resolveTo: $50b0dc4a98ffc0e2$var$resolveToLabelEnd,
    resolveAll: $50b0dc4a98ffc0e2$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $50b0dc4a98ffc0e2$var$resourceConstruct = {
    tokenize: $50b0dc4a98ffc0e2$var$tokenizeResource
};
/** @type {Construct} */ const $50b0dc4a98ffc0e2$var$referenceFullConstruct = {
    tokenize: $50b0dc4a98ffc0e2$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $50b0dc4a98ffc0e2$var$referenceCollapsedConstruct = {
    tokenize: $50b0dc4a98ffc0e2$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $50b0dc4a98ffc0e2$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === 'labelImage' || token.type === 'labelLink' || token.type === 'labelEnd') {
            // Remove the marker.
            events.splice(index + 1, token.type === 'labelImage' ? 4 : 2);
            token.type = 'data';
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $50b0dc4a98ffc0e2$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === 'link' || token.type === 'labelLink' && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === 'labelLink') token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === 'labelImage' || token.type === 'labelLink') && !token._balanced) {
                open = index;
                if (token.type !== 'labelLink') {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === 'labelEnd') close = index;
    }
    const group = {
        type: events[open][1].type === 'labelLink' ? 'link' : 'image',
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: 'label',
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: 'labelText',
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(media, (0, $7e72526cb55d43c6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $d06a2a6a4e8d369a$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $d06a2a6a4e8d369a$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $50b0dc4a98ffc0e2$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === 'labelImage' || self.events[index][1].type === 'labelLink') && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $17f5554bde97fbe8$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter('labelEnd');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelEnd');
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($50b0dc4a98ffc0e2$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($50b0dc4a98ffc0e2$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($50b0dc4a98ffc0e2$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $50b0dc4a98ffc0e2$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter('resource');
        effects.enter('resourceMarker');
        effects.consume(code);
        effects.exit('resourceMarker');
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code) ? (0, $2228285dc419c682$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $3448837652743de7$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, 'resourceDestination', 'resourceDestinationLiteral', 'resourceDestinationLiteralMarker', 'resourceDestinationRaw', 'resourceDestinationString', 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code) ? (0, $2228285dc419c682$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $f45edd17b1387428$export$f970569cc855e483)(effects, resourceTitleAfter, nok, 'resourceTitle', 'resourceTitleMarker', 'resourceTitleString')(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $0e0efac6dff74a8f$export$a30284361b3814b7)(code) ? (0, $2228285dc419c682$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter('resourceMarker');
            effects.consume(code);
            effects.exit('resourceMarker');
            effects.exit('resource');
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $50b0dc4a98ffc0e2$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $085d77918cb094ce$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, 'reference', 'referenceMarker', 'referenceString')(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $17f5554bde97fbe8$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $50b0dc4a98ffc0e2$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter('reference');
        effects.enter('referenceMarker');
        effects.consume(code);
        effects.exit('referenceMarker');
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter('referenceMarker');
            effects.consume(code);
            effects.exit('referenceMarker');
            effects.exit('reference');
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $83c5ba956d75ddb5$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    tokenize: $83c5ba956d75ddb5$var$tokenizeLabelStartImage,
    resolveAll: (0, $50b0dc4a98ffc0e2$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $83c5ba956d75ddb5$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('labelImage');
        effects.enter('labelImageMarker');
        effects.consume(code);
        effects.exit('labelImageMarker');
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter('labelMarker');
            effects.consume(code);
            effects.exit('labelMarker');
            effects.exit('labelImage');
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $a84fbe226dfb7f24$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    tokenize: $a84fbe226dfb7f24$var$tokenizeLabelStartLink,
    resolveAll: (0, $50b0dc4a98ffc0e2$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a84fbe226dfb7f24$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('labelLink');
        effects.enter('labelMarker');
        effects.consume(code);
        effects.exit('labelMarker');
        effects.exit('labelLink');
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $4527b7d88d5e09fb$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $4527b7d88d5e09fb$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4527b7d88d5e09fb$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter('lineEnding');
        effects.consume(code);
        effects.exit('lineEnding');
        return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, ok, 'linePrefix');
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $29159c39c7b4b2ed$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $29159c39c7b4b2ed$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $29159c39c7b4b2ed$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter('thematicBreak');
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter('thematicBreakSequence');
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code))) {
            effects.exit('thematicBreak');
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit('thematicBreakSequence');
        return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, atBreak, 'whitespace')(code) : atBreak(code);
    }
}


const $5ca32a49483ece74$export$8837f4fc672e936d = {
    name: 'list',
    tokenize: $5ca32a49483ece74$var$tokenizeListStart,
    continuation: {
        tokenize: $5ca32a49483ece74$var$tokenizeListContinuation
    },
    exit: $5ca32a49483ece74$var$tokenizeListEnd
};
/** @type {Construct} */ const $5ca32a49483ece74$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $5ca32a49483ece74$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $5ca32a49483ece74$var$indentConstruct = {
    tokenize: $5ca32a49483ece74$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $5ca32a49483ece74$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === 'linePrefix' ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? 'listUnordered' : 'listOrdered');
        if (kind === 'listUnordered' ? !self.containerState.marker || code === self.containerState.marker : (0, $0e0efac6dff74a8f$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === 'listUnordered') {
                effects.enter('listItemPrefix');
                return code === 42 || code === 45 ? effects.check((0, $29159c39c7b4b2ed$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter('listItemPrefix');
                effects.enter('listItemValue');
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $0e0efac6dff74a8f$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit('listItemValue');
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter('listItemMarker');
        effects.consume(code);
        effects.exit('listItemMarker');
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $076254b4b7f28510$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($5ca32a49483ece74$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            effects.enter('listItemPrefixWhitespace');
            effects.consume(code);
            effects.exit('listItemPrefixWhitespace');
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit('listItemPrefix'), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $5ca32a49483ece74$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $076254b4b7f28510$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, ok, 'listItemIndent', self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($5ca32a49483ece74$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, effects.attempt($5ca32a49483ece74$export$8837f4fc672e936d, ok, nok), 'linePrefix', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $5ca32a49483ece74$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, afterPrefix, 'listItemIndent', self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === 'listItemIndent' && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $5ca32a49483ece74$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $5ca32a49483ece74$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, afterPrefix, 'listItemPrefixWhitespace', self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) && tail && tail[1].type === 'listItemPrefixWhitespace' ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $49e8b2437a5fb2e7$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    tokenize: $49e8b2437a5fb2e7$var$tokenizeSetextUnderline,
    resolveTo: $49e8b2437a5fb2e7$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $49e8b2437a5fb2e7$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === 'content') {
            content = index;
            break;
        }
        if (events[index][1].type === 'paragraph') text = index;
    } else {
        if (events[index][1].type === 'content') // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === 'definition') definition = index;
    }
    const heading = {
        type: 'setextHeading',
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = 'setextHeadingText';
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $49e8b2437a5fb2e7$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== 'lineEnding' && self.events[index][1].type !== 'linePrefix' && self.events[index][1].type !== 'content') {
            paragraph = self.events[index][1].type === 'paragraph';
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter('setextHeadingLine');
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter('setextHeadingLineSequence');
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit('setextHeadingLineSequence');
        return (0, $0e0efac6dff74a8f$export$2c6cf65c1127992a)(code) ? (0, $a05c2eee5bad6ea2$export$ae105c1eb063a0a2)(effects, after, 'lineSuffix')(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $0e0efac6dff74a8f$export$34a1dff1c0936953)(code)) {
            effects.exit('setextHeadingLine');
            return ok(code);
        }
        return nok(code);
    }
}



const $65765e65ab996dda$export$5a7bfc01df82fcd1 = {
    [42]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [43]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [45]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [48]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [49]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [50]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [51]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [52]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [53]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [54]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [55]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [56]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [57]: (0, $5ca32a49483ece74$export$8837f4fc672e936d),
    [62]: (0, $6f214667b226e36f$export$200dcd0a5903c968)
};
const $65765e65ab996dda$export$5a2181fb44b58173 = {
    [91]: (0, $00cfe910da5aa029$export$69f215ed977cdb73)
};
const $65765e65ab996dda$export$cf8bead395eff824 = {
    [-2]: (0, $6e144c9fca93ae94$export$47910b7ab28d1853),
    [-1]: (0, $6e144c9fca93ae94$export$47910b7ab28d1853),
    [32]: (0, $6e144c9fca93ae94$export$47910b7ab28d1853)
};
const $65765e65ab996dda$export$ccc7b0636abaffc3 = {
    [35]: (0, $8da6e076ec72e157$export$3871e9deb360695c),
    [42]: (0, $29159c39c7b4b2ed$export$ba7b13e047416c03),
    [45]: [
        (0, $49e8b2437a5fb2e7$export$e104e2de391dfde9),
        (0, $29159c39c7b4b2ed$export$ba7b13e047416c03)
    ],
    [60]: (0, $0059e0f79553be09$export$476ac411cb7d0d8f),
    [61]: (0, $49e8b2437a5fb2e7$export$e104e2de391dfde9),
    [95]: (0, $29159c39c7b4b2ed$export$ba7b13e047416c03),
    [96]: (0, $9187b09b56472dee$export$c23e4921f8d87e7c),
    [126]: (0, $9187b09b56472dee$export$c23e4921f8d87e7c)
};
const $65765e65ab996dda$export$22b082955e083ec3 = {
    [38]: (0, $00fe69b047057e21$export$e31905600aaf3d8e),
    [92]: (0, $948a96e1c6f62fdc$export$2005478564e78d96)
};
const $65765e65ab996dda$export$6f093cfa640b7166 = {
    [-5]: (0, $4527b7d88d5e09fb$export$8e62e0ad51c97b2),
    [-4]: (0, $4527b7d88d5e09fb$export$8e62e0ad51c97b2),
    [-3]: (0, $4527b7d88d5e09fb$export$8e62e0ad51c97b2),
    [33]: (0, $83c5ba956d75ddb5$export$3d754936e25aa5f5),
    [38]: (0, $00fe69b047057e21$export$e31905600aaf3d8e),
    [42]: (0, $7f03a73b7c5efa5e$export$45b92471da762af7),
    [60]: [
        (0, $e16146206eb2750a$export$17ddf85e4c916ad6),
        (0, $ae3f7214b26cfc88$export$398af27f284914fe)
    ],
    [91]: (0, $a84fbe226dfb7f24$export$5c0cee0701a3b584),
    [92]: [
        (0, $f1711030ca70bc89$export$86c573ab9e06f418),
        (0, $948a96e1c6f62fdc$export$2005478564e78d96)
    ],
    [93]: (0, $50b0dc4a98ffc0e2$export$470a5dafbbf62654),
    [95]: (0, $7f03a73b7c5efa5e$export$45b92471da762af7),
    [96]: (0, $58b19d1b9032d781$export$d24f93e715f9df88)
};
const $65765e65ab996dda$export$d44f260a3f9b69f5 = {
    null: [
        (0, $7f03a73b7c5efa5e$export$45b92471da762af7),
        (0, $0fb1f790d7f753f3$export$50397835cbfdbc24)
    ]
};
const $65765e65ab996dda$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $65765e65ab996dda$export$e20fbacbb41798b = {
    null: []
};


function $2b93d67759032147$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $b1e4c4fe60fa07a2$export$86a865d89ef3c690)([
        $65765e65ab996dda$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $39e760912b01def4$export$a7db06668cad9adb)),
        document: create((0, $d2a73748e5f16937$export$5a7bfc01df82fcd1)),
        flow: create((0, $7fd74848ec51c1a3$export$ccc7b0636abaffc3)),
        string: create((0, $0fb1f790d7f753f3$export$22b082955e083ec3)),
        text: create((0, $0fb1f790d7f753f3$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $dcadfc7f857f9c95$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $4fc891641be24a0d$var$search = /[\0\t\n\r]/g;
function $4fc891641be24a0d$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        // @ts-expect-error `Buffer` does allow an encoding.
        value = buffer + value.toString(encoding);
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $4fc891641be24a0d$var$search.lastIndex = startPosition;
            match = $4fc891641be24a0d$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $6ca5a8f72012d661$export$bd0e6e1378a871d7(events) {
    while(!(0, $4332904054d5e6f6$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $34b2e722b84ddfcd$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return '\uFFFD';
    return String.fromCharCode(code);
}




const $1c5b383b5c7187a3$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $1c5b383b5c7187a3$export$a0fb664af7d0cc44(value) {
    return value.replace($1c5b383b5c7187a3$var$characterEscapeOrReference, $1c5b383b5c7187a3$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $1c5b383b5c7187a3$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $34b2e722b84ddfcd$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $734902b983770639$export$289b6a6320f709b4)($2) || $0;
}





const $f8aa679828965dd5$var$own = {}.hasOwnProperty;
const $f8aa679828965dd5$export$d744d789c09bfde6 = /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */ /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */ function(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return $f8aa679828965dd5$var$compiler(options)((0, $6ca5a8f72012d661$export$bd0e6e1378a871d7)((0, $2b93d67759032147$export$98e6a39c04603d36)(options).document().write((0, $4fc891641be24a0d$export$fc37fe19dfda43ee)()(value, encoding, true))));
};
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $f8aa679828965dd5$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $f8aa679828965dd5$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            setData: setData,
            getData: getData
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === 'listOrdered' || events[index][1].type === 'listUnordered') {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($f8aa679828965dd5$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $f8aa679828965dd5$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $f8aa679828965dd5$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $f8aa679828965dd5$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            if (event[1].type === 'listUnordered' || event[1].type === 'listOrdered' || event[1].type === 'blockQuote') {
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
                atMarker = undefined;
            } else if (event[1].type === 'lineEndingBlank') {
                if (event[0] === 'enter') {
                    if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                    atMarker = undefined;
                }
            } else if (event[1].type === 'linePrefix' || event[1].type === 'listItemValue' || event[1].type === 'listItemMarker' || event[1].type === 'listItemPrefix' || event[1].type === 'listItemPrefixWhitespace') ;
            else atMarker = undefined;
            if (!containerBalance && event[0] === 'enter' && event[1].type === 'listItemPrefix' || containerBalance === -1 && event[0] === 'exit' && (event[1].type === 'listUnordered' || event[1].type === 'listOrdered')) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === 'lineEnding' || tailEvent[1].type === 'lineEndingBlank') {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = 'lineEndingBlank';
                                listSpread = true;
                            }
                            tailEvent[1].type = 'lineEnding';
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === 'linePrefix' || tailEvent[1].type === 'blockQuotePrefix' || tailEvent[1].type === 'blockQuotePrefixWhitespace' || tailEvent[1].type === 'blockQuoteMarker' || tailEvent[1].type === 'listItemIndent') ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === 'listItemPrefix') {
                    listItem = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    // @ts-expect-error: `listItem` is most definitely defined, TS...
                    events.splice(index, 0, [
                        'enter',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Set data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @param {CompileData[Key]} [value]
   *   New value.
   * @returns {void}
   *   Nothing.
   */ function setData(key, value) {
        data[key] = value;
    }
    /**
   * Get data.
   *
   * @template {keyof CompileData} Key
   *   Field type.
   * @param {Key} key
   *   Key of field.
   * @returns {CompileData[Key]}
   *   Value.
   */ function getData(key) {
        return data[key];
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Node} create
   *   Create a node.
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {void}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @template {Node} Kind
   *   Node type.
   * @this {CompileContext}
   *   Context.
   * @param {Kind} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {Kind}
   *   The given node.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        // @ts-expect-error: Assume `Node` can exist as a child of `parent`.
        parent.children.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        // @ts-expect-error: `end` will be patched later.
        node.position = {
            start: $f8aa679828965dd5$var$point(token.start)
        };
        return node;
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {void}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {Node}
   *   The closed node.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $c2800647e46698b3$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $f8aa679828965dd5$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $f8aa679828965dd5$var$point(token.end);
        return node;
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $f93ecd636863ff21$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        setData('expectingFirstListItemValue', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectingFirstListItemValue')) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            setData('expectingFirstListItemValue');
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (getData('flowCodeInside')) return;
        this.buffer();
        setData('flowCodeInside', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        setData('flowCodeInside');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $17f5554bde97fbe8$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('setextHeadingSlurpLineEnding', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        setData('setextHeadingSlurpLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        let tail = node.children[node.children.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            // @ts-expect-error: we’ll add `end` later.
            tail.position = {
                start: $f8aa679828965dd5$var$point(token.start)
            };
            // @ts-expect-error: Assume `parent` accepts `text`.
            node.children.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $f8aa679828965dd5$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (getData('atHardBreak')) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $f8aa679828965dd5$var$point(token.end);
            setData('atHardBreak');
            return;
        }
        if (!getData('setextHeadingSlurpLineEnding') && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        setData('atHardBreak', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData('inReference')) {
            /** @type {ReferenceType} */ const referenceType = getData('referenceType') || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData('referenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (getData('inReference')) {
            /** @type {ReferenceType} */ const referenceType = getData('referenceType') || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        setData('referenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $1c5b383b5c7187a3$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $17f5554bde97fbe8$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        setData('inReference', true);
        if (node.type === 'link') {
            /** @type {Array<StaticPhrasingContent>} */ // @ts-expect-error: Assume static phrasing content.
            const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        setData('inReference');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        setData('referenceType', 'collapsed');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $17f5554bde97fbe8$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        setData('referenceType', 'full');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = getData('characterReferenceType');
        /** @type {string} */ let value;
        if (type) {
            value = (0, $34b2e722b84ddfcd$export$15a69557afac2c20)(data, type === 'characterReferenceMarkerNumeric' ? 10 : 16);
            setData('characterReferenceType');
        } else {
            const result = (0, $734902b983770639$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $f8aa679828965dd5$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        // @ts-expect-error `depth` will be set later.
        return {
            type: 'heading',
            depth: undefined,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {HTML} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $f8aa679828965dd5$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Extension | Array<Extension>>} extensions
 * @returns {void}
 */ function $f8aa679828965dd5$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $f8aa679828965dd5$var$configure(combined, value);
        else $f8aa679828965dd5$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {void}
 */ function $f8aa679828965dd5$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($f8aa679828965dd5$var$own.call(extension, key)) {
        if (key === 'canContainEols') {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === 'transforms') {
            const right = extension[key];
            if (right) combined[key].push(...right);
        } else if (key === 'enter' || key === 'exit') {
            const right = extension[key];
            if (right) Object.assign(combined[key], right);
        }
    }
}
/** @type {OnEnterError} */ function $f8aa679828965dd5$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $c2800647e46698b3$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $c2800647e46698b3$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $c2800647e46698b3$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $f8afdb2a14a0af6e$export$2e2bcd8739ae039(options) {
    /** @type {import('unified').ParserFunction<Root>} */ const parser = (doc)=>{
        // Assume options.
        const settings = /** @type {Options} */ this.data('settings');
        return (0, $f8aa679828965dd5$export$d744d789c09bfde6)(doc, Object.assign({}, settings, options, {
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: this.data('micromarkExtensions') || [],
            mdastExtensions: this.data('fromMarkdownExtensions') || []
        }));
    };
    Object.assign(this, {
        Parser: parser
    });
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor<any, any, any, any>} Processor
 *
 * @typedef {import('mdast-util-to-hast')} DoNotTouchAsThisImportIncludesRawInTree
 */ /**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Root} HastRoot
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Root} MdastRoot
 *
 * @typedef {import('./state.js').Options} Options
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 */ /**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ 
const $fcc93038428e5e16$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $fcc93038428e5e16$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return '&' + $fcc93038428e5e16$var$characterReferences[value] + ';';
    }
}


function $8152076776227ef8$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $fcc93038428e5e16$export$c564cdbbe6da493)($8152076776227ef8$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $8152076776227ef8$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $0e0efac6dff74a8f$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = '\uFFFD';
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


function $0f3d515b9a22cf98$export$adb608be33961c98(state) {
    /** @type {Array<ElementContent>} */ const listItems = [];
    let index = -1;
    while(++index < state.footnoteOrder.length){
        const def = state.footnoteById[state.footnoteOrder[index]];
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $8152076776227ef8$export$e42a3e39590d28b5)(id.toLowerCase());
        let referenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        while(++referenceIndex <= state.footnoteCounts[id]){
            /** @type {Element} */ const backReference = {
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + state.clobberPrefix + 'fnref-' + safeId + (referenceIndex > 1 ? '-' + referenceIndex : ''),
                    dataFootnoteBackref: true,
                    className: [
                        'data-footnote-backref'
                    ],
                    ariaLabel: state.footnoteBackLabel
                },
                children: [
                    {
                        type: 'text',
                        value: "\u21A9"
                    }
                ]
            };
            if (referenceIndex > 1) backReference.children.push({
                type: 'element',
                tagName: 'sup',
                children: [
                    {
                        type: 'text',
                        value: String(referenceIndex)
                    }
                ]
            });
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            backReferences.push(backReference);
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: state.clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: state.footnoteLabelTagName,
                properties: {
                    // To do: use structured clone.
                    ...JSON.parse(JSON.stringify(state.footnoteLabelProperties)),
                    id: 'footnote-label'
                },
                children: [
                    {
                        type: 'text',
                        value: state.footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @typedef {import('hast').Content} HastContent
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Content} MdastContent
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Parent} MdastParent
 * @typedef {import('mdast').Root} MdastRoot
 */ /**
 * @typedef {HastRoot | HastContent} HastNodes
 * @typedef {MdastRoot | MdastContent} MdastNodes
 * @typedef {Extract<MdastNodes, MdastParent>} MdastParents
 *
 * @typedef EmbeddedHastFields
 *   hast fields.
 * @property {string | null | undefined} [hName]
 *   Generate a specific element with this tag name instead.
 * @property {HastProperties | null | undefined} [hProperties]
 *   Generate an element with these properties instead.
 * @property {Array<HastElementContent> | null | undefined} [hChildren]
 *   Generate an element with this content instead.
 *
 * @typedef {Record<string, unknown> & EmbeddedHastFields} MdastData
 *   mdast data with embedded hast fields.
 *
 * @typedef {MdastNodes & {data?: MdastData | null | undefined}} MdastNodeWithData
 *   mdast node with embedded hast data.
 *
 * @typedef PointLike
 *   Point-like value.
 * @property {number | null | undefined} [line]
 *   Line.
 * @property {number | null | undefined} [column]
 *   Column.
 * @property {number | null | undefined} [offset]
 *   Offset.
 *
 * @typedef PositionLike
 *   Position-like value.
 * @property {PointLike | null | undefined} [start]
 *   Point-like value.
 * @property {PointLike | null | undefined} [end]
 *   Point-like value.
 *
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | null | undefined} parent
 *   Parent of `node`.
 * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
 *   hast node.
 *
 * @callback HFunctionProps
 *   Signature of `state` for when props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {HastProperties} props
 *   Properties.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @callback HFunctionNoProps
 *   Signature of `state` for when no props are passed.
 * @param {MdastNodes | PositionLike | null | undefined} node
 *   mdast node or unist position.
 * @param {string} tagName
 *   HTML tag name.
 * @param {Array<HastElementContent> | null | undefined} [children]
 *   hast content.
 * @returns {HastElement}
 *   Compiled element.
 *
 * @typedef HFields
 *   Info on `state`.
 * @property {boolean} dangerous
 *   Whether HTML is allowed.
 * @property {string} clobberPrefix
 *   Prefix to use to prevent DOM clobbering.
 * @property {string} footnoteLabel
 *   Label to use to introduce the footnote section.
 * @property {string} footnoteLabelTagName
 *   HTML used for the footnote label.
 * @property {HastProperties} footnoteLabelProperties
 *   Properties on the HTML tag used for the footnote label.
 * @property {string} footnoteBackLabel
 *   Label to use from backreferences back to their footnote call.
 * @property {(identifier: string) => MdastDefinition | null} definition
 *   Definition cache.
 * @property {Record<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Record<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {Handler} unknownHandler
 *   Handler for any none not in `passThrough` or otherwise handled.
 * @property {(from: MdastNodes, node: HastNodes) => void} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => Type | HastElement} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {(node: MdastNodes, parent: MdastParents | null | undefined) => HastElementContent | Array<HastElementContent> | null | undefined} one
 *   Transform an mdast node to hast.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastContent>(nodes: Array<Type>, loose?: boolean | null | undefined) => Array<Type | HastText>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 * @property {(left: MdastNodeWithData | PositionLike | null | undefined, right: HastElementContent) => HastElementContent} augment
 *   Like `state` but lower-level and usable on non-elements.
 *   Deprecated: use `patch` and `applyData`.
 * @property {Array<string>} passThrough
 *   List of node types to pass through untouched (except for their children).
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent it from
 *   *clobbering*.
 * @property {string | null | undefined} [footnoteBackLabel='Back to content']
 *   Label to use from backreferences back to their footnote call (affects
 *   screen readers).
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Label to use for the footnotes section (affects screen readers).
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (note that `id: 'footnote-label'`
 *   is always added as footnote calls use it with `aria-describedby` to
 *   provide an accessible label).
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   Tag name to use for the footnote label.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes.
 * @property {Array<string> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes.
 *
 * @typedef {Record<string, Handler>} Handlers
 *   Handle nodes.
 *
 * @typedef {HFunctionProps & HFunctionNoProps & HFields} State
 *   Info passed around.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * Check if `Child` can be a child of `Ancestor`.
 *
 * Returns the ancestor when `Child` can be a child of `Ancestor`, or returns
 * `never`.
 *
 * @template {Node} Ancestor
 *   Node type.
 * @template {Node} Child
 *   Node type.
 * @typedef {(
 *   Ancestor extends Parent
 *     ? Child extends Ancestor['children'][number]
 *       ? Ancestor
 *       : never
 *     : never
 * )} ParentsOf
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends Node ? number | null : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends Node ? Ancestor | null : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * Build a typed `Visitor` function from a node and all possible parents.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Visited
 *   Node type.
 * @template {Parent} Ancestor
 *   Parent type.
 * @typedef {Visitor<Visited, ParentsOf<Ancestor, Visited>>} BuildVisitorFromMatch
 */ /**
 * Build a typed `Visitor` function from a list of descendants and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     import('unist-util-visit-parents/complex-types.js').Matches<Descendant, Check>,
 *     Extract<Descendant, Parent>
 *   >
 * )} BuildVisitorFromDescendants
 */ /**
 * Build a typed `Visitor` function from a tree and a test.
 *
 * It will infer which values are passed as `node` and which as `parent`.
 *
 * @template {Node} [Tree=Node]
 *   Node type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     import('unist-util-visit-parents/complex-types.js').InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 * @typedef {import('unist-util-is').Test} Test
 */ /**
 * @typedef {boolean | 'skip'} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @template {Node} [Visited=Node]
 *   Visited node type.
 * @template {Parent} [Ancestor=Parent]
 *   Ancestor type.
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<Ancestor>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @template {Node} [Tree=Node]
 *   Tree type.
 * @template {Test} [Check=string]
 *   Test type.
 * @typedef {Visitor<import('./complex-types.js').Matches<import('./complex-types.js').InclusiveDescendant<Tree>, Check>, Extract<import('./complex-types.js').InclusiveDescendant<Tree>, Parent>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @typedef {Record<string, unknown>} Props
 * @typedef {null | undefined | string | Props | TestFunctionAnything | Array<string | Props | TestFunctionAnything>} Test
 *   Check for an arbitrary node, unaware of TypeScript inferral.
 *
 * @callback TestFunctionAnything
 *   Check if a node passes a test, unaware of TypeScript inferral.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | void}
 *   Whether this node passes the test.
 */ /**
 * @template {Node} Kind
 *   Node type.
 * @typedef {Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind> | Array<Kind['type'] | Partial<Kind> | TestFunctionPredicate<Kind>>} PredicateTest
 *   Check for a node that can be inferred by TypeScript.
 */ /**
 * Check if a node passes a certain test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback TestFunctionPredicate
 *   Complex test function for a node that can be inferred by TypeScript.
 * @param {Node} node
 *   A node.
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this node passes the test.
 */ /**
 * @callback AssertAnything
 *   Check that an arbitrary value is a node, unaware of TypeScript inferral.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if a node is a node and passes a certain node test.
 *
 * @template {Node} Kind
 *   Node type.
 * @callback AssertPredicate
 *   Check that an arbitrary value is a specific node, aware of TypeScript.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {node is Kind}
 *   Whether this is a node and passes a test.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param node
 *   Thing to check, typically `Node`.
 * @param test
 *   A check for a specific node.
 * @param index
 *   The node’s position in its parent.
 * @param parent
 *   The node’s parent.
 * @returns
 *   Whether `node` is a node and passes a test.
 */ const $79b10d293d73e9b2$export$226b3eccf92c9ed9 = /**
   * @type {(
   *   (() => false) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index: number, parent: Parent, context?: unknown) => node is Kind) &
   *   (<Kind extends Node = Node>(node: unknown, test: PredicateTest<Kind>, index?: null | undefined, parent?: null | undefined, context?: unknown) => node is Kind) &
   *   ((node: unknown, test: Test, index: number, parent: Parent, context?: unknown) => boolean) &
   *   ((node: unknown, test?: Test, index?: null | undefined, parent?: null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function is(node, test, index, parent, context) {
    const check = $79b10d293d73e9b2$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!is(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    // @ts-expect-error Looks like a node.
    return node && node.type && typeof node.type === 'string' ? Boolean(check.call(context, node, index, parent)) : false;
};
const $79b10d293d73e9b2$export$9c68d69a4c5bbcf9 = /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {AssertAnything}
     */ function(test) {
    if (test === undefined || test === null) return $79b10d293d73e9b2$var$ok;
    if (typeof test === 'string') return $79b10d293d73e9b2$var$typeFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $79b10d293d73e9b2$var$anyFactory(test) : $79b10d293d73e9b2$var$propsFactory(test);
    if (typeof test === 'function') return $79b10d293d73e9b2$var$castFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<string | Props | TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */ function $79b10d293d73e9b2$var$anyFactory(tests) {
    /** @type {Array<AssertAnything>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $79b10d293d73e9b2$export$9c68d69a4c5bbcf9(tests[index]);
    return $79b10d293d73e9b2$var$castFactory(any);
    /**
   * @this {unknown}
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].call(this, ...parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */ function $79b10d293d73e9b2$var$propsFactory(check) {
    return $79b10d293d73e9b2$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        /** @type {string} */ let key;
        for(key in check){
            // @ts-expect-error: hush, it sure works as an index.
            if (node[key] !== check[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {AssertAnything}
 */ function $79b10d293d73e9b2$var$typeFactory(check) {
    return $79b10d293d73e9b2$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */ function $79b10d293d73e9b2$var$castFactory(check) {
    return assertion;
    /**
   * @this {unknown}
   * @param {unknown} node
   * @param {Array<unknown>} parameters
   * @returns {boolean}
   */ function assertion(node, ...parameters) {
        return Boolean(node && typeof node === 'object' && 'type' in node && // @ts-expect-error: fine.
        Boolean(check.call(this, node, ...parameters)));
    }
}
function $79b10d293d73e9b2$var$ok() {
    return true;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $9d874ef8a8ef080d$export$35e9368ef982300f(d) {
    return d;
}


const $57d83a7e99fe1db8$export$f4d8133c446fe484 = true;
const $57d83a7e99fe1db8$export$7f100f842f565dc9 = false;
const $57d83a7e99fe1db8$export$8773f85c2fb2c116 = 'skip';
const $57d83a7e99fe1db8$export$70008a21eb6de899 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor<Node>} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
        test = null;
    }
    const is = (0, $79b10d293d73e9b2$export$9c68d69a4c5bbcf9)(test);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
       * @param {Node} node
       * @param {number | undefined} index
       * @param {Array<Parent>} parents
       */ function factory(node, index, parents) {
        /** @type {Record<string, unknown>} */ // @ts-expect-error: hush
        const value = node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $9d874ef8a8ef080d$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {ActionTuple} */ let result = [];
            /** @type {ActionTuple} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<Parent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || null)) {
                result = $57d83a7e99fe1db8$var$toResult(visitor(node, parents));
                if (result[0] === $57d83a7e99fe1db8$export$7f100f842f565dc9) return result;
            }
            // @ts-expect-error looks like a parent.
            if (node.children && result[0] !== $57d83a7e99fe1db8$export$8773f85c2fb2c116) {
                // @ts-expect-error looks like a parent.
                offset = (reverse ? node.children.length : -1) + step;
                // @ts-expect-error looks like a parent.
                grandparents = parents.concat(node);
                // @ts-expect-error looks like a parent.
                while(offset > -1 && offset < node.children.length){
                    // @ts-expect-error looks like a parent.
                    subresult = factory(node.children[offset], offset, grandparents)();
                    if (subresult[0] === $57d83a7e99fe1db8$export$7f100f842f565dc9) return subresult;
                    offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                }
            }
            return result;
        }
    }
};
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $57d83a7e99fe1db8$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $57d83a7e99fe1db8$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}


const $a6795beeb14361e9$export$bf638b60ea8b89b7 = /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */ /**
     * @param {Node} tree
     * @param {Test} test
     * @param {Visitor} visitor
     * @param {boolean | null | undefined} [reverse]
     * @returns {void}
     */ function(tree, test, visitor, reverse) {
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        visitor = test;
        test = null;
    }
    (0, $57d83a7e99fe1db8$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
       * @param {Node} node
       * @param {Array<Parent>} parents
       */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        return visitor(node, parent ? parent.children.indexOf(node) : null, parent);
    }
};


/**
 * @typedef {import('unist').Position} Position
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the starting point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $2eb0166faf454f4f$export$771bf3e4949bfbee = $2eb0166faf454f4f$var$point('start');
const $2eb0166faf454f4f$export$da309cdce9dc2a25 = $2eb0166faf454f4f$var$point('end');
function $2eb0166faf454f4f$export$5880b8b5730aff45(node) {
    return {
        start: $2eb0166faf454f4f$export$771bf3e4949bfbee(node),
        end: $2eb0166faf454f4f$export$da309cdce9dc2a25(node)
    };
}
/**
 * Get the positional info of `node`.
 *
 * @param {'start' | 'end'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $2eb0166faf454f4f$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {NodeLike | Node | null | undefined} [node]
   * @returns {Point}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        // To do: next major: don’t return points when invalid.
        return {
            // @ts-expect-error: in practice, null is allowed.
            line: point.line || null,
            // @ts-expect-error: in practice, null is allowed.
            column: point.column || null,
            // @ts-expect-error: in practice, null is allowed.
            offset: point.offset > -1 ? point.offset : null
        };
    }
}


/**
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {PositionLike | null | undefined} [position]
 */ /**
 * Check if `node` is generated.
 *
 * @param {NodeLike | null | undefined} [node]
 *   Node to check.
 * @returns {boolean}
 *   Whether `node` is generated (does not have positional info).
 */ function $5f4e629f12acb78a$export$41ad1363166ec91a(node) {
    return !node || !node.position || !node.position.start || !node.position.start.line || !node.position.start.column || !node.position.end || !node.position.end.line || !node.position.end.column;
}


/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Definition} Definition
 */ /**
 * @typedef {Root | Content} Node
 *
 * @callback GetDefinition
 *   Get a definition by identifier.
 * @param {string | null | undefined} [identifier]
 *   Identifier of definition.
 * @returns {Definition | null}
 *   Definition corresponding to `identifier` or `null`.
 */ 
const $f02589b0b57bcb5b$var$own = {}.hasOwnProperty;
function $f02589b0b57bcb5b$export$d79264f26953ec1(tree) {
    /** @type {Record<string, Definition>} */ const cache = Object.create(null);
    if (!tree || !tree.type) throw new Error('mdast-util-definitions expected node');
    (0, $a6795beeb14361e9$export$bf638b60ea8b89b7)(tree, 'definition', (definition)=>{
        const id = $f02589b0b57bcb5b$var$clean(definition.identifier);
        if (id && !$f02589b0b57bcb5b$var$own.call(cache, id)) cache[id] = definition;
    });
    return definition;
    /** @type {GetDefinition} */ function definition(identifier) {
        const id = $f02589b0b57bcb5b$var$clean(identifier);
        // To do: next major: return `undefined` when not found.
        return id && $f02589b0b57bcb5b$var$own.call(cache, id) ? cache[id] : null;
    }
}
/**
 * @param {string | null | undefined} [value]
 * @returns {string}
 */ function $f02589b0b57bcb5b$var$clean(value) {
    return String(value || '').toUpperCase();
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $873e8b602d67e1eb$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $c12ffdf45974319a$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7e3f7d005d5ee31c$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    // To do: next major, use `node.lang` w/o regex, the splitting’s been going
    // on for years in remark now.
    const lang = node.lang ? node.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null;
    /** @type {Properties} */ const properties = {};
    if (lang) properties.className = [
        'language-' + lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State

 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $0e6da9eea1159b5c$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $4f8a7fc2c9259b58$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('hast').Element} Element
 * @typedef {import('../state.js').State} State
 */ 
function $fb56a43294cb554f$export$7f87ee744075c1ba(state, node) {
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $8152076776227ef8$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    if (index === -1) {
        state.footnoteOrder.push(id);
        state.footnoteCounts[id] = 1;
        counter = state.footnoteOrder.length;
    } else {
        state.footnoteCounts[id]++;
        counter = index + 1;
    }
    const reuseCounter = state.footnoteCounts[id];
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + state.clobberPrefix + 'fn-' + safeId,
            id: state.clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Footnote} Footnote
 * @typedef {import('../state.js').State} State
 */ 
function $38933c847d32fb3a$export$3b6a720baa2c20ec(state, node) {
    const footnoteById = state.footnoteById;
    let no = 1;
    while(no in footnoteById)no++;
    const identifier = String(no);
    footnoteById[identifier] = {
        type: 'footnoteDefinition',
        identifier: identifier,
        children: [
            {
                type: 'paragraph',
                children: node.children
            }
        ],
        position: node.position
    };
    return (0, $fb56a43294cb554f$export$7f87ee744075c1ba)(state, {
        type: 'footnoteReference',
        identifier: identifier,
        position: node.position
    });
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $bb86154deb79b98e$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').HTML} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Raw | Element | null}
 *   hast node.
 */ function $1cf8a4c88312066a$export$c0bb0b647f701bb5(state, node) {
    if (state.dangerous) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    // To do: next major: return `undefined`.
    return null;
}


/**
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Reference} Reference
 * @typedef {import('mdast').Root} Root
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Reference>} References
 */ // To do: next major: always return array.
/**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {References} node
 *   Reference node (image, link).
 * @returns {ElementContent | Array<ElementContent>}
 *   hast content.
 */ function $2b136c1710f10951$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return {
        type: 'text',
        value: '![' + node.alt + suffix
    };
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $fa63599826cf80b6$export$f281796f6bc3b8db(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $2b136c1710f10951$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $8152076776227ef8$export$e42a3e39590d28b5)(def.url || ''),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $2c7c625ff27de5b7$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $8152076776227ef8$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $bdd09856e8ba33ae$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $dfa38fce9f7f6b8c$export$e6c469b1b7b2bc6a(state, node) {
    const def = state.definition(node.identifier);
    if (!def) return (0, $2b136c1710f10951$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $8152076776227ef8$export$e42a3e39590d28b5)(def.url || '')
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $ff02d09ce4744195$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $8152076776227ef8$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $f7d39bf347298f3f$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $f7d39bf347298f3f$var$listLoose(parent) : $f7d39bf347298f3f$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $f7d39bf347298f3f$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $f7d39bf347298f3f$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $f7d39bf347298f3f$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === undefined || spread === null ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $7b42cd949e6c60f9$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $eae3449019415a3a$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastRoot | HastElement}
 *   hast node.
 */ function $7346253959989240$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $97a52058d14c61a8$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $5e0f53d9d07017d8$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $2eb0166faf454f4f$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $2eb0166faf454f4f$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start.line && end.line) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ /**
 * @typedef {Root | Content} Nodes
 * @typedef {Extract<Nodes, Parent>} Parents
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | null | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $7a41a3b926310dff$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(node, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $87c7b463ad5582bc$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $358395fcbf5a2cfd$var$tab = 9 /* `\t` */ ;
const $358395fcbf5a2cfd$var$space = 32 /* ` ` */ ;
function $358395fcbf5a2cfd$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($358395fcbf5a2cfd$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($358395fcbf5a2cfd$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $358395fcbf5a2cfd$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $358395fcbf5a2cfd$var$tab || code === $358395fcbf5a2cfd$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $358395fcbf5a2cfd$var$tab || code === $358395fcbf5a2cfd$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $ee51ab4e98d30870$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $358395fcbf5a2cfd$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $0a3f1591cf32526f$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $114904d24886f596$export$455ce229eb3d2472 = {
    blockquote: $873e8b602d67e1eb$export$67dc04e652a298ca,
    break: (0, $c12ffdf45974319a$export$371da9dd35aba193),
    code: $7e3f7d005d5ee31c$export$6565f9f03506010b,
    delete: (0, $0e6da9eea1159b5c$export$19426ff118fe8be),
    emphasis: $4f8a7fc2c9259b58$export$bef81ba411953b51,
    footnoteReference: $fb56a43294cb554f$export$7f87ee744075c1ba,
    footnote: $38933c847d32fb3a$export$3b6a720baa2c20ec,
    heading: $bb86154deb79b98e$export$46e4a324ac90507f,
    html: $1cf8a4c88312066a$export$c0bb0b647f701bb5,
    imageReference: $fa63599826cf80b6$export$f281796f6bc3b8db,
    image: $2c7c625ff27de5b7$export$5c452ff88e35e47d,
    inlineCode: $bdd09856e8ba33ae$export$91b9bee19a0d8569,
    linkReference: $dfa38fce9f7f6b8c$export$e6c469b1b7b2bc6a,
    link: $ff02d09ce4744195$export$9c30223ca0a664fb,
    listItem: $f7d39bf347298f3f$export$76c7e83ecc9cdf05,
    list: $7b42cd949e6c60f9$export$8837f4fc672e936d,
    paragraph: $eae3449019415a3a$export$9c206ddddb32a9b,
    root: $7346253959989240$export$e8e78c978b129247,
    strong: $97a52058d14c61a8$export$59ae2c325a998f89,
    table: $5e0f53d9d07017d8$export$9852986a3ec5f6a0,
    tableCell: $87c7b463ad5582bc$export$e1e720e5f4603e6a,
    tableRow: $7a41a3b926310dff$export$ce666bf02318c957,
    text: $ee51ab4e98d30870$export$6f093cfa640b7166,
    thematicBreak: $0a3f1591cf32526f$export$ba7b13e047416c03,
    toml: $114904d24886f596$var$ignore,
    yaml: $114904d24886f596$var$ignore,
    definition: $114904d24886f596$var$ignore,
    footnoteDefinition: $114904d24886f596$var$ignore
};
// Return nothing for nodes that are ignored.
function $114904d24886f596$var$ignore() {
    // To do: next major: return `undefined`.
    return null;
}


const $3b71d02d19a2f9fc$var$own = {}.hasOwnProperty;
function $3b71d02d19a2f9fc$export$e6a0daad8304de(tree, options) {
    const settings = options || {};
    const dangerous = settings.allowDangerousHtml || false;
    /** @type {Record<string, MdastFootnoteDefinition>} */ const footnoteById = {};
    // To do: next major: add `options` to state, remove:
    // `dangerous`, `clobberPrefix`, `footnoteLabel`, `footnoteLabelTagName`,
    // `footnoteLabelProperties`, `footnoteBackLabel`, `passThrough`,
    // `unknownHandler`.
    // To do: next major: move to `state.options.allowDangerousHtml`.
    state.dangerous = dangerous;
    // To do: next major: move to `state.options`.
    state.clobberPrefix = settings.clobberPrefix === undefined || settings.clobberPrefix === null ? 'user-content-' : settings.clobberPrefix;
    // To do: next major: move to `state.options`.
    state.footnoteLabel = settings.footnoteLabel || 'Footnotes';
    // To do: next major: move to `state.options`.
    state.footnoteLabelTagName = settings.footnoteLabelTagName || 'h2';
    // To do: next major: move to `state.options`.
    state.footnoteLabelProperties = settings.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    // To do: next major: move to `state.options`.
    state.footnoteBackLabel = settings.footnoteBackLabel || 'Back to content';
    // To do: next major: move to `state.options`.
    state.unknownHandler = settings.unknownHandler;
    // To do: next major: move to `state.options`.
    state.passThrough = settings.passThrough;
    state.handlers = {
        ...(0, $114904d24886f596$export$455ce229eb3d2472),
        ...settings.handlers
    };
    // To do: next major: replace utility with `definitionById` object, so we
    // only walk once (as we need footnotes too).
    state.definition = (0, $f02589b0b57bcb5b$export$d79264f26953ec1)(tree);
    state.footnoteById = footnoteById;
    /** @type {Array<string>} */ state.footnoteOrder = [];
    /** @type {Record<string, number>} */ state.footnoteCounts = {};
    state.patch = $3b71d02d19a2f9fc$var$patch;
    state.applyData = $3b71d02d19a2f9fc$var$applyData;
    state.one = oneBound;
    state.all = allBound;
    state.wrap = $3b71d02d19a2f9fc$export$4997ffc0176396a6;
    // To do: next major: remove `augment`.
    state.augment = augment;
    (0, $a6795beeb14361e9$export$bf638b60ea8b89b7)(tree, 'footnoteDefinition', (definition)=>{
        const id = String(definition.identifier).toUpperCase();
        // Mimick CM behavior of link definitions.
        // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8290999/index.js#L26>.
        if (!$3b71d02d19a2f9fc$var$own.call(footnoteById, id)) footnoteById[id] = definition;
    });
    // @ts-expect-error Hush, it’s fine!
    return state;
    /**
   * Finalise the created `right`, a hast node, from `left`, an mdast node.
   *
   * @param {MdastNodeWithData | PositionLike | null | undefined} left
   * @param {HastElementContent} right
   * @returns {HastElementContent}
   */ /* c8 ignore start */ // To do: next major: remove.
    function augment(left, right) {
        // Handle `data.hName`, `data.hProperties, `data.hChildren`.
        if (left && 'data' in left && left.data) {
            /** @type {MdastData} */ const data = left.data;
            if (data.hName) {
                if (right.type !== 'element') right = {
                    type: 'element',
                    tagName: '',
                    properties: {},
                    children: []
                };
                right.tagName = data.hName;
            }
            if (right.type === 'element' && data.hProperties) right.properties = {
                ...right.properties,
                ...data.hProperties
            };
            if ('children' in right && right.children && data.hChildren) right.children = data.hChildren;
        }
        if (left) {
            const ctx = 'type' in left ? left : {
                position: left
            };
            if (!(0, $5f4e629f12acb78a$export$41ad1363166ec91a)(ctx)) // @ts-expect-error: fine.
            right.position = {
                start: (0, $2eb0166faf454f4f$export$771bf3e4949bfbee)(ctx),
                end: (0, $2eb0166faf454f4f$export$da309cdce9dc2a25)(ctx)
            };
        }
        return right;
    }
    /* c8 ignore stop */ /**
   * Create an element for `node`.
   *
   * @type {HFunctionProps}
   */ /* c8 ignore start */ // To do: next major: remove.
    function state(node, tagName, props, children) {
        if (Array.isArray(props)) {
            children = props;
            props = {};
        }
        // @ts-expect-error augmenting an element yields an element.
        return augment(node, {
            type: 'element',
            tagName: tagName,
            properties: props || {},
            children: children || []
        });
    }
    /* c8 ignore stop */ /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | null | undefined} [parent]
   *   Parent of `node`.
   * @returns {HastElementContent | Array<HastElementContent> | null | undefined}
   *   Resulting hast node.
   */ function oneBound(node, parent) {
        // @ts-expect-error: that’s a state :)
        return $3b71d02d19a2f9fc$export$80bf7733f1207381(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function allBound(parent) {
        // @ts-expect-error: that’s a state :)
        return $3b71d02d19a2f9fc$export$84bf76cd7afc7469(state, parent);
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {void}
 *   Nothing.
 */ function $3b71d02d19a2f9fc$var$patch(from, to) {
    if (from.position) to.position = (0, $2eb0166faf454f4f$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {Type | HastElement}
 *   Nothing.
 */ function $3b71d02d19a2f9fc$var$applyData(from, to) {
    /** @type {Type | HastElement} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else result = {
                type: 'element',
                tagName: hName,
                properties: {},
                children: []
            };
        }
        if (result.type === 'element' && hProperties) result.properties = {
            ...result.properties,
            ...hProperties
        };
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) // @ts-expect-error: assume valid children are defined.
        result.children = hChildren;
    }
    return result;
}
function $3b71d02d19a2f9fc$export$80bf7733f1207381(state, node, parent) {
    const type = node && node.type;
    // Fail on non-nodes.
    if (!type) throw new Error('Expected node, got `' + node + '`');
    if ($3b71d02d19a2f9fc$var$own.call(state.handlers, type)) return state.handlers[type](state, node, parent);
    if (state.passThrough && state.passThrough.includes(type)) // To do: next major: deep clone.
    // @ts-expect-error: types of passed through nodes are expected to be added manually.
    return 'children' in node ? {
        ...node,
        children: $3b71d02d19a2f9fc$export$84bf76cd7afc7469(state, node)
    } : node;
    if (state.unknownHandler) return state.unknownHandler(state, node, parent);
    return $3b71d02d19a2f9fc$var$defaultUnknownHandler(state, node);
}
function $3b71d02d19a2f9fc$export$84bf76cd7afc7469(state, parent) {
    /** @type {Array<HastElementContent>} */ const values = [];
    if ('children' in parent) {
        const nodes = parent.children;
        let index = -1;
        while(++index < nodes.length){
            const result = $3b71d02d19a2f9fc$export$80bf7733f1207381(state, nodes[index], parent);
            // To do: see if we van clean this? Can we merge texts?
            if (result) {
                if (index && nodes[index - 1].type === 'break') {
                    if (!Array.isArray(result) && result.type === 'text') result.value = result.value.replace(/^\s+/, '');
                    if (!Array.isArray(result) && result.type === 'element') {
                        const head = result.children[0];
                        if (head && head.type === 'text') head.value = head.value.replace(/^\s+/, '');
                    }
                }
                if (Array.isArray(result)) values.push(...result);
                else values.push(result);
            }
        }
    }
    return values;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastText | HastElement}
 *   Resulting hast node.
 */ function $3b71d02d19a2f9fc$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastText | HastElement} */ const result = 'value' in node && !($3b71d02d19a2f9fc$var$own.call(data, 'hProperties') || $3b71d02d19a2f9fc$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: $3b71d02d19a2f9fc$export$84bf76cd7afc7469(state, node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $3b71d02d19a2f9fc$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<Type | HastText>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}


function $5d9dc8503281e181$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $3b71d02d19a2f9fc$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, null);
    const foot = (0, $0f3d515b9a22cf98$export$adb608be33961c98)(state);
    if (foot) // @ts-expect-error If there’s a footer, there were definitions, meaning block
    // content.
    // So assume `node` is a parent node.
    node.children.push({
        type: 'text',
        value: '\n'
    }, foot);
    // To do: next major: always return root?
    return Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node;
}


// Note: the `<MdastRoot, HastRoot>` overload doesn’t seem to work :'(
/**
 * Plugin that turns markdown into HTML to support rehype.
 *
 * *   If a destination processor is given, that processor runs with a new HTML
 *     (hast) tree (bridge-mode).
 *     As the given processor runs with a hast tree, and rehype plugins support
 *     hast, that means rehype plugins can be used with the given processor.
 *     The hast tree is discarded in the end.
 *     It’s highly unlikely that you want to do this.
 * *   The common case is to not pass a destination processor, in which case the
 *     current processor continues running with a new HTML (hast) tree
 *     (mutate-mode).
 *     As the current processor continues with a hast tree, and rehype plugins
 *     support hast, that means rehype plugins can be used after
 *     `remark-rehype`.
 *     It’s likely that this is what you want to do.
 *
 * @param destination
 *   Optional unified processor.
 * @param options
 *   Options passed to `mdast-util-to-hast`.
 */ const $f192f06803e471a7$var$remarkRehype = /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */ function(destination, options) {
    return destination && 'run' in destination ? $f192f06803e471a7$var$bridge(destination, options) : $f192f06803e471a7$var$mutate(destination || options);
};
var $f192f06803e471a7$export$2e2bcd8739ae039 = $f192f06803e471a7$var$remarkRehype;
/**
 * Bridge-mode.
 * Runs the destination with the new hast tree.
 *
 * @type {import('unified').Plugin<[Processor, Options?], MdastRoot>}
 */ function $f192f06803e471a7$var$bridge(destination, options) {
    return (node, file, next)=>{
        destination.run((0, $5d9dc8503281e181$export$c0e4c5cf07538633)(node, options), file, (error)=>{
            next(error);
        });
    };
}
/**
 * Mutate-mode.
 * Further plugins run on the hast tree.
 *
 * @type {import('unified').Plugin<[Options?]|void[], MdastRoot, HastRoot>}
 */ function $f192f06803e471a7$var$mutate(options) {
    // @ts-expect-error: assume a corresponding node is returned by `toHast`.
    return (node)=>(0, $5d9dc8503281e181$export$c0e4c5cf07538633)(node, options);
}



var $4RND8 = parcelRequire("4RND8");
/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $c0bec17d8ff7be96$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $c0bec17d8ff7be96$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $c0bec17d8ff7be96$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $c0bec17d8ff7be96$export$19342e026b58ebb7.prototype.space = null;


function $e375326aea32bcf4$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $c0bec17d8ff7be96$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $f007b01a5d5d2949$export$a3295358bff77e(value) {
    return value.toLowerCase();
}



class $6caa2b737fdff06c$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.space = null;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.boolean = false;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.booleanish = false;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.number = false;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$6caa2b737fdff06c$export$c4868e4a24d48fad.prototype.defined = false;


var $3e0765ec4d1b809c$exports = {};

$parcel$export($3e0765ec4d1b809c$exports, "boolean", () => $3e0765ec4d1b809c$export$4a21f16c33752377);
$parcel$export($3e0765ec4d1b809c$exports, "booleanish", () => $3e0765ec4d1b809c$export$55e9e1fbc638dc8f);
$parcel$export($3e0765ec4d1b809c$exports, "overloadedBoolean", () => $3e0765ec4d1b809c$export$242ac3d3042558aa);
$parcel$export($3e0765ec4d1b809c$exports, "number", () => $3e0765ec4d1b809c$export$98e628dec113755e);
$parcel$export($3e0765ec4d1b809c$exports, "spaceSeparated", () => $3e0765ec4d1b809c$export$ab8645c862eb5a3e);
$parcel$export($3e0765ec4d1b809c$exports, "commaSeparated", () => $3e0765ec4d1b809c$export$9c8d678629b3d3);
$parcel$export($3e0765ec4d1b809c$exports, "commaOrSpaceSeparated", () => $3e0765ec4d1b809c$export$2ad25cfebf36cacd);
let $3e0765ec4d1b809c$var$powers = 0;
const $3e0765ec4d1b809c$export$4a21f16c33752377 = $3e0765ec4d1b809c$var$increment();
const $3e0765ec4d1b809c$export$55e9e1fbc638dc8f = $3e0765ec4d1b809c$var$increment();
const $3e0765ec4d1b809c$export$242ac3d3042558aa = $3e0765ec4d1b809c$var$increment();
const $3e0765ec4d1b809c$export$98e628dec113755e = $3e0765ec4d1b809c$var$increment();
const $3e0765ec4d1b809c$export$ab8645c862eb5a3e = $3e0765ec4d1b809c$var$increment();
const $3e0765ec4d1b809c$export$9c8d678629b3d3 = $3e0765ec4d1b809c$var$increment();
const $3e0765ec4d1b809c$export$2ad25cfebf36cacd = $3e0765ec4d1b809c$var$increment();
function $3e0765ec4d1b809c$var$increment() {
    return 2 ** ++$3e0765ec4d1b809c$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $853be0ef41708b21$var$checks = Object.keys($3e0765ec4d1b809c$exports);
class $853be0ef41708b21$export$ea6b9f0064e88c9b extends (0, $6caa2b737fdff06c$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $853be0ef41708b21$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $853be0ef41708b21$var$checks.length){
            const check = $853be0ef41708b21$var$checks[index];
            $853be0ef41708b21$var$mark(this, $853be0ef41708b21$var$checks[index], (mask & $3e0765ec4d1b809c$exports[check]) === $3e0765ec4d1b809c$exports[check]);
        }
    }
}
$853be0ef41708b21$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $853be0ef41708b21$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}


const $0b045c5af591a347$var$own = {}.hasOwnProperty;
function $0b045c5af591a347$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($0b045c5af591a347$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $853be0ef41708b21$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $f007b01a5d5d2949$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $f007b01a5d5d2949$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $c0bec17d8ff7be96$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $02ff7adca3ea49db$export$2bd1230ec7600845 = (0, $0b045c5af591a347$export$185802fd694ee1f5)({
    space: 'xlink',
    transform (_, prop) {
        return 'xlink:' + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $087bb82375826bda$export$f2913fe8983302e = (0, $0b045c5af591a347$export$185802fd694ee1f5)({
    space: 'xml',
    transform (_, prop) {
        return 'xml:' + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $20224da2b969e71b$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $b08bfac6dde354d4$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $20224da2b969e71b$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $40260ed15412398f$export$e20c24a128671213 = (0, $0b045c5af591a347$export$185802fd694ee1f5)({
    space: 'xmlns',
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    transform: (0, $b08bfac6dde354d4$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $e086f8f5d763843a$export$4d2d26490572750a = (0, $0b045c5af591a347$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaColIndex: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaColSpan: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaControls: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        ariaLevel: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaPressed: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaRowIndex: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaRowSpan: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaSelected: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaValueMin: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaValueNow: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $c286e36270e54f53$export$c0bb0b647f701bb5 = (0, $0b045c5af591a347$export$185802fd694ee1f5)({
    space: 'html',
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    transform: (0, $b08bfac6dde354d4$export$32b9e4cec9c208e1),
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $3e0765ec4d1b809c$export$9c8d678629b3d3),
        acceptCharset: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        accessKey: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        allowPaymentRequest: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        allowUserMedia: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        autoFocus: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        autoPlay: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        blocking: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        cite: null,
        className: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        cols: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        controls: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        controlsList: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        coords: (0, $3e0765ec4d1b809c$export$98e628dec113755e) | (0, $3e0765ec4d1b809c$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        defer: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        download: (0, $3e0765ec4d1b809c$export$242ac3d3042558aa),
        draggable: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        height: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        hidden: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        high: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        httpEquiv: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        itemRef: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        itemScope: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        itemType: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        low: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        multiple: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        muted: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        noValidate: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        optimum: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        pattern: null,
        ping: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        required: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        reversed: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        rows: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        rowSpan: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        sandbox: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        seamless: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        selected: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        shadowRootClonable: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        shadowRootMode: null,
        shape: null,
        size: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        spellCheck: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        useMap: null,
        value: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        width: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        declare: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        leftMargin: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        marginWidth: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        noResize: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        noHref: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        noShade: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        noWrap: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $3e0765ec4d1b809c$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        disableRemotePlayback: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $84376e9154a688ca$export$7ed1367e7fa1ad68 = (0, $0b045c5af591a347$export$185802fd694ee1f5)({
    space: 'svg',
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    transform: (0, $20224da2b969e71b$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        accentHeight: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        amplitude: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        className: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        diffuseConstant: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $3e0765ec4d1b809c$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $3e0765ec4d1b809c$export$9c8d678629b3d3),
        g2: (0, $3e0765ec4d1b809c$export$9c8d678629b3d3),
        glyphName: (0, $3e0765ec4d1b809c$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        horizOriginX: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        horizOriginY: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        id: null,
        ideographic: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        k: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        k1: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        k2: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        k3: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        k4: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        kernelMatrix: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        overlineThickness: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $3e0765ec4d1b809c$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        pointsAtY: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        pointsAtZ: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        rev: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        requiredFonts: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        requiredFormats: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        specularExponent: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        strikethroughThickness: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        strokeOpacity: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        tabIndex: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        targetY: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $3e0765ec4d1b809c$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        underlineThickness: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        vMathematical: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        vIdeographic: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        vertOriginX: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        vertOriginY: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $3e0765ec4d1b809c$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ 


const $453db58efd5c7ac0$var$valid = /^data[-\w.:]+$/i;
const $453db58efd5c7ac0$var$dash = /-[a-z]/g;
const $453db58efd5c7ac0$var$cap = /[A-Z]/g;
function $453db58efd5c7ac0$export$71aa6c912b956294(schema, value) {
    const normal = (0, $f007b01a5d5d2949$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $6caa2b737fdff06c$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $453db58efd5c7ac0$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($453db58efd5c7ac0$var$dash, $453db58efd5c7ac0$var$camelcase);
            prop = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$453db58efd5c7ac0$var$dash.test(rest)) {
                let dashes = rest.replace($453db58efd5c7ac0$var$cap, $453db58efd5c7ac0$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $853be0ef41708b21$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $453db58efd5c7ac0$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $453db58efd5c7ac0$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}


/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $38749de17a8500d7$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};



const $9bc4618a7f6e713d$export$c0bb0b647f701bb5 = (0, $e375326aea32bcf4$export$4950aa0f605343fb)([
    (0, $087bb82375826bda$export$f2913fe8983302e),
    (0, $02ff7adca3ea49db$export$2bd1230ec7600845),
    (0, $40260ed15412398f$export$e20c24a128671213),
    (0, $e086f8f5d763843a$export$4d2d26490572750a),
    (0, $c286e36270e54f53$export$c0bb0b647f701bb5)
], 'html');
const $9bc4618a7f6e713d$export$7ed1367e7fa1ad68 = (0, $e375326aea32bcf4$export$4950aa0f605343fb)([
    (0, $087bb82375826bda$export$f2913fe8983302e),
    (0, $02ff7adca3ea49db$export$2bd1230ec7600845),
    (0, $40260ed15412398f$export$e20c24a128671213),
    (0, $e086f8f5d763843a$export$4d2d26490572750a),
    (0, $84376e9154a688ca$export$7ed1367e7fa1ad68)
], 'svg');



function $57f7f33b1833379a$export$2e2bcd8739ae039(options) {
    if (options.allowedElements && options.disallowedElements) throw new TypeError('Only one of `allowedElements` and `disallowedElements` should be defined');
    if (options.allowedElements || options.disallowedElements || options.allowElement) return (tree)=>{
        (0, $a6795beeb14361e9$export$bf638b60ea8b89b7)(tree, 'element', (node, index, parent_)=>{
            const parent = /** @type {Element|Root} */ parent_;
            /** @type {boolean|undefined} */ let remove;
            if (options.allowedElements) remove = !options.allowedElements.includes(node.tagName);
            else if (options.disallowedElements) remove = options.disallowedElements.includes(node.tagName);
            if (!remove && options.allowElement && typeof index === 'number') remove = !options.allowElement(node, index, parent);
            if (remove && typeof index === 'number') {
                if (options.unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
            return undefined;
        });
    };
}


const $d10af7cc97e9e1f1$var$protocols = [
    'http',
    'https',
    'mailto',
    'tel'
];
function $d10af7cc97e9e1f1$export$b83532a10e2e268b(uri) {
    const url = (uri || '').trim();
    const first = url.charAt(0);
    if (first === '#' || first === '/') return url;
    const colon = url.indexOf(':');
    if (colon === -1) return url;
    let index = -1;
    while(++index < $d10af7cc97e9e1f1$var$protocols.length){
        const protocol = $d10af7cc97e9e1f1$var$protocols[index];
        if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) return url;
    }
    index = url.indexOf('?');
    if (index !== -1 && colon > index) return url;
    index = url.indexOf('#');
    if (index !== -1 && colon > index) return url;
    // eslint-disable-next-line no-script-url
    return 'javascript:void(0)';
}


/**
 * @template T
 * @typedef {import('react').ComponentType<T>} ComponentType<T>
 */ /**
 * @template T
 * @typedef {import('react').ComponentPropsWithoutRef<T>} ComponentPropsWithoutRef<T>
 */ /**
 * @typedef {import('react').ReactNode} ReactNode
 * @typedef {import('unist').Position} Position
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast').Text} Text
 * @typedef {import('hast').Comment} Comment
 * @typedef {import('hast').DocType} Doctype
 * @typedef {import('property-information').Info} Info
 * @typedef {import('property-information').Schema} Schema
 * @typedef {import('./complex-types').ReactMarkdownProps} ReactMarkdownProps
 *
 * @typedef Raw
 * @property {'raw'} type
 * @property {string} value
 *
 * @typedef Context
 * @property {Options} options
 * @property {Schema} schema
 * @property {number} listDepth
 *
 * @callback TransformLink
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {string}
 *
 * @callback TransformImage
 * @param {string} src
 * @param {string} alt
 * @param {string?} title
 * @returns {string}
 *
 * @typedef {import('react').HTMLAttributeAnchorTarget} TransformLinkTargetType
 *
 * @callback TransformLinkTarget
 * @param {string} href
 * @param {Array<ElementContent>} children
 * @param {string?} title
 * @returns {TransformLinkTargetType|undefined}
 *
 * @typedef {keyof JSX.IntrinsicElements} ReactMarkdownNames
 *
 * To do: is `data-sourcepos` typeable?
 *
 * @typedef {ComponentPropsWithoutRef<'code'> & ReactMarkdownProps & {inline?: boolean}} CodeProps
 * @typedef {ComponentPropsWithoutRef<'h1'> & ReactMarkdownProps & {level: number}} HeadingProps
 * @typedef {ComponentPropsWithoutRef<'li'> & ReactMarkdownProps & {checked: boolean|null, index: number, ordered: boolean}} LiProps
 * @typedef {ComponentPropsWithoutRef<'ol'> & ReactMarkdownProps & {depth: number, ordered: true}} OrderedListProps
 * @typedef {ComponentPropsWithoutRef<'table'> & ReactMarkdownProps & {style?: Record<string, unknown>, isHeader: boolean}} TableCellProps
 * @typedef {ComponentPropsWithoutRef<'tr'> & ReactMarkdownProps & {isHeader: boolean}} TableRowProps
 * @typedef {ComponentPropsWithoutRef<'ul'> & ReactMarkdownProps & {depth: number, ordered: false}} UnorderedListProps
 *
 * @typedef {ComponentType<CodeProps>} CodeComponent
 * @typedef {ComponentType<HeadingProps>} HeadingComponent
 * @typedef {ComponentType<LiProps>} LiComponent
 * @typedef {ComponentType<OrderedListProps>} OrderedListComponent
 * @typedef {ComponentType<TableCellProps>} TableCellComponent
 * @typedef {ComponentType<TableRowProps>} TableRowComponent
 * @typedef {ComponentType<UnorderedListProps>} UnorderedListComponent
 *
 * @typedef SpecialComponents
 * @property {CodeComponent|ReactMarkdownNames} code
 * @property {HeadingComponent|ReactMarkdownNames} h1
 * @property {HeadingComponent|ReactMarkdownNames} h2
 * @property {HeadingComponent|ReactMarkdownNames} h3
 * @property {HeadingComponent|ReactMarkdownNames} h4
 * @property {HeadingComponent|ReactMarkdownNames} h5
 * @property {HeadingComponent|ReactMarkdownNames} h6
 * @property {LiComponent|ReactMarkdownNames} li
 * @property {OrderedListComponent|ReactMarkdownNames} ol
 * @property {TableCellComponent|ReactMarkdownNames} td
 * @property {TableCellComponent|ReactMarkdownNames} th
 * @property {TableRowComponent|ReactMarkdownNames} tr
 * @property {UnorderedListComponent|ReactMarkdownNames} ul
 *
 * @typedef {Partial<Omit<import('./complex-types').NormalComponents, keyof SpecialComponents> & SpecialComponents>} Components
 *
 * @typedef Options
 * @property {boolean} [sourcePos=false]
 * @property {boolean} [rawSourcePos=false]
 * @property {boolean} [skipHtml=false]
 * @property {boolean} [includeElementIndex=false]
 * @property {null|false|TransformLink} [transformLinkUri]
 * @property {TransformImage} [transformImageUri]
 * @property {TransformLinkTargetType|TransformLinkTarget} [linkTarget]
 * @property {Components} [components]
 */ 
var $lx97N = parcelRequire("lx97N");
var $cf5c8e2b8685c48a$exports = {};
'use strict';

$cf5c8e2b8685c48a$exports = (parcelRequire("6xvTc"));


/**
 * Check if the given value is *inter-element whitespace*.
 *
 * @param {unknown} thing
 *   Thing to check (typically `Node` or `string`).
 * @returns {boolean}
 *   Whether the `value` is inter-element whitespace (`boolean`): consisting of
 *   zero or more of space, tab (`\t`), line feed (`\n`), carriage return
 *   (`\r`), or form feed (`\f`).
 *   If a node is passed it must be a `Text` node, whose `value` field is
 *   checked.
 */ function $1a7de79656976693$export$7af1228ff777d175(thing) {
    /** @type {string} */ const value = // @ts-expect-error looks like a node.
    thing && typeof thing === 'object' && thing.type === 'text' ? thing.value || '' : thing;
    // HTML whitespace expression.
    // See <https://infra.spec.whatwg.org/#ascii-whitespace>.
    return typeof value === 'string' && value.replace(/[ \t\n\f\r]/g, '') === '';
}



/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $71c7202b4e4c47aa$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $71c7202b4e4c47aa$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


/**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $7ae77a5ec40be267$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $7ae77a5ec40be267$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}


var $24477d961949f00d$exports = {};
var $8c443c74d39aad73$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $8c443c74d39aad73$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $8c443c74d39aad73$var$NEWLINE_REGEX = /\n/g;
var $8c443c74d39aad73$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $8c443c74d39aad73$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $8c443c74d39aad73$var$COLON_REGEX = /^:\s*/;
var $8c443c74d39aad73$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $8c443c74d39aad73$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $8c443c74d39aad73$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $8c443c74d39aad73$var$NEWLINE = '\n';
var $8c443c74d39aad73$var$FORWARD_SLASH = '/';
var $8c443c74d39aad73$var$ASTERISK = '*';
var $8c443c74d39aad73$var$EMPTY_STRING = '';
// types
var $8c443c74d39aad73$var$TYPE_COMMENT = 'comment';
var $8c443c74d39aad73$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $8c443c74d39aad73$exports = function(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($8c443c74d39aad73$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($8c443c74d39aad73$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($8c443c74d39aad73$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($8c443c74d39aad73$var$FORWARD_SLASH != style.charAt(0) || $8c443c74d39aad73$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($8c443c74d39aad73$var$EMPTY_STRING != style.charAt(i) && ($8c443c74d39aad73$var$ASTERISK != style.charAt(i) || $8c443c74d39aad73$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($8c443c74d39aad73$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $8c443c74d39aad73$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($8c443c74d39aad73$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($8c443c74d39aad73$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($8c443c74d39aad73$var$VALUE_REGEX);
        var ret = pos({
            type: $8c443c74d39aad73$var$TYPE_DECLARATION,
            property: $8c443c74d39aad73$var$trim(prop[0].replace($8c443c74d39aad73$var$COMMENT_REGEX, $8c443c74d39aad73$var$EMPTY_STRING)),
            value: val ? $8c443c74d39aad73$var$trim(val[0].replace($8c443c74d39aad73$var$COMMENT_REGEX, $8c443c74d39aad73$var$EMPTY_STRING)) : $8c443c74d39aad73$var$EMPTY_STRING
        });
        // ;
        match($8c443c74d39aad73$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $8c443c74d39aad73$var$trim(str) {
    return str ? str.replace($8c443c74d39aad73$var$TRIM_REGEX, $8c443c74d39aad73$var$EMPTY_STRING) : $8c443c74d39aad73$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $24477d961949f00d$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== 'string') return output;
    var declaration;
    var declarations = $8c443c74d39aad73$exports(style);
    var hasIterator = typeof iterator === 'function';
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$24477d961949f00d$exports = $24477d961949f00d$var$StyleToObject;


const $c185a3685fd00532$var$own = {}.hasOwnProperty;
// The table-related elements that must not contain whitespace text according
// to React.
const $c185a3685fd00532$var$tableElements = new Set([
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr'
]);
function $c185a3685fd00532$export$4b745c302603ab5d(context, node) {
    /** @type {Array<ReactNode>} */ const children = [];
    let childIndex = -1;
    /** @type {Comment|Doctype|Element|Raw|Text} */ let child;
    while(++childIndex < node.children.length){
        child = node.children[childIndex];
        if (child.type === 'element') children.push($c185a3685fd00532$var$toReact(context, child, childIndex, node));
        else if (child.type === 'text') // Currently, a warning is triggered by react for *any* white space in
        // tables.
        // So we drop it.
        // See: <https://github.com/facebook/react/pull/7081>.
        // See: <https://github.com/facebook/react/pull/7515>.
        // See: <https://github.com/remarkjs/remark-react/issues/64>.
        // See: <https://github.com/remarkjs/react-markdown/issues/576>.
        {
            if (node.type !== 'element' || !$c185a3685fd00532$var$tableElements.has(node.tagName) || !(0, $1a7de79656976693$export$7af1228ff777d175)(child)) children.push(child.value);
        } else if (child.type === 'raw' && !context.options.skipHtml) // Default behavior is to show (encoded) HTML.
        children.push(child.value);
    }
    return children;
}
/**
 * @param {Context} context
 * @param {Element} node
 * @param {number} index
 * @param {Element|Root} parent
 */ function $c185a3685fd00532$var$toReact(context, node, index, parent) {
    const options = context.options;
    const parentSchema = context.schema;
    /** @type {ReactMarkdownNames} */ // @ts-expect-error assume a known HTML/SVG element.
    const name = node.tagName;
    /** @type {Record<string, unknown>} */ const properties = {};
    let schema = parentSchema;
    /** @type {string} */ let property;
    if (parentSchema.space === 'html' && name === 'svg') {
        schema = (0, $9bc4618a7f6e713d$export$7ed1367e7fa1ad68);
        context.schema = schema;
    }
    if (node.properties) {
        for(property in node.properties)if ($c185a3685fd00532$var$own.call(node.properties, property)) $c185a3685fd00532$var$addProperty(properties, property, node.properties[property], context);
    }
    if (name === 'ol' || name === 'ul') context.listDepth++;
    const children = $c185a3685fd00532$export$4b745c302603ab5d(context, node);
    if (name === 'ol' || name === 'ul') context.listDepth--;
    // Restore parent schema.
    context.schema = parentSchema;
    // Nodes created by plugins do not have positional info, in which case we use
    // an object that matches the position interface.
    const position = node.position || {
        start: {
            line: null,
            column: null,
            offset: null
        },
        end: {
            line: null,
            column: null,
            offset: null
        }
    };
    const component = options.components && $c185a3685fd00532$var$own.call(options.components, name) ? options.components[name] : name;
    const basic = typeof component === 'string' || component === (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Fragment;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($cf5c8e2b8685c48a$exports))).isValidElementType(component)) throw new TypeError(`Component for name \`${name}\` not defined or is not renderable`);
    properties.key = [
        name,
        position.start.line,
        position.start.column,
        index
    ].join('-');
    if (name === 'a' && options.linkTarget) properties.target = typeof options.linkTarget === 'function' ? options.linkTarget(String(properties.href || ''), node.children, typeof properties.title === 'string' ? properties.title : null) : options.linkTarget;
    if (name === 'a' && options.transformLinkUri) properties.href = options.transformLinkUri(String(properties.href || ''), node.children, typeof properties.title === 'string' ? properties.title : null);
    if (!basic && name === 'code' && parent.type === 'element' && parent.tagName !== 'pre') properties.inline = true;
    if (!basic && (name === 'h1' || name === 'h2' || name === 'h3' || name === 'h4' || name === 'h5' || name === 'h6')) properties.level = Number.parseInt(name.charAt(1), 10);
    if (name === 'img' && options.transformImageUri) properties.src = options.transformImageUri(String(properties.src || ''), String(properties.alt || ''), typeof properties.title === 'string' ? properties.title : null);
    if (!basic && name === 'li' && parent.type === 'element') {
        const input = $c185a3685fd00532$var$getInputElement(node);
        properties.checked = input && input.properties ? Boolean(input.properties.checked) : null;
        properties.index = $c185a3685fd00532$var$getElementsBeforeCount(parent, node);
        properties.ordered = parent.tagName === 'ol';
    }
    if (!basic && (name === 'ol' || name === 'ul')) {
        properties.ordered = name === 'ol';
        properties.depth = context.listDepth;
    }
    if (name === 'td' || name === 'th') {
        if (properties.align) {
            if (!properties.style) properties.style = {};
            // @ts-expect-error assume `style` is an object
            properties.style.textAlign = properties.align;
            delete properties.align;
        }
        if (!basic) properties.isHeader = name === 'th';
    }
    if (!basic && name === 'tr' && parent.type === 'element') properties.isHeader = Boolean(parent.tagName === 'thead');
    // If `sourcePos` is given, pass source information (line/column info from markdown source).
    if (options.sourcePos) properties['data-sourcepos'] = $c185a3685fd00532$var$flattenPosition(position);
    if (!basic && options.rawSourcePos) properties.sourcePosition = node.position;
    // If `includeElementIndex` is given, pass node index info to components.
    if (!basic && options.includeElementIndex) {
        properties.index = $c185a3685fd00532$var$getElementsBeforeCount(parent, node);
        properties.siblingCount = $c185a3685fd00532$var$getElementsBeforeCount(parent);
    }
    if (!basic) properties.node = node;
    // Ensure no React warnings are emitted for void elements w/ children.
    return children.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(component, properties, children) : (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement(component, properties);
}
/**
 * @param {Element|Root} node
 * @returns {Element?}
 */ function $c185a3685fd00532$var$getInputElement(node) {
    let index = -1;
    while(++index < node.children.length){
        const child = node.children[index];
        if (child.type === 'element' && child.tagName === 'input') return child;
    }
    return null;
}
/**
 * @param {Element|Root} parent
 * @param {Element} [node]
 * @returns {number}
 */ function $c185a3685fd00532$var$getElementsBeforeCount(parent, node) {
    let index = -1;
    let count = 0;
    while(++index < parent.children.length){
        if (parent.children[index] === node) break;
        if (parent.children[index].type === 'element') count++;
    }
    return count;
}
/**
 * @param {Record<string, unknown>} props
 * @param {string} prop
 * @param {unknown} value
 * @param {Context} ctx
 */ function $c185a3685fd00532$var$addProperty(props, prop, value, ctx) {
    const info = (0, $453db58efd5c7ac0$export$71aa6c912b956294)(ctx.schema, prop);
    let result = value;
    // Ignore nullish and `NaN` values.
    // eslint-disable-next-line no-self-compare
    if (result === null || result === undefined || result !== result) return;
    // Accept `array`.
    // Most props are space-separated.
    if (Array.isArray(result)) result = info.commaSeparated ? (0, $7ae77a5ec40be267$export$fac44ee5b035f737)(result) : (0, $71c7202b4e4c47aa$export$fac44ee5b035f737)(result);
    if (info.property === 'style' && typeof result === 'string') result = $c185a3685fd00532$var$parseStyle(result);
    if (info.space && info.property) props[$c185a3685fd00532$var$own.call((0, $38749de17a8500d7$export$d8abd7e5fb6871f9), info.property) ? (0, $38749de17a8500d7$export$d8abd7e5fb6871f9)[info.property] : info.property] = result;
    else if (info.attribute) props[info.attribute] = result;
}
/**
 * @param {string} value
 * @returns {Record<string, string>}
 */ function $c185a3685fd00532$var$parseStyle(value) {
    /** @type {Record<string, string>} */ const result = {};
    try {
        (0, (/*@__PURE__*/$parcel$interopDefault($24477d961949f00d$exports)))(value, iterator);
    } catch  {
    // Silent.
    }
    return result;
    /**
   * @param {string} name
   * @param {string} v
   */ function iterator(name, v) {
        const k = name.slice(0, 4) === '-ms-' ? `ms-${name.slice(4)}` : name;
        result[k.replace(/-([a-z])/g, $c185a3685fd00532$var$styleReplacer)] = v;
    }
}
/**
 * @param {unknown} _
 * @param {string} $1
 */ function $c185a3685fd00532$var$styleReplacer(_, $1) {
    return $1.toUpperCase();
}
/**
 * @param {Position|{start: {line: null, column: null, offset: null}, end: {line: null, column: null, offset: null}}} pos
 * @returns {string}
 */ function $c185a3685fd00532$var$flattenPosition(pos) {
    return [
        pos.start.line,
        ':',
        pos.start.column,
        '-',
        pos.end.line,
        ':',
        pos.end.column
    ].map((d)=>String(d)).join('');
}


const $5cc10c261dcd52a9$var$own = {}.hasOwnProperty;
const $5cc10c261dcd52a9$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {Record<string, Deprecation>} */ const $5cc10c261dcd52a9$var$deprecated = {
    plugins: {
        to: 'plugins',
        id: 'change-plugins-to-remarkplugins'
    },
    renderers: {
        to: 'components',
        id: 'change-renderers-to-components'
    },
    astPlugins: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    allowDangerousHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    escapeHtml: {
        id: 'remove-buggy-html-in-markdown-parser'
    },
    source: {
        to: 'children',
        id: 'change-source-to-children'
    },
    allowNode: {
        to: 'allowElement',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    allowedTypes: {
        to: 'allowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    disallowedTypes: {
        to: 'disallowedElements',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes'
    },
    includeNodeIndex: {
        to: 'includeElementIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    }
};
function $5cc10c261dcd52a9$export$83ef7ab426386201(options) {
    for(const key in $5cc10c261dcd52a9$var$deprecated)if ($5cc10c261dcd52a9$var$own.call($5cc10c261dcd52a9$var$deprecated, key) && $5cc10c261dcd52a9$var$own.call(options, key)) {
        const deprecation = $5cc10c261dcd52a9$var$deprecated[key];
        console.warn(`[react-markdown] Warning: please ${deprecation.to ? `use \`${deprecation.to}\` instead of` : 'remove'} \`${key}\` (see <${$5cc10c261dcd52a9$var$changelog}#${deprecation.id}> for more info)`);
        delete $5cc10c261dcd52a9$var$deprecated[key];
    }
    const processor = (0, $18b4b78c0087b74e$export$7cc1b2fe10c52bb)().use((0, $f8afdb2a14a0af6e$export$2e2bcd8739ae039)).use(options.remarkPlugins || []).use((0, $f192f06803e471a7$export$2e2bcd8739ae039), {
        ...options.remarkRehypeOptions,
        allowDangerousHtml: true
    }).use(options.rehypePlugins || []).use((0, $57f7f33b1833379a$export$2e2bcd8739ae039), options);
    const file = new (0, $64ce9a830b94da6b$export$93dff69eb10dc7ce)();
    if (typeof options.children === 'string') file.value = options.children;
    else if (options.children !== undefined && options.children !== null) console.warn(`[react-markdown] Warning: please pass a string as \`children\` (not: \`${options.children}\`)`);
    const hastNode = processor.runSync(processor.parse(file), file);
    if (hastNode.type !== 'root') throw new TypeError('Expected a `root` node');
    /** @type {ReactElement} */ let result = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).Fragment, {}, (0, $c185a3685fd00532$export$4b745c302603ab5d)({
        options: options,
        schema: (0, $9bc4618a7f6e713d$export$c0bb0b647f701bb5),
        listDepth: 0
    }, hastNode));
    if (options.className) result = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).createElement('div', {
        className: options.className
    }, result);
    return result;
}
$5cc10c261dcd52a9$export$83ef7ab426386201.defaultProps = {
    transformLinkUri: (0, $d10af7cc97e9e1f1$export$b83532a10e2e268b)
};
$5cc10c261dcd52a9$export$83ef7ab426386201.propTypes = {
    // Core options:
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    // Layout options:
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string,
    // Filter options:
    allowElement: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
    allowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string),
    disallowedElements: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string),
    unwrapDisallowed: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    // Plugin options:
    remarkPlugins: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func
        ]))
    ])),
    rehypePlugins: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func
        ]))
    ])),
    // Transform options:
    sourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    rawSourcePos: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    skipHtml: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    includeElementIndex: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool,
    transformLinkUri: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).bool
    ]),
    linkTarget: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).string
    ]),
    transformImageUri: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).func,
    components: (0, (/*@__PURE__*/$parcel$interopDefault($4RND8))).object
};



var $4z7Fu = parcelRequire("4z7Fu");
/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $bad8a7c243b10dbb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 8V4H8",
            key: "hb8ula"
        }
    ],
    [
        "rect",
        {
            width: "16",
            height: "12",
            x: "4",
            y: "8",
            rx: "2",
            key: "enze0r"
        }
    ],
    [
        "path",
        {
            d: "M2 14h2",
            key: "vft8re"
        }
    ],
    [
        "path",
        {
            d: "M20 14h2",
            key: "4cs60a"
        }
    ],
    [
        "path",
        {
            d: "M15 13v2",
            key: "1xurst"
        }
    ],
    [
        "path",
        {
            d: "M9 13v2",
            key: "rq6x2g"
        }
    ]
];
const $bad8a7c243b10dbb$export$2e2bcd8739ae039 = (0, $983Jy.default)("bot", $bad8a7c243b10dbb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $c329e3326d2a5663$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $c329e3326d2a5663$export$2e2bcd8739ae039 = (0, $983Jy.default)("check", $c329e3326d2a5663$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $d972ae301a892fb8$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "14",
            height: "14",
            x: "8",
            y: "8",
            rx: "2",
            ry: "2",
            key: "17jyea"
        }
    ],
    [
        "path",
        {
            d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
            key: "zix9uf"
        }
    ]
];
const $d972ae301a892fb8$export$2e2bcd8739ae039 = (0, $983Jy.default)("copy", $d972ae301a892fb8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $47b7b1d982241a98$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.992 16.342a2 2 0 0 1 .094 1.167l-1.065 3.29a1 1 0 0 0 1.236 1.168l3.413-.998a2 2 0 0 1 1.099.092 10 10 0 1 0-4.777-4.719",
            key: "1sd12s"
        }
    ]
];
const $47b7b1d982241a98$export$2e2bcd8739ae039 = (0, $983Jy.default)("message-circle", $47b7b1d982241a98$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $6a7bcb24cac3449c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
            key: "1357e3"
        }
    ],
    [
        "path",
        {
            d: "M3 3v5h5",
            key: "1xhq8a"
        }
    ]
];
const $6a7bcb24cac3449c$export$2e2bcd8739ae039 = (0, $983Jy.default)("rotate-ccw", $6a7bcb24cac3449c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $dcef6361543bf9cb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
];
const $dcef6361543bf9cb$export$2e2bcd8739ae039 = (0, $983Jy.default)("send", $dcef6361543bf9cb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $f8a9a242037f3b30$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
            key: "1s2grr"
        }
    ],
    [
        "path",
        {
            d: "M20 2v4",
            key: "1rf3ol"
        }
    ],
    [
        "path",
        {
            d: "M22 4h-4",
            key: "gwowj6"
        }
    ],
    [
        "circle",
        {
            cx: "4",
            cy: "20",
            r: "2",
            key: "6kqj1y"
        }
    ]
];
const $f8a9a242037f3b30$export$2e2bcd8739ae039 = (0, $983Jy.default)("sparkles", $f8a9a242037f3b30$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.576.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $983Jy = parcelRequire("983Jy");
const $69638a011892dd69$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $69638a011892dd69$export$2e2bcd8739ae039 = (0, $983Jy.default)("user", $69638a011892dd69$export$3efd853dbb351e94);


var $foLar = parcelRequire("foLar");

var $l2Ecb = parcelRequire("l2Ecb");

const $96ae83ea73c687c3$var$chatRoute = `${(0, $l2Ecb.getApiServer)()}/qep-mcp/v1/chat/completions`;
const $96ae83ea73c687c3$var$chatModel = 'qep-assistant';
const $96ae83ea73c687c3$var$maximumPromptLength = 2000;
/** Converts completed rendered turns plus one prompt into the provider-neutral chat message contract. */ function $96ae83ea73c687c3$var$buildChatCompletionMessages(history, prompt) {
    const completionMessages = [];
    for (const message of history)if (message.status === 'complete') completionMessages.push({
        role: message.role,
        content: message.content
    });
    completionMessages.push({
        role: 'user',
        content: prompt
    });
    return completionMessages;
}
/** Narrows an unknown value to a non-array record for response-boundary validation. */ function $96ae83ea73c687c3$var$isRecord(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
/** Maps a trusted HTTP status to safe user text without rendering provider-controlled error payloads. */ function $96ae83ea73c687c3$var$readChatErrorMessage(error) {
    if ($96ae83ea73c687c3$var$isRecord(error) && error.status === 429) return 'Error: The chatbot is rate limited. Please wait a moment and try again.';
    return 'Error: Unable to fetch response.';
}
/** Narrows an unknown value to an array whose entries remain untrusted. */ function $96ae83ea73c687c3$var$isUnknownArray(value) {
    return Array.isArray(value);
}
/** Extracts non-empty assistant text from an untrusted OpenAI-compatible completion response. */ function $96ae83ea73c687c3$var$readAssistantContent(value) {
    if (!$96ae83ea73c687c3$var$isRecord(value) || !$96ae83ea73c687c3$var$isUnknownArray(value.choices)) return undefined;
    const firstChoice = value.choices[0];
    if (!$96ae83ea73c687c3$var$isRecord(firstChoice) || !$96ae83ea73c687c3$var$isRecord(firstChoice.message)) return undefined;
    const { content: content } = firstChoice.message;
    return typeof content === 'string' && content.trim() ? content : undefined;
}
/** Parses one Chat storage entry, removing malformed JSON so later mounts can recover. */ function $96ae83ea73c687c3$var$readStoredJson(key) {
    const storedValue = localStorage.getItem(key);
    if (!storedValue) return undefined;
    try {
        return JSON.parse(storedValue);
    } catch  {
        localStorage.removeItem(key);
        return undefined;
    }
}
/** Checks that persisted icon coordinates are finite numbers before viewport constraints are applied. */ function $96ae83ea73c687c3$var$isChatIconPosition(value) {
    if (!value || typeof value !== 'object') return false;
    const position = value;
    return typeof position.x === 'number' && Number.isFinite(position.x) && typeof position.y === 'number' && Number.isFinite(position.y);
}
/** Constrains a launcher position to the visible viewport and returns safe coordinates. */ function $96ae83ea73c687c3$var$constrainChatIconPosition(position) {
    const maximumX = Math.max(0, window.innerWidth - 70);
    const maximumY = Math.max(0, window.innerHeight - 70);
    return {
        x: Math.max(0, Math.min(position.x, maximumX)),
        y: Math.max(0, Math.min(position.y, maximumY))
    };
}
/** Calculates a responsive panel position beside the launcher while keeping the entire panel visible. */ function $96ae83ea73c687c3$var$calculateChatWindowPosition(iconPosition) {
    const panelWidth = Math.min(420, window.innerWidth - 24);
    const panelHeight = Math.min(640, window.innerHeight - 24);
    const iconSize = 52;
    const gap = 12;
    const edge = 12;
    const spaceAbove = iconPosition.y;
    const spaceLeft = iconPosition.x;
    const top = spaceAbove >= panelHeight + gap ? iconPosition.y - panelHeight - gap : Math.min(iconPosition.y + iconSize + gap, window.innerHeight - panelHeight - edge);
    const left = spaceLeft >= panelWidth + gap ? iconPosition.x - panelWidth - gap : Math.min(iconPosition.x + iconSize + gap, window.innerWidth - panelWidth - edge);
    return {
        x: Math.max(edge, left),
        y: Math.max(edge, top)
    };
}
/** Replaces one message by identifier without mutating React state or depending on array ordering. */ function $96ae83ea73c687c3$var$replaceChatMessage(history, messageId, replacement) {
    const updatedHistory = [];
    for (const message of history)updatedHistory.push(message.id === messageId ? replacement : message);
    return updatedHistory;
}
/** Reports whether the rendered conversation currently contains an in-flight assistant turn. */ function $96ae83ea73c687c3$var$hasLoadingMessage(history) {
    for (const message of history){
        if (message.status === 'loading') return true;
    }
    return false;
}
/** Renders the draggable Browser assistant while persisting only its non-sensitive launcher position. */ const $96ae83ea73c687c3$var$Chat = ()=>{
    const [isOpen, setIsOpen] = (0, $lx97N.useState)(false);
    const [messages, setMessages] = (0, $lx97N.useState)([]);
    const [input, setInput] = (0, $lx97N.useState)('');
    const [copiedMessageId, setCopiedMessageId] = (0, $lx97N.useState)();
    const [copyErrorMessageId, setCopyErrorMessageId] = (0, $lx97N.useState)();
    const nextMessageId = (0, $lx97N.useRef)(1);
    const inputRef = (0, $lx97N.useRef)(null);
    const messagesEndRef = (0, $lx97N.useRef)(null);
    const loading = $96ae83ea73c687c3$var$hasLoadingMessage(messages);
    const [iconPosition, setIconPosition] = (0, $lx97N.useState)(()=>{
        const savedPosition = $96ae83ea73c687c3$var$readStoredJson('chatIconPosition');
        const initialPosition = $96ae83ea73c687c3$var$isChatIconPosition(savedPosition) ? savedPosition : {
            x: window.innerWidth - 70,
            y: window.innerHeight - 70
        };
        return $96ae83ea73c687c3$var$constrainChatIconPosition(initialPosition);
    });
    /** Toggles the assistant panel without clearing its session-local conversation. */ const toggleChat = ()=>{
        setIsOpen((previousIsOpen)=>!previousIsOpen);
    };
    (0, $lx97N.useEffect)(()=>{
        // Conversation data from earlier builds is removed so another authenticated user cannot inherit it.
        localStorage.removeItem('chatMessages');
    }, []);
    (0, $lx97N.useEffect)(()=>{
        /** Keeps the launcher reachable when the browser viewport changes size. */ const handleResize = ()=>{
            setIconPosition((previousPosition)=>$96ae83ea73c687c3$var$constrainChatIconPosition(previousPosition));
        };
        /** Removes the viewport listener when the assistant unmounts. */ const removeResizeListener = ()=>{
            window.removeEventListener('resize', handleResize);
        };
        window.addEventListener('resize', handleResize);
        return removeResizeListener;
    }, []);
    (0, $lx97N.useEffect)(()=>{
        // Launcher placement is non-sensitive and survives reloads independently of chat text.
        localStorage.setItem('chatIconPosition', JSON.stringify(iconPosition));
    }, [
        iconPosition
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (isOpen) inputRef.current?.focus();
    }, [
        isOpen
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (!isOpen) return undefined;
        /** Closes the panel from anywhere in the window while leaving its conversation intact. */ const handleEscape = (event)=>{
            if (event.key === 'Escape') setIsOpen(false);
        };
        /** Removes the keyboard listener whenever the panel closes or unmounts. */ const removeEscapeListener = ()=>{
            globalThis.removeEventListener('keydown', handleEscape);
        };
        globalThis.addEventListener('keydown', handleEscape);
        return removeEscapeListener;
    }, [
        isOpen
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (isOpen && messages.length > 0) messagesEndRef.current?.scrollIntoView?.({
            behavior: 'smooth',
            block: 'end'
        });
    }, [
        isOpen,
        messages
    ]);
    /** Opens or closes the launcher from Enter or Space while preserving mouse drag behavior. */ const handleLauncherKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleChat();
        }
    };
    /** Tracks a launcher mouse gesture, moving on drag or toggling the panel on a stationary click. */ const handleDragStart = (event)=>{
        if (event.button !== 0) return;
        let isDragging = false;
        const startX = event.clientX - iconPosition.x;
        const startY = event.clientY - iconPosition.y;
        const overlay = document.createElement('div');
        overlay.className = 'chat-drag-overlay';
        document.body.append(overlay);
        /** Moves the launcher with the pointer and constrains it to the visible viewport. */ const handleDragMove = (moveEvent)=>{
            isDragging = true;
            setIconPosition($96ae83ea73c687c3$var$constrainChatIconPosition({
                x: moveEvent.clientX - startX,
                y: moveEvent.clientY - startY
            }));
        };
        /** Cleans up document listeners and treats a no-movement gesture as launcher activation. */ const handleDragEnd = ()=>{
            document.removeEventListener('mousemove', handleDragMove);
            document.removeEventListener('mouseup', handleDragEnd);
            overlay.remove();
            if (!isDragging) toggleChat();
        };
        document.addEventListener('mousemove', handleDragMove);
        document.addEventListener('mouseup', handleDragEnd);
    };
    /** Sends one credentialed non-streaming completion and resolves its placeholder with safe text. */ const getChatResponse = async (completionMessages, responseMessageId)=>{
        try {
            const chatResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($4z7Fu))).post($96ae83ea73c687c3$var$chatRoute).withCredentials().send({
                model: $96ae83ea73c687c3$var$chatModel,
                messages: completionMessages
            }).set('Accept', 'application/json');
            const chatResponseContent = $96ae83ea73c687c3$var$readAssistantContent(chatResponse.body);
            if (!chatResponseContent) throw new Error('Invalid chat completion response');
            const replacement = {
                id: responseMessageId,
                role: 'assistant',
                content: chatResponseContent,
                status: 'complete'
            };
            setMessages((previousMessages)=>$96ae83ea73c687c3$var$replaceChatMessage(previousMessages, responseMessageId, replacement));
        } catch (error) {
            console.error('Error in chat request');
            const replacement = {
                id: responseMessageId,
                role: 'assistant',
                content: $96ae83ea73c687c3$var$readChatErrorMessage(error),
                status: 'error'
            };
            setMessages((previousMessages)=>$96ae83ea73c687c3$var$replaceChatMessage(previousMessages, responseMessageId, replacement));
        }
    };
    /** Queues one trimmed prompt and starts a completion using history captured before submission. */ const submitPrompt = (requestedPrompt = input)=>{
        const prompt = requestedPrompt.trim();
        if (!prompt || loading) return;
        const userMessage = {
            id: nextMessageId.current,
            role: 'user',
            content: prompt,
            status: 'complete'
        };
        nextMessageId.current += 1;
        const assistantMessage = {
            id: nextMessageId.current,
            role: 'assistant',
            content: '',
            status: 'loading'
        };
        nextMessageId.current += 1;
        const completionMessages = $96ae83ea73c687c3$var$buildChatCompletionMessages(messages, prompt);
        setMessages((previousMessages)=>[
                ...previousMessages,
                userMessage,
                assistantMessage
            ]);
        setInput('');
        setCopiedMessageId(undefined);
        setCopyErrorMessageId(undefined);
        getChatResponse(completionMessages, assistantMessage.id);
    };
    /** Submits the controlled composer while preventing browser form navigation. */ const handleFormSubmit = (event)=>{
        event.preventDefault();
        submitPrompt();
    };
    /** Synchronizes the controlled composer with user-entered text up to its declared limit. */ const handleInputChange = (event)=>{
        setInput(event.target.value);
    };
    /** Sends on unmodified Enter while preserving Shift+Enter and IME composition for multiline text. */ const handleComposerKeyDown = (event)=>{
        if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
            event.preventDefault();
            submitPrompt();
        }
    };
    /** Submits the visible suggestion stored on its button through the normal prompt flow. */ const handleSuggestedPrompt = (event)=>{
        const { prompt: prompt } = event.currentTarget.dataset;
        if (prompt) submitPrompt(prompt);
    };
    /** Clears the in-memory conversation after confirmation and returns focus to the composer. */ const handleNewChat = ()=>{
        // Browser confirmation prevents accidental loss of the intentionally non-persisted conversation.
        // eslint-disable-next-line no-alert
        if (messages.length > 0 && !globalThis.confirm('Start a new chat? This conversation will be cleared.')) return;
        setMessages([]);
        setInput('');
        setCopiedMessageId(undefined);
        setCopyErrorMessageId(undefined);
        inputRef.current?.focus();
    };
    /** Copies one completed assistant response and records success or failure for accessible feedback. */ const copyAssistantResponse = async (messageId)=>{
        let selectedMessage;
        for (const message of messages)if (String(message.id) === messageId && message.role === 'assistant' && message.status === 'complete') {
            selectedMessage = message;
            break;
        }
        if (!selectedMessage) return;
        try {
            await navigator.clipboard.writeText(selectedMessage.content);
            setCopiedMessageId(selectedMessage.id);
            setCopyErrorMessageId(undefined);
        } catch  {
            setCopyErrorMessageId(selectedMessage.id);
            setCopiedMessageId(undefined);
        }
    };
    /** Starts the asynchronous clipboard action for the assistant message identified by the clicked control. */ const handleCopyResponse = (event)=>{
        const { messageId: messageId } = event.currentTarget.dataset;
        if (messageId) copyAssistantResponse(messageId);
    };
    /** Builds the visible conversation rows with role identity, Markdown, loading state, and copy feedback. */ const renderMessages = ()=>{
        const renderedMessages = [];
        for (const message of messages){
            const isAssistant = message.role === 'assistant';
            const isCopied = copiedMessageId === message.id;
            const hasCopyError = copyErrorMessageId === message.id;
            let messageContent;
            if (message.status === 'loading') messageContent = /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                className: "chat-thinking",
                role: "status",
                "aria-live": "polite",
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        children: "QEP Assistant is thinking"
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                        className: "chat-thinking-dots",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("i", {}),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("i", {}),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("i", {})
                        ]
                    })
                ]
            });
            else if (isAssistant) messageContent = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $5cc10c261dcd52a9$export$83ef7ab426386201), {
                children: message.content
            });
            else messageContent = /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                children: message.content
            });
            let copyButtonText = 'Copy';
            if (isCopied) copyButtonText = 'Copied';
            else if (hasCopyError) copyButtonText = 'Try again';
            const renderedMessage = /*#__PURE__*/ (0, $fRwNr.jsxs)("article", {
                className: `chat-message-row chat-message-row--${message.role}`,
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        className: "chat-message-avatar",
                        "aria-hidden": "true",
                        children: isAssistant ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $bad8a7c243b10dbb$export$2e2bcd8739ae039), {
                            size: 16
                        }) : /*#__PURE__*/ (0, $fRwNr.jsx)((0, $69638a011892dd69$export$2e2bcd8739ae039), {
                            size: 16
                        })
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "chat-message-stack",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                className: "chat-message-author",
                                children: isAssistant ? 'QEP Assistant' : 'You'
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                className: `chat-message chat-message--${message.role} chat-message--${message.status}`,
                                children: [
                                    messageContent,
                                    isAssistant && message.status === 'complete' ? /*#__PURE__*/ (0, $fRwNr.jsxs)("button", {
                                        type: "button",
                                        className: `chat-copy-button${isCopied ? ' chat-copy-button--copied' : ''}`,
                                        "aria-label": isCopied ? 'Response copied' : 'Copy response',
                                        "data-message-id": message.id,
                                        onClick: handleCopyResponse,
                                        children: [
                                            isCopied ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $c329e3326d2a5663$export$2e2bcd8739ae039), {
                                                size: 14
                                            }) : /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d972ae301a892fb8$export$2e2bcd8739ae039), {
                                                size: 14
                                            }),
                                            /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                                children: copyButtonText
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            }, message.id);
            renderedMessages.push(renderedMessage);
        }
        return renderedMessages;
    };
    const chatWindowPosition = $96ae83ea73c687c3$var$calculateChatWindowPosition(iconPosition);
    return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
        className: "chat-container",
        children: [
            isOpen ? /*#__PURE__*/ (0, $fRwNr.jsxs)("section", {
                id: "qep-assistant-dialog",
                className: "chat-window",
                role: "dialog",
                "aria-modal": "false",
                "aria-labelledby": "qep-assistant-title",
                style: {
                    left: `${chatWindowPosition.x}px`,
                    top: `${chatWindowPosition.y}px`
                },
                children: [
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("header", {
                        className: "chat-header",
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                className: "chat-brand-mark",
                                "aria-hidden": "true",
                                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f8a9a242037f3b30$export$2e2bcd8739ae039), {
                                    size: 19
                                })
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                className: "chat-heading",
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("h2", {
                                        id: "qep-assistant-title",
                                        children: "QEP Assistant"
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                                        className: "chat-presence",
                                        children: [
                                            /*#__PURE__*/ (0, $fRwNr.jsx)("i", {
                                                "aria-hidden": "true"
                                            }),
                                            "Online"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                className: "chat-header-actions",
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                                        type: "button",
                                        className: "chat-header-button",
                                        "aria-label": "Start a new chat",
                                        disabled: loading,
                                        onClick: handleNewChat,
                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $6a7bcb24cac3449c$export$2e2bcd8739ae039), {
                                            size: 17
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                                        type: "button",
                                        className: "chat-header-button",
                                        "aria-label": "Close QEP Assistant",
                                        onClick: toggleChat,
                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $foLar.default), {
                                            size: 19
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                        className: "chat-messages",
                        "aria-live": "polite",
                        children: [
                            messages.length === 0 ? /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                className: "chat-welcome",
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                        className: "chat-welcome-icon",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f8a9a242037f3b30$export$2e2bcd8739ae039), {
                                            size: 24
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                        className: "chat-eyebrow",
                                        children: "Your QEP copilot"
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("h3", {
                                        children: "How can I help?"
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                        className: "chat-welcome-copy",
                                        children: "Ask about your positions, orders, or what needs attention across your workspace."
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                        className: "chat-suggestions",
                                        "aria-label": "Suggested prompts",
                                        children: [
                                            /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                                                type: "button",
                                                "data-prompt": "Summarize my positions",
                                                onClick: handleSuggestedPrompt,
                                                children: "Summarize my positions"
                                            }),
                                            /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                                                type: "button",
                                                "data-prompt": "Show my open orders",
                                                onClick: handleSuggestedPrompt,
                                                children: "Show my open orders"
                                            }),
                                            /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                                                type: "button",
                                                "data-prompt": "What needs my attention?",
                                                onClick: handleSuggestedPrompt,
                                                children: "What needs my attention?"
                                            })
                                        ]
                                    })
                                ]
                            }) : renderMessages(),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                ref: messagesEndRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsxs)("form", {
                        className: "chat-form",
                        onSubmit: handleFormSubmit,
                        children: [
                            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                className: "chat-composer",
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("label", {
                                        className: "chat-visually-hidden",
                                        htmlFor: "qep-assistant-input",
                                        children: "Message QEP Assistant"
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("textarea", {
                                        id: "qep-assistant-input",
                                        ref: inputRef,
                                        value: input,
                                        onChange: handleInputChange,
                                        onKeyDown: handleComposerKeyDown,
                                        className: "chat-input",
                                        placeholder: "Ask QEP Assistant...",
                                        rows: 2,
                                        maxLength: $96ae83ea73c687c3$var$maximumPromptLength,
                                        disabled: loading
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                                        type: "submit",
                                        className: "chat-submit",
                                        "aria-label": "Send message",
                                        disabled: loading || !input.trim(),
                                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $dcef6361543bf9cb$export$2e2bcd8739ae039), {
                                            size: 18
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                                className: "chat-composer-meta",
                                children: [
                                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                                        children: "Enter to send \xb7 Shift+Enter for a new line"
                                    }),
                                    /*#__PURE__*/ (0, $fRwNr.jsxs)("span", {
                                        children: [
                                            input.length,
                                            "/",
                                            $96ae83ea73c687c3$var$maximumPromptLength
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fRwNr.jsx)("p", {
                                className: "chat-disclaimer",
                                children: "AI responses may be inaccurate. Verify important details."
                            })
                        ]
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $fRwNr.jsxs)("button", {
                type: "button",
                className: "chat-icon",
                "aria-label": isOpen ? 'Close QEP Assistant' : 'Open QEP Assistant',
                "aria-expanded": isOpen,
                "aria-controls": "qep-assistant-dialog",
                title: "QEP Assistant \u2014 drag to move",
                style: {
                    left: `${iconPosition.x}px`,
                    top: `${iconPosition.y}px`
                },
                onMouseDown: handleDragStart,
                onKeyDown: handleLauncherKeyDown,
                children: [
                    isOpen ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $foLar.default), {
                        size: 23
                    }) : /*#__PURE__*/ (0, $fRwNr.jsx)((0, $47b7b1d982241a98$export$2e2bcd8739ae039), {
                        size: 24
                    }),
                    /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
                        className: "chat-icon-spark",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f8a9a242037f3b30$export$2e2bcd8739ae039), {
                            size: 10
                        })
                    })
                ]
            })
        ]
    });
};
var $96ae83ea73c687c3$export$2e2bcd8739ae039 = $96ae83ea73c687c3$var$Chat;




const $36b83affa0bb2ccb$var$getWindowBrowserClient = ()=>(0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().applicationClient;
const $36b83affa0bb2ccb$export$587f97f149daf0ce = async (windowId)=>{
    const browserClient = $36b83affa0bb2ccb$var$getWindowBrowserClient();
    const browserContextId = String(browserClient.browserContextId);
    await browserClient.broadcast(browserClient.APPLICATION_EVENTS.WINDOW.SELECT_WINDOW.topic, {
        browserContextId: browserContextId,
        windowId: windowId
    });
};
const $36b83affa0bb2ccb$export$4ac7ac3505f26fae = async (windowId)=>{
    const browserClient = $36b83affa0bb2ccb$var$getWindowBrowserClient();
    const browserContextId = String(browserClient.browserContextId);
    browserClient.publish(browserClient.APPLICATION_EVENTS.WINDOW.CLOSE_WINDOW.topic, {
        browserContextId: browserContextId,
        windowId: windowId
    });
};


const $723a57945d1b80ed$var$fields = [
    'Name',
    'Field1',
    'Field2',
    'Field3',
    'Field4',
    'Field5'
];
const $723a57945d1b80ed$var$allowedWorkspaceHtmlTags = new Set([
    'a',
    'b',
    'blockquote',
    'br',
    'code',
    'div',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'i',
    'li',
    'ol',
    'p',
    'pre',
    's',
    'span',
    'strong',
    'table',
    'tbody',
    'td',
    'th',
    'thead',
    'tr',
    'u',
    'ul'
]);
const $723a57945d1b80ed$var$allowedWorkspaceHtmlAttributes = new Set([
    'class',
    'colspan',
    'href',
    'rel',
    'rowspan',
    'target',
    'title'
]);
const $723a57945d1b80ed$var$allowedWorkspaceLinkProtocols = new Set([
    'http:',
    'https:',
    'mailto:'
]);
/**
 * Reports whether a workspace link resolves to an explicitly supported non-script protocol.
 */ const $723a57945d1b80ed$var$isSafeWorkspaceLink = (rawHref)=>{
    try {
        // eslint-disable-next-line no-control-regex -- Browser URL parsing ignores these obfuscating control characters.
        const compactHref = rawHref.replaceAll(/[\u0000-\u0020\u007F-\u009F]/g, '');
        const url = new URL(compactHref, document.baseURI);
        return $723a57945d1b80ed$var$allowedWorkspaceLinkProtocols.has(url.protocol);
    } catch  {
        return false;
    }
};
/**
 * Removes executable workspace markup while preserving the supported formatting allowlist.
 */ const $723a57945d1b80ed$var$sanitizeWorkspaceHtml = (rawHtml)=>{
    const parsedDocument = new DOMParser().parseFromString(rawHtml, 'text/html');
    for (const element of parsedDocument.body.querySelectorAll('*')){
        const tagName = element.tagName.toLowerCase();
        if (!$723a57945d1b80ed$var$allowedWorkspaceHtmlTags.has(tagName)) {
            element.replaceWith(parsedDocument.createTextNode(element.textContent ?? ''));
            continue;
        }
        // Snapshot the live attribute collection because unsafe attributes are removed during iteration.
        const attributes = [
            ...element.attributes
        ];
        for (const attribute of attributes){
            const attributeName = attribute.name.toLowerCase();
            const isUnsafeLink = attributeName === 'href' && !$723a57945d1b80ed$var$isSafeWorkspaceLink(attribute.value);
            if (!$723a57945d1b80ed$var$allowedWorkspaceHtmlAttributes.has(attributeName) || isUnsafeLink) element.removeAttribute(attribute.name);
        }
        if (tagName === 'a' && element.hasAttribute('href')) {
            element.setAttribute('target', '_blank');
            element.setAttribute('rel', 'noopener noreferrer');
        }
    }
    return parsedDocument.body.innerHTML;
};
const $723a57945d1b80ed$export$1138b2ea7aa8b50a = ({ node: node })=>{
    const [isEditing, setIsEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useState(false);
    const [draftName, setDraftName] = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useState(node.getName());
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useRef(undefined);
    const draftNameRef = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useRef(draftName);
    (0, $lx97N.useEffect)(()=>{
        draftNameRef.current = draftName;
    }, [
        draftName
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (!isEditing) setDraftName(node.getName());
    }, [
        isEditing,
        node
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (isEditing) {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [
        isEditing
    ]);
    /**
   * Commits a changed tab name through the FlexLayout model and exits edit mode.
   */ const commitEditing = (0, $lx97N.useCallback)((nextName)=>{
        setIsEditing(false);
        const committedName = nextName.trim().length === 0 ? node.getName() : nextName;
        if (committedName !== node.getName()) node.getModel().doAction((0, $8041f202454d6b76$export$b52183d5cfb26dc9).renameTab(node.getId(), committedName));
    }, [
        node
    ]);
    /**
   * Cancels editing and restores the current model name.
   */ const cancelEditing = (0, $lx97N.useCallback)(()=>{
        setDraftName(node.getName());
        setIsEditing(false);
    }, [
        node
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (!isEditing) return;
        /**
     * Commits when focus leaves the textbox because the user clicked elsewhere in the layout.
     */ const handlePointerDown = (event)=>{
            if (event.target !== inputRef.current) commitEditing(draftNameRef.current);
        };
        /**
     * Commits when browser focus moves into an iframe, which does not always produce an outer document click.
     */ const handleWindowBlur = ()=>{
            const { activeElement: activeElement } = document;
            if (activeElement instanceof HTMLElement && activeElement.tagName === 'IFRAME') commitEditing(draftNameRef.current);
        };
        document.body.addEventListener('pointerdown', handlePointerDown);
        globalThis.addEventListener('blur', handleWindowBlur);
        return ()=>{
            document.body.removeEventListener('pointerdown', handlePointerDown);
            globalThis.removeEventListener('blur', handleWindowBlur);
        };
    }, [
        commitEditing,
        isEditing
    ]);
    /**
   * Starts label editing without allowing the double-click to select or drag the tab.
   */ const handleDoubleClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setDraftName(node.getName());
        setIsEditing(true);
    };
    /**
   * Keeps pointer events inside the text box from reaching FlexLayout's tab drag handlers.
   */ const handleInputPointerDown = (event)=>{
        event.stopPropagation();
    };
    /**
   * Applies keyboard semantics that match the previous FlexLayout patch.
   */ const handleInputKeyDown = (event)=>{
        if (event.code === 'Escape') {
            cancelEditing();
            event.stopPropagation();
            return;
        }
        if (event.code === 'Enter' || event.code === 'NumpadEnter') {
            commitEditing(event.currentTarget.value);
            event.stopPropagation();
        }
    };
    /**
   * Keeps the draft name synchronized with the controlled text input.
   */ const handleInputChange = (event)=>{
        setDraftName(event.currentTarget.value);
    };
    /**
   * Stores the current edit input without keeping null in React ref state.
   */ const handleInputRef = (inputElement)=>{
        inputRef.current = inputElement ?? undefined;
    };
    if (isEditing) return /*#__PURE__*/ (0, $fRwNr.jsx)("input", {
        ref: handleInputRef,
        className: "browser-window-tab-label-input",
        type: "text",
        value: draftName,
        onChange: handleInputChange,
        onKeyDown: handleInputKeyDown,
        onPointerDown: handleInputPointerDown
    });
    return /*#__PURE__*/ (0, $fRwNr.jsx)("span", {
        className: "browser-window-tab-label",
        title: node.getName(),
        onDoubleClick: handleDoubleClick,
        children: node.getName()
    });
};
const $723a57945d1b80ed$var$findFirstTabSet = (node)=>{
    if (!node) return undefined;
    if (node.type === 'tabset') return node;
    for (const child of node.children ?? []){
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const tabSet = $723a57945d1b80ed$var$findFirstTabSet(child);
        if (tabSet) return tabSet;
    }
    return undefined;
};
/**
 * Captures the browser shell runtime config so cross-origin component iframes can reuse the same application service.
 * Standalone component hosts do not always have the rc/dev runtime values available at their own origin.
 */ const $723a57945d1b80ed$var$getRuntimeConfigPayload = ()=>({
        apiServer: (0, $l2Ecb.getApiServer)(),
        appEnv: (0, $l2Ecb.getAppEnv)(),
        fileServer: (0, $l2Ecb.getFileServer)(),
        previewMode: String((0, $l2Ecb.isPreviewMode)()),
        webSocketServer: (0, $l2Ecb.getWebSocketServer)(),
        mdsWsServer: (0, $l2Ecb.getMdsWsServer)(),
        oasWsServer: (0, $l2Ecb.getOasWsServer)()
    });
const $723a57945d1b80ed$var$getTabsFromLayout = (node)=>{
    if (!node) return [];
    if (node.type === 'tab' && typeof node.id === 'string') return [
        {
            id: node.id,
            name: node.name,
            config: node.config
        }
    ];
    return (node.children ?? []).flatMap((child)=>$723a57945d1b80ed$var$getTabsFromLayout(child));
};
const $723a57945d1b80ed$var$getAllLayoutTabs = (json)=>{
    const layoutTabs = $723a57945d1b80ed$var$getTabsFromLayout(json.layout);
    const borderTabs = (json.borders ?? []).flatMap((border)=>$723a57945d1b80ed$var$getTabsFromLayout(border));
    return [
        ...layoutTabs,
        ...borderTabs
    ];
};
const $723a57945d1b80ed$export$9d3f4e55cfbc78e = (json, componentId)=>$723a57945d1b80ed$var$getAllLayoutTabs(json).find((tab)=>tab.config?.componentId === componentId)?.id;
const $723a57945d1b80ed$var$isOrderBlotterTab = (tab)=>{
    if (tab.config?.componentId === 'orderBlotter') return true;
    if (tab.name === 'Order Blotter') return true;
    return typeof tab.config?.data === 'string' && tab.config.data.includes('/components/blotter/index.html');
};
const $723a57945d1b80ed$export$ce3581c872948a90 = (json)=>$723a57945d1b80ed$var$getAllLayoutTabs(json).find((tab)=>$723a57945d1b80ed$var$isOrderBlotterTab(tab))?.id;
const $723a57945d1b80ed$export$a7c3a6cf2bbac1bd = (model)=>{
    const existingOrderBlotterId = $723a57945d1b80ed$export$ce3581c872948a90(model.toJson());
    if (!existingOrderBlotterId) return false;
    model.doAction((0, $8041f202454d6b76$export$b52183d5cfb26dc9).selectTab(existingOrderBlotterId));
    return $723a57945d1b80ed$export$7861d2da08c61de8(existingOrderBlotterId);
};
const $723a57945d1b80ed$export$7861d2da08c61de8 = (tabId)=>{
    const iframes = document.querySelectorAll('iframe');
    for (const iframe of iframes){
        if (iframe.getAttribute('title') !== tabId) continue;
        const iframeOrigin = (0, $evEIS.resolveHttpOrigin)(iframe.src, document.baseURI);
        const messageResult = (0, $9e69feacc2576cdd$export$779d4719498a216c)((0, $19TnD.orderBlotterAddTabMessageSchema), {
            type: 'order_blotter_add_internal_tab'
        });
        if (!iframe.contentWindow || !iframeOrigin || !messageResult.success) return false;
        iframe.contentWindow.postMessage(messageResult.output, iframeOrigin);
        return true;
    }
    return false;
};
const $723a57945d1b80ed$var$ensureTopTabSet = (json)=>{
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const topTabSet = $723a57945d1b80ed$var$findFirstTabSet(json.layout);
    if (topTabSet) return topTabSet;
    const createdTabSet = {
        type: 'tabset',
        selected: 0,
        children: []
    };
    if (!json.layout || typeof json.layout !== 'object') {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        json.layout = {
            type: 'row',
            children: [
                createdTabSet
            ]
        };
        return createdTabSet;
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const layoutNode = json.layout;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    layoutNode.children = Array.isArray(layoutNode.children) ? [
        createdTabSet,
        ...layoutNode.children
    ] : [
        createdTabSet
    ];
    return createdTabSet;
};
const $723a57945d1b80ed$export$892cb9cfd20eddd8 = (json)=>{
    const clone = structuredClone(json);
    const borderTabs = (clone.borders ?? []).flatMap((border)=>border.children ?? []);
    if (borderTabs.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const topTabSet = $723a57945d1b80ed$var$ensureTopTabSet(clone);
        // Preserve existing order in the top tabset, then append moved border tabs.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        topTabSet.children = [
            ...topTabSet.children ?? [],
            ...borderTabs
        ];
        if (typeof topTabSet.selected !== 'number' || topTabSet.selected < 0) topTabSet.selected = 0;
    }
    // Remove all border bars so side/bottom borders are no longer rendered.
    clone.borders = [];
    return clone;
};
const $723a57945d1b80ed$export$86fbec116b87613f = ()=>{
    const dispatch = (0, $3bGoE.useDispatch)(); // Use the AppDispatch type
    const layoutRef = (0, $lx97N.useRef)(undefined);
    const workspaceJson = (0, $3bGoE.useSelector)((0, $205bb7b61a2ef47c$export$669ddd1b9a2f2077));
    const [model, setModel] = (0, (/*@__PURE__*/$parcel$interopDefault($lx97N))).useState(undefined);
    const modelRef = (0, $lx97N.useRef)(undefined);
    const closeListeners = (0, $lx97N.useRef)({});
    /** Registers window-open and iframe-initialization handlers and returns their shared cleanup. */ const listenForWindowOpen = (0, $lx97N.useCallback)(()=>{
        const container = (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)();
        /** Opens a requested component only when it belongs to this Browser context. */ const handleWindowOpen = (message)=>{
            if (!layoutRef.current) return;
            if (message.message.browserContextId !== container.applicationClient.browserContextId) return;
            const node = modelRef.current?.getNodeById(message.message.requestingWindowId);
            const tabNode = (0, $27e6451b22bf09f3$export$a543b6e2fc959d7c)(message.message);
            if (node?.getParent()) {
                layoutRef.current.addTabToTabSet(node?.getParent()?.getId() ?? '', tabNode);
                return;
            }
            if (message.message.requestingWindowId) console.warn(`[WindowContainer] Unable to find requesting window ${message.message.requestingWindowId} ` + `in browser context ${container.applicationClient.browserContextId}; ` + 'opening in active tab set instead.');
            layoutRef.current.addTabToActiveTabSet(tabNode);
        };
        const openWindowTopic = container.applicationClient.APPLICATION_EVENTS.WINDOW.OPEN_WINDOW.topic;
        container.applicationClient.subscribe(openWindowTopic, handleWindowOpen);
        // Allow for us to pass info to the iframe for startup
        /** Supplies Browser context and runtime configuration to the iframe that requested initialization. */ const handleWindowInitialize = (event)=>{
            const requestResult = (0, $9e69feacc2576cdd$export$779d4719498a216c)((0, $19TnD.windowInitializeRequestSchema), event.data);
            if (!requestResult.success) return;
            const browserClient = container.applicationClient;
            const browserContextId = String(browserClient.browserContextId);
            const trustedFrontendOrigins = (0, $evEIS.resolveTrustedFrontendOrigins)((0, $l2Ecb.getFileServer)(), globalThis.location.origin);
            const iframes = document.querySelectorAll('iframe');
            for (const iframe of iframes){
                const iframeOrigin = (0, $evEIS.resolveHttpOrigin)(iframe.src, document.baseURI);
                if (iframe.contentWindow === event.source && iframeOrigin === event.origin && trustedFrontendOrigins.has(event.origin)) {
                    const responseResult = (0, $9e69feacc2576cdd$export$779d4719498a216c)((0, $19TnD.windowInitializeResponseSchema), {
                        type: 'window_initialize',
                        browserContextId: browserContextId,
                        spawnDataId: iframe.getAttribute('spawndataid'),
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        windowID: iframe.getAttribute('title'),
                        componentId: iframe.getAttribute('componentid'),
                        runtimeConfig: $723a57945d1b80ed$var$getRuntimeConfigPayload()
                    });
                    if (responseResult.success) iframe.contentWindow.postMessage(responseResult.output, iframeOrigin);
                }
            }
        };
        window.addEventListener('message', handleWindowInitialize);
        /** Removes the exact callbacks registered by this mount. */ return ()=>{
            container.applicationClient.unSubscribe(openWindowTopic, handleWindowOpen);
            window.removeEventListener('message', handleWindowInitialize);
        };
    }, []);
    /** Registers the window-close handler and returns its cleanup. */ const listenForWindowClose = (0, $lx97N.useCallback)(()=>{
        const container = (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)();
        /** Deletes a requested tab only when it belongs to this Browser context. */ const handleWindowClose = (message)=>{
            if (!layoutRef.current) return;
            if (message.message.browserContextId !== container.applicationClient.browserContextId) return;
            const node = modelRef.current?.getNodeById(message.message.windowId);
            if (node) {
                modelRef.current?.doAction((0, $8041f202454d6b76$export$b52183d5cfb26dc9).deleteTab(node.getId()));
                return;
            }
            console.warn(`[WindowContainer] Close requested for unknown window ${message.message.windowId} in browser context ${container.applicationClient.browserContextId}.`);
        };
        const closeWindowTopic = container.applicationClient.APPLICATION_EVENTS.WINDOW.CLOSE_WINDOW.topic;
        container.applicationClient.subscribe(closeWindowTopic, handleWindowClose);
        /** Removes the exact close callback registered by this mount. */ return ()=>{
            container.applicationClient.unSubscribe(closeWindowTopic, handleWindowClose);
        };
    }, []);
    /** Registers the show-window handler and returns its cleanup. */ const listenForShowWindow = (0, $lx97N.useCallback)(()=>{
        const container = (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)();
        /** Selects a hidden requested tab only when it belongs to this Browser context. */ const handleShowWindow = (message)=>{
            if (message.message.browserContextId !== container.applicationClient.browserContextId) return;
            const node = modelRef.current?.getNodeById(message.message.windowId);
            if (node) {
                if (node.visible === false) modelRef.current?.doAction((0, $8041f202454d6b76$export$b52183d5cfb26dc9).selectTab(node.getId()));
                return;
            }
            console.warn(`[WindowContainer] Show requested for unknown window ${message.message.windowId} ` + `in browser context ${container.applicationClient.browserContextId}.`);
        };
        const showWindowTopic = container.applicationClient.APPLICATION_EVENTS.WINDOW.SHOW_WINDOW.topic;
        container.applicationClient.subscribe(showWindowTopic, handleShowWindow);
        /** Removes the exact show callback registered by this mount. */ return ()=>{
            container.applicationClient.unSubscribe(showWindowTopic, handleShowWindow);
        };
    }, []);
    /** Registers both scrim handlers and returns their combined cleanup. */ const listenForScrimChanges = (0, $lx97N.useCallback)(()=>{
        const container = (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)();
        /** Shows the loading scrim for a requested tab in this Browser context. */ const handleShowScrim = (message)=>{
            if (message.message.browserContextId !== container.applicationClient.browserContextId) return;
            const node = modelRef.current?.getNodeById(message.message.windowId);
            if (node) {
                // eslint-disable-next-line unicorn/prefer-query-selector
                document.getElementById(node.getId())?.parentElement?.getElementsByClassName('loadingScrim')[0]?.classList.add('show');
                return;
            }
            console.warn(`[WindowContainer] Scrim show requested for unknown window ${message.message.windowId} ` + `in browser context ${container.applicationClient.browserContextId}.`);
        };
        const showScrimTopic = container.applicationClient.APPLICATION_EVENTS.WINDOW.SHOW_SCRIM.topic;
        container.applicationClient.subscribe(showScrimTopic, handleShowScrim);
        /** Hides the loading scrim for a requested tab in this Browser context. */ const handleHideScrim = (message)=>{
            if (message.message.browserContextId !== container.applicationClient.browserContextId) return;
            const node = modelRef.current?.getNodeById(message.message.windowId);
            if (node) {
                // eslint-disable-next-line unicorn/prefer-query-selector
                document.getElementById(node.getId())?.parentElement?.getElementsByClassName('loadingScrim')[0]?.classList.remove('show');
                return;
            }
            console.warn(`[WindowContainer] Scrim hide requested for unknown window ${message.message.windowId} ` + `in browser context ${container.applicationClient.browserContextId}.`);
        };
        const hideScrimTopic = container.applicationClient.APPLICATION_EVENTS.WINDOW.HIDE_SCRIM.topic;
        container.applicationClient.subscribe(hideScrimTopic, handleHideScrim);
        /** Removes the exact scrim callbacks registered by this mount. */ return ()=>{
            container.applicationClient.unSubscribe(showScrimTopic, handleShowScrim);
            container.applicationClient.unSubscribe(hideScrimTopic, handleHideScrim);
        };
    }, []);
    // Owns every external listener registered for this App mount.
    (0, $lx97N.useEffect)(()=>{
        const cleanupWindowOpen = listenForWindowOpen();
        const cleanupWindowClose = listenForWindowClose();
        const cleanupShowWindow = listenForShowWindow();
        const cleanupScrimChanges = listenForScrimChanges();
        // Preload algo definitions
        dispatch((0, $205bb7b61a2ef47c$export$8127e61763eee2ff)(''));
        /** Releases all application-client and global listeners owned by this mount. */ return ()=>{
            cleanupWindowOpen();
            cleanupWindowClose();
            cleanupShowWindow();
            cleanupScrimChanges();
        };
    }, []);
    (0, $lx97N.useEffect)(()=>{
        let looping = true;
        let raf;
        let activeTab;
        function updateActiveTab(element) {
            const parentTab = element?.closest('.flexlayout__tab');
            if (parentTab === activeTab) return;
            activeTab?.classList.remove('browser-window-active');
            parentTab?.classList.add('browser-window-active');
            activeTab = parentTab ?? undefined;
        }
        function loop() {
            if (document.activeElement?.tagName === 'IFRAME') updateActiveTab(document.activeElement);
            if (looping) raf = requestAnimationFrame(loop);
        }
        raf = requestAnimationFrame(loop);
        function handleClickOrFocus(event) {
            if (event.target instanceof Element) updateActiveTab(event.target);
            else updateActiveTab(undefined);
        }
        function unselectAll() {
            globalThis.getSelection()?.removeAllRanges();
        }
        document.addEventListener('blur', unselectAll, true);
        document.addEventListener('click', handleClickOrFocus, true);
        document.addEventListener('focus', handleClickOrFocus, true);
        return ()=>{
            looping = false;
            cancelAnimationFrame(raf);
            document.removeEventListener('blur', unselectAll, true);
            document.removeEventListener('click', handleClickOrFocus, true);
            document.removeEventListener('focus', handleClickOrFocus, true);
            updateActiveTab(undefined);
        };
    }, []);
    /** Applies the deployment's tab-mount policy while materializing the saved workspace model. */ (0, $lx97N.useEffect)(()=>{
        if (!workspaceJson) return;
        if (Object.keys(workspaceJson).length === 0) return;
        const workspaceJsonClone = $723a57945d1b80ed$export$892cb9cfd20eddd8(structuredClone(workspaceJson));
        workspaceJsonClone.global ??= {};
        // Overrides for the layout
        workspaceJsonClone.global.tabEnablePopout = false;
        workspaceJsonClone.global.splitterSize = 4;
        workspaceJsonClone.global.tabSetEnableActiveIcon = false;
        // Preserve eager real-time initialization by default, while allowing deployments to opt into lazy mounting.
        workspaceJsonClone.global.tabEnableRenderOnDemand = (0, $l2Ecb.isWorkspaceTabRenderOnDemand)();
        workspaceJsonClone.global.splitterEnableHandle = true;
        workspaceJsonClone.global.tabEnableRename = false;
        workspaceJsonClone.global.tabSetClassNameTabStrip = 'QEP_Tab_Strip';
        const newModel = (0, $8041f202454d6b76$export$a1edc412be3e1841).fromJson(workspaceJsonClone);
        if (workspaceJsonClone?.layout) {
            if (!workspaceJsonClone.layout.id && !workspaceJsonClone.global.qepFallbackWorkspace) dispatch((0, $205bb7b61a2ef47c$export$ebe11ca8cc8aae14)(newModel.toJson()));
        } else return;
        setModel(newModel);
        modelRef.current = newModel;
    }, [
        workspaceJson
    ]);
    // /https://github.com/caplin/FlexLayout/blob/master/examples/demo/App.tsx#L11
    const factory = (0, $lx97N.useCallback)((node)=>{
        // Log lifecycle events
        const component = node.getComponent();
        if (!closeListeners.current[node.getId()]) {
            closeListeners.current[node.getId()] = async ()=>{
                const linkerGroups = Object.values((0, $d186cacbb2c7caf0$export$69f683232f4f6610));
                const windows = await (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().linker.getLinkedWindows(linkerGroups);
                if (windows.length > 0) {
                    for (const w of windows)for (const g of linkerGroups)(0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().linker.deRegisterLink(g, node.getId());
                }
                node.removeEventListener('close');
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete closeListeners.current[node.getId()];
            };
            node.setEventListener('close', closeListeners.current[node.getId()]);
        }
        switch(component){
            case 'json':
                break;
            case 'selector':
                return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $d2a2fde1b0e0a2a8$export$c01fc56470459c64), {
                    layout: layoutRef,
                    model: modelRef,
                    tabId: node.getId()
                });
            case 'grid':
                if (node.getExtraData().data === null || node.getExtraData().data === undefined) // Create data in node extra data first time accessed
                node.getExtraData().data = $723a57945d1b80ed$export$ee2e61155bc28a();
                return /*#__PURE__*/ (0, $fRwNr.jsx)($723a57945d1b80ed$export$3fe48f9151d0ecc2, {
                    fields: $723a57945d1b80ed$var$fields,
                    onClick: ()=>{},
                    data: node.getExtraData().data
                });
            case 'text':
                try {
                    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: $723a57945d1b80ed$var$sanitizeWorkspaceHtml(node.getConfig().text)
                        }
                    });
                } catch (error) {
                    console.error(error);
                }
                break;
            case 'multitype':
                try {
                    const config = node.getConfig();
                    if (config.type === 'url') {
                        const nodeContent = /*#__PURE__*/ (0, $fRwNr.jsx)("iframe", {
                            id: node?.attributes?.id,
                            spawndataid: config?.spawnDataId,
                            componentid: config?.componentId,
                            title: node.getId(),
                            src: config.data,
                            className: "browser-window-iframe",
                            width: "100%",
                            height: "100%"
                        });
                        return /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
                            className: "nodeWithScrim",
                            children: [
                                /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                                    className: "loadingScrim",
                                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $eda52aa0d1dd92cb$export$7c20be4c1d342248), {})
                                }),
                                nodeContent
                            ]
                        });
                    }
                    if (config.type === 'html') return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: $723a57945d1b80ed$var$sanitizeWorkspaceHtml(config.data)
                        }
                    });
                    if (config.type === 'text') return /*#__PURE__*/ (0, $fRwNr.jsx)("textarea", {
                        style: {
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            resize: 'none',
                            boxSizing: 'border-box',
                            border: 'none'
                        },
                        defaultValue: config.data
                    });
                } catch (error) {
                    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                        children: String(error)
                    });
                }
                break;
            case undefined:
                break;
        }
        // Else if (component === "tabstorage") {
        //    return <TabStorage tab={node} layout={this.layoutRef!.current!} />
        // }
        return null;
    }, []);
    const onAddFromTabSetButton = (node)=>{
        const addedTab = layoutRef.current.addTabToTabSet(node.getId(), {
            component: 'selector',
            name: 'Open component'
        });
        requestAnimationFrame(()=>{
            if (node.getSelectedNode() === undefined) model?.doAction((0, $8041f202454d6b76$export$b52183d5cfb26dc9).selectTab(addedTab?.getId() ?? ''));
        });
    };
    const onRenderTabSet = (node, renderValues)=>{
        renderValues.stickyButtons.push(/*#__PURE__*/ (0, $fRwNr.jsx)((0, $424ebeae788e048c$export$2e2bcd8739ae039), {
            alt: "Add",
            title: "Add Tab (using onRenderTabSet callback, see Demo)",
            style: {
                width: '1.1rem',
                height: '1.1rem'
            },
            // className={styles.flexlayout__tab_toolbar_button}
            onMouseOver: ()=>{},
            onClick: ()=>{
                onAddFromTabSetButton(node);
            }
        }, "Add button"));
    };
    const onRenderTab = (node, renderValues)=>{
        renderValues.leading = /*#__PURE__*/ (0, $fRwNr.jsx)((0, $6144036ef99e20eb$export$2e2bcd8739ae039), {
            node: node
        });
        renderValues.content = /*#__PURE__*/ (0, $fRwNr.jsx)($723a57945d1b80ed$export$1138b2ea7aa8b50a, {
            node: node
        });
    };
    const onAction = (action)=>{
        switch(action.type){
            case (0, $8041f202454d6b76$export$b52183d5cfb26dc9).SELECT_TAB:
                (0, $36b83affa0bb2ccb$export$587f97f149daf0ce)(action.data.tabNode);
                break;
            case (0, $8041f202454d6b76$export$b52183d5cfb26dc9).DELETE_TAB:
                (0, $36b83affa0bb2ccb$export$4ac7ac3505f26fae)(action.data.node);
                break;
            default:
                break;
        }
        return action;
    };
    if (!workspaceJson?.global || !model) return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        children: "Loading..."
    });
    const saveLayout = ()=>{
        if (workspaceJson.global.qepFallbackWorkspace) return;
        dispatch((0, $205bb7b61a2ef47c$export$ebe11ca8cc8aae14)(model?.toJson()));
    };
    const debounceSave = (0, $37w0r.debounce)(saveLayout, 1000);
    const shouldRenderChat = (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)().canUseFeature('chatbox');
    return /*#__PURE__*/ (0, $fRwNr.jsx)((0, $18c26bf3fa1baa25$export$51e651dc78bb62ed), {
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
            className: "browser-window-layout",
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsx)((0, $9eb9aabf400d1bf8$export$4c260019440d418f), {
                    layout: layoutRef
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                    className: "browser-window-content",
                    children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $8041f202454d6b76$export$c84671f46d6a1ca), {
                        ref: layoutRef,
                        realtimeResize: true,
                        model: model,
                        onModelChange: (model)=>{
                            debounceSave();
                        },
                        onAction: onAction,
                        onRenderTab: onRenderTab,
                        onRenderTabSet: onRenderTabSet,
                        factory: factory
                    })
                }),
                shouldRenderChat ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $96ae83ea73c687c3$export$2e2bcd8739ae039), {}) : null
            ]
        })
    });
};
const $723a57945d1b80ed$export$3fe48f9151d0ecc2 = (props)=>{
    const headercells = props.fields.map((field)=>/*#__PURE__*/ (0, $fRwNr.jsx)("th", {
            children: field
        }, field));
    const rows = props.data.map((item, idx)=>/*#__PURE__*/ (0, $fRwNr.jsx)("tr", {
            children: props.fields.map((field)=>/*#__PURE__*/ (0, $fRwNr.jsx)("td", {
                    children: item[field]
                }, field))
        }, idx));
    return /*#__PURE__*/ (0, $fRwNr.jsx)("table", {
        className: "simple_table",
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)("tbody", {
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsx)("tr", {
                    children: headercells
                }),
                rows
            ]
        })
    });
};
const $723a57945d1b80ed$export$ee2e61155bc28a = ()=>{
    const data = [];
    const r = Math.random() * 50;
    for(let i = 0; i < r; i++){
        const rec = {};
        rec.Name = $723a57945d1b80ed$export$7fa8378418b4411e(5, 'ABCDEFGHIJKLMNOPQRSTUVWXYZ');
        for(let j = 1; j < $723a57945d1b80ed$var$fields.length; j++)rec[$723a57945d1b80ed$var$fields[j]] = (1.5 + Math.random() * 2).toFixed(2);
        data.push(rec);
    }
    return {
        data: data
    };
};
const $723a57945d1b80ed$export$7fa8378418b4411e = (length, chars)=>{
    const a = [];
    for(let i = 0; i < length; i++)a.push(chars[Math.floor(Math.random() * chars.length)]);
    return a.join('');
};




var $5Wk8r = parcelRequire("5Wk8r");

var $3bGoE = parcelRequire("3bGoE");

var $QDzUP = parcelRequire("QDzUP");

var $5Wk8r = parcelRequire("5Wk8r");
const $38e0c9fa1daccf09$var$initialState = {
    value: 12578940,
    keyHoldings: [
        {
            name: 'Gold',
            value: 2336.45,
            changeAmount: -5.3,
            changePercent: -0.23
        },
        {
            name: 'Crude Oil',
            value: 83.29,
            changeAmount: -0.75,
            changePercent: -0.89
        }
    ],
    topCommodities: [
        {
            name: 'Corn',
            value: 4.5,
            changeAmount: 0.05,
            changePercent: 1.12
        },
        {
            name: 'Wheat',
            value: 6.2,
            changeAmount: -0.02,
            changePercent: -0.32
        },
        {
            name: 'Soybeans',
            value: 11.8,
            changeAmount: 0.15,
            changePercent: 1.29
        }
    ],
    positions: [
        {
            id: 'pos1',
            assetName: 'AAPL',
            quantity: 100,
            averagePrice: 170.32,
            currentValue: 17500,
            unrealizedPl: 468,
            unrealizedPlPercent: 2.75
        },
        {
            id: 'pos2',
            assetName: 'MSFT',
            quantity: 50,
            averagePrice: 330.1,
            currentValue: 16800,
            unrealizedPl: 295,
            unrealizedPlPercent: 1.79
        },
        {
            id: 'pos3',
            assetName: 'TSLA',
            quantity: 20,
            averagePrice: 250.75,
            currentValue: 4800,
            unrealizedPl: -415,
            unrealizedPlPercent: -7.96
        }
    ],
    orders: [
        {
            id: 'ord1',
            assetName: 'GOOGL',
            type: 'Buy',
            quantity: 10,
            price: 135.5,
            orderType: 'Limit',
            status: 'Pending',
            timestamp: '2025-06-11T10:30:00Z'
        },
        {
            id: 'ord2',
            assetName: 'AMZN',
            type: 'Sell',
            quantity: 5,
            price: 125,
            orderType: 'Limit',
            status: 'Filled',
            timestamp: '2025-06-10T15:45:00Z'
        },
        {
            id: 'ord3',
            assetName: 'NVDA',
            type: 'Buy',
            quantity: 15,
            orderType: 'Market',
            status: 'Filled',
            timestamp: '2025-06-11T09:15:00Z'
        },
        {
            id: 'ord4',
            assetName: 'BTC',
            type: 'Buy',
            quantity: 0.5,
            price: 30000,
            orderType: 'Limit',
            status: 'Cancelled',
            timestamp: '2025-06-09T12:00:00Z'
        }
    ]
};
const $38e0c9fa1daccf09$var$portfolioSlice = (0, $5Wk8r.createSlice)({
    name: 'portfolio',
    initialState: $38e0c9fa1daccf09$var$initialState,
    reducers: {
    }
});
var $38e0c9fa1daccf09$export$2e2bcd8739ae039 = $38e0c9fa1daccf09$var$portfolioSlice.reducer;



const $6eca7382d3baad6e$var$rootReducer = (0, $QDzUP.combineReducers)({
    application: (0, $205bb7b61a2ef47c$export$2e2bcd8739ae039),
    portfolio: (0, $38e0c9fa1daccf09$export$2e2bcd8739ae039)
});
var $6eca7382d3baad6e$export$2e2bcd8739ae039 = $6eca7382d3baad6e$var$rootReducer;


const $ae10a400cfc40203$var$store = (0, $5Wk8r.configureStore)({
    reducer: (0, $6eca7382d3baad6e$export$2e2bcd8739ae039)
});
const $ae10a400cfc40203$export$f51d452c10d5b956 = (0, $3bGoE.useDispatch);
const $ae10a400cfc40203$export$a7347740d65f620b = (0, $3bGoE.useSelector);
var $ae10a400cfc40203$export$2e2bcd8739ae039 = $ae10a400cfc40203$var$store;


/* eslint-disable new-cap */ 
var $fRwNr = parcelRequire("fRwNr");

var $lx97N = parcelRequire("lx97N");


var $cckdX = parcelRequire("cckdX");

var $8qhDq = parcelRequire("8qhDq");

var $lx97N = parcelRequire("lx97N");
function $a9feabfa5daa36cc$export$af0df06f438ca276(statusNames) {
    const statuses = statusNames.reduce((acc, statusName)=>{
        acc[statusName] = globalThis.QEP.connectivity.getStatus(statusName);
        return acc;
    }, {});
    const [connectivityStatuses, setConnectivityStatuses] = (0, $lx97N.useState)(statuses);
    (0, $lx97N.useEffect)(()=>{
        const offHandler = globalThis.QEP.connectivity.listenToStatusesChange((newStatuses)=>{
            const updatedStatuses = statusNames.reduce((acc, statusName)=>{
                acc[statusName] = newStatuses.find((newStatus)=>statusName === newStatus.componentName);
                return acc;
            }, {});
            setConnectivityStatuses(updatedStatuses);
        });
        return offHandler;
    }, []);
    return connectivityStatuses;
}



var $l2Ecb = parcelRequire("l2Ecb");
var $071246a099ea2ff2$exports = {};
$071246a099ea2ff2$exports = new URL("../darkLogo.0ad3084c.svg", import.meta.url).toString();



const $1524ad9a4d49dcf0$export$21a94553ffa41578 = ()=>{
    const [loading, setLoading] = (0, $lx97N.useState)(false);
    const connectivity = (0, $a9feabfa5daa36cc$export$af0df06f438ca276)([
        (0, $cckdX.HEALTH_ENDPOINTS).HTTP_CLIENT
    ]);
    const httpConnectivity = connectivity[(0, $cckdX.HEALTH_ENDPOINTS).HTTP_CLIENT];
    const isOpen = httpConnectivity && typeof httpConnectivity === 'object' && 'statusInfo' in httpConnectivity && httpConnectivity.statusInfo === (0, $8qhDq.HasiStatus).HASISTATUS_OK;
    const authUrl = `https://login.microsoftonline.com/57368c21-b8cf-42cf-bd0b-43ecd4bc62ae/oauth2/v2.0/authorize?client_id=${(0, $l2Ecb.getAuthClientId)()}
    &redirect_uri=${(0, $l2Ecb.getAuthRedirect)()}
    &scope=https://graph.microsoft.com/.default
    &state=${`{ "env": "${(0, $l2Ecb.getAuthState)()}", "timezone": "${Intl.DateTimeFormat().resolvedOptions().timeZone}","frontend": "${(0, $l2Ecb.getFileServer)()}","mode": "browser"}`}
    &response_type=code`;
    return /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "browser-login-root",
        children: /*#__PURE__*/ (0, $fRwNr.jsxs)("div", {
            className: "browser-login-card",
            children: [
                /*#__PURE__*/ (0, $fRwNr.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($071246a099ea2ff2$exports))),
                    alt: "QEP Logo",
                    className: "browser-login-logo"
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                    className: "browser-login-title",
                    children: "QEP Login"
                }),
                !isOpen && /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
                    className: "browser-login-error-message",
                    children: "Unable to connect to the server. Please check your network connection."
                }),
                /*#__PURE__*/ (0, $fRwNr.jsx)("button", {
                    type: "button",
                    disabled: loading || !isOpen,
                    onClick: ()=>{
                        setLoading(true);
                        globalThis.location.href = authUrl;
                    },
                    className: "browser-login-button",
                    children: loading ? 'Redirecting...' : 'Sign in with SSO'
                })
            ]
        })
    });
};



/**
 * Checks for Service Worker updates without allowing unsupported browser capabilities or lookup failures to block startup.
 */ async function $276e4404356e4c3b$var$handleServiceWorkerUpdates() {
    const { serviceWorker: serviceWorker } = navigator;
    if (!serviceWorker || typeof serviceWorker.getRegistrations !== 'function' || typeof serviceWorker.addEventListener !== 'function' || typeof globalThis.MessageChannel !== 'function') return;
    const messageChannel = new globalThis.MessageChannel();
    const UseServiceWorker = "true";
    let registrationsPromise;
    try {
        registrationsPromise = serviceWorker.getRegistrations();
    } catch  {
        return;
    }
    serviceWorker.controller?.postMessage({
        topic: 'version'
    }, [
        messageChannel.port2
    ]);
    let refreshing = false;
    serviceWorker.addEventListener('controllerchange', ()=>{
        if (refreshing) return;
        refreshing = true;
        globalThis.location.reload();
    }, {
        once: true
    });
    let registrations;
    try {
        registrations = await registrationsPromise;
    } catch  {
        return;
    }
    await Promise.all(registrations.map(async (registration)=>{
        if (!UseServiceWorker) {
            await registration.unregister();
            globalThis.location.reload();
            return;
        }
        if (registration) {
            if (registration.waiting) registration.waiting.postMessage?.({
                type: 'SKIP_WAITING'
            });
            registration.addEventListener('updatefound', ()=>{
                const newWorker = registration.installing;
                if (newWorker) newWorker.addEventListener('statechange', ()=>{
                    if (newWorker.state === 'installed' && serviceWorker.controller) registration?.waiting?.postMessage({
                        type: 'SKIP_WAITING'
                    });
                });
            });
        }
    }));
}
/**
 * Enables browser-shell testing fallbacks only in non-production runtime environments.
 */ function $276e4404356e4c3b$var$isTestingModeEnabled() {
    return (0, $l2Ecb.isTestingQueryEnabled)(globalThis.location.search);
}
const $276e4404356e4c3b$var$createFallbackWorkspace = ()=>({
        global: {
            qepFallbackWorkspace: true,
            tabClassName: 'customTab',
            tabContentClassName: 'customContent',
            tabEnableRenderOnDemand: false,
            splitterEnableHandle: true
        },
        borders: [],
        layout: {
            type: 'row',
            children: [
                {
                    type: 'tabset',
                    selected: 0,
                    children: [
                        {
                            type: 'tab',
                            name: 'Open component',
                            component: 'selector'
                        }
                    ]
                }
            ]
        }
    });
const $276e4404356e4c3b$export$861edd1ccea2f746 = ()=>{
    const dispatch = (0, $3bGoE.useDispatch)();
    const [browser] = (0, $lx97N.useState)(()=>(0, $27e6451b22bf09f3$export$49f5bf502122d4f7)());
    const [loading, setLoading] = (0, $lx97N.useState)(true);
    const [showLogin, setShowLogin] = (0, $lx97N.useState)(true);
    const [isMobile, setIsMobile] = (0, $lx97N.useState)(()=>(0, $6139c2c725da4b69$export$713066d5f49c53c8)());
    (0, $lx97N.useEffect)(()=>{
        /** Keeps the shell choice aligned with device and viewport changes after initial render. */ function handleResize() {
            setIsMobile((0, $6139c2c725da4b69$export$713066d5f49c53c8)());
        }
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const onReady = (0, $lx97N.useCallback)(async ()=>{
        setLoading(true);
        // Ensure splash screen is visible for at least 500ms
        const minSplash = 0;
        const start = Date.now();
        const isTestingMode = $276e4404356e4c3b$var$isTestingModeEnabled();
        const loadInitialStateDispatch = dispatch((0, $205bb7b61a2ef47c$export$6ecb652b0e5a904d)(''));
        const loadInitialStatePromise = typeof loadInitialStateDispatch?.unwrap === 'function' ? loadInitialStateDispatch.unwrap() : Promise.resolve(loadInitialStateDispatch);
        const initialStateResult = await Promise.race([
            (async ()=>{
                try {
                    await loadInitialStatePromise;
                    return 'loaded';
                } catch  {
                    return 'error';
                }
            })(),
            new Promise((resolve)=>{
                globalThis.setTimeout(()=>{
                    resolve('timeout');
                }, isTestingMode ? 7000 : 15000);
            })
        ]);
        if (initialStateResult !== 'loaded') dispatch((0, $205bb7b61a2ef47c$export$dca58f17277bcc93).actions.updateWorkspaceState($276e4404356e4c3b$var$createFallbackWorkspace()));
        const elapsed = Date.now() - start;
        if (elapsed < minSplash) setTimeout(()=>{
            setLoading(false);
        }, minSplash - elapsed);
        else setLoading(false);
    }, [
        dispatch
    ]);
    (0, $lx97N.useEffect)(()=>{
        $276e4404356e4c3b$var$handleServiceWorkerUpdates();
    }, []);
    const onAuthChange = (0, $lx97N.useCallback)(async (message)=>{
        if (!message.message) {
            setShowLogin(true);
            setLoading(false);
        }
        if (message.message) {
            setShowLogin(false);
            onReady();
        }
    }, [
        onReady
    ]);
    (0, $lx97N.useEffect)(()=>{
        browser.applicationClient.addListener(browser.applicationClient.APPLICATION_EVENTS.AUTH.AUTH_STATUS_CHANGE.topic, onAuthChange);
        // Check authentication status and show login if needed
        const checkAuth = async ()=>{
            const authInfo = await browser.applicationClient.getAuthInfo();
            if (authInfo) {
                setShowLogin(false);
                onReady();
            } else {
                setShowLogin(true);
                setLoading(false);
            }
        };
        checkAuth();
        return ()=>{
            browser.applicationClient.removeListener(browser.applicationClient.APPLICATION_EVENTS.AUTH.AUTH_STATUS_CHANGE.topic, onAuthChange);
        };
    }, [
        browser.applicationClient,
        onAuthChange,
        onReady
    ]);
    const isAutoLogoutEnabled = (0, $d9gj3.getQepSystem)().container.canUseFeature('autoLogout');
    /** Completes automatic server logout before permanently disposing API services. */ const handleSleepLogout = (0, $lx97N.useCallback)(async ()=>{
        const container = (0, $27e6451b22bf09f3$export$49f5bf502122d4f7)();
        try {
            await container.authentication.logout();
        } catch (error) {
            console.error('Failed to log out automatically', error);
        } finally{
            (0, $b70d5c68bc353deb$export$b7d6753c864dd3cf)();
        }
    }, []);
    (0, $53062adebdc9cb0b$export$e157413978fb74eb)(handleSleepLogout, {
        enabled: isAutoLogoutEnabled
    });
    // Splash scrim overlay
    const splashScrim = loading ? /*#__PURE__*/ (0, $fRwNr.jsx)("div", {
        className: "browser-splash-scrim",
        children: /*#__PURE__*/ (0, $fRwNr.jsx)("img", {
            className: "browser-splash-image",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($035d655aca4aa381$exports))),
            alt: "Loading..."
        })
    }) : null;
    return /*#__PURE__*/ (0, $fRwNr.jsxs)((0, $fRwNr.Fragment), {
        children: [
            showLogin ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $1524ad9a4d49dcf0$export$21a94553ffa41578), {}) : isMobile && (0, $d9gj3.getQepSystem)().container.canUseFeature('mobile') ? /*#__PURE__*/ (0, $fRwNr.jsx)((0, $f9a6beb82d30d817$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $fRwNr.jsx)((0, $723a57945d1b80ed$export$86fbec116b87613f), {}),
            !showLogin && splashScrim
        ]
    });
};
const $276e4404356e4c3b$var$render = ()=>{
    const domNode = document.querySelector('#react-content');
    if (domNode) {
        const root = (0, $jhfT6.createRoot)(domNode);
        root.render(/*#__PURE__*/ (0, $fRwNr.jsx)((0, $49c44fb299ddf6a4$export$dd147bee413758f6), {
            children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $48db39880a45c6a8$export$d8964aec282183a3), {
                children: /*#__PURE__*/ (0, $fRwNr.jsx)((0, $3bGoE.Provider), {
                    store: (0, $ae10a400cfc40203$export$2e2bcd8739ae039),
                    children: /*#__PURE__*/ (0, $fRwNr.jsx)($276e4404356e4c3b$export$861edd1ccea2f746, {})
                })
            })
        }));
    } else console.error('Failed to find the root element');
};
// eslint-disable-next-line unicorn/prefer-top-level-await
(0, $h0N84.getPreloadComplete)().then(async ()=>{
    (0, $d9gj3.getQepSystem)().container.onReady($276e4404356e4c3b$var$render);
});


//# sourceMappingURL=index.82fd2036.js.map
